(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0744"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0744"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bPPxF", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $89dc7052dac79b11$export$ffb0004e005737fa; }, function (v) { return $89dc7052dac79b11$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $89dc7052dac79b11$export$34b9dba7ce09269b; }, function (v) { return $89dc7052dac79b11$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $89dc7052dac79b11$export$25062201e9e25d76; }, function (v) { return $89dc7052dac79b11$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $89dc7052dac79b11$export$ffb0004e005737fa;
var $89dc7052dac79b11$export$34b9dba7ce09269b;
var $89dc7052dac79b11$export$25062201e9e25d76;
"use strict";

var $hEVyQ = parcelRequire("hEVyQ");
var $89dc7052dac79b11$var$k = Symbol.for("react.element"), $89dc7052dac79b11$var$l = Symbol.for("react.fragment"), $89dc7052dac79b11$var$m = Object.prototype.hasOwnProperty, $89dc7052dac79b11$var$n = $hEVyQ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $89dc7052dac79b11$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $89dc7052dac79b11$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$89dc7052dac79b11$var$m.call(a, b) && !$89dc7052dac79b11$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $89dc7052dac79b11$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $89dc7052dac79b11$var$n.current
    };
}
$89dc7052dac79b11$export$ffb0004e005737fa = $89dc7052dac79b11$var$l;
$89dc7052dac79b11$export$34b9dba7ce09269b = $89dc7052dac79b11$var$q;
$89dc7052dac79b11$export$25062201e9e25d76 = $89dc7052dac79b11$var$q;

});
parcelRegister("hEVyQ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("iU0le"));

});
parcelRegister("iU0le", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $dc2db8c7c6836697$export$dca3b0875bd9a954; }, function (v) { return $dc2db8c7c6836697$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $dc2db8c7c6836697$export$16fa2f45be04daa8; }, function (v) { return $dc2db8c7c6836697$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $dc2db8c7c6836697$export$ffb0004e005737fa; }, function (v) { return $dc2db8c7c6836697$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $dc2db8c7c6836697$export$e2c29f18771995cb; }, function (v) { return $dc2db8c7c6836697$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $dc2db8c7c6836697$export$221d75b3f55bb0bd; }, function (v) { return $dc2db8c7c6836697$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $dc2db8c7c6836697$export$5f8d39834fd61797; }, function (v) { return $dc2db8c7c6836697$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $dc2db8c7c6836697$export$74bf444e3cd11ea5; }, function (v) { return $dc2db8c7c6836697$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $dc2db8c7c6836697$export$ae55be85d98224ed; }, function (v) { return $dc2db8c7c6836697$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $dc2db8c7c6836697$export$e530037191fcd5d7; }, function (v) { return $dc2db8c7c6836697$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $dc2db8c7c6836697$export$fd42f52fd3ae1109; }, function (v) { return $dc2db8c7c6836697$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $dc2db8c7c6836697$export$c8a8987d4410bf2d; }, function (v) { return $dc2db8c7c6836697$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $dc2db8c7c6836697$export$d38cd72104c1f0e9; }, function (v) { return $dc2db8c7c6836697$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $dc2db8c7c6836697$export$7d1e3a5e95ceca43; }, function (v) { return $dc2db8c7c6836697$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $dc2db8c7c6836697$export$257a8862b851cb5b; }, function (v) { return $dc2db8c7c6836697$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $dc2db8c7c6836697$export$a8257692ac88316c; }, function (v) { return $dc2db8c7c6836697$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $dc2db8c7c6836697$export$488013bae63b21da; }, function (v) { return $dc2db8c7c6836697$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $dc2db8c7c6836697$export$7c73462e0d25e514; }, function (v) { return $dc2db8c7c6836697$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $dc2db8c7c6836697$export$7568632d0d33d16d; }, function (v) { return $dc2db8c7c6836697$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $dc2db8c7c6836697$export$88948ce120ea2619; }, function (v) { return $dc2db8c7c6836697$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $dc2db8c7c6836697$export$35808ee640e87ca7; }, function (v) { return $dc2db8c7c6836697$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $dc2db8c7c6836697$export$fae74005e78b1a27; }, function (v) { return $dc2db8c7c6836697$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $dc2db8c7c6836697$export$dc8fbce3eb94dc1e; }, function (v) { return $dc2db8c7c6836697$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $dc2db8c7c6836697$export$6a7bc4e911dc01cf; }, function (v) { return $dc2db8c7c6836697$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $dc2db8c7c6836697$export$6d9c69b0de29b591; }, function (v) { return $dc2db8c7c6836697$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $dc2db8c7c6836697$export$f680877a34711e37; }, function (v) { return $dc2db8c7c6836697$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $dc2db8c7c6836697$export$d5a552a76deda3c2; }, function (v) { return $dc2db8c7c6836697$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $dc2db8c7c6836697$export$aaabe4eda9ed9969; }, function (v) { return $dc2db8c7c6836697$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $dc2db8c7c6836697$export$e5c5a5f917a5871c; }, function (v) { return $dc2db8c7c6836697$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $dc2db8c7c6836697$export$1538c33de8887b59; }, function (v) { return $dc2db8c7c6836697$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $dc2db8c7c6836697$export$13e3392192263954; }, function (v) { return $dc2db8c7c6836697$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $dc2db8c7c6836697$export$b8f5890fc79d6aca; }, function (v) { return $dc2db8c7c6836697$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $dc2db8c7c6836697$export$60241385465d0a34; }, function (v) { return $dc2db8c7c6836697$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $dc2db8c7c6836697$export$306c0aa65ff9ec16; }, function (v) { return $dc2db8c7c6836697$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $dc2db8c7c6836697$export$7b286972b8d8ccbf; }, function (v) { return $dc2db8c7c6836697$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $dc2db8c7c6836697$export$83d89fbfd8236492; }, function (v) { return $dc2db8c7c6836697$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dc2db8c7c6836697$export$dca3b0875bd9a954;
var $dc2db8c7c6836697$export$16fa2f45be04daa8;
var $dc2db8c7c6836697$export$ffb0004e005737fa;
var $dc2db8c7c6836697$export$e2c29f18771995cb;
var $dc2db8c7c6836697$export$221d75b3f55bb0bd;
var $dc2db8c7c6836697$export$5f8d39834fd61797;
var $dc2db8c7c6836697$export$74bf444e3cd11ea5;
var $dc2db8c7c6836697$export$ae55be85d98224ed;
var $dc2db8c7c6836697$export$e530037191fcd5d7;
var $dc2db8c7c6836697$export$fd42f52fd3ae1109;
var $dc2db8c7c6836697$export$c8a8987d4410bf2d;
var $dc2db8c7c6836697$export$d38cd72104c1f0e9;
var $dc2db8c7c6836697$export$7d1e3a5e95ceca43;
var $dc2db8c7c6836697$export$257a8862b851cb5b;
var $dc2db8c7c6836697$export$a8257692ac88316c;
var $dc2db8c7c6836697$export$488013bae63b21da;
var $dc2db8c7c6836697$export$7c73462e0d25e514;
var $dc2db8c7c6836697$export$7568632d0d33d16d;
var $dc2db8c7c6836697$export$88948ce120ea2619;
var $dc2db8c7c6836697$export$35808ee640e87ca7;
var $dc2db8c7c6836697$export$fae74005e78b1a27;
var $dc2db8c7c6836697$export$dc8fbce3eb94dc1e;
var $dc2db8c7c6836697$export$6a7bc4e911dc01cf;
var $dc2db8c7c6836697$export$6d9c69b0de29b591;
var $dc2db8c7c6836697$export$f680877a34711e37;
var $dc2db8c7c6836697$export$d5a552a76deda3c2;
var $dc2db8c7c6836697$export$aaabe4eda9ed9969;
var $dc2db8c7c6836697$export$e5c5a5f917a5871c;
var $dc2db8c7c6836697$export$1538c33de8887b59;
var $dc2db8c7c6836697$export$13e3392192263954;
var $dc2db8c7c6836697$export$b8f5890fc79d6aca;
var $dc2db8c7c6836697$export$60241385465d0a34;
var $dc2db8c7c6836697$export$306c0aa65ff9ec16;
var $dc2db8c7c6836697$export$7b286972b8d8ccbf;
var $dc2db8c7c6836697$export$83d89fbfd8236492;
"use strict";
var $dc2db8c7c6836697$var$l = Symbol.for("react.element"), $dc2db8c7c6836697$var$n = Symbol.for("react.portal"), $dc2db8c7c6836697$var$p = Symbol.for("react.fragment"), $dc2db8c7c6836697$var$q = Symbol.for("react.strict_mode"), $dc2db8c7c6836697$var$r = Symbol.for("react.profiler"), $dc2db8c7c6836697$var$t = Symbol.for("react.provider"), $dc2db8c7c6836697$var$u = Symbol.for("react.context"), $dc2db8c7c6836697$var$v = Symbol.for("react.forward_ref"), $dc2db8c7c6836697$var$w = Symbol.for("react.suspense"), $dc2db8c7c6836697$var$x = Symbol.for("react.memo"), $dc2db8c7c6836697$var$y = Symbol.for("react.lazy"), $dc2db8c7c6836697$var$z = Symbol.iterator;
function $dc2db8c7c6836697$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dc2db8c7c6836697$var$z && a[$dc2db8c7c6836697$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dc2db8c7c6836697$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dc2db8c7c6836697$var$C = Object.assign, $dc2db8c7c6836697$var$D = {};
function $dc2db8c7c6836697$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dc2db8c7c6836697$var$D;
    this.updater = e || $dc2db8c7c6836697$var$B;
}
$dc2db8c7c6836697$var$E.prototype.isReactComponent = {};
$dc2db8c7c6836697$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dc2db8c7c6836697$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dc2db8c7c6836697$var$F() {}
$dc2db8c7c6836697$var$F.prototype = $dc2db8c7c6836697$var$E.prototype;
function $dc2db8c7c6836697$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dc2db8c7c6836697$var$D;
    this.updater = e || $dc2db8c7c6836697$var$B;
}
var $dc2db8c7c6836697$var$H = $dc2db8c7c6836697$var$G.prototype = new $dc2db8c7c6836697$var$F;
$dc2db8c7c6836697$var$H.constructor = $dc2db8c7c6836697$var$G;
$dc2db8c7c6836697$var$C($dc2db8c7c6836697$var$H, $dc2db8c7c6836697$var$E.prototype);
$dc2db8c7c6836697$var$H.isPureReactComponent = !0;
var $dc2db8c7c6836697$var$I = Array.isArray, $dc2db8c7c6836697$var$J = Object.prototype.hasOwnProperty, $dc2db8c7c6836697$var$K = {
    current: null
}, $dc2db8c7c6836697$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dc2db8c7c6836697$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dc2db8c7c6836697$var$J.call(b, d) && !$dc2db8c7c6836697$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dc2db8c7c6836697$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dc2db8c7c6836697$var$K.current
    };
}
function $dc2db8c7c6836697$var$N(a, b) {
    return {
        $$typeof: $dc2db8c7c6836697$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dc2db8c7c6836697$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dc2db8c7c6836697$var$l;
}
function $dc2db8c7c6836697$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dc2db8c7c6836697$var$P = /\/+/g;
function $dc2db8c7c6836697$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dc2db8c7c6836697$var$escape("" + a.key) : b.toString(36);
}
function $dc2db8c7c6836697$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dc2db8c7c6836697$var$l:
                case $dc2db8c7c6836697$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dc2db8c7c6836697$var$Q(h, 0) : d, $dc2db8c7c6836697$var$I(c) ? (e = "", null != a && (e = a.replace($dc2db8c7c6836697$var$P, "$&/") + "/"), $dc2db8c7c6836697$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dc2db8c7c6836697$var$O(c) && (c = $dc2db8c7c6836697$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dc2db8c7c6836697$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dc2db8c7c6836697$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dc2db8c7c6836697$var$Q(k, g);
        h += $dc2db8c7c6836697$var$R(k, b, e, f, c);
    }
    else if (f = $dc2db8c7c6836697$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dc2db8c7c6836697$var$Q(k, g++), h += $dc2db8c7c6836697$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dc2db8c7c6836697$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dc2db8c7c6836697$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dc2db8c7c6836697$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dc2db8c7c6836697$var$U = {
    current: null
}, $dc2db8c7c6836697$var$V = {
    transition: null
}, $dc2db8c7c6836697$var$W = {
    ReactCurrentDispatcher: $dc2db8c7c6836697$var$U,
    ReactCurrentBatchConfig: $dc2db8c7c6836697$var$V,
    ReactCurrentOwner: $dc2db8c7c6836697$var$K
};
$dc2db8c7c6836697$export$dca3b0875bd9a954 = {
    map: $dc2db8c7c6836697$var$S,
    forEach: function(a, b, e) {
        $dc2db8c7c6836697$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dc2db8c7c6836697$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dc2db8c7c6836697$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dc2db8c7c6836697$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dc2db8c7c6836697$export$16fa2f45be04daa8 = $dc2db8c7c6836697$var$E;
$dc2db8c7c6836697$export$ffb0004e005737fa = $dc2db8c7c6836697$var$p;
$dc2db8c7c6836697$export$e2c29f18771995cb = $dc2db8c7c6836697$var$r;
$dc2db8c7c6836697$export$221d75b3f55bb0bd = $dc2db8c7c6836697$var$G;
$dc2db8c7c6836697$export$5f8d39834fd61797 = $dc2db8c7c6836697$var$q;
$dc2db8c7c6836697$export$74bf444e3cd11ea5 = $dc2db8c7c6836697$var$w;
$dc2db8c7c6836697$export$ae55be85d98224ed = $dc2db8c7c6836697$var$W;
$dc2db8c7c6836697$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dc2db8c7c6836697$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dc2db8c7c6836697$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dc2db8c7c6836697$var$J.call(b, f) && !$dc2db8c7c6836697$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dc2db8c7c6836697$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dc2db8c7c6836697$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dc2db8c7c6836697$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dc2db8c7c6836697$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dc2db8c7c6836697$export$c8a8987d4410bf2d = $dc2db8c7c6836697$var$M;
$dc2db8c7c6836697$export$d38cd72104c1f0e9 = function(a) {
    var b = $dc2db8c7c6836697$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dc2db8c7c6836697$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dc2db8c7c6836697$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dc2db8c7c6836697$var$v,
        render: a
    };
};
$dc2db8c7c6836697$export$a8257692ac88316c = $dc2db8c7c6836697$var$O;
$dc2db8c7c6836697$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dc2db8c7c6836697$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dc2db8c7c6836697$var$T
    };
};
$dc2db8c7c6836697$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dc2db8c7c6836697$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dc2db8c7c6836697$export$7568632d0d33d16d = function(a) {
    var b = $dc2db8c7c6836697$var$V.transition;
    $dc2db8c7c6836697$var$V.transition = {};
    try {
        a();
    } finally{
        $dc2db8c7c6836697$var$V.transition = b;
    }
};
$dc2db8c7c6836697$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$dc2db8c7c6836697$export$35808ee640e87ca7 = function(a, b) {
    return $dc2db8c7c6836697$var$U.current.useCallback(a, b);
};
$dc2db8c7c6836697$export$fae74005e78b1a27 = function(a) {
    return $dc2db8c7c6836697$var$U.current.useContext(a);
};
$dc2db8c7c6836697$export$dc8fbce3eb94dc1e = function() {};
$dc2db8c7c6836697$export$6a7bc4e911dc01cf = function(a) {
    return $dc2db8c7c6836697$var$U.current.useDeferredValue(a);
};
$dc2db8c7c6836697$export$6d9c69b0de29b591 = function(a, b) {
    return $dc2db8c7c6836697$var$U.current.useEffect(a, b);
};
$dc2db8c7c6836697$export$f680877a34711e37 = function() {
    return $dc2db8c7c6836697$var$U.current.useId();
};
$dc2db8c7c6836697$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dc2db8c7c6836697$var$U.current.useImperativeHandle(a, b, e);
};
$dc2db8c7c6836697$export$aaabe4eda9ed9969 = function(a, b) {
    return $dc2db8c7c6836697$var$U.current.useInsertionEffect(a, b);
};
$dc2db8c7c6836697$export$e5c5a5f917a5871c = function(a, b) {
    return $dc2db8c7c6836697$var$U.current.useLayoutEffect(a, b);
};
$dc2db8c7c6836697$export$1538c33de8887b59 = function(a, b) {
    return $dc2db8c7c6836697$var$U.current.useMemo(a, b);
};
$dc2db8c7c6836697$export$13e3392192263954 = function(a, b, e) {
    return $dc2db8c7c6836697$var$U.current.useReducer(a, b, e);
};
$dc2db8c7c6836697$export$b8f5890fc79d6aca = function(a) {
    return $dc2db8c7c6836697$var$U.current.useRef(a);
};
$dc2db8c7c6836697$export$60241385465d0a34 = function(a) {
    return $dc2db8c7c6836697$var$U.current.useState(a);
};
$dc2db8c7c6836697$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dc2db8c7c6836697$var$U.current.useSyncExternalStore(a, b, e);
};
$dc2db8c7c6836697$export$7b286972b8d8ccbf = function() {
    return $dc2db8c7c6836697$var$U.current.useTransition();
};
$dc2db8c7c6836697$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("eALUl", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $a9f996f354cff77e$export$ae55be85d98224ed; }, function (v) { return $a9f996f354cff77e$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $a9f996f354cff77e$export$d39a5bbd09211389; }, function (v) { return $a9f996f354cff77e$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $a9f996f354cff77e$export$882461b6382ed46c; }, function (v) { return $a9f996f354cff77e$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $a9f996f354cff77e$export$466bfc07425424d5; }, function (v) { return $a9f996f354cff77e$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $a9f996f354cff77e$export$cd75ccfd720a3cd4; }, function (v) { return $a9f996f354cff77e$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $a9f996f354cff77e$export$fa8d919ba61d84db; }, function (v) { return $a9f996f354cff77e$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $a9f996f354cff77e$export$757ceba2d55c277e; }, function (v) { return $a9f996f354cff77e$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $a9f996f354cff77e$export$b3890eb0ae9dca99; }, function (v) { return $a9f996f354cff77e$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $a9f996f354cff77e$export$502457920280e6be; }, function (v) { return $a9f996f354cff77e$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $a9f996f354cff77e$export$c78a37762a8d58e1; }, function (v) { return $a9f996f354cff77e$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $a9f996f354cff77e$export$dc54d992c10e8a18; }, function (v) { return $a9f996f354cff77e$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $a9f996f354cff77e$export$83d89fbfd8236492; }, function (v) { return $a9f996f354cff77e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $a9f996f354cff77e$export$ae55be85d98224ed;
var $a9f996f354cff77e$export$d39a5bbd09211389;
var $a9f996f354cff77e$export$882461b6382ed46c;
var $a9f996f354cff77e$export$466bfc07425424d5;
var $a9f996f354cff77e$export$cd75ccfd720a3cd4;
var $a9f996f354cff77e$export$fa8d919ba61d84db;
var $a9f996f354cff77e$export$757ceba2d55c277e;
var $a9f996f354cff77e$export$b3890eb0ae9dca99;
var $a9f996f354cff77e$export$502457920280e6be;
var $a9f996f354cff77e$export$c78a37762a8d58e1;
var $a9f996f354cff77e$export$dc54d992c10e8a18;
var $a9f996f354cff77e$export$83d89fbfd8236492;
"use strict";

var $hEVyQ = parcelRequire("hEVyQ");

var $8PzWl = parcelRequire("8PzWl");
function $a9f996f354cff77e$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a9f996f354cff77e$var$da = new Set, $a9f996f354cff77e$var$ea = {};
function $a9f996f354cff77e$var$fa(a, b) {
    $a9f996f354cff77e$var$ha(a, b);
    $a9f996f354cff77e$var$ha(a + "Capture", b);
}
function $a9f996f354cff77e$var$ha(a, b) {
    $a9f996f354cff77e$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$a9f996f354cff77e$var$da.add(b[a]);
}
var $a9f996f354cff77e$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a9f996f354cff77e$var$ja = Object.prototype.hasOwnProperty, $a9f996f354cff77e$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a9f996f354cff77e$var$la = {}, $a9f996f354cff77e$var$ma = {};
function $a9f996f354cff77e$var$oa(a) {
    if ($a9f996f354cff77e$var$ja.call($a9f996f354cff77e$var$ma, a)) return !0;
    if ($a9f996f354cff77e$var$ja.call($a9f996f354cff77e$var$la, a)) return !1;
    if ($a9f996f354cff77e$var$ka.test(a)) return $a9f996f354cff77e$var$ma[a] = !0;
    $a9f996f354cff77e$var$la[a] = !0;
    return !1;
}
function $a9f996f354cff77e$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $a9f996f354cff77e$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $a9f996f354cff77e$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $a9f996f354cff77e$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $a9f996f354cff77e$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a9f996f354cff77e$var$z[a] = new $a9f996f354cff77e$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a9f996f354cff77e$var$z[b] = new $a9f996f354cff77e$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a9f996f354cff77e$var$z[a] = new $a9f996f354cff77e$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a9f996f354cff77e$var$z[a] = new $a9f996f354cff77e$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a9f996f354cff77e$var$z[a] = new $a9f996f354cff77e$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a9f996f354cff77e$var$z[a] = new $a9f996f354cff77e$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a9f996f354cff77e$var$z[a] = new $a9f996f354cff77e$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a9f996f354cff77e$var$z[a] = new $a9f996f354cff77e$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a9f996f354cff77e$var$z[a] = new $a9f996f354cff77e$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a9f996f354cff77e$var$ra = /[\-:]([a-z])/g;
function $a9f996f354cff77e$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a9f996f354cff77e$var$ra, $a9f996f354cff77e$var$sa);
    $a9f996f354cff77e$var$z[b] = new $a9f996f354cff77e$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a9f996f354cff77e$var$ra, $a9f996f354cff77e$var$sa);
    $a9f996f354cff77e$var$z[b] = new $a9f996f354cff77e$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a9f996f354cff77e$var$ra, $a9f996f354cff77e$var$sa);
    $a9f996f354cff77e$var$z[b] = new $a9f996f354cff77e$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a9f996f354cff77e$var$z[a] = new $a9f996f354cff77e$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a9f996f354cff77e$var$z.xlinkHref = new $a9f996f354cff77e$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a9f996f354cff77e$var$z[a] = new $a9f996f354cff77e$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $a9f996f354cff77e$var$ta(a, b, c, d) {
    var e = $a9f996f354cff77e$var$z.hasOwnProperty(b) ? $a9f996f354cff77e$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $a9f996f354cff77e$var$qa(b, c, e, d) && (c = null), d || null === e ? $a9f996f354cff77e$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $a9f996f354cff77e$var$ua = $hEVyQ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $a9f996f354cff77e$var$va = Symbol.for("react.element"), $a9f996f354cff77e$var$wa = Symbol.for("react.portal"), $a9f996f354cff77e$var$ya = Symbol.for("react.fragment"), $a9f996f354cff77e$var$za = Symbol.for("react.strict_mode"), $a9f996f354cff77e$var$Aa = Symbol.for("react.profiler"), $a9f996f354cff77e$var$Ba = Symbol.for("react.provider"), $a9f996f354cff77e$var$Ca = Symbol.for("react.context"), $a9f996f354cff77e$var$Da = Symbol.for("react.forward_ref"), $a9f996f354cff77e$var$Ea = Symbol.for("react.suspense"), $a9f996f354cff77e$var$Fa = Symbol.for("react.suspense_list"), $a9f996f354cff77e$var$Ga = Symbol.for("react.memo"), $a9f996f354cff77e$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $a9f996f354cff77e$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $a9f996f354cff77e$var$Ja = Symbol.iterator;
function $a9f996f354cff77e$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a9f996f354cff77e$var$Ja && a[$a9f996f354cff77e$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a9f996f354cff77e$var$A = Object.assign, $a9f996f354cff77e$var$La;
function $a9f996f354cff77e$var$Ma(a) {
    if (void 0 === $a9f996f354cff77e$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $a9f996f354cff77e$var$La = b && b[1] || "";
    }
    return "\n" + $a9f996f354cff77e$var$La + a;
}
var $a9f996f354cff77e$var$Na = !1;
function $a9f996f354cff77e$var$Oa(a, b) {
    if (!a || $a9f996f354cff77e$var$Na) return "";
    $a9f996f354cff77e$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $a9f996f354cff77e$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $a9f996f354cff77e$var$Ma(a) : "";
}
function $a9f996f354cff77e$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $a9f996f354cff77e$var$Ma(a.type);
        case 16:
            return $a9f996f354cff77e$var$Ma("Lazy");
        case 13:
            return $a9f996f354cff77e$var$Ma("Suspense");
        case 19:
            return $a9f996f354cff77e$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $a9f996f354cff77e$var$Oa(a.type, !1), a;
        case 11:
            return a = $a9f996f354cff77e$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $a9f996f354cff77e$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $a9f996f354cff77e$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a9f996f354cff77e$var$ya:
            return "Fragment";
        case $a9f996f354cff77e$var$wa:
            return "Portal";
        case $a9f996f354cff77e$var$Aa:
            return "Profiler";
        case $a9f996f354cff77e$var$za:
            return "StrictMode";
        case $a9f996f354cff77e$var$Ea:
            return "Suspense";
        case $a9f996f354cff77e$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a9f996f354cff77e$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $a9f996f354cff77e$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $a9f996f354cff77e$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $a9f996f354cff77e$var$Ga:
            return b = a.displayName || null, null !== b ? b : $a9f996f354cff77e$var$Qa(a.type) || "Memo";
        case $a9f996f354cff77e$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $a9f996f354cff77e$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $a9f996f354cff77e$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $a9f996f354cff77e$var$Qa(b);
        case 8:
            return b === $a9f996f354cff77e$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $a9f996f354cff77e$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $a9f996f354cff77e$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $a9f996f354cff77e$var$Ua(a) {
    var b = $a9f996f354cff77e$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $a9f996f354cff77e$var$Va(a) {
    a._valueTracker || (a._valueTracker = $a9f996f354cff77e$var$Ua(a));
}
function $a9f996f354cff77e$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $a9f996f354cff77e$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $a9f996f354cff77e$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $a9f996f354cff77e$var$Ya(a, b) {
    var c = b.checked;
    return $a9f996f354cff77e$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $a9f996f354cff77e$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $a9f996f354cff77e$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a9f996f354cff77e$var$ab(a, b) {
    b = b.checked;
    null != b && $a9f996f354cff77e$var$ta(a, "checked", b, !1);
}
function $a9f996f354cff77e$var$bb(a, b) {
    $a9f996f354cff77e$var$ab(a, b);
    var c = $a9f996f354cff77e$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $a9f996f354cff77e$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $a9f996f354cff77e$var$cb(a, b.type, $a9f996f354cff77e$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $a9f996f354cff77e$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $a9f996f354cff77e$var$cb(a, b, c) {
    if ("number" !== b || $a9f996f354cff77e$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $a9f996f354cff77e$var$eb = Array.isArray;
function $a9f996f354cff77e$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $a9f996f354cff77e$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $a9f996f354cff77e$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($a9f996f354cff77e$var$p(91));
    return $a9f996f354cff77e$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $a9f996f354cff77e$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($a9f996f354cff77e$var$p(92));
            if ($a9f996f354cff77e$var$eb(c)) {
                if (1 < c.length) throw Error($a9f996f354cff77e$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $a9f996f354cff77e$var$Sa(c)
    };
}
function $a9f996f354cff77e$var$ib(a, b) {
    var c = $a9f996f354cff77e$var$Sa(b.value), d = $a9f996f354cff77e$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $a9f996f354cff77e$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $a9f996f354cff77e$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $a9f996f354cff77e$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $a9f996f354cff77e$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $a9f996f354cff77e$var$mb, $a9f996f354cff77e$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $a9f996f354cff77e$var$mb = $a9f996f354cff77e$var$mb || document.createElement("div");
        $a9f996f354cff77e$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $a9f996f354cff77e$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $a9f996f354cff77e$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $a9f996f354cff77e$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a9f996f354cff77e$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a9f996f354cff77e$var$pb).forEach(function(a) {
    $a9f996f354cff77e$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a9f996f354cff77e$var$pb[b] = $a9f996f354cff77e$var$pb[a];
    });
});
function $a9f996f354cff77e$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $a9f996f354cff77e$var$pb.hasOwnProperty(a) && $a9f996f354cff77e$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $a9f996f354cff77e$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $a9f996f354cff77e$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $a9f996f354cff77e$var$tb = $a9f996f354cff77e$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $a9f996f354cff77e$var$ub(a, b) {
    if (b) {
        if ($a9f996f354cff77e$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($a9f996f354cff77e$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($a9f996f354cff77e$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($a9f996f354cff77e$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($a9f996f354cff77e$var$p(62));
    }
}
function $a9f996f354cff77e$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $a9f996f354cff77e$var$wb = null;
function $a9f996f354cff77e$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $a9f996f354cff77e$var$yb = null, $a9f996f354cff77e$var$zb = null, $a9f996f354cff77e$var$Ab = null;
function $a9f996f354cff77e$var$Bb(a) {
    if (a = $a9f996f354cff77e$var$Cb(a)) {
        if ("function" !== typeof $a9f996f354cff77e$var$yb) throw Error($a9f996f354cff77e$var$p(280));
        var b = a.stateNode;
        b && (b = $a9f996f354cff77e$var$Db(b), $a9f996f354cff77e$var$yb(a.stateNode, a.type, b));
    }
}
function $a9f996f354cff77e$var$Eb(a) {
    $a9f996f354cff77e$var$zb ? $a9f996f354cff77e$var$Ab ? $a9f996f354cff77e$var$Ab.push(a) : $a9f996f354cff77e$var$Ab = [
        a
    ] : $a9f996f354cff77e$var$zb = a;
}
function $a9f996f354cff77e$var$Fb() {
    if ($a9f996f354cff77e$var$zb) {
        var a = $a9f996f354cff77e$var$zb, b = $a9f996f354cff77e$var$Ab;
        $a9f996f354cff77e$var$Ab = $a9f996f354cff77e$var$zb = null;
        $a9f996f354cff77e$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$a9f996f354cff77e$var$Bb(b[a]);
    }
}
function $a9f996f354cff77e$var$Gb(a, b) {
    return a(b);
}
function $a9f996f354cff77e$var$Hb() {}
var $a9f996f354cff77e$var$Ib = !1;
function $a9f996f354cff77e$var$Jb(a, b, c) {
    if ($a9f996f354cff77e$var$Ib) return a(b, c);
    $a9f996f354cff77e$var$Ib = !0;
    try {
        return $a9f996f354cff77e$var$Gb(a, b, c);
    } finally{
        if ($a9f996f354cff77e$var$Ib = !1, null !== $a9f996f354cff77e$var$zb || null !== $a9f996f354cff77e$var$Ab) $a9f996f354cff77e$var$Hb(), $a9f996f354cff77e$var$Fb();
    }
}
function $a9f996f354cff77e$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $a9f996f354cff77e$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($a9f996f354cff77e$var$p(231, b, typeof c));
    return c;
}
var $a9f996f354cff77e$var$Lb = !1;
if ($a9f996f354cff77e$var$ia) try {
    var $a9f996f354cff77e$var$Mb = {};
    Object.defineProperty($a9f996f354cff77e$var$Mb, "passive", {
        get: function() {
            $a9f996f354cff77e$var$Lb = !0;
        }
    });
    window.addEventListener("test", $a9f996f354cff77e$var$Mb, $a9f996f354cff77e$var$Mb);
    window.removeEventListener("test", $a9f996f354cff77e$var$Mb, $a9f996f354cff77e$var$Mb);
} catch (a) {
    $a9f996f354cff77e$var$Lb = !1;
}
function $a9f996f354cff77e$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $a9f996f354cff77e$var$Ob = !1, $a9f996f354cff77e$var$Pb = null, $a9f996f354cff77e$var$Qb = !1, $a9f996f354cff77e$var$Rb = null, $a9f996f354cff77e$var$Sb = {
    onError: function(a) {
        $a9f996f354cff77e$var$Ob = !0;
        $a9f996f354cff77e$var$Pb = a;
    }
};
function $a9f996f354cff77e$var$Tb(a, b, c, d, e, f, g, h, k) {
    $a9f996f354cff77e$var$Ob = !1;
    $a9f996f354cff77e$var$Pb = null;
    $a9f996f354cff77e$var$Nb.apply($a9f996f354cff77e$var$Sb, arguments);
}
function $a9f996f354cff77e$var$Ub(a, b, c, d, e, f, g, h, k) {
    $a9f996f354cff77e$var$Tb.apply(this, arguments);
    if ($a9f996f354cff77e$var$Ob) {
        if ($a9f996f354cff77e$var$Ob) {
            var l = $a9f996f354cff77e$var$Pb;
            $a9f996f354cff77e$var$Ob = !1;
            $a9f996f354cff77e$var$Pb = null;
        } else throw Error($a9f996f354cff77e$var$p(198));
        $a9f996f354cff77e$var$Qb || ($a9f996f354cff77e$var$Qb = !0, $a9f996f354cff77e$var$Rb = l);
    }
}
function $a9f996f354cff77e$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $a9f996f354cff77e$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $a9f996f354cff77e$var$Xb(a) {
    if ($a9f996f354cff77e$var$Vb(a) !== a) throw Error($a9f996f354cff77e$var$p(188));
}
function $a9f996f354cff77e$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $a9f996f354cff77e$var$Vb(a);
        if (null === b) throw Error($a9f996f354cff77e$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $a9f996f354cff77e$var$Xb(e), a;
                if (f === d) return $a9f996f354cff77e$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($a9f996f354cff77e$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($a9f996f354cff77e$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($a9f996f354cff77e$var$p(190));
    }
    if (3 !== c.tag) throw Error($a9f996f354cff77e$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $a9f996f354cff77e$var$Zb(a) {
    a = $a9f996f354cff77e$var$Yb(a);
    return null !== a ? $a9f996f354cff77e$var$$b(a) : null;
}
function $a9f996f354cff77e$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $a9f996f354cff77e$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $a9f996f354cff77e$var$ac = $8PzWl.unstable_scheduleCallback, $a9f996f354cff77e$var$bc = $8PzWl.unstable_cancelCallback, $a9f996f354cff77e$var$cc = $8PzWl.unstable_shouldYield, $a9f996f354cff77e$var$dc = $8PzWl.unstable_requestPaint, $a9f996f354cff77e$var$B = $8PzWl.unstable_now, $a9f996f354cff77e$var$ec = $8PzWl.unstable_getCurrentPriorityLevel, $a9f996f354cff77e$var$fc = $8PzWl.unstable_ImmediatePriority, $a9f996f354cff77e$var$gc = $8PzWl.unstable_UserBlockingPriority, $a9f996f354cff77e$var$hc = $8PzWl.unstable_NormalPriority, $a9f996f354cff77e$var$ic = $8PzWl.unstable_LowPriority, $a9f996f354cff77e$var$jc = $8PzWl.unstable_IdlePriority, $a9f996f354cff77e$var$kc = null, $a9f996f354cff77e$var$lc = null;
function $a9f996f354cff77e$var$mc(a) {
    if ($a9f996f354cff77e$var$lc && "function" === typeof $a9f996f354cff77e$var$lc.onCommitFiberRoot) try {
        $a9f996f354cff77e$var$lc.onCommitFiberRoot($a9f996f354cff77e$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $a9f996f354cff77e$var$oc = Math.clz32 ? Math.clz32 : $a9f996f354cff77e$var$nc, $a9f996f354cff77e$var$pc = Math.log, $a9f996f354cff77e$var$qc = Math.LN2;
function $a9f996f354cff77e$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($a9f996f354cff77e$var$pc(a) / $a9f996f354cff77e$var$qc | 0) | 0;
}
var $a9f996f354cff77e$var$rc = 64, $a9f996f354cff77e$var$sc = 4194304;
function $a9f996f354cff77e$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $a9f996f354cff77e$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $a9f996f354cff77e$var$tc(h) : (f &= g, 0 !== f && (d = $a9f996f354cff77e$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $a9f996f354cff77e$var$tc(g) : 0 !== f && (d = $a9f996f354cff77e$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $a9f996f354cff77e$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $a9f996f354cff77e$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $a9f996f354cff77e$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $a9f996f354cff77e$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $a9f996f354cff77e$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $a9f996f354cff77e$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $a9f996f354cff77e$var$yc() {
    var a = $a9f996f354cff77e$var$rc;
    $a9f996f354cff77e$var$rc <<= 1;
    0 === ($a9f996f354cff77e$var$rc & 4194240) && ($a9f996f354cff77e$var$rc = 64);
    return a;
}
function $a9f996f354cff77e$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $a9f996f354cff77e$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $a9f996f354cff77e$var$oc(b);
    a[b] = c;
}
function $a9f996f354cff77e$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $a9f996f354cff77e$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $a9f996f354cff77e$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $a9f996f354cff77e$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $a9f996f354cff77e$var$C = 0;
function $a9f996f354cff77e$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $a9f996f354cff77e$var$Ec, $a9f996f354cff77e$var$Fc, $a9f996f354cff77e$var$Gc, $a9f996f354cff77e$var$Hc, $a9f996f354cff77e$var$Ic, $a9f996f354cff77e$var$Jc = !1, $a9f996f354cff77e$var$Kc = [], $a9f996f354cff77e$var$Lc = null, $a9f996f354cff77e$var$Mc = null, $a9f996f354cff77e$var$Nc = null, $a9f996f354cff77e$var$Oc = new Map, $a9f996f354cff77e$var$Pc = new Map, $a9f996f354cff77e$var$Qc = [], $a9f996f354cff77e$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $a9f996f354cff77e$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $a9f996f354cff77e$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $a9f996f354cff77e$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $a9f996f354cff77e$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $a9f996f354cff77e$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a9f996f354cff77e$var$Pc.delete(b.pointerId);
    }
}
function $a9f996f354cff77e$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $a9f996f354cff77e$var$Cb(b), null !== b && $a9f996f354cff77e$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $a9f996f354cff77e$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $a9f996f354cff77e$var$Lc = $a9f996f354cff77e$var$Tc($a9f996f354cff77e$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $a9f996f354cff77e$var$Mc = $a9f996f354cff77e$var$Tc($a9f996f354cff77e$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $a9f996f354cff77e$var$Nc = $a9f996f354cff77e$var$Tc($a9f996f354cff77e$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $a9f996f354cff77e$var$Oc.set(f, $a9f996f354cff77e$var$Tc($a9f996f354cff77e$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $a9f996f354cff77e$var$Pc.set(f, $a9f996f354cff77e$var$Tc($a9f996f354cff77e$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $a9f996f354cff77e$var$Vc(a) {
    var b = $a9f996f354cff77e$var$Wc(a.target);
    if (null !== b) {
        var c = $a9f996f354cff77e$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $a9f996f354cff77e$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $a9f996f354cff77e$var$Ic(a.priority, function() {
                        $a9f996f354cff77e$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $a9f996f354cff77e$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $a9f996f354cff77e$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $a9f996f354cff77e$var$wb = d;
            c.target.dispatchEvent(d);
            $a9f996f354cff77e$var$wb = null;
        } else return b = $a9f996f354cff77e$var$Cb(c), null !== b && $a9f996f354cff77e$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $a9f996f354cff77e$var$Zc(a, b, c) {
    $a9f996f354cff77e$var$Xc(a) && c.delete(b);
}
function $a9f996f354cff77e$var$$c() {
    $a9f996f354cff77e$var$Jc = !1;
    null !== $a9f996f354cff77e$var$Lc && $a9f996f354cff77e$var$Xc($a9f996f354cff77e$var$Lc) && ($a9f996f354cff77e$var$Lc = null);
    null !== $a9f996f354cff77e$var$Mc && $a9f996f354cff77e$var$Xc($a9f996f354cff77e$var$Mc) && ($a9f996f354cff77e$var$Mc = null);
    null !== $a9f996f354cff77e$var$Nc && $a9f996f354cff77e$var$Xc($a9f996f354cff77e$var$Nc) && ($a9f996f354cff77e$var$Nc = null);
    $a9f996f354cff77e$var$Oc.forEach($a9f996f354cff77e$var$Zc);
    $a9f996f354cff77e$var$Pc.forEach($a9f996f354cff77e$var$Zc);
}
function $a9f996f354cff77e$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $a9f996f354cff77e$var$Jc || ($a9f996f354cff77e$var$Jc = !0, $8PzWl.unstable_scheduleCallback($8PzWl.unstable_NormalPriority, $a9f996f354cff77e$var$$c)));
}
function $a9f996f354cff77e$var$bd(a) {
    function b(b) {
        return $a9f996f354cff77e$var$ad(b, a);
    }
    if (0 < $a9f996f354cff77e$var$Kc.length) {
        $a9f996f354cff77e$var$ad($a9f996f354cff77e$var$Kc[0], a);
        for(var c = 1; c < $a9f996f354cff77e$var$Kc.length; c++){
            var d = $a9f996f354cff77e$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $a9f996f354cff77e$var$Lc && $a9f996f354cff77e$var$ad($a9f996f354cff77e$var$Lc, a);
    null !== $a9f996f354cff77e$var$Mc && $a9f996f354cff77e$var$ad($a9f996f354cff77e$var$Mc, a);
    null !== $a9f996f354cff77e$var$Nc && $a9f996f354cff77e$var$ad($a9f996f354cff77e$var$Nc, a);
    $a9f996f354cff77e$var$Oc.forEach(b);
    $a9f996f354cff77e$var$Pc.forEach(b);
    for(c = 0; c < $a9f996f354cff77e$var$Qc.length; c++)d = $a9f996f354cff77e$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $a9f996f354cff77e$var$Qc.length && (c = $a9f996f354cff77e$var$Qc[0], null === c.blockedOn);)$a9f996f354cff77e$var$Vc(c), null === c.blockedOn && $a9f996f354cff77e$var$Qc.shift();
}
var $a9f996f354cff77e$var$cd = $a9f996f354cff77e$var$ua.ReactCurrentBatchConfig, $a9f996f354cff77e$var$dd = !0;
function $a9f996f354cff77e$var$ed(a, b, c, d) {
    var e = $a9f996f354cff77e$var$C, f = $a9f996f354cff77e$var$cd.transition;
    $a9f996f354cff77e$var$cd.transition = null;
    try {
        $a9f996f354cff77e$var$C = 1, $a9f996f354cff77e$var$fd(a, b, c, d);
    } finally{
        $a9f996f354cff77e$var$C = e, $a9f996f354cff77e$var$cd.transition = f;
    }
}
function $a9f996f354cff77e$var$gd(a, b, c, d) {
    var e = $a9f996f354cff77e$var$C, f = $a9f996f354cff77e$var$cd.transition;
    $a9f996f354cff77e$var$cd.transition = null;
    try {
        $a9f996f354cff77e$var$C = 4, $a9f996f354cff77e$var$fd(a, b, c, d);
    } finally{
        $a9f996f354cff77e$var$C = e, $a9f996f354cff77e$var$cd.transition = f;
    }
}
function $a9f996f354cff77e$var$fd(a, b, c, d) {
    if ($a9f996f354cff77e$var$dd) {
        var e = $a9f996f354cff77e$var$Yc(a, b, c, d);
        if (null === e) $a9f996f354cff77e$var$hd(a, b, d, $a9f996f354cff77e$var$id, c), $a9f996f354cff77e$var$Sc(a, d);
        else if ($a9f996f354cff77e$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($a9f996f354cff77e$var$Sc(a, d), b & 4 && -1 < $a9f996f354cff77e$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $a9f996f354cff77e$var$Cb(e);
                null !== f && $a9f996f354cff77e$var$Ec(f);
                f = $a9f996f354cff77e$var$Yc(a, b, c, d);
                null === f && $a9f996f354cff77e$var$hd(a, b, d, $a9f996f354cff77e$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $a9f996f354cff77e$var$hd(a, b, d, null, c);
    }
}
var $a9f996f354cff77e$var$id = null;
function $a9f996f354cff77e$var$Yc(a, b, c, d) {
    $a9f996f354cff77e$var$id = null;
    a = $a9f996f354cff77e$var$xb(d);
    a = $a9f996f354cff77e$var$Wc(a);
    if (null !== a) {
        if (b = $a9f996f354cff77e$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $a9f996f354cff77e$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $a9f996f354cff77e$var$id = a;
    return null;
}
function $a9f996f354cff77e$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($a9f996f354cff77e$var$ec()){
                case $a9f996f354cff77e$var$fc:
                    return 1;
                case $a9f996f354cff77e$var$gc:
                    return 4;
                case $a9f996f354cff77e$var$hc:
                case $a9f996f354cff77e$var$ic:
                    return 16;
                case $a9f996f354cff77e$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $a9f996f354cff77e$var$kd = null, $a9f996f354cff77e$var$ld = null, $a9f996f354cff77e$var$md = null;
function $a9f996f354cff77e$var$nd() {
    if ($a9f996f354cff77e$var$md) return $a9f996f354cff77e$var$md;
    var a, b = $a9f996f354cff77e$var$ld, c = b.length, d, e = "value" in $a9f996f354cff77e$var$kd ? $a9f996f354cff77e$var$kd.value : $a9f996f354cff77e$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $a9f996f354cff77e$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $a9f996f354cff77e$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $a9f996f354cff77e$var$pd() {
    return !0;
}
function $a9f996f354cff77e$var$qd() {
    return !1;
}
function $a9f996f354cff77e$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $a9f996f354cff77e$var$pd : $a9f996f354cff77e$var$qd;
        this.isPropagationStopped = $a9f996f354cff77e$var$qd;
        return this;
    }
    $a9f996f354cff77e$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $a9f996f354cff77e$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $a9f996f354cff77e$var$pd);
        },
        persist: function() {},
        isPersistent: $a9f996f354cff77e$var$pd
    });
    return b;
}
var $a9f996f354cff77e$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a9f996f354cff77e$var$td = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$sd), $a9f996f354cff77e$var$ud = $a9f996f354cff77e$var$A({}, $a9f996f354cff77e$var$sd, {
    view: 0,
    detail: 0
}), $a9f996f354cff77e$var$vd = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$ud), $a9f996f354cff77e$var$wd, $a9f996f354cff77e$var$xd, $a9f996f354cff77e$var$yd, $a9f996f354cff77e$var$Ad = $a9f996f354cff77e$var$A({}, $a9f996f354cff77e$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a9f996f354cff77e$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $a9f996f354cff77e$var$yd && ($a9f996f354cff77e$var$yd && "mousemove" === a.type ? ($a9f996f354cff77e$var$wd = a.screenX - $a9f996f354cff77e$var$yd.screenX, $a9f996f354cff77e$var$xd = a.screenY - $a9f996f354cff77e$var$yd.screenY) : $a9f996f354cff77e$var$xd = $a9f996f354cff77e$var$wd = 0, $a9f996f354cff77e$var$yd = a);
        return $a9f996f354cff77e$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $a9f996f354cff77e$var$xd;
    }
}), $a9f996f354cff77e$var$Bd = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$Ad), $a9f996f354cff77e$var$Cd = $a9f996f354cff77e$var$A({}, $a9f996f354cff77e$var$Ad, {
    dataTransfer: 0
}), $a9f996f354cff77e$var$Dd = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$Cd), $a9f996f354cff77e$var$Ed = $a9f996f354cff77e$var$A({}, $a9f996f354cff77e$var$ud, {
    relatedTarget: 0
}), $a9f996f354cff77e$var$Fd = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$Ed), $a9f996f354cff77e$var$Gd = $a9f996f354cff77e$var$A({}, $a9f996f354cff77e$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a9f996f354cff77e$var$Hd = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$Gd), $a9f996f354cff77e$var$Id = $a9f996f354cff77e$var$A({}, $a9f996f354cff77e$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $a9f996f354cff77e$var$Jd = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$Id), $a9f996f354cff77e$var$Kd = $a9f996f354cff77e$var$A({}, $a9f996f354cff77e$var$sd, {
    data: 0
}), $a9f996f354cff77e$var$Ld = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$Kd), $a9f996f354cff77e$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a9f996f354cff77e$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a9f996f354cff77e$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a9f996f354cff77e$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $a9f996f354cff77e$var$Od[a]) ? !!b[a] : !1;
}
function $a9f996f354cff77e$var$zd() {
    return $a9f996f354cff77e$var$Pd;
}
var $a9f996f354cff77e$var$Qd = $a9f996f354cff77e$var$A({}, $a9f996f354cff77e$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $a9f996f354cff77e$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $a9f996f354cff77e$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $a9f996f354cff77e$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a9f996f354cff77e$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $a9f996f354cff77e$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $a9f996f354cff77e$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $a9f996f354cff77e$var$Rd = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$Qd), $a9f996f354cff77e$var$Sd = $a9f996f354cff77e$var$A({}, $a9f996f354cff77e$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a9f996f354cff77e$var$Td = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$Sd), $a9f996f354cff77e$var$Ud = $a9f996f354cff77e$var$A({}, $a9f996f354cff77e$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a9f996f354cff77e$var$zd
}), $a9f996f354cff77e$var$Vd = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$Ud), $a9f996f354cff77e$var$Wd = $a9f996f354cff77e$var$A({}, $a9f996f354cff77e$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a9f996f354cff77e$var$Xd = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$Wd), $a9f996f354cff77e$var$Yd = $a9f996f354cff77e$var$A({}, $a9f996f354cff77e$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a9f996f354cff77e$var$Zd = $a9f996f354cff77e$var$rd($a9f996f354cff77e$var$Yd), $a9f996f354cff77e$var$$d = [
    9,
    13,
    27,
    32
], $a9f996f354cff77e$var$ae = $a9f996f354cff77e$var$ia && "CompositionEvent" in window, $a9f996f354cff77e$var$be = null;
$a9f996f354cff77e$var$ia && "documentMode" in document && ($a9f996f354cff77e$var$be = document.documentMode);
var $a9f996f354cff77e$var$ce = $a9f996f354cff77e$var$ia && "TextEvent" in window && !$a9f996f354cff77e$var$be, $a9f996f354cff77e$var$de = $a9f996f354cff77e$var$ia && (!$a9f996f354cff77e$var$ae || $a9f996f354cff77e$var$be && 8 < $a9f996f354cff77e$var$be && 11 >= $a9f996f354cff77e$var$be), $a9f996f354cff77e$var$ee = String.fromCharCode(32), $a9f996f354cff77e$var$fe = !1;
function $a9f996f354cff77e$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $a9f996f354cff77e$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a9f996f354cff77e$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $a9f996f354cff77e$var$ie = !1;
function $a9f996f354cff77e$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $a9f996f354cff77e$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $a9f996f354cff77e$var$fe = !0;
            return $a9f996f354cff77e$var$ee;
        case "textInput":
            return a = b.data, a === $a9f996f354cff77e$var$ee && $a9f996f354cff77e$var$fe ? null : a;
        default:
            return null;
    }
}
function $a9f996f354cff77e$var$ke(a, b) {
    if ($a9f996f354cff77e$var$ie) return "compositionend" === a || !$a9f996f354cff77e$var$ae && $a9f996f354cff77e$var$ge(a, b) ? (a = $a9f996f354cff77e$var$nd(), $a9f996f354cff77e$var$md = $a9f996f354cff77e$var$ld = $a9f996f354cff77e$var$kd = null, $a9f996f354cff77e$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $a9f996f354cff77e$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $a9f996f354cff77e$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a9f996f354cff77e$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$a9f996f354cff77e$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $a9f996f354cff77e$var$ne(a, b, c, d) {
    $a9f996f354cff77e$var$Eb(d);
    b = $a9f996f354cff77e$var$oe(b, "onChange");
    0 < b.length && (c = new $a9f996f354cff77e$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $a9f996f354cff77e$var$pe = null, $a9f996f354cff77e$var$qe = null;
function $a9f996f354cff77e$var$re(a) {
    $a9f996f354cff77e$var$se(a, 0);
}
function $a9f996f354cff77e$var$te(a) {
    var b = $a9f996f354cff77e$var$ue(a);
    if ($a9f996f354cff77e$var$Wa(b)) return a;
}
function $a9f996f354cff77e$var$ve(a, b) {
    if ("change" === a) return b;
}
var $a9f996f354cff77e$var$we = !1;
if ($a9f996f354cff77e$var$ia) {
    var $a9f996f354cff77e$var$xe;
    if ($a9f996f354cff77e$var$ia) {
        var $a9f996f354cff77e$var$ye = "oninput" in document;
        if (!$a9f996f354cff77e$var$ye) {
            var $a9f996f354cff77e$var$ze = document.createElement("div");
            $a9f996f354cff77e$var$ze.setAttribute("oninput", "return;");
            $a9f996f354cff77e$var$ye = "function" === typeof $a9f996f354cff77e$var$ze.oninput;
        }
        $a9f996f354cff77e$var$xe = $a9f996f354cff77e$var$ye;
    } else $a9f996f354cff77e$var$xe = !1;
    $a9f996f354cff77e$var$we = $a9f996f354cff77e$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $a9f996f354cff77e$var$Ae() {
    $a9f996f354cff77e$var$pe && ($a9f996f354cff77e$var$pe.detachEvent("onpropertychange", $a9f996f354cff77e$var$Be), $a9f996f354cff77e$var$qe = $a9f996f354cff77e$var$pe = null);
}
function $a9f996f354cff77e$var$Be(a) {
    if ("value" === a.propertyName && $a9f996f354cff77e$var$te($a9f996f354cff77e$var$qe)) {
        var b = [];
        $a9f996f354cff77e$var$ne(b, $a9f996f354cff77e$var$qe, a, $a9f996f354cff77e$var$xb(a));
        $a9f996f354cff77e$var$Jb($a9f996f354cff77e$var$re, b);
    }
}
function $a9f996f354cff77e$var$Ce(a, b, c) {
    "focusin" === a ? ($a9f996f354cff77e$var$Ae(), $a9f996f354cff77e$var$pe = b, $a9f996f354cff77e$var$qe = c, $a9f996f354cff77e$var$pe.attachEvent("onpropertychange", $a9f996f354cff77e$var$Be)) : "focusout" === a && $a9f996f354cff77e$var$Ae();
}
function $a9f996f354cff77e$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $a9f996f354cff77e$var$te($a9f996f354cff77e$var$qe);
}
function $a9f996f354cff77e$var$Ee(a, b) {
    if ("click" === a) return $a9f996f354cff77e$var$te(b);
}
function $a9f996f354cff77e$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $a9f996f354cff77e$var$te(b);
}
function $a9f996f354cff77e$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a9f996f354cff77e$var$He = "function" === typeof Object.is ? Object.is : $a9f996f354cff77e$var$Ge;
function $a9f996f354cff77e$var$Ie(a, b) {
    if ($a9f996f354cff77e$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$a9f996f354cff77e$var$ja.call(b, e) || !$a9f996f354cff77e$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $a9f996f354cff77e$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $a9f996f354cff77e$var$Ke(a, b) {
    var c = $a9f996f354cff77e$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $a9f996f354cff77e$var$Je(c);
    }
}
function $a9f996f354cff77e$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $a9f996f354cff77e$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $a9f996f354cff77e$var$Me() {
    for(var a = window, b = $a9f996f354cff77e$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $a9f996f354cff77e$var$Xa(a.document);
    }
    return b;
}
function $a9f996f354cff77e$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $a9f996f354cff77e$var$Oe(a) {
    var b = $a9f996f354cff77e$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $a9f996f354cff77e$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $a9f996f354cff77e$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $a9f996f354cff77e$var$Ke(c, f);
                var g = $a9f996f354cff77e$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $a9f996f354cff77e$var$Pe = $a9f996f354cff77e$var$ia && "documentMode" in document && 11 >= document.documentMode, $a9f996f354cff77e$var$Qe = null, $a9f996f354cff77e$var$Re = null, $a9f996f354cff77e$var$Se = null, $a9f996f354cff77e$var$Te = !1;
function $a9f996f354cff77e$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $a9f996f354cff77e$var$Te || null == $a9f996f354cff77e$var$Qe || $a9f996f354cff77e$var$Qe !== $a9f996f354cff77e$var$Xa(d) || (d = $a9f996f354cff77e$var$Qe, "selectionStart" in d && $a9f996f354cff77e$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $a9f996f354cff77e$var$Se && $a9f996f354cff77e$var$Ie($a9f996f354cff77e$var$Se, d) || ($a9f996f354cff77e$var$Se = d, d = $a9f996f354cff77e$var$oe($a9f996f354cff77e$var$Re, "onSelect"), 0 < d.length && (b = new $a9f996f354cff77e$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $a9f996f354cff77e$var$Qe)));
}
function $a9f996f354cff77e$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $a9f996f354cff77e$var$We = {
    animationend: $a9f996f354cff77e$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $a9f996f354cff77e$var$Ve("Animation", "AnimationIteration"),
    animationstart: $a9f996f354cff77e$var$Ve("Animation", "AnimationStart"),
    transitionend: $a9f996f354cff77e$var$Ve("Transition", "TransitionEnd")
}, $a9f996f354cff77e$var$Xe = {}, $a9f996f354cff77e$var$Ye = {};
$a9f996f354cff77e$var$ia && ($a9f996f354cff77e$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $a9f996f354cff77e$var$We.animationend.animation, delete $a9f996f354cff77e$var$We.animationiteration.animation, delete $a9f996f354cff77e$var$We.animationstart.animation), "TransitionEvent" in window || delete $a9f996f354cff77e$var$We.transitionend.transition);
function $a9f996f354cff77e$var$Ze(a) {
    if ($a9f996f354cff77e$var$Xe[a]) return $a9f996f354cff77e$var$Xe[a];
    if (!$a9f996f354cff77e$var$We[a]) return a;
    var b = $a9f996f354cff77e$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $a9f996f354cff77e$var$Ye) return $a9f996f354cff77e$var$Xe[a] = b[c];
    return a;
}
var $a9f996f354cff77e$var$$e = $a9f996f354cff77e$var$Ze("animationend"), $a9f996f354cff77e$var$af = $a9f996f354cff77e$var$Ze("animationiteration"), $a9f996f354cff77e$var$bf = $a9f996f354cff77e$var$Ze("animationstart"), $a9f996f354cff77e$var$cf = $a9f996f354cff77e$var$Ze("transitionend"), $a9f996f354cff77e$var$df = new Map, $a9f996f354cff77e$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $a9f996f354cff77e$var$ff(a, b) {
    $a9f996f354cff77e$var$df.set(a, b);
    $a9f996f354cff77e$var$fa(b, [
        a
    ]);
}
for(var $a9f996f354cff77e$var$gf = 0; $a9f996f354cff77e$var$gf < $a9f996f354cff77e$var$ef.length; $a9f996f354cff77e$var$gf++){
    var $a9f996f354cff77e$var$hf = $a9f996f354cff77e$var$ef[$a9f996f354cff77e$var$gf], $a9f996f354cff77e$var$jf = $a9f996f354cff77e$var$hf.toLowerCase(), $a9f996f354cff77e$var$kf = $a9f996f354cff77e$var$hf[0].toUpperCase() + $a9f996f354cff77e$var$hf.slice(1);
    $a9f996f354cff77e$var$ff($a9f996f354cff77e$var$jf, "on" + $a9f996f354cff77e$var$kf);
}
$a9f996f354cff77e$var$ff($a9f996f354cff77e$var$$e, "onAnimationEnd");
$a9f996f354cff77e$var$ff($a9f996f354cff77e$var$af, "onAnimationIteration");
$a9f996f354cff77e$var$ff($a9f996f354cff77e$var$bf, "onAnimationStart");
$a9f996f354cff77e$var$ff("dblclick", "onDoubleClick");
$a9f996f354cff77e$var$ff("focusin", "onFocus");
$a9f996f354cff77e$var$ff("focusout", "onBlur");
$a9f996f354cff77e$var$ff($a9f996f354cff77e$var$cf, "onTransitionEnd");
$a9f996f354cff77e$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a9f996f354cff77e$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a9f996f354cff77e$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a9f996f354cff77e$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a9f996f354cff77e$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a9f996f354cff77e$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a9f996f354cff77e$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a9f996f354cff77e$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a9f996f354cff77e$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a9f996f354cff77e$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a9f996f354cff77e$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a9f996f354cff77e$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($a9f996f354cff77e$var$lf));
function $a9f996f354cff77e$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $a9f996f354cff77e$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $a9f996f354cff77e$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a9f996f354cff77e$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a9f996f354cff77e$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($a9f996f354cff77e$var$Qb) throw a = $a9f996f354cff77e$var$Rb, $a9f996f354cff77e$var$Qb = !1, $a9f996f354cff77e$var$Rb = null, a;
}
function $a9f996f354cff77e$var$D(a, b) {
    var c = b[$a9f996f354cff77e$var$of];
    void 0 === c && (c = b[$a9f996f354cff77e$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($a9f996f354cff77e$var$pf(b, a, 2, !1), c.add(d));
}
function $a9f996f354cff77e$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $a9f996f354cff77e$var$pf(c, a, d, b);
}
var $a9f996f354cff77e$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $a9f996f354cff77e$var$sf(a) {
    if (!a[$a9f996f354cff77e$var$rf]) {
        a[$a9f996f354cff77e$var$rf] = !0;
        $a9f996f354cff77e$var$da.forEach(function(b) {
            "selectionchange" !== b && ($a9f996f354cff77e$var$mf.has(b) || $a9f996f354cff77e$var$qf(b, !1, a), $a9f996f354cff77e$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$a9f996f354cff77e$var$rf] || (b[$a9f996f354cff77e$var$rf] = !0, $a9f996f354cff77e$var$qf("selectionchange", !1, b));
    }
}
function $a9f996f354cff77e$var$pf(a, b, c, d) {
    switch($a9f996f354cff77e$var$jd(b)){
        case 1:
            var e = $a9f996f354cff77e$var$ed;
            break;
        case 4:
            e = $a9f996f354cff77e$var$gd;
            break;
        default:
            e = $a9f996f354cff77e$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$a9f996f354cff77e$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $a9f996f354cff77e$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $a9f996f354cff77e$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $a9f996f354cff77e$var$Jb(function() {
        var d = f, e = $a9f996f354cff77e$var$xb(c), g = [];
        a: {
            var h = $a9f996f354cff77e$var$df.get(a);
            if (void 0 !== h) {
                var k = $a9f996f354cff77e$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $a9f996f354cff77e$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $a9f996f354cff77e$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $a9f996f354cff77e$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $a9f996f354cff77e$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $a9f996f354cff77e$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $a9f996f354cff77e$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $a9f996f354cff77e$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $a9f996f354cff77e$var$Vd;
                        break;
                    case $a9f996f354cff77e$var$$e:
                    case $a9f996f354cff77e$var$af:
                    case $a9f996f354cff77e$var$bf:
                        k = $a9f996f354cff77e$var$Hd;
                        break;
                    case $a9f996f354cff77e$var$cf:
                        k = $a9f996f354cff77e$var$Xd;
                        break;
                    case "scroll":
                        k = $a9f996f354cff77e$var$vd;
                        break;
                    case "wheel":
                        k = $a9f996f354cff77e$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $a9f996f354cff77e$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $a9f996f354cff77e$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $a9f996f354cff77e$var$Kb(w, x), null != F && t.push($a9f996f354cff77e$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $a9f996f354cff77e$var$wb && (n = c.relatedTarget || c.fromElement) && ($a9f996f354cff77e$var$Wc(n) || n[$a9f996f354cff77e$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $a9f996f354cff77e$var$Wc(n) : null, null !== n && (J = $a9f996f354cff77e$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $a9f996f354cff77e$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $a9f996f354cff77e$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $a9f996f354cff77e$var$ue(k);
                        u = null == n ? h : $a9f996f354cff77e$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $a9f996f354cff77e$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $a9f996f354cff77e$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $a9f996f354cff77e$var$vf(F))u++;
                            for(; 0 < w - u;)t = $a9f996f354cff77e$var$vf(t), w--;
                            for(; 0 < u - w;)x = $a9f996f354cff77e$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $a9f996f354cff77e$var$vf(t);
                                x = $a9f996f354cff77e$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $a9f996f354cff77e$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $a9f996f354cff77e$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $a9f996f354cff77e$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $a9f996f354cff77e$var$ve;
                else if ($a9f996f354cff77e$var$me(h)) {
                    if ($a9f996f354cff77e$var$we) na = $a9f996f354cff77e$var$Fe;
                    else {
                        na = $a9f996f354cff77e$var$De;
                        var xa = $a9f996f354cff77e$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $a9f996f354cff77e$var$Ee);
                if (na && (na = na(a, d))) {
                    $a9f996f354cff77e$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $a9f996f354cff77e$var$cb(h, "number", h.value);
            }
            xa = d ? $a9f996f354cff77e$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($a9f996f354cff77e$var$me(xa) || "true" === xa.contentEditable) $a9f996f354cff77e$var$Qe = xa, $a9f996f354cff77e$var$Re = d, $a9f996f354cff77e$var$Se = null;
                    break;
                case "focusout":
                    $a9f996f354cff77e$var$Se = $a9f996f354cff77e$var$Re = $a9f996f354cff77e$var$Qe = null;
                    break;
                case "mousedown":
                    $a9f996f354cff77e$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a9f996f354cff77e$var$Te = !1;
                    $a9f996f354cff77e$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($a9f996f354cff77e$var$Pe) break;
                case "keydown":
                case "keyup":
                    $a9f996f354cff77e$var$Ue(g, c, e);
            }
            var $a;
            if ($a9f996f354cff77e$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $a9f996f354cff77e$var$ie ? $a9f996f354cff77e$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($a9f996f354cff77e$var$de && "ko" !== c.locale && ($a9f996f354cff77e$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $a9f996f354cff77e$var$ie && ($a = $a9f996f354cff77e$var$nd()) : ($a9f996f354cff77e$var$kd = e, $a9f996f354cff77e$var$ld = "value" in $a9f996f354cff77e$var$kd ? $a9f996f354cff77e$var$kd.value : $a9f996f354cff77e$var$kd.textContent, $a9f996f354cff77e$var$ie = !0)), xa = $a9f996f354cff77e$var$oe(d, ba), 0 < xa.length && (ba = new $a9f996f354cff77e$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $a9f996f354cff77e$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $a9f996f354cff77e$var$ce ? $a9f996f354cff77e$var$je(a, c) : $a9f996f354cff77e$var$ke(a, c)) d = $a9f996f354cff77e$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $a9f996f354cff77e$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $a9f996f354cff77e$var$se(g, b);
    });
}
function $a9f996f354cff77e$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $a9f996f354cff77e$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $a9f996f354cff77e$var$Kb(a, c), null != f && d.unshift($a9f996f354cff77e$var$tf(a, f, e)), f = $a9f996f354cff77e$var$Kb(a, b), null != f && d.push($a9f996f354cff77e$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $a9f996f354cff77e$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $a9f996f354cff77e$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $a9f996f354cff77e$var$Kb(c, f), null != k && g.unshift($a9f996f354cff77e$var$tf(c, k, h))) : e || (k = $a9f996f354cff77e$var$Kb(c, f), null != k && g.push($a9f996f354cff77e$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $a9f996f354cff77e$var$xf = /\r\n?/g, $a9f996f354cff77e$var$yf = /\u0000|\uFFFD/g;
function $a9f996f354cff77e$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($a9f996f354cff77e$var$xf, "\n").replace($a9f996f354cff77e$var$yf, "");
}
function $a9f996f354cff77e$var$Af(a, b, c) {
    b = $a9f996f354cff77e$var$zf(b);
    if ($a9f996f354cff77e$var$zf(a) !== b && c) throw Error($a9f996f354cff77e$var$p(425));
}
function $a9f996f354cff77e$var$Bf() {}
var $a9f996f354cff77e$var$Cf = null, $a9f996f354cff77e$var$Df = null;
function $a9f996f354cff77e$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $a9f996f354cff77e$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $a9f996f354cff77e$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $a9f996f354cff77e$var$Hf = "function" === typeof Promise ? Promise : void 0, $a9f996f354cff77e$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $a9f996f354cff77e$var$Hf ? function(a) {
    return $a9f996f354cff77e$var$Hf.resolve(null).then(a).catch($a9f996f354cff77e$var$If);
} : $a9f996f354cff77e$var$Ff;
function $a9f996f354cff77e$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $a9f996f354cff77e$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $a9f996f354cff77e$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $a9f996f354cff77e$var$bd(b);
}
function $a9f996f354cff77e$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $a9f996f354cff77e$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $a9f996f354cff77e$var$Nf = Math.random().toString(36).slice(2), $a9f996f354cff77e$var$Of = "__reactFiber$" + $a9f996f354cff77e$var$Nf, $a9f996f354cff77e$var$Pf = "__reactProps$" + $a9f996f354cff77e$var$Nf, $a9f996f354cff77e$var$uf = "__reactContainer$" + $a9f996f354cff77e$var$Nf, $a9f996f354cff77e$var$of = "__reactEvents$" + $a9f996f354cff77e$var$Nf, $a9f996f354cff77e$var$Qf = "__reactListeners$" + $a9f996f354cff77e$var$Nf, $a9f996f354cff77e$var$Rf = "__reactHandles$" + $a9f996f354cff77e$var$Nf;
function $a9f996f354cff77e$var$Wc(a) {
    var b = a[$a9f996f354cff77e$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$a9f996f354cff77e$var$uf] || c[$a9f996f354cff77e$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $a9f996f354cff77e$var$Mf(a); null !== a;){
                if (c = a[$a9f996f354cff77e$var$Of]) return c;
                a = $a9f996f354cff77e$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $a9f996f354cff77e$var$Cb(a) {
    a = a[$a9f996f354cff77e$var$Of] || a[$a9f996f354cff77e$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $a9f996f354cff77e$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($a9f996f354cff77e$var$p(33));
}
function $a9f996f354cff77e$var$Db(a) {
    return a[$a9f996f354cff77e$var$Pf] || null;
}
var $a9f996f354cff77e$var$Sf = [], $a9f996f354cff77e$var$Tf = -1;
function $a9f996f354cff77e$var$Uf(a) {
    return {
        current: a
    };
}
function $a9f996f354cff77e$var$E(a) {
    0 > $a9f996f354cff77e$var$Tf || (a.current = $a9f996f354cff77e$var$Sf[$a9f996f354cff77e$var$Tf], $a9f996f354cff77e$var$Sf[$a9f996f354cff77e$var$Tf] = null, $a9f996f354cff77e$var$Tf--);
}
function $a9f996f354cff77e$var$G(a, b) {
    $a9f996f354cff77e$var$Tf++;
    $a9f996f354cff77e$var$Sf[$a9f996f354cff77e$var$Tf] = a.current;
    a.current = b;
}
var $a9f996f354cff77e$var$Vf = {}, $a9f996f354cff77e$var$H = $a9f996f354cff77e$var$Uf($a9f996f354cff77e$var$Vf), $a9f996f354cff77e$var$Wf = $a9f996f354cff77e$var$Uf(!1), $a9f996f354cff77e$var$Xf = $a9f996f354cff77e$var$Vf;
function $a9f996f354cff77e$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $a9f996f354cff77e$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $a9f996f354cff77e$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $a9f996f354cff77e$var$$f() {
    $a9f996f354cff77e$var$E($a9f996f354cff77e$var$Wf);
    $a9f996f354cff77e$var$E($a9f996f354cff77e$var$H);
}
function $a9f996f354cff77e$var$ag(a, b, c) {
    if ($a9f996f354cff77e$var$H.current !== $a9f996f354cff77e$var$Vf) throw Error($a9f996f354cff77e$var$p(168));
    $a9f996f354cff77e$var$G($a9f996f354cff77e$var$H, b);
    $a9f996f354cff77e$var$G($a9f996f354cff77e$var$Wf, c);
}
function $a9f996f354cff77e$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($a9f996f354cff77e$var$p(108, $a9f996f354cff77e$var$Ra(a) || "Unknown", e));
    return $a9f996f354cff77e$var$A({}, c, d);
}
function $a9f996f354cff77e$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $a9f996f354cff77e$var$Vf;
    $a9f996f354cff77e$var$Xf = $a9f996f354cff77e$var$H.current;
    $a9f996f354cff77e$var$G($a9f996f354cff77e$var$H, a);
    $a9f996f354cff77e$var$G($a9f996f354cff77e$var$Wf, $a9f996f354cff77e$var$Wf.current);
    return !0;
}
function $a9f996f354cff77e$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($a9f996f354cff77e$var$p(169));
    c ? (a = $a9f996f354cff77e$var$bg(a, b, $a9f996f354cff77e$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $a9f996f354cff77e$var$E($a9f996f354cff77e$var$Wf), $a9f996f354cff77e$var$E($a9f996f354cff77e$var$H), $a9f996f354cff77e$var$G($a9f996f354cff77e$var$H, a)) : $a9f996f354cff77e$var$E($a9f996f354cff77e$var$Wf);
    $a9f996f354cff77e$var$G($a9f996f354cff77e$var$Wf, c);
}
var $a9f996f354cff77e$var$eg = null, $a9f996f354cff77e$var$fg = !1, $a9f996f354cff77e$var$gg = !1;
function $a9f996f354cff77e$var$hg(a) {
    null === $a9f996f354cff77e$var$eg ? $a9f996f354cff77e$var$eg = [
        a
    ] : $a9f996f354cff77e$var$eg.push(a);
}
function $a9f996f354cff77e$var$ig(a) {
    $a9f996f354cff77e$var$fg = !0;
    $a9f996f354cff77e$var$hg(a);
}
function $a9f996f354cff77e$var$jg() {
    if (!$a9f996f354cff77e$var$gg && null !== $a9f996f354cff77e$var$eg) {
        $a9f996f354cff77e$var$gg = !0;
        var a = 0, b = $a9f996f354cff77e$var$C;
        try {
            var c = $a9f996f354cff77e$var$eg;
            for($a9f996f354cff77e$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $a9f996f354cff77e$var$eg = null;
            $a9f996f354cff77e$var$fg = !1;
        } catch (e) {
            throw null !== $a9f996f354cff77e$var$eg && ($a9f996f354cff77e$var$eg = $a9f996f354cff77e$var$eg.slice(a + 1)), $a9f996f354cff77e$var$ac($a9f996f354cff77e$var$fc, $a9f996f354cff77e$var$jg), e;
        } finally{
            $a9f996f354cff77e$var$C = b, $a9f996f354cff77e$var$gg = !1;
        }
    }
    return null;
}
var $a9f996f354cff77e$var$kg = [], $a9f996f354cff77e$var$lg = 0, $a9f996f354cff77e$var$mg = null, $a9f996f354cff77e$var$ng = 0, $a9f996f354cff77e$var$og = [], $a9f996f354cff77e$var$pg = 0, $a9f996f354cff77e$var$qg = null, $a9f996f354cff77e$var$rg = 1, $a9f996f354cff77e$var$sg = "";
function $a9f996f354cff77e$var$tg(a, b) {
    $a9f996f354cff77e$var$kg[$a9f996f354cff77e$var$lg++] = $a9f996f354cff77e$var$ng;
    $a9f996f354cff77e$var$kg[$a9f996f354cff77e$var$lg++] = $a9f996f354cff77e$var$mg;
    $a9f996f354cff77e$var$mg = a;
    $a9f996f354cff77e$var$ng = b;
}
function $a9f996f354cff77e$var$ug(a, b, c) {
    $a9f996f354cff77e$var$og[$a9f996f354cff77e$var$pg++] = $a9f996f354cff77e$var$rg;
    $a9f996f354cff77e$var$og[$a9f996f354cff77e$var$pg++] = $a9f996f354cff77e$var$sg;
    $a9f996f354cff77e$var$og[$a9f996f354cff77e$var$pg++] = $a9f996f354cff77e$var$qg;
    $a9f996f354cff77e$var$qg = a;
    var d = $a9f996f354cff77e$var$rg;
    a = $a9f996f354cff77e$var$sg;
    var e = 32 - $a9f996f354cff77e$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $a9f996f354cff77e$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $a9f996f354cff77e$var$rg = 1 << 32 - $a9f996f354cff77e$var$oc(b) + e | c << e | d;
        $a9f996f354cff77e$var$sg = f + a;
    } else $a9f996f354cff77e$var$rg = 1 << f | c << e | d, $a9f996f354cff77e$var$sg = a;
}
function $a9f996f354cff77e$var$vg(a) {
    null !== a.return && ($a9f996f354cff77e$var$tg(a, 1), $a9f996f354cff77e$var$ug(a, 1, 0));
}
function $a9f996f354cff77e$var$wg(a) {
    for(; a === $a9f996f354cff77e$var$mg;)$a9f996f354cff77e$var$mg = $a9f996f354cff77e$var$kg[--$a9f996f354cff77e$var$lg], $a9f996f354cff77e$var$kg[$a9f996f354cff77e$var$lg] = null, $a9f996f354cff77e$var$ng = $a9f996f354cff77e$var$kg[--$a9f996f354cff77e$var$lg], $a9f996f354cff77e$var$kg[$a9f996f354cff77e$var$lg] = null;
    for(; a === $a9f996f354cff77e$var$qg;)$a9f996f354cff77e$var$qg = $a9f996f354cff77e$var$og[--$a9f996f354cff77e$var$pg], $a9f996f354cff77e$var$og[$a9f996f354cff77e$var$pg] = null, $a9f996f354cff77e$var$sg = $a9f996f354cff77e$var$og[--$a9f996f354cff77e$var$pg], $a9f996f354cff77e$var$og[$a9f996f354cff77e$var$pg] = null, $a9f996f354cff77e$var$rg = $a9f996f354cff77e$var$og[--$a9f996f354cff77e$var$pg], $a9f996f354cff77e$var$og[$a9f996f354cff77e$var$pg] = null;
}
var $a9f996f354cff77e$var$xg = null, $a9f996f354cff77e$var$yg = null, $a9f996f354cff77e$var$I = !1, $a9f996f354cff77e$var$zg = null;
function $a9f996f354cff77e$var$Ag(a, b) {
    var c = $a9f996f354cff77e$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $a9f996f354cff77e$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $a9f996f354cff77e$var$xg = a, $a9f996f354cff77e$var$yg = $a9f996f354cff77e$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $a9f996f354cff77e$var$xg = a, $a9f996f354cff77e$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $a9f996f354cff77e$var$qg ? {
                id: $a9f996f354cff77e$var$rg,
                overflow: $a9f996f354cff77e$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $a9f996f354cff77e$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $a9f996f354cff77e$var$xg = a, $a9f996f354cff77e$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $a9f996f354cff77e$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $a9f996f354cff77e$var$Eg(a) {
    if ($a9f996f354cff77e$var$I) {
        var b = $a9f996f354cff77e$var$yg;
        if (b) {
            var c = b;
            if (!$a9f996f354cff77e$var$Cg(a, b)) {
                if ($a9f996f354cff77e$var$Dg(a)) throw Error($a9f996f354cff77e$var$p(418));
                b = $a9f996f354cff77e$var$Lf(c.nextSibling);
                var d = $a9f996f354cff77e$var$xg;
                b && $a9f996f354cff77e$var$Cg(a, b) ? $a9f996f354cff77e$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $a9f996f354cff77e$var$I = !1, $a9f996f354cff77e$var$xg = a);
            }
        } else {
            if ($a9f996f354cff77e$var$Dg(a)) throw Error($a9f996f354cff77e$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $a9f996f354cff77e$var$I = !1;
            $a9f996f354cff77e$var$xg = a;
        }
    }
}
function $a9f996f354cff77e$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $a9f996f354cff77e$var$xg = a;
}
function $a9f996f354cff77e$var$Gg(a) {
    if (a !== $a9f996f354cff77e$var$xg) return !1;
    if (!$a9f996f354cff77e$var$I) return $a9f996f354cff77e$var$Fg(a), $a9f996f354cff77e$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$a9f996f354cff77e$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $a9f996f354cff77e$var$yg)) {
        if ($a9f996f354cff77e$var$Dg(a)) throw $a9f996f354cff77e$var$Hg(), Error($a9f996f354cff77e$var$p(418));
        for(; b;)$a9f996f354cff77e$var$Ag(a, b), b = $a9f996f354cff77e$var$Lf(b.nextSibling);
    }
    $a9f996f354cff77e$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($a9f996f354cff77e$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $a9f996f354cff77e$var$yg = $a9f996f354cff77e$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $a9f996f354cff77e$var$yg = null;
        }
    } else $a9f996f354cff77e$var$yg = $a9f996f354cff77e$var$xg ? $a9f996f354cff77e$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $a9f996f354cff77e$var$Hg() {
    for(var a = $a9f996f354cff77e$var$yg; a;)a = $a9f996f354cff77e$var$Lf(a.nextSibling);
}
function $a9f996f354cff77e$var$Ig() {
    $a9f996f354cff77e$var$yg = $a9f996f354cff77e$var$xg = null;
    $a9f996f354cff77e$var$I = !1;
}
function $a9f996f354cff77e$var$Jg(a) {
    null === $a9f996f354cff77e$var$zg ? $a9f996f354cff77e$var$zg = [
        a
    ] : $a9f996f354cff77e$var$zg.push(a);
}
var $a9f996f354cff77e$var$Kg = $a9f996f354cff77e$var$ua.ReactCurrentBatchConfig;
function $a9f996f354cff77e$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $a9f996f354cff77e$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $a9f996f354cff77e$var$Mg = $a9f996f354cff77e$var$Uf(null), $a9f996f354cff77e$var$Ng = null, $a9f996f354cff77e$var$Og = null, $a9f996f354cff77e$var$Pg = null;
function $a9f996f354cff77e$var$Qg() {
    $a9f996f354cff77e$var$Pg = $a9f996f354cff77e$var$Og = $a9f996f354cff77e$var$Ng = null;
}
function $a9f996f354cff77e$var$Rg(a) {
    var b = $a9f996f354cff77e$var$Mg.current;
    $a9f996f354cff77e$var$E($a9f996f354cff77e$var$Mg);
    a._currentValue = b;
}
function $a9f996f354cff77e$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $a9f996f354cff77e$var$Tg(a, b) {
    $a9f996f354cff77e$var$Ng = a;
    $a9f996f354cff77e$var$Pg = $a9f996f354cff77e$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($a9f996f354cff77e$var$Ug = !0), a.firstContext = null);
}
function $a9f996f354cff77e$var$Vg(a) {
    var b = a._currentValue;
    if ($a9f996f354cff77e$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $a9f996f354cff77e$var$Og) {
            if (null === $a9f996f354cff77e$var$Ng) throw Error($a9f996f354cff77e$var$p(308));
            $a9f996f354cff77e$var$Og = a;
            $a9f996f354cff77e$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $a9f996f354cff77e$var$Og = $a9f996f354cff77e$var$Og.next = a;
    }
    return b;
}
var $a9f996f354cff77e$var$Wg = null;
function $a9f996f354cff77e$var$Xg(a) {
    null === $a9f996f354cff77e$var$Wg ? $a9f996f354cff77e$var$Wg = [
        a
    ] : $a9f996f354cff77e$var$Wg.push(a);
}
function $a9f996f354cff77e$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $a9f996f354cff77e$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $a9f996f354cff77e$var$Zg(a, d);
}
function $a9f996f354cff77e$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $a9f996f354cff77e$var$$g = !1;
function $a9f996f354cff77e$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $a9f996f354cff77e$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $a9f996f354cff77e$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a9f996f354cff77e$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($a9f996f354cff77e$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $a9f996f354cff77e$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $a9f996f354cff77e$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $a9f996f354cff77e$var$Zg(a, c);
}
function $a9f996f354cff77e$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a9f996f354cff77e$var$Cc(a, c);
    }
}
function $a9f996f354cff77e$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $a9f996f354cff77e$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $a9f996f354cff77e$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $a9f996f354cff77e$var$A({}, q, r);
                            break a;
                        case 2:
                            $a9f996f354cff77e$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $a9f996f354cff77e$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $a9f996f354cff77e$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($a9f996f354cff77e$var$p(191, e));
            e.call(d);
        }
    }
}
var $a9f996f354cff77e$var$jh = (new $hEVyQ.Component).refs;
function $a9f996f354cff77e$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $a9f996f354cff77e$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $a9f996f354cff77e$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $a9f996f354cff77e$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a9f996f354cff77e$var$L(), e = $a9f996f354cff77e$var$lh(a), f = $a9f996f354cff77e$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a9f996f354cff77e$var$dh(a, f, e);
        null !== b && ($a9f996f354cff77e$var$mh(b, a, e, d), $a9f996f354cff77e$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a9f996f354cff77e$var$L(), e = $a9f996f354cff77e$var$lh(a), f = $a9f996f354cff77e$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a9f996f354cff77e$var$dh(a, f, e);
        null !== b && ($a9f996f354cff77e$var$mh(b, a, e, d), $a9f996f354cff77e$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $a9f996f354cff77e$var$L(), d = $a9f996f354cff77e$var$lh(a), e = $a9f996f354cff77e$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $a9f996f354cff77e$var$dh(a, e, d);
        null !== b && ($a9f996f354cff77e$var$mh(b, a, d, c), $a9f996f354cff77e$var$eh(b, a, d));
    }
};
function $a9f996f354cff77e$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$a9f996f354cff77e$var$Ie(c, d) || !$a9f996f354cff77e$var$Ie(e, f) : !0;
}
function $a9f996f354cff77e$var$ph(a, b, c) {
    var d = !1, e = $a9f996f354cff77e$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $a9f996f354cff77e$var$Vg(f) : (e = $a9f996f354cff77e$var$Zf(b) ? $a9f996f354cff77e$var$Xf : $a9f996f354cff77e$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $a9f996f354cff77e$var$Yf(a, e) : $a9f996f354cff77e$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $a9f996f354cff77e$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $a9f996f354cff77e$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $a9f996f354cff77e$var$nh.enqueueReplaceState(b, b.state, null);
}
function $a9f996f354cff77e$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $a9f996f354cff77e$var$jh;
    $a9f996f354cff77e$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $a9f996f354cff77e$var$Vg(f) : (f = $a9f996f354cff77e$var$Zf(b) ? $a9f996f354cff77e$var$Xf : $a9f996f354cff77e$var$H.current, e.context = $a9f996f354cff77e$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($a9f996f354cff77e$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $a9f996f354cff77e$var$nh.enqueueReplaceState(e, e.state, null), $a9f996f354cff77e$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $a9f996f354cff77e$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($a9f996f354cff77e$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($a9f996f354cff77e$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $a9f996f354cff77e$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($a9f996f354cff77e$var$p(284));
        if (!c._owner) throw Error($a9f996f354cff77e$var$p(290, a));
    }
    return a;
}
function $a9f996f354cff77e$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($a9f996f354cff77e$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $a9f996f354cff77e$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $a9f996f354cff77e$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $a9f996f354cff77e$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $a9f996f354cff77e$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $a9f996f354cff77e$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $a9f996f354cff77e$var$Ha && $a9f996f354cff77e$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $a9f996f354cff77e$var$sh(a, b, c), d.return = a, d;
        d = $a9f996f354cff77e$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $a9f996f354cff77e$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $a9f996f354cff77e$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $a9f996f354cff77e$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $a9f996f354cff77e$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $a9f996f354cff77e$var$va:
                    return c = $a9f996f354cff77e$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $a9f996f354cff77e$var$sh(a, null, b), c.return = a, c;
                case $a9f996f354cff77e$var$wa:
                    return b = $a9f996f354cff77e$var$zh(b, a.mode, c), b.return = a, b;
                case $a9f996f354cff77e$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($a9f996f354cff77e$var$eb(b) || $a9f996f354cff77e$var$Ka(b)) return b = $a9f996f354cff77e$var$Ah(b, a.mode, c, null), b.return = a, b;
            $a9f996f354cff77e$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $a9f996f354cff77e$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $a9f996f354cff77e$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $a9f996f354cff77e$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($a9f996f354cff77e$var$eb(c) || $a9f996f354cff77e$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $a9f996f354cff77e$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $a9f996f354cff77e$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $a9f996f354cff77e$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $a9f996f354cff77e$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($a9f996f354cff77e$var$eb(d) || $a9f996f354cff77e$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $a9f996f354cff77e$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $a9f996f354cff77e$var$I && $a9f996f354cff77e$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $a9f996f354cff77e$var$I && $a9f996f354cff77e$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $a9f996f354cff77e$var$I && $a9f996f354cff77e$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $a9f996f354cff77e$var$Ka(h);
        if ("function" !== typeof l) throw Error($a9f996f354cff77e$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($a9f996f354cff77e$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $a9f996f354cff77e$var$I && $a9f996f354cff77e$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $a9f996f354cff77e$var$I && $a9f996f354cff77e$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $a9f996f354cff77e$var$I && $a9f996f354cff77e$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $a9f996f354cff77e$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $a9f996f354cff77e$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $a9f996f354cff77e$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $a9f996f354cff77e$var$Ha && $a9f996f354cff77e$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $a9f996f354cff77e$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $a9f996f354cff77e$var$ya ? (d = $a9f996f354cff77e$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $a9f996f354cff77e$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $a9f996f354cff77e$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $a9f996f354cff77e$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $a9f996f354cff77e$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $a9f996f354cff77e$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($a9f996f354cff77e$var$eb(f)) return n(a, d, f, h);
            if ($a9f996f354cff77e$var$Ka(f)) return t(a, d, f, h);
            $a9f996f354cff77e$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $a9f996f354cff77e$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $a9f996f354cff77e$var$Bh = $a9f996f354cff77e$var$vh(!0), $a9f996f354cff77e$var$Ch = $a9f996f354cff77e$var$vh(!1), $a9f996f354cff77e$var$Dh = {}, $a9f996f354cff77e$var$Eh = $a9f996f354cff77e$var$Uf($a9f996f354cff77e$var$Dh), $a9f996f354cff77e$var$Fh = $a9f996f354cff77e$var$Uf($a9f996f354cff77e$var$Dh), $a9f996f354cff77e$var$Gh = $a9f996f354cff77e$var$Uf($a9f996f354cff77e$var$Dh);
function $a9f996f354cff77e$var$Hh(a) {
    if (a === $a9f996f354cff77e$var$Dh) throw Error($a9f996f354cff77e$var$p(174));
    return a;
}
function $a9f996f354cff77e$var$Ih(a, b) {
    $a9f996f354cff77e$var$G($a9f996f354cff77e$var$Gh, b);
    $a9f996f354cff77e$var$G($a9f996f354cff77e$var$Fh, a);
    $a9f996f354cff77e$var$G($a9f996f354cff77e$var$Eh, $a9f996f354cff77e$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $a9f996f354cff77e$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $a9f996f354cff77e$var$lb(b, a);
    }
    $a9f996f354cff77e$var$E($a9f996f354cff77e$var$Eh);
    $a9f996f354cff77e$var$G($a9f996f354cff77e$var$Eh, b);
}
function $a9f996f354cff77e$var$Jh() {
    $a9f996f354cff77e$var$E($a9f996f354cff77e$var$Eh);
    $a9f996f354cff77e$var$E($a9f996f354cff77e$var$Fh);
    $a9f996f354cff77e$var$E($a9f996f354cff77e$var$Gh);
}
function $a9f996f354cff77e$var$Kh(a) {
    $a9f996f354cff77e$var$Hh($a9f996f354cff77e$var$Gh.current);
    var b = $a9f996f354cff77e$var$Hh($a9f996f354cff77e$var$Eh.current);
    var c = $a9f996f354cff77e$var$lb(b, a.type);
    b !== c && ($a9f996f354cff77e$var$G($a9f996f354cff77e$var$Fh, a), $a9f996f354cff77e$var$G($a9f996f354cff77e$var$Eh, c));
}
function $a9f996f354cff77e$var$Lh(a) {
    $a9f996f354cff77e$var$Fh.current === a && ($a9f996f354cff77e$var$E($a9f996f354cff77e$var$Eh), $a9f996f354cff77e$var$E($a9f996f354cff77e$var$Fh));
}
var $a9f996f354cff77e$var$M = $a9f996f354cff77e$var$Uf(0);
function $a9f996f354cff77e$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $a9f996f354cff77e$var$Nh = [];
function $a9f996f354cff77e$var$Oh() {
    for(var a = 0; a < $a9f996f354cff77e$var$Nh.length; a++)$a9f996f354cff77e$var$Nh[a]._workInProgressVersionPrimary = null;
    $a9f996f354cff77e$var$Nh.length = 0;
}
var $a9f996f354cff77e$var$Ph = $a9f996f354cff77e$var$ua.ReactCurrentDispatcher, $a9f996f354cff77e$var$Qh = $a9f996f354cff77e$var$ua.ReactCurrentBatchConfig, $a9f996f354cff77e$var$Rh = 0, $a9f996f354cff77e$var$N = null, $a9f996f354cff77e$var$O = null, $a9f996f354cff77e$var$P = null, $a9f996f354cff77e$var$Sh = !1, $a9f996f354cff77e$var$Th = !1, $a9f996f354cff77e$var$Uh = 0, $a9f996f354cff77e$var$Vh = 0;
function $a9f996f354cff77e$var$Q() {
    throw Error($a9f996f354cff77e$var$p(321));
}
function $a9f996f354cff77e$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$a9f996f354cff77e$var$He(a[c], b[c])) return !1;
    return !0;
}
function $a9f996f354cff77e$var$Xh(a, b, c, d, e, f) {
    $a9f996f354cff77e$var$Rh = f;
    $a9f996f354cff77e$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $a9f996f354cff77e$var$Ph.current = null === a || null === a.memoizedState ? $a9f996f354cff77e$var$Yh : $a9f996f354cff77e$var$Zh;
    a = c(d, e);
    if ($a9f996f354cff77e$var$Th) {
        f = 0;
        do {
            $a9f996f354cff77e$var$Th = !1;
            $a9f996f354cff77e$var$Uh = 0;
            if (25 <= f) throw Error($a9f996f354cff77e$var$p(301));
            f += 1;
            $a9f996f354cff77e$var$P = $a9f996f354cff77e$var$O = null;
            b.updateQueue = null;
            $a9f996f354cff77e$var$Ph.current = $a9f996f354cff77e$var$$h;
            a = c(d, e);
        }while ($a9f996f354cff77e$var$Th);
    }
    $a9f996f354cff77e$var$Ph.current = $a9f996f354cff77e$var$ai;
    b = null !== $a9f996f354cff77e$var$O && null !== $a9f996f354cff77e$var$O.next;
    $a9f996f354cff77e$var$Rh = 0;
    $a9f996f354cff77e$var$P = $a9f996f354cff77e$var$O = $a9f996f354cff77e$var$N = null;
    $a9f996f354cff77e$var$Sh = !1;
    if (b) throw Error($a9f996f354cff77e$var$p(300));
    return a;
}
function $a9f996f354cff77e$var$bi() {
    var a = 0 !== $a9f996f354cff77e$var$Uh;
    $a9f996f354cff77e$var$Uh = 0;
    return a;
}
function $a9f996f354cff77e$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a9f996f354cff77e$var$P ? $a9f996f354cff77e$var$N.memoizedState = $a9f996f354cff77e$var$P = a : $a9f996f354cff77e$var$P = $a9f996f354cff77e$var$P.next = a;
    return $a9f996f354cff77e$var$P;
}
function $a9f996f354cff77e$var$di() {
    if (null === $a9f996f354cff77e$var$O) {
        var a = $a9f996f354cff77e$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $a9f996f354cff77e$var$O.next;
    var b = null === $a9f996f354cff77e$var$P ? $a9f996f354cff77e$var$N.memoizedState : $a9f996f354cff77e$var$P.next;
    if (null !== b) $a9f996f354cff77e$var$P = b, $a9f996f354cff77e$var$O = a;
    else {
        if (null === a) throw Error($a9f996f354cff77e$var$p(310));
        $a9f996f354cff77e$var$O = a;
        a = {
            memoizedState: $a9f996f354cff77e$var$O.memoizedState,
            baseState: $a9f996f354cff77e$var$O.baseState,
            baseQueue: $a9f996f354cff77e$var$O.baseQueue,
            queue: $a9f996f354cff77e$var$O.queue,
            next: null
        };
        null === $a9f996f354cff77e$var$P ? $a9f996f354cff77e$var$N.memoizedState = $a9f996f354cff77e$var$P = a : $a9f996f354cff77e$var$P = $a9f996f354cff77e$var$P.next = a;
    }
    return $a9f996f354cff77e$var$P;
}
function $a9f996f354cff77e$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a9f996f354cff77e$var$fi(a) {
    var b = $a9f996f354cff77e$var$di(), c = b.queue;
    if (null === c) throw Error($a9f996f354cff77e$var$p(311));
    c.lastRenderedReducer = a;
    var d = $a9f996f354cff77e$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($a9f996f354cff77e$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $a9f996f354cff77e$var$N.lanes |= m;
                $a9f996f354cff77e$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $a9f996f354cff77e$var$He(d, b.memoizedState) || ($a9f996f354cff77e$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $a9f996f354cff77e$var$N.lanes |= f, $a9f996f354cff77e$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $a9f996f354cff77e$var$gi(a) {
    var b = $a9f996f354cff77e$var$di(), c = b.queue;
    if (null === c) throw Error($a9f996f354cff77e$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $a9f996f354cff77e$var$He(f, b.memoizedState) || ($a9f996f354cff77e$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $a9f996f354cff77e$var$hi() {}
function $a9f996f354cff77e$var$ii(a, b) {
    var c = $a9f996f354cff77e$var$N, d = $a9f996f354cff77e$var$di(), e = b(), f = !$a9f996f354cff77e$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $a9f996f354cff77e$var$Ug = !0);
    d = d.queue;
    $a9f996f354cff77e$var$ji($a9f996f354cff77e$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $a9f996f354cff77e$var$P && $a9f996f354cff77e$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $a9f996f354cff77e$var$li(9, $a9f996f354cff77e$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $a9f996f354cff77e$var$R) throw Error($a9f996f354cff77e$var$p(349));
        0 !== ($a9f996f354cff77e$var$Rh & 30) || $a9f996f354cff77e$var$ni(c, b, e);
    }
    return e;
}
function $a9f996f354cff77e$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $a9f996f354cff77e$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a9f996f354cff77e$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $a9f996f354cff77e$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $a9f996f354cff77e$var$oi(b) && $a9f996f354cff77e$var$pi(a);
}
function $a9f996f354cff77e$var$ki(a, b, c) {
    return c(function() {
        $a9f996f354cff77e$var$oi(b) && $a9f996f354cff77e$var$pi(a);
    });
}
function $a9f996f354cff77e$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$a9f996f354cff77e$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $a9f996f354cff77e$var$pi(a) {
    var b = $a9f996f354cff77e$var$Zg(a, 1);
    null !== b && $a9f996f354cff77e$var$mh(b, a, 1, -1);
}
function $a9f996f354cff77e$var$qi(a) {
    var b = $a9f996f354cff77e$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a9f996f354cff77e$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $a9f996f354cff77e$var$ri.bind(null, $a9f996f354cff77e$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $a9f996f354cff77e$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $a9f996f354cff77e$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a9f996f354cff77e$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $a9f996f354cff77e$var$si() {
    return $a9f996f354cff77e$var$di().memoizedState;
}
function $a9f996f354cff77e$var$ti(a, b, c, d) {
    var e = $a9f996f354cff77e$var$ci();
    $a9f996f354cff77e$var$N.flags |= a;
    e.memoizedState = $a9f996f354cff77e$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $a9f996f354cff77e$var$ui(a, b, c, d) {
    var e = $a9f996f354cff77e$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $a9f996f354cff77e$var$O) {
        var g = $a9f996f354cff77e$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $a9f996f354cff77e$var$Wh(d, g.deps)) {
            e.memoizedState = $a9f996f354cff77e$var$li(b, c, f, d);
            return;
        }
    }
    $a9f996f354cff77e$var$N.flags |= a;
    e.memoizedState = $a9f996f354cff77e$var$li(1 | b, c, f, d);
}
function $a9f996f354cff77e$var$vi(a, b) {
    return $a9f996f354cff77e$var$ti(8390656, 8, a, b);
}
function $a9f996f354cff77e$var$ji(a, b) {
    return $a9f996f354cff77e$var$ui(2048, 8, a, b);
}
function $a9f996f354cff77e$var$wi(a, b) {
    return $a9f996f354cff77e$var$ui(4, 2, a, b);
}
function $a9f996f354cff77e$var$xi(a, b) {
    return $a9f996f354cff77e$var$ui(4, 4, a, b);
}
function $a9f996f354cff77e$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $a9f996f354cff77e$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $a9f996f354cff77e$var$ui(4, 4, $a9f996f354cff77e$var$yi.bind(null, b, a), c);
}
function $a9f996f354cff77e$var$Ai() {}
function $a9f996f354cff77e$var$Bi(a, b) {
    var c = $a9f996f354cff77e$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a9f996f354cff77e$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a9f996f354cff77e$var$Ci(a, b) {
    var c = $a9f996f354cff77e$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a9f996f354cff77e$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a9f996f354cff77e$var$Di(a, b, c) {
    if (0 === ($a9f996f354cff77e$var$Rh & 21)) return a.baseState && (a.baseState = !1, $a9f996f354cff77e$var$Ug = !0), a.memoizedState = c;
    $a9f996f354cff77e$var$He(c, b) || (c = $a9f996f354cff77e$var$yc(), $a9f996f354cff77e$var$N.lanes |= c, $a9f996f354cff77e$var$hh |= c, a.baseState = !0);
    return b;
}
function $a9f996f354cff77e$var$Ei(a, b) {
    var c = $a9f996f354cff77e$var$C;
    $a9f996f354cff77e$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $a9f996f354cff77e$var$Qh.transition;
    $a9f996f354cff77e$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $a9f996f354cff77e$var$C = c, $a9f996f354cff77e$var$Qh.transition = d;
    }
}
function $a9f996f354cff77e$var$Fi() {
    return $a9f996f354cff77e$var$di().memoizedState;
}
function $a9f996f354cff77e$var$Gi(a, b, c) {
    var d = $a9f996f354cff77e$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a9f996f354cff77e$var$Hi(a)) $a9f996f354cff77e$var$Ii(b, c);
    else if (c = $a9f996f354cff77e$var$Yg(a, b, c, d), null !== c) {
        var e = $a9f996f354cff77e$var$L();
        $a9f996f354cff77e$var$mh(c, a, d, e);
        $a9f996f354cff77e$var$Ji(c, b, d);
    }
}
function $a9f996f354cff77e$var$ri(a, b, c) {
    var d = $a9f996f354cff77e$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a9f996f354cff77e$var$Hi(a)) $a9f996f354cff77e$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($a9f996f354cff77e$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $a9f996f354cff77e$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $a9f996f354cff77e$var$Yg(a, b, e, d);
        null !== c && (e = $a9f996f354cff77e$var$L(), $a9f996f354cff77e$var$mh(c, a, d, e), $a9f996f354cff77e$var$Ji(c, b, d));
    }
}
function $a9f996f354cff77e$var$Hi(a) {
    var b = a.alternate;
    return a === $a9f996f354cff77e$var$N || null !== b && b === $a9f996f354cff77e$var$N;
}
function $a9f996f354cff77e$var$Ii(a, b) {
    $a9f996f354cff77e$var$Th = $a9f996f354cff77e$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $a9f996f354cff77e$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a9f996f354cff77e$var$Cc(a, c);
    }
}
var $a9f996f354cff77e$var$ai = {
    readContext: $a9f996f354cff77e$var$Vg,
    useCallback: $a9f996f354cff77e$var$Q,
    useContext: $a9f996f354cff77e$var$Q,
    useEffect: $a9f996f354cff77e$var$Q,
    useImperativeHandle: $a9f996f354cff77e$var$Q,
    useInsertionEffect: $a9f996f354cff77e$var$Q,
    useLayoutEffect: $a9f996f354cff77e$var$Q,
    useMemo: $a9f996f354cff77e$var$Q,
    useReducer: $a9f996f354cff77e$var$Q,
    useRef: $a9f996f354cff77e$var$Q,
    useState: $a9f996f354cff77e$var$Q,
    useDebugValue: $a9f996f354cff77e$var$Q,
    useDeferredValue: $a9f996f354cff77e$var$Q,
    useTransition: $a9f996f354cff77e$var$Q,
    useMutableSource: $a9f996f354cff77e$var$Q,
    useSyncExternalStore: $a9f996f354cff77e$var$Q,
    useId: $a9f996f354cff77e$var$Q,
    unstable_isNewReconciler: !1
}, $a9f996f354cff77e$var$Yh = {
    readContext: $a9f996f354cff77e$var$Vg,
    useCallback: function(a, b) {
        $a9f996f354cff77e$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $a9f996f354cff77e$var$Vg,
    useEffect: $a9f996f354cff77e$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $a9f996f354cff77e$var$ti(4194308, 4, $a9f996f354cff77e$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $a9f996f354cff77e$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $a9f996f354cff77e$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $a9f996f354cff77e$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $a9f996f354cff77e$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $a9f996f354cff77e$var$Gi.bind(null, $a9f996f354cff77e$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $a9f996f354cff77e$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $a9f996f354cff77e$var$qi,
    useDebugValue: $a9f996f354cff77e$var$Ai,
    useDeferredValue: function(a) {
        return $a9f996f354cff77e$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $a9f996f354cff77e$var$qi(!1), b = a[0];
        a = $a9f996f354cff77e$var$Ei.bind(null, a[1]);
        $a9f996f354cff77e$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $a9f996f354cff77e$var$N, e = $a9f996f354cff77e$var$ci();
        if ($a9f996f354cff77e$var$I) {
            if (void 0 === c) throw Error($a9f996f354cff77e$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $a9f996f354cff77e$var$R) throw Error($a9f996f354cff77e$var$p(349));
            0 !== ($a9f996f354cff77e$var$Rh & 30) || $a9f996f354cff77e$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $a9f996f354cff77e$var$vi($a9f996f354cff77e$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $a9f996f354cff77e$var$li(9, $a9f996f354cff77e$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $a9f996f354cff77e$var$ci(), b = $a9f996f354cff77e$var$R.identifierPrefix;
        if ($a9f996f354cff77e$var$I) {
            var c = $a9f996f354cff77e$var$sg;
            var d = $a9f996f354cff77e$var$rg;
            c = (d & ~(1 << 32 - $a9f996f354cff77e$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $a9f996f354cff77e$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $a9f996f354cff77e$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $a9f996f354cff77e$var$Zh = {
    readContext: $a9f996f354cff77e$var$Vg,
    useCallback: $a9f996f354cff77e$var$Bi,
    useContext: $a9f996f354cff77e$var$Vg,
    useEffect: $a9f996f354cff77e$var$ji,
    useImperativeHandle: $a9f996f354cff77e$var$zi,
    useInsertionEffect: $a9f996f354cff77e$var$wi,
    useLayoutEffect: $a9f996f354cff77e$var$xi,
    useMemo: $a9f996f354cff77e$var$Ci,
    useReducer: $a9f996f354cff77e$var$fi,
    useRef: $a9f996f354cff77e$var$si,
    useState: function() {
        return $a9f996f354cff77e$var$fi($a9f996f354cff77e$var$ei);
    },
    useDebugValue: $a9f996f354cff77e$var$Ai,
    useDeferredValue: function(a) {
        var b = $a9f996f354cff77e$var$di();
        return $a9f996f354cff77e$var$Di(b, $a9f996f354cff77e$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $a9f996f354cff77e$var$fi($a9f996f354cff77e$var$ei)[0], b = $a9f996f354cff77e$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a9f996f354cff77e$var$hi,
    useSyncExternalStore: $a9f996f354cff77e$var$ii,
    useId: $a9f996f354cff77e$var$Fi,
    unstable_isNewReconciler: !1
}, $a9f996f354cff77e$var$$h = {
    readContext: $a9f996f354cff77e$var$Vg,
    useCallback: $a9f996f354cff77e$var$Bi,
    useContext: $a9f996f354cff77e$var$Vg,
    useEffect: $a9f996f354cff77e$var$ji,
    useImperativeHandle: $a9f996f354cff77e$var$zi,
    useInsertionEffect: $a9f996f354cff77e$var$wi,
    useLayoutEffect: $a9f996f354cff77e$var$xi,
    useMemo: $a9f996f354cff77e$var$Ci,
    useReducer: $a9f996f354cff77e$var$gi,
    useRef: $a9f996f354cff77e$var$si,
    useState: function() {
        return $a9f996f354cff77e$var$gi($a9f996f354cff77e$var$ei);
    },
    useDebugValue: $a9f996f354cff77e$var$Ai,
    useDeferredValue: function(a) {
        var b = $a9f996f354cff77e$var$di();
        return null === $a9f996f354cff77e$var$O ? b.memoizedState = a : $a9f996f354cff77e$var$Di(b, $a9f996f354cff77e$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $a9f996f354cff77e$var$gi($a9f996f354cff77e$var$ei)[0], b = $a9f996f354cff77e$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a9f996f354cff77e$var$hi,
    useSyncExternalStore: $a9f996f354cff77e$var$ii,
    useId: $a9f996f354cff77e$var$Fi,
    unstable_isNewReconciler: !1
};
function $a9f996f354cff77e$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $a9f996f354cff77e$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $a9f996f354cff77e$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $a9f996f354cff77e$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $a9f996f354cff77e$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $a9f996f354cff77e$var$Oi(a, b, c) {
    c = $a9f996f354cff77e$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $a9f996f354cff77e$var$Pi || ($a9f996f354cff77e$var$Pi = !0, $a9f996f354cff77e$var$Qi = d);
        $a9f996f354cff77e$var$Mi(a, b);
    };
    return c;
}
function $a9f996f354cff77e$var$Ri(a, b, c) {
    c = $a9f996f354cff77e$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $a9f996f354cff77e$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $a9f996f354cff77e$var$Mi(a, b);
        "function" !== typeof d && (null === $a9f996f354cff77e$var$Si ? $a9f996f354cff77e$var$Si = new Set([
            this
        ]) : $a9f996f354cff77e$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $a9f996f354cff77e$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $a9f996f354cff77e$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $a9f996f354cff77e$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $a9f996f354cff77e$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $a9f996f354cff77e$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $a9f996f354cff77e$var$ch(-1, 1), b.tag = 2, $a9f996f354cff77e$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $a9f996f354cff77e$var$Xi = $a9f996f354cff77e$var$ua.ReactCurrentOwner, $a9f996f354cff77e$var$Ug = !1;
function $a9f996f354cff77e$var$Yi(a, b, c, d) {
    b.child = null === a ? $a9f996f354cff77e$var$Ch(b, null, c, d) : $a9f996f354cff77e$var$Bh(b, a.child, c, d);
}
function $a9f996f354cff77e$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $a9f996f354cff77e$var$Tg(b, e);
    d = $a9f996f354cff77e$var$Xh(a, b, c, d, f, e);
    c = $a9f996f354cff77e$var$bi();
    if (null !== a && !$a9f996f354cff77e$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a9f996f354cff77e$var$$i(a, b, e);
    $a9f996f354cff77e$var$I && c && $a9f996f354cff77e$var$vg(b);
    b.flags |= 1;
    $a9f996f354cff77e$var$Yi(a, b, d, e);
    return b.child;
}
function $a9f996f354cff77e$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$a9f996f354cff77e$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $a9f996f354cff77e$var$cj(a, b, f, d, e);
        a = $a9f996f354cff77e$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $a9f996f354cff77e$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $a9f996f354cff77e$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $a9f996f354cff77e$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $a9f996f354cff77e$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($a9f996f354cff77e$var$Ie(f, d) && a.ref === b.ref) {
            if ($a9f996f354cff77e$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($a9f996f354cff77e$var$Ug = !0);
            else return b.lanes = a.lanes, $a9f996f354cff77e$var$$i(a, b, e);
        }
    }
    return $a9f996f354cff77e$var$dj(a, b, c, d, e);
}
function $a9f996f354cff77e$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $a9f996f354cff77e$var$G($a9f996f354cff77e$var$fj, $a9f996f354cff77e$var$gj), $a9f996f354cff77e$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $a9f996f354cff77e$var$G($a9f996f354cff77e$var$fj, $a9f996f354cff77e$var$gj), $a9f996f354cff77e$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $a9f996f354cff77e$var$G($a9f996f354cff77e$var$fj, $a9f996f354cff77e$var$gj);
            $a9f996f354cff77e$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $a9f996f354cff77e$var$G($a9f996f354cff77e$var$fj, $a9f996f354cff77e$var$gj), $a9f996f354cff77e$var$gj |= d;
    $a9f996f354cff77e$var$Yi(a, b, e, c);
    return b.child;
}
function $a9f996f354cff77e$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $a9f996f354cff77e$var$dj(a, b, c, d, e) {
    var f = $a9f996f354cff77e$var$Zf(c) ? $a9f996f354cff77e$var$Xf : $a9f996f354cff77e$var$H.current;
    f = $a9f996f354cff77e$var$Yf(b, f);
    $a9f996f354cff77e$var$Tg(b, e);
    c = $a9f996f354cff77e$var$Xh(a, b, c, d, f, e);
    d = $a9f996f354cff77e$var$bi();
    if (null !== a && !$a9f996f354cff77e$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a9f996f354cff77e$var$$i(a, b, e);
    $a9f996f354cff77e$var$I && d && $a9f996f354cff77e$var$vg(b);
    b.flags |= 1;
    $a9f996f354cff77e$var$Yi(a, b, c, e);
    return b.child;
}
function $a9f996f354cff77e$var$ij(a, b, c, d, e) {
    if ($a9f996f354cff77e$var$Zf(c)) {
        var f = !0;
        $a9f996f354cff77e$var$cg(b);
    } else f = !1;
    $a9f996f354cff77e$var$Tg(b, e);
    if (null === b.stateNode) $a9f996f354cff77e$var$jj(a, b), $a9f996f354cff77e$var$ph(b, c, d), $a9f996f354cff77e$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $a9f996f354cff77e$var$Vg(l) : (l = $a9f996f354cff77e$var$Zf(c) ? $a9f996f354cff77e$var$Xf : $a9f996f354cff77e$var$H.current, l = $a9f996f354cff77e$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $a9f996f354cff77e$var$qh(b, g, d, l);
        $a9f996f354cff77e$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $a9f996f354cff77e$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $a9f996f354cff77e$var$Wf.current || $a9f996f354cff77e$var$$g ? ("function" === typeof m && ($a9f996f354cff77e$var$kh(b, c, m, d), k = b.memoizedState), (h = $a9f996f354cff77e$var$$g || $a9f996f354cff77e$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $a9f996f354cff77e$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $a9f996f354cff77e$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $a9f996f354cff77e$var$Vg(k) : (k = $a9f996f354cff77e$var$Zf(c) ? $a9f996f354cff77e$var$Xf : $a9f996f354cff77e$var$H.current, k = $a9f996f354cff77e$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $a9f996f354cff77e$var$qh(b, g, d, k);
        $a9f996f354cff77e$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $a9f996f354cff77e$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $a9f996f354cff77e$var$Wf.current || $a9f996f354cff77e$var$$g ? ("function" === typeof y && ($a9f996f354cff77e$var$kh(b, c, y, d), n = b.memoizedState), (l = $a9f996f354cff77e$var$$g || $a9f996f354cff77e$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $a9f996f354cff77e$var$kj(a, b, c, d, f, e);
}
function $a9f996f354cff77e$var$kj(a, b, c, d, e, f) {
    $a9f996f354cff77e$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $a9f996f354cff77e$var$dg(b, c, !1), $a9f996f354cff77e$var$$i(a, b, f);
    d = b.stateNode;
    $a9f996f354cff77e$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $a9f996f354cff77e$var$Bh(b, a.child, null, f), b.child = $a9f996f354cff77e$var$Bh(b, null, h, f)) : $a9f996f354cff77e$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $a9f996f354cff77e$var$dg(b, c, !0);
    return b.child;
}
function $a9f996f354cff77e$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $a9f996f354cff77e$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $a9f996f354cff77e$var$ag(a, b.context, !1);
    $a9f996f354cff77e$var$Ih(a, b.containerInfo);
}
function $a9f996f354cff77e$var$mj(a, b, c, d, e) {
    $a9f996f354cff77e$var$Ig();
    $a9f996f354cff77e$var$Jg(e);
    b.flags |= 256;
    $a9f996f354cff77e$var$Yi(a, b, c, d);
    return b.child;
}
var $a9f996f354cff77e$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $a9f996f354cff77e$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $a9f996f354cff77e$var$pj(a, b, c) {
    var d = b.pendingProps, e = $a9f996f354cff77e$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $a9f996f354cff77e$var$G($a9f996f354cff77e$var$M, e & 1);
    if (null === a) {
        $a9f996f354cff77e$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $a9f996f354cff77e$var$qj(g, d, 0, null), a = $a9f996f354cff77e$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $a9f996f354cff77e$var$oj(c), b.memoizedState = $a9f996f354cff77e$var$nj, a) : $a9f996f354cff77e$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $a9f996f354cff77e$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $a9f996f354cff77e$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $a9f996f354cff77e$var$wh(h, f) : (f = $a9f996f354cff77e$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $a9f996f354cff77e$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $a9f996f354cff77e$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $a9f996f354cff77e$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $a9f996f354cff77e$var$rj(a, b) {
    b = $a9f996f354cff77e$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $a9f996f354cff77e$var$tj(a, b, c, d) {
    null !== d && $a9f996f354cff77e$var$Jg(d);
    $a9f996f354cff77e$var$Bh(b, a.child, null, c);
    a = $a9f996f354cff77e$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $a9f996f354cff77e$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $a9f996f354cff77e$var$Li(Error($a9f996f354cff77e$var$p(422))), $a9f996f354cff77e$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $a9f996f354cff77e$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $a9f996f354cff77e$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $a9f996f354cff77e$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $a9f996f354cff77e$var$oj(g);
        b.memoizedState = $a9f996f354cff77e$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $a9f996f354cff77e$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($a9f996f354cff77e$var$p(419));
        d = $a9f996f354cff77e$var$Li(f, d, void 0);
        return $a9f996f354cff77e$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($a9f996f354cff77e$var$Ug || h) {
        d = $a9f996f354cff77e$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $a9f996f354cff77e$var$Zg(a, e), $a9f996f354cff77e$var$mh(d, a, e, -1));
        }
        $a9f996f354cff77e$var$uj();
        d = $a9f996f354cff77e$var$Li(Error($a9f996f354cff77e$var$p(421)));
        return $a9f996f354cff77e$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $a9f996f354cff77e$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $a9f996f354cff77e$var$yg = $a9f996f354cff77e$var$Lf(e.nextSibling);
    $a9f996f354cff77e$var$xg = b;
    $a9f996f354cff77e$var$I = !0;
    $a9f996f354cff77e$var$zg = null;
    null !== a && ($a9f996f354cff77e$var$og[$a9f996f354cff77e$var$pg++] = $a9f996f354cff77e$var$rg, $a9f996f354cff77e$var$og[$a9f996f354cff77e$var$pg++] = $a9f996f354cff77e$var$sg, $a9f996f354cff77e$var$og[$a9f996f354cff77e$var$pg++] = $a9f996f354cff77e$var$qg, $a9f996f354cff77e$var$rg = a.id, $a9f996f354cff77e$var$sg = a.overflow, $a9f996f354cff77e$var$qg = b);
    b = $a9f996f354cff77e$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $a9f996f354cff77e$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $a9f996f354cff77e$var$Sg(a.return, b, c);
}
function $a9f996f354cff77e$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $a9f996f354cff77e$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $a9f996f354cff77e$var$Yi(a, b, d.children, c);
    d = $a9f996f354cff77e$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $a9f996f354cff77e$var$wj(a, c, b);
            else if (19 === a.tag) $a9f996f354cff77e$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $a9f996f354cff77e$var$G($a9f996f354cff77e$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $a9f996f354cff77e$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $a9f996f354cff77e$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $a9f996f354cff77e$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $a9f996f354cff77e$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $a9f996f354cff77e$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $a9f996f354cff77e$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $a9f996f354cff77e$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $a9f996f354cff77e$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($a9f996f354cff77e$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $a9f996f354cff77e$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $a9f996f354cff77e$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $a9f996f354cff77e$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $a9f996f354cff77e$var$lj(b);
            $a9f996f354cff77e$var$Ig();
            break;
        case 5:
            $a9f996f354cff77e$var$Kh(b);
            break;
        case 1:
            $a9f996f354cff77e$var$Zf(b.type) && $a9f996f354cff77e$var$cg(b);
            break;
        case 4:
            $a9f996f354cff77e$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $a9f996f354cff77e$var$G($a9f996f354cff77e$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $a9f996f354cff77e$var$G($a9f996f354cff77e$var$M, $a9f996f354cff77e$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $a9f996f354cff77e$var$pj(a, b, c);
                $a9f996f354cff77e$var$G($a9f996f354cff77e$var$M, $a9f996f354cff77e$var$M.current & 1);
                a = $a9f996f354cff77e$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $a9f996f354cff77e$var$G($a9f996f354cff77e$var$M, $a9f996f354cff77e$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $a9f996f354cff77e$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $a9f996f354cff77e$var$G($a9f996f354cff77e$var$M, $a9f996f354cff77e$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $a9f996f354cff77e$var$ej(a, b, c);
    }
    return $a9f996f354cff77e$var$$i(a, b, c);
}
var $a9f996f354cff77e$var$Aj, $a9f996f354cff77e$var$Bj, $a9f996f354cff77e$var$Cj, $a9f996f354cff77e$var$Dj;
$a9f996f354cff77e$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$a9f996f354cff77e$var$Bj = function() {};
$a9f996f354cff77e$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $a9f996f354cff77e$var$Hh($a9f996f354cff77e$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $a9f996f354cff77e$var$Ya(a, e);
                d = $a9f996f354cff77e$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $a9f996f354cff77e$var$A({}, e, {
                    value: void 0
                });
                d = $a9f996f354cff77e$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $a9f996f354cff77e$var$gb(a, e);
                d = $a9f996f354cff77e$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $a9f996f354cff77e$var$Bf);
        }
        $a9f996f354cff77e$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($a9f996f354cff77e$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($a9f996f354cff77e$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $a9f996f354cff77e$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$a9f996f354cff77e$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $a9f996f354cff77e$var$Ej(a, b) {
    if (!$a9f996f354cff77e$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $a9f996f354cff77e$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $a9f996f354cff77e$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $a9f996f354cff77e$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $a9f996f354cff77e$var$S(b), null;
        case 1:
            return $a9f996f354cff77e$var$Zf(b.type) && $a9f996f354cff77e$var$$f(), $a9f996f354cff77e$var$S(b), null;
        case 3:
            d = b.stateNode;
            $a9f996f354cff77e$var$Jh();
            $a9f996f354cff77e$var$E($a9f996f354cff77e$var$Wf);
            $a9f996f354cff77e$var$E($a9f996f354cff77e$var$H);
            $a9f996f354cff77e$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $a9f996f354cff77e$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $a9f996f354cff77e$var$zg && ($a9f996f354cff77e$var$Gj($a9f996f354cff77e$var$zg), $a9f996f354cff77e$var$zg = null));
            $a9f996f354cff77e$var$Bj(a, b);
            $a9f996f354cff77e$var$S(b);
            return null;
        case 5:
            $a9f996f354cff77e$var$Lh(b);
            var e = $a9f996f354cff77e$var$Hh($a9f996f354cff77e$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $a9f996f354cff77e$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($a9f996f354cff77e$var$p(166));
                    $a9f996f354cff77e$var$S(b);
                    return null;
                }
                a = $a9f996f354cff77e$var$Hh($a9f996f354cff77e$var$Eh.current);
                if ($a9f996f354cff77e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$a9f996f354cff77e$var$Of] = b;
                    d[$a9f996f354cff77e$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $a9f996f354cff77e$var$D("cancel", d);
                            $a9f996f354cff77e$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $a9f996f354cff77e$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $a9f996f354cff77e$var$lf.length; e++)$a9f996f354cff77e$var$D($a9f996f354cff77e$var$lf[e], d);
                            break;
                        case "source":
                            $a9f996f354cff77e$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $a9f996f354cff77e$var$D("error", d);
                            $a9f996f354cff77e$var$D("load", d);
                            break;
                        case "details":
                            $a9f996f354cff77e$var$D("toggle", d);
                            break;
                        case "input":
                            $a9f996f354cff77e$var$Za(d, f);
                            $a9f996f354cff77e$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $a9f996f354cff77e$var$D("invalid", d);
                            break;
                        case "textarea":
                            $a9f996f354cff77e$var$hb(d, f), $a9f996f354cff77e$var$D("invalid", d);
                    }
                    $a9f996f354cff77e$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $a9f996f354cff77e$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $a9f996f354cff77e$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $a9f996f354cff77e$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $a9f996f354cff77e$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $a9f996f354cff77e$var$Va(d);
                            $a9f996f354cff77e$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $a9f996f354cff77e$var$Va(d);
                            $a9f996f354cff77e$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $a9f996f354cff77e$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $a9f996f354cff77e$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$a9f996f354cff77e$var$Of] = b;
                    a[$a9f996f354cff77e$var$Pf] = d;
                    $a9f996f354cff77e$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $a9f996f354cff77e$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $a9f996f354cff77e$var$D("cancel", a);
                                $a9f996f354cff77e$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $a9f996f354cff77e$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $a9f996f354cff77e$var$lf.length; e++)$a9f996f354cff77e$var$D($a9f996f354cff77e$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $a9f996f354cff77e$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $a9f996f354cff77e$var$D("error", a);
                                $a9f996f354cff77e$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $a9f996f354cff77e$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $a9f996f354cff77e$var$Za(a, d);
                                e = $a9f996f354cff77e$var$Ya(a, d);
                                $a9f996f354cff77e$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $a9f996f354cff77e$var$A({}, d, {
                                    value: void 0
                                });
                                $a9f996f354cff77e$var$D("invalid", a);
                                break;
                            case "textarea":
                                $a9f996f354cff77e$var$hb(a, d);
                                e = $a9f996f354cff77e$var$gb(a, d);
                                $a9f996f354cff77e$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $a9f996f354cff77e$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $a9f996f354cff77e$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $a9f996f354cff77e$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $a9f996f354cff77e$var$ob(a, k) : "number" === typeof k && $a9f996f354cff77e$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($a9f996f354cff77e$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $a9f996f354cff77e$var$D("scroll", a) : null != k && $a9f996f354cff77e$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $a9f996f354cff77e$var$Va(a);
                                $a9f996f354cff77e$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $a9f996f354cff77e$var$Va(a);
                                $a9f996f354cff77e$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $a9f996f354cff77e$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $a9f996f354cff77e$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $a9f996f354cff77e$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $a9f996f354cff77e$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $a9f996f354cff77e$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $a9f996f354cff77e$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($a9f996f354cff77e$var$p(166));
                c = $a9f996f354cff77e$var$Hh($a9f996f354cff77e$var$Gh.current);
                $a9f996f354cff77e$var$Hh($a9f996f354cff77e$var$Eh.current);
                if ($a9f996f354cff77e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$a9f996f354cff77e$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $a9f996f354cff77e$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $a9f996f354cff77e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $a9f996f354cff77e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$a9f996f354cff77e$var$Of] = b, b.stateNode = d;
            }
            $a9f996f354cff77e$var$S(b);
            return null;
        case 13:
            $a9f996f354cff77e$var$E($a9f996f354cff77e$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($a9f996f354cff77e$var$I && null !== $a9f996f354cff77e$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $a9f996f354cff77e$var$Hg(), $a9f996f354cff77e$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $a9f996f354cff77e$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($a9f996f354cff77e$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($a9f996f354cff77e$var$p(317));
                        f[$a9f996f354cff77e$var$Of] = b;
                    } else $a9f996f354cff77e$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $a9f996f354cff77e$var$S(b);
                    f = !1;
                } else null !== $a9f996f354cff77e$var$zg && ($a9f996f354cff77e$var$Gj($a9f996f354cff77e$var$zg), $a9f996f354cff77e$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($a9f996f354cff77e$var$M.current & 1) ? 0 === $a9f996f354cff77e$var$T && ($a9f996f354cff77e$var$T = 3) : $a9f996f354cff77e$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $a9f996f354cff77e$var$S(b);
            return null;
        case 4:
            return $a9f996f354cff77e$var$Jh(), $a9f996f354cff77e$var$Bj(a, b), null === a && $a9f996f354cff77e$var$sf(b.stateNode.containerInfo), $a9f996f354cff77e$var$S(b), null;
        case 10:
            return $a9f996f354cff77e$var$Rg(b.type._context), $a9f996f354cff77e$var$S(b), null;
        case 17:
            return $a9f996f354cff77e$var$Zf(b.type) && $a9f996f354cff77e$var$$f(), $a9f996f354cff77e$var$S(b), null;
        case 19:
            $a9f996f354cff77e$var$E($a9f996f354cff77e$var$M);
            f = b.memoizedState;
            if (null === f) return $a9f996f354cff77e$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $a9f996f354cff77e$var$Ej(f, !1);
                else {
                    if (0 !== $a9f996f354cff77e$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $a9f996f354cff77e$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $a9f996f354cff77e$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $a9f996f354cff77e$var$G($a9f996f354cff77e$var$M, $a9f996f354cff77e$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $a9f996f354cff77e$var$B() > $a9f996f354cff77e$var$Hj && (b.flags |= 128, d = !0, $a9f996f354cff77e$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $a9f996f354cff77e$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $a9f996f354cff77e$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$a9f996f354cff77e$var$I) return $a9f996f354cff77e$var$S(b), null;
                    } else 2 * $a9f996f354cff77e$var$B() - f.renderingStartTime > $a9f996f354cff77e$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $a9f996f354cff77e$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $a9f996f354cff77e$var$B(), b.sibling = null, c = $a9f996f354cff77e$var$M.current, $a9f996f354cff77e$var$G($a9f996f354cff77e$var$M, d ? c & 1 | 2 : c & 1), b;
            $a9f996f354cff77e$var$S(b);
            return null;
        case 22:
        case 23:
            return $a9f996f354cff77e$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($a9f996f354cff77e$var$gj & 1073741824) && ($a9f996f354cff77e$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $a9f996f354cff77e$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($a9f996f354cff77e$var$p(156, b.tag));
}
function $a9f996f354cff77e$var$Jj(a, b) {
    $a9f996f354cff77e$var$wg(b);
    switch(b.tag){
        case 1:
            return $a9f996f354cff77e$var$Zf(b.type) && $a9f996f354cff77e$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $a9f996f354cff77e$var$Jh(), $a9f996f354cff77e$var$E($a9f996f354cff77e$var$Wf), $a9f996f354cff77e$var$E($a9f996f354cff77e$var$H), $a9f996f354cff77e$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $a9f996f354cff77e$var$Lh(b), null;
        case 13:
            $a9f996f354cff77e$var$E($a9f996f354cff77e$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($a9f996f354cff77e$var$p(340));
                $a9f996f354cff77e$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $a9f996f354cff77e$var$E($a9f996f354cff77e$var$M), null;
        case 4:
            return $a9f996f354cff77e$var$Jh(), null;
        case 10:
            return $a9f996f354cff77e$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $a9f996f354cff77e$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $a9f996f354cff77e$var$Kj = !1, $a9f996f354cff77e$var$U = !1, $a9f996f354cff77e$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $a9f996f354cff77e$var$V = null;
function $a9f996f354cff77e$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $a9f996f354cff77e$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $a9f996f354cff77e$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $a9f996f354cff77e$var$W(a, b, d);
    }
}
var $a9f996f354cff77e$var$Oj = !1;
function $a9f996f354cff77e$var$Pj(a, b) {
    $a9f996f354cff77e$var$Cf = $a9f996f354cff77e$var$dd;
    a = $a9f996f354cff77e$var$Me();
    if ($a9f996f354cff77e$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $a9f996f354cff77e$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $a9f996f354cff77e$var$dd = !1;
    for($a9f996f354cff77e$var$V = b; null !== $a9f996f354cff77e$var$V;)if (b = $a9f996f354cff77e$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $a9f996f354cff77e$var$V = a;
    else for(; null !== $a9f996f354cff77e$var$V;){
        b = $a9f996f354cff77e$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $a9f996f354cff77e$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($a9f996f354cff77e$var$p(163));
            }
        } catch (F) {
            $a9f996f354cff77e$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $a9f996f354cff77e$var$V = a;
            break;
        }
        $a9f996f354cff77e$var$V = b.return;
    }
    n = $a9f996f354cff77e$var$Oj;
    $a9f996f354cff77e$var$Oj = !1;
    return n;
}
function $a9f996f354cff77e$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $a9f996f354cff77e$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $a9f996f354cff77e$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $a9f996f354cff77e$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $a9f996f354cff77e$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $a9f996f354cff77e$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$a9f996f354cff77e$var$Of], delete b[$a9f996f354cff77e$var$Pf], delete b[$a9f996f354cff77e$var$of], delete b[$a9f996f354cff77e$var$Qf], delete b[$a9f996f354cff77e$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $a9f996f354cff77e$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $a9f996f354cff77e$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $a9f996f354cff77e$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $a9f996f354cff77e$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $a9f996f354cff77e$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($a9f996f354cff77e$var$Wj(a, b, c), a = a.sibling; null !== a;)$a9f996f354cff77e$var$Wj(a, b, c), a = a.sibling;
}
function $a9f996f354cff77e$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($a9f996f354cff77e$var$Xj(a, b, c), a = a.sibling; null !== a;)$a9f996f354cff77e$var$Xj(a, b, c), a = a.sibling;
}
var $a9f996f354cff77e$var$X = null, $a9f996f354cff77e$var$Yj = !1;
function $a9f996f354cff77e$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$a9f996f354cff77e$var$ak(a, b, c), c = c.sibling;
}
function $a9f996f354cff77e$var$ak(a, b, c) {
    if ($a9f996f354cff77e$var$lc && "function" === typeof $a9f996f354cff77e$var$lc.onCommitFiberUnmount) try {
        $a9f996f354cff77e$var$lc.onCommitFiberUnmount($a9f996f354cff77e$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $a9f996f354cff77e$var$U || $a9f996f354cff77e$var$Mj(c, b);
        case 6:
            var d = $a9f996f354cff77e$var$X, e = $a9f996f354cff77e$var$Yj;
            $a9f996f354cff77e$var$X = null;
            $a9f996f354cff77e$var$Zj(a, b, c);
            $a9f996f354cff77e$var$X = d;
            $a9f996f354cff77e$var$Yj = e;
            null !== $a9f996f354cff77e$var$X && ($a9f996f354cff77e$var$Yj ? (a = $a9f996f354cff77e$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $a9f996f354cff77e$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $a9f996f354cff77e$var$X && ($a9f996f354cff77e$var$Yj ? (a = $a9f996f354cff77e$var$X, c = c.stateNode, 8 === a.nodeType ? $a9f996f354cff77e$var$Kf(a.parentNode, c) : 1 === a.nodeType && $a9f996f354cff77e$var$Kf(a, c), $a9f996f354cff77e$var$bd(a)) : $a9f996f354cff77e$var$Kf($a9f996f354cff77e$var$X, c.stateNode));
            break;
        case 4:
            d = $a9f996f354cff77e$var$X;
            e = $a9f996f354cff77e$var$Yj;
            $a9f996f354cff77e$var$X = c.stateNode.containerInfo;
            $a9f996f354cff77e$var$Yj = !0;
            $a9f996f354cff77e$var$Zj(a, b, c);
            $a9f996f354cff77e$var$X = d;
            $a9f996f354cff77e$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$a9f996f354cff77e$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $a9f996f354cff77e$var$Nj(c, b, g) : 0 !== (f & 4) && $a9f996f354cff77e$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $a9f996f354cff77e$var$Zj(a, b, c);
            break;
        case 1:
            if (!$a9f996f354cff77e$var$U && ($a9f996f354cff77e$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $a9f996f354cff77e$var$W(c, b, h);
            }
            $a9f996f354cff77e$var$Zj(a, b, c);
            break;
        case 21:
            $a9f996f354cff77e$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($a9f996f354cff77e$var$U = (d = $a9f996f354cff77e$var$U) || null !== c.memoizedState, $a9f996f354cff77e$var$Zj(a, b, c), $a9f996f354cff77e$var$U = d) : $a9f996f354cff77e$var$Zj(a, b, c);
            break;
        default:
            $a9f996f354cff77e$var$Zj(a, b, c);
    }
}
function $a9f996f354cff77e$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $a9f996f354cff77e$var$Lj);
        b.forEach(function(b) {
            var d = $a9f996f354cff77e$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $a9f996f354cff77e$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $a9f996f354cff77e$var$X = h.stateNode;
                        $a9f996f354cff77e$var$Yj = !1;
                        break a;
                    case 3:
                        $a9f996f354cff77e$var$X = h.stateNode.containerInfo;
                        $a9f996f354cff77e$var$Yj = !0;
                        break a;
                    case 4:
                        $a9f996f354cff77e$var$X = h.stateNode.containerInfo;
                        $a9f996f354cff77e$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $a9f996f354cff77e$var$X) throw Error($a9f996f354cff77e$var$p(160));
            $a9f996f354cff77e$var$ak(f, g, e);
            $a9f996f354cff77e$var$X = null;
            $a9f996f354cff77e$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $a9f996f354cff77e$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$a9f996f354cff77e$var$ek(b, a), b = b.sibling;
}
function $a9f996f354cff77e$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $a9f996f354cff77e$var$dk(b, a);
            $a9f996f354cff77e$var$fk(a);
            if (d & 4) {
                try {
                    $a9f996f354cff77e$var$Qj(3, a, a.return), $a9f996f354cff77e$var$Rj(3, a);
                } catch (t) {
                    $a9f996f354cff77e$var$W(a, a.return, t);
                }
                try {
                    $a9f996f354cff77e$var$Qj(5, a, a.return);
                } catch (t) {
                    $a9f996f354cff77e$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $a9f996f354cff77e$var$dk(b, a);
            $a9f996f354cff77e$var$fk(a);
            d & 512 && null !== c && $a9f996f354cff77e$var$Mj(c, c.return);
            break;
        case 5:
            $a9f996f354cff77e$var$dk(b, a);
            $a9f996f354cff77e$var$fk(a);
            d & 512 && null !== c && $a9f996f354cff77e$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $a9f996f354cff77e$var$ob(e, "");
                } catch (t) {
                    $a9f996f354cff77e$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $a9f996f354cff77e$var$ab(e, f);
                    $a9f996f354cff77e$var$vb(h, g);
                    var l = $a9f996f354cff77e$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $a9f996f354cff77e$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $a9f996f354cff77e$var$nb(e, q) : "children" === m ? $a9f996f354cff77e$var$ob(e, q) : $a9f996f354cff77e$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $a9f996f354cff77e$var$bb(e, f);
                            break;
                        case "textarea":
                            $a9f996f354cff77e$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $a9f996f354cff77e$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $a9f996f354cff77e$var$fb(e, !!f.multiple, f.defaultValue, !0) : $a9f996f354cff77e$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$a9f996f354cff77e$var$Pf] = f;
                } catch (t) {
                    $a9f996f354cff77e$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $a9f996f354cff77e$var$dk(b, a);
            $a9f996f354cff77e$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($a9f996f354cff77e$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $a9f996f354cff77e$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $a9f996f354cff77e$var$dk(b, a);
            $a9f996f354cff77e$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $a9f996f354cff77e$var$bd(b.containerInfo);
            } catch (t) {
                $a9f996f354cff77e$var$W(a, a.return, t);
            }
            break;
        case 4:
            $a9f996f354cff77e$var$dk(b, a);
            $a9f996f354cff77e$var$fk(a);
            break;
        case 13:
            $a9f996f354cff77e$var$dk(b, a);
            $a9f996f354cff77e$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($a9f996f354cff77e$var$gk = $a9f996f354cff77e$var$B()));
            d & 4 && $a9f996f354cff77e$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($a9f996f354cff77e$var$U = (l = $a9f996f354cff77e$var$U) || m, $a9f996f354cff77e$var$dk(b, a), $a9f996f354cff77e$var$U = l) : $a9f996f354cff77e$var$dk(b, a);
            $a9f996f354cff77e$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($a9f996f354cff77e$var$V = a, m = a.child; null !== m;){
                    for(q = $a9f996f354cff77e$var$V = m; null !== $a9f996f354cff77e$var$V;){
                        r = $a9f996f354cff77e$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $a9f996f354cff77e$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $a9f996f354cff77e$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $a9f996f354cff77e$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $a9f996f354cff77e$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $a9f996f354cff77e$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $a9f996f354cff77e$var$V = y) : $a9f996f354cff77e$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $a9f996f354cff77e$var$rb("display", g));
                            } catch (t) {
                                $a9f996f354cff77e$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $a9f996f354cff77e$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $a9f996f354cff77e$var$dk(b, a);
            $a9f996f354cff77e$var$fk(a);
            d & 4 && $a9f996f354cff77e$var$bk(a);
            break;
        case 21:
            break;
        default:
            $a9f996f354cff77e$var$dk(b, a), $a9f996f354cff77e$var$fk(a);
    }
}
function $a9f996f354cff77e$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($a9f996f354cff77e$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($a9f996f354cff77e$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($a9f996f354cff77e$var$ob(e, ""), d.flags &= -33);
                    var f = $a9f996f354cff77e$var$Vj(a);
                    $a9f996f354cff77e$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $a9f996f354cff77e$var$Vj(a);
                    $a9f996f354cff77e$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($a9f996f354cff77e$var$p(161));
            }
        } catch (k) {
            $a9f996f354cff77e$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $a9f996f354cff77e$var$ik(a, b, c) {
    $a9f996f354cff77e$var$V = a;
    $a9f996f354cff77e$var$jk(a, b, c);
}
function $a9f996f354cff77e$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $a9f996f354cff77e$var$V;){
        var e = $a9f996f354cff77e$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $a9f996f354cff77e$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $a9f996f354cff77e$var$U;
                h = $a9f996f354cff77e$var$Kj;
                var l = $a9f996f354cff77e$var$U;
                $a9f996f354cff77e$var$Kj = g;
                if (($a9f996f354cff77e$var$U = k) && !l) for($a9f996f354cff77e$var$V = e; null !== $a9f996f354cff77e$var$V;)g = $a9f996f354cff77e$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $a9f996f354cff77e$var$kk(e) : null !== k ? (k.return = g, $a9f996f354cff77e$var$V = k) : $a9f996f354cff77e$var$kk(e);
                for(; null !== f;)$a9f996f354cff77e$var$V = f, $a9f996f354cff77e$var$jk(f, b, c), f = f.sibling;
                $a9f996f354cff77e$var$V = e;
                $a9f996f354cff77e$var$Kj = h;
                $a9f996f354cff77e$var$U = l;
            }
            $a9f996f354cff77e$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $a9f996f354cff77e$var$V = f) : $a9f996f354cff77e$var$lk(a, b, c);
    }
}
function $a9f996f354cff77e$var$lk(a) {
    for(; null !== $a9f996f354cff77e$var$V;){
        var b = $a9f996f354cff77e$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $a9f996f354cff77e$var$U || $a9f996f354cff77e$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$a9f996f354cff77e$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $a9f996f354cff77e$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $a9f996f354cff77e$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $a9f996f354cff77e$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $a9f996f354cff77e$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($a9f996f354cff77e$var$p(163));
                }
                $a9f996f354cff77e$var$U || b.flags & 512 && $a9f996f354cff77e$var$Sj(b);
            } catch (r) {
                $a9f996f354cff77e$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $a9f996f354cff77e$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a9f996f354cff77e$var$V = c;
            break;
        }
        $a9f996f354cff77e$var$V = b.return;
    }
}
function $a9f996f354cff77e$var$hk(a) {
    for(; null !== $a9f996f354cff77e$var$V;){
        var b = $a9f996f354cff77e$var$V;
        if (b === a) {
            $a9f996f354cff77e$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a9f996f354cff77e$var$V = c;
            break;
        }
        $a9f996f354cff77e$var$V = b.return;
    }
}
function $a9f996f354cff77e$var$kk(a) {
    for(; null !== $a9f996f354cff77e$var$V;){
        var b = $a9f996f354cff77e$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $a9f996f354cff77e$var$Rj(4, b);
                    } catch (k) {
                        $a9f996f354cff77e$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $a9f996f354cff77e$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $a9f996f354cff77e$var$Sj(b);
                    } catch (k) {
                        $a9f996f354cff77e$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $a9f996f354cff77e$var$Sj(b);
                    } catch (k) {
                        $a9f996f354cff77e$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $a9f996f354cff77e$var$W(b, b.return, k);
        }
        if (b === a) {
            $a9f996f354cff77e$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $a9f996f354cff77e$var$V = h;
            break;
        }
        $a9f996f354cff77e$var$V = b.return;
    }
}
var $a9f996f354cff77e$var$mk = Math.ceil, $a9f996f354cff77e$var$nk = $a9f996f354cff77e$var$ua.ReactCurrentDispatcher, $a9f996f354cff77e$var$ok = $a9f996f354cff77e$var$ua.ReactCurrentOwner, $a9f996f354cff77e$var$pk = $a9f996f354cff77e$var$ua.ReactCurrentBatchConfig, $a9f996f354cff77e$var$K = 0, $a9f996f354cff77e$var$R = null, $a9f996f354cff77e$var$Y = null, $a9f996f354cff77e$var$Z = 0, $a9f996f354cff77e$var$gj = 0, $a9f996f354cff77e$var$fj = $a9f996f354cff77e$var$Uf(0), $a9f996f354cff77e$var$T = 0, $a9f996f354cff77e$var$qk = null, $a9f996f354cff77e$var$hh = 0, $a9f996f354cff77e$var$rk = 0, $a9f996f354cff77e$var$sk = 0, $a9f996f354cff77e$var$tk = null, $a9f996f354cff77e$var$uk = null, $a9f996f354cff77e$var$gk = 0, $a9f996f354cff77e$var$Hj = Infinity, $a9f996f354cff77e$var$vk = null, $a9f996f354cff77e$var$Pi = !1, $a9f996f354cff77e$var$Qi = null, $a9f996f354cff77e$var$Si = null, $a9f996f354cff77e$var$wk = !1, $a9f996f354cff77e$var$xk = null, $a9f996f354cff77e$var$yk = 0, $a9f996f354cff77e$var$zk = 0, $a9f996f354cff77e$var$Ak = null, $a9f996f354cff77e$var$Bk = -1, $a9f996f354cff77e$var$Ck = 0;
function $a9f996f354cff77e$var$L() {
    return 0 !== ($a9f996f354cff77e$var$K & 6) ? $a9f996f354cff77e$var$B() : -1 !== $a9f996f354cff77e$var$Bk ? $a9f996f354cff77e$var$Bk : $a9f996f354cff77e$var$Bk = $a9f996f354cff77e$var$B();
}
function $a9f996f354cff77e$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($a9f996f354cff77e$var$K & 2) && 0 !== $a9f996f354cff77e$var$Z) return $a9f996f354cff77e$var$Z & -$a9f996f354cff77e$var$Z;
    if (null !== $a9f996f354cff77e$var$Kg.transition) return 0 === $a9f996f354cff77e$var$Ck && ($a9f996f354cff77e$var$Ck = $a9f996f354cff77e$var$yc()), $a9f996f354cff77e$var$Ck;
    a = $a9f996f354cff77e$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $a9f996f354cff77e$var$jd(a.type);
    return a;
}
function $a9f996f354cff77e$var$mh(a, b, c, d) {
    if (50 < $a9f996f354cff77e$var$zk) throw $a9f996f354cff77e$var$zk = 0, $a9f996f354cff77e$var$Ak = null, Error($a9f996f354cff77e$var$p(185));
    $a9f996f354cff77e$var$Ac(a, c, d);
    if (0 === ($a9f996f354cff77e$var$K & 2) || a !== $a9f996f354cff77e$var$R) a === $a9f996f354cff77e$var$R && (0 === ($a9f996f354cff77e$var$K & 2) && ($a9f996f354cff77e$var$rk |= c), 4 === $a9f996f354cff77e$var$T && $a9f996f354cff77e$var$Dk(a, $a9f996f354cff77e$var$Z)), $a9f996f354cff77e$var$Ek(a, d), 1 === c && 0 === $a9f996f354cff77e$var$K && 0 === (b.mode & 1) && ($a9f996f354cff77e$var$Hj = $a9f996f354cff77e$var$B() + 500, $a9f996f354cff77e$var$fg && $a9f996f354cff77e$var$jg());
}
function $a9f996f354cff77e$var$Ek(a, b) {
    var c = a.callbackNode;
    $a9f996f354cff77e$var$wc(a, b);
    var d = $a9f996f354cff77e$var$uc(a, a === $a9f996f354cff77e$var$R ? $a9f996f354cff77e$var$Z : 0);
    if (0 === d) null !== c && $a9f996f354cff77e$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $a9f996f354cff77e$var$bc(c);
        if (1 === b) 0 === a.tag ? $a9f996f354cff77e$var$ig($a9f996f354cff77e$var$Fk.bind(null, a)) : $a9f996f354cff77e$var$hg($a9f996f354cff77e$var$Fk.bind(null, a)), $a9f996f354cff77e$var$Jf(function() {
            0 === ($a9f996f354cff77e$var$K & 6) && $a9f996f354cff77e$var$jg();
        }), c = null;
        else {
            switch($a9f996f354cff77e$var$Dc(d)){
                case 1:
                    c = $a9f996f354cff77e$var$fc;
                    break;
                case 4:
                    c = $a9f996f354cff77e$var$gc;
                    break;
                case 16:
                    c = $a9f996f354cff77e$var$hc;
                    break;
                case 536870912:
                    c = $a9f996f354cff77e$var$jc;
                    break;
                default:
                    c = $a9f996f354cff77e$var$hc;
            }
            c = $a9f996f354cff77e$var$Gk(c, $a9f996f354cff77e$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $a9f996f354cff77e$var$Hk(a, b) {
    $a9f996f354cff77e$var$Bk = -1;
    $a9f996f354cff77e$var$Ck = 0;
    if (0 !== ($a9f996f354cff77e$var$K & 6)) throw Error($a9f996f354cff77e$var$p(327));
    var c = a.callbackNode;
    if ($a9f996f354cff77e$var$Ik() && a.callbackNode !== c) return null;
    var d = $a9f996f354cff77e$var$uc(a, a === $a9f996f354cff77e$var$R ? $a9f996f354cff77e$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $a9f996f354cff77e$var$Jk(a, d);
    else {
        b = d;
        var e = $a9f996f354cff77e$var$K;
        $a9f996f354cff77e$var$K |= 2;
        var f = $a9f996f354cff77e$var$Kk();
        if ($a9f996f354cff77e$var$R !== a || $a9f996f354cff77e$var$Z !== b) $a9f996f354cff77e$var$vk = null, $a9f996f354cff77e$var$Hj = $a9f996f354cff77e$var$B() + 500, $a9f996f354cff77e$var$Lk(a, b);
        for(;;)try {
            $a9f996f354cff77e$var$Mk();
            break;
        } catch (h) {
            $a9f996f354cff77e$var$Nk(a, h);
        }
        $a9f996f354cff77e$var$Qg();
        $a9f996f354cff77e$var$nk.current = f;
        $a9f996f354cff77e$var$K = e;
        null !== $a9f996f354cff77e$var$Y ? b = 0 : ($a9f996f354cff77e$var$R = null, $a9f996f354cff77e$var$Z = 0, b = $a9f996f354cff77e$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $a9f996f354cff77e$var$xc(a), 0 !== e && (d = e, b = $a9f996f354cff77e$var$Ok(a, e)));
        if (1 === b) throw c = $a9f996f354cff77e$var$qk, $a9f996f354cff77e$var$Lk(a, 0), $a9f996f354cff77e$var$Dk(a, d), $a9f996f354cff77e$var$Ek(a, $a9f996f354cff77e$var$B()), c;
        if (6 === b) $a9f996f354cff77e$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$a9f996f354cff77e$var$Pk(e) && (b = $a9f996f354cff77e$var$Jk(a, d), 2 === b && (f = $a9f996f354cff77e$var$xc(a), 0 !== f && (d = f, b = $a9f996f354cff77e$var$Ok(a, f))), 1 === b)) throw c = $a9f996f354cff77e$var$qk, $a9f996f354cff77e$var$Lk(a, 0), $a9f996f354cff77e$var$Dk(a, d), $a9f996f354cff77e$var$Ek(a, $a9f996f354cff77e$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($a9f996f354cff77e$var$p(345));
                case 2:
                    $a9f996f354cff77e$var$Qk(a, $a9f996f354cff77e$var$uk, $a9f996f354cff77e$var$vk);
                    break;
                case 3:
                    $a9f996f354cff77e$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $a9f996f354cff77e$var$gk + 500 - $a9f996f354cff77e$var$B(), 10 < b)) {
                        if (0 !== $a9f996f354cff77e$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $a9f996f354cff77e$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $a9f996f354cff77e$var$Ff($a9f996f354cff77e$var$Qk.bind(null, a, $a9f996f354cff77e$var$uk, $a9f996f354cff77e$var$vk), b);
                        break;
                    }
                    $a9f996f354cff77e$var$Qk(a, $a9f996f354cff77e$var$uk, $a9f996f354cff77e$var$vk);
                    break;
                case 4:
                    $a9f996f354cff77e$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $a9f996f354cff77e$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $a9f996f354cff77e$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $a9f996f354cff77e$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $a9f996f354cff77e$var$Ff($a9f996f354cff77e$var$Qk.bind(null, a, $a9f996f354cff77e$var$uk, $a9f996f354cff77e$var$vk), d);
                        break;
                    }
                    $a9f996f354cff77e$var$Qk(a, $a9f996f354cff77e$var$uk, $a9f996f354cff77e$var$vk);
                    break;
                case 5:
                    $a9f996f354cff77e$var$Qk(a, $a9f996f354cff77e$var$uk, $a9f996f354cff77e$var$vk);
                    break;
                default:
                    throw Error($a9f996f354cff77e$var$p(329));
            }
        }
    }
    $a9f996f354cff77e$var$Ek(a, $a9f996f354cff77e$var$B());
    return a.callbackNode === c ? $a9f996f354cff77e$var$Hk.bind(null, a) : null;
}
function $a9f996f354cff77e$var$Ok(a, b) {
    var c = $a9f996f354cff77e$var$tk;
    a.current.memoizedState.isDehydrated && ($a9f996f354cff77e$var$Lk(a, b).flags |= 256);
    a = $a9f996f354cff77e$var$Jk(a, b);
    2 !== a && (b = $a9f996f354cff77e$var$uk, $a9f996f354cff77e$var$uk = c, null !== b && $a9f996f354cff77e$var$Gj(b));
    return a;
}
function $a9f996f354cff77e$var$Gj(a) {
    null === $a9f996f354cff77e$var$uk ? $a9f996f354cff77e$var$uk = a : $a9f996f354cff77e$var$uk.push.apply($a9f996f354cff77e$var$uk, a);
}
function $a9f996f354cff77e$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$a9f996f354cff77e$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $a9f996f354cff77e$var$Dk(a, b) {
    b &= ~$a9f996f354cff77e$var$sk;
    b &= ~$a9f996f354cff77e$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $a9f996f354cff77e$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $a9f996f354cff77e$var$Fk(a) {
    if (0 !== ($a9f996f354cff77e$var$K & 6)) throw Error($a9f996f354cff77e$var$p(327));
    $a9f996f354cff77e$var$Ik();
    var b = $a9f996f354cff77e$var$uc(a, 0);
    if (0 === (b & 1)) return $a9f996f354cff77e$var$Ek(a, $a9f996f354cff77e$var$B()), null;
    var c = $a9f996f354cff77e$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $a9f996f354cff77e$var$xc(a);
        0 !== d && (b = d, c = $a9f996f354cff77e$var$Ok(a, d));
    }
    if (1 === c) throw c = $a9f996f354cff77e$var$qk, $a9f996f354cff77e$var$Lk(a, 0), $a9f996f354cff77e$var$Dk(a, b), $a9f996f354cff77e$var$Ek(a, $a9f996f354cff77e$var$B()), c;
    if (6 === c) throw Error($a9f996f354cff77e$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $a9f996f354cff77e$var$Qk(a, $a9f996f354cff77e$var$uk, $a9f996f354cff77e$var$vk);
    $a9f996f354cff77e$var$Ek(a, $a9f996f354cff77e$var$B());
    return null;
}
function $a9f996f354cff77e$var$Rk(a, b) {
    var c = $a9f996f354cff77e$var$K;
    $a9f996f354cff77e$var$K |= 1;
    try {
        return a(b);
    } finally{
        $a9f996f354cff77e$var$K = c, 0 === $a9f996f354cff77e$var$K && ($a9f996f354cff77e$var$Hj = $a9f996f354cff77e$var$B() + 500, $a9f996f354cff77e$var$fg && $a9f996f354cff77e$var$jg());
    }
}
function $a9f996f354cff77e$var$Sk(a) {
    null !== $a9f996f354cff77e$var$xk && 0 === $a9f996f354cff77e$var$xk.tag && 0 === ($a9f996f354cff77e$var$K & 6) && $a9f996f354cff77e$var$Ik();
    var b = $a9f996f354cff77e$var$K;
    $a9f996f354cff77e$var$K |= 1;
    var c = $a9f996f354cff77e$var$pk.transition, d = $a9f996f354cff77e$var$C;
    try {
        if ($a9f996f354cff77e$var$pk.transition = null, $a9f996f354cff77e$var$C = 1, a) return a();
    } finally{
        $a9f996f354cff77e$var$C = d, $a9f996f354cff77e$var$pk.transition = c, $a9f996f354cff77e$var$K = b, 0 === ($a9f996f354cff77e$var$K & 6) && $a9f996f354cff77e$var$jg();
    }
}
function $a9f996f354cff77e$var$Ij() {
    $a9f996f354cff77e$var$gj = $a9f996f354cff77e$var$fj.current;
    $a9f996f354cff77e$var$E($a9f996f354cff77e$var$fj);
}
function $a9f996f354cff77e$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $a9f996f354cff77e$var$Gf(c));
    if (null !== $a9f996f354cff77e$var$Y) for(c = $a9f996f354cff77e$var$Y.return; null !== c;){
        var d = c;
        $a9f996f354cff77e$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $a9f996f354cff77e$var$$f();
                break;
            case 3:
                $a9f996f354cff77e$var$Jh();
                $a9f996f354cff77e$var$E($a9f996f354cff77e$var$Wf);
                $a9f996f354cff77e$var$E($a9f996f354cff77e$var$H);
                $a9f996f354cff77e$var$Oh();
                break;
            case 5:
                $a9f996f354cff77e$var$Lh(d);
                break;
            case 4:
                $a9f996f354cff77e$var$Jh();
                break;
            case 13:
                $a9f996f354cff77e$var$E($a9f996f354cff77e$var$M);
                break;
            case 19:
                $a9f996f354cff77e$var$E($a9f996f354cff77e$var$M);
                break;
            case 10:
                $a9f996f354cff77e$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $a9f996f354cff77e$var$Ij();
        }
        c = c.return;
    }
    $a9f996f354cff77e$var$R = a;
    $a9f996f354cff77e$var$Y = a = $a9f996f354cff77e$var$wh(a.current, null);
    $a9f996f354cff77e$var$Z = $a9f996f354cff77e$var$gj = b;
    $a9f996f354cff77e$var$T = 0;
    $a9f996f354cff77e$var$qk = null;
    $a9f996f354cff77e$var$sk = $a9f996f354cff77e$var$rk = $a9f996f354cff77e$var$hh = 0;
    $a9f996f354cff77e$var$uk = $a9f996f354cff77e$var$tk = null;
    if (null !== $a9f996f354cff77e$var$Wg) {
        for(b = 0; b < $a9f996f354cff77e$var$Wg.length; b++)if (c = $a9f996f354cff77e$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $a9f996f354cff77e$var$Wg = null;
    }
    return a;
}
function $a9f996f354cff77e$var$Nk(a, b) {
    do {
        var c = $a9f996f354cff77e$var$Y;
        try {
            $a9f996f354cff77e$var$Qg();
            $a9f996f354cff77e$var$Ph.current = $a9f996f354cff77e$var$ai;
            if ($a9f996f354cff77e$var$Sh) {
                for(var d = $a9f996f354cff77e$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $a9f996f354cff77e$var$Sh = !1;
            }
            $a9f996f354cff77e$var$Rh = 0;
            $a9f996f354cff77e$var$P = $a9f996f354cff77e$var$O = $a9f996f354cff77e$var$N = null;
            $a9f996f354cff77e$var$Th = !1;
            $a9f996f354cff77e$var$Uh = 0;
            $a9f996f354cff77e$var$ok.current = null;
            if (null === c || null === c.return) {
                $a9f996f354cff77e$var$T = 1;
                $a9f996f354cff77e$var$qk = b;
                $a9f996f354cff77e$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $a9f996f354cff77e$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $a9f996f354cff77e$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $a9f996f354cff77e$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $a9f996f354cff77e$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $a9f996f354cff77e$var$Ti(f, l, b);
                            $a9f996f354cff77e$var$uj();
                            break a;
                        }
                        k = Error($a9f996f354cff77e$var$p(426));
                    }
                } else if ($a9f996f354cff77e$var$I && h.mode & 1) {
                    var J = $a9f996f354cff77e$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $a9f996f354cff77e$var$Wi(J, g, h, f, b);
                        $a9f996f354cff77e$var$Jg($a9f996f354cff77e$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $a9f996f354cff77e$var$Ki(k, h);
                4 !== $a9f996f354cff77e$var$T && ($a9f996f354cff77e$var$T = 2);
                null === $a9f996f354cff77e$var$tk ? $a9f996f354cff77e$var$tk = [
                    f
                ] : $a9f996f354cff77e$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $a9f996f354cff77e$var$Oi(f, k, b);
                            $a9f996f354cff77e$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $a9f996f354cff77e$var$Si || !$a9f996f354cff77e$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $a9f996f354cff77e$var$Ri(f, h, b);
                                $a9f996f354cff77e$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $a9f996f354cff77e$var$Tk(c);
        } catch (na) {
            b = na;
            $a9f996f354cff77e$var$Y === c && null !== c && ($a9f996f354cff77e$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $a9f996f354cff77e$var$Kk() {
    var a = $a9f996f354cff77e$var$nk.current;
    $a9f996f354cff77e$var$nk.current = $a9f996f354cff77e$var$ai;
    return null === a ? $a9f996f354cff77e$var$ai : a;
}
function $a9f996f354cff77e$var$uj() {
    if (0 === $a9f996f354cff77e$var$T || 3 === $a9f996f354cff77e$var$T || 2 === $a9f996f354cff77e$var$T) $a9f996f354cff77e$var$T = 4;
    null === $a9f996f354cff77e$var$R || 0 === ($a9f996f354cff77e$var$hh & 268435455) && 0 === ($a9f996f354cff77e$var$rk & 268435455) || $a9f996f354cff77e$var$Dk($a9f996f354cff77e$var$R, $a9f996f354cff77e$var$Z);
}
function $a9f996f354cff77e$var$Jk(a, b) {
    var c = $a9f996f354cff77e$var$K;
    $a9f996f354cff77e$var$K |= 2;
    var d = $a9f996f354cff77e$var$Kk();
    if ($a9f996f354cff77e$var$R !== a || $a9f996f354cff77e$var$Z !== b) $a9f996f354cff77e$var$vk = null, $a9f996f354cff77e$var$Lk(a, b);
    for(;;)try {
        $a9f996f354cff77e$var$Uk();
        break;
    } catch (e) {
        $a9f996f354cff77e$var$Nk(a, e);
    }
    $a9f996f354cff77e$var$Qg();
    $a9f996f354cff77e$var$K = c;
    $a9f996f354cff77e$var$nk.current = d;
    if (null !== $a9f996f354cff77e$var$Y) throw Error($a9f996f354cff77e$var$p(261));
    $a9f996f354cff77e$var$R = null;
    $a9f996f354cff77e$var$Z = 0;
    return $a9f996f354cff77e$var$T;
}
function $a9f996f354cff77e$var$Uk() {
    for(; null !== $a9f996f354cff77e$var$Y;)$a9f996f354cff77e$var$Vk($a9f996f354cff77e$var$Y);
}
function $a9f996f354cff77e$var$Mk() {
    for(; null !== $a9f996f354cff77e$var$Y && !$a9f996f354cff77e$var$cc();)$a9f996f354cff77e$var$Vk($a9f996f354cff77e$var$Y);
}
function $a9f996f354cff77e$var$Vk(a) {
    var b = $a9f996f354cff77e$var$Wk(a.alternate, a, $a9f996f354cff77e$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $a9f996f354cff77e$var$Tk(a) : $a9f996f354cff77e$var$Y = b;
    $a9f996f354cff77e$var$ok.current = null;
}
function $a9f996f354cff77e$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $a9f996f354cff77e$var$Fj(c, b, $a9f996f354cff77e$var$gj), null !== c) {
                $a9f996f354cff77e$var$Y = c;
                return;
            }
        } else {
            c = $a9f996f354cff77e$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $a9f996f354cff77e$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $a9f996f354cff77e$var$T = 6;
                $a9f996f354cff77e$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $a9f996f354cff77e$var$Y = b;
            return;
        }
        $a9f996f354cff77e$var$Y = b = a;
    }while (null !== b);
    0 === $a9f996f354cff77e$var$T && ($a9f996f354cff77e$var$T = 5);
}
function $a9f996f354cff77e$var$Qk(a, b, c) {
    var d = $a9f996f354cff77e$var$C, e = $a9f996f354cff77e$var$pk.transition;
    try {
        $a9f996f354cff77e$var$pk.transition = null, $a9f996f354cff77e$var$C = 1, $a9f996f354cff77e$var$Xk(a, b, c, d);
    } finally{
        $a9f996f354cff77e$var$pk.transition = e, $a9f996f354cff77e$var$C = d;
    }
    return null;
}
function $a9f996f354cff77e$var$Xk(a, b, c, d) {
    do $a9f996f354cff77e$var$Ik();
    while (null !== $a9f996f354cff77e$var$xk);
    if (0 !== ($a9f996f354cff77e$var$K & 6)) throw Error($a9f996f354cff77e$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($a9f996f354cff77e$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $a9f996f354cff77e$var$Bc(a, f);
    a === $a9f996f354cff77e$var$R && ($a9f996f354cff77e$var$Y = $a9f996f354cff77e$var$R = null, $a9f996f354cff77e$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $a9f996f354cff77e$var$wk || ($a9f996f354cff77e$var$wk = !0, $a9f996f354cff77e$var$Gk($a9f996f354cff77e$var$hc, function() {
        $a9f996f354cff77e$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $a9f996f354cff77e$var$pk.transition;
        $a9f996f354cff77e$var$pk.transition = null;
        var g = $a9f996f354cff77e$var$C;
        $a9f996f354cff77e$var$C = 1;
        var h = $a9f996f354cff77e$var$K;
        $a9f996f354cff77e$var$K |= 4;
        $a9f996f354cff77e$var$ok.current = null;
        $a9f996f354cff77e$var$Pj(a, c);
        $a9f996f354cff77e$var$ek(c, a);
        $a9f996f354cff77e$var$Oe($a9f996f354cff77e$var$Df);
        $a9f996f354cff77e$var$dd = !!$a9f996f354cff77e$var$Cf;
        $a9f996f354cff77e$var$Df = $a9f996f354cff77e$var$Cf = null;
        a.current = c;
        $a9f996f354cff77e$var$ik(c, a, e);
        $a9f996f354cff77e$var$dc();
        $a9f996f354cff77e$var$K = h;
        $a9f996f354cff77e$var$C = g;
        $a9f996f354cff77e$var$pk.transition = f;
    } else a.current = c;
    $a9f996f354cff77e$var$wk && ($a9f996f354cff77e$var$wk = !1, $a9f996f354cff77e$var$xk = a, $a9f996f354cff77e$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($a9f996f354cff77e$var$Si = null);
    $a9f996f354cff77e$var$mc(c.stateNode, d);
    $a9f996f354cff77e$var$Ek(a, $a9f996f354cff77e$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($a9f996f354cff77e$var$Pi) throw $a9f996f354cff77e$var$Pi = !1, a = $a9f996f354cff77e$var$Qi, $a9f996f354cff77e$var$Qi = null, a;
    0 !== ($a9f996f354cff77e$var$yk & 1) && 0 !== a.tag && $a9f996f354cff77e$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $a9f996f354cff77e$var$Ak ? $a9f996f354cff77e$var$zk++ : ($a9f996f354cff77e$var$zk = 0, $a9f996f354cff77e$var$Ak = a) : $a9f996f354cff77e$var$zk = 0;
    $a9f996f354cff77e$var$jg();
    return null;
}
function $a9f996f354cff77e$var$Ik() {
    if (null !== $a9f996f354cff77e$var$xk) {
        var a = $a9f996f354cff77e$var$Dc($a9f996f354cff77e$var$yk), b = $a9f996f354cff77e$var$pk.transition, c = $a9f996f354cff77e$var$C;
        try {
            $a9f996f354cff77e$var$pk.transition = null;
            $a9f996f354cff77e$var$C = 16 > a ? 16 : a;
            if (null === $a9f996f354cff77e$var$xk) var d = !1;
            else {
                a = $a9f996f354cff77e$var$xk;
                $a9f996f354cff77e$var$xk = null;
                $a9f996f354cff77e$var$yk = 0;
                if (0 !== ($a9f996f354cff77e$var$K & 6)) throw Error($a9f996f354cff77e$var$p(331));
                var e = $a9f996f354cff77e$var$K;
                $a9f996f354cff77e$var$K |= 4;
                for($a9f996f354cff77e$var$V = a.current; null !== $a9f996f354cff77e$var$V;){
                    var f = $a9f996f354cff77e$var$V, g = f.child;
                    if (0 !== ($a9f996f354cff77e$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($a9f996f354cff77e$var$V = l; null !== $a9f996f354cff77e$var$V;){
                                    var m = $a9f996f354cff77e$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $a9f996f354cff77e$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $a9f996f354cff77e$var$V = q;
                                    else for(; null !== $a9f996f354cff77e$var$V;){
                                        m = $a9f996f354cff77e$var$V;
                                        var r = m.sibling, y = m.return;
                                        $a9f996f354cff77e$var$Tj(m);
                                        if (m === l) {
                                            $a9f996f354cff77e$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $a9f996f354cff77e$var$V = r;
                                            break;
                                        }
                                        $a9f996f354cff77e$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $a9f996f354cff77e$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $a9f996f354cff77e$var$V = g;
                    else b: for(; null !== $a9f996f354cff77e$var$V;){
                        f = $a9f996f354cff77e$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $a9f996f354cff77e$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $a9f996f354cff77e$var$V = x;
                            break b;
                        }
                        $a9f996f354cff77e$var$V = f.return;
                    }
                }
                var w = a.current;
                for($a9f996f354cff77e$var$V = w; null !== $a9f996f354cff77e$var$V;){
                    g = $a9f996f354cff77e$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $a9f996f354cff77e$var$V = u;
                    else b: for(g = w; null !== $a9f996f354cff77e$var$V;){
                        h = $a9f996f354cff77e$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $a9f996f354cff77e$var$Rj(9, h);
                            }
                        } catch (na) {
                            $a9f996f354cff77e$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $a9f996f354cff77e$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $a9f996f354cff77e$var$V = F;
                            break b;
                        }
                        $a9f996f354cff77e$var$V = h.return;
                    }
                }
                $a9f996f354cff77e$var$K = e;
                $a9f996f354cff77e$var$jg();
                if ($a9f996f354cff77e$var$lc && "function" === typeof $a9f996f354cff77e$var$lc.onPostCommitFiberRoot) try {
                    $a9f996f354cff77e$var$lc.onPostCommitFiberRoot($a9f996f354cff77e$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $a9f996f354cff77e$var$C = c, $a9f996f354cff77e$var$pk.transition = b;
        }
    }
    return !1;
}
function $a9f996f354cff77e$var$Yk(a, b, c) {
    b = $a9f996f354cff77e$var$Ki(c, b);
    b = $a9f996f354cff77e$var$Oi(a, b, 1);
    a = $a9f996f354cff77e$var$dh(a, b, 1);
    b = $a9f996f354cff77e$var$L();
    null !== a && ($a9f996f354cff77e$var$Ac(a, 1, b), $a9f996f354cff77e$var$Ek(a, b));
}
function $a9f996f354cff77e$var$W(a, b, c) {
    if (3 === a.tag) $a9f996f354cff77e$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $a9f996f354cff77e$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $a9f996f354cff77e$var$Si || !$a9f996f354cff77e$var$Si.has(d))) {
                a = $a9f996f354cff77e$var$Ki(c, a);
                a = $a9f996f354cff77e$var$Ri(b, a, 1);
                b = $a9f996f354cff77e$var$dh(b, a, 1);
                a = $a9f996f354cff77e$var$L();
                null !== b && ($a9f996f354cff77e$var$Ac(b, 1, a), $a9f996f354cff77e$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $a9f996f354cff77e$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $a9f996f354cff77e$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $a9f996f354cff77e$var$R === a && ($a9f996f354cff77e$var$Z & c) === c && (4 === $a9f996f354cff77e$var$T || 3 === $a9f996f354cff77e$var$T && ($a9f996f354cff77e$var$Z & 130023424) === $a9f996f354cff77e$var$Z && 500 > $a9f996f354cff77e$var$B() - $a9f996f354cff77e$var$gk ? $a9f996f354cff77e$var$Lk(a, 0) : $a9f996f354cff77e$var$sk |= c);
    $a9f996f354cff77e$var$Ek(a, b);
}
function $a9f996f354cff77e$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $a9f996f354cff77e$var$sc, $a9f996f354cff77e$var$sc <<= 1, 0 === ($a9f996f354cff77e$var$sc & 130023424) && ($a9f996f354cff77e$var$sc = 4194304)));
    var c = $a9f996f354cff77e$var$L();
    a = $a9f996f354cff77e$var$Zg(a, b);
    null !== a && ($a9f996f354cff77e$var$Ac(a, b, c), $a9f996f354cff77e$var$Ek(a, c));
}
function $a9f996f354cff77e$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $a9f996f354cff77e$var$Zk(a, c);
}
function $a9f996f354cff77e$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($a9f996f354cff77e$var$p(314));
    }
    null !== d && d.delete(b);
    $a9f996f354cff77e$var$Zk(a, c);
}
var $a9f996f354cff77e$var$Wk;
$a9f996f354cff77e$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $a9f996f354cff77e$var$Wf.current) $a9f996f354cff77e$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $a9f996f354cff77e$var$Ug = !1, $a9f996f354cff77e$var$zj(a, b, c);
            $a9f996f354cff77e$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $a9f996f354cff77e$var$Ug = !1, $a9f996f354cff77e$var$I && 0 !== (b.flags & 1048576) && $a9f996f354cff77e$var$ug(b, $a9f996f354cff77e$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $a9f996f354cff77e$var$jj(a, b);
            a = b.pendingProps;
            var e = $a9f996f354cff77e$var$Yf(b, $a9f996f354cff77e$var$H.current);
            $a9f996f354cff77e$var$Tg(b, c);
            e = $a9f996f354cff77e$var$Xh(null, b, d, a, e, c);
            var f = $a9f996f354cff77e$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $a9f996f354cff77e$var$Zf(d) ? (f = !0, $a9f996f354cff77e$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $a9f996f354cff77e$var$ah(b), e.updater = $a9f996f354cff77e$var$nh, b.stateNode = e, e._reactInternals = b, $a9f996f354cff77e$var$rh(b, d, a, c), b = $a9f996f354cff77e$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $a9f996f354cff77e$var$I && f && $a9f996f354cff77e$var$vg(b), $a9f996f354cff77e$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $a9f996f354cff77e$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $a9f996f354cff77e$var$$k(d);
                a = $a9f996f354cff77e$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $a9f996f354cff77e$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $a9f996f354cff77e$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $a9f996f354cff77e$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $a9f996f354cff77e$var$aj(null, b, d, $a9f996f354cff77e$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($a9f996f354cff77e$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a9f996f354cff77e$var$Lg(d, e), $a9f996f354cff77e$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a9f996f354cff77e$var$Lg(d, e), $a9f996f354cff77e$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $a9f996f354cff77e$var$lj(b);
                if (null === a) throw Error($a9f996f354cff77e$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $a9f996f354cff77e$var$bh(a, b);
                $a9f996f354cff77e$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $a9f996f354cff77e$var$Ki(Error($a9f996f354cff77e$var$p(423)), b);
                        b = $a9f996f354cff77e$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $a9f996f354cff77e$var$Ki(Error($a9f996f354cff77e$var$p(424)), b);
                        b = $a9f996f354cff77e$var$mj(a, b, d, c, e);
                        break a;
                    } else for($a9f996f354cff77e$var$yg = $a9f996f354cff77e$var$Lf(b.stateNode.containerInfo.firstChild), $a9f996f354cff77e$var$xg = b, $a9f996f354cff77e$var$I = !0, $a9f996f354cff77e$var$zg = null, c = $a9f996f354cff77e$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $a9f996f354cff77e$var$Ig();
                    if (d === e) {
                        b = $a9f996f354cff77e$var$$i(a, b, c);
                        break a;
                    }
                    $a9f996f354cff77e$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $a9f996f354cff77e$var$Kh(b), null === a && $a9f996f354cff77e$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $a9f996f354cff77e$var$Ef(d, e) ? g = null : null !== f && $a9f996f354cff77e$var$Ef(d, f) && (b.flags |= 32), $a9f996f354cff77e$var$hj(a, b), $a9f996f354cff77e$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $a9f996f354cff77e$var$Eg(b), null;
        case 13:
            return $a9f996f354cff77e$var$pj(a, b, c);
        case 4:
            return $a9f996f354cff77e$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $a9f996f354cff77e$var$Bh(b, null, d, c) : $a9f996f354cff77e$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a9f996f354cff77e$var$Lg(d, e), $a9f996f354cff77e$var$Zi(a, b, d, e, c);
        case 7:
            return $a9f996f354cff77e$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $a9f996f354cff77e$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $a9f996f354cff77e$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $a9f996f354cff77e$var$G($a9f996f354cff77e$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($a9f996f354cff77e$var$He(f.value, g)) {
                        if (f.children === e.children && !$a9f996f354cff77e$var$Wf.current) {
                            b = $a9f996f354cff77e$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $a9f996f354cff77e$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $a9f996f354cff77e$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($a9f996f354cff77e$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $a9f996f354cff77e$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $a9f996f354cff77e$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $a9f996f354cff77e$var$Tg(b, c), e = $a9f996f354cff77e$var$Vg(e), d = d(e), b.flags |= 1, $a9f996f354cff77e$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $a9f996f354cff77e$var$Lg(d, b.pendingProps), e = $a9f996f354cff77e$var$Lg(d.type, e), $a9f996f354cff77e$var$aj(a, b, d, e, c);
        case 15:
            return $a9f996f354cff77e$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a9f996f354cff77e$var$Lg(d, e), $a9f996f354cff77e$var$jj(a, b), b.tag = 1, $a9f996f354cff77e$var$Zf(d) ? (a = !0, $a9f996f354cff77e$var$cg(b)) : a = !1, $a9f996f354cff77e$var$Tg(b, c), $a9f996f354cff77e$var$ph(b, d, e), $a9f996f354cff77e$var$rh(b, d, e, c), $a9f996f354cff77e$var$kj(null, b, d, !0, a, c);
        case 19:
            return $a9f996f354cff77e$var$yj(a, b, c);
        case 22:
            return $a9f996f354cff77e$var$ej(a, b, c);
    }
    throw Error($a9f996f354cff77e$var$p(156, b.tag));
};
function $a9f996f354cff77e$var$Gk(a, b) {
    return $a9f996f354cff77e$var$ac(a, b);
}
function $a9f996f354cff77e$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a9f996f354cff77e$var$Bg(a, b, c, d) {
    return new $a9f996f354cff77e$var$al(a, b, c, d);
}
function $a9f996f354cff77e$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $a9f996f354cff77e$var$$k(a) {
    if ("function" === typeof a) return $a9f996f354cff77e$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $a9f996f354cff77e$var$Da) return 11;
        if (a === $a9f996f354cff77e$var$Ga) return 14;
    }
    return 2;
}
function $a9f996f354cff77e$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $a9f996f354cff77e$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $a9f996f354cff77e$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $a9f996f354cff77e$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $a9f996f354cff77e$var$ya:
            return $a9f996f354cff77e$var$Ah(c.children, e, f, b);
        case $a9f996f354cff77e$var$za:
            g = 8;
            e |= 8;
            break;
        case $a9f996f354cff77e$var$Aa:
            return a = $a9f996f354cff77e$var$Bg(12, c, b, e | 2), a.elementType = $a9f996f354cff77e$var$Aa, a.lanes = f, a;
        case $a9f996f354cff77e$var$Ea:
            return a = $a9f996f354cff77e$var$Bg(13, c, b, e), a.elementType = $a9f996f354cff77e$var$Ea, a.lanes = f, a;
        case $a9f996f354cff77e$var$Fa:
            return a = $a9f996f354cff77e$var$Bg(19, c, b, e), a.elementType = $a9f996f354cff77e$var$Fa, a.lanes = f, a;
        case $a9f996f354cff77e$var$Ia:
            return $a9f996f354cff77e$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $a9f996f354cff77e$var$Ba:
                    g = 10;
                    break a;
                case $a9f996f354cff77e$var$Ca:
                    g = 9;
                    break a;
                case $a9f996f354cff77e$var$Da:
                    g = 11;
                    break a;
                case $a9f996f354cff77e$var$Ga:
                    g = 14;
                    break a;
                case $a9f996f354cff77e$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($a9f996f354cff77e$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $a9f996f354cff77e$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $a9f996f354cff77e$var$Ah(a, b, c, d) {
    a = $a9f996f354cff77e$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $a9f996f354cff77e$var$qj(a, b, c, d) {
    a = $a9f996f354cff77e$var$Bg(22, a, d, b);
    a.elementType = $a9f996f354cff77e$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $a9f996f354cff77e$var$xh(a, b, c) {
    a = $a9f996f354cff77e$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $a9f996f354cff77e$var$zh(a, b, c) {
    b = $a9f996f354cff77e$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $a9f996f354cff77e$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $a9f996f354cff77e$var$zc(0);
    this.expirationTimes = $a9f996f354cff77e$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a9f996f354cff77e$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $a9f996f354cff77e$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $a9f996f354cff77e$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $a9f996f354cff77e$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $a9f996f354cff77e$var$ah(f);
    return a;
}
function $a9f996f354cff77e$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a9f996f354cff77e$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $a9f996f354cff77e$var$el(a) {
    if (!a) return $a9f996f354cff77e$var$Vf;
    a = a._reactInternals;
    a: {
        if ($a9f996f354cff77e$var$Vb(a) !== a || 1 !== a.tag) throw Error($a9f996f354cff77e$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($a9f996f354cff77e$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($a9f996f354cff77e$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($a9f996f354cff77e$var$Zf(c)) return $a9f996f354cff77e$var$bg(a, c, b);
    }
    return b;
}
function $a9f996f354cff77e$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $a9f996f354cff77e$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $a9f996f354cff77e$var$el(null);
    c = a.current;
    d = $a9f996f354cff77e$var$L();
    e = $a9f996f354cff77e$var$lh(c);
    f = $a9f996f354cff77e$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $a9f996f354cff77e$var$dh(c, f, e);
    a.current.lanes = e;
    $a9f996f354cff77e$var$Ac(a, e, d);
    $a9f996f354cff77e$var$Ek(a, d);
    return a;
}
function $a9f996f354cff77e$var$gl(a, b, c, d) {
    var e = b.current, f = $a9f996f354cff77e$var$L(), g = $a9f996f354cff77e$var$lh(e);
    c = $a9f996f354cff77e$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $a9f996f354cff77e$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $a9f996f354cff77e$var$dh(e, b, g);
    null !== a && ($a9f996f354cff77e$var$mh(a, e, g, f), $a9f996f354cff77e$var$eh(a, e, g));
    return g;
}
function $a9f996f354cff77e$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $a9f996f354cff77e$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $a9f996f354cff77e$var$jl(a, b) {
    $a9f996f354cff77e$var$il(a, b);
    (a = a.alternate) && $a9f996f354cff77e$var$il(a, b);
}
function $a9f996f354cff77e$var$kl() {
    return null;
}
var $a9f996f354cff77e$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $a9f996f354cff77e$var$ml(a) {
    this._internalRoot = a;
}
$a9f996f354cff77e$var$nl.prototype.render = $a9f996f354cff77e$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($a9f996f354cff77e$var$p(409));
    $a9f996f354cff77e$var$gl(a, b, null, null);
};
$a9f996f354cff77e$var$nl.prototype.unmount = $a9f996f354cff77e$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $a9f996f354cff77e$var$Sk(function() {
            $a9f996f354cff77e$var$gl(null, a, null, null);
        });
        b[$a9f996f354cff77e$var$uf] = null;
    }
};
function $a9f996f354cff77e$var$nl(a) {
    this._internalRoot = a;
}
$a9f996f354cff77e$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $a9f996f354cff77e$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $a9f996f354cff77e$var$Qc.length && 0 !== b && b < $a9f996f354cff77e$var$Qc[c].priority; c++);
        $a9f996f354cff77e$var$Qc.splice(c, 0, a);
        0 === c && $a9f996f354cff77e$var$Vc(a);
    }
};
function $a9f996f354cff77e$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $a9f996f354cff77e$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $a9f996f354cff77e$var$ql() {}
function $a9f996f354cff77e$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $a9f996f354cff77e$var$hl(g);
                f.call(a);
            };
        }
        var g = $a9f996f354cff77e$var$fl(b, d, a, 0, null, !1, !1, "", $a9f996f354cff77e$var$ql);
        a._reactRootContainer = g;
        a[$a9f996f354cff77e$var$uf] = g.current;
        $a9f996f354cff77e$var$sf(8 === a.nodeType ? a.parentNode : a);
        $a9f996f354cff77e$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $a9f996f354cff77e$var$hl(k);
            h.call(a);
        };
    }
    var k = $a9f996f354cff77e$var$cl(a, 0, !1, null, null, !1, !1, "", $a9f996f354cff77e$var$ql);
    a._reactRootContainer = k;
    a[$a9f996f354cff77e$var$uf] = k.current;
    $a9f996f354cff77e$var$sf(8 === a.nodeType ? a.parentNode : a);
    $a9f996f354cff77e$var$Sk(function() {
        $a9f996f354cff77e$var$gl(b, k, c, d);
    });
    return k;
}
function $a9f996f354cff77e$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $a9f996f354cff77e$var$hl(g);
                h.call(a);
            };
        }
        $a9f996f354cff77e$var$gl(b, g, a, e);
    } else g = $a9f996f354cff77e$var$rl(c, b, a, e, d);
    return $a9f996f354cff77e$var$hl(g);
}
$a9f996f354cff77e$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $a9f996f354cff77e$var$tc(b.pendingLanes);
                0 !== c && ($a9f996f354cff77e$var$Cc(b, c | 1), $a9f996f354cff77e$var$Ek(b, $a9f996f354cff77e$var$B()), 0 === ($a9f996f354cff77e$var$K & 6) && ($a9f996f354cff77e$var$Hj = $a9f996f354cff77e$var$B() + 500, $a9f996f354cff77e$var$jg()));
            }
            break;
        case 13:
            $a9f996f354cff77e$var$Sk(function() {
                var b = $a9f996f354cff77e$var$Zg(a, 1);
                if (null !== b) {
                    var c = $a9f996f354cff77e$var$L();
                    $a9f996f354cff77e$var$mh(b, a, 1, c);
                }
            }), $a9f996f354cff77e$var$jl(a, 1);
    }
};
$a9f996f354cff77e$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $a9f996f354cff77e$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $a9f996f354cff77e$var$L();
            $a9f996f354cff77e$var$mh(b, a, 134217728, c);
        }
        $a9f996f354cff77e$var$jl(a, 134217728);
    }
};
$a9f996f354cff77e$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $a9f996f354cff77e$var$lh(a), c = $a9f996f354cff77e$var$Zg(a, b);
        if (null !== c) {
            var d = $a9f996f354cff77e$var$L();
            $a9f996f354cff77e$var$mh(c, a, b, d);
        }
        $a9f996f354cff77e$var$jl(a, b);
    }
};
$a9f996f354cff77e$var$Hc = function() {
    return $a9f996f354cff77e$var$C;
};
$a9f996f354cff77e$var$Ic = function(a, b) {
    var c = $a9f996f354cff77e$var$C;
    try {
        return $a9f996f354cff77e$var$C = a, b();
    } finally{
        $a9f996f354cff77e$var$C = c;
    }
};
$a9f996f354cff77e$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $a9f996f354cff77e$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $a9f996f354cff77e$var$Db(d);
                        if (!e) throw Error($a9f996f354cff77e$var$p(90));
                        $a9f996f354cff77e$var$Wa(d);
                        $a9f996f354cff77e$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $a9f996f354cff77e$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $a9f996f354cff77e$var$fb(a, !!c.multiple, b, !1);
    }
};
$a9f996f354cff77e$var$Gb = $a9f996f354cff77e$var$Rk;
$a9f996f354cff77e$var$Hb = $a9f996f354cff77e$var$Sk;
var $a9f996f354cff77e$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $a9f996f354cff77e$var$Cb,
        $a9f996f354cff77e$var$ue,
        $a9f996f354cff77e$var$Db,
        $a9f996f354cff77e$var$Eb,
        $a9f996f354cff77e$var$Fb,
        $a9f996f354cff77e$var$Rk
    ]
}, $a9f996f354cff77e$var$ul = {
    findFiberByHostInstance: $a9f996f354cff77e$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $a9f996f354cff77e$var$vl = {
    bundleType: $a9f996f354cff77e$var$ul.bundleType,
    version: $a9f996f354cff77e$var$ul.version,
    rendererPackageName: $a9f996f354cff77e$var$ul.rendererPackageName,
    rendererConfig: $a9f996f354cff77e$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $a9f996f354cff77e$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $a9f996f354cff77e$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $a9f996f354cff77e$var$ul.findFiberByHostInstance || $a9f996f354cff77e$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a9f996f354cff77e$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a9f996f354cff77e$var$wl.isDisabled && $a9f996f354cff77e$var$wl.supportsFiber) try {
        $a9f996f354cff77e$var$kc = $a9f996f354cff77e$var$wl.inject($a9f996f354cff77e$var$vl), $a9f996f354cff77e$var$lc = $a9f996f354cff77e$var$wl;
    } catch (a) {}
}
$a9f996f354cff77e$export$ae55be85d98224ed = $a9f996f354cff77e$var$tl;
$a9f996f354cff77e$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$a9f996f354cff77e$var$ol(b)) throw Error($a9f996f354cff77e$var$p(200));
    return $a9f996f354cff77e$var$dl(a, b, null, c);
};
$a9f996f354cff77e$export$882461b6382ed46c = function(a, b) {
    if (!$a9f996f354cff77e$var$ol(a)) throw Error($a9f996f354cff77e$var$p(299));
    var c = !1, d = "", e = $a9f996f354cff77e$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $a9f996f354cff77e$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$a9f996f354cff77e$var$uf] = b.current;
    $a9f996f354cff77e$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $a9f996f354cff77e$var$ml(b);
};
$a9f996f354cff77e$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($a9f996f354cff77e$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($a9f996f354cff77e$var$p(268, a));
    }
    a = $a9f996f354cff77e$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$a9f996f354cff77e$export$cd75ccfd720a3cd4 = function(a) {
    return $a9f996f354cff77e$var$Sk(a);
};
$a9f996f354cff77e$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$a9f996f354cff77e$var$pl(b)) throw Error($a9f996f354cff77e$var$p(200));
    return $a9f996f354cff77e$var$sl(null, a, b, !0, c);
};
$a9f996f354cff77e$export$757ceba2d55c277e = function(a, b, c) {
    if (!$a9f996f354cff77e$var$ol(a)) throw Error($a9f996f354cff77e$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $a9f996f354cff77e$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $a9f996f354cff77e$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$a9f996f354cff77e$var$uf] = b.current;
    $a9f996f354cff77e$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $a9f996f354cff77e$var$nl(b);
};
$a9f996f354cff77e$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$a9f996f354cff77e$var$pl(b)) throw Error($a9f996f354cff77e$var$p(200));
    return $a9f996f354cff77e$var$sl(null, a, b, !1, c);
};
$a9f996f354cff77e$export$502457920280e6be = function(a) {
    if (!$a9f996f354cff77e$var$pl(a)) throw Error($a9f996f354cff77e$var$p(40));
    return a._reactRootContainer ? ($a9f996f354cff77e$var$Sk(function() {
        $a9f996f354cff77e$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$a9f996f354cff77e$var$uf] = null;
        });
    }), !0) : !1;
};
$a9f996f354cff77e$export$c78a37762a8d58e1 = $a9f996f354cff77e$var$Rk;
$a9f996f354cff77e$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$a9f996f354cff77e$var$pl(c)) throw Error($a9f996f354cff77e$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($a9f996f354cff77e$var$p(38));
    return $a9f996f354cff77e$var$sl(a, b, c, !1, d);
};
$a9f996f354cff77e$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("8PzWl", function(module, exports) {
"use strict";

module.exports = (parcelRequire("eDAk5"));

});
parcelRegister("eDAk5", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $aa80e22ed743fb40$export$c4744153514ff05d; }, function (v) { return $aa80e22ed743fb40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $aa80e22ed743fb40$export$3e506c1ccc9cc1a7; }, function (v) { return $aa80e22ed743fb40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $aa80e22ed743fb40$export$e26fe2ed2fa76875; }, function (v) { return $aa80e22ed743fb40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $aa80e22ed743fb40$export$502329bbf4b505b1; }, function (v) { return $aa80e22ed743fb40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $aa80e22ed743fb40$export$6e3807111c4874c4; }, function (v) { return $aa80e22ed743fb40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $aa80e22ed743fb40$export$c27134553091fb3a; }, function (v) { return $aa80e22ed743fb40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $aa80e22ed743fb40$export$33ee1acdc04fd2a2; }, function (v) { return $aa80e22ed743fb40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $aa80e22ed743fb40$export$b00a404bbd5edef2; }, function (v) { return $aa80e22ed743fb40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $aa80e22ed743fb40$export$8352ce38b91d0c62; }, function (v) { return $aa80e22ed743fb40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $aa80e22ed743fb40$export$d66a1c1c77bd778b; }, function (v) { return $aa80e22ed743fb40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $aa80e22ed743fb40$export$d3dfb8e4810cb555; }, function (v) { return $aa80e22ed743fb40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $aa80e22ed743fb40$export$839f9183b0465a69; }, function (v) { return $aa80e22ed743fb40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $aa80e22ed743fb40$export$72fdf0e06517287b; }, function (v) { return $aa80e22ed743fb40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $aa80e22ed743fb40$export$4b844e58a3e414b4; }, function (v) { return $aa80e22ed743fb40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $aa80e22ed743fb40$export$816d2913ae6b83b1; }, function (v) { return $aa80e22ed743fb40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $aa80e22ed743fb40$export$61bcfe829111a1d0; }, function (v) { return $aa80e22ed743fb40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $aa80e22ed743fb40$export$7ee8c9beb337bc3f; }, function (v) { return $aa80e22ed743fb40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $aa80e22ed743fb40$export$b5836b71941fa3ed; }, function (v) { return $aa80e22ed743fb40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $aa80e22ed743fb40$export$cf845f2c119da08a; }, function (v) { return $aa80e22ed743fb40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa80e22ed743fb40$export$c4744153514ff05d;
var $aa80e22ed743fb40$export$3e506c1ccc9cc1a7;
var $aa80e22ed743fb40$export$e26fe2ed2fa76875;
var $aa80e22ed743fb40$export$502329bbf4b505b1;
var $aa80e22ed743fb40$export$6e3807111c4874c4;
var $aa80e22ed743fb40$export$c27134553091fb3a;
var $aa80e22ed743fb40$export$33ee1acdc04fd2a2;
var $aa80e22ed743fb40$export$b00a404bbd5edef2;
var $aa80e22ed743fb40$export$8352ce38b91d0c62;
var $aa80e22ed743fb40$export$d66a1c1c77bd778b;
var $aa80e22ed743fb40$export$d3dfb8e4810cb555;
var $aa80e22ed743fb40$export$839f9183b0465a69;
var $aa80e22ed743fb40$export$72fdf0e06517287b;
var $aa80e22ed743fb40$export$4b844e58a3e414b4;
var $aa80e22ed743fb40$export$816d2913ae6b83b1;
var $aa80e22ed743fb40$export$61bcfe829111a1d0;
var $aa80e22ed743fb40$export$7ee8c9beb337bc3f;
var $aa80e22ed743fb40$export$b5836b71941fa3ed;
var $aa80e22ed743fb40$export$cf845f2c119da08a;
"use strict";
function $aa80e22ed743fb40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $aa80e22ed743fb40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $aa80e22ed743fb40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $aa80e22ed743fb40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $aa80e22ed743fb40$var$g(C, c)) n < e && 0 > $aa80e22ed743fb40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $aa80e22ed743fb40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $aa80e22ed743fb40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $aa80e22ed743fb40$var$l = performance;
    $aa80e22ed743fb40$export$c4744153514ff05d = function() {
        return $aa80e22ed743fb40$var$l.now();
    };
} else {
    var $aa80e22ed743fb40$var$p = Date, $aa80e22ed743fb40$var$q = $aa80e22ed743fb40$var$p.now();
    $aa80e22ed743fb40$export$c4744153514ff05d = function() {
        return $aa80e22ed743fb40$var$p.now() - $aa80e22ed743fb40$var$q;
    };
}
var $aa80e22ed743fb40$var$r = [], $aa80e22ed743fb40$var$t = [], $aa80e22ed743fb40$var$u = 1, $aa80e22ed743fb40$var$v = null, $aa80e22ed743fb40$var$y = 3, $aa80e22ed743fb40$var$z = !1, $aa80e22ed743fb40$var$A = !1, $aa80e22ed743fb40$var$B = !1, $aa80e22ed743fb40$var$D = "function" === typeof setTimeout ? setTimeout : null, $aa80e22ed743fb40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $aa80e22ed743fb40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $aa80e22ed743fb40$var$G(a) {
    for(var b = $aa80e22ed743fb40$var$h($aa80e22ed743fb40$var$t); null !== b;){
        if (null === b.callback) $aa80e22ed743fb40$var$k($aa80e22ed743fb40$var$t);
        else if (b.startTime <= a) $aa80e22ed743fb40$var$k($aa80e22ed743fb40$var$t), b.sortIndex = b.expirationTime, $aa80e22ed743fb40$var$f($aa80e22ed743fb40$var$r, b);
        else break;
        b = $aa80e22ed743fb40$var$h($aa80e22ed743fb40$var$t);
    }
}
function $aa80e22ed743fb40$var$H(a) {
    $aa80e22ed743fb40$var$B = !1;
    $aa80e22ed743fb40$var$G(a);
    if (!$aa80e22ed743fb40$var$A) {
        if (null !== $aa80e22ed743fb40$var$h($aa80e22ed743fb40$var$r)) $aa80e22ed743fb40$var$A = !0, $aa80e22ed743fb40$var$I($aa80e22ed743fb40$var$J);
        else {
            var b = $aa80e22ed743fb40$var$h($aa80e22ed743fb40$var$t);
            null !== b && $aa80e22ed743fb40$var$K($aa80e22ed743fb40$var$H, b.startTime - a);
        }
    }
}
function $aa80e22ed743fb40$var$J(a, b) {
    $aa80e22ed743fb40$var$A = !1;
    $aa80e22ed743fb40$var$B && ($aa80e22ed743fb40$var$B = !1, $aa80e22ed743fb40$var$E($aa80e22ed743fb40$var$L), $aa80e22ed743fb40$var$L = -1);
    $aa80e22ed743fb40$var$z = !0;
    var c = $aa80e22ed743fb40$var$y;
    try {
        $aa80e22ed743fb40$var$G(b);
        for($aa80e22ed743fb40$var$v = $aa80e22ed743fb40$var$h($aa80e22ed743fb40$var$r); null !== $aa80e22ed743fb40$var$v && (!($aa80e22ed743fb40$var$v.expirationTime > b) || a && !$aa80e22ed743fb40$var$M());){
            var d = $aa80e22ed743fb40$var$v.callback;
            if ("function" === typeof d) {
                $aa80e22ed743fb40$var$v.callback = null;
                $aa80e22ed743fb40$var$y = $aa80e22ed743fb40$var$v.priorityLevel;
                var e = d($aa80e22ed743fb40$var$v.expirationTime <= b);
                b = $aa80e22ed743fb40$export$c4744153514ff05d();
                "function" === typeof e ? $aa80e22ed743fb40$var$v.callback = e : $aa80e22ed743fb40$var$v === $aa80e22ed743fb40$var$h($aa80e22ed743fb40$var$r) && $aa80e22ed743fb40$var$k($aa80e22ed743fb40$var$r);
                $aa80e22ed743fb40$var$G(b);
            } else $aa80e22ed743fb40$var$k($aa80e22ed743fb40$var$r);
            $aa80e22ed743fb40$var$v = $aa80e22ed743fb40$var$h($aa80e22ed743fb40$var$r);
        }
        if (null !== $aa80e22ed743fb40$var$v) var w = !0;
        else {
            var m = $aa80e22ed743fb40$var$h($aa80e22ed743fb40$var$t);
            null !== m && $aa80e22ed743fb40$var$K($aa80e22ed743fb40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $aa80e22ed743fb40$var$v = null, $aa80e22ed743fb40$var$y = c, $aa80e22ed743fb40$var$z = !1;
    }
}
var $aa80e22ed743fb40$var$N = !1, $aa80e22ed743fb40$var$O = null, $aa80e22ed743fb40$var$L = -1, $aa80e22ed743fb40$var$P = 5, $aa80e22ed743fb40$var$Q = -1;
function $aa80e22ed743fb40$var$M() {
    return $aa80e22ed743fb40$export$c4744153514ff05d() - $aa80e22ed743fb40$var$Q < $aa80e22ed743fb40$var$P ? !1 : !0;
}
function $aa80e22ed743fb40$var$R() {
    if (null !== $aa80e22ed743fb40$var$O) {
        var a = $aa80e22ed743fb40$export$c4744153514ff05d();
        $aa80e22ed743fb40$var$Q = a;
        var b = !0;
        try {
            b = $aa80e22ed743fb40$var$O(!0, a);
        } finally{
            b ? $aa80e22ed743fb40$var$S() : ($aa80e22ed743fb40$var$N = !1, $aa80e22ed743fb40$var$O = null);
        }
    } else $aa80e22ed743fb40$var$N = !1;
}
var $aa80e22ed743fb40$var$S;
if ("function" === typeof $aa80e22ed743fb40$var$F) $aa80e22ed743fb40$var$S = function() {
    $aa80e22ed743fb40$var$F($aa80e22ed743fb40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $aa80e22ed743fb40$var$T = new MessageChannel, $aa80e22ed743fb40$var$U = $aa80e22ed743fb40$var$T.port2;
    $aa80e22ed743fb40$var$T.port1.onmessage = $aa80e22ed743fb40$var$R;
    $aa80e22ed743fb40$var$S = function() {
        $aa80e22ed743fb40$var$U.postMessage(null);
    };
} else $aa80e22ed743fb40$var$S = function() {
    $aa80e22ed743fb40$var$D($aa80e22ed743fb40$var$R, 0);
};
function $aa80e22ed743fb40$var$I(a) {
    $aa80e22ed743fb40$var$O = a;
    $aa80e22ed743fb40$var$N || ($aa80e22ed743fb40$var$N = !0, $aa80e22ed743fb40$var$S());
}
function $aa80e22ed743fb40$var$K(a, b) {
    $aa80e22ed743fb40$var$L = $aa80e22ed743fb40$var$D(function() {
        a($aa80e22ed743fb40$export$c4744153514ff05d());
    }, b);
}
$aa80e22ed743fb40$export$3e506c1ccc9cc1a7 = 5;
$aa80e22ed743fb40$export$e26fe2ed2fa76875 = 1;
$aa80e22ed743fb40$export$502329bbf4b505b1 = 4;
$aa80e22ed743fb40$export$6e3807111c4874c4 = 3;
$aa80e22ed743fb40$export$c27134553091fb3a = null;
$aa80e22ed743fb40$export$33ee1acdc04fd2a2 = 2;
$aa80e22ed743fb40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$aa80e22ed743fb40$export$8352ce38b91d0c62 = function() {
    $aa80e22ed743fb40$var$A || $aa80e22ed743fb40$var$z || ($aa80e22ed743fb40$var$A = !0, $aa80e22ed743fb40$var$I($aa80e22ed743fb40$var$J));
};
$aa80e22ed743fb40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $aa80e22ed743fb40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$aa80e22ed743fb40$export$d3dfb8e4810cb555 = function() {
    return $aa80e22ed743fb40$var$y;
};
$aa80e22ed743fb40$export$839f9183b0465a69 = function() {
    return $aa80e22ed743fb40$var$h($aa80e22ed743fb40$var$r);
};
$aa80e22ed743fb40$export$72fdf0e06517287b = function(a) {
    switch($aa80e22ed743fb40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $aa80e22ed743fb40$var$y;
    }
    var c = $aa80e22ed743fb40$var$y;
    $aa80e22ed743fb40$var$y = b;
    try {
        return a();
    } finally{
        $aa80e22ed743fb40$var$y = c;
    }
};
$aa80e22ed743fb40$export$4b844e58a3e414b4 = function() {};
$aa80e22ed743fb40$export$816d2913ae6b83b1 = function() {};
$aa80e22ed743fb40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $aa80e22ed743fb40$var$y;
    $aa80e22ed743fb40$var$y = a;
    try {
        return b();
    } finally{
        $aa80e22ed743fb40$var$y = c;
    }
};
$aa80e22ed743fb40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $aa80e22ed743fb40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $aa80e22ed743fb40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $aa80e22ed743fb40$var$f($aa80e22ed743fb40$var$t, a), null === $aa80e22ed743fb40$var$h($aa80e22ed743fb40$var$r) && a === $aa80e22ed743fb40$var$h($aa80e22ed743fb40$var$t) && ($aa80e22ed743fb40$var$B ? ($aa80e22ed743fb40$var$E($aa80e22ed743fb40$var$L), $aa80e22ed743fb40$var$L = -1) : $aa80e22ed743fb40$var$B = !0, $aa80e22ed743fb40$var$K($aa80e22ed743fb40$var$H, c - d))) : (a.sortIndex = e, $aa80e22ed743fb40$var$f($aa80e22ed743fb40$var$r, a), $aa80e22ed743fb40$var$A || $aa80e22ed743fb40$var$z || ($aa80e22ed743fb40$var$A = !0, $aa80e22ed743fb40$var$I($aa80e22ed743fb40$var$J)));
    return a;
};
$aa80e22ed743fb40$export$b5836b71941fa3ed = $aa80e22ed743fb40$var$M;
$aa80e22ed743fb40$export$cf845f2c119da08a = function(a) {
    var b = $aa80e22ed743fb40$var$y;
    return function() {
        var c = $aa80e22ed743fb40$var$y;
        $aa80e22ed743fb40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $aa80e22ed743fb40$var$y = c;
        }
    };
};

});



parcelRegister("foTQs", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $b3646a9743d9d433$export$2b8d127b894957b9; }, function (v) { return $b3646a9743d9d433$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $b3646a9743d9d433$export$cea3a54a6425200c; }, function (v) { return $b3646a9743d9d433$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $b3646a9743d9d433$export$a7c73072b1a182ae; }, function (v) { return $b3646a9743d9d433$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b3646a9743d9d433$export$9f27bc3417b4524d; }, function (v) { return $b3646a9743d9d433$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b3646a9743d9d433$export$db77ccec0bb4ccac; }, function (v) { return $b3646a9743d9d433$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b3646a9743d9d433$export$8392c0c9d3dcbd35; }, function (v) { return $b3646a9743d9d433$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b3646a9743d9d433$export$ffb0004e005737fa; }, function (v) { return $b3646a9743d9d433$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b3646a9743d9d433$export$b624eff549462981; }, function (v) { return $b3646a9743d9d433$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b3646a9743d9d433$export$7897aa7841a5380c; }, function (v) { return $b3646a9743d9d433$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b3646a9743d9d433$export$602eac185826482c; }, function (v) { return $b3646a9743d9d433$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b3646a9743d9d433$export$e2c29f18771995cb; }, function (v) { return $b3646a9743d9d433$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b3646a9743d9d433$export$5f8d39834fd61797; }, function (v) { return $b3646a9743d9d433$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b3646a9743d9d433$export$74bf444e3cd11ea5; }, function (v) { return $b3646a9743d9d433$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b3646a9743d9d433$export$92387174baf9b227; }, function (v) { return $b3646a9743d9d433$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b3646a9743d9d433$export$ec112efeb987d9c6; }, function (v) { return $b3646a9743d9d433$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b3646a9743d9d433$export$b706b080d889d2c9; }, function (v) { return $b3646a9743d9d433$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b3646a9743d9d433$export$5be5a87408f70ddc; }, function (v) { return $b3646a9743d9d433$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b3646a9743d9d433$export$45a5e7f76e0caa8d; }, function (v) { return $b3646a9743d9d433$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b3646a9743d9d433$export$455c2e768291efa6; }, function (v) { return $b3646a9743d9d433$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b3646a9743d9d433$export$9522e17588c12572; }, function (v) { return $b3646a9743d9d433$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b3646a9743d9d433$export$2110ac352bb060b9; }, function (v) { return $b3646a9743d9d433$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b3646a9743d9d433$export$56885ab8b9c456ab; }, function (v) { return $b3646a9743d9d433$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b3646a9743d9d433$export$d927fcb6adf8f9de; }, function (v) { return $b3646a9743d9d433$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b3646a9743d9d433$export$b82d16f27459e05a; }, function (v) { return $b3646a9743d9d433$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b3646a9743d9d433$export$522c17b4f5e123e8; }, function (v) { return $b3646a9743d9d433$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b3646a9743d9d433$export$1aabd8a0274ecfd6; }, function (v) { return $b3646a9743d9d433$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b3646a9743d9d433$export$9b621391a187a31a; }, function (v) { return $b3646a9743d9d433$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b3646a9743d9d433$export$f5bbd400c2f4426f; }, function (v) { return $b3646a9743d9d433$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b3646a9743d9d433$export$2b8d127b894957b9;
var $b3646a9743d9d433$export$cea3a54a6425200c;
var $b3646a9743d9d433$export$a7c73072b1a182ae;
var $b3646a9743d9d433$export$9f27bc3417b4524d;
var $b3646a9743d9d433$export$db77ccec0bb4ccac;
var $b3646a9743d9d433$export$8392c0c9d3dcbd35;
var $b3646a9743d9d433$export$ffb0004e005737fa;
var $b3646a9743d9d433$export$b624eff549462981;
var $b3646a9743d9d433$export$7897aa7841a5380c;
var $b3646a9743d9d433$export$602eac185826482c;
var $b3646a9743d9d433$export$e2c29f18771995cb;
var $b3646a9743d9d433$export$5f8d39834fd61797;
var $b3646a9743d9d433$export$74bf444e3cd11ea5;
var $b3646a9743d9d433$export$92387174baf9b227;
var $b3646a9743d9d433$export$ec112efeb987d9c6;
var $b3646a9743d9d433$export$b706b080d889d2c9;
var $b3646a9743d9d433$export$5be5a87408f70ddc;
var $b3646a9743d9d433$export$45a5e7f76e0caa8d;
var $b3646a9743d9d433$export$455c2e768291efa6;
var $b3646a9743d9d433$export$9522e17588c12572;
var $b3646a9743d9d433$export$2110ac352bb060b9;
var $b3646a9743d9d433$export$56885ab8b9c456ab;
var $b3646a9743d9d433$export$d927fcb6adf8f9de;
var $b3646a9743d9d433$export$b82d16f27459e05a;
var $b3646a9743d9d433$export$522c17b4f5e123e8;
var $b3646a9743d9d433$export$1aabd8a0274ecfd6;
var $b3646a9743d9d433$export$9b621391a187a31a;
var $b3646a9743d9d433$export$f5bbd400c2f4426f;
"use strict";
var $b3646a9743d9d433$var$b = "function" === typeof Symbol && Symbol.for, $b3646a9743d9d433$var$c = $b3646a9743d9d433$var$b ? Symbol.for("react.element") : 60103, $b3646a9743d9d433$var$d = $b3646a9743d9d433$var$b ? Symbol.for("react.portal") : 60106, $b3646a9743d9d433$var$e = $b3646a9743d9d433$var$b ? Symbol.for("react.fragment") : 60107, $b3646a9743d9d433$var$f = $b3646a9743d9d433$var$b ? Symbol.for("react.strict_mode") : 60108, $b3646a9743d9d433$var$g = $b3646a9743d9d433$var$b ? Symbol.for("react.profiler") : 60114, $b3646a9743d9d433$var$h = $b3646a9743d9d433$var$b ? Symbol.for("react.provider") : 60109, $b3646a9743d9d433$var$k = $b3646a9743d9d433$var$b ? Symbol.for("react.context") : 60110, $b3646a9743d9d433$var$l = $b3646a9743d9d433$var$b ? Symbol.for("react.async_mode") : 60111, $b3646a9743d9d433$var$m = $b3646a9743d9d433$var$b ? Symbol.for("react.concurrent_mode") : 60111, $b3646a9743d9d433$var$n = $b3646a9743d9d433$var$b ? Symbol.for("react.forward_ref") : 60112, $b3646a9743d9d433$var$p = $b3646a9743d9d433$var$b ? Symbol.for("react.suspense") : 60113, $b3646a9743d9d433$var$q = $b3646a9743d9d433$var$b ? Symbol.for("react.suspense_list") : 60120, $b3646a9743d9d433$var$r = $b3646a9743d9d433$var$b ? Symbol.for("react.memo") : 60115, $b3646a9743d9d433$var$t = $b3646a9743d9d433$var$b ? Symbol.for("react.lazy") : 60116, $b3646a9743d9d433$var$v = $b3646a9743d9d433$var$b ? Symbol.for("react.block") : 60121, $b3646a9743d9d433$var$w = $b3646a9743d9d433$var$b ? Symbol.for("react.fundamental") : 60117, $b3646a9743d9d433$var$x = $b3646a9743d9d433$var$b ? Symbol.for("react.responder") : 60118, $b3646a9743d9d433$var$y = $b3646a9743d9d433$var$b ? Symbol.for("react.scope") : 60119;
function $b3646a9743d9d433$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $b3646a9743d9d433$var$c:
                switch(a = a.type, a){
                    case $b3646a9743d9d433$var$l:
                    case $b3646a9743d9d433$var$m:
                    case $b3646a9743d9d433$var$e:
                    case $b3646a9743d9d433$var$g:
                    case $b3646a9743d9d433$var$f:
                    case $b3646a9743d9d433$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b3646a9743d9d433$var$k:
                            case $b3646a9743d9d433$var$n:
                            case $b3646a9743d9d433$var$t:
                            case $b3646a9743d9d433$var$r:
                            case $b3646a9743d9d433$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $b3646a9743d9d433$var$d:
                return u;
        }
    }
}
function $b3646a9743d9d433$var$A(a) {
    return $b3646a9743d9d433$var$z(a) === $b3646a9743d9d433$var$m;
}
$b3646a9743d9d433$export$2b8d127b894957b9 = $b3646a9743d9d433$var$l;
$b3646a9743d9d433$export$cea3a54a6425200c = $b3646a9743d9d433$var$m;
$b3646a9743d9d433$export$a7c73072b1a182ae = $b3646a9743d9d433$var$k;
$b3646a9743d9d433$export$9f27bc3417b4524d = $b3646a9743d9d433$var$h;
$b3646a9743d9d433$export$db77ccec0bb4ccac = $b3646a9743d9d433$var$c;
$b3646a9743d9d433$export$8392c0c9d3dcbd35 = $b3646a9743d9d433$var$n;
$b3646a9743d9d433$export$ffb0004e005737fa = $b3646a9743d9d433$var$e;
$b3646a9743d9d433$export$b624eff549462981 = $b3646a9743d9d433$var$t;
$b3646a9743d9d433$export$7897aa7841a5380c = $b3646a9743d9d433$var$r;
$b3646a9743d9d433$export$602eac185826482c = $b3646a9743d9d433$var$d;
$b3646a9743d9d433$export$e2c29f18771995cb = $b3646a9743d9d433$var$g;
$b3646a9743d9d433$export$5f8d39834fd61797 = $b3646a9743d9d433$var$f;
$b3646a9743d9d433$export$74bf444e3cd11ea5 = $b3646a9743d9d433$var$p;
$b3646a9743d9d433$export$92387174baf9b227 = function(a) {
    return $b3646a9743d9d433$var$A(a) || $b3646a9743d9d433$var$z(a) === $b3646a9743d9d433$var$l;
};
$b3646a9743d9d433$export$ec112efeb987d9c6 = $b3646a9743d9d433$var$A;
$b3646a9743d9d433$export$b706b080d889d2c9 = function(a) {
    return $b3646a9743d9d433$var$z(a) === $b3646a9743d9d433$var$k;
};
$b3646a9743d9d433$export$5be5a87408f70ddc = function(a) {
    return $b3646a9743d9d433$var$z(a) === $b3646a9743d9d433$var$h;
};
$b3646a9743d9d433$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b3646a9743d9d433$var$c;
};
$b3646a9743d9d433$export$455c2e768291efa6 = function(a) {
    return $b3646a9743d9d433$var$z(a) === $b3646a9743d9d433$var$n;
};
$b3646a9743d9d433$export$9522e17588c12572 = function(a) {
    return $b3646a9743d9d433$var$z(a) === $b3646a9743d9d433$var$e;
};
$b3646a9743d9d433$export$2110ac352bb060b9 = function(a) {
    return $b3646a9743d9d433$var$z(a) === $b3646a9743d9d433$var$t;
};
$b3646a9743d9d433$export$56885ab8b9c456ab = function(a) {
    return $b3646a9743d9d433$var$z(a) === $b3646a9743d9d433$var$r;
};
$b3646a9743d9d433$export$d927fcb6adf8f9de = function(a) {
    return $b3646a9743d9d433$var$z(a) === $b3646a9743d9d433$var$d;
};
$b3646a9743d9d433$export$b82d16f27459e05a = function(a) {
    return $b3646a9743d9d433$var$z(a) === $b3646a9743d9d433$var$g;
};
$b3646a9743d9d433$export$522c17b4f5e123e8 = function(a) {
    return $b3646a9743d9d433$var$z(a) === $b3646a9743d9d433$var$f;
};
$b3646a9743d9d433$export$1aabd8a0274ecfd6 = function(a) {
    return $b3646a9743d9d433$var$z(a) === $b3646a9743d9d433$var$p;
};
$b3646a9743d9d433$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b3646a9743d9d433$var$e || a === $b3646a9743d9d433$var$m || a === $b3646a9743d9d433$var$g || a === $b3646a9743d9d433$var$f || a === $b3646a9743d9d433$var$p || a === $b3646a9743d9d433$var$q || "object" === typeof a && null !== a && (a.$$typeof === $b3646a9743d9d433$var$t || a.$$typeof === $b3646a9743d9d433$var$r || a.$$typeof === $b3646a9743d9d433$var$h || a.$$typeof === $b3646a9743d9d433$var$k || a.$$typeof === $b3646a9743d9d433$var$n || a.$$typeof === $b3646a9743d9d433$var$w || a.$$typeof === $b3646a9743d9d433$var$x || a.$$typeof === $b3646a9743d9d433$var$y || a.$$typeof === $b3646a9743d9d433$var$v);
};
$b3646a9743d9d433$export$f5bbd400c2f4426f = $b3646a9743d9d433$var$z;

});

parcelRegister("gbXzY", function(module, exports) {

$parcel$export(module.exports, "NonFullScreenPageMode", function () { return NonFullScreenPageMode; });
$parcel$export(module.exports, "ReadingDirection", function () { return ReadingDirection; });
$parcel$export(module.exports, "PrintScaling", function () { return PrintScaling; });
$parcel$export(module.exports, "Duplex", function () { return Duplex; });
$parcel$export(module.exports, "default", function () { return $bc9be3a38327e193$export$2e2bcd8739ae039; });

var $7Igbp = parcelRequire("7Igbp");

var $evfTd = parcelRequire("evfTd");

var $a7yPZ = parcelRequire("a7yPZ");

var $gcVIu = parcelRequire("gcVIu");
parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
var asEnum = function(rawValue, enumType) {
    if (rawValue === undefined) return undefined;
    return enumType[rawValue];
};
var NonFullScreenPageMode;
(function(NonFullScreenPageMode) {
    /**
     * After exiting FullScreen mode, neither the document outline nor thumbnail
     * images should be visible.
     */ NonFullScreenPageMode["UseNone"] = "UseNone";
    /** After exiting FullScreen mode, the document outline should be visible. */ NonFullScreenPageMode["UseOutlines"] = "UseOutlines";
    /** After exiting FullScreen mode, thumbnail images should be visible. */ NonFullScreenPageMode["UseThumbs"] = "UseThumbs";
    /**
     * After exiting FullScreen mode, the optional content group panel should be
     * visible.
     */ NonFullScreenPageMode["UseOC"] = "UseOC";
})(NonFullScreenPageMode || (NonFullScreenPageMode = {}));
var ReadingDirection;
(function(ReadingDirection) {
    /** The predominant reading order is Left to Right. */ ReadingDirection["L2R"] = "L2R";
    /**
     * The predominant reading order is Right to left (including vertical writing
     * systems, such as Chinese, Japanese and Korean).
     */ ReadingDirection["R2L"] = "R2L";
})(ReadingDirection || (ReadingDirection = {}));
var PrintScaling;
(function(PrintScaling) {
    /** No page scaling. */ PrintScaling["None"] = "None";
    /* Use the PDF reader's default print scaling. */ PrintScaling["AppDefault"] = "AppDefault";
})(PrintScaling || (PrintScaling = {}));
var Duplex;
(function(Duplex) {
    /** The PDF reader should print single-sided. */ Duplex["Simplex"] = "Simplex";
    /**
     * The PDF reader should print double sided and flip on the short edge of the
     * sheet.
     */ Duplex["DuplexFlipShortEdge"] = "DuplexFlipShortEdge";
    /**
     * The PDF reader should print double sided and flip on the long edge of the
     * sheet.
     */ Duplex["DuplexFlipLongEdge"] = "DuplexFlipLongEdge";
})(Duplex || (Duplex = {}));
var ViewerPreferences = /** @class */ function() {
    /** @ignore */ function ViewerPreferences(dict) {
        this.dict = dict;
    }
    ViewerPreferences.prototype.lookupBool = function(key) {
        var returnObj = this.dict.lookup((0, $a7yPZ.default).of(key));
        if (returnObj instanceof (0, $evfTd.default)) return returnObj;
        return undefined;
    };
    ViewerPreferences.prototype.lookupName = function(key) {
        var returnObj = this.dict.lookup((0, $a7yPZ.default).of(key));
        if (returnObj instanceof (0, $a7yPZ.default)) return returnObj;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.HideToolbar = function() {
        return this.lookupBool("HideToolbar");
    };
    /** @ignore */ ViewerPreferences.prototype.HideMenubar = function() {
        return this.lookupBool("HideMenubar");
    };
    /** @ignore */ ViewerPreferences.prototype.HideWindowUI = function() {
        return this.lookupBool("HideWindowUI");
    };
    /** @ignore */ ViewerPreferences.prototype.FitWindow = function() {
        return this.lookupBool("FitWindow");
    };
    /** @ignore */ ViewerPreferences.prototype.CenterWindow = function() {
        return this.lookupBool("CenterWindow");
    };
    /** @ignore */ ViewerPreferences.prototype.DisplayDocTitle = function() {
        return this.lookupBool("DisplayDocTitle");
    };
    /** @ignore */ ViewerPreferences.prototype.NonFullScreenPageMode = function() {
        return this.lookupName("NonFullScreenPageMode");
    };
    /** @ignore */ ViewerPreferences.prototype.Direction = function() {
        return this.lookupName("Direction");
    };
    /** @ignore */ ViewerPreferences.prototype.PrintScaling = function() {
        return this.lookupName("PrintScaling");
    };
    /** @ignore */ ViewerPreferences.prototype.Duplex = function() {
        return this.lookupName("Duplex");
    };
    /** @ignore */ ViewerPreferences.prototype.PickTrayByPDFSize = function() {
        return this.lookupBool("PickTrayByPDFSize");
    };
    /** @ignore */ ViewerPreferences.prototype.PrintPageRange = function() {
        var PrintPageRange = this.dict.lookup((0, $a7yPZ.default).of("PrintPageRange"));
        if (PrintPageRange instanceof (0, $7Igbp.default)) return PrintPageRange;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.NumCopies = function() {
        var NumCopies = this.dict.lookup((0, $a7yPZ.default).of("NumCopies"));
        if (NumCopies instanceof (0, $gcVIu.default)) return NumCopies;
        return undefined;
    };
    /**
     * Returns `true` if PDF readers should hide the toolbar menus when displaying
     * this document.
     * @returns Whether or not toolbars should be hidden.
     */ ViewerPreferences.prototype.getHideToolbar = function() {
        var _a, _b;
        return (_b = (_a = this.HideToolbar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the menu bar when displaying this
     * document.
     * @returns Whether or not the menu bar should be hidden.
     */ ViewerPreferences.prototype.getHideMenubar = function() {
        var _a, _b;
        return (_b = (_a = this.HideMenubar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the user interface elements in
     * the document's window (such as scroll bars and navigation controls),
     * leaving only the document's contents displayed.
     * @returns Whether or not user interface elements should be hidden.
     */ ViewerPreferences.prototype.getHideWindowUI = function() {
        var _a, _b;
        return (_b = (_a = this.HideWindowUI()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should resize the document's window to fit
     * the size of the first displayed page.
     * @returns Whether or not the window should be resized to fit.
     */ ViewerPreferences.prototype.getFitWindow = function() {
        var _a, _b;
        return (_b = (_a = this.FitWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should position the document's window in the
     * center of the screen.
     * @returns Whether or not to center the document window.
     */ ViewerPreferences.prototype.getCenterWindow = function() {
        var _a, _b;
        return (_b = (_a = this.CenterWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if the window's title bar should display the document
     * `Title`, taken from the document metadata (see [[PDFDocument.getTitle]]).
     * Returns `false` if the title bar should instead display the filename of the
     * PDF file.
     * @returns Whether to display the document title.
     */ ViewerPreferences.prototype.getDisplayDocTitle = function() {
        var _a, _b;
        return (_b = (_a = this.DisplayDocTitle()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns the page mode, which tells the PDF reader how to display the
     * document after exiting full-screen mode.
     * @returns The page mode after exiting full-screen mode.
     */ ViewerPreferences.prototype.getNonFullScreenPageMode = function() {
        var _a, _b;
        var mode = (_a = this.NonFullScreenPageMode()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(mode, NonFullScreenPageMode)) !== null && _b !== void 0 ? _b : NonFullScreenPageMode.UseNone;
    };
    /**
     * Returns the predominant reading order for text.
     * @returns The text reading order.
     */ ViewerPreferences.prototype.getReadingDirection = function() {
        var _a, _b;
        var direction = (_a = this.Direction()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(direction, ReadingDirection)) !== null && _b !== void 0 ? _b : ReadingDirection.L2R;
    };
    /**
     * Returns the page scaling option that the PDF reader should select when the
     * print dialog is displayed.
     * @returns The page scaling option.
     */ ViewerPreferences.prototype.getPrintScaling = function() {
        var _a, _b;
        var scaling = (_a = this.PrintScaling()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(scaling, PrintScaling)) !== null && _b !== void 0 ? _b : PrintScaling.AppDefault;
    };
    /**
     * Returns the paper handling option that should be used when printing the
     * file from the print dialog.
     * @returns The paper handling option.
     */ ViewerPreferences.prototype.getDuplex = function() {
        var _a;
        var duplex = (_a = this.Duplex()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return asEnum(duplex, Duplex);
    };
    /**
     * Returns `true` if the PDF page size should be used to select the input
     * paper tray.
     * @returns Whether or not the PDF page size should be used to select the
     *          input paper tray.
     */ ViewerPreferences.prototype.getPickTrayByPDFSize = function() {
        var _a;
        return (_a = this.PickTrayByPDFSize()) === null || _a === void 0 ? void 0 : _a.asBoolean();
    };
    /**
     * Returns an array of page number ranges, which are the values used to
     * initialize the print dialog box when the file is printed. Each range
     * specifies the first (`start`) and last (`end`) pages in a sub-range of
     * pages to be printed. The first page of the PDF file is denoted by 0.
     * For example:
     * ```js
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * const includesPage3 = viewerPrefs
     *   .getPrintRanges()
     *   .some(pr => pr.start =< 2 && pr.end >= 2)
     * if (includesPage3) console.log('printRange includes page 3')
     * ```
     * @returns An array of objects, each with the properties `start` and `end`,
     *          denoting page indices. If not, specified an empty array is
     *          returned.
     */ ViewerPreferences.prototype.getPrintPageRange = function() {
        var rng = this.PrintPageRange();
        if (!rng) return [];
        var pageRanges = [];
        for(var i = 0; i < rng.size(); i += 2){
            // Despite the spec clearly stating that "The first page of the PDF file
            // shall be donoted by 1", several test PDFs (spec 1.7) created in
            // Acrobat XI 11.0 and also read with Reader DC 2020.013 indicate this is
            // actually a 0 based index.
            var start = rng.lookup(i, (0, $gcVIu.default)).asNumber();
            var end = rng.lookup(i + 1, (0, $gcVIu.default)).asNumber();
            pageRanges.push({
                start: start,
                end: end
            });
        }
        return pageRanges;
    };
    /**
     * Returns the number of copies to be printed when the print dialog is opened
     * for this document.
     * @returns The default number of copies to be printed.
     */ ViewerPreferences.prototype.getNumCopies = function() {
        var _a, _b;
        return (_b = (_a = this.NumCopies()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    /**
     * Choose whether the PDF reader's toolbars should be hidden while the
     * document is active.
     * @param hideToolbar `true` if the toolbar should be hidden.
     */ ViewerPreferences.prototype.setHideToolbar = function(hideToolbar) {
        var HideToolbar = this.dict.context.obj(hideToolbar);
        this.dict.set((0, $a7yPZ.default).of("HideToolbar"), HideToolbar);
    };
    /**
     * Choose whether the PDF reader's menu bar should be hidden while the
     * document is active.
     * @param hideMenubar `true` if the menu bar should be hidden.
     */ ViewerPreferences.prototype.setHideMenubar = function(hideMenubar) {
        var HideMenubar = this.dict.context.obj(hideMenubar);
        this.dict.set((0, $a7yPZ.default).of("HideMenubar"), HideMenubar);
    };
    /**
     * Choose whether the PDF reader should hide user interface elements in the
     * document's window (such as scroll bars and navigation controls), leaving
     * only the document's contents displayed.
     * @param hideWindowUI `true` if the user interface elements should be hidden.
     */ ViewerPreferences.prototype.setHideWindowUI = function(hideWindowUI) {
        var HideWindowUI = this.dict.context.obj(hideWindowUI);
        this.dict.set((0, $a7yPZ.default).of("HideWindowUI"), HideWindowUI);
    };
    /**
     * Choose whether the PDF reader should resize the document's window to fit
     * the size of the first displayed page.
     * @param fitWindow `true` if the window should be resized.
     */ ViewerPreferences.prototype.setFitWindow = function(fitWindow) {
        var FitWindow = this.dict.context.obj(fitWindow);
        this.dict.set((0, $a7yPZ.default).of("FitWindow"), FitWindow);
    };
    /**
     * Choose whether the PDF reader should position the document's window in the
     * center of the screen.
     * @param centerWindow `true` if the window should be centered.
     */ ViewerPreferences.prototype.setCenterWindow = function(centerWindow) {
        var CenterWindow = this.dict.context.obj(centerWindow);
        this.dict.set((0, $a7yPZ.default).of("CenterWindow"), CenterWindow);
    };
    /**
     * Choose whether the window's title bar should display the document `Title`
     * taken from the document metadata (see [[PDFDocument.setTitle]]). If
     * `false`, the title bar should instead display the PDF filename.
     * @param displayTitle `true` if the document title should be displayed.
     */ ViewerPreferences.prototype.setDisplayDocTitle = function(displayTitle) {
        var DisplayDocTitle = this.dict.context.obj(displayTitle);
        this.dict.set((0, $a7yPZ.default).of("DisplayDocTitle"), DisplayDocTitle);
    };
    /**
     * Choose how the PDF reader should display the document upon exiting
     * full-screen mode. This entry is meaningful only if the value of the
     * `PageMode` entry in the document's [[PDFCatalog]] is `FullScreen`.
     *
     * For example:
     * ```js
     * import { PDFDocument, NonFullScreenPageMode, PDFName } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     *
     * // Set the PageMode
     * pdfDoc.catalog.set(PDFName.of('PageMode'),PDFName.of('FullScreen'))
     *
     * // Set what happens when full-screen is closed
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setNonFullScreenPageMode(NonFullScreenPageMode.UseOutlines)
     * ```
     *
     * @param nonFullScreenPageMode How the document should be displayed upon
     *                              exiting full screen mode.
     */ ViewerPreferences.prototype.setNonFullScreenPageMode = function(nonFullScreenPageMode) {
        (0, $2qnUk.assertIsOneOf)(nonFullScreenPageMode, "nonFullScreenPageMode", NonFullScreenPageMode);
        var mode = (0, $a7yPZ.default).of(nonFullScreenPageMode);
        this.dict.set((0, $a7yPZ.default).of("NonFullScreenPageMode"), mode);
    };
    /**
     * Choose the predominant reading order for text.
     *
     * This entry has no direct effect on the document's contents or page
     * numbering, but may be used to determine the relative positioning of pages
     * when displayed side by side or printed n-up.
     *
     * For example:
     * ```js
     * import { PDFDocument, ReadingDirection } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setReadingDirection(ReadingDirection.R2L)
     * ```
     *
     * @param readingDirection The reading order for text.
     */ ViewerPreferences.prototype.setReadingDirection = function(readingDirection) {
        (0, $2qnUk.assertIsOneOf)(readingDirection, "readingDirection", ReadingDirection);
        var direction = (0, $a7yPZ.default).of(readingDirection);
        this.dict.set((0, $a7yPZ.default).of("Direction"), direction);
    };
    /**
     * Choose the page scaling option that should be selected when a print dialog
     * is displayed for this document.
     *
     * For example:
     * ```js
     * import { PDFDocument, PrintScaling } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setPrintScaling(PrintScaling.None)
     * ```
     *
     * @param printScaling The print scaling option.
     */ ViewerPreferences.prototype.setPrintScaling = function(printScaling) {
        (0, $2qnUk.assertIsOneOf)(printScaling, "printScaling", PrintScaling);
        var scaling = (0, $a7yPZ.default).of(printScaling);
        this.dict.set((0, $a7yPZ.default).of("PrintScaling"), scaling);
    };
    /**
     * Choose the paper handling option that should be selected by default in the
     * print dialog.
     *
     * For example:
     * ```js
     * import { PDFDocument, Duplex } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setDuplex(Duplex.DuplexFlipShortEdge)
     * ```
     *
     * @param duplex The double or single sided printing option.
     */ ViewerPreferences.prototype.setDuplex = function(duplex) {
        (0, $2qnUk.assertIsOneOf)(duplex, "duplex", Duplex);
        var dup = (0, $a7yPZ.default).of(duplex);
        this.dict.set((0, $a7yPZ.default).of("Duplex"), dup);
    };
    /**
     * Choose whether the PDF document's page size should be used to select the
     * input paper tray when printing. This setting influences only the preset
     * values used to populate the print dialog presented by a PDF reader.
     *
     * If PickTrayByPDFSize is true, the check box in the print dialog associated
     * with input paper tray should be checked. This setting has no effect on
     * operating systems that do not provide the ability to pick the input tray
     * by size.
     *
     * @param pickTrayByPDFSize `true` if the document's page size should be used
     *                          to select the input paper tray.
     */ ViewerPreferences.prototype.setPickTrayByPDFSize = function(pickTrayByPDFSize) {
        var PickTrayByPDFSize = this.dict.context.obj(pickTrayByPDFSize);
        this.dict.set((0, $a7yPZ.default).of("PickTrayByPDFSize"), PickTrayByPDFSize);
    };
    /**
     * Choose the page numbers used to initialize the print dialog box when the
     * file is printed. The first page of the PDF file is denoted by 0.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     *
     * // We can set the default print range to only the first page
     * viewerPrefs.setPrintPageRange({ start: 0, end: 0 })
     *
     * // Or we can supply noncontiguous ranges (e.g. pages 1, 3, and 5-7)
     * viewerPrefs.setPrintPageRange([
     *   { start: 0, end: 0 },
     *   { start: 2, end: 2 },
     *   { start: 4, end: 6 },
     * ])
     * ```
     *
     * @param printPageRange An object or array of objects, each with the
     *                       properties `start` and `end`, denoting a range of
     *                       page indices.
     */ ViewerPreferences.prototype.setPrintPageRange = function(printPageRange) {
        if (!Array.isArray(printPageRange)) printPageRange = [
            printPageRange
        ];
        var flatRange = [];
        for(var idx = 0, len = printPageRange.length; idx < len; idx++){
            flatRange.push(printPageRange[idx].start);
            flatRange.push(printPageRange[idx].end);
        }
        (0, $2qnUk.assertEachIs)(flatRange, "printPageRange", [
            "number"
        ]);
        var pageRanges = this.dict.context.obj(flatRange);
        this.dict.set((0, $a7yPZ.default).of("PrintPageRange"), pageRanges);
    };
    /**
     * Choose the default number of copies to be printed when the print dialog is
     * opened for this file.
     * @param numCopies The default number of copies.
     */ ViewerPreferences.prototype.setNumCopies = function(numCopies) {
        (0, $2qnUk.assertRange)(numCopies, "numCopies", 1, Number.MAX_VALUE);
        (0, $2qnUk.assertInteger)(numCopies, "numCopies");
        var NumCopies = this.dict.context.obj(numCopies);
        this.dict.set((0, $a7yPZ.default).of("NumCopies"), NumCopies);
    };
    /** @ignore */ ViewerPreferences.fromDict = function(dict) {
        return new ViewerPreferences(dict);
    };
    /** @ignore */ ViewerPreferences.create = function(context) {
        var dict = context.obj({});
        return new ViewerPreferences(dict);
    };
    return ViewerPreferences;
}();
var $bc9be3a38327e193$export$2e2bcd8739ae039 = ViewerPreferences;

});
parcelRegister("7Igbp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59d932185a76bf85$export$2e2bcd8739ae039; });

var $59LZ8 = parcelRequire("59LZ8");

var $gcVIu = parcelRequire("gcVIu");

var $cWdWp = parcelRequire("cWdWp");

var $5ZWJa = parcelRequire("5ZWJa");

var $1cWQu = parcelRequire("1cWQu");
var $59d932185a76bf85$var$PDFArray = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFArray, _super);
    function PDFArray(context) {
        var _this = _super.call(this) || this;
        _this.array = [];
        _this.context = context;
        return _this;
    }
    PDFArray.prototype.size = function() {
        return this.array.length;
    };
    PDFArray.prototype.push = function(object) {
        this.array.push(object);
    };
    PDFArray.prototype.insert = function(index, object) {
        this.array.splice(index, 0, object);
    };
    PDFArray.prototype.indexOf = function(object) {
        var index = this.array.indexOf(object);
        return index === -1 ? undefined : index;
    };
    PDFArray.prototype.remove = function(index) {
        this.array.splice(index, 1);
    };
    PDFArray.prototype.set = function(idx, object) {
        this.array[idx] = object;
    };
    PDFArray.prototype.get = function(index) {
        return this.array[index];
    };
    PDFArray.prototype.lookupMaybe = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookupMaybe.apply(_a, (0, $59LZ8.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.lookup = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookup.apply(_a, (0, $59LZ8.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.asRectangle = function() {
        if (this.size() !== 4) throw new (0, $1cWQu.PDFArrayIsNotRectangleError)(this.size());
        var lowerLeftX = this.lookup(0, (0, $gcVIu.default)).asNumber();
        var lowerLeftY = this.lookup(1, (0, $gcVIu.default)).asNumber();
        var upperRightX = this.lookup(2, (0, $gcVIu.default)).asNumber();
        var upperRightY = this.lookup(3, (0, $gcVIu.default)).asNumber();
        var x = lowerLeftX;
        var y = lowerLeftY;
        var width = upperRightX - lowerLeftX;
        var height = upperRightY - lowerLeftY;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    };
    PDFArray.prototype.asArray = function() {
        return this.array.slice();
    };
    PDFArray.prototype.clone = function(context) {
        var clone = PDFArray.withContext(context || this.context);
        for(var idx = 0, len = this.size(); idx < len; idx++)clone.push(this.array[idx]);
        return clone;
    };
    PDFArray.prototype.toString = function() {
        var arrayString = "[ ";
        for(var idx = 0, len = this.size(); idx < len; idx++){
            arrayString += this.get(idx).toString();
            arrayString += " ";
        }
        arrayString += "]";
        return arrayString;
    };
    PDFArray.prototype.sizeInBytes = function() {
        var size = 3;
        for(var idx = 0, len = this.size(); idx < len; idx++)size += this.get(idx).sizeInBytes() + 1;
        return size;
    };
    PDFArray.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $5ZWJa.default).LeftSquareBracket;
        buffer[offset++] = (0, $5ZWJa.default).Space;
        for(var idx = 0, len = this.size(); idx < len; idx++){
            offset += this.get(idx).copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $5ZWJa.default).Space;
        }
        buffer[offset++] = (0, $5ZWJa.default).RightSquareBracket;
        return offset - initialOffset;
    };
    PDFArray.prototype.scalePDFNumbers = function(x, y) {
        for(var idx = 0, len = this.size(); idx < len; idx++){
            var el = this.lookup(idx);
            if (el instanceof (0, $gcVIu.default)) {
                var factor = idx % 2 === 0 ? x : y;
                this.set(idx, (0, $gcVIu.default).of(el.asNumber() * factor));
            }
        }
    };
    PDFArray.withContext = function(context) {
        return new PDFArray(context);
    };
    return PDFArray;
}((0, $cWdWp.default));
var $59d932185a76bf85$export$2e2bcd8739ae039 = $59d932185a76bf85$var$PDFArray;

});
parcelRegister("59LZ8", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $3c1303dd2d398196$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $3c1303dd2d398196$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $3c1303dd2d398196$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $3c1303dd2d398196$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $3c1303dd2d398196$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spreadArrays", function () { return $3c1303dd2d398196$export$6388937ca91ccae8; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $3c1303dd2d398196$var$extendStatics = function(d, b) {
    $3c1303dd2d398196$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $3c1303dd2d398196$var$extendStatics(d, b);
};
function $3c1303dd2d398196$export$a8ba968b8961cb8a(d, b) {
    $3c1303dd2d398196$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3c1303dd2d398196$export$18ce0697a983be9b = function() {
    $3c1303dd2d398196$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3c1303dd2d398196$export$18ce0697a983be9b.apply(this, arguments);
};
function $3c1303dd2d398196$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3c1303dd2d398196$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3c1303dd2d398196$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3c1303dd2d398196$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3c1303dd2d398196$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3c1303dd2d398196$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $3c1303dd2d398196$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $3c1303dd2d398196$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $3c1303dd2d398196$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3c1303dd2d398196$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3c1303dd2d398196$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3c1303dd2d398196$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3c1303dd2d398196$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3c1303dd2d398196$export$10c90e4f7922046c(v) {
    return this instanceof $3c1303dd2d398196$export$10c90e4f7922046c ? (this.v = v, this) : new $3c1303dd2d398196$export$10c90e4f7922046c(v);
}
function $3c1303dd2d398196$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3c1303dd2d398196$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3c1303dd2d398196$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3c1303dd2d398196$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $3c1303dd2d398196$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3c1303dd2d398196$export$19a8beecd37a4c45 === "function" ? $3c1303dd2d398196$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3c1303dd2d398196$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $3c1303dd2d398196$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $3c1303dd2d398196$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3c1303dd2d398196$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $3c1303dd2d398196$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("gcVIu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcca899fa0be7bfb$export$2e2bcd8739ae039; });

var $59LZ8 = parcelRequire("59LZ8");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $cXeLZ = parcelRequire("cXeLZ");

var $cWdWp = parcelRequire("cWdWp");
var $bcca899fa0be7bfb$var$PDFNumber = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFNumber, _super);
    function PDFNumber(value) {
        var _this = _super.call(this) || this;
        _this.numberValue = value;
        _this.stringValue = (0, $cXeLZ.numberToString)(value);
        return _this;
    }
    PDFNumber.prototype.asNumber = function() {
        return this.numberValue;
    };
    /** @deprecated in favor of [[PDFNumber.asNumber]] */ PDFNumber.prototype.value = function() {
        return this.numberValue;
    };
    PDFNumber.prototype.clone = function() {
        return PDFNumber.of(this.numberValue);
    };
    PDFNumber.prototype.toString = function() {
        return this.stringValue;
    };
    PDFNumber.prototype.sizeInBytes = function() {
        return this.stringValue.length;
    };
    PDFNumber.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $cZKSB.copyStringIntoBuffer)(this.stringValue, buffer, offset);
        return this.stringValue.length;
    };
    PDFNumber.of = function(value) {
        return new PDFNumber(value);
    };
    return PDFNumber;
}((0, $cWdWp.default));
var $bcca899fa0be7bfb$export$2e2bcd8739ae039 = $bcca899fa0be7bfb$var$PDFNumber;

});
parcelRegister("6vLBB", function(module, exports) {
$parcel$export(module.exports, "arrayAsString", function () { return (parcelRequire("i8eKs")).arrayAsString; });
$parcel$export(module.exports, "byAscendingId", function () { return (parcelRequire("i8eKs")).byAscendingId; });
$parcel$export(module.exports, "canBeConvertedToUint8Array", function () { return (parcelRequire("i8eKs")).canBeConvertedToUint8Array; });
$parcel$export(module.exports, "last", function () { return (parcelRequire("i8eKs")).last; });
$parcel$export(module.exports, "mergeIntoTypedArray", function () { return (parcelRequire("i8eKs")).mergeIntoTypedArray; });
$parcel$export(module.exports, "mergeUint8Arrays", function () { return (parcelRequire("i8eKs")).mergeUint8Arrays; });
$parcel$export(module.exports, "pluckIndices", function () { return (parcelRequire("i8eKs")).pluckIndices; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("i8eKs")).range; });
$parcel$export(module.exports, "reverseArray", function () { return (parcelRequire("i8eKs")).reverseArray; });
$parcel$export(module.exports, "sortedUniq", function () { return (parcelRequire("i8eKs")).sortedUniq; });
$parcel$export(module.exports, "sum", function () { return (parcelRequire("i8eKs")).sum; });
$parcel$export(module.exports, "toUint8Array", function () { return (parcelRequire("i8eKs")).toUint8Array; });
$parcel$export(module.exports, "typedArrayFor", function () { return (parcelRequire("i8eKs")).typedArrayFor; });
$parcel$export(module.exports, "waitForTick", function () { return (parcelRequire("egzXy")).waitForTick; });
$parcel$export(module.exports, "breakTextIntoLines", function () { return (parcelRequire("cZKSB")).breakTextIntoLines; });
$parcel$export(module.exports, "charAtIndex", function () { return (parcelRequire("cZKSB")).charAtIndex; });
$parcel$export(module.exports, "charFromCode", function () { return (parcelRequire("cZKSB")).charFromCode; });
$parcel$export(module.exports, "charFromHexCode", function () { return (parcelRequire("cZKSB")).charFromHexCode; });
$parcel$export(module.exports, "charSplit", function () { return (parcelRequire("cZKSB")).charSplit; });
$parcel$export(module.exports, "cleanText", function () { return (parcelRequire("cZKSB")).cleanText; });
$parcel$export(module.exports, "copyStringIntoBuffer", function () { return (parcelRequire("cZKSB")).copyStringIntoBuffer; });
$parcel$export(module.exports, "findLastMatch", function () { return (parcelRequire("cZKSB")).findLastMatch; });
$parcel$export(module.exports, "lineSplit", function () { return (parcelRequire("cZKSB")).lineSplit; });
$parcel$export(module.exports, "mergeLines", function () { return (parcelRequire("cZKSB")).mergeLines; });
$parcel$export(module.exports, "padStart", function () { return (parcelRequire("cZKSB")).padStart; });
$parcel$export(module.exports, "parseDate", function () { return (parcelRequire("cZKSB")).parseDate; });
$parcel$export(module.exports, "toCharCode", function () { return (parcelRequire("cZKSB")).toCharCode; });
$parcel$export(module.exports, "toCodePoint", function () { return (parcelRequire("cZKSB")).toCodePoint; });
$parcel$export(module.exports, "toHexString", function () { return (parcelRequire("cZKSB")).toHexString; });
$parcel$export(module.exports, "toHexStringOfMinLength", function () { return (parcelRequire("cZKSB")).toHexStringOfMinLength; });
$parcel$export(module.exports, "hasUtf16BOM", function () { return (parcelRequire("bPoC4")).hasUtf16BOM; });
$parcel$export(module.exports, "utf16Decode", function () { return (parcelRequire("bPoC4")).utf16Decode; });
$parcel$export(module.exports, "utf16Encode", function () { return (parcelRequire("bPoC4")).utf16Encode; });
$parcel$export(module.exports, "bytesFor", function () { return (parcelRequire("cXeLZ")).bytesFor; });
$parcel$export(module.exports, "numberToString", function () { return (parcelRequire("cXeLZ")).numberToString; });
$parcel$export(module.exports, "sizeInBytes", function () { return (parcelRequire("cXeLZ")).sizeInBytes; });
$parcel$export(module.exports, "error", function () { return (parcelRequire("evyBg")).error; });
$parcel$export(module.exports, "encodeToBase64", function () { return (parcelRequire("9GHB7")).encodeToBase64; });
$parcel$export(module.exports, "isStandardFont", function () { return (parcelRequire("4PFuJ")).isStandardFont; });
$parcel$export(module.exports, "rectanglesAreEqual", function () { return (parcelRequire("4PFuJ")).rectanglesAreEqual; });
$parcel$export(module.exports, "assertEachIs", function () { return (parcelRequire("2qnUk")).assertEachIs; });
$parcel$export(module.exports, "assertInteger", function () { return (parcelRequire("2qnUk")).assertInteger; });
$parcel$export(module.exports, "assertIs", function () { return (parcelRequire("2qnUk")).assertIs; });
$parcel$export(module.exports, "assertIsOneOf", function () { return (parcelRequire("2qnUk")).assertIsOneOf; });
$parcel$export(module.exports, "assertIsOneOfOrUndefined", function () { return (parcelRequire("2qnUk")).assertIsOneOfOrUndefined; });
$parcel$export(module.exports, "assertIsSubset", function () { return (parcelRequire("2qnUk")).assertIsSubset; });
$parcel$export(module.exports, "assertMultiple", function () { return (parcelRequire("2qnUk")).assertMultiple; });
$parcel$export(module.exports, "assertOrUndefined", function () { return (parcelRequire("2qnUk")).assertOrUndefined; });
$parcel$export(module.exports, "assertPositive", function () { return (parcelRequire("2qnUk")).assertPositive; });
$parcel$export(module.exports, "assertRange", function () { return (parcelRequire("2qnUk")).assertRange; });
$parcel$export(module.exports, "assertRangeOrUndefined", function () { return (parcelRequire("2qnUk")).assertRangeOrUndefined; });
$parcel$export(module.exports, "pdfDocEncodingDecode", function () { return (parcelRequire("8I4bY")).pdfDocEncodingDecode; });

$parcel$export(module.exports, "Cache", function () { return (parcelRequire("6E4Ej")).default; });
parcelRequire("i8eKs");
parcelRequire("egzXy");
parcelRequire("cZKSB");
parcelRequire("bPoC4");
parcelRequire("cXeLZ");
parcelRequire("evyBg");
parcelRequire("9GHB7");
parcelRequire("4PFuJ");
parcelRequire("2qnUk");
parcelRequire("8I4bY");

var $6E4Ej = parcelRequire("6E4Ej");

});
parcelRegister("i8eKs", function(module, exports) {

$parcel$export(module.exports, "last", function () { return $d3346a105c8db8a0$export$4c7897fafd92b108; });
$parcel$export(module.exports, "typedArrayFor", function () { return $d3346a105c8db8a0$export$98b44e66722b6f4d; });
$parcel$export(module.exports, "mergeIntoTypedArray", function () { return $d3346a105c8db8a0$export$8907b5381cbcd9a7; });
$parcel$export(module.exports, "mergeUint8Arrays", function () { return $d3346a105c8db8a0$export$99cee7ee2de7e6e4; });
$parcel$export(module.exports, "arrayAsString", function () { return $d3346a105c8db8a0$export$5f8f9664fe5c5f14; });
$parcel$export(module.exports, "byAscendingId", function () { return $d3346a105c8db8a0$export$55b6b1f56c6e1ba5; });
$parcel$export(module.exports, "sortedUniq", function () { return $d3346a105c8db8a0$export$720e3b5aefb27114; });
$parcel$export(module.exports, "reverseArray", function () { return $d3346a105c8db8a0$export$c9b97e771c4a8302; });
$parcel$export(module.exports, "sum", function () { return $d3346a105c8db8a0$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "range", function () { return $d3346a105c8db8a0$export$d02631cccf789723; });
$parcel$export(module.exports, "pluckIndices", function () { return $d3346a105c8db8a0$export$279d041ff3481d88; });
$parcel$export(module.exports, "canBeConvertedToUint8Array", function () { return $d3346a105c8db8a0$export$20e9c5ed92218c4b; });
$parcel$export(module.exports, "toUint8Array", function () { return $d3346a105c8db8a0$export$73470fd2221e6aef; });

var $9GHB7 = parcelRequire("9GHB7");

var $cZKSB = parcelRequire("cZKSB");
var $d3346a105c8db8a0$export$4c7897fafd92b108 = function(array) {
    return array[array.length - 1];
};
var $d3346a105c8db8a0$export$98b44e66722b6f4d = function(value) {
    if (value instanceof Uint8Array) return value;
    var length = value.length;
    var typedArray = new Uint8Array(length);
    for(var idx = 0; idx < length; idx++)typedArray[idx] = value.charCodeAt(idx);
    return typedArray;
};
var $d3346a105c8db8a0$export$8907b5381cbcd9a7 = function() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var arrayCount = arrays.length;
    var typedArrays = [];
    for(var idx = 0; idx < arrayCount; idx++){
        var element = arrays[idx];
        typedArrays[idx] = element instanceof Uint8Array ? element : $d3346a105c8db8a0$export$98b44e66722b6f4d(element);
    }
    var totalSize = 0;
    for(var idx = 0; idx < arrayCount; idx++)totalSize += arrays[idx].length;
    var merged = new Uint8Array(totalSize);
    var offset = 0;
    for(var arrIdx = 0; arrIdx < arrayCount; arrIdx++){
        var arr = typedArrays[arrIdx];
        for(var byteIdx = 0, arrLen = arr.length; byteIdx < arrLen; byteIdx++)merged[offset++] = arr[byteIdx];
    }
    return merged;
};
var $d3346a105c8db8a0$export$99cee7ee2de7e6e4 = function(arrays) {
    var totalSize = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++)totalSize += arrays[idx].length;
    var mergedBuffer = new Uint8Array(totalSize);
    var offset = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++){
        var array = arrays[idx];
        mergedBuffer.set(array, offset);
        offset += array.length;
    }
    return mergedBuffer;
};
var $d3346a105c8db8a0$export$5f8f9664fe5c5f14 = function(array) {
    var str = "";
    for(var idx = 0, len = array.length; idx < len; idx++)str += (0, $cZKSB.charFromCode)(array[idx]);
    return str;
};
var $d3346a105c8db8a0$export$55b6b1f56c6e1ba5 = function(a, b) {
    return a.id - b.id;
};
var $d3346a105c8db8a0$export$720e3b5aefb27114 = function(array, indexer) {
    var uniq = [];
    for(var idx = 0, len = array.length; idx < len; idx++){
        var curr = array[idx];
        var prev = array[idx - 1];
        if (idx === 0 || indexer(curr) !== indexer(prev)) uniq.push(curr);
    }
    return uniq;
};
var $d3346a105c8db8a0$export$c9b97e771c4a8302 = function(array) {
    var arrayLen = array.length;
    for(var idx = 0, len = Math.floor(arrayLen / 2); idx < len; idx++){
        var leftIdx = idx;
        var rightIdx = arrayLen - idx - 1;
        var temp = array[idx];
        array[leftIdx] = array[rightIdx];
        array[rightIdx] = temp;
    }
    return array;
};
var $d3346a105c8db8a0$export$8a63f25cc62965f1 = function(array) {
    var total = 0;
    for(var idx = 0, len = array.length; idx < len; idx++)total += array[idx];
    return total;
};
var $d3346a105c8db8a0$export$d02631cccf789723 = function(start, end) {
    var arr = new Array(end - start);
    for(var idx = 0, len = arr.length; idx < len; idx++)arr[idx] = start + idx;
    return arr;
};
var $d3346a105c8db8a0$export$279d041ff3481d88 = function(arr, indices) {
    var plucked = new Array(indices.length);
    for(var idx = 0, len = indices.length; idx < len; idx++)plucked[idx] = arr[indices[idx]];
    return plucked;
};
var $d3346a105c8db8a0$export$20e9c5ed92218c4b = function(input) {
    return input instanceof Uint8Array || input instanceof ArrayBuffer || typeof input === "string";
};
var $d3346a105c8db8a0$export$73470fd2221e6aef = function(input) {
    if (typeof input === "string") return (0, $9GHB7.decodeFromBase64DataUri)(input);
    else if (input instanceof ArrayBuffer) return new Uint8Array(input);
    else if (input instanceof Uint8Array) return input;
    else throw new TypeError("`input` must be one of `string | ArrayBuffer | Uint8Array`");
};

});
parcelRegister("9GHB7", function(module, exports) {

$parcel$export(module.exports, "encodeToBase64", function () { return $70d9daeaba80dc3e$export$373f4c3083978ffd; });
$parcel$export(module.exports, "decodeFromBase64DataUri", function () { return $70d9daeaba80dc3e$export$f6810f5086699d73; });
/*
 * The `chars`, `lookup`, `encode`, and `decode` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ var $70d9daeaba80dc3e$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var $70d9daeaba80dc3e$var$lookup = new Uint8Array(256);
for(var $70d9daeaba80dc3e$var$i = 0; $70d9daeaba80dc3e$var$i < $70d9daeaba80dc3e$var$chars.length; $70d9daeaba80dc3e$var$i++)$70d9daeaba80dc3e$var$lookup[$70d9daeaba80dc3e$var$chars.charCodeAt($70d9daeaba80dc3e$var$i)] = $70d9daeaba80dc3e$var$i;
var $70d9daeaba80dc3e$export$373f4c3083978ffd = function(bytes) {
    var base64 = "";
    var len = bytes.length;
    for(var i = 0; i < len; i += 3){
        base64 += $70d9daeaba80dc3e$var$chars[bytes[i] >> 2];
        base64 += $70d9daeaba80dc3e$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $70d9daeaba80dc3e$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $70d9daeaba80dc3e$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
var $70d9daeaba80dc3e$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $70d9daeaba80dc3e$var$lookup[base64.charCodeAt(i)];
        encoded2 = $70d9daeaba80dc3e$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $70d9daeaba80dc3e$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $70d9daeaba80dc3e$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
// This regex is designed to be as flexible as possible. It will parse certain
// invalid data URIs.
var $70d9daeaba80dc3e$var$DATA_URI_PREFIX_REGEX = /^(data)?:?([\w\/\+]+)?;?(charset=[\w-]+|base64)?.*,/i;
var $70d9daeaba80dc3e$export$f6810f5086699d73 = function(dataUri) {
    var trimmedUri = dataUri.trim();
    var prefix = trimmedUri.substring(0, 100);
    var res = prefix.match($70d9daeaba80dc3e$var$DATA_URI_PREFIX_REGEX);
    // Assume it's not a data URI - just a plain base64 string
    if (!res) return $70d9daeaba80dc3e$export$83edfd8fcc66ec17(trimmedUri);
    // Remove the data URI prefix and parse the remainder as a base64 string
    var fullMatch = res[0];
    var data = trimmedUri.substring(fullMatch.length);
    return $70d9daeaba80dc3e$export$83edfd8fcc66ec17(data);
};

});

parcelRegister("cZKSB", function(module, exports) {

$parcel$export(module.exports, "toCharCode", function () { return $975f8bdd0461166f$export$d90166409dd04e85; });
$parcel$export(module.exports, "toCodePoint", function () { return $975f8bdd0461166f$export$93bf578f015d73f0; });
$parcel$export(module.exports, "toHexStringOfMinLength", function () { return $975f8bdd0461166f$export$6ac97d2d1bf41f39; });
$parcel$export(module.exports, "padStart", function () { return $975f8bdd0461166f$export$36cf564d487b5178; });
$parcel$export(module.exports, "toHexString", function () { return $975f8bdd0461166f$export$f4915efbb94d4d01; });
$parcel$export(module.exports, "charFromCode", function () { return $975f8bdd0461166f$export$207031940e6950ad; });
$parcel$export(module.exports, "charFromHexCode", function () { return $975f8bdd0461166f$export$ceedd1b69dcde7a5; });
$parcel$export(module.exports, "copyStringIntoBuffer", function () { return $975f8bdd0461166f$export$c41a03555c37a984; });
$parcel$export(module.exports, "cleanText", function () { return $975f8bdd0461166f$export$6b5e57d20078142b; });
$parcel$export(module.exports, "lineSplit", function () { return $975f8bdd0461166f$export$4f60280859794d8c; });
$parcel$export(module.exports, "mergeLines", function () { return $975f8bdd0461166f$export$b5bf5e120f07cbe; });
$parcel$export(module.exports, "charAtIndex", function () { return $975f8bdd0461166f$export$1a93fc5af577aa5c; });
$parcel$export(module.exports, "charSplit", function () { return $975f8bdd0461166f$export$78f5a8ab9b5e7f1e; });
$parcel$export(module.exports, "breakTextIntoLines", function () { return $975f8bdd0461166f$export$38936f7739928807; });
$parcel$export(module.exports, "parseDate", function () { return $975f8bdd0461166f$export$6b862160d295c8e; });
$parcel$export(module.exports, "findLastMatch", function () { return $975f8bdd0461166f$export$dc1d7d42f51764e3; });
var $975f8bdd0461166f$export$d90166409dd04e85 = function(character) {
    return character.charCodeAt(0);
};
var $975f8bdd0461166f$export$93bf578f015d73f0 = function(character) {
    return character.codePointAt(0);
};
var $975f8bdd0461166f$export$6ac97d2d1bf41f39 = function(num, minLength) {
    return $975f8bdd0461166f$export$36cf564d487b5178(num.toString(16), minLength, "0").toUpperCase();
};
var $975f8bdd0461166f$export$f4915efbb94d4d01 = function(num) {
    return $975f8bdd0461166f$export$6ac97d2d1bf41f39(num, 2);
};
var $975f8bdd0461166f$export$207031940e6950ad = function(code) {
    return String.fromCharCode(code);
};
var $975f8bdd0461166f$export$ceedd1b69dcde7a5 = function(hex) {
    return $975f8bdd0461166f$export$207031940e6950ad(parseInt(hex, 16));
};
var $975f8bdd0461166f$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = "";
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};
var $975f8bdd0461166f$export$c41a03555c37a984 = function(str, buffer, offset) {
    var length = str.length;
    for(var idx = 0; idx < length; idx++)buffer[offset++] = str.charCodeAt(idx);
    return length;
};
var $975f8bdd0461166f$export$505d8f7c00d806ca = function(prefix, suffixLength) {
    if (suffixLength === void 0) suffixLength = 4;
    return prefix + "-" + Math.floor(Math.random() * Math.pow(10, suffixLength));
};
var $975f8bdd0461166f$export$7c57da42ce8e346f = function(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};
var $975f8bdd0461166f$export$6b5e57d20078142b = function(text) {
    return text.replace(/\t|\u0085|\u2028|\u2029/g, "    ").replace(/[\b\v]/g, "");
};
var $975f8bdd0461166f$export$60bd2eb6e5a75df0 = [
    "\\n",
    "\\f",
    "\\r",
    "\\u000B"
];
var $975f8bdd0461166f$export$634cc0013ed0f624 = [
    "\n",
    "\f",
    "\r",
    "\v"
];
var $975f8bdd0461166f$export$3fc8feceeed3beb0 = function(text) {
    return /^[\n\f\r\u000B]$/.test(text);
};
var $975f8bdd0461166f$export$4f60280859794d8c = function(text) {
    return text.split(/[\n\f\r\u000B]/);
};
var $975f8bdd0461166f$export$b5bf5e120f07cbe = function(text) {
    return text.replace(/[\n\f\r\u000B]/g, " ");
};
var $975f8bdd0461166f$export$1a93fc5af577aa5c = function(text, index) {
    // Get the first code unit and code unit value
    var cuFirst = text.charCodeAt(index);
    var cuSecond;
    var nextIndex = index + 1;
    var length = 1;
    if (// Check if it's the start of a surrogate pair.
    cuFirst >= 0xd800 && cuFirst <= 0xdbff && // high surrogate
    text.length > nextIndex // there is a next code unit
    ) {
        cuSecond = text.charCodeAt(nextIndex);
        if (cuSecond >= 0xdc00 && cuSecond <= 0xdfff) length = 2; // low surrogate
    }
    return [
        text.slice(index, index + length),
        length
    ];
};
var $975f8bdd0461166f$export$78f5a8ab9b5e7f1e = function(text) {
    var chars = [];
    for(var idx = 0, len = text.length; idx < len;){
        var _a = $975f8bdd0461166f$export$1a93fc5af577aa5c(text, idx), c = _a[0], cLen = _a[1];
        chars.push(c);
        idx += cLen;
    }
    return chars;
};
var $975f8bdd0461166f$var$buildWordBreakRegex = function(wordBreaks) {
    var newlineCharUnion = $975f8bdd0461166f$export$60bd2eb6e5a75df0.join("|");
    var escapedRules = [
        "$"
    ];
    for(var idx = 0, len = wordBreaks.length; idx < len; idx++){
        var wordBreak = wordBreaks[idx];
        if ($975f8bdd0461166f$export$3fc8feceeed3beb0(wordBreak)) throw new TypeError("`wordBreak` must not include " + newlineCharUnion);
        escapedRules.push(wordBreak === "" ? "." : $975f8bdd0461166f$export$7c57da42ce8e346f(wordBreak));
    }
    var breakRules = escapedRules.join("|");
    return new RegExp("(" + newlineCharUnion + ")|((.*?)(" + breakRules + "))", "gm");
};
var $975f8bdd0461166f$export$38936f7739928807 = function(text, wordBreaks, maxWidth, computeWidthOfText) {
    var regex = $975f8bdd0461166f$var$buildWordBreakRegex(wordBreaks);
    var words = $975f8bdd0461166f$export$6b5e57d20078142b(text).match(regex);
    var currLine = "";
    var currWidth = 0;
    var lines = [];
    var pushCurrLine = function() {
        if (currLine !== "") lines.push(currLine);
        currLine = "";
        currWidth = 0;
    };
    for(var idx = 0, len = words.length; idx < len; idx++){
        var word = words[idx];
        if ($975f8bdd0461166f$export$3fc8feceeed3beb0(word)) pushCurrLine();
        else {
            var width = computeWidthOfText(word);
            if (currWidth + width > maxWidth) pushCurrLine();
            currLine += word;
            currWidth += width;
        }
    }
    pushCurrLine();
    return lines;
};
// See section "7.9.4 Dates" of the PDF specification
var $975f8bdd0461166f$var$dateRegex = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/;
var $975f8bdd0461166f$export$6b862160d295c8e = function(dateStr) {
    var match = dateStr.match($975f8bdd0461166f$var$dateRegex);
    if (!match) return undefined;
    var year = match[1], _a = match[2], month = _a === void 0 ? "01" : _a, _b = match[3], day = _b === void 0 ? "01" : _b, _c = match[4], hours = _c === void 0 ? "00" : _c, _d = match[5], mins = _d === void 0 ? "00" : _d, _e = match[6], secs = _e === void 0 ? "00" : _e, _f = match[7], offsetSign = _f === void 0 ? "Z" : _f, _g = match[8], offsetHours = _g === void 0 ? "00" : _g, _h = match[9], offsetMins = _h === void 0 ? "00" : _h;
    // http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15
    var tzOffset = offsetSign === "Z" ? "Z" : "" + offsetSign + offsetHours + ":" + offsetMins;
    var date = new Date(year + "-" + month + "-" + day + "T" + hours + ":" + mins + ":" + secs + tzOffset);
    return date;
};
var $975f8bdd0461166f$export$dc1d7d42f51764e3 = function(value, regex) {
    var _a;
    var position = 0;
    var lastMatch;
    while(position < value.length){
        var match = value.substring(position).match(regex);
        if (!match) return {
            match: lastMatch,
            pos: position
        };
        lastMatch = match;
        position += ((_a = match.index) !== null && _a !== void 0 ? _a : 0) + match[0].length;
    }
    return {
        match: lastMatch,
        pos: position
    };
};

});


parcelRegister("egzXy", function(module, exports) {

$parcel$export(module.exports, "waitForTick", function () { return $a62e7424f762f979$export$3b7198a3beef1a5f; });
/**
 * Returns a Promise that resolves after at least one tick of the
 * Macro Task Queue occurs.
 */ var $a62e7424f762f979$export$3b7198a3beef1a5f = function() {
    return new Promise(function(resolve) {
        setTimeout(function() {
            return resolve();
        }, 0);
    });
};

});

parcelRegister("bPoC4", function(module, exports) {

$parcel$export(module.exports, "utf16Encode", function () { return $89c78cc5928a4ada$export$73704d2337848c8e; });
$parcel$export(module.exports, "highSurrogate", function () { return $89c78cc5928a4ada$export$8d3bd4086f36eaeb; });
$parcel$export(module.exports, "lowSurrogate", function () { return $89c78cc5928a4ada$export$382051c72943492d; });
$parcel$export(module.exports, "isWithinBMP", function () { return $89c78cc5928a4ada$export$919ae47c3852aa15; });
$parcel$export(module.exports, "hasSurrogates", function () { return $89c78cc5928a4ada$export$d5ab89e7561b44ab; });
$parcel$export(module.exports, "utf16Decode", function () { return $89c78cc5928a4ada$export$b89f54f9db637f79; });
$parcel$export(module.exports, "hasUtf16BOM", function () { return $89c78cc5928a4ada$export$41e7c15c75b1b24d; });

var $cZKSB = parcelRequire("cZKSB");
var $89c78cc5928a4ada$export$e1b32e613f230dc6 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xef, 0xbb, 0xbf);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // One byte encoding
        if (codePoint < 0x80) {
            var byte1 = codePoint & 0x7f;
            encoded.push(byte1);
            idx += 1;
        } else if (codePoint < 0x0800) {
            var byte1 = codePoint >> 6 & 0x1f | 0xc0;
            var byte2 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2);
            idx += 1;
        } else if (codePoint < 0x010000) {
            var byte1 = codePoint >> 12 & 0x0f | 0xe0;
            var byte2 = codePoint >> 6 & 0x3f | 0x80;
            var byte3 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3);
            idx += 1;
        } else if (codePoint < 0x110000) {
            var byte1 = codePoint >> 18 & 0x07 | 0xf0;
            var byte2 = codePoint >> 12 & 0x3f | 0x80;
            var byte3 = codePoint >> 6 & 0x3f | 0x80;
            var byte4 = codePoint >> 0 & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3, byte4);
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $cZKSB.toHexString)(codePoint));
    }
    return new Uint8Array(encoded);
};
var $89c78cc5928a4ada$export$73704d2337848c8e = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xfeff);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // Two byte encoding
        if (codePoint < 0x010000) {
            encoded.push(codePoint);
            idx += 1;
        } else if (codePoint < 0x110000) {
            encoded.push($89c78cc5928a4ada$export$8d3bd4086f36eaeb(codePoint), $89c78cc5928a4ada$export$382051c72943492d(codePoint));
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $cZKSB.toHexString)(codePoint));
    }
    return new Uint16Array(encoded);
};
var $89c78cc5928a4ada$export$919ae47c3852aa15 = function(codePoint) {
    return codePoint >= 0 && codePoint <= 0xffff;
};
var $89c78cc5928a4ada$export$d5ab89e7561b44ab = function(codePoint) {
    return codePoint >= 0x010000 && codePoint <= 0x10ffff;
};
var $89c78cc5928a4ada$export$8d3bd4086f36eaeb = function(codePoint) {
    return Math.floor((codePoint - 0x10000) / 0x400) + 0xd800;
};
var $89c78cc5928a4ada$export$382051c72943492d = function(codePoint) {
    return (codePoint - 0x10000) % 0x400 + 0xdc00;
};
var $89c78cc5928a4ada$var$ByteOrder;
(function(ByteOrder) {
    ByteOrder["BigEndian"] = "BigEndian";
    ByteOrder["LittleEndian"] = "LittleEndian";
})($89c78cc5928a4ada$var$ByteOrder || ($89c78cc5928a4ada$var$ByteOrder = {}));
var $89c78cc5928a4ada$var$REPLACEMENT = "\uFFFD".codePointAt(0);
var $89c78cc5928a4ada$export$b89f54f9db637f79 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    // Need at least 2 bytes of data in UTF-16 encodings
    if (input.length <= 1) return String.fromCodePoint($89c78cc5928a4ada$var$REPLACEMENT);
    var byteOrder = byteOrderMark ? $89c78cc5928a4ada$var$readBOM(input) : $89c78cc5928a4ada$var$ByteOrder.BigEndian;
    // Skip byte order mark if needed
    var idx = byteOrderMark ? 2 : 0;
    var codePoints = [];
    while(input.length - idx >= 2){
        var first = $89c78cc5928a4ada$var$decodeValues(input[idx++], input[idx++], byteOrder);
        if ($89c78cc5928a4ada$var$isHighSurrogate(first)) {
            if (input.length - idx < 2) // Need at least 2 bytes left for the low surrogate that is required
            codePoints.push($89c78cc5928a4ada$var$REPLACEMENT);
            else {
                var second = $89c78cc5928a4ada$var$decodeValues(input[idx++], input[idx++], byteOrder);
                if ($89c78cc5928a4ada$var$isLowSurrogate(second)) codePoints.push(first, second);
                else // Low surrogates should always follow high surrogates
                codePoints.push($89c78cc5928a4ada$var$REPLACEMENT);
            }
        } else if ($89c78cc5928a4ada$var$isLowSurrogate(first)) {
            // High surrogates should always come first since `decodeValues()`
            // accounts for the byte ordering
            idx += 2;
            codePoints.push($89c78cc5928a4ada$var$REPLACEMENT);
        } else codePoints.push(first);
    }
    // There shouldn't be extra byte(s) left over
    if (idx < input.length) codePoints.push($89c78cc5928a4ada$var$REPLACEMENT);
    return String.fromCodePoint.apply(String, codePoints);
};
/**
 * Returns `true` if the given `codePoint` is a high surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $89c78cc5928a4ada$var$isHighSurrogate = function(codePoint) {
    return codePoint >= 0xd800 && codePoint <= 0xdbff;
};
/**
 * Returns `true` if the given `codePoint` is a low surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $89c78cc5928a4ada$var$isLowSurrogate = function(codePoint) {
    return codePoint >= 0xdc00 && codePoint <= 0xdfff;
};
/**
 * Decodes the given utf-16 values first and second using the specified
 * byte order.
 * @param first The first byte of the encoding.
 * @param second The second byte of the encoding.
 * @param byteOrder The byte order of the encoding.
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Examples
 */ var $89c78cc5928a4ada$var$decodeValues = function(first, second, byteOrder) {
    // Append the binary representation of the preceding byte by shifting the
    // first one 8 to the left and than applying a bitwise or-operator to append
    // the second one.
    if (byteOrder === $89c78cc5928a4ada$var$ByteOrder.LittleEndian) return second << 8 | first;
    if (byteOrder === $89c78cc5928a4ada$var$ByteOrder.BigEndian) return first << 8 | second;
    throw new Error("Invalid byteOrder: " + byteOrder);
};
/**
 * Returns whether the given array contains a byte order mark for the
 * UTF-16BE or UTF-16LE encoding. If it has neither, BigEndian is assumed.
 *
 * Reference: https://en.wikipedia.org/wiki/Byte_order_mark#UTF-16
 *
 * @param bytes The byte array to be evaluated.
 */ // prettier-ignore
var $89c78cc5928a4ada$var$readBOM = function(bytes) {
    return $89c78cc5928a4ada$var$hasUtf16BigEndianBOM(bytes) ? $89c78cc5928a4ada$var$ByteOrder.BigEndian : $89c78cc5928a4ada$var$hasUtf16LittleEndianBOM(bytes) ? $89c78cc5928a4ada$var$ByteOrder.LittleEndian : $89c78cc5928a4ada$var$ByteOrder.BigEndian;
};
var $89c78cc5928a4ada$var$hasUtf16BigEndianBOM = function(bytes) {
    return bytes[0] === 0xfe && bytes[1] === 0xff;
};
var $89c78cc5928a4ada$var$hasUtf16LittleEndianBOM = function(bytes) {
    return bytes[0] === 0xff && bytes[1] === 0xfe;
};
var $89c78cc5928a4ada$export$41e7c15c75b1b24d = function(bytes) {
    return $89c78cc5928a4ada$var$hasUtf16BigEndianBOM(bytes) || $89c78cc5928a4ada$var$hasUtf16LittleEndianBOM(bytes);
};

});

parcelRegister("cXeLZ", function(module, exports) {

$parcel$export(module.exports, "numberToString", function () { return $96e674572173e752$export$f67be9d9b0e25d7b; });
$parcel$export(module.exports, "sizeInBytes", function () { return $96e674572173e752$export$cc6acfd7a782614d; });
$parcel$export(module.exports, "bytesFor", function () { return $96e674572173e752$export$3c7962b7d5fa4e42; });
// tslint:disable radix
/**
 * Converts a number to its string representation in decimal. This function
 * differs from simply converting a number to a string with `.toString()`
 * because this function's output string will **not** contain exponential
 * notation.
 *
 * Credit: https://stackoverflow.com/a/46545519
 */ var $96e674572173e752$export$f67be9d9b0e25d7b = function(num) {
    var numStr = String(num);
    if (Math.abs(num) < 1.0) {
        var e = parseInt(num.toString().split("e-")[1]);
        if (e) {
            var negative = num < 0;
            if (negative) num *= -1;
            num *= Math.pow(10, e - 1);
            numStr = "0." + new Array(e).join("0") + num.toString().substring(2);
            if (negative) numStr = "-" + numStr;
        }
    } else {
        var e = parseInt(num.toString().split("+")[1]);
        if (e > 20) {
            e -= 20;
            num /= Math.pow(10, e);
            numStr = num.toString() + new Array(e + 1).join("0");
        }
    }
    return numStr;
};
var $96e674572173e752$export$cc6acfd7a782614d = function(n) {
    return Math.ceil(n.toString(2).length / 8);
};
var $96e674572173e752$export$3c7962b7d5fa4e42 = function(n) {
    var bytes = new Uint8Array($96e674572173e752$export$cc6acfd7a782614d(n));
    for(var i = 1; i <= bytes.length; i++)bytes[i - 1] = n >> (bytes.length - i) * 8;
    return bytes;
};

});

parcelRegister("evyBg", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $a8fecccac10a8751$export$a3bc9b8ed74fc; });
var $a8fecccac10a8751$export$a3bc9b8ed74fc = function(msg) {
    throw new Error(msg);
};

});

parcelRegister("4PFuJ", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $384c1cd2d08b4440$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "isStandardFont", function () { return $384c1cd2d08b4440$export$f2950432a4491977; });
$parcel$export(module.exports, "rectanglesAreEqual", function () { return $384c1cd2d08b4440$export$93263d7e9f52c023; });
parcelRequire("9Mq7C");
var $7yxAx = parcelRequire("7yxAx");
var $384c1cd2d08b4440$export$68c286be0e7e55b7 = function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $384c1cd2d08b4440$export$59252e21bbb61725 = $384c1cd2d08b4440$export$68c286be0e7e55b7((0, $7yxAx.FontNames));
var $384c1cd2d08b4440$export$f2950432a4491977 = function(input) {
    return $384c1cd2d08b4440$export$59252e21bbb61725.includes(input);
};
var $384c1cd2d08b4440$export$93263d7e9f52c023 = function(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
};

});
parcelRegister("9Mq7C", function(module, exports) {
$parcel$export(module.exports, "Font", function () { return (parcelRequire("7yxAx")).Font; });
$parcel$export(module.exports, "FontNames", function () { return (parcelRequire("7yxAx")).FontNames; });
$parcel$export(module.exports, "Encodings", function () { return (parcelRequire("gMRCf")).Encodings; });
parcelRequire("7yxAx");
parcelRequire("gMRCf");

});
parcelRegister("7yxAx", function(module, exports) {

$parcel$export(module.exports, "FontNames", function () { return $5805c34d0956c90e$export$a1e7b970f5a14844; });
$parcel$export(module.exports, "Font", function () { return $5805c34d0956c90e$export$89abf52a030e56ee; });

var $h1seI = parcelRequire("h1seI");

var $lzhEg = parcelRequire("lzhEg");

var $ciUVV = parcelRequire("ciUVV");

var $9pxsr = parcelRequire("9pxsr");

var $kdd0L = parcelRequire("kdd0L");

var $fzlmn = parcelRequire("fzlmn");

var $7OLpt = parcelRequire("7OLpt");

var $6XKHD = parcelRequire("6XKHD");

var $dYKni = parcelRequire("dYKni");

var $gfvkf = parcelRequire("gfvkf");

var $9nKIA = parcelRequire("9nKIA");

var $2tWPf = parcelRequire("2tWPf");

var $6YBy7 = parcelRequire("6YBy7");

var $4W3VQ = parcelRequire("4W3VQ");

var $islrW = parcelRequire("islrW");
// prettier-ignore
var $5805c34d0956c90e$var$compressedJsonForFontName = {
    "Courier": (0, (/*@__PURE__*/$parcel$interopDefault($kdd0L))),
    "Courier-Bold": (0, (/*@__PURE__*/$parcel$interopDefault($lzhEg))),
    "Courier-Oblique": (0, (/*@__PURE__*/$parcel$interopDefault($9pxsr))),
    "Courier-BoldOblique": (0, (/*@__PURE__*/$parcel$interopDefault($ciUVV))),
    "Helvetica": (0, (/*@__PURE__*/$parcel$interopDefault($dYKni))),
    "Helvetica-Bold": (0, (/*@__PURE__*/$parcel$interopDefault($fzlmn))),
    "Helvetica-Oblique": (0, (/*@__PURE__*/$parcel$interopDefault($6XKHD))),
    "Helvetica-BoldOblique": (0, (/*@__PURE__*/$parcel$interopDefault($7OLpt))),
    "Times-Roman": (0, (/*@__PURE__*/$parcel$interopDefault($6YBy7))),
    "Times-Bold": (0, (/*@__PURE__*/$parcel$interopDefault($gfvkf))),
    "Times-Italic": (0, (/*@__PURE__*/$parcel$interopDefault($2tWPf))),
    "Times-BoldItalic": (0, (/*@__PURE__*/$parcel$interopDefault($9nKIA))),
    "Symbol": (0, (/*@__PURE__*/$parcel$interopDefault($4W3VQ))),
    "ZapfDingbats": (0, (/*@__PURE__*/$parcel$interopDefault($islrW)))
};
var $5805c34d0956c90e$export$a1e7b970f5a14844;
(function(FontNames) {
    FontNames["Courier"] = "Courier";
    FontNames["CourierBold"] = "Courier-Bold";
    FontNames["CourierOblique"] = "Courier-Oblique";
    FontNames["CourierBoldOblique"] = "Courier-BoldOblique";
    FontNames["Helvetica"] = "Helvetica";
    FontNames["HelveticaBold"] = "Helvetica-Bold";
    FontNames["HelveticaOblique"] = "Helvetica-Oblique";
    FontNames["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    FontNames["TimesRoman"] = "Times-Roman";
    FontNames["TimesRomanBold"] = "Times-Bold";
    FontNames["TimesRomanItalic"] = "Times-Italic";
    FontNames["TimesRomanBoldItalic"] = "Times-BoldItalic";
    FontNames["Symbol"] = "Symbol";
    FontNames["ZapfDingbats"] = "ZapfDingbats";
})($5805c34d0956c90e$export$a1e7b970f5a14844 || ($5805c34d0956c90e$export$a1e7b970f5a14844 = {}));
var $5805c34d0956c90e$var$fontCache = {};
var $5805c34d0956c90e$export$89abf52a030e56ee = /** @class */ function() {
    function Font() {
        var _this = this;
        this.getWidthOfGlyph = function(glyphName) {
            return _this.CharWidths[glyphName];
        };
        this.getXAxisKerningForPair = function(leftGlyphName, rightGlyphName) {
            return (_this.KernPairXAmounts[leftGlyphName] || {})[rightGlyphName];
        };
    }
    Font.load = function(fontName) {
        var cachedFont = $5805c34d0956c90e$var$fontCache[fontName];
        if (cachedFont) return cachedFont;
        var json = (0, $h1seI.decompressJson)($5805c34d0956c90e$var$compressedJsonForFontName[fontName]);
        var font = Object.assign(new Font(), JSON.parse(json));
        font.CharWidths = font.CharMetrics.reduce(function(acc, metric) {
            acc[metric.N] = metric.WX;
            return acc;
        }, {});
        font.KernPairXAmounts = font.KernPairs.reduce(function(acc, _a) {
            var name1 = _a[0], name2 = _a[1], width = _a[2];
            if (!acc[name1]) acc[name1] = {};
            acc[name1][name2] = width;
            return acc;
        }, {});
        $5805c34d0956c90e$var$fontCache[fontName] = font;
        return font;
    };
    return Font;
}();

});
parcelRegister("h1seI", function(module, exports) {

$parcel$export(module.exports, "decompressJson", function () { return $c6486ed6fe8439b9$export$134b8d792d6efd14; });
$parcel$export(module.exports, "padStart", function () { return $c6486ed6fe8439b9$export$36cf564d487b5178; });
/*
 * The `chars`, `lookup`, and `decodeFromBase64` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ 
var $ckBc7 = parcelRequire("ckBc7");
var $c6486ed6fe8439b9$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var $c6486ed6fe8439b9$var$lookup = new Uint8Array(256);
for(var $c6486ed6fe8439b9$var$i = 0; $c6486ed6fe8439b9$var$i < $c6486ed6fe8439b9$var$chars.length; $c6486ed6fe8439b9$var$i++)$c6486ed6fe8439b9$var$lookup[$c6486ed6fe8439b9$var$chars.charCodeAt($c6486ed6fe8439b9$var$i)] = $c6486ed6fe8439b9$var$i;
var $c6486ed6fe8439b9$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $c6486ed6fe8439b9$var$lookup[base64.charCodeAt(i)];
        encoded2 = $c6486ed6fe8439b9$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $c6486ed6fe8439b9$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $c6486ed6fe8439b9$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
var $c6486ed6fe8439b9$var$arrayToString = function(array) {
    var str = "";
    for(var i = 0; i < array.length; i++)str += String.fromCharCode(array[i]);
    return str;
};
var $c6486ed6fe8439b9$export$134b8d792d6efd14 = function(compressedJson) {
    return $c6486ed6fe8439b9$var$arrayToString((0, (/*@__PURE__*/$parcel$interopDefault($ckBc7))).inflate($c6486ed6fe8439b9$export$83edfd8fcc66ec17(compressedJson)));
};
var $c6486ed6fe8439b9$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = "";
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};

});
parcelRegister("ckBc7", function(module, exports) {
// Top level file is just a mixin of submodules & constants
"use strict";

var $532Kf = parcelRequire("532Kf");
var $8fa43459601d418f$require$assign = $532Kf.assign;

var $kRM9U = parcelRequire("kRM9U");

var $gAuyB = parcelRequire("gAuyB");

var $gCeDq = parcelRequire("gCeDq");
var $8fa43459601d418f$var$pako = {};
$8fa43459601d418f$require$assign($8fa43459601d418f$var$pako, $kRM9U, $gAuyB, $gCeDq);
module.exports = $8fa43459601d418f$var$pako;

});
parcelRegister("532Kf", function(module, exports) {
"use strict";
var $3acf5ca733f2241d$var$TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
function $3acf5ca733f2241d$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(var p in source)if ($3acf5ca733f2241d$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $3acf5ca733f2241d$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $3acf5ca733f2241d$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $3acf5ca733f2241d$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $3acf5ca733f2241d$var$fnUntyped);
    }
};
module.exports.setTyped($3acf5ca733f2241d$var$TYPED_OK);

});

parcelRegister("kRM9U", function(module, exports) {

$parcel$export(module.exports, "Deflate", function () { return $f30e1d3fe39a2146$export$ae157b6234afe138; }, function (v) { return $f30e1d3fe39a2146$export$ae157b6234afe138 = v; });
$parcel$export(module.exports, "deflate", function () { return $f30e1d3fe39a2146$export$2316623ecd1285ab; }, function (v) { return $f30e1d3fe39a2146$export$2316623ecd1285ab = v; });
$parcel$export(module.exports, "deflateRaw", function () { return $f30e1d3fe39a2146$export$e95d6a8f69fb340a; }, function (v) { return $f30e1d3fe39a2146$export$e95d6a8f69fb340a = v; });
$parcel$export(module.exports, "gzip", function () { return $f30e1d3fe39a2146$export$69f0ea7cf3a331a8; }, function (v) { return $f30e1d3fe39a2146$export$69f0ea7cf3a331a8 = v; });
var $f30e1d3fe39a2146$export$ae157b6234afe138;
var $f30e1d3fe39a2146$export$2316623ecd1285ab;
var $f30e1d3fe39a2146$export$e95d6a8f69fb340a;
var $f30e1d3fe39a2146$export$69f0ea7cf3a331a8;
"use strict";

var $kY9Mx = parcelRequire("kY9Mx");

var $532Kf = parcelRequire("532Kf");

var $ksAc9 = parcelRequire("ksAc9");

var $cNAbT = parcelRequire("cNAbT");

var $hylP7 = parcelRequire("hylP7");
var $f30e1d3fe39a2146$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $f30e1d3fe39a2146$var$Z_NO_FLUSH = 0;
var $f30e1d3fe39a2146$var$Z_FINISH = 4;
var $f30e1d3fe39a2146$var$Z_OK = 0;
var $f30e1d3fe39a2146$var$Z_STREAM_END = 1;
var $f30e1d3fe39a2146$var$Z_SYNC_FLUSH = 2;
var $f30e1d3fe39a2146$var$Z_DEFAULT_COMPRESSION = -1;
var $f30e1d3fe39a2146$var$Z_DEFAULT_STRATEGY = 0;
var $f30e1d3fe39a2146$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $f30e1d3fe39a2146$var$Deflate(options) {
    if (!(this instanceof $f30e1d3fe39a2146$var$Deflate)) return new $f30e1d3fe39a2146$var$Deflate(options);
    this.options = $532Kf.assign({
        level: $f30e1d3fe39a2146$var$Z_DEFAULT_COMPRESSION,
        method: $f30e1d3fe39a2146$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $f30e1d3fe39a2146$var$Z_DEFAULT_STRATEGY,
        to: ""
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $hylP7();
    this.strm.avail_out = 0;
    var status = $kY9Mx.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $f30e1d3fe39a2146$var$Z_OK) throw new Error($cNAbT[status]);
    if (opt.header) $kY9Mx.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $ksAc9.string2buf(opt.dictionary);
        else if ($f30e1d3fe39a2146$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $kY9Mx.deflateSetDictionary(this.strm, dict);
        if (status !== $f30e1d3fe39a2146$var$Z_OK) throw new Error($cNAbT[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $f30e1d3fe39a2146$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $f30e1d3fe39a2146$var$Z_FINISH : $f30e1d3fe39a2146$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $ksAc9.string2buf(data);
    else if ($f30e1d3fe39a2146$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $532Kf.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $kY9Mx.deflate(strm, _mode); /* no bad return value */ 
        if (status !== $f30e1d3fe39a2146$var$Z_STREAM_END && status !== $f30e1d3fe39a2146$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $f30e1d3fe39a2146$var$Z_FINISH || _mode === $f30e1d3fe39a2146$var$Z_SYNC_FLUSH)) {
            if (this.options.to === "string") this.onData($ksAc9.buf2binstring($532Kf.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($532Kf.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $f30e1d3fe39a2146$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $f30e1d3fe39a2146$var$Z_FINISH) {
        status = $kY9Mx.deflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $f30e1d3fe39a2146$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $f30e1d3fe39a2146$var$Z_SYNC_FLUSH) {
        this.onEnd($f30e1d3fe39a2146$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $f30e1d3fe39a2146$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $f30e1d3fe39a2146$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $f30e1d3fe39a2146$var$Z_OK) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $532Kf.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $f30e1d3fe39a2146$var$deflate(input, options) {
    var deflator = new $f30e1d3fe39a2146$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $cNAbT[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $f30e1d3fe39a2146$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $f30e1d3fe39a2146$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $f30e1d3fe39a2146$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $f30e1d3fe39a2146$var$deflate(input, options);
}
$f30e1d3fe39a2146$export$ae157b6234afe138 = $f30e1d3fe39a2146$var$Deflate;
$f30e1d3fe39a2146$export$2316623ecd1285ab = $f30e1d3fe39a2146$var$deflate;
$f30e1d3fe39a2146$export$e95d6a8f69fb340a = $f30e1d3fe39a2146$var$deflateRaw;
$f30e1d3fe39a2146$export$69f0ea7cf3a331a8 = $f30e1d3fe39a2146$var$gzip;

});
parcelRegister("kY9Mx", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", function () { return $f440ffb97e942816$export$a65c7b2bde87cb70; }, function (v) { return $f440ffb97e942816$export$a65c7b2bde87cb70 = v; });
$parcel$export(module.exports, "deflateSetHeader", function () { return $f440ffb97e942816$export$1cd50f7b2515ba19; }, function (v) { return $f440ffb97e942816$export$1cd50f7b2515ba19 = v; });
$parcel$export(module.exports, "deflate", function () { return $f440ffb97e942816$export$2316623ecd1285ab; }, function (v) { return $f440ffb97e942816$export$2316623ecd1285ab = v; });
$parcel$export(module.exports, "deflateEnd", function () { return $f440ffb97e942816$export$599854fa319a815f; }, function (v) { return $f440ffb97e942816$export$599854fa319a815f = v; });
$parcel$export(module.exports, "deflateSetDictionary", function () { return $f440ffb97e942816$export$f55e0b3ab66b5d46; }, function (v) { return $f440ffb97e942816$export$f55e0b3ab66b5d46 = v; });
var $f440ffb97e942816$export$72b35d618fb8ad9b;
var $f440ffb97e942816$export$a65c7b2bde87cb70;
var $f440ffb97e942816$export$8f99f0e30bc7dd53;
var $f440ffb97e942816$export$e78fab288549509;
var $f440ffb97e942816$export$1cd50f7b2515ba19;
var $f440ffb97e942816$export$2316623ecd1285ab;
var $f440ffb97e942816$export$599854fa319a815f;
var $f440ffb97e942816$export$f55e0b3ab66b5d46;
var $f440ffb97e942816$export$12b6e1fcadea22f9;
"use strict";

var $532Kf = parcelRequire("532Kf");

var $ayjtf = parcelRequire("ayjtf");

var $rkt9O = parcelRequire("rkt9O");

var $gKg9v = parcelRequire("gKg9v");

var $cNAbT = parcelRequire("cNAbT");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $f440ffb97e942816$var$Z_NO_FLUSH = 0;
var $f440ffb97e942816$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $f440ffb97e942816$var$Z_FULL_FLUSH = 3;
var $f440ffb97e942816$var$Z_FINISH = 4;
var $f440ffb97e942816$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $f440ffb97e942816$var$Z_OK = 0;
var $f440ffb97e942816$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $f440ffb97e942816$var$Z_STREAM_ERROR = -2;
var $f440ffb97e942816$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $f440ffb97e942816$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $f440ffb97e942816$var$Z_DEFAULT_COMPRESSION = -1;
var $f440ffb97e942816$var$Z_FILTERED = 1;
var $f440ffb97e942816$var$Z_HUFFMAN_ONLY = 2;
var $f440ffb97e942816$var$Z_RLE = 3;
var $f440ffb97e942816$var$Z_FIXED = 4;
var $f440ffb97e942816$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $f440ffb97e942816$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $f440ffb97e942816$var$Z_DEFLATED = 8;
/*============================================================================*/ var $f440ffb97e942816$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $f440ffb97e942816$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $f440ffb97e942816$var$DEF_MEM_LEVEL = 8;
var $f440ffb97e942816$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $f440ffb97e942816$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $f440ffb97e942816$var$L_CODES = $f440ffb97e942816$var$LITERALS + 1 + $f440ffb97e942816$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $f440ffb97e942816$var$D_CODES = 30;
/* number of distance codes */ var $f440ffb97e942816$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $f440ffb97e942816$var$HEAP_SIZE = 2 * $f440ffb97e942816$var$L_CODES + 1;
/* maximum heap size */ var $f440ffb97e942816$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $f440ffb97e942816$var$MIN_MATCH = 3;
var $f440ffb97e942816$var$MAX_MATCH = 258;
var $f440ffb97e942816$var$MIN_LOOKAHEAD = $f440ffb97e942816$var$MAX_MATCH + $f440ffb97e942816$var$MIN_MATCH + 1;
var $f440ffb97e942816$var$PRESET_DICT = 0x20;
var $f440ffb97e942816$var$INIT_STATE = 42;
var $f440ffb97e942816$var$EXTRA_STATE = 69;
var $f440ffb97e942816$var$NAME_STATE = 73;
var $f440ffb97e942816$var$COMMENT_STATE = 91;
var $f440ffb97e942816$var$HCRC_STATE = 103;
var $f440ffb97e942816$var$BUSY_STATE = 113;
var $f440ffb97e942816$var$FINISH_STATE = 666;
var $f440ffb97e942816$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $f440ffb97e942816$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $f440ffb97e942816$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $f440ffb97e942816$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $f440ffb97e942816$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $f440ffb97e942816$var$err(strm, errorCode) {
    strm.msg = $cNAbT[errorCode];
    return errorCode;
}
function $f440ffb97e942816$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $f440ffb97e942816$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $f440ffb97e942816$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $532Kf.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $f440ffb97e942816$var$flush_block_only(s, last) {
    $ayjtf._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $f440ffb97e942816$var$flush_pending(s.strm);
}
function $f440ffb97e942816$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $f440ffb97e942816$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $f440ffb97e942816$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $532Kf.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $rkt9O(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $gKg9v(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $f440ffb97e942816$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $f440ffb97e942816$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $f440ffb97e942816$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $f440ffb97e942816$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $f440ffb97e942816$var$MAX_MATCH - (strend - scan);
        scan = strend - $f440ffb97e942816$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $f440ffb97e942816$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $f440ffb97e942816$var$MIN_LOOKAHEAD)) {
            $532Kf.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $f440ffb97e942816$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $f440ffb97e942816$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $f440ffb97e942816$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $f440ffb97e942816$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $f440ffb97e942816$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $f440ffb97e942816$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $f440ffb97e942816$var$fill_window(s);
            if (s.lookahead === 0 && flush === $f440ffb97e942816$var$Z_NO_FLUSH) return $f440ffb97e942816$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $f440ffb97e942816$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $f440ffb97e942816$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $f440ffb97e942816$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $f440ffb97e942816$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $f440ffb97e942816$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_FINISH_STARTED;
        /***/ return $f440ffb97e942816$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $f440ffb97e942816$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_NEED_MORE;
    /***/ }
    return $f440ffb97e942816$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $f440ffb97e942816$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $f440ffb97e942816$var$MIN_LOOKAHEAD) {
            $f440ffb97e942816$var$fill_window(s);
            if (s.lookahead < $f440ffb97e942816$var$MIN_LOOKAHEAD && flush === $f440ffb97e942816$var$Z_NO_FLUSH) return $f440ffb97e942816$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $f440ffb97e942816$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $f440ffb97e942816$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $f440ffb97e942816$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $f440ffb97e942816$var$longest_match(s, hash_head);
        if (s.match_length >= $f440ffb97e942816$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $ayjtf._tr_tally(s, s.strstart - s.match_start, s.match_length - $f440ffb97e942816$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $f440ffb97e942816$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $f440ffb97e942816$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ayjtf._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $f440ffb97e942816$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $f440ffb97e942816$var$MIN_MATCH - 1 ? s.strstart : $f440ffb97e942816$var$MIN_MATCH - 1;
    if (flush === $f440ffb97e942816$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $f440ffb97e942816$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_FINISH_STARTED;
        /***/ return $f440ffb97e942816$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $f440ffb97e942816$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_NEED_MORE;
    /***/ }
    return $f440ffb97e942816$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $f440ffb97e942816$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $f440ffb97e942816$var$MIN_LOOKAHEAD) {
            $f440ffb97e942816$var$fill_window(s);
            if (s.lookahead < $f440ffb97e942816$var$MIN_LOOKAHEAD && flush === $f440ffb97e942816$var$Z_NO_FLUSH) return $f440ffb97e942816$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $f440ffb97e942816$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $f440ffb97e942816$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $f440ffb97e942816$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $f440ffb97e942816$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $f440ffb97e942816$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $f440ffb97e942816$var$Z_FILTERED || s.match_length === $f440ffb97e942816$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $f440ffb97e942816$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $f440ffb97e942816$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $f440ffb97e942816$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $ayjtf._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $f440ffb97e942816$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $f440ffb97e942816$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $f440ffb97e942816$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $f440ffb97e942816$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $ayjtf._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $f440ffb97e942816$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $ayjtf._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $f440ffb97e942816$var$MIN_MATCH - 1 ? s.strstart : $f440ffb97e942816$var$MIN_MATCH - 1;
    if (flush === $f440ffb97e942816$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $f440ffb97e942816$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_FINISH_STARTED;
        /***/ return $f440ffb97e942816$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $f440ffb97e942816$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_NEED_MORE;
    /***/ }
    return $f440ffb97e942816$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $f440ffb97e942816$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $f440ffb97e942816$var$MAX_MATCH) {
            $f440ffb97e942816$var$fill_window(s);
            if (s.lookahead <= $f440ffb97e942816$var$MAX_MATCH && flush === $f440ffb97e942816$var$Z_NO_FLUSH) return $f440ffb97e942816$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $f440ffb97e942816$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $f440ffb97e942816$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $f440ffb97e942816$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $f440ffb97e942816$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $ayjtf._tr_tally(s, 1, s.match_length - $f440ffb97e942816$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ayjtf._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $f440ffb97e942816$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $f440ffb97e942816$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $f440ffb97e942816$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_FINISH_STARTED;
        /***/ return $f440ffb97e942816$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $f440ffb97e942816$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_NEED_MORE;
    /***/ }
    return $f440ffb97e942816$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $f440ffb97e942816$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $f440ffb97e942816$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $f440ffb97e942816$var$Z_NO_FLUSH) return $f440ffb97e942816$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ayjtf._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $f440ffb97e942816$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $f440ffb97e942816$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $f440ffb97e942816$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_FINISH_STARTED;
        /***/ return $f440ffb97e942816$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $f440ffb97e942816$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $f440ffb97e942816$var$BS_NEED_MORE;
    /***/ }
    return $f440ffb97e942816$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $f440ffb97e942816$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $f440ffb97e942816$var$configuration_table;
$f440ffb97e942816$var$configuration_table = [
    /*      good lazy nice chain */ new $f440ffb97e942816$var$Config(0, 0, 0, 0, $f440ffb97e942816$var$deflate_stored),
    /* 0 store only */ new $f440ffb97e942816$var$Config(4, 4, 8, 4, $f440ffb97e942816$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $f440ffb97e942816$var$Config(4, 5, 16, 8, $f440ffb97e942816$var$deflate_fast),
    /* 2 */ new $f440ffb97e942816$var$Config(4, 6, 32, 32, $f440ffb97e942816$var$deflate_fast),
    /* 3 */ new $f440ffb97e942816$var$Config(4, 4, 16, 16, $f440ffb97e942816$var$deflate_slow),
    /* 4 lazy matches */ new $f440ffb97e942816$var$Config(8, 16, 32, 32, $f440ffb97e942816$var$deflate_slow),
    /* 5 */ new $f440ffb97e942816$var$Config(8, 16, 128, 128, $f440ffb97e942816$var$deflate_slow),
    /* 6 */ new $f440ffb97e942816$var$Config(8, 32, 128, 256, $f440ffb97e942816$var$deflate_slow),
    /* 7 */ new $f440ffb97e942816$var$Config(32, 128, 258, 1024, $f440ffb97e942816$var$deflate_slow),
    /* 8 */ new $f440ffb97e942816$var$Config(32, 258, 258, 4096, $f440ffb97e942816$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $f440ffb97e942816$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $f440ffb97e942816$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $f440ffb97e942816$var$configuration_table[s.level].max_lazy;
    s.good_match = $f440ffb97e942816$var$configuration_table[s.level].good_length;
    s.nice_match = $f440ffb97e942816$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $f440ffb97e942816$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $f440ffb97e942816$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $f440ffb97e942816$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $f440ffb97e942816$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $532Kf.Buf16($f440ffb97e942816$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $532Kf.Buf16((2 * $f440ffb97e942816$var$D_CODES + 1) * 2);
    this.bl_tree = new $532Kf.Buf16((2 * $f440ffb97e942816$var$BL_CODES + 1) * 2);
    $f440ffb97e942816$var$zero(this.dyn_ltree);
    $f440ffb97e942816$var$zero(this.dyn_dtree);
    $f440ffb97e942816$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $532Kf.Buf16($f440ffb97e942816$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $532Kf.Buf16(2 * $f440ffb97e942816$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $f440ffb97e942816$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $532Kf.Buf16(2 * $f440ffb97e942816$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $f440ffb97e942816$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $f440ffb97e942816$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $f440ffb97e942816$var$err(strm, $f440ffb97e942816$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $f440ffb97e942816$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $f440ffb97e942816$var$INIT_STATE : $f440ffb97e942816$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $f440ffb97e942816$var$Z_NO_FLUSH;
    $ayjtf._tr_init(s);
    return $f440ffb97e942816$var$Z_OK;
}
function $f440ffb97e942816$var$deflateReset(strm) {
    var ret = $f440ffb97e942816$var$deflateResetKeep(strm);
    if (ret === $f440ffb97e942816$var$Z_OK) $f440ffb97e942816$var$lm_init(strm.state);
    return ret;
}
function $f440ffb97e942816$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $f440ffb97e942816$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $f440ffb97e942816$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $f440ffb97e942816$var$Z_OK;
}
function $f440ffb97e942816$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $f440ffb97e942816$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $f440ffb97e942816$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $f440ffb97e942816$var$MAX_MEM_LEVEL || method !== $f440ffb97e942816$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $f440ffb97e942816$var$Z_FIXED) return $f440ffb97e942816$var$err(strm, $f440ffb97e942816$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $f440ffb97e942816$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $f440ffb97e942816$var$MIN_MATCH - 1) / $f440ffb97e942816$var$MIN_MATCH);
    s.window = new $532Kf.Buf8(s.w_size * 2);
    s.head = new $532Kf.Buf16(s.hash_size);
    s.prev = new $532Kf.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $532Kf.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $f440ffb97e942816$var$deflateReset(strm);
}
function $f440ffb97e942816$var$deflateInit(strm, level) {
    return $f440ffb97e942816$var$deflateInit2(strm, level, $f440ffb97e942816$var$Z_DEFLATED, $f440ffb97e942816$var$MAX_WBITS, $f440ffb97e942816$var$DEF_MEM_LEVEL, $f440ffb97e942816$var$Z_DEFAULT_STRATEGY);
}
function $f440ffb97e942816$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $f440ffb97e942816$var$Z_BLOCK || flush < 0) return strm ? $f440ffb97e942816$var$err(strm, $f440ffb97e942816$var$Z_STREAM_ERROR) : $f440ffb97e942816$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $f440ffb97e942816$var$FINISH_STATE && flush !== $f440ffb97e942816$var$Z_FINISH) return $f440ffb97e942816$var$err(strm, strm.avail_out === 0 ? $f440ffb97e942816$var$Z_BUF_ERROR : $f440ffb97e942816$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $f440ffb97e942816$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $f440ffb97e942816$var$put_byte(s, 31);
            $f440ffb97e942816$var$put_byte(s, 139);
            $f440ffb97e942816$var$put_byte(s, 8);
            if (!s.gzhead) {
                $f440ffb97e942816$var$put_byte(s, 0);
                $f440ffb97e942816$var$put_byte(s, 0);
                $f440ffb97e942816$var$put_byte(s, 0);
                $f440ffb97e942816$var$put_byte(s, 0);
                $f440ffb97e942816$var$put_byte(s, 0);
                $f440ffb97e942816$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $f440ffb97e942816$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $f440ffb97e942816$var$put_byte(s, $f440ffb97e942816$var$OS_CODE);
                s.status = $f440ffb97e942816$var$BUSY_STATE;
            } else {
                $f440ffb97e942816$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $f440ffb97e942816$var$put_byte(s, s.gzhead.time & 0xff);
                $f440ffb97e942816$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $f440ffb97e942816$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $f440ffb97e942816$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $f440ffb97e942816$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $f440ffb97e942816$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $f440ffb97e942816$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $f440ffb97e942816$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $f440ffb97e942816$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $gKg9v(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $f440ffb97e942816$var$EXTRA_STATE;
            }
        } else {
            var header = $f440ffb97e942816$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $f440ffb97e942816$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $f440ffb97e942816$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $f440ffb97e942816$var$BUSY_STATE;
            $f440ffb97e942816$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $f440ffb97e942816$var$putShortMSB(s, strm.adler >>> 16);
                $f440ffb97e942816$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $f440ffb97e942816$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $gKg9v(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $f440ffb97e942816$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $f440ffb97e942816$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $gKg9v(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $f440ffb97e942816$var$NAME_STATE;
            }
        } else s.status = $f440ffb97e942816$var$NAME_STATE;
    }
    if (s.status === $f440ffb97e942816$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $gKg9v(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $f440ffb97e942816$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $f440ffb97e942816$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $gKg9v(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $f440ffb97e942816$var$COMMENT_STATE;
            }
        } else s.status = $f440ffb97e942816$var$COMMENT_STATE;
    }
    if (s.status === $f440ffb97e942816$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $gKg9v(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $f440ffb97e942816$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $f440ffb97e942816$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $gKg9v(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $f440ffb97e942816$var$HCRC_STATE;
        } else s.status = $f440ffb97e942816$var$HCRC_STATE;
    }
    if (s.status === $f440ffb97e942816$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $f440ffb97e942816$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $f440ffb97e942816$var$put_byte(s, strm.adler & 0xff);
                $f440ffb97e942816$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $f440ffb97e942816$var$BUSY_STATE;
            }
        } else s.status = $f440ffb97e942816$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $f440ffb97e942816$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $f440ffb97e942816$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $f440ffb97e942816$var$rank(flush) <= $f440ffb97e942816$var$rank(old_flush) && flush !== $f440ffb97e942816$var$Z_FINISH) return $f440ffb97e942816$var$err(strm, $f440ffb97e942816$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $f440ffb97e942816$var$FINISH_STATE && strm.avail_in !== 0) return $f440ffb97e942816$var$err(strm, $f440ffb97e942816$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $f440ffb97e942816$var$Z_NO_FLUSH && s.status !== $f440ffb97e942816$var$FINISH_STATE) {
        var bstate = s.strategy === $f440ffb97e942816$var$Z_HUFFMAN_ONLY ? $f440ffb97e942816$var$deflate_huff(s, flush) : s.strategy === $f440ffb97e942816$var$Z_RLE ? $f440ffb97e942816$var$deflate_rle(s, flush) : $f440ffb97e942816$var$configuration_table[s.level].func(s, flush);
        if (bstate === $f440ffb97e942816$var$BS_FINISH_STARTED || bstate === $f440ffb97e942816$var$BS_FINISH_DONE) s.status = $f440ffb97e942816$var$FINISH_STATE;
        if (bstate === $f440ffb97e942816$var$BS_NEED_MORE || bstate === $f440ffb97e942816$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $f440ffb97e942816$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $f440ffb97e942816$var$BS_BLOCK_DONE) {
            if (flush === $f440ffb97e942816$var$Z_PARTIAL_FLUSH) $ayjtf._tr_align(s);
            else if (flush !== $f440ffb97e942816$var$Z_BLOCK) {
                $ayjtf._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $f440ffb97e942816$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $f440ffb97e942816$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $f440ffb97e942816$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $f440ffb97e942816$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $f440ffb97e942816$var$Z_FINISH) return $f440ffb97e942816$var$Z_OK;
    if (s.wrap <= 0) return $f440ffb97e942816$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $f440ffb97e942816$var$put_byte(s, strm.adler & 0xff);
        $f440ffb97e942816$var$put_byte(s, strm.adler >> 8 & 0xff);
        $f440ffb97e942816$var$put_byte(s, strm.adler >> 16 & 0xff);
        $f440ffb97e942816$var$put_byte(s, strm.adler >> 24 & 0xff);
        $f440ffb97e942816$var$put_byte(s, strm.total_in & 0xff);
        $f440ffb97e942816$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $f440ffb97e942816$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $f440ffb97e942816$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $f440ffb97e942816$var$putShortMSB(s, strm.adler >>> 16);
        $f440ffb97e942816$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $f440ffb97e942816$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $f440ffb97e942816$var$Z_OK : $f440ffb97e942816$var$Z_STREAM_END;
}
function $f440ffb97e942816$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $f440ffb97e942816$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $f440ffb97e942816$var$INIT_STATE && status !== $f440ffb97e942816$var$EXTRA_STATE && status !== $f440ffb97e942816$var$NAME_STATE && status !== $f440ffb97e942816$var$COMMENT_STATE && status !== $f440ffb97e942816$var$HCRC_STATE && status !== $f440ffb97e942816$var$BUSY_STATE && status !== $f440ffb97e942816$var$FINISH_STATE) return $f440ffb97e942816$var$err(strm, $f440ffb97e942816$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $f440ffb97e942816$var$BUSY_STATE ? $f440ffb97e942816$var$err(strm, $f440ffb97e942816$var$Z_DATA_ERROR) : $f440ffb97e942816$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $f440ffb97e942816$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $f440ffb97e942816$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $f440ffb97e942816$var$INIT_STATE || s.lookahead) return $f440ffb97e942816$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $rkt9O(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $f440ffb97e942816$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $532Kf.Buf8(s.w_size);
        $532Kf.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $f440ffb97e942816$var$fill_window(s);
    while(s.lookahead >= $f440ffb97e942816$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($f440ffb97e942816$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $f440ffb97e942816$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $f440ffb97e942816$var$MIN_MATCH - 1;
        $f440ffb97e942816$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $f440ffb97e942816$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $f440ffb97e942816$var$Z_OK;
}
$f440ffb97e942816$export$72b35d618fb8ad9b = $f440ffb97e942816$var$deflateInit;
$f440ffb97e942816$export$a65c7b2bde87cb70 = $f440ffb97e942816$var$deflateInit2;
$f440ffb97e942816$export$8f99f0e30bc7dd53 = $f440ffb97e942816$var$deflateReset;
$f440ffb97e942816$export$e78fab288549509 = $f440ffb97e942816$var$deflateResetKeep;
$f440ffb97e942816$export$1cd50f7b2515ba19 = $f440ffb97e942816$var$deflateSetHeader;
$f440ffb97e942816$export$2316623ecd1285ab = $f440ffb97e942816$var$deflate;
$f440ffb97e942816$export$599854fa319a815f = $f440ffb97e942816$var$deflateEnd;
$f440ffb97e942816$export$f55e0b3ab66b5d46 = $f440ffb97e942816$var$deflateSetDictionary;
$f440ffb97e942816$export$12b6e1fcadea22f9 = "pako deflate (from Nodeca project)"; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("ayjtf", function(module, exports) {

$parcel$export(module.exports, "_tr_init", function () { return $7aec2ed5dfffaaa3$export$4e4fc0157c3cd14d; }, function (v) { return $7aec2ed5dfffaaa3$export$4e4fc0157c3cd14d = v; });
$parcel$export(module.exports, "_tr_stored_block", function () { return $7aec2ed5dfffaaa3$export$8959e34c5e020172; }, function (v) { return $7aec2ed5dfffaaa3$export$8959e34c5e020172 = v; });
$parcel$export(module.exports, "_tr_flush_block", function () { return $7aec2ed5dfffaaa3$export$44f15b52eef0cf41; }, function (v) { return $7aec2ed5dfffaaa3$export$44f15b52eef0cf41 = v; });
$parcel$export(module.exports, "_tr_tally", function () { return $7aec2ed5dfffaaa3$export$b3cbce147289408f; }, function (v) { return $7aec2ed5dfffaaa3$export$b3cbce147289408f = v; });
$parcel$export(module.exports, "_tr_align", function () { return $7aec2ed5dfffaaa3$export$bfb360e02ee9b403; }, function (v) { return $7aec2ed5dfffaaa3$export$bfb360e02ee9b403 = v; });
var $7aec2ed5dfffaaa3$export$4e4fc0157c3cd14d;
var $7aec2ed5dfffaaa3$export$8959e34c5e020172;
var $7aec2ed5dfffaaa3$export$44f15b52eef0cf41;
var $7aec2ed5dfffaaa3$export$b3cbce147289408f;
var $7aec2ed5dfffaaa3$export$bfb360e02ee9b403;
"use strict";

var $532Kf = parcelRequire("532Kf");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $7aec2ed5dfffaaa3$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $7aec2ed5dfffaaa3$var$Z_BINARY = 0;
var $7aec2ed5dfffaaa3$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $7aec2ed5dfffaaa3$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $7aec2ed5dfffaaa3$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $7aec2ed5dfffaaa3$var$STORED_BLOCK = 0;
var $7aec2ed5dfffaaa3$var$STATIC_TREES = 1;
var $7aec2ed5dfffaaa3$var$DYN_TREES = 2;
/* The three kinds of block type */ var $7aec2ed5dfffaaa3$var$MIN_MATCH = 3;
var $7aec2ed5dfffaaa3$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $7aec2ed5dfffaaa3$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $7aec2ed5dfffaaa3$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $7aec2ed5dfffaaa3$var$L_CODES = $7aec2ed5dfffaaa3$var$LITERALS + 1 + $7aec2ed5dfffaaa3$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $7aec2ed5dfffaaa3$var$D_CODES = 30;
/* number of distance codes */ var $7aec2ed5dfffaaa3$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $7aec2ed5dfffaaa3$var$HEAP_SIZE = 2 * $7aec2ed5dfffaaa3$var$L_CODES + 1;
/* maximum heap size */ var $7aec2ed5dfffaaa3$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $7aec2ed5dfffaaa3$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $7aec2ed5dfffaaa3$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $7aec2ed5dfffaaa3$var$END_BLOCK = 256;
/* end of block literal code */ var $7aec2ed5dfffaaa3$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $7aec2ed5dfffaaa3$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $7aec2ed5dfffaaa3$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $7aec2ed5dfffaaa3$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $7aec2ed5dfffaaa3$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $7aec2ed5dfffaaa3$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $7aec2ed5dfffaaa3$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $7aec2ed5dfffaaa3$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $7aec2ed5dfffaaa3$var$static_ltree = new Array(($7aec2ed5dfffaaa3$var$L_CODES + 2) * 2);
$7aec2ed5dfffaaa3$var$zero($7aec2ed5dfffaaa3$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $7aec2ed5dfffaaa3$var$static_dtree = new Array($7aec2ed5dfffaaa3$var$D_CODES * 2);
$7aec2ed5dfffaaa3$var$zero($7aec2ed5dfffaaa3$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $7aec2ed5dfffaaa3$var$_dist_code = new Array($7aec2ed5dfffaaa3$var$DIST_CODE_LEN);
$7aec2ed5dfffaaa3$var$zero($7aec2ed5dfffaaa3$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $7aec2ed5dfffaaa3$var$_length_code = new Array($7aec2ed5dfffaaa3$var$MAX_MATCH - $7aec2ed5dfffaaa3$var$MIN_MATCH + 1);
$7aec2ed5dfffaaa3$var$zero($7aec2ed5dfffaaa3$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $7aec2ed5dfffaaa3$var$base_length = new Array($7aec2ed5dfffaaa3$var$LENGTH_CODES);
$7aec2ed5dfffaaa3$var$zero($7aec2ed5dfffaaa3$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $7aec2ed5dfffaaa3$var$base_dist = new Array($7aec2ed5dfffaaa3$var$D_CODES);
$7aec2ed5dfffaaa3$var$zero($7aec2ed5dfffaaa3$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $7aec2ed5dfffaaa3$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $7aec2ed5dfffaaa3$var$static_l_desc;
var $7aec2ed5dfffaaa3$var$static_d_desc;
var $7aec2ed5dfffaaa3$var$static_bl_desc;
function $7aec2ed5dfffaaa3$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $7aec2ed5dfffaaa3$var$d_code(dist) {
    return dist < 256 ? $7aec2ed5dfffaaa3$var$_dist_code[dist] : $7aec2ed5dfffaaa3$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $7aec2ed5dfffaaa3$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $7aec2ed5dfffaaa3$var$send_bits(s, value, length) {
    if (s.bi_valid > $7aec2ed5dfffaaa3$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $7aec2ed5dfffaaa3$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $7aec2ed5dfffaaa3$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $7aec2ed5dfffaaa3$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $7aec2ed5dfffaaa3$var$send_code(s, c, tree) {
    $7aec2ed5dfffaaa3$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $7aec2ed5dfffaaa3$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $7aec2ed5dfffaaa3$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $7aec2ed5dfffaaa3$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $7aec2ed5dfffaaa3$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $7aec2ed5dfffaaa3$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $7aec2ed5dfffaaa3$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $7aec2ed5dfffaaa3$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($7aec2ed5dfffaaa3$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $7aec2ed5dfffaaa3$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $7aec2ed5dfffaaa3$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $7aec2ed5dfffaaa3$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($7aec2ed5dfffaaa3$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $7aec2ed5dfffaaa3$var$LENGTH_CODES - 1; code++){
        $7aec2ed5dfffaaa3$var$base_length[code] = length;
        for(n = 0; n < 1 << $7aec2ed5dfffaaa3$var$extra_lbits[code]; n++)$7aec2ed5dfffaaa3$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $7aec2ed5dfffaaa3$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $7aec2ed5dfffaaa3$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $7aec2ed5dfffaaa3$var$extra_dbits[code]; n++)$7aec2ed5dfffaaa3$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $7aec2ed5dfffaaa3$var$D_CODES; code++){
        $7aec2ed5dfffaaa3$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $7aec2ed5dfffaaa3$var$extra_dbits[code] - 7; n++)$7aec2ed5dfffaaa3$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $7aec2ed5dfffaaa3$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $7aec2ed5dfffaaa3$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $7aec2ed5dfffaaa3$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $7aec2ed5dfffaaa3$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $7aec2ed5dfffaaa3$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $7aec2ed5dfffaaa3$var$gen_codes($7aec2ed5dfffaaa3$var$static_ltree, $7aec2ed5dfffaaa3$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $7aec2ed5dfffaaa3$var$D_CODES; n++){
        $7aec2ed5dfffaaa3$var$static_dtree[n * 2 + 1] = 5;
        $7aec2ed5dfffaaa3$var$static_dtree[n * 2] = $7aec2ed5dfffaaa3$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $7aec2ed5dfffaaa3$var$static_l_desc = new $7aec2ed5dfffaaa3$var$StaticTreeDesc($7aec2ed5dfffaaa3$var$static_ltree, $7aec2ed5dfffaaa3$var$extra_lbits, $7aec2ed5dfffaaa3$var$LITERALS + 1, $7aec2ed5dfffaaa3$var$L_CODES, $7aec2ed5dfffaaa3$var$MAX_BITS);
    $7aec2ed5dfffaaa3$var$static_d_desc = new $7aec2ed5dfffaaa3$var$StaticTreeDesc($7aec2ed5dfffaaa3$var$static_dtree, $7aec2ed5dfffaaa3$var$extra_dbits, 0, $7aec2ed5dfffaaa3$var$D_CODES, $7aec2ed5dfffaaa3$var$MAX_BITS);
    $7aec2ed5dfffaaa3$var$static_bl_desc = new $7aec2ed5dfffaaa3$var$StaticTreeDesc(new Array(0), $7aec2ed5dfffaaa3$var$extra_blbits, 0, $7aec2ed5dfffaaa3$var$BL_CODES, $7aec2ed5dfffaaa3$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $7aec2ed5dfffaaa3$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $7aec2ed5dfffaaa3$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $7aec2ed5dfffaaa3$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $7aec2ed5dfffaaa3$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$7aec2ed5dfffaaa3$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $7aec2ed5dfffaaa3$var$bi_windup(s) {
    if (s.bi_valid > 8) $7aec2ed5dfffaaa3$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $7aec2ed5dfffaaa3$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $7aec2ed5dfffaaa3$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $7aec2ed5dfffaaa3$var$put_short(s, len);
        $7aec2ed5dfffaaa3$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $532Kf.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $7aec2ed5dfffaaa3$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $7aec2ed5dfffaaa3$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $7aec2ed5dfffaaa3$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($7aec2ed5dfffaaa3$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $7aec2ed5dfffaaa3$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $7aec2ed5dfffaaa3$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $7aec2ed5dfffaaa3$var$_length_code[lc];
            $7aec2ed5dfffaaa3$var$send_code(s, code + $7aec2ed5dfffaaa3$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $7aec2ed5dfffaaa3$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $7aec2ed5dfffaaa3$var$base_length[code];
                $7aec2ed5dfffaaa3$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $7aec2ed5dfffaaa3$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $7aec2ed5dfffaaa3$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $7aec2ed5dfffaaa3$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $7aec2ed5dfffaaa3$var$base_dist[code];
                $7aec2ed5dfffaaa3$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $7aec2ed5dfffaaa3$var$send_code(s, $7aec2ed5dfffaaa3$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $7aec2ed5dfffaaa3$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $7aec2ed5dfffaaa3$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$7aec2ed5dfffaaa3$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $7aec2ed5dfffaaa3$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $7aec2ed5dfffaaa3$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $7aec2ed5dfffaaa3$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $7aec2ed5dfffaaa3$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $7aec2ed5dfffaaa3$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$7aec2ed5dfffaaa3$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$7aec2ed5dfffaaa3$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$7aec2ed5dfffaaa3$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $7aec2ed5dfffaaa3$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $7aec2ed5dfffaaa3$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $7aec2ed5dfffaaa3$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $7aec2ed5dfffaaa3$var$send_code(s, $7aec2ed5dfffaaa3$var$REP_3_6, s.bl_tree);
            $7aec2ed5dfffaaa3$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $7aec2ed5dfffaaa3$var$send_code(s, $7aec2ed5dfffaaa3$var$REPZ_3_10, s.bl_tree);
            $7aec2ed5dfffaaa3$var$send_bits(s, count - 3, 3);
        } else {
            $7aec2ed5dfffaaa3$var$send_code(s, $7aec2ed5dfffaaa3$var$REPZ_11_138, s.bl_tree);
            $7aec2ed5dfffaaa3$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $7aec2ed5dfffaaa3$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $7aec2ed5dfffaaa3$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $7aec2ed5dfffaaa3$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $7aec2ed5dfffaaa3$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $7aec2ed5dfffaaa3$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$7aec2ed5dfffaaa3$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $7aec2ed5dfffaaa3$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $7aec2ed5dfffaaa3$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $7aec2ed5dfffaaa3$var$send_bits(s, dcodes - 1, 5);
    $7aec2ed5dfffaaa3$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $7aec2ed5dfffaaa3$var$send_bits(s, s.bl_tree[$7aec2ed5dfffaaa3$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $7aec2ed5dfffaaa3$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $7aec2ed5dfffaaa3$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $7aec2ed5dfffaaa3$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $7aec2ed5dfffaaa3$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $7aec2ed5dfffaaa3$var$Z_TEXT;
    for(n = 32; n < $7aec2ed5dfffaaa3$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $7aec2ed5dfffaaa3$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $7aec2ed5dfffaaa3$var$Z_BINARY;
}
var $7aec2ed5dfffaaa3$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $7aec2ed5dfffaaa3$var$_tr_init(s) {
    if (!$7aec2ed5dfffaaa3$var$static_init_done) {
        $7aec2ed5dfffaaa3$var$tr_static_init();
        $7aec2ed5dfffaaa3$var$static_init_done = true;
    }
    s.l_desc = new $7aec2ed5dfffaaa3$var$TreeDesc(s.dyn_ltree, $7aec2ed5dfffaaa3$var$static_l_desc);
    s.d_desc = new $7aec2ed5dfffaaa3$var$TreeDesc(s.dyn_dtree, $7aec2ed5dfffaaa3$var$static_d_desc);
    s.bl_desc = new $7aec2ed5dfffaaa3$var$TreeDesc(s.bl_tree, $7aec2ed5dfffaaa3$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $7aec2ed5dfffaaa3$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $7aec2ed5dfffaaa3$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $7aec2ed5dfffaaa3$var$send_bits(s, ($7aec2ed5dfffaaa3$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $7aec2ed5dfffaaa3$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $7aec2ed5dfffaaa3$var$_tr_align(s) {
    $7aec2ed5dfffaaa3$var$send_bits(s, $7aec2ed5dfffaaa3$var$STATIC_TREES << 1, 3);
    $7aec2ed5dfffaaa3$var$send_code(s, $7aec2ed5dfffaaa3$var$END_BLOCK, $7aec2ed5dfffaaa3$var$static_ltree);
    $7aec2ed5dfffaaa3$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $7aec2ed5dfffaaa3$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $7aec2ed5dfffaaa3$var$Z_UNKNOWN) s.strm.data_type = $7aec2ed5dfffaaa3$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $7aec2ed5dfffaaa3$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $7aec2ed5dfffaaa3$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $7aec2ed5dfffaaa3$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $7aec2ed5dfffaaa3$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $7aec2ed5dfffaaa3$var$Z_FIXED || static_lenb === opt_lenb) {
        $7aec2ed5dfffaaa3$var$send_bits(s, ($7aec2ed5dfffaaa3$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $7aec2ed5dfffaaa3$var$compress_block(s, $7aec2ed5dfffaaa3$var$static_ltree, $7aec2ed5dfffaaa3$var$static_dtree);
    } else {
        $7aec2ed5dfffaaa3$var$send_bits(s, ($7aec2ed5dfffaaa3$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $7aec2ed5dfffaaa3$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $7aec2ed5dfffaaa3$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $7aec2ed5dfffaaa3$var$init_block(s);
    if (last) $7aec2ed5dfffaaa3$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $7aec2ed5dfffaaa3$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($7aec2ed5dfffaaa3$var$_length_code[lc] + $7aec2ed5dfffaaa3$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$7aec2ed5dfffaaa3$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$7aec2ed5dfffaaa3$export$4e4fc0157c3cd14d = $7aec2ed5dfffaaa3$var$_tr_init;
$7aec2ed5dfffaaa3$export$8959e34c5e020172 = $7aec2ed5dfffaaa3$var$_tr_stored_block;
$7aec2ed5dfffaaa3$export$44f15b52eef0cf41 = $7aec2ed5dfffaaa3$var$_tr_flush_block;
$7aec2ed5dfffaaa3$export$b3cbce147289408f = $7aec2ed5dfffaaa3$var$_tr_tally;
$7aec2ed5dfffaaa3$export$bfb360e02ee9b403 = $7aec2ed5dfffaaa3$var$_tr_align;

});

parcelRegister("rkt9O", function(module, exports) {
"use strict";
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $05226680f22a088c$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $05226680f22a088c$var$adler32;

});

parcelRegister("gKg9v", function(module, exports) {
"use strict";
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $c30d78bb18c52e9e$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $c30d78bb18c52e9e$var$crcTable = $c30d78bb18c52e9e$var$makeTable();
function $c30d78bb18c52e9e$var$crc32(crc, buf, len, pos) {
    var t = $c30d78bb18c52e9e$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $c30d78bb18c52e9e$var$crc32;

});

parcelRegister("cNAbT", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("ksAc9", function(module, exports) {

$parcel$export(module.exports, "string2buf", function () { return $ee527fbd95854d19$export$7a4c1b2f775b5a9f; }, function (v) { return $ee527fbd95854d19$export$7a4c1b2f775b5a9f = v; });
$parcel$export(module.exports, "buf2binstring", function () { return $ee527fbd95854d19$export$a751fe64af8a9a51; }, function (v) { return $ee527fbd95854d19$export$a751fe64af8a9a51 = v; });
$parcel$export(module.exports, "binstring2buf", function () { return $ee527fbd95854d19$export$1d1a7119601ff18c; }, function (v) { return $ee527fbd95854d19$export$1d1a7119601ff18c = v; });
$parcel$export(module.exports, "buf2string", function () { return $ee527fbd95854d19$export$49a50563f377746; }, function (v) { return $ee527fbd95854d19$export$49a50563f377746 = v; });
$parcel$export(module.exports, "utf8border", function () { return $ee527fbd95854d19$export$53dee3f58a714214; }, function (v) { return $ee527fbd95854d19$export$53dee3f58a714214 = v; });
// String encode/decode helpers
// convert string to array (typed, when possible)
var $ee527fbd95854d19$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $ee527fbd95854d19$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $ee527fbd95854d19$export$1d1a7119601ff18c;
// convert array to string
var $ee527fbd95854d19$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $ee527fbd95854d19$export$53dee3f58a714214;
"use strict";

var $532Kf = parcelRequire("532Kf");
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $ee527fbd95854d19$var$STR_APPLY_OK = true;
var $ee527fbd95854d19$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $ee527fbd95854d19$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $ee527fbd95854d19$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $ee527fbd95854d19$var$_utf8len = new $532Kf.Buf8(256);
for(var $ee527fbd95854d19$var$q = 0; $ee527fbd95854d19$var$q < 256; $ee527fbd95854d19$var$q++)$ee527fbd95854d19$var$_utf8len[$ee527fbd95854d19$var$q] = $ee527fbd95854d19$var$q >= 252 ? 6 : $ee527fbd95854d19$var$q >= 248 ? 5 : $ee527fbd95854d19$var$q >= 240 ? 4 : $ee527fbd95854d19$var$q >= 224 ? 3 : $ee527fbd95854d19$var$q >= 192 ? 2 : 1;
$ee527fbd95854d19$var$_utf8len[254] = $ee527fbd95854d19$var$_utf8len[254] = 1; // Invalid sequence start
$ee527fbd95854d19$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $532Kf.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $ee527fbd95854d19$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $ee527fbd95854d19$var$STR_APPLY_UIA_OK || !buf.subarray && $ee527fbd95854d19$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $532Kf.shrinkBuf(buf, len));
    }
    var result = "";
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$ee527fbd95854d19$export$a751fe64af8a9a51 = function(buf) {
    return $ee527fbd95854d19$var$buf2binstring(buf, buf.length);
};
$ee527fbd95854d19$export$1d1a7119601ff18c = function(str) {
    var buf = new $532Kf.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$ee527fbd95854d19$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $ee527fbd95854d19$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $ee527fbd95854d19$var$buf2binstring(utf16buf, out);
};
$ee527fbd95854d19$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $ee527fbd95854d19$var$_utf8len[buf[pos]] > max ? pos : max;
};

});

parcelRegister("hylP7", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $cc768a5a5c9a5478$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $cc768a5a5c9a5478$var$ZStream;

});


parcelRegister("gAuyB", function(module, exports) {

$parcel$export(module.exports, "Inflate", function () { return $c137b62430a40534$export$d1de70a877d6e43c; }, function (v) { return $c137b62430a40534$export$d1de70a877d6e43c = v; });
$parcel$export(module.exports, "inflate", function () { return $c137b62430a40534$export$cae1ce83fe4a1782; }, function (v) { return $c137b62430a40534$export$cae1ce83fe4a1782 = v; });
$parcel$export(module.exports, "inflateRaw", function () { return $c137b62430a40534$export$d0f0aa2d05c905c5; }, function (v) { return $c137b62430a40534$export$d0f0aa2d05c905c5 = v; });
$parcel$export(module.exports, "ungzip", function () { return $c137b62430a40534$export$95adf9d270383091; }, function (v) { return $c137b62430a40534$export$95adf9d270383091 = v; });
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $c137b62430a40534$export$d1de70a877d6e43c;
var $c137b62430a40534$export$cae1ce83fe4a1782;
var $c137b62430a40534$export$d0f0aa2d05c905c5;
var $c137b62430a40534$export$95adf9d270383091;
"use strict";

var $4GaGf = parcelRequire("4GaGf");

var $532Kf = parcelRequire("532Kf");

var $ksAc9 = parcelRequire("ksAc9");

var $gCeDq = parcelRequire("gCeDq");

var $cNAbT = parcelRequire("cNAbT");

var $hylP7 = parcelRequire("hylP7");

var $clFN8 = parcelRequire("clFN8");
var $c137b62430a40534$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $c137b62430a40534$var$Inflate(options) {
    if (!(this instanceof $c137b62430a40534$var$Inflate)) return new $c137b62430a40534$var$Inflate(options);
    this.options = $532Kf.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ""
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $hylP7();
    this.strm.avail_out = 0;
    var status = $4GaGf.inflateInit2(this.strm, opt.windowBits);
    if (status !== $gCeDq.Z_OK) throw new Error($cNAbT[status]);
    this.header = new $clFN8();
    $4GaGf.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $ksAc9.string2buf(opt.dictionary);
        else if ($c137b62430a40534$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $4GaGf.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $gCeDq.Z_OK) throw new Error($cNAbT[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $c137b62430a40534$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $gCeDq.Z_FINISH : $gCeDq.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === "string") // Only binary strings can be decompressed on practice
    strm.input = $ksAc9.binstring2buf(data);
    else if ($c137b62430a40534$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $532Kf.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $4GaGf.inflate(strm, $gCeDq.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $gCeDq.Z_NEED_DICT && dictionary) status = $4GaGf.inflateSetDictionary(this.strm, dictionary);
        if (status === $gCeDq.Z_BUF_ERROR && allowBufError === true) {
            status = $gCeDq.Z_OK;
            allowBufError = false;
        }
        if (status !== $gCeDq.Z_STREAM_END && status !== $gCeDq.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $gCeDq.Z_STREAM_END || strm.avail_in === 0 && (_mode === $gCeDq.Z_FINISH || _mode === $gCeDq.Z_SYNC_FLUSH)) {
                if (this.options.to === "string") {
                    next_out_utf8 = $ksAc9.utf8border(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $ksAc9.buf2string(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $532Kf.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($532Kf.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $gCeDq.Z_STREAM_END);
    if (status === $gCeDq.Z_STREAM_END) _mode = $gCeDq.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $gCeDq.Z_FINISH) {
        status = $4GaGf.inflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $gCeDq.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $gCeDq.Z_SYNC_FLUSH) {
        this.onEnd($gCeDq.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $c137b62430a40534$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $c137b62430a40534$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $gCeDq.Z_OK) {
        if (this.options.to === "string") // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join("");
        else this.result = $532Kf.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $c137b62430a40534$var$inflate(input, options) {
    var inflator = new $c137b62430a40534$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $cNAbT[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $c137b62430a40534$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $c137b62430a40534$var$inflate(input, options);
}
$c137b62430a40534$export$d1de70a877d6e43c = $c137b62430a40534$var$Inflate;
$c137b62430a40534$export$cae1ce83fe4a1782 = $c137b62430a40534$var$inflate;
$c137b62430a40534$export$d0f0aa2d05c905c5 = $c137b62430a40534$var$inflateRaw;
$c137b62430a40534$export$95adf9d270383091 = $c137b62430a40534$var$inflate;

});
parcelRegister("4GaGf", function(module, exports) {

$parcel$export(module.exports, "inflateInit2", function () { return $36835e8e2f292567$export$6792d92addc5c8a0; }, function (v) { return $36835e8e2f292567$export$6792d92addc5c8a0 = v; });
$parcel$export(module.exports, "inflate", function () { return $36835e8e2f292567$export$cae1ce83fe4a1782; }, function (v) { return $36835e8e2f292567$export$cae1ce83fe4a1782 = v; });
$parcel$export(module.exports, "inflateEnd", function () { return $36835e8e2f292567$export$224e1a443c3fba76; }, function (v) { return $36835e8e2f292567$export$224e1a443c3fba76 = v; });
$parcel$export(module.exports, "inflateGetHeader", function () { return $36835e8e2f292567$export$6d4647cb9e1c75fc; }, function (v) { return $36835e8e2f292567$export$6d4647cb9e1c75fc = v; });
$parcel$export(module.exports, "inflateSetDictionary", function () { return $36835e8e2f292567$export$60da749bed98ccf8; }, function (v) { return $36835e8e2f292567$export$60da749bed98ccf8 = v; });
var $36835e8e2f292567$export$42de45683a92ba94;
var $36835e8e2f292567$export$7633ac2cd30f9650;
var $36835e8e2f292567$export$6710ea52c4ec9d6a;
var $36835e8e2f292567$export$9c140b25e26874f9;
var $36835e8e2f292567$export$6792d92addc5c8a0;
var $36835e8e2f292567$export$cae1ce83fe4a1782;
var $36835e8e2f292567$export$224e1a443c3fba76;
var $36835e8e2f292567$export$6d4647cb9e1c75fc;
var $36835e8e2f292567$export$60da749bed98ccf8;
var $36835e8e2f292567$export$220f6291ca35fd71;
"use strict";

var $532Kf = parcelRequire("532Kf");

var $rkt9O = parcelRequire("rkt9O");

var $gKg9v = parcelRequire("gKg9v");

var $jKQ7u = parcelRequire("jKQ7u");

var $dFW7R = parcelRequire("dFW7R");
var $36835e8e2f292567$var$CODES = 0;
var $36835e8e2f292567$var$LENS = 1;
var $36835e8e2f292567$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $36835e8e2f292567$var$Z_FINISH = 4;
var $36835e8e2f292567$var$Z_BLOCK = 5;
var $36835e8e2f292567$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $36835e8e2f292567$var$Z_OK = 0;
var $36835e8e2f292567$var$Z_STREAM_END = 1;
var $36835e8e2f292567$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $36835e8e2f292567$var$Z_STREAM_ERROR = -2;
var $36835e8e2f292567$var$Z_DATA_ERROR = -3;
var $36835e8e2f292567$var$Z_MEM_ERROR = -4;
var $36835e8e2f292567$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $36835e8e2f292567$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $36835e8e2f292567$var$HEAD = 1; /* i: waiting for magic header */ 
var $36835e8e2f292567$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $36835e8e2f292567$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $36835e8e2f292567$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $36835e8e2f292567$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $36835e8e2f292567$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $36835e8e2f292567$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $36835e8e2f292567$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $36835e8e2f292567$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $36835e8e2f292567$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $36835e8e2f292567$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $36835e8e2f292567$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $36835e8e2f292567$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $36835e8e2f292567$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $36835e8e2f292567$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $36835e8e2f292567$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $36835e8e2f292567$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $36835e8e2f292567$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $36835e8e2f292567$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $36835e8e2f292567$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $36835e8e2f292567$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $36835e8e2f292567$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $36835e8e2f292567$var$DIST = 23; /* i: waiting for distance code */ 
var $36835e8e2f292567$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $36835e8e2f292567$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $36835e8e2f292567$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $36835e8e2f292567$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $36835e8e2f292567$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $36835e8e2f292567$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $36835e8e2f292567$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $36835e8e2f292567$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $36835e8e2f292567$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $36835e8e2f292567$var$ENOUGH_LENS = 852;
var $36835e8e2f292567$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $36835e8e2f292567$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $36835e8e2f292567$var$DEF_WBITS = $36835e8e2f292567$var$MAX_WBITS;
function $36835e8e2f292567$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $36835e8e2f292567$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $532Kf.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $532Kf.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $36835e8e2f292567$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $36835e8e2f292567$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $36835e8e2f292567$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $532Kf.Buf32($36835e8e2f292567$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $532Kf.Buf32($36835e8e2f292567$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $36835e8e2f292567$var$Z_OK;
}
function $36835e8e2f292567$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $36835e8e2f292567$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $36835e8e2f292567$var$inflateResetKeep(strm);
}
function $36835e8e2f292567$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $36835e8e2f292567$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $36835e8e2f292567$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $36835e8e2f292567$var$inflateReset(strm);
}
function $36835e8e2f292567$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $36835e8e2f292567$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $36835e8e2f292567$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $36835e8e2f292567$var$inflateReset2(strm, windowBits);
    if (ret !== $36835e8e2f292567$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $36835e8e2f292567$var$inflateInit(strm) {
    return $36835e8e2f292567$var$inflateInit2(strm, $36835e8e2f292567$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $36835e8e2f292567$var$virgin = true;
var $36835e8e2f292567$var$lenfix, $36835e8e2f292567$var$distfix; // We have no pointers in JS, so keep tables separate
function $36835e8e2f292567$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($36835e8e2f292567$var$virgin) {
        var sym;
        $36835e8e2f292567$var$lenfix = new $532Kf.Buf32(512);
        $36835e8e2f292567$var$distfix = new $532Kf.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $dFW7R($36835e8e2f292567$var$LENS, state.lens, 0, 288, $36835e8e2f292567$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $dFW7R($36835e8e2f292567$var$DISTS, state.lens, 0, 32, $36835e8e2f292567$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $36835e8e2f292567$var$virgin = false;
    }
    state.lencode = $36835e8e2f292567$var$lenfix;
    state.lenbits = 9;
    state.distcode = $36835e8e2f292567$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $36835e8e2f292567$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $532Kf.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $532Kf.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $532Kf.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $532Kf.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $36835e8e2f292567$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $532Kf.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $36835e8e2f292567$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $36835e8e2f292567$var$TYPE) state.mode = $36835e8e2f292567$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $36835e8e2f292567$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $36835e8e2f292567$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $36835e8e2f292567$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $gKg9v(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $36835e8e2f292567$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $36835e8e2f292567$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $36835e8e2f292567$var$DICTID : $36835e8e2f292567$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $36835e8e2f292567$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $36835e8e2f292567$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $gKg9v(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $36835e8e2f292567$var$TIME;
        /* falls through */ case $36835e8e2f292567$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $gKg9v(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $36835e8e2f292567$var$OS;
        /* falls through */ case $36835e8e2f292567$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $gKg9v(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $36835e8e2f292567$var$EXLEN;
        /* falls through */ case $36835e8e2f292567$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $gKg9v(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $36835e8e2f292567$var$EXTRA;
        /* falls through */ case $36835e8e2f292567$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $532Kf.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $gKg9v(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $36835e8e2f292567$var$NAME;
        /* falls through */ case $36835e8e2f292567$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $gKg9v(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $36835e8e2f292567$var$COMMENT;
        /* falls through */ case $36835e8e2f292567$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $gKg9v(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $36835e8e2f292567$var$HCRC;
        /* falls through */ case $36835e8e2f292567$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $36835e8e2f292567$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $36835e8e2f292567$var$TYPE;
            break;
        case $36835e8e2f292567$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $36835e8e2f292567$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $36835e8e2f292567$var$DICT;
        /* falls through */ case $36835e8e2f292567$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $36835e8e2f292567$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $36835e8e2f292567$var$TYPE;
        /* falls through */ case $36835e8e2f292567$var$TYPE:
            if (flush === $36835e8e2f292567$var$Z_BLOCK || flush === $36835e8e2f292567$var$Z_TREES) break inf_leave;
        /* falls through */ case $36835e8e2f292567$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $36835e8e2f292567$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $36835e8e2f292567$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $36835e8e2f292567$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $36835e8e2f292567$var$LEN_; /* decode codes */ 
                    if (flush === $36835e8e2f292567$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $36835e8e2f292567$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $36835e8e2f292567$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $36835e8e2f292567$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $36835e8e2f292567$var$COPY_;
            if (flush === $36835e8e2f292567$var$Z_TREES) break inf_leave;
        /* falls through */ case $36835e8e2f292567$var$COPY_:
            state.mode = $36835e8e2f292567$var$COPY;
        /* falls through */ case $36835e8e2f292567$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $532Kf.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $36835e8e2f292567$var$TYPE;
            break;
        case $36835e8e2f292567$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $36835e8e2f292567$var$LENLENS;
        /* falls through */ case $36835e8e2f292567$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $dFW7R($36835e8e2f292567$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $36835e8e2f292567$var$CODELENS;
        /* falls through */ case $36835e8e2f292567$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $36835e8e2f292567$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $36835e8e2f292567$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $36835e8e2f292567$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $dFW7R($36835e8e2f292567$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $dFW7R($36835e8e2f292567$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $36835e8e2f292567$var$LEN_;
            if (flush === $36835e8e2f292567$var$Z_TREES) break inf_leave;
        /* falls through */ case $36835e8e2f292567$var$LEN_:
            state.mode = $36835e8e2f292567$var$LEN;
        /* falls through */ case $36835e8e2f292567$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $jKQ7u(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $36835e8e2f292567$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $36835e8e2f292567$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $36835e8e2f292567$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $36835e8e2f292567$var$LENEXT;
        /* falls through */ case $36835e8e2f292567$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $36835e8e2f292567$var$DIST;
        /* falls through */ case $36835e8e2f292567$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $36835e8e2f292567$var$DISTEXT;
        /* falls through */ case $36835e8e2f292567$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $36835e8e2f292567$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $36835e8e2f292567$var$MATCH;
        /* falls through */ case $36835e8e2f292567$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $36835e8e2f292567$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $36835e8e2f292567$var$LEN;
            break;
        case $36835e8e2f292567$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $36835e8e2f292567$var$LEN;
            break;
        case $36835e8e2f292567$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $gKg9v(state.check, output, _out, put - _out) : $rkt9O(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $36835e8e2f292567$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $36835e8e2f292567$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $36835e8e2f292567$var$LENGTH;
        /* falls through */ case $36835e8e2f292567$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $36835e8e2f292567$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $36835e8e2f292567$var$DONE;
        /* falls through */ case $36835e8e2f292567$var$DONE:
            ret = $36835e8e2f292567$var$Z_STREAM_END;
            break inf_leave;
        case $36835e8e2f292567$var$BAD:
            ret = $36835e8e2f292567$var$Z_DATA_ERROR;
            break inf_leave;
        case $36835e8e2f292567$var$MEM:
            return $36835e8e2f292567$var$Z_MEM_ERROR;
        case $36835e8e2f292567$var$SYNC:
        /* falls through */ default:
            return $36835e8e2f292567$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $36835e8e2f292567$var$BAD && (state.mode < $36835e8e2f292567$var$CHECK || flush !== $36835e8e2f292567$var$Z_FINISH)) {
        if ($36835e8e2f292567$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $36835e8e2f292567$var$MEM;
            return $36835e8e2f292567$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $gKg9v(state.check, output, _out, strm.next_out - _out) : $rkt9O(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $36835e8e2f292567$var$TYPE ? 128 : 0) + (state.mode === $36835e8e2f292567$var$LEN_ || state.mode === $36835e8e2f292567$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $36835e8e2f292567$var$Z_FINISH) && ret === $36835e8e2f292567$var$Z_OK) ret = $36835e8e2f292567$var$Z_BUF_ERROR;
    return ret;
}
function $36835e8e2f292567$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $36835e8e2f292567$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $36835e8e2f292567$var$Z_OK;
}
function $36835e8e2f292567$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $36835e8e2f292567$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $36835e8e2f292567$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $36835e8e2f292567$var$Z_OK;
}
function $36835e8e2f292567$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $36835e8e2f292567$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $36835e8e2f292567$var$DICT) return $36835e8e2f292567$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $36835e8e2f292567$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $rkt9O(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $36835e8e2f292567$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $36835e8e2f292567$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $36835e8e2f292567$var$MEM;
        return $36835e8e2f292567$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $36835e8e2f292567$var$Z_OK;
}
$36835e8e2f292567$export$42de45683a92ba94 = $36835e8e2f292567$var$inflateReset;
$36835e8e2f292567$export$7633ac2cd30f9650 = $36835e8e2f292567$var$inflateReset2;
$36835e8e2f292567$export$6710ea52c4ec9d6a = $36835e8e2f292567$var$inflateResetKeep;
$36835e8e2f292567$export$9c140b25e26874f9 = $36835e8e2f292567$var$inflateInit;
$36835e8e2f292567$export$6792d92addc5c8a0 = $36835e8e2f292567$var$inflateInit2;
$36835e8e2f292567$export$cae1ce83fe4a1782 = $36835e8e2f292567$var$inflate;
$36835e8e2f292567$export$224e1a443c3fba76 = $36835e8e2f292567$var$inflateEnd;
$36835e8e2f292567$export$6d4647cb9e1c75fc = $36835e8e2f292567$var$inflateGetHeader;
$36835e8e2f292567$export$60da749bed98ccf8 = $36835e8e2f292567$var$inflateSetDictionary;
$36835e8e2f292567$export$220f6291ca35fd71 = "pako inflate (from Nodeca project)"; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("jKQ7u", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $e61abe1b3a093f7f$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $e61abe1b3a093f7f$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $e61abe1b3a093f7f$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $e61abe1b3a093f7f$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $e61abe1b3a093f7f$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $e61abe1b3a093f7f$var$TYPE;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $e61abe1b3a093f7f$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("dFW7R", function(module, exports) {
"use strict";

var $532Kf = parcelRequire("532Kf");
var $9f4c31446aea2811$var$MAXBITS = 15;
var $9f4c31446aea2811$var$ENOUGH_LENS = 852;
var $9f4c31446aea2811$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $9f4c31446aea2811$var$CODES = 0;
var $9f4c31446aea2811$var$LENS = 1;
var $9f4c31446aea2811$var$DISTS = 2;
var $9f4c31446aea2811$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $9f4c31446aea2811$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $9f4c31446aea2811$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $9f4c31446aea2811$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $532Kf.Buf16($9f4c31446aea2811$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $532Kf.Buf16($9f4c31446aea2811$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $9f4c31446aea2811$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $9f4c31446aea2811$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $9f4c31446aea2811$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $9f4c31446aea2811$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $9f4c31446aea2811$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $9f4c31446aea2811$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $9f4c31446aea2811$var$LENS) {
        base = $9f4c31446aea2811$var$lbase;
        base_index -= 257;
        extra = $9f4c31446aea2811$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $9f4c31446aea2811$var$dbase;
        extra = $9f4c31446aea2811$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $9f4c31446aea2811$var$LENS && used > $9f4c31446aea2811$var$ENOUGH_LENS || type === $9f4c31446aea2811$var$DISTS && used > $9f4c31446aea2811$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $9f4c31446aea2811$var$LENS && used > $9f4c31446aea2811$var$ENOUGH_LENS || type === $9f4c31446aea2811$var$DISTS && used > $9f4c31446aea2811$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("gCeDq", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});

parcelRegister("clFN8", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $8fd7dd23744d03dd$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
module.exports = $8fd7dd23744d03dd$var$GZheader;

});




parcelRegister("lzhEg", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("ciUVV", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("9pxsr", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("kdd0L", function(module, exports) {
module.exports = JSON.parse('"eJyFWdtSGzkQ/RXXPO1WmZSBEAJvjnESb8AmGENCKg+ypj3Wohk5ugAmlX9fzUCyW6s+ysuUfVqXvh61Zr4XI1PX1PjiuLg6C05U1Ns/Ojx42TsYHB4eFf3irWn8VNQUB4xMsIpsCwatU1DUSm8T+JpUtW7XP6NShToiEy+0ksOm0nHkIP53b9UDlefKy3Vx7G2gfjFaCyukJzundu74wVNTUnlhatE8a/XmjXkojr/s7O33d/YOBv3D3YP+68HB136xiEOtVg2dG6e8Mk1xvLM7GPxHcLlW8rYh54rjOLO4Iuu6YcVgsP9iMBjELabGK/lkymZrWxt6f8g/e7tHr4/68Xk06J673XOve+53z8PesDRL6s23zlPtepNGGrsxVngqX/R6Q617F+1qrndBjuxdRONu4ziqVE01l2vqHNgtMveiKYUtf0rjwJHYvH/26MGrvX7x6ee/l3uv+sXQydZPtjh+tXfUL07o1/+d3YPDfjH35fvrOHO3+3n1/LN19hl5q2T0x5fvxfWnOL/11zQq4jYiuuFH/38wPUgt6hT/Fkw0dKlTSRPqZevnqkllpdFa2BTfkJVtdiYCUUeRi94BGnQBY9YTlhpNKyQC04RrV3S3zCwdXIrKWFQihdfbzZoY66MpyjCWOC3cOoUfyZoUNQ0TJX/PjPRrS8zYVSxZBlV3zFinHhiQ7jjriPdpoziFpdGGWcNRrYBIt1WcbvotCCYHK0uxDhkzvwVyHVOksWd0H6bQmxQapdBJCo1T6G0KvUuh9yk0SaG/UuhDCp2m0FkKTVNolkLnKfQxhS5SaJ5Clym0SKGrFLpOoU8p9DmFblJoGU+iW/I8bSyjDNTp8zzIKVIpqawMDIuGlrRdPDiYEun4jVeG4ZwlU2MM/zIVxHABU1AMy6WQSqG/U4ihV6aEGW8xVcvQ3oZxZQox3MDQC+P7kEJ3KXSfQgyTbhnS5/MLJMKSO0y78bls9EqX8KgvzT3jZ/50bo9L3fYraQq1XR3Ls1vu7FhpYxV7HoBVZLDxGJeMA7uycarrOmHXwnuzCipKagMooBV3C/9GDFy/YqpjxSR+bORYmilFVXFH2hPOtmJPDUcbO7LE1H7shURlxYYjtdj6E2PFv+5dCpfxcF4KXPQrAEBOWquNU0yhRkv92gTUKT4d+nxqRwdwrY+QwXONS8fkK01MOYO6qoW0XA4vLXEbl8YLyddbGa9axNpv2SqU8SoWG26Gu0NTCRtqLQKzjalik8mwtBSsHVTzCTtkWh5jy1Xs8fim8BQcsDOE8xvUkeSCZncQvL/b3pKpTg32NQhnVo+lGa+yMeWZoE1wPAmknwBJE/IRJRC6z1iDUt0pLps/A82GucoQYNIiN2kLJrnu2oVqhHJLLvg6WWA3CFQMC6BdQBPGeJOTSBDc/SNrqPz5voLZClGOBHkgeL9MswpolKOAUS+zq43QaoBVxxmedMBMBwlRgd21eaSmYgQXYIt3WSNDtkhywiEKqQWKSGjrTcZzl2tjmcVmaPcL4Lc5wEug7QJtEPjM7N5tuNA1OExPNAMpOEQ4oNU6aK82mmkzAzDwEhgYWy2vhC7VirldbTE1TME+Kpcs42yaZU4dLJJAjwbRIAroFDhoAhZq37zFhoF7/ba05pYa9g5kqVIOdL3vQLAnOUYJsar5q8gY5JQFBhnkmRsw4QZ47PklF3gFNvZMhzKCpKCzvOVR6wdPRyQYovYhk5XAwY+oNNDeMxQRdPSgSDm0MzZilm1LgIUnpD0TK8+TtL83GUbEqtXMKw0FNDL5PnOMXF+CDqfj8ZjANiYyo9o8k698Rn7I5vEpCJy3oqRaWEZzyrDCBHhpghLnFGgdnbYWmjkZ2psJKHCTy6gGdE2L38QP+IeQQRXg0mjQc1S5oPJOmGdDN8trXkaW4L52GBCiEVAiQDYvleTCcAIWsllrpiA+BuAX+bTOSodgzSHkaL7nmoF1HjMVMkanPdr7NmsKaAQm2VIAKvj85cZUbbwbw70fwVwasCguhb5W5S+03EH+CIxqsktFl+MTQqEaH4f2O+TXfvGBbHMulG2/Hn/98Q/b2xEO"');

});

parcelRegister("fzlmn", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("7OLpt", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("6XKHD", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("dYKni", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("gfvkf", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("9nKIA", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("2tWPf", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("6YBy7", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("4W3VQ", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("islrW", function(module, exports) {
module.exports = JSON.parse('"eJxtmNtu20YQhl+F4FULyMGeD7pz3AY1ChtG7NpFA18w1NomIlECSRcxgrx7SVk7+wOdG8H5OJydf2Z2d5gf9cV+t0v9VK/r+6vXsXlOlbHe28paq229qj/t++m62aXZ4J/m8PRb1z9/baZxefK63Z6eXN5dVMvTCh83u277xr/6kLrnl2XNq7TpXnczuZyabdee98/b2VzM/x4/dd/T5qab2pd6PQ2vaVVfvDRD005puE3Lu7eH1HbN9hTjx4/77/X6y5lcnUmjVzHIVVDicVX/1W/SsO36dLMfu6nb9/X6TAoBD+5euvZbn8axXtuZ36dhPJrVQqgPQoh5hev91LWLkIv94W1Ygq9+aX+tZAx2tfz64284/sblN/rqfLP/mqrbt3FKu7G67Nv9cNgPzZQ2H6rz7bb6vLgZq89pTMO/M/xfEqturJpqSM/d7GJIm2oamk3aNcO3av80O5xh3yyKmm1193ZIT02bqovTKjP+MAf++7zsZvZ3276kYyWWXB0z99S18/PbafPHQ71W4fjn/fxnFO+ZvkrT0LVzTr78qB/+nk38bHM9exgP8zr1z9U7jt6840YW5uSJKcZOCaBBnKgm5mU8MVNYyMwWFvO7Ukagkmgg6sDWQ5yFFqjzUrLEaQ3BEmiwNsMSaZS0vgWfOkPHWQowNeTUc0kumnxZvsgPxlGai6VTGUqAVCTQ6QkWnc77DKEiLktSUBJKqHIQZ86d8gCpHYoiEzMsb1ubYy8vW50DChB5ZhGqrijD0EqUIeiaEHIfCg5Kpuu0ApiToaGPSY0uaQsyr65L2oKi1yFt1PLaQ3lzfXTgXodGoJYzglndSLDMPg1sTPJpQJHJigw0QrGERqD9YhyTOgONQDUyuF1zaxuokc/BW2ztXCMrGZ9WMW1oQZHIXWNBkSCfRZEL5BMUiZw6CzVSFCfUSGZFNjIldoKDkonTKQiJIGzWmFd3BizJJ9SINoLDriOfUCOZS+zg+KGD1qGiLNMLxtJD1/ns00ON6EzyUCM6vbxhoBKaqbG3DFQCNiL1iHccBPV0DHhQH/JW8EW90dkyFKGywCJU0WkVSvSGeiSUODWFFD0HYdPQVoiRgfPMA+/nnRgiAyNYSjpWNQcNSMrtFCUH4ZIRpSCWocFCSuhCEY6hoUClc0WC52BJlCYYLQdhN+hygRRRlo5BKRRLS6oihSqh+ZzzRGG1Mo4Iz1LoP0qsxDGFzk0JE42ji0jCPejomJKCuwil4m5CiRMEUMVSzVLDUstSx1Juc0oVWMpqY295qVltmtWmWW2a1aZZbZrVplltmtWmWW2G1WZYbYbVZlhthtVmWG2G1WZYbYbVZlhtltVmWW2W1WZZbZbVZlltltVmWW2W1QYjQCh7E2aAQHeGhCFgPoNoy8KNb2wxBhmGKBxoUZXlLGsLI6AsftEDHV0wIURVbANLcTKlGGBIKPOAxCmhePCKUwFzAmpDFRQvjA9R06Hq8TONvshgKDCuRAZTXigUxjxNFfKRo3CLhnIJBMFRvMZpqpNBMlQJzGT5WFQMVQI/AikPMIhEU1aDjqJvQwmjSHB05cC9jbYwc5UtAHNLhDw41ha+lEqF4JaH3gmB61SYcqInxTDmQK8v08vjqv4zDf1N0w3Lf4A8/vwPpfK11w=="');

});


parcelRegister("gMRCf", function(module, exports) {

$parcel$export(module.exports, "Encodings", function () { return $c38ab80ffc5411cc$export$c85030bb86979d84; });
/* tslint:disable max-classes-per-file */ 
var $h1seI = parcelRequire("h1seI");

var $2lOgw = parcelRequire("2lOgw");
var $c38ab80ffc5411cc$var$decompressedEncodings = (0, $h1seI.decompressJson)((0, (/*@__PURE__*/$parcel$interopDefault($2lOgw))));
var $c38ab80ffc5411cc$var$allUnicodeMappings = JSON.parse($c38ab80ffc5411cc$var$decompressedEncodings);
var $c38ab80ffc5411cc$var$Encoding = /** @class */ function() {
    function Encoding(name, unicodeMappings) {
        var _this = this;
        this.canEncodeUnicodeCodePoint = function(codePoint) {
            return codePoint in _this.unicodeMappings;
        };
        this.encodeUnicodeCodePoint = function(codePoint) {
            var mapped = _this.unicodeMappings[codePoint];
            if (!mapped) {
                var str = String.fromCharCode(codePoint);
                var hexCode = "0x" + (0, $h1seI.padStart)(codePoint.toString(16), 4, "0");
                var msg = _this.name + ' cannot encode "' + str + '" (' + hexCode + ")";
                throw new Error(msg);
            }
            return {
                code: mapped[0],
                name: mapped[1]
            };
        };
        this.name = name;
        this.supportedCodePoints = Object.keys(unicodeMappings).map(Number).sort(function(a, b) {
            return a - b;
        });
        this.unicodeMappings = unicodeMappings;
    }
    return Encoding;
}();
var $c38ab80ffc5411cc$export$c85030bb86979d84 = {
    Symbol: new $c38ab80ffc5411cc$var$Encoding("Symbol", $c38ab80ffc5411cc$var$allUnicodeMappings.symbol),
    ZapfDingbats: new $c38ab80ffc5411cc$var$Encoding("ZapfDingbats", $c38ab80ffc5411cc$var$allUnicodeMappings.zapfdingbats),
    WinAnsi: new $c38ab80ffc5411cc$var$Encoding("WinAnsi", $c38ab80ffc5411cc$var$allUnicodeMappings.win1252)
};

});
parcelRegister("2lOgw", function(module, exports) {
module.exports = JSON.parse('"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"');

});




parcelRegister("2qnUk", function(module, exports) {

$parcel$export(module.exports, "assertIsOneOf", function () { return $1c408e00cca9f23a$export$8883a3014ee46cd1; });
$parcel$export(module.exports, "assertIsOneOfOrUndefined", function () { return $1c408e00cca9f23a$export$846079600c50354e; });
$parcel$export(module.exports, "assertIsSubset", function () { return $1c408e00cca9f23a$export$dce66947695c582f; });
$parcel$export(module.exports, "assertIs", function () { return $1c408e00cca9f23a$export$6fee1f82edcf4a03; });
$parcel$export(module.exports, "assertOrUndefined", function () { return $1c408e00cca9f23a$export$92143017cb173fb0; });
$parcel$export(module.exports, "assertEachIs", function () { return $1c408e00cca9f23a$export$47fbce961905bcd0; });
$parcel$export(module.exports, "assertRange", function () { return $1c408e00cca9f23a$export$6698b6d148bc9b0c; });
$parcel$export(module.exports, "assertRangeOrUndefined", function () { return $1c408e00cca9f23a$export$bce4080186be486; });
$parcel$export(module.exports, "assertMultiple", function () { return $1c408e00cca9f23a$export$c9f5acf8e31d1a2e; });
$parcel$export(module.exports, "assertInteger", function () { return $1c408e00cca9f23a$export$a59e49f1e2708383; });
$parcel$export(module.exports, "assertPositive", function () { return $1c408e00cca9f23a$export$2cad8b74f3cf13dd; });
/* tslint:disable:ban-types */ 
var $4PFuJ = parcelRequire("4PFuJ");
var $1c408e00cca9f23a$export$c7ce26e85cccb3a8 = function(val) {
    return "`" + val + "`";
};
var $1c408e00cca9f23a$export$1909b7b8a28995a9 = function(val) {
    return "'" + val + "'";
};
// prettier-ignore
var $1c408e00cca9f23a$var$formatValue = function(value) {
    var type = typeof value;
    if (type === "string") return $1c408e00cca9f23a$export$1909b7b8a28995a9(value);
    else if (type === "undefined") return $1c408e00cca9f23a$export$c7ce26e85cccb3a8(value);
    else return value;
};
var $1c408e00cca9f23a$export$2ac73c5d250d45a9 = function(value, valueName, values) {
    var allowedValues = new Array(values.length);
    for(var idx = 0, len = values.length; idx < len; idx++){
        var v = values[idx];
        allowedValues[idx] = $1c408e00cca9f23a$var$formatValue(v);
    }
    var joinedValues = allowedValues.join(" or ");
    // prettier-ignore
    return $1c408e00cca9f23a$export$c7ce26e85cccb3a8(valueName) + " must be one of " + joinedValues + ", but was actually " + $1c408e00cca9f23a$var$formatValue(value);
};
var $1c408e00cca9f23a$export$8883a3014ee46cd1 = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $4PFuJ.values)(allowedValues);
    for(var idx = 0, len = allowedValues.length; idx < len; idx++){
        if (value === allowedValues[idx]) return;
    }
    throw new TypeError($1c408e00cca9f23a$export$2ac73c5d250d45a9(value, valueName, allowedValues));
};
var $1c408e00cca9f23a$export$846079600c50354e = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $4PFuJ.values)(allowedValues);
    $1c408e00cca9f23a$export$8883a3014ee46cd1(value, valueName, allowedValues.concat(undefined));
};
var $1c408e00cca9f23a$export$dce66947695c582f = function(values, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $4PFuJ.values)(allowedValues);
    for(var idx = 0, len = values.length; idx < len; idx++)$1c408e00cca9f23a$export$8883a3014ee46cd1(values[idx], valueName, allowedValues);
};
var $1c408e00cca9f23a$export$e2b5c5db9e2009fd = function(val) {
    if (val === null) return "null";
    if (val === undefined) return "undefined";
    if (typeof val === "string") return "string";
    if (isNaN(val)) return "NaN";
    if (typeof val === "number") return "number";
    if (typeof val === "boolean") return "boolean";
    if (typeof val === "symbol") return "symbol";
    if (typeof val === "bigint") return "bigint";
    if (val.constructor && val.constructor.name) return val.constructor.name;
    if (val.name) return val.name;
    if (val.constructor) return String(val.constructor);
    return String(val);
};
var $1c408e00cca9f23a$export$26b9f946b448f23e = function(value, type) {
    if (type === "null") return value === null;
    if (type === "undefined") return value === undefined;
    if (type === "string") return typeof value === "string";
    if (type === "number") return typeof value === "number" && !isNaN(value);
    if (type === "boolean") return typeof value === "boolean";
    if (type === "symbol") return typeof value === "symbol";
    if (type === "bigint") return typeof value === "bigint";
    if (type === Date) return value instanceof Date;
    if (type === Array) return value instanceof Array;
    if (type === Uint8Array) return value instanceof Uint8Array;
    if (type === ArrayBuffer) return value instanceof ArrayBuffer;
    if (type === Function) return value instanceof Function;
    return value instanceof type[0];
};
var $1c408e00cca9f23a$export$6e3e1e6304e79984 = function(value, valueName, types) {
    var allowedTypes = new Array(types.length);
    for(var idx = 0, len = types.length; idx < len; idx++){
        var type = types[idx];
        if (type === "null") allowedTypes[idx] = $1c408e00cca9f23a$export$c7ce26e85cccb3a8("null");
        if (type === "undefined") allowedTypes[idx] = $1c408e00cca9f23a$export$c7ce26e85cccb3a8("undefined");
        if (type === "string") allowedTypes[idx] = $1c408e00cca9f23a$export$c7ce26e85cccb3a8("string");
        else if (type === "number") allowedTypes[idx] = $1c408e00cca9f23a$export$c7ce26e85cccb3a8("number");
        else if (type === "boolean") allowedTypes[idx] = $1c408e00cca9f23a$export$c7ce26e85cccb3a8("boolean");
        else if (type === "symbol") allowedTypes[idx] = $1c408e00cca9f23a$export$c7ce26e85cccb3a8("symbol");
        else if (type === "bigint") allowedTypes[idx] = $1c408e00cca9f23a$export$c7ce26e85cccb3a8("bigint");
        else if (type === Array) allowedTypes[idx] = $1c408e00cca9f23a$export$c7ce26e85cccb3a8("Array");
        else if (type === Uint8Array) allowedTypes[idx] = $1c408e00cca9f23a$export$c7ce26e85cccb3a8("Uint8Array");
        else if (type === ArrayBuffer) allowedTypes[idx] = $1c408e00cca9f23a$export$c7ce26e85cccb3a8("ArrayBuffer");
        else allowedTypes[idx] = $1c408e00cca9f23a$export$c7ce26e85cccb3a8(type[1]);
    }
    var joinedTypes = allowedTypes.join(" or ");
    // prettier-ignore
    return $1c408e00cca9f23a$export$c7ce26e85cccb3a8(valueName) + " must be of type " + joinedTypes + ", but was actually of type " + $1c408e00cca9f23a$export$c7ce26e85cccb3a8($1c408e00cca9f23a$export$e2b5c5db9e2009fd(value));
};
var $1c408e00cca9f23a$export$6fee1f82edcf4a03 = function(value, valueName, types) {
    for(var idx = 0, len = types.length; idx < len; idx++){
        if ($1c408e00cca9f23a$export$26b9f946b448f23e(value, types[idx])) return;
    }
    throw new TypeError($1c408e00cca9f23a$export$6e3e1e6304e79984(value, valueName, types));
};
var $1c408e00cca9f23a$export$92143017cb173fb0 = function(value, valueName, types) {
    $1c408e00cca9f23a$export$6fee1f82edcf4a03(value, valueName, types.concat("undefined"));
};
var $1c408e00cca9f23a$export$47fbce961905bcd0 = function(values, valueName, types) {
    for(var idx = 0, len = values.length; idx < len; idx++)$1c408e00cca9f23a$export$6fee1f82edcf4a03(values[idx], valueName, types);
};
var $1c408e00cca9f23a$export$6698b6d148bc9b0c = function(value, valueName, min, max) {
    $1c408e00cca9f23a$export$6fee1f82edcf4a03(value, valueName, [
        "number"
    ]);
    $1c408e00cca9f23a$export$6fee1f82edcf4a03(min, "min", [
        "number"
    ]);
    $1c408e00cca9f23a$export$6fee1f82edcf4a03(max, "max", [
        "number"
    ]);
    max = Math.max(min, max);
    if (value < min || value > max) // prettier-ignore
    throw new Error($1c408e00cca9f23a$export$c7ce26e85cccb3a8(valueName) + " must be at least " + min + " and at most " + max + ", but was actually " + value);
};
var $1c408e00cca9f23a$export$bce4080186be486 = function(value, valueName, min, max) {
    $1c408e00cca9f23a$export$6fee1f82edcf4a03(value, valueName, [
        "number",
        "undefined"
    ]);
    if (typeof value === "number") $1c408e00cca9f23a$export$6698b6d148bc9b0c(value, valueName, min, max);
};
var $1c408e00cca9f23a$export$c9f5acf8e31d1a2e = function(value, valueName, multiplier) {
    $1c408e00cca9f23a$export$6fee1f82edcf4a03(value, valueName, [
        "number"
    ]);
    if (value % multiplier !== 0) // prettier-ignore
    throw new Error($1c408e00cca9f23a$export$c7ce26e85cccb3a8(valueName) + " must be a multiple of " + multiplier + ", but was actually " + value);
};
var $1c408e00cca9f23a$export$a59e49f1e2708383 = function(value, valueName) {
    if (!Number.isInteger(value)) throw new Error($1c408e00cca9f23a$export$c7ce26e85cccb3a8(valueName) + " must be an integer, but was actually " + value);
};
var $1c408e00cca9f23a$export$2cad8b74f3cf13dd = function(value, valueName) {
    if (![
        1,
        0
    ].includes(Math.sign(value))) // prettier-ignore
    throw new Error($1c408e00cca9f23a$export$c7ce26e85cccb3a8(valueName) + " must be a positive number or 0, but was actually " + value);
};

});

parcelRegister("8I4bY", function(module, exports) {

$parcel$export(module.exports, "pdfDocEncodingDecode", function () { return $6575af46ad3a2b42$export$ea426b9c784ba215; });

var $cZKSB = parcelRequire("cZKSB");
// Mapping from PDFDocEncoding to Unicode code point
var $6575af46ad3a2b42$var$pdfDocEncodingToUnicode = new Uint16Array(256);
// Initialize the code points which are the same
for(var $6575af46ad3a2b42$var$idx = 0; $6575af46ad3a2b42$var$idx < 256; $6575af46ad3a2b42$var$idx++)$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[$6575af46ad3a2b42$var$idx] = $6575af46ad3a2b42$var$idx;
// Set differences (see "Table D.2 – PDFDocEncoding Character Set" of the PDF spec)
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x16] = (0, $cZKSB.toCharCode)("\x17"); // SYNCRONOUS IDLE
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x18] = (0, $cZKSB.toCharCode)("\u02D8"); // BREVE
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x19] = (0, $cZKSB.toCharCode)("\u02C7"); // CARON
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x1a] = (0, $cZKSB.toCharCode)("\u02C6"); // MODIFIER LETTER CIRCUMFLEX ACCENT
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x1b] = (0, $cZKSB.toCharCode)("\u02D9"); // DOT ABOVE
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x1c] = (0, $cZKSB.toCharCode)("\u02DD"); // DOUBLE ACUTE ACCENT
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x1d] = (0, $cZKSB.toCharCode)("\u02DB"); // OGONEK
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x1e] = (0, $cZKSB.toCharCode)("\u02DA"); // RING ABOVE
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x1f] = (0, $cZKSB.toCharCode)("\u02DC"); // SMALL TILDE
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x7f] = (0, $cZKSB.toCharCode)("\uFFFD"); // REPLACEMENT CHARACTER (box with questionmark)
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x80] = (0, $cZKSB.toCharCode)("\u2022"); // BULLET
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x81] = (0, $cZKSB.toCharCode)("\u2020"); // DAGGER
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x82] = (0, $cZKSB.toCharCode)("\u2021"); // DOUBLE DAGGER
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x83] = (0, $cZKSB.toCharCode)("\u2026"); // HORIZONTAL ELLIPSIS
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x84] = (0, $cZKSB.toCharCode)("\u2014"); // EM DASH
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x85] = (0, $cZKSB.toCharCode)("\u2013"); // EN DASH
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x86] = (0, $cZKSB.toCharCode)("\u0192"); // LATIN SMALL LETTER SCRIPT F
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x87] = (0, $cZKSB.toCharCode)("\u2044"); // FRACTION SLASH (solidus)
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x88] = (0, $cZKSB.toCharCode)("\u2039"); // SINGLE LEFT-POINTING ANGLE QUOTATION MARK
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x89] = (0, $cZKSB.toCharCode)("\u203A"); // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x8a] = (0, $cZKSB.toCharCode)("\u2212"); // MINUS SIGN
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x8b] = (0, $cZKSB.toCharCode)("\u2030"); // PER MILLE SIGN
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x8c] = (0, $cZKSB.toCharCode)("\u201E"); // DOUBLE LOW-9 QUOTATION MARK (quotedblbase)
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x8d] = (0, $cZKSB.toCharCode)("\u201C"); // LEFT DOUBLE QUOTATION MARK (quotedblleft)
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x8e] = (0, $cZKSB.toCharCode)("\u201D"); // RIGHT DOUBLE QUOTATION MARK (quotedblright)
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x8f] = (0, $cZKSB.toCharCode)("\u2018"); // LEFT SINGLE QUOTATION MARK (quoteleft)
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x90] = (0, $cZKSB.toCharCode)("\u2019"); // RIGHT SINGLE QUOTATION MARK (quoteright)
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x91] = (0, $cZKSB.toCharCode)("\u201A"); // SINGLE LOW-9 QUOTATION MARK (quotesinglbase)
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x92] = (0, $cZKSB.toCharCode)("\u2122"); // TRADE MARK SIGN
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x93] = (0, $cZKSB.toCharCode)("\uFB01"); // LATIN SMALL LIGATURE FI
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x94] = (0, $cZKSB.toCharCode)("\uFB02"); // LATIN SMALL LIGATURE FL
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x95] = (0, $cZKSB.toCharCode)("\u0141"); // LATIN CAPITAL LETTER L WITH STROKE
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x96] = (0, $cZKSB.toCharCode)("\u0152"); // LATIN CAPITAL LIGATURE OE
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x97] = (0, $cZKSB.toCharCode)("\u0160"); // LATIN CAPITAL LETTER S WITH CARON
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x98] = (0, $cZKSB.toCharCode)("\u0178"); // LATIN CAPITAL LETTER Y WITH DIAERESIS
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x99] = (0, $cZKSB.toCharCode)("\u017D"); // LATIN CAPITAL LETTER Z WITH CARON
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x9a] = (0, $cZKSB.toCharCode)("\u0131"); // LATIN SMALL LETTER DOTLESS I
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x9b] = (0, $cZKSB.toCharCode)("\u0142"); // LATIN SMALL LETTER L WITH STROKE
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x9c] = (0, $cZKSB.toCharCode)("\u0153"); // LATIN SMALL LIGATURE OE
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x9d] = (0, $cZKSB.toCharCode)("\u0161"); // LATIN SMALL LETTER S WITH CARON
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x9e] = (0, $cZKSB.toCharCode)("\u017E"); // LATIN SMALL LETTER Z WITH CARON
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0x9f] = (0, $cZKSB.toCharCode)("\uFFFD"); // REPLACEMENT CHARACTER (box with questionmark)
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0xa0] = (0, $cZKSB.toCharCode)("\u20AC"); // EURO SIGN
$6575af46ad3a2b42$var$pdfDocEncodingToUnicode[0xad] = (0, $cZKSB.toCharCode)("\uFFFD"); // REPLACEMENT CHARACTER (box with questionmark)
var $6575af46ad3a2b42$export$ea426b9c784ba215 = function(bytes) {
    var codePoints = new Array(bytes.length);
    for(var idx = 0, len = bytes.length; idx < len; idx++)codePoints[idx] = $6575af46ad3a2b42$var$pdfDocEncodingToUnicode[bytes[idx]];
    return String.fromCodePoint.apply(String, codePoints);
};

});

parcelRegister("6E4Ej", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d6a15bfddacabca$export$2e2bcd8739ae039; });
var $4d6a15bfddacabca$var$Cache = /** @class */ function() {
    function Cache(populate) {
        this.populate = populate;
        this.value = undefined;
    }
    Cache.prototype.getValue = function() {
        return this.value;
    };
    Cache.prototype.access = function() {
        if (!this.value) this.value = this.populate();
        return this.value;
    };
    Cache.prototype.invalidate = function() {
        this.value = undefined;
    };
    Cache.populatedBy = function(populate) {
        return new Cache(populate);
    };
    return Cache;
}();
var $4d6a15bfddacabca$export$2e2bcd8739ae039 = $4d6a15bfddacabca$var$Cache;

});


parcelRegister("cWdWp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96b5b737cf723064$export$2e2bcd8739ae039; });

var $1cWQu = parcelRequire("1cWQu");
var $96b5b737cf723064$var$PDFObject = /** @class */ function() {
    function PDFObject() {}
    PDFObject.prototype.clone = function(_context) {
        throw new (0, $1cWQu.MethodNotImplementedError)(this.constructor.name, "clone");
    };
    PDFObject.prototype.toString = function() {
        throw new (0, $1cWQu.MethodNotImplementedError)(this.constructor.name, "toString");
    };
    PDFObject.prototype.sizeInBytes = function() {
        throw new (0, $1cWQu.MethodNotImplementedError)(this.constructor.name, "sizeInBytes");
    };
    PDFObject.prototype.copyBytesInto = function(_buffer, _offset) {
        throw new (0, $1cWQu.MethodNotImplementedError)(this.constructor.name, "copyBytesInto");
    };
    return PDFObject;
}();
var $96b5b737cf723064$export$2e2bcd8739ae039 = $96b5b737cf723064$var$PDFObject;

});
parcelRegister("1cWQu", function(module, exports) {

$parcel$export(module.exports, "MethodNotImplementedError", function () { return $0e148ef5e3ab151b$export$b549a6777be1bc17; });
$parcel$export(module.exports, "PrivateConstructorError", function () { return $0e148ef5e3ab151b$export$20e18464cd4b43a; });
$parcel$export(module.exports, "UnexpectedObjectTypeError", function () { return $0e148ef5e3ab151b$export$ab03f98a62c22159; });
$parcel$export(module.exports, "UnsupportedEncodingError", function () { return $0e148ef5e3ab151b$export$5de8fe8a6031fb92; });
$parcel$export(module.exports, "ReparseError", function () { return $0e148ef5e3ab151b$export$df523155c7c35e23; });
$parcel$export(module.exports, "MissingPageContentsEmbeddingError", function () { return $0e148ef5e3ab151b$export$48e9be38307e3c37; });
$parcel$export(module.exports, "UnrecognizedStreamTypeError", function () { return $0e148ef5e3ab151b$export$f8343077e7fd3a86; });
$parcel$export(module.exports, "PageEmbeddingMismatchedContextError", function () { return $0e148ef5e3ab151b$export$22c55e00f6509a2c; });
$parcel$export(module.exports, "PDFArrayIsNotRectangleError", function () { return $0e148ef5e3ab151b$export$a76bae7761f3d760; });
$parcel$export(module.exports, "InvalidPDFDateStringError", function () { return $0e148ef5e3ab151b$export$8638e3ad1edceac8; });
$parcel$export(module.exports, "InvalidTargetIndexError", function () { return $0e148ef5e3ab151b$export$845c01ec1ddb8877; });
$parcel$export(module.exports, "CorruptPageTreeError", function () { return $0e148ef5e3ab151b$export$1012d63cae1523f8; });
$parcel$export(module.exports, "IndexOutOfBoundsError", function () { return $0e148ef5e3ab151b$export$19a77d83c7473130; });
$parcel$export(module.exports, "InvalidAcroFieldValueError", function () { return $0e148ef5e3ab151b$export$d39c49ea9be644ec; });
$parcel$export(module.exports, "MultiSelectValueError", function () { return $0e148ef5e3ab151b$export$6606fe23b6c4542c; });
$parcel$export(module.exports, "MissingDAEntryError", function () { return $0e148ef5e3ab151b$export$dfa101de065b3cc2; });
$parcel$export(module.exports, "MissingTfOperatorError", function () { return $0e148ef5e3ab151b$export$b5ee390f1267b133; });
$parcel$export(module.exports, "NumberParsingError", function () { return $0e148ef5e3ab151b$export$81adf4c464255546; });
$parcel$export(module.exports, "NextByteAssertionError", function () { return $0e148ef5e3ab151b$export$fda6cb3cf0fe0c76; });
$parcel$export(module.exports, "PDFObjectParsingError", function () { return $0e148ef5e3ab151b$export$b8907968b8d7f502; });
$parcel$export(module.exports, "PDFInvalidObjectParsingError", function () { return $0e148ef5e3ab151b$export$72474f06fb3a1c6b; });
$parcel$export(module.exports, "PDFStreamParsingError", function () { return $0e148ef5e3ab151b$export$b1a91b84397f50d6; });
$parcel$export(module.exports, "UnbalancedParenthesisError", function () { return $0e148ef5e3ab151b$export$92803ff0e03167f9; });
$parcel$export(module.exports, "StalledParserError", function () { return $0e148ef5e3ab151b$export$b934c61834236c8; });
$parcel$export(module.exports, "MissingPDFHeaderError", function () { return $0e148ef5e3ab151b$export$cf6bd1b11dd05d74; });
$parcel$export(module.exports, "MissingKeywordError", function () { return $0e148ef5e3ab151b$export$bc024c15c94be864; });

var $59LZ8 = parcelRequire("59LZ8");
parcelRequire("6vLBB");
var $i8eKs = parcelRequire("i8eKs");
var $0e148ef5e3ab151b$export$b549a6777be1bc17 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(MethodNotImplementedError, _super);
    function MethodNotImplementedError(className, methodName) {
        var _this = this;
        var msg = "Method " + className + "." + methodName + "() not implemented";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MethodNotImplementedError;
}(Error);
var $0e148ef5e3ab151b$export$20e18464cd4b43a = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PrivateConstructorError, _super);
    function PrivateConstructorError(className) {
        var _this = this;
        var msg = "Cannot construct " + className + " - it has a private constructor";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PrivateConstructorError;
}(Error);
var $0e148ef5e3ab151b$export$ab03f98a62c22159 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(UnexpectedObjectTypeError, _super);
    function UnexpectedObjectTypeError(expected, actual) {
        var _this = this;
        var name = function(t) {
            var _a, _b;
            return (_a = t === null || t === void 0 ? void 0 : t.name) !== null && _a !== void 0 ? _a : (_b = t === null || t === void 0 ? void 0 : t.constructor) === null || _b === void 0 ? void 0 : _b.name;
        };
        var expectedTypes = Array.isArray(expected) ? expected.map(name) : [
            name(expected)
        ];
        var msg = "Expected instance of " + expectedTypes.join(" or ") + ", " + ("but got instance of " + (actual ? name(actual) : actual));
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedObjectTypeError;
}(Error);
var $0e148ef5e3ab151b$export$5de8fe8a6031fb92 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(UnsupportedEncodingError, _super);
    function UnsupportedEncodingError(encoding) {
        var _this = this;
        var msg = encoding + " stream encoding not supported";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnsupportedEncodingError;
}(Error);
var $0e148ef5e3ab151b$export$df523155c7c35e23 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(ReparseError, _super);
    function ReparseError(className, methodName) {
        var _this = this;
        var msg = "Cannot call " + className + "." + methodName + "() more than once";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ReparseError;
}(Error);
var $0e148ef5e3ab151b$export$3afc9350d4666214 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(MissingCatalogError, _super);
    function MissingCatalogError(ref) {
        var _this = this;
        var msg = "Missing catalog (ref=" + ref + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingCatalogError;
}(Error);
var $0e148ef5e3ab151b$export$48e9be38307e3c37 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(MissingPageContentsEmbeddingError, _super);
    function MissingPageContentsEmbeddingError() {
        var _this = this;
        var msg = "Can't embed page with missing Contents";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingPageContentsEmbeddingError;
}(Error);
var $0e148ef5e3ab151b$export$f8343077e7fd3a86 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(UnrecognizedStreamTypeError, _super);
    function UnrecognizedStreamTypeError(stream) {
        var _a, _b, _c;
        var _this = this;
        var streamType = (_c = (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.contructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : stream === null || stream === void 0 ? void 0 : stream.name) !== null && _c !== void 0 ? _c : stream;
        var msg = "Unrecognized stream type: " + streamType;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnrecognizedStreamTypeError;
}(Error);
var $0e148ef5e3ab151b$export$22c55e00f6509a2c = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PageEmbeddingMismatchedContextError, _super);
    function PageEmbeddingMismatchedContextError() {
        var _this = this;
        var msg = "Found mismatched contexts while embedding pages. All pages in the array passed to `PDFDocument.embedPages()` must be from the same document.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PageEmbeddingMismatchedContextError;
}(Error);
var $0e148ef5e3ab151b$export$a76bae7761f3d760 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFArrayIsNotRectangleError, _super);
    function PDFArrayIsNotRectangleError(size) {
        var _this = this;
        var msg = "Attempted to convert PDFArray with " + size + " elements to rectangle, but must have exactly 4 elements.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFArrayIsNotRectangleError;
}(Error);
var $0e148ef5e3ab151b$export$8638e3ad1edceac8 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(InvalidPDFDateStringError, _super);
    function InvalidPDFDateStringError(value) {
        var _this = this;
        var msg = 'Attempted to convert "' + value + '" to a date, but it does not match the PDF date string format.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidPDFDateStringError;
}(Error);
var $0e148ef5e3ab151b$export$845c01ec1ddb8877 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(InvalidTargetIndexError, _super);
    function InvalidTargetIndexError(targetIndex, Count) {
        var _this = this;
        var msg = "Invalid targetIndex specified: targetIndex=" + targetIndex + " must be less than Count=" + Count;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidTargetIndexError;
}(Error);
var $0e148ef5e3ab151b$export$1012d63cae1523f8 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(CorruptPageTreeError, _super);
    function CorruptPageTreeError(targetIndex, operation) {
        var _this = this;
        var msg = "Failed to " + operation + " at targetIndex=" + targetIndex + " due to corrupt page tree: It is likely that one or more 'Count' entries are invalid";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CorruptPageTreeError;
}(Error);
var $0e148ef5e3ab151b$export$19a77d83c7473130 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(IndexOutOfBoundsError, _super);
    function IndexOutOfBoundsError(index, min, max) {
        var _this = this;
        var msg = "index should be at least " + min + " and at most " + max + ", but was actually " + index;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return IndexOutOfBoundsError;
}(Error);
var $0e148ef5e3ab151b$export$d39c49ea9be644ec = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(InvalidAcroFieldValueError, _super);
    function InvalidAcroFieldValueError() {
        var _this = this;
        var msg = "Attempted to set invalid field value";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidAcroFieldValueError;
}(Error);
var $0e148ef5e3ab151b$export$6606fe23b6c4542c = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(MultiSelectValueError, _super);
    function MultiSelectValueError() {
        var _this = this;
        var msg = "Attempted to select multiple values for single-select field";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MultiSelectValueError;
}(Error);
var $0e148ef5e3ab151b$export$dfa101de065b3cc2 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(MissingDAEntryError, _super);
    function MissingDAEntryError(fieldName) {
        var _this = this;
        var msg = "No /DA (default appearance) entry found for field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingDAEntryError;
}(Error);
var $0e148ef5e3ab151b$export$b5ee390f1267b133 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(MissingTfOperatorError, _super);
    function MissingTfOperatorError(fieldName) {
        var _this = this;
        var msg = "No Tf operator found for DA of field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingTfOperatorError;
}(Error);
var $0e148ef5e3ab151b$export$81adf4c464255546 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(NumberParsingError, _super);
    function NumberParsingError(pos, value) {
        var _this = this;
        var msg = "Failed to parse number " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + '): "' + value + '"');
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NumberParsingError;
}(Error);
var $0e148ef5e3ab151b$export$fd202455a19cb700 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFParsingError, _super);
    function PDFParsingError(pos, details) {
        var _this = this;
        var msg = "Failed to parse PDF document " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): " + details);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFParsingError;
}(Error);
var $0e148ef5e3ab151b$export$fda6cb3cf0fe0c76 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(NextByteAssertionError, _super);
    function NextByteAssertionError(pos, expectedByte, actualByte) {
        var _this = this;
        var msg = "Expected next byte to be " + expectedByte + " but it was actually " + actualByte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return NextByteAssertionError;
}($0e148ef5e3ab151b$export$fd202455a19cb700);
var $0e148ef5e3ab151b$export$b8907968b8d7f502 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFObjectParsingError, _super);
    function PDFObjectParsingError(pos, byte) {
        var _this = this;
        var msg = "Failed to parse PDF object starting with the following byte: " + byte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFObjectParsingError;
}($0e148ef5e3ab151b$export$fd202455a19cb700);
var $0e148ef5e3ab151b$export$72474f06fb3a1c6b = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFInvalidObjectParsingError, _super);
    function PDFInvalidObjectParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse invalid PDF object";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFInvalidObjectParsingError;
}($0e148ef5e3ab151b$export$fd202455a19cb700);
var $0e148ef5e3ab151b$export$b1a91b84397f50d6 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFStreamParsingError, _super);
    function PDFStreamParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF stream";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFStreamParsingError;
}($0e148ef5e3ab151b$export$fd202455a19cb700);
var $0e148ef5e3ab151b$export$92803ff0e03167f9 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(UnbalancedParenthesisError, _super);
    function UnbalancedParenthesisError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF literal string due to unbalanced parenthesis";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return UnbalancedParenthesisError;
}($0e148ef5e3ab151b$export$fd202455a19cb700);
var $0e148ef5e3ab151b$export$b934c61834236c8 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(StalledParserError, _super);
    function StalledParserError(pos) {
        var _this = this;
        var msg = "Parser stalled";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return StalledParserError;
}($0e148ef5e3ab151b$export$fd202455a19cb700);
var $0e148ef5e3ab151b$export$cf6bd1b11dd05d74 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(MissingPDFHeaderError, _super);
    function MissingPDFHeaderError(pos) {
        var _this = this;
        var msg = "No PDF header found";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingPDFHeaderError;
}($0e148ef5e3ab151b$export$fd202455a19cb700);
var $0e148ef5e3ab151b$export$bc024c15c94be864 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(MissingKeywordError, _super);
    function MissingKeywordError(pos, keyword) {
        var _this = this;
        var msg = "Did not find expected keyword '" + (0, $i8eKs.arrayAsString)(keyword) + "'";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingKeywordError;
}($0e148ef5e3ab151b$export$fd202455a19cb700);

});



parcelRegister("5ZWJa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45e03453b5079dfc$export$2e2bcd8739ae039; });
var $45e03453b5079dfc$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Null"] = 0] = "Null";
    CharCodes[CharCodes["Backspace"] = 8] = "Backspace";
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["Newline"] = 10] = "Newline";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationPoint"] = 33] = "ExclamationPoint";
    CharCodes[CharCodes["Hash"] = 35] = "Hash";
    CharCodes[CharCodes["Percent"] = 37] = "Percent";
    CharCodes[CharCodes["LeftParen"] = 40] = "LeftParen";
    CharCodes[CharCodes["RightParen"] = 41] = "RightParen";
    CharCodes[CharCodes["Plus"] = 43] = "Plus";
    CharCodes[CharCodes["Minus"] = 45] = "Minus";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Period"] = 46] = "Period";
    CharCodes[CharCodes["ForwardSlash"] = 47] = "ForwardSlash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["One"] = 49] = "One";
    CharCodes[CharCodes["Two"] = 50] = "Two";
    CharCodes[CharCodes["Three"] = 51] = "Three";
    CharCodes[CharCodes["Four"] = 52] = "Four";
    CharCodes[CharCodes["Five"] = 53] = "Five";
    CharCodes[CharCodes["Six"] = 54] = "Six";
    CharCodes[CharCodes["Seven"] = 55] = "Seven";
    CharCodes[CharCodes["Eight"] = 56] = "Eight";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["LessThan"] = 60] = "LessThan";
    CharCodes[CharCodes["GreaterThan"] = 62] = "GreaterThan";
    CharCodes[CharCodes["A"] = 65] = "A";
    CharCodes[CharCodes["D"] = 68] = "D";
    CharCodes[CharCodes["E"] = 69] = "E";
    CharCodes[CharCodes["F"] = 70] = "F";
    CharCodes[CharCodes["O"] = 79] = "O";
    CharCodes[CharCodes["P"] = 80] = "P";
    CharCodes[CharCodes["R"] = 82] = "R";
    CharCodes[CharCodes["LeftSquareBracket"] = 91] = "LeftSquareBracket";
    CharCodes[CharCodes["BackSlash"] = 92] = "BackSlash";
    CharCodes[CharCodes["RightSquareBracket"] = 93] = "RightSquareBracket";
    CharCodes[CharCodes["a"] = 97] = "a";
    CharCodes[CharCodes["b"] = 98] = "b";
    CharCodes[CharCodes["d"] = 100] = "d";
    CharCodes[CharCodes["e"] = 101] = "e";
    CharCodes[CharCodes["f"] = 102] = "f";
    CharCodes[CharCodes["i"] = 105] = "i";
    CharCodes[CharCodes["j"] = 106] = "j";
    CharCodes[CharCodes["l"] = 108] = "l";
    CharCodes[CharCodes["m"] = 109] = "m";
    CharCodes[CharCodes["n"] = 110] = "n";
    CharCodes[CharCodes["o"] = 111] = "o";
    CharCodes[CharCodes["r"] = 114] = "r";
    CharCodes[CharCodes["s"] = 115] = "s";
    CharCodes[CharCodes["t"] = 116] = "t";
    CharCodes[CharCodes["u"] = 117] = "u";
    CharCodes[CharCodes["x"] = 120] = "x";
    CharCodes[CharCodes["LeftCurly"] = 123] = "LeftCurly";
    CharCodes[CharCodes["RightCurly"] = 125] = "RightCurly";
    CharCodes[CharCodes["Tilde"] = 126] = "Tilde";
})($45e03453b5079dfc$var$CharCodes || ($45e03453b5079dfc$var$CharCodes = {}));
var $45e03453b5079dfc$export$2e2bcd8739ae039 = $45e03453b5079dfc$var$CharCodes;

});


parcelRegister("evfTd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8f049450f3783a5$export$2e2bcd8739ae039; });

var $59LZ8 = parcelRequire("59LZ8");

var $1cWQu = parcelRequire("1cWQu");

var $cWdWp = parcelRequire("cWdWp");

var $5ZWJa = parcelRequire("5ZWJa");
var $a8f049450f3783a5$var$ENFORCER = {};
var $a8f049450f3783a5$var$PDFBool = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFBool, _super);
    function PDFBool(enforcer, value) {
        var _this = this;
        if (enforcer !== $a8f049450f3783a5$var$ENFORCER) throw new (0, $1cWQu.PrivateConstructorError)("PDFBool");
        _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFBool.prototype.asBoolean = function() {
        return this.value;
    };
    PDFBool.prototype.clone = function() {
        return this;
    };
    PDFBool.prototype.toString = function() {
        return String(this.value);
    };
    PDFBool.prototype.sizeInBytes = function() {
        return this.value ? 4 : 5;
    };
    PDFBool.prototype.copyBytesInto = function(buffer, offset) {
        if (this.value) {
            buffer[offset++] = (0, $5ZWJa.default).t;
            buffer[offset++] = (0, $5ZWJa.default).r;
            buffer[offset++] = (0, $5ZWJa.default).u;
            buffer[offset++] = (0, $5ZWJa.default).e;
            return 4;
        } else {
            buffer[offset++] = (0, $5ZWJa.default).f;
            buffer[offset++] = (0, $5ZWJa.default).a;
            buffer[offset++] = (0, $5ZWJa.default).l;
            buffer[offset++] = (0, $5ZWJa.default).s;
            buffer[offset++] = (0, $5ZWJa.default).e;
            return 5;
        }
    };
    PDFBool.True = new PDFBool($a8f049450f3783a5$var$ENFORCER, true);
    PDFBool.False = new PDFBool($a8f049450f3783a5$var$ENFORCER, false);
    return PDFBool;
}((0, $cWdWp.default));
var $a8f049450f3783a5$export$2e2bcd8739ae039 = $a8f049450f3783a5$var$PDFBool;

});

parcelRegister("a7yPZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75e594dd3f081000$export$2e2bcd8739ae039; });

var $59LZ8 = parcelRequire("59LZ8");

var $1cWQu = parcelRequire("1cWQu");

var $cWdWp = parcelRequire("cWdWp");

var $5ZWJa = parcelRequire("5ZWJa");

var $5eyt7 = parcelRequire("5eyt7");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $75e594dd3f081000$var$decodeName = function(name) {
    return name.replace(/#([\dABCDEF]{2})/g, function(_, hex) {
        return (0, $cZKSB.charFromHexCode)(hex);
    });
};
var $75e594dd3f081000$var$isRegularChar = function(charCode) {
    return charCode >= (0, $5ZWJa.default).ExclamationPoint && charCode <= (0, $5ZWJa.default).Tilde && !(0, $5eyt7.IsIrregular)[charCode];
};
var $75e594dd3f081000$var$ENFORCER = {};
var $75e594dd3f081000$var$pool = new Map();
var $75e594dd3f081000$var$PDFName = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFName, _super);
    function PDFName(enforcer, name) {
        var _this = this;
        if (enforcer !== $75e594dd3f081000$var$ENFORCER) throw new (0, $1cWQu.PrivateConstructorError)("PDFName");
        _this = _super.call(this) || this;
        var encodedName = "/";
        for(var idx = 0, len = name.length; idx < len; idx++){
            var character = name[idx];
            var code = (0, $cZKSB.toCharCode)(character);
            encodedName += $75e594dd3f081000$var$isRegularChar(code) ? character : "#" + (0, $cZKSB.toHexString)(code);
        }
        _this.encodedName = encodedName;
        return _this;
    }
    PDFName.prototype.asBytes = function() {
        var bytes = [];
        var hex = "";
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 1, len = this.encodedName.length; idx < len; idx++){
            var char = this.encodedName[idx];
            var byte = (0, $cZKSB.toCharCode)(char);
            var nextChar = this.encodedName[idx + 1];
            if (!escaped) {
                if (byte === (0, $5ZWJa.default).Hash) escaped = true;
                else pushByte(byte);
            } else if (byte >= (0, $5ZWJa.default).Zero && byte <= (0, $5ZWJa.default).Nine || byte >= (0, $5ZWJa.default).a && byte <= (0, $5ZWJa.default).f || byte >= (0, $5ZWJa.default).A && byte <= (0, $5ZWJa.default).F) {
                hex += char;
                if (hex.length === 2 || !(nextChar >= "0" && nextChar <= "9" || nextChar >= "a" && nextChar <= "f" || nextChar >= "A" && nextChar <= "F")) {
                    pushByte(parseInt(hex, 16));
                    hex = "";
                }
            } else pushByte(byte);
        }
        return new Uint8Array(bytes);
    };
    // TODO: This should probably use `utf8Decode()`
    // TODO: Polyfill Array.from?
    PDFName.prototype.decodeText = function() {
        var bytes = this.asBytes();
        return String.fromCharCode.apply(String, Array.from(bytes));
    };
    PDFName.prototype.asString = function() {
        return this.encodedName;
    };
    /** @deprecated in favor of [[PDFName.asString]] */ PDFName.prototype.value = function() {
        return this.encodedName;
    };
    PDFName.prototype.clone = function() {
        return this;
    };
    PDFName.prototype.toString = function() {
        return this.encodedName;
    };
    PDFName.prototype.sizeInBytes = function() {
        return this.encodedName.length;
    };
    PDFName.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $cZKSB.copyStringIntoBuffer)(this.encodedName, buffer, offset);
        return this.encodedName.length;
    };
    PDFName.of = function(name) {
        var decodedValue = $75e594dd3f081000$var$decodeName(name);
        var instance = $75e594dd3f081000$var$pool.get(decodedValue);
        if (!instance) {
            instance = new PDFName($75e594dd3f081000$var$ENFORCER, decodedValue);
            $75e594dd3f081000$var$pool.set(decodedValue, instance);
        }
        return instance;
    };
    /* tslint:disable member-ordering */ PDFName.Length = PDFName.of("Length");
    PDFName.FlateDecode = PDFName.of("FlateDecode");
    PDFName.Resources = PDFName.of("Resources");
    PDFName.Font = PDFName.of("Font");
    PDFName.XObject = PDFName.of("XObject");
    PDFName.ExtGState = PDFName.of("ExtGState");
    PDFName.Contents = PDFName.of("Contents");
    PDFName.Type = PDFName.of("Type");
    PDFName.Parent = PDFName.of("Parent");
    PDFName.MediaBox = PDFName.of("MediaBox");
    PDFName.Page = PDFName.of("Page");
    PDFName.Annots = PDFName.of("Annots");
    PDFName.TrimBox = PDFName.of("TrimBox");
    PDFName.ArtBox = PDFName.of("ArtBox");
    PDFName.BleedBox = PDFName.of("BleedBox");
    PDFName.CropBox = PDFName.of("CropBox");
    PDFName.Rotate = PDFName.of("Rotate");
    PDFName.Title = PDFName.of("Title");
    PDFName.Author = PDFName.of("Author");
    PDFName.Subject = PDFName.of("Subject");
    PDFName.Creator = PDFName.of("Creator");
    PDFName.Keywords = PDFName.of("Keywords");
    PDFName.Producer = PDFName.of("Producer");
    PDFName.CreationDate = PDFName.of("CreationDate");
    PDFName.ModDate = PDFName.of("ModDate");
    return PDFName;
}((0, $cWdWp.default));
var $75e594dd3f081000$export$2e2bcd8739ae039 = $75e594dd3f081000$var$PDFName;

});
parcelRegister("5eyt7", function(module, exports) {

$parcel$export(module.exports, "IsIrregular", function () { return $3cf8ff51fa41879b$export$5a447e10c710a69b; });

var $5ZWJa = parcelRequire("5ZWJa");

var $hV4t3 = parcelRequire("hV4t3");

var $3dQGf = parcelRequire("3dQGf");
var $3cf8ff51fa41879b$export$5a447e10c710a69b = new Uint8Array(256);
for(var $3cf8ff51fa41879b$var$idx = 0, $3cf8ff51fa41879b$var$len = 256; $3cf8ff51fa41879b$var$idx < $3cf8ff51fa41879b$var$len; $3cf8ff51fa41879b$var$idx++)$3cf8ff51fa41879b$export$5a447e10c710a69b[$3cf8ff51fa41879b$var$idx] = (0, $3dQGf.IsWhitespace)[$3cf8ff51fa41879b$var$idx] || (0, $hV4t3.IsDelimiter)[$3cf8ff51fa41879b$var$idx] ? 1 : 0;
$3cf8ff51fa41879b$export$5a447e10c710a69b[(0, $5ZWJa.default).Hash] = 1;

});
parcelRegister("hV4t3", function(module, exports) {

$parcel$export(module.exports, "IsDelimiter", function () { return $d0bb39bd11733f81$export$30620680eaa3becd; });

var $5ZWJa = parcelRequire("5ZWJa");
var $d0bb39bd11733f81$export$30620680eaa3becd = new Uint8Array(256);
$d0bb39bd11733f81$export$30620680eaa3becd[(0, $5ZWJa.default).LeftParen] = 1;
$d0bb39bd11733f81$export$30620680eaa3becd[(0, $5ZWJa.default).RightParen] = 1;
$d0bb39bd11733f81$export$30620680eaa3becd[(0, $5ZWJa.default).LessThan] = 1;
$d0bb39bd11733f81$export$30620680eaa3becd[(0, $5ZWJa.default).GreaterThan] = 1;
$d0bb39bd11733f81$export$30620680eaa3becd[(0, $5ZWJa.default).LeftSquareBracket] = 1;
$d0bb39bd11733f81$export$30620680eaa3becd[(0, $5ZWJa.default).RightSquareBracket] = 1;
$d0bb39bd11733f81$export$30620680eaa3becd[(0, $5ZWJa.default).LeftCurly] = 1;
$d0bb39bd11733f81$export$30620680eaa3becd[(0, $5ZWJa.default).RightCurly] = 1;
$d0bb39bd11733f81$export$30620680eaa3becd[(0, $5ZWJa.default).ForwardSlash] = 1;
$d0bb39bd11733f81$export$30620680eaa3becd[(0, $5ZWJa.default).Percent] = 1;

});

parcelRegister("3dQGf", function(module, exports) {

$parcel$export(module.exports, "IsWhitespace", function () { return $258b733a4015053e$export$38c4de915d0e2c37; });

var $5ZWJa = parcelRequire("5ZWJa");
var $258b733a4015053e$export$38c4de915d0e2c37 = new Uint8Array(256);
$258b733a4015053e$export$38c4de915d0e2c37[(0, $5ZWJa.default).Null] = 1;
$258b733a4015053e$export$38c4de915d0e2c37[(0, $5ZWJa.default).Tab] = 1;
$258b733a4015053e$export$38c4de915d0e2c37[(0, $5ZWJa.default).Newline] = 1;
$258b733a4015053e$export$38c4de915d0e2c37[(0, $5ZWJa.default).FormFeed] = 1;
$258b733a4015053e$export$38c4de915d0e2c37[(0, $5ZWJa.default).CarriageReturn] = 1;
$258b733a4015053e$export$38c4de915d0e2c37[(0, $5ZWJa.default).Space] = 1;

});




parcelRegister("bz579", function(module, exports) {


module.exports = (parcelRequire("77jhP"))((parcelRequire("ei5ZA")).resolve("kUbmd")).then(()=>parcelRequire("1pAT9"));

});
parcelRegister("77jhP", function(module, exports) {
"use strict";

var $dKQ1w = parcelRequire("dKQ1w");
module.exports = $dKQ1w(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("dKQ1w", function(module, exports) {
"use strict";
var $a037ed06a1c9c73e$var$cachedBundles = {};
var $a037ed06a1c9c73e$var$cachedPreloads = {};
var $a037ed06a1c9c73e$var$cachedPrefetches = {};
function $a037ed06a1c9c73e$var$getCache(type) {
    switch(type){
        case "preload":
            return $a037ed06a1c9c73e$var$cachedPreloads;
        case "prefetch":
            return $a037ed06a1c9c73e$var$cachedPrefetches;
        default:
            return $a037ed06a1c9c73e$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a037ed06a1c9c73e$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("2cOpH", function(module, exports) {


module.exports = (parcelRequire("77jhP"))((parcelRequire("ei5ZA")).resolve("3hrYc")).then(()=>parcelRequire("im1dV"));

});

var $7d421eaa7dee1123$exports = {};
"use strict";

$7d421eaa7dee1123$exports = (parcelRequire("bPPxF"));


var $94b66d1f5bb6e578$export$882461b6382ed46c;
var $94b66d1f5bb6e578$export$757ceba2d55c277e;
"use strict";
var $b4bc5509af1b9d3e$exports = {};
"use strict";
function $b4bc5509af1b9d3e$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4bc5509af1b9d3e$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4bc5509af1b9d3e$var$checkDCE();

$b4bc5509af1b9d3e$exports = (parcelRequire("eALUl"));


var $94b66d1f5bb6e578$var$i;
$94b66d1f5bb6e578$export$882461b6382ed46c = $b4bc5509af1b9d3e$exports.createRoot;
$94b66d1f5bb6e578$export$757ceba2d55c277e = $b4bc5509af1b9d3e$exports.hydrateRoot;





var $hEVyQ = parcelRequire("hEVyQ");


var $hEVyQ = parcelRequire("hEVyQ");
var $93d437ea92523dce$export$56eef2c66459c635 = "_1yj1lr80";


function $c2d6c7e30fa459e6$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $7ca105576352d92d$export$2e2bcd8739ae039() {
    $7ca105576352d92d$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7ca105576352d92d$export$2e2bcd8739ae039.apply(this, arguments);
}



var $hEVyQ = parcelRequire("hEVyQ");

function $12c3a87622ffcd48$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $12c3a87622ffcd48$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $12c3a87622ffcd48$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $12c3a87622ffcd48$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $12c3a87622ffcd48$export$2e2bcd8739ae039 = $12c3a87622ffcd48$export$4f5d2d50c9deca37;



function $aa74efc05e7ee0b2$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}


/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $4083e2de269799a0$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }


/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $dbd72f49419aab0a$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $dbd72f49419aab0a$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $dbd72f49419aab0a$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $dbd72f49419aab0a$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $dbd72f49419aab0a$export$677b39864803984e($dbd72f49419aab0a$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $4083e2de269799a0$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $4083e2de269799a0$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $dbd72f49419aab0a$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $dbd72f49419aab0a$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $dbd72f49419aab0a$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $dbd72f49419aab0a$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $dbd72f49419aab0a$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $dbd72f49419aab0a$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $dbd72f49419aab0a$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$dbd72f49419aab0a$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $dbd72f49419aab0a$export$29fb7152bd3f781a(color) {
    color = $dbd72f49419aab0a$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $dbd72f49419aab0a$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $dbd72f49419aab0a$export$c852d90bf7403b62(color) {
    color = $dbd72f49419aab0a$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $dbd72f49419aab0a$export$677b39864803984e($dbd72f49419aab0a$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $dbd72f49419aab0a$export$d061e26956a60b0a(foreground, background) {
    const lumA = $dbd72f49419aab0a$export$c852d90bf7403b62(foreground);
    const lumB = $dbd72f49419aab0a$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $dbd72f49419aab0a$export$58f0f39f63f3cf42(color, value) {
    color = $dbd72f49419aab0a$export$677b39864803984e(color);
    value = $dbd72f49419aab0a$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $dbd72f49419aab0a$export$211a73f2b8c10ce4(color);
}
function $dbd72f49419aab0a$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $dbd72f49419aab0a$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $dbd72f49419aab0a$export$4b073707ff63303(color, coefficient) {
    color = $dbd72f49419aab0a$export$677b39864803984e(color);
    coefficient = $dbd72f49419aab0a$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $dbd72f49419aab0a$export$211a73f2b8c10ce4(color);
}
function $dbd72f49419aab0a$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $dbd72f49419aab0a$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $dbd72f49419aab0a$export$c0816ed86df316af(color, coefficient) {
    color = $dbd72f49419aab0a$export$677b39864803984e(color);
    coefficient = $dbd72f49419aab0a$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $dbd72f49419aab0a$export$211a73f2b8c10ce4(color);
}
function $dbd72f49419aab0a$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $dbd72f49419aab0a$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $dbd72f49419aab0a$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $dbd72f49419aab0a$export$c852d90bf7403b62(color) > 0.5 ? $dbd72f49419aab0a$export$4b073707ff63303(color, coefficient) : $dbd72f49419aab0a$export$c0816ed86df316af(color, coefficient);
}
function $dbd72f49419aab0a$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $dbd72f49419aab0a$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}





var $hEVyQ = parcelRequire("hEVyQ");





function $2dde65852ab1a54d$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $4083e2de269799a0$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}


var $2acf9cf0cb04308d$export$2e2bcd8739ae039 = (0, $2dde65852ab1a54d$export$2e2bcd8739ae039);




/**
 * @mui/styled-engine v5.13.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 

var $hEVyQ = parcelRequire("hEVyQ");
function $aa14e78c1e62c9d7$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $f990c49f56bd055b$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $f990c49f56bd055b$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $aa14e78c1e62c9d7$export$2e2bcd8739ae039)(function(prop) {
    return $f990c49f56bd055b$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $hEVyQ = parcelRequire("hEVyQ");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $78c93fe04117038f$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $78c93fe04117038f$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $78c93fe04117038f$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($78c93fe04117038f$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $78c93fe04117038f$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 = "-ms-";
var $05db4ec8e7f6e82d$export$2c0f367103c8d01c = "-moz-";
var $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 = "-webkit-";
var $05db4ec8e7f6e82d$export$a29989082612d0d9 = "comm";
var $05db4ec8e7f6e82d$export$aa3a2e812ca8570d = "rule";
var $05db4ec8e7f6e82d$export$527d108ccf083c2b = "decl";
var $05db4ec8e7f6e82d$export$d3d35020fa5b54f0 = "@page";
var $05db4ec8e7f6e82d$export$500415a86c544f73 = "@media";
var $05db4ec8e7f6e82d$export$a763edbf796b780a = "@import";
var $05db4ec8e7f6e82d$export$2790aeb8b4e5c826 = "@charset";
var $05db4ec8e7f6e82d$export$1cc683e23b84b133 = "@viewport";
var $05db4ec8e7f6e82d$export$9447a5efea57e862 = "@supports";
var $05db4ec8e7f6e82d$export$ef011b4e114b1fba = "@document";
var $05db4ec8e7f6e82d$export$6aad947bda0f3f46 = "@namespace";
var $05db4ec8e7f6e82d$export$b44a8529a35fcb60 = "@keyframes";
var $05db4ec8e7f6e82d$export$2c16de31893252e6 = "@font-face";
var $05db4ec8e7f6e82d$export$3d846dd52e150c6f = "@counter-style";
var $05db4ec8e7f6e82d$export$22314bfbb57653fe = "@font-feature-values";
var $05db4ec8e7f6e82d$export$d773506282b3cfe6 = "@layer";
var $05db4ec8e7f6e82d$export$2335f513bbd82c6d = Math.abs;
var $05db4ec8e7f6e82d$export$6788812c4e6611e6 = String.fromCharCode;
var $05db4ec8e7f6e82d$export$e6e34fd1f2686227 = Object.assign;
function $05db4ec8e7f6e82d$export$d6af199866bfb566(e, r) {
    return $05db4ec8e7f6e82d$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $05db4ec8e7f6e82d$export$a9db5e087081082d(e, 0)) << 2 ^ $05db4ec8e7f6e82d$export$a9db5e087081082d(e, 1)) << 2 ^ $05db4ec8e7f6e82d$export$a9db5e087081082d(e, 2)) << 2 ^ $05db4ec8e7f6e82d$export$a9db5e087081082d(e, 3) : 0;
}
function $05db4ec8e7f6e82d$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $05db4ec8e7f6e82d$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $05db4ec8e7f6e82d$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $05db4ec8e7f6e82d$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $05db4ec8e7f6e82d$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $05db4ec8e7f6e82d$export$36776f635604f274(e) {
    return e.length;
}
function $05db4ec8e7f6e82d$export$f9084667e487ed46(e) {
    return e.length;
}
function $05db4ec8e7f6e82d$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $05db4ec8e7f6e82d$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $05db4ec8e7f6e82d$export$53f1d5ea8de3d7c = 1;
var $05db4ec8e7f6e82d$export$4e0c71f277ca26b3 = 1;
var $05db4ec8e7f6e82d$export$f24224f1c91d8156 = 0;
var $05db4ec8e7f6e82d$export$5880b8b5730aff45 = 0;
var $05db4ec8e7f6e82d$export$c0306caf338ac095 = 0;
var $05db4ec8e7f6e82d$export$30a86d91af8ff6e6 = "";
function $05db4ec8e7f6e82d$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $05db4ec8e7f6e82d$export$53f1d5ea8de3d7c,
        column: $05db4ec8e7f6e82d$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $05db4ec8e7f6e82d$export$784d13d8ee351f07(e, r) {
    return $05db4ec8e7f6e82d$export$e6e34fd1f2686227($05db4ec8e7f6e82d$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $05db4ec8e7f6e82d$export$eba6f6f03b0a92e7() {
    return $05db4ec8e7f6e82d$export$c0306caf338ac095;
}
function $05db4ec8e7f6e82d$export$232faf9add678146() {
    $05db4ec8e7f6e82d$export$c0306caf338ac095 = $05db4ec8e7f6e82d$export$5880b8b5730aff45 > 0 ? $05db4ec8e7f6e82d$export$a9db5e087081082d($05db4ec8e7f6e82d$export$30a86d91af8ff6e6, --$05db4ec8e7f6e82d$export$5880b8b5730aff45) : 0;
    if ($05db4ec8e7f6e82d$export$4e0c71f277ca26b3--, $05db4ec8e7f6e82d$export$c0306caf338ac095 === 10) $05db4ec8e7f6e82d$export$4e0c71f277ca26b3 = 1, $05db4ec8e7f6e82d$export$53f1d5ea8de3d7c--;
    return $05db4ec8e7f6e82d$export$c0306caf338ac095;
}
function $05db4ec8e7f6e82d$export$48cfd1e771a65c4f() {
    $05db4ec8e7f6e82d$export$c0306caf338ac095 = $05db4ec8e7f6e82d$export$5880b8b5730aff45 < $05db4ec8e7f6e82d$export$f24224f1c91d8156 ? $05db4ec8e7f6e82d$export$a9db5e087081082d($05db4ec8e7f6e82d$export$30a86d91af8ff6e6, $05db4ec8e7f6e82d$export$5880b8b5730aff45++) : 0;
    if ($05db4ec8e7f6e82d$export$4e0c71f277ca26b3++, $05db4ec8e7f6e82d$export$c0306caf338ac095 === 10) $05db4ec8e7f6e82d$export$4e0c71f277ca26b3 = 1, $05db4ec8e7f6e82d$export$53f1d5ea8de3d7c++;
    return $05db4ec8e7f6e82d$export$c0306caf338ac095;
}
function $05db4ec8e7f6e82d$export$4d3fb11e950abb9e() {
    return $05db4ec8e7f6e82d$export$a9db5e087081082d($05db4ec8e7f6e82d$export$30a86d91af8ff6e6, $05db4ec8e7f6e82d$export$5880b8b5730aff45);
}
function $05db4ec8e7f6e82d$export$e88cb2efb12ae807() {
    return $05db4ec8e7f6e82d$export$5880b8b5730aff45;
}
function $05db4ec8e7f6e82d$export$58adb3bec8346d0f(e, r) {
    return $05db4ec8e7f6e82d$export$2f35ab04d2335697($05db4ec8e7f6e82d$export$30a86d91af8ff6e6, e, r);
}
function $05db4ec8e7f6e82d$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $05db4ec8e7f6e82d$export$2de70f21292aac9e(e) {
    return $05db4ec8e7f6e82d$export$53f1d5ea8de3d7c = $05db4ec8e7f6e82d$export$4e0c71f277ca26b3 = 1, $05db4ec8e7f6e82d$export$f24224f1c91d8156 = $05db4ec8e7f6e82d$export$36776f635604f274($05db4ec8e7f6e82d$export$30a86d91af8ff6e6 = e), $05db4ec8e7f6e82d$export$5880b8b5730aff45 = 0, [];
}
function $05db4ec8e7f6e82d$export$45918ac1574455b1(e) {
    return $05db4ec8e7f6e82d$export$30a86d91af8ff6e6 = "", e;
}
function $05db4ec8e7f6e82d$export$410ac95b9ec204b8(e) {
    return $05db4ec8e7f6e82d$export$87c2784dc9fc4ab($05db4ec8e7f6e82d$export$58adb3bec8346d0f($05db4ec8e7f6e82d$export$5880b8b5730aff45 - 1, $05db4ec8e7f6e82d$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $05db4ec8e7f6e82d$export$660b2ee2d4fb4eff(e) {
    return $05db4ec8e7f6e82d$export$45918ac1574455b1($05db4ec8e7f6e82d$export$5f8c09e3ae6f64e1($05db4ec8e7f6e82d$export$2de70f21292aac9e(e)));
}
function $05db4ec8e7f6e82d$export$7af1228ff777d175(e) {
    while($05db4ec8e7f6e82d$export$c0306caf338ac095 = $05db4ec8e7f6e82d$export$4d3fb11e950abb9e())if ($05db4ec8e7f6e82d$export$c0306caf338ac095 < 33) $05db4ec8e7f6e82d$export$48cfd1e771a65c4f();
    else break;
    return $05db4ec8e7f6e82d$export$9e1725a4cfeada27(e) > 2 || $05db4ec8e7f6e82d$export$9e1725a4cfeada27($05db4ec8e7f6e82d$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $05db4ec8e7f6e82d$export$5f8c09e3ae6f64e1(e) {
    while($05db4ec8e7f6e82d$export$48cfd1e771a65c4f())switch($05db4ec8e7f6e82d$export$9e1725a4cfeada27($05db4ec8e7f6e82d$export$c0306caf338ac095)){
        case 0:
            $05db4ec8e7f6e82d$export$10d8903dec122b9d($05db4ec8e7f6e82d$export$c2ab62c7bf24634($05db4ec8e7f6e82d$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $05db4ec8e7f6e82d$export$10d8903dec122b9d($05db4ec8e7f6e82d$export$410ac95b9ec204b8($05db4ec8e7f6e82d$export$c0306caf338ac095), e);
            break;
        default:
            $05db4ec8e7f6e82d$export$10d8903dec122b9d($05db4ec8e7f6e82d$export$6788812c4e6611e6($05db4ec8e7f6e82d$export$c0306caf338ac095), e);
    }
    return e;
}
function $05db4ec8e7f6e82d$export$955ba06d119e085e(e, r) {
    while(--r && $05db4ec8e7f6e82d$export$48cfd1e771a65c4f())if ($05db4ec8e7f6e82d$export$c0306caf338ac095 < 48 || $05db4ec8e7f6e82d$export$c0306caf338ac095 > 102 || $05db4ec8e7f6e82d$export$c0306caf338ac095 > 57 && $05db4ec8e7f6e82d$export$c0306caf338ac095 < 65 || $05db4ec8e7f6e82d$export$c0306caf338ac095 > 70 && $05db4ec8e7f6e82d$export$c0306caf338ac095 < 97) break;
    return $05db4ec8e7f6e82d$export$58adb3bec8346d0f(e, $05db4ec8e7f6e82d$export$e88cb2efb12ae807() + (r < 6 && $05db4ec8e7f6e82d$export$4d3fb11e950abb9e() == 32 && $05db4ec8e7f6e82d$export$48cfd1e771a65c4f() == 32));
}
function $05db4ec8e7f6e82d$export$c889f2fcc19dbf12(e) {
    while($05db4ec8e7f6e82d$export$48cfd1e771a65c4f())switch($05db4ec8e7f6e82d$export$c0306caf338ac095){
        case e:
            return $05db4ec8e7f6e82d$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $05db4ec8e7f6e82d$export$c889f2fcc19dbf12($05db4ec8e7f6e82d$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $05db4ec8e7f6e82d$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $05db4ec8e7f6e82d$export$48cfd1e771a65c4f();
            break;
    }
    return $05db4ec8e7f6e82d$export$5880b8b5730aff45;
}
function $05db4ec8e7f6e82d$export$4254d4e2b3745c4c(e, r) {
    while($05db4ec8e7f6e82d$export$48cfd1e771a65c4f())if (e + $05db4ec8e7f6e82d$export$c0306caf338ac095 === 57) break;
    else if (e + $05db4ec8e7f6e82d$export$c0306caf338ac095 === 84 && $05db4ec8e7f6e82d$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $05db4ec8e7f6e82d$export$58adb3bec8346d0f(r, $05db4ec8e7f6e82d$export$5880b8b5730aff45 - 1) + "*" + $05db4ec8e7f6e82d$export$6788812c4e6611e6(e === 47 ? e : $05db4ec8e7f6e82d$export$48cfd1e771a65c4f());
}
function $05db4ec8e7f6e82d$export$c2ab62c7bf24634(e) {
    while(!$05db4ec8e7f6e82d$export$9e1725a4cfeada27($05db4ec8e7f6e82d$export$4d3fb11e950abb9e()))$05db4ec8e7f6e82d$export$48cfd1e771a65c4f();
    return $05db4ec8e7f6e82d$export$58adb3bec8346d0f(e, $05db4ec8e7f6e82d$export$5880b8b5730aff45);
}
function $05db4ec8e7f6e82d$export$ef7acd7185315e22(e) {
    return $05db4ec8e7f6e82d$export$45918ac1574455b1($05db4ec8e7f6e82d$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $05db4ec8e7f6e82d$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $05db4ec8e7f6e82d$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $05db4ec8e7f6e82d$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $05db4ec8e7f6e82d$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($05db4ec8e7f6e82d$export$f8e21b1e77979a08(j += $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed($05db4ec8e7f6e82d$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $05db4ec8e7f6e82d$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $05db4ec8e7f6e82d$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $05db4ec8e7f6e82d$export$955ba06d119e085e($05db4ec8e7f6e82d$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($05db4ec8e7f6e82d$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $05db4ec8e7f6e82d$export$10d8903dec122b9d($05db4ec8e7f6e82d$export$4a34f930e789283c($05db4ec8e7f6e82d$export$4254d4e2b3745c4c($05db4ec8e7f6e82d$export$48cfd1e771a65c4f(), $05db4ec8e7f6e82d$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $05db4ec8e7f6e82d$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $05db4ec8e7f6e82d$export$36776f635604f274(j) - l) $05db4ec8e7f6e82d$export$10d8903dec122b9d(p > 32 ? $05db4ec8e7f6e82d$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $05db4ec8e7f6e82d$export$f8483753829ec8f3($05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $05db4ec8e7f6e82d$export$10d8903dec122b9d(y = $05db4ec8e7f6e82d$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $05db4ec8e7f6e82d$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $05db4ec8e7f6e82d$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $05db4ec8e7f6e82d$export$98e6a39c04603d36(e, y, y, n && $05db4ec8e7f6e82d$export$10d8903dec122b9d($05db4ec8e7f6e82d$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $05db4ec8e7f6e82d$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $05db4ec8e7f6e82d$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $05db4ec8e7f6e82d$export$232faf9add678146() == 125) continue;
            }
            switch(j += $05db4ec8e7f6e82d$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($05db4ec8e7f6e82d$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($05db4ec8e7f6e82d$export$4d3fb11e950abb9e() === 45) j += $05db4ec8e7f6e82d$export$410ac95b9ec204b8($05db4ec8e7f6e82d$export$48cfd1e771a65c4f());
                    v = $05db4ec8e7f6e82d$export$4d3fb11e950abb9e(), o = l = $05db4ec8e7f6e82d$export$36776f635604f274(g = j += $05db4ec8e7f6e82d$export$c2ab62c7bf24634($05db4ec8e7f6e82d$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $05db4ec8e7f6e82d$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $05db4ec8e7f6e82d$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $05db4ec8e7f6e82d$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $05db4ec8e7f6e82d$export$2f35ab04d2335697(e, v + 1, v = $05db4ec8e7f6e82d$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $05db4ec8e7f6e82d$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $05db4ec8e7f6e82d$export$35059013cd4a06db(e, r, a, s === 0 ? $05db4ec8e7f6e82d$export$aa3a2e812ca8570d : i, f, o, l);
}
function $05db4ec8e7f6e82d$export$4a34f930e789283c(e, r, a) {
    return $05db4ec8e7f6e82d$export$35059013cd4a06db(e, r, a, $05db4ec8e7f6e82d$export$a29989082612d0d9, $05db4ec8e7f6e82d$export$6788812c4e6611e6($05db4ec8e7f6e82d$export$eba6f6f03b0a92e7()), $05db4ec8e7f6e82d$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $05db4ec8e7f6e82d$export$f8483753829ec8f3(e, r, a, n) {
    return $05db4ec8e7f6e82d$export$35059013cd4a06db(e, r, a, $05db4ec8e7f6e82d$export$527d108ccf083c2b, $05db4ec8e7f6e82d$export$2f35ab04d2335697(e, 0, n), $05db4ec8e7f6e82d$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $05db4ec8e7f6e82d$export$82e9f45cca5ba907(n, c, s) {
    switch($05db4ec8e7f6e82d$export$d6af199866bfb566(n, c)){
        case 5103:
            return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $05db4ec8e7f6e82d$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + $05db4ec8e7f6e82d$export$2c0f367103c8d01c + n + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($05db4ec8e7f6e82d$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + "box-$1$2" + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + "flex-item-" + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$05db4ec8e7f6e82d$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + "grid-row-" + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + "flex-line-pack" + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + "box-" + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, "-grow", "") + $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed($05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed($05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed($05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + "box-pack:$3" + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$05db4ec8e7f6e82d$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + "grid-column-align" + $05db4ec8e7f6e82d$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $05db4ec8e7f6e82d$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$05db4ec8e7f6e82d$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$05db4ec8e7f6e82d$export$f8e21b1e77979a08(s, "span") ? $05db4ec8e7f6e82d$export$4659b591c19bdf3d(s, /\d+/) : +$05db4ec8e7f6e82d$export$4659b591c19bdf3d(s, /\d+/) - +$05db4ec8e7f6e82d$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $05db4ec8e7f6e82d$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed($05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($05db4ec8e7f6e82d$export$36776f635604f274(n) - 1 - c > 6) switch($05db4ec8e7f6e82d$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($05db4ec8e7f6e82d$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $05db4ec8e7f6e82d$export$2c0f367103c8d01c + ($05db4ec8e7f6e82d$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$05db4ec8e7f6e82d$export$f8e21b1e77979a08(n, "stretch") ? $05db4ec8e7f6e82d$export$82e9f45cca5ba907($05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($05db4ec8e7f6e82d$export$a9db5e087081082d(n, c + 6) === 121) return $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, ":", ":" + $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($05db4ec8e7f6e82d$export$a9db5e087081082d(n, $05db4ec8e7f6e82d$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + ($05db4ec8e7f6e82d$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, ":", ":" + $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $05db4ec8e7f6e82d$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $05db4ec8e7f6e82d$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $05db4ec8e7f6e82d$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $05db4ec8e7f6e82d$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $05db4ec8e7f6e82d$export$a763edbf796b780a:
        case $05db4ec8e7f6e82d$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $05db4ec8e7f6e82d$export$a29989082612d0d9:
            return "";
        case $05db4ec8e7f6e82d$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $05db4ec8e7f6e82d$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $05db4ec8e7f6e82d$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $05db4ec8e7f6e82d$export$36776f635604f274(a = $05db4ec8e7f6e82d$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $05db4ec8e7f6e82d$export$5a7767152ae0305f(e) {
    var r = $05db4ec8e7f6e82d$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $05db4ec8e7f6e82d$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $05db4ec8e7f6e82d$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $05db4ec8e7f6e82d$export$527d108ccf083c2b:
                n.return = $05db4ec8e7f6e82d$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $05db4ec8e7f6e82d$export$b44a8529a35fcb60:
                return $05db4ec8e7f6e82d$export$dfdc1655ccc5b9cb([
                    $05db4ec8e7f6e82d$export$784d13d8ee351f07(n, {
                        value: $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $05db4ec8e7f6e82d$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $05db4ec8e7f6e82d$export$aa3a2e812ca8570d:
                if (n.length) return $05db4ec8e7f6e82d$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($05db4ec8e7f6e82d$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $05db4ec8e7f6e82d$export$dfdc1655ccc5b9cb([
                                $05db4ec8e7f6e82d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $05db4ec8e7f6e82d$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $05db4ec8e7f6e82d$export$dfdc1655ccc5b9cb([
                                $05db4ec8e7f6e82d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $05db4ec8e7f6e82d$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $05db4ec8e7f6e82d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $05db4ec8e7f6e82d$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $05db4ec8e7f6e82d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $05db4ec8e7f6e82d$export$76a88f7de6507443(e) {
    switch(e.type){
        case $05db4ec8e7f6e82d$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $05db4ec8e7f6e82d$export$1be1fc439b849fdf($05db4ec8e7f6e82d$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($05db4ec8e7f6e82d$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $05db4ec8e7f6e82d$export$2f35ab04d2335697(r, 1, $05db4ec8e7f6e82d$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $05db4ec8e7f6e82d$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $05db4ec8e7f6e82d$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $05db4ec8e7f6e82d$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $15dcf72fca69c6c1$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};



var $745ad4aaf61aab46$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $05db4ec8e7f6e82d$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $05db4ec8e7f6e82d$export$9e1725a4cfeada27)(character)) break;
        (0, $05db4ec8e7f6e82d$export$48cfd1e771a65c4f)();
    }
    return (0, $05db4ec8e7f6e82d$export$58adb3bec8346d0f)(begin, (0, $05db4ec8e7f6e82d$export$5880b8b5730aff45));
};
var $745ad4aaf61aab46$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $05db4ec8e7f6e82d$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $05db4ec8e7f6e82d$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $745ad4aaf61aab46$var$identifierWithPointTracking((0, $05db4ec8e7f6e82d$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $05db4ec8e7f6e82d$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $05db4ec8e7f6e82d$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $05db4ec8e7f6e82d$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $05db4ec8e7f6e82d$export$48cfd1e771a65c4f)());
    return parsed;
};
var $745ad4aaf61aab46$var$getRules = function getRules(value, points) {
    return (0, $05db4ec8e7f6e82d$export$45918ac1574455b1)($745ad4aaf61aab46$var$toRules((0, $05db4ec8e7f6e82d$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $745ad4aaf61aab46$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $745ad4aaf61aab46$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$745ad4aaf61aab46$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $745ad4aaf61aab46$var$fixedElements.set(element, true);
    var points = [];
    var rules = $745ad4aaf61aab46$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $745ad4aaf61aab46$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $745ad4aaf61aab46$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $745ad4aaf61aab46$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($745ad4aaf61aab46$var$ignoreFlag) > -1;
};
var $745ad4aaf61aab46$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($745ad4aaf61aab46$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $745ad4aaf61aab46$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $745ad4aaf61aab46$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$745ad4aaf61aab46$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $745ad4aaf61aab46$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $745ad4aaf61aab46$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$745ad4aaf61aab46$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $745ad4aaf61aab46$var$nullifyElement(element);
    } else if ($745ad4aaf61aab46$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $745ad4aaf61aab46$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $745ad4aaf61aab46$var$prefix(value, length) {
    switch((0, $05db4ec8e7f6e82d$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$2c0f367103c8d01c) + value + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + "flex-item-" + (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + "box-" + (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)((0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)((0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)((0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $05db4ec8e7f6e82d$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $05db4ec8e7f6e82d$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $05db4ec8e7f6e82d$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $05db4ec8e7f6e82d$export$2c0f367103c8d01c) + ((0, $05db4ec8e7f6e82d$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $05db4ec8e7f6e82d$export$f8e21b1e77979a08)(value, "stretch") ? $745ad4aaf61aab46$var$prefix((0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $05db4ec8e7f6e82d$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $05db4ec8e7f6e82d$export$a9db5e087081082d)(value, (0, $05db4ec8e7f6e82d$export$36776f635604f274)(value) - 3 - (~(0, $05db4ec8e7f6e82d$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + ((0, $05db4ec8e7f6e82d$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $05db4ec8e7f6e82d$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + value + (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $745ad4aaf61aab46$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $05db4ec8e7f6e82d$export$527d108ccf083c2b:
                element["return"] = $745ad4aaf61aab46$var$prefix(element.value, element.length);
                break;
            case 0, $05db4ec8e7f6e82d$export$b44a8529a35fcb60:
                return (0, $05db4ec8e7f6e82d$export$dfdc1655ccc5b9cb)([
                    (0, $05db4ec8e7f6e82d$export$784d13d8ee351f07)(element, {
                        value: (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $05db4ec8e7f6e82d$export$aa3a2e812ca8570d:
                if (element.length) return (0, $05db4ec8e7f6e82d$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $05db4ec8e7f6e82d$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $05db4ec8e7f6e82d$export$dfdc1655ccc5b9cb)([
                                (0, $05db4ec8e7f6e82d$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $05db4ec8e7f6e82d$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $05db4ec8e7f6e82d$export$dfdc1655ccc5b9cb)([
                                (0, $05db4ec8e7f6e82d$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $05db4ec8e7f6e82d$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $05db4ec8e7f6e82d$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $05db4ec8e7f6e82d$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $05db4ec8e7f6e82d$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $05db4ec8e7f6e82d$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $05db4ec8e7f6e82d$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $745ad4aaf61aab46$var$defaultStylisPlugins = [
    $745ad4aaf61aab46$var$prefixer
];
var $745ad4aaf61aab46$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $745ad4aaf61aab46$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $745ad4aaf61aab46$var$compat,
        $745ad4aaf61aab46$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $05db4ec8e7f6e82d$export$fac44ee5b035f737),
        (0, $05db4ec8e7f6e82d$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $05db4ec8e7f6e82d$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $05db4ec8e7f6e82d$export$dfdc1655ccc5b9cb)((0, $05db4ec8e7f6e82d$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $78c93fe04117038f$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $5fbc8cae9a1dbaa5$exports = {};
"use strict";
var $a2af6ae9a67a4561$exports = {};
"use strict";

$a2af6ae9a67a4561$exports = (parcelRequire("foTQs"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $5fbc8cae9a1dbaa5$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $5fbc8cae9a1dbaa5$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $5fbc8cae9a1dbaa5$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $5fbc8cae9a1dbaa5$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $5fbc8cae9a1dbaa5$var$TYPE_STATICS = {};
$5fbc8cae9a1dbaa5$var$TYPE_STATICS[$a2af6ae9a67a4561$exports.ForwardRef] = $5fbc8cae9a1dbaa5$var$FORWARD_REF_STATICS;
$5fbc8cae9a1dbaa5$var$TYPE_STATICS[$a2af6ae9a67a4561$exports.Memo] = $5fbc8cae9a1dbaa5$var$MEMO_STATICS;
function $5fbc8cae9a1dbaa5$var$getStatics(component) {
    // React v16.11 and below
    if ($a2af6ae9a67a4561$exports.isMemo(component)) return $5fbc8cae9a1dbaa5$var$MEMO_STATICS;
     // React v16.12 and above
    return $5fbc8cae9a1dbaa5$var$TYPE_STATICS[component["$$typeof"]] || $5fbc8cae9a1dbaa5$var$REACT_STATICS;
}
var $5fbc8cae9a1dbaa5$var$defineProperty = Object.defineProperty;
var $5fbc8cae9a1dbaa5$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $5fbc8cae9a1dbaa5$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5fbc8cae9a1dbaa5$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $5fbc8cae9a1dbaa5$var$getPrototypeOf = Object.getPrototypeOf;
var $5fbc8cae9a1dbaa5$var$objectPrototype = Object.prototype;
function $5fbc8cae9a1dbaa5$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($5fbc8cae9a1dbaa5$var$objectPrototype) {
            var inheritedComponent = $5fbc8cae9a1dbaa5$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $5fbc8cae9a1dbaa5$var$objectPrototype) $5fbc8cae9a1dbaa5$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $5fbc8cae9a1dbaa5$var$getOwnPropertyNames(sourceComponent);
        if ($5fbc8cae9a1dbaa5$var$getOwnPropertySymbols) keys = keys.concat($5fbc8cae9a1dbaa5$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $5fbc8cae9a1dbaa5$var$getStatics(targetComponent);
        var sourceStatics = $5fbc8cae9a1dbaa5$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$5fbc8cae9a1dbaa5$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $5fbc8cae9a1dbaa5$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $5fbc8cae9a1dbaa5$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$5fbc8cae9a1dbaa5$exports = $5fbc8cae9a1dbaa5$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $85f226a14c0a12f7$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5fbc8cae9a1dbaa5$exports)))(targetComponent, sourceComponent);
};


var $c3bc7b650c08c562$var$isBrowser = true;
function $c3bc7b650c08c562$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $c3bc7b650c08c562$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $c3bc7b650c08c562$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $c3bc7b650c08c562$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $c3bc7b650c08c562$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $27a57b36dec0c1e0$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $33b9e30ce26716d3$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $52e7fcdb7ae82216$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $52e7fcdb7ae82216$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $52e7fcdb7ae82216$var$hyphenateRegex = /[A-Z]|^ms/g;
var $52e7fcdb7ae82216$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $52e7fcdb7ae82216$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $52e7fcdb7ae82216$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $52e7fcdb7ae82216$var$processStyleName = /* #__PURE__ */ (0, $aa14e78c1e62c9d7$export$2e2bcd8739ae039)(function(styleName) {
    return $52e7fcdb7ae82216$var$isCustomProperty(styleName) ? styleName : styleName.replace($52e7fcdb7ae82216$var$hyphenateRegex, "-$&").toLowerCase();
});
var $52e7fcdb7ae82216$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($52e7fcdb7ae82216$var$animationRegex, function(match, p1, p2) {
                $52e7fcdb7ae82216$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $52e7fcdb7ae82216$var$cursor
                };
                return p1;
            });
    }
    if ((0, $33b9e30ce26716d3$export$2e2bcd8739ae039)[key] !== 1 && !$52e7fcdb7ae82216$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $52e7fcdb7ae82216$var$contentValuePattern, $52e7fcdb7ae82216$var$contentValues, $52e7fcdb7ae82216$var$oldProcessStyleValue, $52e7fcdb7ae82216$var$msPattern, $52e7fcdb7ae82216$var$hyphenPattern, $52e7fcdb7ae82216$var$hyphenatedCache;
var $52e7fcdb7ae82216$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $52e7fcdb7ae82216$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $52e7fcdb7ae82216$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $52e7fcdb7ae82216$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $52e7fcdb7ae82216$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $52e7fcdb7ae82216$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $52e7fcdb7ae82216$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $52e7fcdb7ae82216$var$cursor;
                var result = interpolation(mergedProps);
                $52e7fcdb7ae82216$var$cursor = previousCursor;
                return $52e7fcdb7ae82216$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $52e7fcdb7ae82216$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $52e7fcdb7ae82216$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($52e7fcdb7ae82216$var$isProcessableValue(value)) string += $52e7fcdb7ae82216$var$processStyleName(_key) + ":" + $52e7fcdb7ae82216$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($52e7fcdb7ae82216$var$isProcessableValue(value[_i])) string += $52e7fcdb7ae82216$var$processStyleName(_key) + ":" + $52e7fcdb7ae82216$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $52e7fcdb7ae82216$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $52e7fcdb7ae82216$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $52e7fcdb7ae82216$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $52e7fcdb7ae82216$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $52e7fcdb7ae82216$var$cursor;
var $52e7fcdb7ae82216$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $52e7fcdb7ae82216$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $52e7fcdb7ae82216$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $52e7fcdb7ae82216$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $52e7fcdb7ae82216$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $52e7fcdb7ae82216$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $27a57b36dec0c1e0$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $52e7fcdb7ae82216$var$cursor
    };
};



var $hEVyQ = parcelRequire("hEVyQ");
var $6c9b66b3ea7444be$var$syncFallback = function syncFallback(create) {
    return create();
};
var $6c9b66b3ea7444be$var$useInsertionEffect = $hEVyQ.useInsertionEffect ? $hEVyQ.useInsertionEffect : false;
var $6c9b66b3ea7444be$export$db21c7ffa21794e7 = $6c9b66b3ea7444be$var$useInsertionEffect || $6c9b66b3ea7444be$var$syncFallback;
var $6c9b66b3ea7444be$export$811a713a7276cb9d = $6c9b66b3ea7444be$var$useInsertionEffect || $hEVyQ.useLayoutEffect;


var $85d7f76edb428000$export$23f2a1d2818174ef = true;
var $85d7f76edb428000$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $85d7f76edb428000$var$EmotionCacheContext = /* #__PURE__ */ $hEVyQ.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $745ad4aaf61aab46$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $85d7f76edb428000$export$e7094788287c5e9b = $85d7f76edb428000$var$EmotionCacheContext.Provider;
var $85d7f76edb428000$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $hEVyQ.useContext)($85d7f76edb428000$var$EmotionCacheContext);
};
var $85d7f76edb428000$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $hEVyQ.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $hEVyQ.useContext)($85d7f76edb428000$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$85d7f76edb428000$export$23f2a1d2818174ef) $85d7f76edb428000$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $hEVyQ.useContext)($85d7f76edb428000$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $745ad4aaf61aab46$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $hEVyQ.createElement($85d7f76edb428000$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $85d7f76edb428000$export$971d5caa766a69d7 = /* #__PURE__ */ $hEVyQ.createContext({});
var $85d7f76edb428000$export$3b14a55fb2447963 = function useTheme() {
    return $hEVyQ.useContext($85d7f76edb428000$export$971d5caa766a69d7);
};
var $85d7f76edb428000$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $85d7f76edb428000$var$createCacheWithTheme = /* #__PURE__ */ (0, $15dcf72fca69c6c1$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $15dcf72fca69c6c1$export$2e2bcd8739ae039)(function(theme) {
        return $85d7f76edb428000$var$getTheme(outerTheme, theme);
    });
});
var $85d7f76edb428000$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $hEVyQ.useContext($85d7f76edb428000$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $85d7f76edb428000$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $hEVyQ.createElement($85d7f76edb428000$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $85d7f76edb428000$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $hEVyQ.useContext($85d7f76edb428000$export$971d5caa766a69d7);
        return /*#__PURE__*/ $hEVyQ.createElement(Component, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $hEVyQ.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $85f226a14c0a12f7$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $85d7f76edb428000$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $85d7f76edb428000$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $85d7f76edb428000$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $85d7f76edb428000$var$getLastPart(match[1]);
    return undefined;
};
var $85d7f76edb428000$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $85d7f76edb428000$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $85d7f76edb428000$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $85d7f76edb428000$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($85d7f76edb428000$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $85d7f76edb428000$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $85d7f76edb428000$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $85d7f76edb428000$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $85d7f76edb428000$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($85d7f76edb428000$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$85d7f76edb428000$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $85d7f76edb428000$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $c3bc7b650c08c562$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $6c9b66b3ea7444be$export$db21c7ffa21794e7)(function() {
        return (0, $c3bc7b650c08c562$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $85d7f76edb428000$var$Emotion = /* #__PURE__ */ $85d7f76edb428000$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$85d7f76edb428000$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $c3bc7b650c08c562$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $52e7fcdb7ae82216$export$6321afa313b251b5)(registeredStyles, undefined, $hEVyQ.useContext($85d7f76edb428000$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($85d7f76edb428000$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $85d7f76edb428000$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $hEVyQ.createElement($hEVyQ.Fragment, null, /*#__PURE__*/ $hEVyQ.createElement($85d7f76edb428000$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $hEVyQ.createElement(WrappedComponent, newProps));
});
var $85d7f76edb428000$export$a9c23c6ac3fc3eca = $85d7f76edb428000$var$Emotion;



var $hEVyQ = parcelRequire("hEVyQ");




var $ea7921174f90c74f$exports = {};
function $ea7921174f90c74f$var$_extends() {
    $ea7921174f90c74f$exports = $ea7921174f90c74f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $ea7921174f90c74f$exports.__esModule = true, $ea7921174f90c74f$exports["default"] = $ea7921174f90c74f$exports;
    return $ea7921174f90c74f$var$_extends.apply(this, arguments);
}
$ea7921174f90c74f$exports = $ea7921174f90c74f$var$_extends, $ea7921174f90c74f$exports.__esModule = true, $ea7921174f90c74f$exports["default"] = $ea7921174f90c74f$exports;





var $7a3cc2f12361a925$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $7a3cc2f12361a925$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $85d7f76edb428000$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return $hEVyQ.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $85d7f76edb428000$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $85d7f76edb428000$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $hEVyQ.createElement.apply(null, createElementArgArray);
};
var $7a3cc2f12361a925$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $7a3cc2f12361a925$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $85d7f76edb428000$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $52e7fcdb7ae82216$export$6321afa313b251b5)([
        styles
    ], undefined, $hEVyQ.useContext((0, $85d7f76edb428000$export$971d5caa766a69d7)));
    if (!(0, $85d7f76edb428000$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $hEVyQ.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $hEVyQ.useRef();
    (0, $6c9b66b3ea7444be$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $6c9b66b3ea7444be$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $c3bc7b650c08c562$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $7a3cc2f12361a925$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $52e7fcdb7ae82216$export$6321afa313b251b5)(args);
}
var $7a3cc2f12361a925$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $7a3cc2f12361a925$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $7a3cc2f12361a925$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $7a3cc2f12361a925$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $c3bc7b650c08c562$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $7a3cc2f12361a925$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $6c9b66b3ea7444be$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $c3bc7b650c08c562$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $7a3cc2f12361a925$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $85d7f76edb428000$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $52e7fcdb7ae82216$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $c3bc7b650c08c562$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $7a3cc2f12361a925$var$merge(cache.registered, css, $7a3cc2f12361a925$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $hEVyQ.useContext((0, $85d7f76edb428000$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $hEVyQ.createElement($hEVyQ.Fragment, null, /*#__PURE__*/ $hEVyQ.createElement($7a3cc2f12361a925$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $7a3cc2f12361a925$var$isBrowser, $7a3cc2f12361a925$var$isTestEnv, $7a3cc2f12361a925$var$globalContext, $7a3cc2f12361a925$var$globalKey;





var $91ec2008c5e93a9d$var$testOmitPropsOnStringTag = (0, $f990c49f56bd055b$export$2e2bcd8739ae039);
var $91ec2008c5e93a9d$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $91ec2008c5e93a9d$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $91ec2008c5e93a9d$var$testOmitPropsOnStringTag : $91ec2008c5e93a9d$var$testOmitPropsOnComponent;
};
var $91ec2008c5e93a9d$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $91ec2008c5e93a9d$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $91ec2008c5e93a9d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $c3bc7b650c08c562$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $6c9b66b3ea7444be$export$db21c7ffa21794e7)(function() {
        return (0, $c3bc7b650c08c562$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $91ec2008c5e93a9d$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $91ec2008c5e93a9d$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $91ec2008c5e93a9d$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $85d7f76edb428000$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $hEVyQ.useContext((0, $85d7f76edb428000$export$971d5caa766a69d7));
            }
            if (typeof props.className === "string") className = (0, $c3bc7b650c08c562$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $52e7fcdb7ae82216$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $91ec2008c5e93a9d$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $hEVyQ.createElement($hEVyQ.Fragment, null, /*#__PURE__*/ $hEVyQ.createElement($91ec2008c5e93a9d$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $hEVyQ.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $91ec2008c5e93a9d$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};



parcelRequire("hEVyQ");





var $e6546d4af21a3b2d$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $e6546d4af21a3b2d$export$2e2bcd8739ae039 = (0, $91ec2008c5e93a9d$export$2e2bcd8739ae039).bind();
$e6546d4af21a3b2d$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $e6546d4af21a3b2d$export$2e2bcd8739ae039[tagName] = $e6546d4af21a3b2d$export$2e2bcd8739ae039(tagName);
});





function $8b67f114cb8f4e1d$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $e6546d4af21a3b2d$export$2e2bcd8739ae039)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $8b67f114cb8f4e1d$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};





function $c041f5f3d1fce1ef$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $c041f5f3d1fce1ef$var$deepClone(source) {
    if (!$c041f5f3d1fce1ef$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $c041f5f3d1fce1ef$var$deepClone(source[key]);
    });
    return output;
}
function $c041f5f3d1fce1ef$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($c041f5f3d1fce1ef$export$53b83ca8eaab0383(target) && $c041f5f3d1fce1ef$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($c041f5f3d1fce1ef$export$53b83ca8eaab0383(source[key]) && key in target && $c041f5f3d1fce1ef$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $c041f5f3d1fce1ef$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $c041f5f3d1fce1ef$export$53b83ca8eaab0383(source[key]) ? $c041f5f3d1fce1ef$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}




const $b4b5cb6b160afbb0$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $b4b5cb6b160afbb0$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $b4b5cb6b160afbb0$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $b4b5cb6b160afbb0$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(breakpoints, $b4b5cb6b160afbb0$var$_excluded);
    const sortedValues = $b4b5cb6b160afbb0$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}


const $8da727b3d0e5d9d2$var$shape = {
    borderRadius: 4
};
var $8da727b3d0e5d9d2$export$2e2bcd8739ae039 = $8da727b3d0e5d9d2$var$shape;







function $844797093bcf7c5a$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $c041f5f3d1fce1ef$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $844797093bcf7c5a$export$2e2bcd8739ae039 = $844797093bcf7c5a$var$merge;


const $2bc41c1b49f158a3$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2bc41c1b49f158a3$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$2bc41c1b49f158a3$export$68c286be0e7e55b7[key]}px)`
};
function $2bc41c1b49f158a3$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2bc41c1b49f158a3$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $2bc41c1b49f158a3$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $2bc41c1b49f158a3$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2bc41c1b49f158a3$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2bc41c1b49f158a3$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $7ca105576352d92d$export$2e2bcd8739ae039)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $844797093bcf7c5a$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2bc41c1b49f158a3$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2bc41c1b49f158a3$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2bc41c1b49f158a3$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2bc41c1b49f158a3$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $c041f5f3d1fce1ef$export$2e2bcd8739ae039)(prev, next), {});
    return $2bc41c1b49f158a3$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $2bc41c1b49f158a3$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2bc41c1b49f158a3$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $2bc41c1b49f158a3$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $2bc41c1b49f158a3$export$2e2bcd8739ae039 = $2bc41c1b49f158a3$var$breakpoints;





function $bb7cec1d1d5bbb63$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $bb7cec1d1d5bbb63$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $bb7cec1d1d5bbb63$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $bb7cec1d1d5bbb63$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $bb7cec1d1d5bbb63$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $bb7cec1d1d5bbb63$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $bb7cec1d1d5bbb63$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $2dde65852ab1a54d$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $2bc41c1b49f158a3$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $bb7cec1d1d5bbb63$export$2e2bcd8739ae039 = $bb7cec1d1d5bbb63$var$style;



function $391a61bfc6349738$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $fc82371fe7fefdd9$var$properties = {
    m: "margin",
    p: "padding"
};
const $fc82371fe7fefdd9$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $fc82371fe7fefdd9$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $fc82371fe7fefdd9$var$getCssProperties = (0, $391a61bfc6349738$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($fc82371fe7fefdd9$var$aliases[prop]) prop = $fc82371fe7fefdd9$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $fc82371fe7fefdd9$var$properties[a];
    const direction = $fc82371fe7fefdd9$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $fc82371fe7fefdd9$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $fc82371fe7fefdd9$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $fc82371fe7fefdd9$var$spacingKeys = [
    ...$fc82371fe7fefdd9$export$aab52a0dde05ad8a,
    ...$fc82371fe7fefdd9$export$f8397d44f03ab6ad
];
function $fc82371fe7fefdd9$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $bb7cec1d1d5bbb63$export$2aa3fd96c49a84a8)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $fc82371fe7fefdd9$export$1def6f833384e3d1(theme) {
    return $fc82371fe7fefdd9$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $fc82371fe7fefdd9$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $fc82371fe7fefdd9$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $fc82371fe7fefdd9$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $fc82371fe7fefdd9$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $fc82371fe7fefdd9$var$getCssProperties(prop);
    const styleFromPropValue = $fc82371fe7fefdd9$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $2bc41c1b49f158a3$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $fc82371fe7fefdd9$var$style(props, keys) {
    const transformer = $fc82371fe7fefdd9$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$fc82371fe7fefdd9$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $844797093bcf7c5a$export$2e2bcd8739ae039), {});
}
function $fc82371fe7fefdd9$export$7ede87f9b603dd3c(props) {
    return $fc82371fe7fefdd9$var$style(props, $fc82371fe7fefdd9$export$aab52a0dde05ad8a);
}
$fc82371fe7fefdd9$export$7ede87f9b603dd3c.propTypes = {};
$fc82371fe7fefdd9$export$7ede87f9b603dd3c.filterProps = $fc82371fe7fefdd9$export$aab52a0dde05ad8a;
function $fc82371fe7fefdd9$export$6f98e8eaf0be1996(props) {
    return $fc82371fe7fefdd9$var$style(props, $fc82371fe7fefdd9$export$f8397d44f03ab6ad);
}
$fc82371fe7fefdd9$export$6f98e8eaf0be1996.propTypes = {};
$fc82371fe7fefdd9$export$6f98e8eaf0be1996.filterProps = $fc82371fe7fefdd9$export$f8397d44f03ab6ad;
function $fc82371fe7fefdd9$var$spacing(props) {
    return $fc82371fe7fefdd9$var$style(props, $fc82371fe7fefdd9$var$spacingKeys);
}
$fc82371fe7fefdd9$var$spacing.propTypes = {};
$fc82371fe7fefdd9$var$spacing.filterProps = $fc82371fe7fefdd9$var$spacingKeys;
var $fc82371fe7fefdd9$export$2e2bcd8739ae039 = $fc82371fe7fefdd9$var$spacing;


function $0e1a4ac26474ca38$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $fc82371fe7fefdd9$export$1def6f833384e3d1)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}










function $50c66438bbaeab77$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $844797093bcf7c5a$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $50c66438bbaeab77$export$2e2bcd8739ae039 = $50c66438bbaeab77$var$compose;




function $4c90dbf9808a5f73$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $4c90dbf9808a5f73$export$1edee58a52776cd9 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "border",
    themeKey: "borders",
    transform: $4c90dbf9808a5f73$export$34e2febe53ae29cc
});
const $4c90dbf9808a5f73$export$f9a7b6bd24892946 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $4c90dbf9808a5f73$export$34e2febe53ae29cc
});
const $4c90dbf9808a5f73$export$5abca33e6be905d2 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $4c90dbf9808a5f73$export$34e2febe53ae29cc
});
const $4c90dbf9808a5f73$export$e2ce9f12a980a822 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $4c90dbf9808a5f73$export$34e2febe53ae29cc
});
const $4c90dbf9808a5f73$export$47658cca1a909427 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $4c90dbf9808a5f73$export$34e2febe53ae29cc
});
const $4c90dbf9808a5f73$export$e7fb0694ba2404fc = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "borderColor",
    themeKey: "palette"
});
const $4c90dbf9808a5f73$export$126a92c968acdb85 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $4c90dbf9808a5f73$export$85cc51cb8fbb8c0e = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $4c90dbf9808a5f73$export$340b0327727f6d1a = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $4c90dbf9808a5f73$export$60beef91a985b4bf = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $4c90dbf9808a5f73$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $fc82371fe7fefdd9$export$cb5ee237cce814a2)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $fc82371fe7fefdd9$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2bc41c1b49f158a3$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$4c90dbf9808a5f73$export$7a57f79000377ca2.propTypes = {};
$4c90dbf9808a5f73$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $4c90dbf9808a5f73$var$borders = (0, $50c66438bbaeab77$export$2e2bcd8739ae039)($4c90dbf9808a5f73$export$1edee58a52776cd9, $4c90dbf9808a5f73$export$f9a7b6bd24892946, $4c90dbf9808a5f73$export$5abca33e6be905d2, $4c90dbf9808a5f73$export$e2ce9f12a980a822, $4c90dbf9808a5f73$export$47658cca1a909427, $4c90dbf9808a5f73$export$e7fb0694ba2404fc, $4c90dbf9808a5f73$export$126a92c968acdb85, $4c90dbf9808a5f73$export$85cc51cb8fbb8c0e, $4c90dbf9808a5f73$export$340b0327727f6d1a, $4c90dbf9808a5f73$export$60beef91a985b4bf, $4c90dbf9808a5f73$export$7a57f79000377ca2);
var $4c90dbf9808a5f73$export$2e2bcd8739ae039 = $4c90dbf9808a5f73$var$borders;







const $90fc8746f26caff4$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $fc82371fe7fefdd9$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $fc82371fe7fefdd9$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2bc41c1b49f158a3$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$90fc8746f26caff4$export$5df9adcb0db95e1e.propTypes = {};
$90fc8746f26caff4$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $90fc8746f26caff4$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $fc82371fe7fefdd9$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $fc82371fe7fefdd9$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2bc41c1b49f158a3$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$90fc8746f26caff4$export$ec60d70ff941a580.propTypes = {};
$90fc8746f26caff4$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $90fc8746f26caff4$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $fc82371fe7fefdd9$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $fc82371fe7fefdd9$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2bc41c1b49f158a3$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$90fc8746f26caff4$export$8a833ffa5f5dbeda.propTypes = {};
$90fc8746f26caff4$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $90fc8746f26caff4$export$baf44164ca3a34e8 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "gridColumn"
});
const $90fc8746f26caff4$export$8f7213a1cd01e832 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "gridRow"
});
const $90fc8746f26caff4$export$b0e0abbc49ba668 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "gridAutoFlow"
});
const $90fc8746f26caff4$export$bcd8b929d4b4142 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "gridAutoColumns"
});
const $90fc8746f26caff4$export$e5039a674e14c828 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "gridAutoRows"
});
const $90fc8746f26caff4$export$42bd9088661ffb03 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "gridTemplateColumns"
});
const $90fc8746f26caff4$export$920682ae05b999bc = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "gridTemplateRows"
});
const $90fc8746f26caff4$export$1b88fbdd482fd33a = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "gridTemplateAreas"
});
const $90fc8746f26caff4$export$bdb486e40d52d26f = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "gridArea"
});
const $90fc8746f26caff4$var$grid = (0, $50c66438bbaeab77$export$2e2bcd8739ae039)($90fc8746f26caff4$export$5df9adcb0db95e1e, $90fc8746f26caff4$export$ec60d70ff941a580, $90fc8746f26caff4$export$8a833ffa5f5dbeda, $90fc8746f26caff4$export$baf44164ca3a34e8, $90fc8746f26caff4$export$8f7213a1cd01e832, $90fc8746f26caff4$export$b0e0abbc49ba668, $90fc8746f26caff4$export$bcd8b929d4b4142, $90fc8746f26caff4$export$e5039a674e14c828, $90fc8746f26caff4$export$42bd9088661ffb03, $90fc8746f26caff4$export$920682ae05b999bc, $90fc8746f26caff4$export$1b88fbdd482fd33a, $90fc8746f26caff4$export$bdb486e40d52d26f);
var $90fc8746f26caff4$export$2e2bcd8739ae039 = $90fc8746f26caff4$var$grid;




function $0e69964f8913a1e7$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $0e69964f8913a1e7$export$35e9368ef982300f = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "color",
    themeKey: "palette",
    transform: $0e69964f8913a1e7$export$dbaffd4420ea0ac6
});
const $0e69964f8913a1e7$export$2506f56c10355b33 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $0e69964f8913a1e7$export$dbaffd4420ea0ac6
});
const $0e69964f8913a1e7$export$8c5a050822fd698c = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $0e69964f8913a1e7$export$dbaffd4420ea0ac6
});
const $0e69964f8913a1e7$var$palette = (0, $50c66438bbaeab77$export$2e2bcd8739ae039)($0e69964f8913a1e7$export$35e9368ef982300f, $0e69964f8913a1e7$export$2506f56c10355b33, $0e69964f8913a1e7$export$8c5a050822fd698c);
var $0e69964f8913a1e7$export$2e2bcd8739ae039 = $0e69964f8913a1e7$var$palette;





function $6ce6495e446713ab$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $6ce6495e446713ab$export$7e3df82ee760448c = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "width",
    transform: $6ce6495e446713ab$export$8afece71750ec241
});
const $6ce6495e446713ab$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
            const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || (0, $2bc41c1b49f158a3$export$68c286be0e7e55b7)[propValue];
            return {
                maxWidth: breakpoint || $6ce6495e446713ab$export$8afece71750ec241(propValue)
            };
        };
        return (0, $2bc41c1b49f158a3$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$6ce6495e446713ab$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $6ce6495e446713ab$export$ee148fbbe8357dd2 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "minWidth",
    transform: $6ce6495e446713ab$export$8afece71750ec241
});
const $6ce6495e446713ab$export$ac607276a8fe9f0a = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "height",
    transform: $6ce6495e446713ab$export$8afece71750ec241
});
const $6ce6495e446713ab$export$dc0d8bd0b94f8570 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "maxHeight",
    transform: $6ce6495e446713ab$export$8afece71750ec241
});
const $6ce6495e446713ab$export$a43cf604e12f3b17 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "minHeight",
    transform: $6ce6495e446713ab$export$8afece71750ec241
});
const $6ce6495e446713ab$export$ffed9f14fb65e276 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "width",
    transform: $6ce6495e446713ab$export$8afece71750ec241
});
const $6ce6495e446713ab$export$905076ed6620e671 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "height",
    transform: $6ce6495e446713ab$export$8afece71750ec241
});
const $6ce6495e446713ab$export$6ccc93f785106a58 = (0, $bb7cec1d1d5bbb63$export$2e2bcd8739ae039)({
    prop: "boxSizing"
});
const $6ce6495e446713ab$var$sizing = (0, $50c66438bbaeab77$export$2e2bcd8739ae039)($6ce6495e446713ab$export$7e3df82ee760448c, $6ce6495e446713ab$export$488fda99655ff65a, $6ce6495e446713ab$export$ee148fbbe8357dd2, $6ce6495e446713ab$export$ac607276a8fe9f0a, $6ce6495e446713ab$export$dc0d8bd0b94f8570, $6ce6495e446713ab$export$a43cf604e12f3b17, $6ce6495e446713ab$export$6ccc93f785106a58);
var $6ce6495e446713ab$export$2e2bcd8739ae039 = $6ce6495e446713ab$var$sizing;


const $104cc514cb62d3a2$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $4c90dbf9808a5f73$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $4c90dbf9808a5f73$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $4c90dbf9808a5f73$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $4c90dbf9808a5f73$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $4c90dbf9808a5f73$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $4c90dbf9808a5f73$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $0e69964f8913a1e7$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $0e69964f8913a1e7$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $0e69964f8913a1e7$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $fc82371fe7fefdd9$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $fc82371fe7fefdd9$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $90fc8746f26caff4$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $90fc8746f26caff4$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $90fc8746f26caff4$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $6ce6495e446713ab$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $6ce6495e446713ab$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $6ce6495e446713ab$export$8afece71750ec241)
    },
    height: {
        transform: (0, $6ce6495e446713ab$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $6ce6495e446713ab$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $6ce6495e446713ab$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $104cc514cb62d3a2$export$2e2bcd8739ae039 = $104cc514cb62d3a2$var$defaultSxConfig;


function $e8cd13de62f033e2$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $e8cd13de62f033e2$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $e8cd13de62f033e2$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $bb7cec1d1d5bbb63$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $bb7cec1d1d5bbb63$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $bb7cec1d1d5bbb63$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $2dde65852ab1a54d$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $2bc41c1b49f158a3$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $104cc514cb62d3a2$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $2bc41c1b49f158a3$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $e8cd13de62f033e2$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $844797093bcf7c5a$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $2bc41c1b49f158a3$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($e8cd13de62f033e2$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $844797093bcf7c5a$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $844797093bcf7c5a$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $2bc41c1b49f158a3$export$8922c90b6e020726)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $e8cd13de62f033e2$var$styleFunctionSx = $e8cd13de62f033e2$export$7d53d8bf2911e013();
$e8cd13de62f033e2$var$styleFunctionSx.filterProps = [
    "sx"
];
var $e8cd13de62f033e2$export$2e2bcd8739ae039 = $e8cd13de62f033e2$var$styleFunctionSx;



const $8b354f397cd54b58$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $8b354f397cd54b58$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(options, $8b354f397cd54b58$var$_excluded);
    const breakpoints = (0, $b4b5cb6b160afbb0$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $0e1a4ac26474ca38$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $c041f5f3d1fce1ef$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, (0, $8da727b3d0e5d9d2$export$2e2bcd8739ae039), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $c041f5f3d1fce1ef$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, (0, $104cc514cb62d3a2$export$2e2bcd8739ae039), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $e8cd13de62f033e2$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $8b354f397cd54b58$export$2e2bcd8739ae039 = $8b354f397cd54b58$var$createTheme;




const $2734f4f2d1b75a6c$var$_excluded = [
    "variant"
];
function $2734f4f2d1b75a6c$var$isEmpty(string) {
    return string.length === 0;
}
function $2734f4f2d1b75a6c$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $2734f4f2d1b75a6c$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $2734f4f2d1b75a6c$var$isEmpty(classKey) ? props[key] : (0, $2dde65852ab1a54d$export$2e2bcd8739ae039)(props[key]);
        else classKey += `${$2734f4f2d1b75a6c$var$isEmpty(classKey) ? key : (0, $2dde65852ab1a54d$export$2e2bcd8739ae039)(key)}${(0, $2dde65852ab1a54d$export$2e2bcd8739ae039)(props[key].toString())}`;
    });
    return classKey;
}



const $6a77c56efc47f61c$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $6a77c56efc47f61c$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $6a77c56efc47f61c$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $6a77c56efc47f61c$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $6a77c56efc47f61c$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $2734f4f2d1b75a6c$export$2e2bcd8739ae039)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $6a77c56efc47f61c$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components, _theme$components$nam;
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $2734f4f2d1b75a6c$export$2e2bcd8739ae039)(themeVariant.props)]);
    });
    return variantsStyles;
};
function $6a77c56efc47f61c$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $6a77c56efc47f61c$export$35e57303dbd8a66 = (0, $8b354f397cd54b58$export$2e2bcd8739ae039)();
const $6a77c56efc47f61c$var$lowercaseFirstLetter = (string)=>{
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $6a77c56efc47f61c$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $6a77c56efc47f61c$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $6a77c56efc47f61c$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $6a77c56efc47f61c$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $6a77c56efc47f61c$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $6a77c56efc47f61c$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $e8cd13de62f033e2$export$2e2bcd8739ae039)((0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
            theme: $6a77c56efc47f61c$var$resolveTheme((0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $8b67f114cb8f4e1d$export$e00380445f2b9e0c)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: overridesResolver } = inputOptions, options = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(inputOptions, $6a77c56efc47f61c$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $6a77c56efc47f61c$export$3ba67b570e26eea0;
        if (componentSlot === "Root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($6a77c56efc47f61c$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $8b67f114cb8f4e1d$export$2e2bcd8739ae039)(tag, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (props)=>{
                    return stylesArg((0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
                        theme: $6a77c56efc47f61c$var$resolveTheme((0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
                            defaultTheme: defaultTheme,
                            themeId: themeId
                        }))
                    }));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $6a77c56efc47f61c$var$resolveTheme((0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $6a77c56efc47f61c$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $6a77c56efc47f61c$var$resolveTheme((0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $6a77c56efc47f61c$var$variantsResolver(props, $6a77c56efc47f61c$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>styleArg((0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
                    theme: $6a77c56efc47f61c$var$resolveTheme((0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    }))
                }));
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}








function $09452dbcc3ae046b$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}






const $409c5770cf1571f1$var$common = {
    black: "#000",
    white: "#fff"
};
var $409c5770cf1571f1$export$2e2bcd8739ae039 = $409c5770cf1571f1$var$common;


const $4b41266b8bb39ce7$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $4b41266b8bb39ce7$export$2e2bcd8739ae039 = $4b41266b8bb39ce7$var$grey;


const $fb48c640243594e4$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $fb48c640243594e4$export$2e2bcd8739ae039 = $fb48c640243594e4$var$purple;


const $e2f5701c6b2e6007$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $e2f5701c6b2e6007$export$2e2bcd8739ae039 = $e2f5701c6b2e6007$var$red;


const $b92006c9b334febb$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $b92006c9b334febb$export$2e2bcd8739ae039 = $b92006c9b334febb$var$orange;


const $12bbb2097eacbab3$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $12bbb2097eacbab3$export$2e2bcd8739ae039 = $12bbb2097eacbab3$var$blue;


const $1c836d5b3dc0e049$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $1c836d5b3dc0e049$export$2e2bcd8739ae039 = $1c836d5b3dc0e049$var$lightBlue;


const $056f2a78b2aa38b9$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $056f2a78b2aa38b9$export$2e2bcd8739ae039 = $056f2a78b2aa38b9$var$green;


const $8a37995c22ae4bf6$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $8a37995c22ae4bf6$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $409c5770cf1571f1$export$2e2bcd8739ae039).white,
        default: (0, $409c5770cf1571f1$export$2e2bcd8739ae039).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $8a37995c22ae4bf6$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $409c5770cf1571f1$export$2e2bcd8739ae039).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $409c5770cf1571f1$export$2e2bcd8739ae039).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $8a37995c22ae4bf6$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $dbd72f49419aab0a$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $dbd72f49419aab0a$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $8a37995c22ae4bf6$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $12bbb2097eacbab3$export$2e2bcd8739ae039)[200],
        light: (0, $12bbb2097eacbab3$export$2e2bcd8739ae039)[50],
        dark: (0, $12bbb2097eacbab3$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $12bbb2097eacbab3$export$2e2bcd8739ae039)[700],
        light: (0, $12bbb2097eacbab3$export$2e2bcd8739ae039)[400],
        dark: (0, $12bbb2097eacbab3$export$2e2bcd8739ae039)[800]
    };
}
function $8a37995c22ae4bf6$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $fb48c640243594e4$export$2e2bcd8739ae039)[200],
        light: (0, $fb48c640243594e4$export$2e2bcd8739ae039)[50],
        dark: (0, $fb48c640243594e4$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $fb48c640243594e4$export$2e2bcd8739ae039)[500],
        light: (0, $fb48c640243594e4$export$2e2bcd8739ae039)[300],
        dark: (0, $fb48c640243594e4$export$2e2bcd8739ae039)[700]
    };
}
function $8a37995c22ae4bf6$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $e2f5701c6b2e6007$export$2e2bcd8739ae039)[500],
        light: (0, $e2f5701c6b2e6007$export$2e2bcd8739ae039)[300],
        dark: (0, $e2f5701c6b2e6007$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $e2f5701c6b2e6007$export$2e2bcd8739ae039)[700],
        light: (0, $e2f5701c6b2e6007$export$2e2bcd8739ae039)[400],
        dark: (0, $e2f5701c6b2e6007$export$2e2bcd8739ae039)[800]
    };
}
function $8a37995c22ae4bf6$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1c836d5b3dc0e049$export$2e2bcd8739ae039)[400],
        light: (0, $1c836d5b3dc0e049$export$2e2bcd8739ae039)[300],
        dark: (0, $1c836d5b3dc0e049$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $1c836d5b3dc0e049$export$2e2bcd8739ae039)[700],
        light: (0, $1c836d5b3dc0e049$export$2e2bcd8739ae039)[500],
        dark: (0, $1c836d5b3dc0e049$export$2e2bcd8739ae039)[900]
    };
}
function $8a37995c22ae4bf6$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $056f2a78b2aa38b9$export$2e2bcd8739ae039)[400],
        light: (0, $056f2a78b2aa38b9$export$2e2bcd8739ae039)[300],
        dark: (0, $056f2a78b2aa38b9$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $056f2a78b2aa38b9$export$2e2bcd8739ae039)[800],
        light: (0, $056f2a78b2aa38b9$export$2e2bcd8739ae039)[500],
        dark: (0, $056f2a78b2aa38b9$export$2e2bcd8739ae039)[900]
    };
}
function $8a37995c22ae4bf6$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $b92006c9b334febb$export$2e2bcd8739ae039)[400],
        light: (0, $b92006c9b334febb$export$2e2bcd8739ae039)[300],
        dark: (0, $b92006c9b334febb$export$2e2bcd8739ae039)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $b92006c9b334febb$export$2e2bcd8739ae039)[500],
        dark: (0, $b92006c9b334febb$export$2e2bcd8739ae039)[900]
    };
}
function $8a37995c22ae4bf6$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(palette, $8a37995c22ae4bf6$var$_excluded);
    const primary = palette.primary || $8a37995c22ae4bf6$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $8a37995c22ae4bf6$var$getDefaultSecondary(mode);
    const error = palette.error || $8a37995c22ae4bf6$var$getDefaultError(mode);
    const info = palette.info || $8a37995c22ae4bf6$var$getDefaultInfo(mode);
    const success = palette.success || $8a37995c22ae4bf6$var$getDefaultSuccess(mode);
    const warning = palette.warning || $8a37995c22ae4bf6$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $dbd72f49419aab0a$export$d061e26956a60b0a)(background, $8a37995c22ae4bf6$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $8a37995c22ae4bf6$export$55ce6f3a06c59543.text.primary : $8a37995c22ae4bf6$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $4083e2de269799a0$export$2e2bcd8739ae039)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $4083e2de269799a0$export$2e2bcd8739ae039)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $8a37995c22ae4bf6$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $8a37995c22ae4bf6$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $8a37995c22ae4bf6$export$55ce6f3a06c59543,
        light: $8a37995c22ae4bf6$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $c041f5f3d1fce1ef$export$2e2bcd8739ae039)((0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        // A collection of common colors.
        common: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, (0, $409c5770cf1571f1$export$2e2bcd8739ae039)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $4b41266b8bb39ce7$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}





const $4ac6d4aa960b3cab$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $4ac6d4aa960b3cab$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $4ac6d4aa960b3cab$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $4ac6d4aa960b3cab$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4ac6d4aa960b3cab$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $4ac6d4aa960b3cab$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(_ref, $4ac6d4aa960b3cab$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $4ac6d4aa960b3cab$var$defaultFontFamily ? {
            letterSpacing: `${$4ac6d4aa960b3cab$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $4ac6d4aa960b3cab$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $4ac6d4aa960b3cab$var$caseAllCaps),
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $c041f5f3d1fce1ef$export$2e2bcd8739ae039)((0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


const $70f918fab57c3d1e$var$shadowKeyUmbraOpacity = 0.2;
const $70f918fab57c3d1e$var$shadowKeyPenumbraOpacity = 0.14;
const $70f918fab57c3d1e$var$shadowAmbientShadowOpacity = 0.12;
function $70f918fab57c3d1e$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$70f918fab57c3d1e$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$70f918fab57c3d1e$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$70f918fab57c3d1e$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $70f918fab57c3d1e$var$shadows = [
    "none",
    $70f918fab57c3d1e$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $70f918fab57c3d1e$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $70f918fab57c3d1e$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $70f918fab57c3d1e$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $70f918fab57c3d1e$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $70f918fab57c3d1e$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $70f918fab57c3d1e$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $70f918fab57c3d1e$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $70f918fab57c3d1e$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $70f918fab57c3d1e$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $70f918fab57c3d1e$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $70f918fab57c3d1e$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $70f918fab57c3d1e$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $70f918fab57c3d1e$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $70f918fab57c3d1e$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $70f918fab57c3d1e$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $70f918fab57c3d1e$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $70f918fab57c3d1e$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $70f918fab57c3d1e$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $70f918fab57c3d1e$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $70f918fab57c3d1e$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $70f918fab57c3d1e$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $70f918fab57c3d1e$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $70f918fab57c3d1e$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $70f918fab57c3d1e$export$2e2bcd8739ae039 = $70f918fab57c3d1e$var$shadows;




const $2753eb7934c93fe9$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $2753eb7934c93fe9$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $2753eb7934c93fe9$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $2753eb7934c93fe9$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $2753eb7934c93fe9$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $2753eb7934c93fe9$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, $2753eb7934c93fe9$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, $2753eb7934c93fe9$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(options, $2753eb7934c93fe9$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $2753eb7934c93fe9$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $2753eb7934c93fe9$var$formatMs(delay)}`).join(",");
    };
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        getAutoHeightDuration: $2753eb7934c93fe9$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $5e75907d1104b865$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $5e75907d1104b865$export$2e2bcd8739ae039 = $5e75907d1104b865$var$zIndex;


const $ea1da536acea9340$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $ea1da536acea9340$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(options, $ea1da536acea9340$var$_excluded);
    if (options.vars) throw new Error((0, $4083e2de269799a0$export$2e2bcd8739ae039)(18));
    const palette = (0, $8a37995c22ae4bf6$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, $8b354f397cd54b58$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $c041f5f3d1fce1ef$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $09452dbcc3ae046b$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $70f918fab57c3d1e$export$2e2bcd8739ae039).slice(),
        typography: (0, $4ac6d4aa960b3cab$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $2753eb7934c93fe9$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, (0, $5e75907d1104b865$export$2e2bcd8739ae039))
    });
    muiTheme = (0, $c041f5f3d1fce1ef$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $c041f5f3d1fce1ef$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, (0, $104cc514cb62d3a2$export$2e2bcd8739ae039), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $e8cd13de62f033e2$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $ea1da536acea9340$var$warnedOnce = false;
function $ea1da536acea9340$export$c469355549431d9b(...args) {
    return $ea1da536acea9340$var$createTheme(...args);
}
var $ea1da536acea9340$export$2e2bcd8739ae039 = $ea1da536acea9340$var$createTheme;


const $d2a1fcd560cfdd72$var$defaultTheme = (0, $ea1da536acea9340$export$2e2bcd8739ae039)();
var $d2a1fcd560cfdd72$export$2e2bcd8739ae039 = $d2a1fcd560cfdd72$var$defaultTheme;


var $7586e29635f86062$export$2e2bcd8739ae039 = "$$material";


const $f0eb61bababa8473$export$effb20ecdbf4d6aa = (prop)=>(0, $6a77c56efc47f61c$export$3ba67b570e26eea0)(prop) && prop !== "classes";
const $f0eb61bababa8473$export$f10c5a10d27438e5 = (0, $6a77c56efc47f61c$export$3ba67b570e26eea0);
const $f0eb61bababa8473$var$styled = (0, $6a77c56efc47f61c$export$2e2bcd8739ae039)({
    themeId: (0, $7586e29635f86062$export$2e2bcd8739ae039),
    defaultTheme: $d2a1fcd560cfdd72$export$2e2bcd8739ae039,
    rootShouldForwardProp: $f0eb61bababa8473$export$effb20ecdbf4d6aa
});
var $f0eb61bababa8473$export$2e2bcd8739ae039 = $f0eb61bababa8473$var$styled;


/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $hEVyQ = parcelRequire("hEVyQ");
function $2eca462ab2867696$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $hEVyQ.useRef(controlled !== undefined);
    const [valueState, setValue] = $hEVyQ.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $hEVyQ.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


var $0feb9b02456bcdb9$export$2e2bcd8739ae039 = (0, $2eca462ab2867696$export$2e2bcd8739ae039);



var $hEVyQ = parcelRequire("hEVyQ");

var $hEVyQ = parcelRequire("hEVyQ");
/**
 * @ignore - internal component.
 */ const $994c906661fff8d9$var$FormControlContext = /*#__PURE__*/ $hEVyQ.createContext(undefined);
var $994c906661fff8d9$export$2e2bcd8739ae039 = $994c906661fff8d9$var$FormControlContext;


function $aa5dba5365b3a355$export$2e2bcd8739ae039() {
    return $hEVyQ.useContext((0, $994c906661fff8d9$export$2e2bcd8739ae039));
}





var $hEVyQ = parcelRequire("hEVyQ");





/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */ function $ec866b9bc2d17599$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $ec866b9bc2d17599$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}


function $5c526c6ba0140439$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $ec866b9bc2d17599$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}




var $hEVyQ = parcelRequire("hEVyQ");

function $980399c30f268020$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $980399c30f268020$var$useTheme(defaultTheme = null) {
    const contextTheme = $hEVyQ.useContext((0, $85d7f76edb428000$export$971d5caa766a69d7));
    return !contextTheme || $980399c30f268020$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $980399c30f268020$export$2e2bcd8739ae039 = $980399c30f268020$var$useTheme;


const $adb2b7c4d20eb565$export$35e57303dbd8a66 = (0, $8b354f397cd54b58$export$2e2bcd8739ae039)();
function $adb2b7c4d20eb565$var$useTheme(defaultTheme = $adb2b7c4d20eb565$export$35e57303dbd8a66) {
    return (0, $980399c30f268020$export$2e2bcd8739ae039)(defaultTheme);
}
var $adb2b7c4d20eb565$export$2e2bcd8739ae039 = $adb2b7c4d20eb565$var$useTheme;


function $453d753b537f7a1e$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $adb2b7c4d20eb565$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $5c526c6ba0140439$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}




function $7fe3c49d20140c33$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $453d753b537f7a1e$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $d2a1fcd560cfdd72$export$2e2bcd8739ae039,
        themeId: (0, $7586e29635f86062$export$2e2bcd8739ae039)
    });
}



var $hEVyQ = parcelRequire("hEVyQ");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $0019f7c6881c2f5e$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $e81b6b5071071d38$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $hEVyQ.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $0019f7c6881c2f5e$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


var $4905b1fe0147563b$export$2e2bcd8739ae039 = (0, $e81b6b5071071d38$export$2e2bcd8739ae039);



var $hEVyQ = parcelRequire("hEVyQ");

var $hEVyQ = parcelRequire("hEVyQ");
const $61eddb5b42e38ae3$var$useEnhancedEffect = typeof window !== "undefined" ? $hEVyQ.useLayoutEffect : $hEVyQ.useEffect;
var $61eddb5b42e38ae3$export$2e2bcd8739ae039 = $61eddb5b42e38ae3$var$useEnhancedEffect;


function $5897920079d0cc3e$export$2e2bcd8739ae039(fn) {
    const ref = $hEVyQ.useRef(fn);
    (0, $61eddb5b42e38ae3$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $hEVyQ.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}


var $ce5ab4ef9d0fb403$export$2e2bcd8739ae039 = (0, $5897920079d0cc3e$export$2e2bcd8739ae039);


// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $hEVyQ = parcelRequire("hEVyQ");
let $af1ec9f4f6bb17e3$var$hadKeyboardEvent = true;
let $af1ec9f4f6bb17e3$var$hadFocusVisibleRecently = false;
let $af1ec9f4f6bb17e3$var$hadFocusVisibleRecentlyTimeout;
const $af1ec9f4f6bb17e3$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $af1ec9f4f6bb17e3$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $af1ec9f4f6bb17e3$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $af1ec9f4f6bb17e3$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $af1ec9f4f6bb17e3$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $af1ec9f4f6bb17e3$var$handlePointerDown() {
    $af1ec9f4f6bb17e3$var$hadKeyboardEvent = false;
}
function $af1ec9f4f6bb17e3$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($af1ec9f4f6bb17e3$var$hadFocusVisibleRecently) $af1ec9f4f6bb17e3$var$hadKeyboardEvent = true;
    }
}
function $af1ec9f4f6bb17e3$var$prepare(doc) {
    doc.addEventListener("keydown", $af1ec9f4f6bb17e3$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $af1ec9f4f6bb17e3$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $af1ec9f4f6bb17e3$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $af1ec9f4f6bb17e3$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $af1ec9f4f6bb17e3$var$handleVisibilityChange, true);
}
function $af1ec9f4f6bb17e3$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $af1ec9f4f6bb17e3$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $af1ec9f4f6bb17e3$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $af1ec9f4f6bb17e3$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $af1ec9f4f6bb17e3$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $af1ec9f4f6bb17e3$var$handleVisibilityChange, true);
}
function $af1ec9f4f6bb17e3$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $af1ec9f4f6bb17e3$var$hadKeyboardEvent || $af1ec9f4f6bb17e3$var$focusTriggersKeyboardModality(target);
}
function $af1ec9f4f6bb17e3$export$2e2bcd8739ae039() {
    const ref = $hEVyQ.useCallback((node)=>{
        if (node != null) $af1ec9f4f6bb17e3$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $hEVyQ.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $af1ec9f4f6bb17e3$var$hadFocusVisibleRecently = true;
            window.clearTimeout($af1ec9f4f6bb17e3$var$hadFocusVisibleRecentlyTimeout);
            $af1ec9f4f6bb17e3$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $af1ec9f4f6bb17e3$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($af1ec9f4f6bb17e3$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


var $ddefa92cf2d002cd$export$2e2bcd8739ae039 = (0, $af1ec9f4f6bb17e3$export$2e2bcd8739ae039);





var $hEVyQ = parcelRequire("hEVyQ");



function $f58438fbf9e0cfe8$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $7f45a5ed6f0b9bd3$export$2e2bcd8739ae039(o, p) {
    $7f45a5ed6f0b9bd3$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7f45a5ed6f0b9bd3$export$2e2bcd8739ae039(o, p);
}


function $9fb73a7ee2a909cc$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $7f45a5ed6f0b9bd3$export$2e2bcd8739ae039)(subClass, superClass);
}




var $hEVyQ = parcelRequire("hEVyQ");

var $hEVyQ = parcelRequire("hEVyQ");
var $3ab9174fd4fe3441$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($hEVyQ))).createContext(null);



var $hEVyQ = parcelRequire("hEVyQ");
function $ca8660f751ed4f87$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $hEVyQ.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $hEVyQ.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $ca8660f751ed4f87$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $ca8660f751ed4f87$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $ca8660f751ed4f87$export$fa71e2345c31d7a2(props, onExited) {
    return $ca8660f751ed4f87$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $hEVyQ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $ca8660f751ed4f87$var$getProp(child, "appear", props),
            enter: $ca8660f751ed4f87$var$getProp(child, "enter", props),
            exit: $ca8660f751ed4f87$var$getProp(child, "exit", props)
        });
    });
}
function $ca8660f751ed4f87$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $ca8660f751ed4f87$export$bbc8a025727ea824(nextProps.children);
    var children = $ca8660f751ed4f87$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $hEVyQ.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $hEVyQ.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $hEVyQ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $ca8660f751ed4f87$var$getProp(child, "exit", nextProps),
            enter: $ca8660f751ed4f87$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $hEVyQ.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $hEVyQ.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $hEVyQ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $ca8660f751ed4f87$var$getProp(child, "exit", nextProps),
            enter: $ca8660f751ed4f87$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $dffe925579923e27$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $dffe925579923e27$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $dffe925579923e27$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $9fb73a7ee2a909cc$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $f58438fbf9e0cfe8$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $ca8660f751ed4f87$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $ca8660f751ed4f87$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $ca8660f751ed4f87$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $dffe925579923e27$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hEVyQ))).createElement((0, $3ab9174fd4fe3441$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hEVyQ))).createElement((0, $3ab9174fd4fe3441$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hEVyQ))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($hEVyQ))).Component);
$dffe925579923e27$var$TransitionGroup.propTypes = {};
$dffe925579923e27$var$TransitionGroup.defaultProps = $dffe925579923e27$var$defaultProps;
var $dffe925579923e27$export$2e2bcd8739ae039 = $dffe925579923e27$var$TransitionGroup;







var $hEVyQ = parcelRequire("hEVyQ");



function $9b59287e14d60b99$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $hEVyQ.useState(false);
    const rippleClassName = (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $hEVyQ.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("span", {
            className: childClassName
        })
    });
}
var $9b59287e14d60b99$export$2e2bcd8739ae039 = $9b59287e14d60b99$var$Ripple;


const $01568f097002593e$var$defaultGenerator = (componentName)=>componentName;
const $01568f097002593e$var$createClassNameGenerator = ()=>{
    let generate = $01568f097002593e$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $01568f097002593e$var$defaultGenerator;
        }
    };
};
const $01568f097002593e$var$ClassNameGenerator = $01568f097002593e$var$createClassNameGenerator();
var $01568f097002593e$export$2e2bcd8739ae039 = $01568f097002593e$var$ClassNameGenerator;


const $09942e33151bb514$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    readOnly: "readOnly",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    required: "required",
    selected: "selected"
};
function $09942e33151bb514$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $09942e33151bb514$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $01568f097002593e$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}


function $8c0ac374284de90a$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $09942e33151bb514$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $6d8a0cbf5a66d3ee$export$b464606f735ab902(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiTouchRipple", slot);
}
const $6d8a0cbf5a66d3ee$var$touchRippleClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039 = $6d8a0cbf5a66d3ee$var$touchRippleClasses;



const $a952d3e146056c0c$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $a952d3e146056c0c$var$_ = (t)=>t, $a952d3e146056c0c$var$_t, $a952d3e146056c0c$var$_t2, $a952d3e146056c0c$var$_t3, $a952d3e146056c0c$var$_t4;
const $a952d3e146056c0c$var$DURATION = 550;
const $a952d3e146056c0c$export$95d0c9356b2231a3 = 80;
const $a952d3e146056c0c$var$enterKeyframe = (0, $7a3cc2f12361a925$export$d25ddfdf17c3ad3e)($a952d3e146056c0c$var$_t || ($a952d3e146056c0c$var$_t = $a952d3e146056c0c$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $a952d3e146056c0c$var$exitKeyframe = (0, $7a3cc2f12361a925$export$d25ddfdf17c3ad3e)($a952d3e146056c0c$var$_t2 || ($a952d3e146056c0c$var$_t2 = $a952d3e146056c0c$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $a952d3e146056c0c$var$pulsateKeyframe = (0, $7a3cc2f12361a925$export$d25ddfdf17c3ad3e)($a952d3e146056c0c$var$_t3 || ($a952d3e146056c0c$var$_t3 = $a952d3e146056c0c$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $a952d3e146056c0c$export$f6b7418508c72c25 = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $a952d3e146056c0c$export$676cfe7b12693c4b = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)((0, $9b59287e14d60b99$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($a952d3e146056c0c$var$_t4 || ($a952d3e146056c0c$var$_t4 = $a952d3e146056c0c$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039).rippleVisible, $a952d3e146056c0c$var$enterKeyframe, $a952d3e146056c0c$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039).child, (0, $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039).childLeaving, $a952d3e146056c0c$var$exitKeyframe, $a952d3e146056c0c$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039).childPulsate, $a952d3e146056c0c$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $a952d3e146056c0c$var$TouchRipple = /*#__PURE__*/ $hEVyQ.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $a952d3e146056c0c$var$_excluded);
    const [ripples, setRipples] = $hEVyQ.useState([]);
    const nextKey = $hEVyQ.useRef(0);
    const rippleCallback = $hEVyQ.useRef(null);
    $hEVyQ.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $hEVyQ.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $hEVyQ.useRef(null);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $hEVyQ.useRef(null);
    const container = $hEVyQ.useRef(null);
    $hEVyQ.useEffect(()=>{
        return ()=>{
            clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $hEVyQ.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($a952d3e146056c0c$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.ripple, (0, $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.child, (0, $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.childLeaving, (0, $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.childPulsate, (0, $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $a952d3e146056c0c$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $hEVyQ.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $a952d3e146056c0c$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $hEVyQ.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $hEVyQ.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $hEVyQ.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($a952d3e146056c0c$export$f6b7418508c72c25, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)((0, $6d8a0cbf5a66d3ee$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $dffe925579923e27$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $a952d3e146056c0c$export$2e2bcd8739ae039 = $a952d3e146056c0c$var$TouchRipple;




function $afa2ab550fd6f6d2$export$fccb0498dcd99783(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiButtonBase", slot);
}
const $afa2ab550fd6f6d2$var$buttonBaseClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $afa2ab550fd6f6d2$export$2e2bcd8739ae039 = $afa2ab550fd6f6d2$var$buttonBaseClasses;



const $02430851b7e91562$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $02430851b7e91562$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $afa2ab550fd6f6d2$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $02430851b7e91562$export$7ec0dcc5e3cdcd36 = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $afa2ab550fd6f6d2$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $02430851b7e91562$var$ButtonBase = /*#__PURE__*/ $hEVyQ.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $02430851b7e91562$var$_excluded);
    const buttonRef = $hEVyQ.useRef(null);
    const rippleRef = $hEVyQ.useRef(null);
    const handleRippleRef = (0, $4905b1fe0147563b$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $ddefa92cf2d002cd$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $hEVyQ.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $hEVyQ.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $hEVyQ.useState(false);
    $hEVyQ.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $hEVyQ.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $ce5ab4ef9d0fb403$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $ce5ab4ef9d0fb403$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $hEVyQ.useRef(false);
    const handleKeyDown = (0, $ce5ab4ef9d0fb403$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $ce5ab4ef9d0fb403$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $4905b1fe0147563b$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $02430851b7e91562$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)($02430851b7e91562$export$7ec0dcc5e3cdcd36, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        as: ComponentProp,
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $7d421eaa7dee1123$exports.jsx)((0, $a952d3e146056c0c$export$2e2bcd8739ae039), (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $02430851b7e91562$export$2e2bcd8739ae039 = $02430851b7e91562$var$ButtonBase;




function $f0b3c88925a0dcc8$export$baa0faa0c7ad8085(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("PrivateSwitchBase", slot);
}
const $f0b3c88925a0dcc8$var$switchBaseClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $f0b3c88925a0dcc8$export$2e2bcd8739ae039 = $f0b3c88925a0dcc8$var$switchBaseClasses;



const $2474e6bdebed9cd3$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $2474e6bdebed9cd3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $f0b3c88925a0dcc8$export$baa0faa0c7ad8085), classes);
};
const $2474e6bdebed9cd3$var$SwitchBaseRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)((0, $02430851b7e91562$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $2474e6bdebed9cd3$var$SwitchBaseInput = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("input")({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $2474e6bdebed9cd3$var$SwitchBase = /*#__PURE__*/ $hEVyQ.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $2474e6bdebed9cd3$var$_excluded);
    const [checked, setCheckedState] = (0, $0feb9b02456bcdb9$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $aa5dba5365b3a355$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $2474e6bdebed9cd3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)($2474e6bdebed9cd3$var$SwitchBaseRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        component: "span",
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($2474e6bdebed9cd3$var$SwitchBaseInput, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $2474e6bdebed9cd3$export$2e2bcd8739ae039 = $2474e6bdebed9cd3$var$SwitchBase;


parcelRequire("hEVyQ");


var $hEVyQ = parcelRequire("hEVyQ");



var $hEVyQ = parcelRequire("hEVyQ");








function $f62c7665350f98b1$export$c7c50641356bdfa5(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiSvgIcon", slot);
}
const $f62c7665350f98b1$var$svgIconClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $f62c7665350f98b1$export$2e2bcd8739ae039 = $f62c7665350f98b1$var$svgIconClasses;



const $ccddc74c30d439ce$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $ccddc74c30d439ce$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $f62c7665350f98b1$export$c7c50641356bdfa5), classes);
};
const $ccddc74c30d439ce$var$SvgIconRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette$ownerState$c2, _palette2, _palette2$action, _palette3, _palette3$action;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        fill: "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null ? void 0 : (_palette$ownerState$c2 = _palette[ownerState.color]) == null ? void 0 : _palette$ownerState$c2.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null ? void 0 : (_palette2$action = _palette2.action) == null ? void 0 : _palette2$action.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null ? void 0 : (_palette3$action = _palette3.action) == null ? void 0 : _palette3$action.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $ccddc74c30d439ce$var$SvgIcon = /*#__PURE__*/ $hEVyQ.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $ccddc74c30d439ce$var$_excluded);
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $ccddc74c30d439ce$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)($ccddc74c30d439ce$var$SvgIconRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        as: component,
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, {
        ownerState: ownerState,
        children: [
            children,
            titleAccess ? /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$ccddc74c30d439ce$var$SvgIcon.muiName = "SvgIcon";
var $ccddc74c30d439ce$export$2e2bcd8739ae039 = $ccddc74c30d439ce$var$SvgIcon;



function $68f272343dd416b4$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $ccddc74c30d439ce$export$2e2bcd8739ae039), (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $ccddc74c30d439ce$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $hEVyQ.memo(/*#__PURE__*/ $hEVyQ.forwardRef(Component));
}



var $9d599e421284edec$export$2e2bcd8739ae039 = (0, $68f272343dd416b4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");


parcelRequire("hEVyQ");


var $ec58666448fc5c96$export$2e2bcd8739ae039 = (0, $68f272343dd416b4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");


parcelRequire("hEVyQ");


var $a4c231f9d1b15545$export$2e2bcd8739ae039 = (0, $68f272343dd416b4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");







function $e63a8b3e361b98d6$export$6c57c6e16b4063b(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiCheckbox", slot);
}
const $e63a8b3e361b98d6$var$checkboxClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary"
]);
var $e63a8b3e361b98d6$export$2e2bcd8739ae039 = $e63a8b3e361b98d6$var$checkboxClasses;



const $73a3d59b1cc1f0d9$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $73a3d59b1cc1f0d9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(color)}`
        ]
    };
    const composedClasses = (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $e63a8b3e361b98d6$export$6c57c6e16b4063b), classes);
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $73a3d59b1cc1f0d9$var$CheckboxRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)((0, $2474e6bdebed9cd3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $f0eb61bababa8473$export$effb20ecdbf4d6aa)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            ownerState.color !== "default" && styles[`color${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dbd72f49419aab0a$export$58f0f39f63f3cf42)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $e63a8b3e361b98d6$export$2e2bcd8739ae039).checked}, &.${(0, $e63a8b3e361b98d6$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $e63a8b3e361b98d6$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $73a3d59b1cc1f0d9$var$defaultCheckedIcon = /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $ec58666448fc5c96$export$2e2bcd8739ae039), {});
const $73a3d59b1cc1f0d9$var$defaultIcon = /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $9d599e421284edec$export$2e2bcd8739ae039), {});
const $73a3d59b1cc1f0d9$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $a4c231f9d1b15545$export$2e2bcd8739ae039), {});
const $73a3d59b1cc1f0d9$var$Checkbox = /*#__PURE__*/ $hEVyQ.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $73a3d59b1cc1f0d9$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $73a3d59b1cc1f0d9$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $73a3d59b1cc1f0d9$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium", className: className } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $73a3d59b1cc1f0d9$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $73a3d59b1cc1f0d9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($73a3d59b1cc1f0d9$var$CheckboxRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        type: "checkbox",
        inputProps: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $hEVyQ.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $hEVyQ.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $73a3d59b1cc1f0d9$export$2e2bcd8739ae039 = $73a3d59b1cc1f0d9$var$Checkbox;




var $hEVyQ = parcelRequire("hEVyQ");






// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $c3719a08438f2dee$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $c3719a08438f2dee$export$2e2bcd8739ae039 = $c3719a08438f2dee$var$getOverlayAlpha;






function $98699effd06a6b97$export$29cdb466b9b6f20b(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiPaper", slot);
}
const $98699effd06a6b97$var$paperClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $98699effd06a6b97$export$2e2bcd8739ae039 = $98699effd06a6b97$var$paperClasses;



const $5fce1dd627eb6b1d$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $5fce1dd627eb6b1d$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $98699effd06a6b97$export$29cdb466b9b6f20b), classes);
};
const $5fce1dd627eb6b1d$var$PaperRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $dbd72f49419aab0a$export$58f0f39f63f3cf42)("#fff", (0, $c3719a08438f2dee$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $dbd72f49419aab0a$export$58f0f39f63f3cf42)("#fff", (0, $c3719a08438f2dee$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $5fce1dd627eb6b1d$var$Paper = /*#__PURE__*/ $hEVyQ.forwardRef(function Paper(inProps, ref) {
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $5fce1dd627eb6b1d$var$_excluded);
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $5fce1dd627eb6b1d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($5fce1dd627eb6b1d$var$PaperRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        as: component,
        ownerState: ownerState,
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other));
});
var $5fce1dd627eb6b1d$export$2e2bcd8739ae039 = $5fce1dd627eb6b1d$var$Paper;


const $ed760d377ebb44c8$var$PagePreview = ({ page: { pageIndex: pageIndex, pageProxy: pageProxy, included: included, file: file }, setInclusion: setInclusion })=>{
    const canvasRef = (0, $hEVyQ.useRef)(null);
    (0, $hEVyQ.useEffect)(()=>{
        const scale = 0.5; // TODO: decide nicely
        const viewport = pageProxy.getViewport({
            scale: scale
        });
        // Support HiDPI-screens.
        const outputScale = window.devicePixelRatio || 1;
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        canvas.width = Math.floor(viewport.width * outputScale);
        canvas.height = Math.floor(viewport.height * outputScale);
        canvas.style.width = Math.floor(viewport.width) + "px";
        canvas.style.height = Math.floor(viewport.height) + "px";
        const transform = outputScale !== 1 ? [
            outputScale,
            0,
            0,
            outputScale,
            0,
            0
        ] : null;
        const renderContext = {
            canvasContext: context,
            transform: transform,
            viewport: viewport
        };
        pageProxy.render(renderContext);
    }, [
        pageProxy
    ]);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)((0, $5fce1dd627eb6b1d$export$2e2bcd8739ae039), {
        sx: {
            position: "relative",
            opacity: included ? 1 : 0.6
        },
        onClick: (e)=>{
            setInclusion(!included);
        },
        children: [
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("canvas", {
                ref: canvasRef
            }),
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)("span", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    fontSize: "16px",
                    padding: "4px"
                },
                children: [
                    file.name,
                    " (",
                    pageIndex + 1,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $73a3d59b1cc1f0d9$export$2e2bcd8739ae039), {
                checked: included,
                size: "medium",
                sx: {
                    position: "absolute",
                    top: "-8px",
                    right: "-8px"
                }
            })
        ]
    });
};
var $ed760d377ebb44c8$export$2e2bcd8739ae039 = $ed760d377ebb44c8$var$PagePreview;
const $ed760d377ebb44c8$export$c6856de364e4c9db = ({ pages: pages, setPages: setPages })=>{
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("div", {
        className: (0, $93d437ea92523dce$export$56eef2c66459c635),
        children: pages.map((page)=>/*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($ed760d377ebb44c8$var$PagePreview, {
                page: page,
                setInclusion: (included)=>setPages((pages)=>{
                        const newPages = [
                            ...pages
                        ];
                        newPages[pages.indexOf(page)].included = included;
                        return newPages;
                    })
            }, `${page.fileIndex}-${page.pageIndex}`))
    });
};




var $hEVyQ = parcelRequire("hEVyQ");
var $148a99c9e2d34415$exports = {};
$parcel$export($148a99c9e2d34415$exports, "degrees", function () { return $d82a2f5ff75b3e04$export$41fc368e1a942b97; });
$parcel$export($148a99c9e2d34415$exports, "PageSizes", function () { return $9ed9386fb79996c0$export$b4a05ae367f5515c; });
$parcel$export($148a99c9e2d34415$exports, "PDFDocument", function () { return $c32e913e0d181c9e$export$2e2bcd8739ae039; });

var $59LZ8 = parcelRequire("59LZ8");

var $59LZ8 = parcelRequire("59LZ8");
parcelRequire("1cWQu");

var $5ZWJa = parcelRequire("5ZWJa");

var $59LZ8 = parcelRequire("59LZ8");

var $ckBc7 = parcelRequire("ckBc7");

var $5ZWJa = parcelRequire("5ZWJa");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $7610640e6ae69024$var$PDFHeader = /** @class */ function() {
    function PDFHeader(major, minor) {
        this.major = String(major);
        this.minor = String(minor);
    }
    PDFHeader.prototype.toString = function() {
        var bc = (0, $cZKSB.charFromCode)(129);
        return "%PDF-" + this.major + "." + this.minor + "\n%" + bc + bc + bc + bc;
    };
    PDFHeader.prototype.sizeInBytes = function() {
        return 12 + this.major.length + this.minor.length;
    };
    PDFHeader.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $5ZWJa.default).Percent;
        buffer[offset++] = (0, $5ZWJa.default).P;
        buffer[offset++] = (0, $5ZWJa.default).D;
        buffer[offset++] = (0, $5ZWJa.default).F;
        buffer[offset++] = (0, $5ZWJa.default).Dash;
        offset += (0, $cZKSB.copyStringIntoBuffer)(this.major, buffer, offset);
        buffer[offset++] = (0, $5ZWJa.default).Period;
        offset += (0, $cZKSB.copyStringIntoBuffer)(this.minor, buffer, offset);
        buffer[offset++] = (0, $5ZWJa.default).Newline;
        buffer[offset++] = (0, $5ZWJa.default).Percent;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        return offset - initialOffset;
    };
    PDFHeader.forVersion = function(major, minor) {
        return new PDFHeader(major, minor);
    };
    return PDFHeader;
}();
var $7610640e6ae69024$export$2e2bcd8739ae039 = $7610640e6ae69024$var$PDFHeader;



var $1cWQu = parcelRequire("1cWQu");

var $7Igbp = parcelRequire("7Igbp");

var $evfTd = parcelRequire("evfTd");

var $59LZ8 = parcelRequire("59LZ8");

var $a7yPZ = parcelRequire("a7yPZ");

var $59LZ8 = parcelRequire("59LZ8");

var $cWdWp = parcelRequire("cWdWp");

var $5ZWJa = parcelRequire("5ZWJa");
var $3923dd19d4d56cea$var$PDFNull = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFNull, _super);
    function PDFNull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFNull.prototype.asNull = function() {
        return null;
    };
    PDFNull.prototype.clone = function() {
        return this;
    };
    PDFNull.prototype.toString = function() {
        return "null";
    };
    PDFNull.prototype.sizeInBytes = function() {
        return 4;
    };
    PDFNull.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $5ZWJa.default).n;
        buffer[offset++] = (0, $5ZWJa.default).u;
        buffer[offset++] = (0, $5ZWJa.default).l;
        buffer[offset++] = (0, $5ZWJa.default).l;
        return 4;
    };
    return PDFNull;
}((0, $cWdWp.default));
var $3923dd19d4d56cea$export$2e2bcd8739ae039 = new $3923dd19d4d56cea$var$PDFNull();



var $cWdWp = parcelRequire("cWdWp");

var $5ZWJa = parcelRequire("5ZWJa");
var $f437c135fa674ebe$var$PDFDict = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFDict, _super);
    function PDFDict(map, context) {
        var _this = _super.call(this) || this;
        _this.dict = map;
        _this.context = context;
        return _this;
    }
    PDFDict.prototype.keys = function() {
        return Array.from(this.dict.keys());
    };
    PDFDict.prototype.values = function() {
        return Array.from(this.dict.values());
    };
    PDFDict.prototype.entries = function() {
        return Array.from(this.dict.entries());
    };
    PDFDict.prototype.set = function(key, value) {
        this.dict.set(key, value);
    };
    PDFDict.prototype.get = function(key, // TODO: `preservePDFNull` is for backwards compatibility. Should be
    // removed in next breaking API change.
    preservePDFNull) {
        if (preservePDFNull === void 0) preservePDFNull = false;
        var value = this.dict.get(key);
        if (value === (0, $3923dd19d4d56cea$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.has = function(key) {
        var value = this.dict.get(key);
        return value !== undefined && value !== (0, $3923dd19d4d56cea$export$2e2bcd8739ae039);
    };
    PDFDict.prototype.lookupMaybe = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $3923dd19d4d56cea$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookupMaybe.apply(_a, (0, $59LZ8.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $3923dd19d4d56cea$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.lookup = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $3923dd19d4d56cea$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookup.apply(_a, (0, $59LZ8.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $3923dd19d4d56cea$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.delete = function(key) {
        return this.dict.delete(key);
    };
    PDFDict.prototype.asMap = function() {
        return new Map(this.dict);
    };
    /** Generate a random key that doesn't exist in current key set */ PDFDict.prototype.uniqueKey = function(tag) {
        if (tag === void 0) tag = "";
        var existingKeys = this.keys();
        var key = (0, $a7yPZ.default).of(this.context.addRandomSuffix(tag, 10));
        while(existingKeys.includes(key))key = (0, $a7yPZ.default).of(this.context.addRandomSuffix(tag, 10));
        return key;
    };
    PDFDict.prototype.clone = function(context) {
        var clone = PDFDict.withContext(context || this.context);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFDict.prototype.toString = function() {
        var dictString = "<<\n";
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            dictString += key.toString() + " " + value.toString() + "\n";
        }
        dictString += ">>";
        return dictString;
    };
    PDFDict.prototype.sizeInBytes = function() {
        var size = 5;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            size += key.sizeInBytes() + value.sizeInBytes() + 2;
        }
        return size;
    };
    PDFDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $5ZWJa.default).LessThan;
        buffer[offset++] = (0, $5ZWJa.default).LessThan;
        buffer[offset++] = (0, $5ZWJa.default).Newline;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            offset += key.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $5ZWJa.default).Space;
            offset += value.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $5ZWJa.default).Newline;
        }
        buffer[offset++] = (0, $5ZWJa.default).GreaterThan;
        buffer[offset++] = (0, $5ZWJa.default).GreaterThan;
        return offset - initialOffset;
    };
    PDFDict.withContext = function(context) {
        return new PDFDict(new Map(), context);
    };
    PDFDict.fromMapWithContext = function(map, context) {
        return new PDFDict(map, context);
    };
    return PDFDict;
}((0, $cWdWp.default));
var $f437c135fa674ebe$export$2e2bcd8739ae039 = $f437c135fa674ebe$var$PDFDict;



var $a7yPZ = parcelRequire("a7yPZ");


var $gcVIu = parcelRequire("gcVIu");

var $cWdWp = parcelRequire("cWdWp");

var $59LZ8 = parcelRequire("59LZ8");

var $59LZ8 = parcelRequire("59LZ8");

var $1cWQu = parcelRequire("1cWQu");

var $a7yPZ = parcelRequire("a7yPZ");

var $gcVIu = parcelRequire("gcVIu");

var $cWdWp = parcelRequire("cWdWp");

var $5ZWJa = parcelRequire("5ZWJa");
var $29b9b1023bfccc2c$var$PDFStream = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFStream, _super);
    function PDFStream(dict) {
        var _this = _super.call(this) || this;
        _this.dict = dict;
        return _this;
    }
    PDFStream.prototype.clone = function(_context) {
        throw new (0, $1cWQu.MethodNotImplementedError)(this.constructor.name, "clone");
    };
    PDFStream.prototype.getContentsString = function() {
        throw new (0, $1cWQu.MethodNotImplementedError)(this.constructor.name, "getContentsString");
    };
    PDFStream.prototype.getContents = function() {
        throw new (0, $1cWQu.MethodNotImplementedError)(this.constructor.name, "getContents");
    };
    PDFStream.prototype.getContentsSize = function() {
        throw new (0, $1cWQu.MethodNotImplementedError)(this.constructor.name, "getContentsSize");
    };
    PDFStream.prototype.updateDict = function() {
        var contentsSize = this.getContentsSize();
        this.dict.set((0, $a7yPZ.default).Length, (0, $gcVIu.default).of(contentsSize));
    };
    PDFStream.prototype.sizeInBytes = function() {
        this.updateDict();
        return this.dict.sizeInBytes() + this.getContentsSize() + 18;
    };
    PDFStream.prototype.toString = function() {
        this.updateDict();
        var streamString = this.dict.toString();
        streamString += "\nstream\n";
        streamString += this.getContentsString();
        streamString += "\nendstream";
        return streamString;
    };
    PDFStream.prototype.copyBytesInto = function(buffer, offset) {
        this.updateDict();
        var initialOffset = offset;
        offset += this.dict.copyBytesInto(buffer, offset);
        buffer[offset++] = (0, $5ZWJa.default).Newline;
        buffer[offset++] = (0, $5ZWJa.default).s;
        buffer[offset++] = (0, $5ZWJa.default).t;
        buffer[offset++] = (0, $5ZWJa.default).r;
        buffer[offset++] = (0, $5ZWJa.default).e;
        buffer[offset++] = (0, $5ZWJa.default).a;
        buffer[offset++] = (0, $5ZWJa.default).m;
        buffer[offset++] = (0, $5ZWJa.default).Newline;
        var contents = this.getContents();
        for(var idx = 0, len = contents.length; idx < len; idx++)buffer[offset++] = contents[idx];
        buffer[offset++] = (0, $5ZWJa.default).Newline;
        buffer[offset++] = (0, $5ZWJa.default).e;
        buffer[offset++] = (0, $5ZWJa.default).n;
        buffer[offset++] = (0, $5ZWJa.default).d;
        buffer[offset++] = (0, $5ZWJa.default).s;
        buffer[offset++] = (0, $5ZWJa.default).t;
        buffer[offset++] = (0, $5ZWJa.default).r;
        buffer[offset++] = (0, $5ZWJa.default).e;
        buffer[offset++] = (0, $5ZWJa.default).a;
        buffer[offset++] = (0, $5ZWJa.default).m;
        return offset - initialOffset;
    };
    return PDFStream;
}((0, $cWdWp.default));
var $29b9b1023bfccc2c$export$2e2bcd8739ae039 = $29b9b1023bfccc2c$var$PDFStream;


parcelRequire("6vLBB");
var $i8eKs = parcelRequire("i8eKs");
var $6f2895f4e287e745$var$PDFRawStream = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFRawStream, _super);
    function PDFRawStream(dict, contents) {
        var _this = _super.call(this, dict) || this;
        _this.contents = contents;
        return _this;
    }
    PDFRawStream.prototype.asUint8Array = function() {
        return this.contents.slice();
    };
    PDFRawStream.prototype.clone = function(context) {
        return PDFRawStream.of(this.dict.clone(context), this.contents.slice());
    };
    PDFRawStream.prototype.getContentsString = function() {
        return (0, $i8eKs.arrayAsString)(this.contents);
    };
    PDFRawStream.prototype.getContents = function() {
        return this.contents;
    };
    PDFRawStream.prototype.getContentsSize = function() {
        return this.contents.length;
    };
    PDFRawStream.of = function(dict, contents) {
        return new PDFRawStream(dict, contents);
    };
    return PDFRawStream;
}((0, $29b9b1023bfccc2c$export$2e2bcd8739ae039));
var $6f2895f4e287e745$export$2e2bcd8739ae039 = $6f2895f4e287e745$var$PDFRawStream;



var $59LZ8 = parcelRequire("59LZ8");

var $1cWQu = parcelRequire("1cWQu");

var $cWdWp = parcelRequire("cWdWp");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $06a507a20ec07388$var$ENFORCER = {};
var $06a507a20ec07388$var$pool = new Map();
var $06a507a20ec07388$var$PDFRef = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFRef, _super);
    function PDFRef(enforcer, objectNumber, generationNumber) {
        var _this = this;
        if (enforcer !== $06a507a20ec07388$var$ENFORCER) throw new (0, $1cWQu.PrivateConstructorError)("PDFRef");
        _this = _super.call(this) || this;
        _this.objectNumber = objectNumber;
        _this.generationNumber = generationNumber;
        _this.tag = objectNumber + " " + generationNumber + " R";
        return _this;
    }
    PDFRef.prototype.clone = function() {
        return this;
    };
    PDFRef.prototype.toString = function() {
        return this.tag;
    };
    PDFRef.prototype.sizeInBytes = function() {
        return this.tag.length;
    };
    PDFRef.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $cZKSB.copyStringIntoBuffer)(this.tag, buffer, offset);
        return this.tag.length;
    };
    PDFRef.of = function(objectNumber, generationNumber) {
        if (generationNumber === void 0) generationNumber = 0;
        var tag = objectNumber + " " + generationNumber + " R";
        var instance = $06a507a20ec07388$var$pool.get(tag);
        if (!instance) {
            instance = new PDFRef($06a507a20ec07388$var$ENFORCER, objectNumber, generationNumber);
            $06a507a20ec07388$var$pool.set(tag, instance);
        }
        return instance;
    };
    return PDFRef;
}((0, $cWdWp.default));
var $06a507a20ec07388$export$2e2bcd8739ae039 = $06a507a20ec07388$var$PDFRef;



var $cWdWp = parcelRequire("cWdWp");

var $5ZWJa = parcelRequire("5ZWJa");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $2cc502e5651ab7a6$var$PDFOperator = /** @class */ function() {
    function PDFOperator(name, args) {
        this.name = name;
        this.args = args || [];
    }
    PDFOperator.prototype.clone = function(context) {
        var args = new Array(this.args.length);
        for(var idx = 0, len = args.length; idx < len; idx++){
            var arg = this.args[idx];
            args[idx] = arg instanceof (0, $cWdWp.default) ? arg.clone(context) : arg;
        }
        return PDFOperator.of(this.name, args);
    };
    PDFOperator.prototype.toString = function() {
        var value = "";
        for(var idx = 0, len = this.args.length; idx < len; idx++)value += String(this.args[idx]) + " ";
        value += this.name;
        return value;
    };
    PDFOperator.prototype.sizeInBytes = function() {
        var size = 0;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            size += (arg instanceof (0, $cWdWp.default) ? arg.sizeInBytes() : arg.length) + 1;
        }
        size += this.name.length;
        return size;
    };
    PDFOperator.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            if (arg instanceof (0, $cWdWp.default)) offset += arg.copyBytesInto(buffer, offset);
            else offset += (0, $cZKSB.copyStringIntoBuffer)(arg, buffer, offset);
            buffer[offset++] = (0, $5ZWJa.default).Space;
        }
        offset += (0, $cZKSB.copyStringIntoBuffer)(this.name, buffer, offset);
        return offset - initialOffset;
    };
    PDFOperator.of = function(name, args) {
        return new PDFOperator(name, args);
    };
    return PDFOperator;
}();
var $2cc502e5651ab7a6$export$2e2bcd8739ae039 = $2cc502e5651ab7a6$var$PDFOperator;


var $4238d3c012553b3e$var$PDFOperatorNames;
(function(PDFOperatorNames) {
    // Non Stroking Color Operators
    PDFOperatorNames["NonStrokingColor"] = "sc";
    PDFOperatorNames["NonStrokingColorN"] = "scn";
    PDFOperatorNames["NonStrokingColorRgb"] = "rg";
    PDFOperatorNames["NonStrokingColorGray"] = "g";
    PDFOperatorNames["NonStrokingColorCmyk"] = "k";
    PDFOperatorNames["NonStrokingColorspace"] = "cs";
    // Stroking Color Operators
    PDFOperatorNames["StrokingColor"] = "SC";
    PDFOperatorNames["StrokingColorN"] = "SCN";
    PDFOperatorNames["StrokingColorRgb"] = "RG";
    PDFOperatorNames["StrokingColorGray"] = "G";
    PDFOperatorNames["StrokingColorCmyk"] = "K";
    PDFOperatorNames["StrokingColorspace"] = "CS";
    // Marked Content Operators
    PDFOperatorNames["BeginMarkedContentSequence"] = "BDC";
    PDFOperatorNames["BeginMarkedContent"] = "BMC";
    PDFOperatorNames["EndMarkedContent"] = "EMC";
    PDFOperatorNames["MarkedContentPointWithProps"] = "DP";
    PDFOperatorNames["MarkedContentPoint"] = "MP";
    PDFOperatorNames["DrawObject"] = "Do";
    // Graphics State Operators
    PDFOperatorNames["ConcatTransformationMatrix"] = "cm";
    PDFOperatorNames["PopGraphicsState"] = "Q";
    PDFOperatorNames["PushGraphicsState"] = "q";
    PDFOperatorNames["SetFlatness"] = "i";
    PDFOperatorNames["SetGraphicsStateParams"] = "gs";
    PDFOperatorNames["SetLineCapStyle"] = "J";
    PDFOperatorNames["SetLineDashPattern"] = "d";
    PDFOperatorNames["SetLineJoinStyle"] = "j";
    PDFOperatorNames["SetLineMiterLimit"] = "M";
    PDFOperatorNames["SetLineWidth"] = "w";
    PDFOperatorNames["SetTextMatrix"] = "Tm";
    PDFOperatorNames["SetRenderingIntent"] = "ri";
    // Graphics Operators
    PDFOperatorNames["AppendRectangle"] = "re";
    PDFOperatorNames["BeginInlineImage"] = "BI";
    PDFOperatorNames["BeginInlineImageData"] = "ID";
    PDFOperatorNames["EndInlineImage"] = "EI";
    PDFOperatorNames["ClipEvenOdd"] = "W*";
    PDFOperatorNames["ClipNonZero"] = "W";
    PDFOperatorNames["CloseAndStroke"] = "s";
    PDFOperatorNames["CloseFillEvenOddAndStroke"] = "b*";
    PDFOperatorNames["CloseFillNonZeroAndStroke"] = "b";
    PDFOperatorNames["ClosePath"] = "h";
    PDFOperatorNames["AppendBezierCurve"] = "c";
    PDFOperatorNames["CurveToReplicateFinalPoint"] = "y";
    PDFOperatorNames["CurveToReplicateInitialPoint"] = "v";
    PDFOperatorNames["EndPath"] = "n";
    PDFOperatorNames["FillEvenOddAndStroke"] = "B*";
    PDFOperatorNames["FillEvenOdd"] = "f*";
    PDFOperatorNames["FillNonZeroAndStroke"] = "B";
    PDFOperatorNames["FillNonZero"] = "f";
    PDFOperatorNames["LegacyFillNonZero"] = "F";
    PDFOperatorNames["LineTo"] = "l";
    PDFOperatorNames["MoveTo"] = "m";
    PDFOperatorNames["ShadingFill"] = "sh";
    PDFOperatorNames["StrokePath"] = "S";
    // Text Operators
    PDFOperatorNames["BeginText"] = "BT";
    PDFOperatorNames["EndText"] = "ET";
    PDFOperatorNames["MoveText"] = "Td";
    PDFOperatorNames["MoveTextSetLeading"] = "TD";
    PDFOperatorNames["NextLine"] = "T*";
    PDFOperatorNames["SetCharacterSpacing"] = "Tc";
    PDFOperatorNames["SetFontAndSize"] = "Tf";
    PDFOperatorNames["SetTextHorizontalScaling"] = "Tz";
    PDFOperatorNames["SetTextLineHeight"] = "TL";
    PDFOperatorNames["SetTextRenderingMode"] = "Tr";
    PDFOperatorNames["SetTextRise"] = "Ts";
    PDFOperatorNames["SetWordSpacing"] = "Tw";
    PDFOperatorNames["ShowText"] = "Tj";
    PDFOperatorNames["ShowTextAdjusted"] = "TJ";
    PDFOperatorNames["ShowTextLine"] = "'";
    PDFOperatorNames["ShowTextLineAndSpace"] = '"';
    // Type3 Font Operators
    PDFOperatorNames["Type3D0"] = "d0";
    PDFOperatorNames["Type3D1"] = "d1";
    // Compatibility Section Operators
    PDFOperatorNames["BeginCompatibilitySection"] = "BX";
    PDFOperatorNames["EndCompatibilitySection"] = "EX";
})($4238d3c012553b3e$var$PDFOperatorNames || ($4238d3c012553b3e$var$PDFOperatorNames = {}));
var $4238d3c012553b3e$export$2e2bcd8739ae039 = $4238d3c012553b3e$var$PDFOperatorNames;



var $59LZ8 = parcelRequire("59LZ8");

var $59LZ8 = parcelRequire("59LZ8");

var $ckBc7 = parcelRequire("ckBc7");

var $1cWQu = parcelRequire("1cWQu");

var $a7yPZ = parcelRequire("a7yPZ");

parcelRequire("6vLBB");
var $6E4Ej = parcelRequire("6E4Ej");
var $9149f07c335e2813$var$PDFFlateStream = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFFlateStream, _super);
    function PDFFlateStream(dict, encode) {
        var _this = _super.call(this, dict) || this;
        _this.computeContents = function() {
            var unencodedContents = _this.getUnencodedContents();
            return _this.encode ? (0, (/*@__PURE__*/$parcel$interopDefault($ckBc7))).deflate(unencodedContents) : unencodedContents;
        };
        _this.encode = encode;
        if (encode) dict.set((0, $a7yPZ.default).of("Filter"), (0, $a7yPZ.default).of("FlateDecode"));
        _this.contentsCache = (0, $6E4Ej.default).populatedBy(_this.computeContents);
        return _this;
    }
    PDFFlateStream.prototype.getContents = function() {
        return this.contentsCache.access();
    };
    PDFFlateStream.prototype.getContentsSize = function() {
        return this.contentsCache.access().length;
    };
    PDFFlateStream.prototype.getUnencodedContents = function() {
        throw new (0, $1cWQu.MethodNotImplementedError)(this.constructor.name, "getUnencodedContents");
    };
    return PDFFlateStream;
}((0, $29b9b1023bfccc2c$export$2e2bcd8739ae039));
var $9149f07c335e2813$export$2e2bcd8739ae039 = $9149f07c335e2813$var$PDFFlateStream;



var $5ZWJa = parcelRequire("5ZWJa");
var $b3f77b3eab24ae0a$var$PDFContentStream = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFContentStream, _super);
    function PDFContentStream(dict, operators, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        _this.operators = operators;
        return _this;
    }
    PDFContentStream.prototype.push = function() {
        var _a;
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        (_a = this.operators).push.apply(_a, operators);
    };
    PDFContentStream.prototype.clone = function(context) {
        var operators = new Array(this.operators.length);
        for(var idx = 0, len = this.operators.length; idx < len; idx++)operators[idx] = this.operators[idx].clone(context);
        var _a = this, dict = _a.dict, encode = _a.encode;
        return PDFContentStream.of(dict.clone(context), operators, encode);
    };
    PDFContentStream.prototype.getContentsString = function() {
        var value = "";
        for(var idx = 0, len = this.operators.length; idx < len; idx++)value += this.operators[idx] + "\n";
        return value;
    };
    PDFContentStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++){
            offset += this.operators[idx].copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $5ZWJa.default).Newline;
        }
        return buffer;
    };
    PDFContentStream.prototype.getUnencodedContentsSize = function() {
        var size = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++)size += this.operators[idx].sizeInBytes() + 1;
        return size;
    };
    PDFContentStream.of = function(dict, operators, encode) {
        if (encode === void 0) encode = true;
        return new PDFContentStream(dict, operators, encode);
    };
    return PDFContentStream;
}((0, $9149f07c335e2813$export$2e2bcd8739ae039));
var $b3f77b3eab24ae0a$export$2e2bcd8739ae039 = $b3f77b3eab24ae0a$var$PDFContentStream;


parcelRequire("6vLBB");
var $i8eKs = parcelRequire("i8eKs");
/**
 * Generates a pseudo random number. Although it is not cryptographically secure
 * and uniformly distributed, it is not a concern for the intended use-case,
 * which is to generate distinct numbers.
 *
 * Credit: https://stackoverflow.com/a/19303725/10254049
 */ var $7527625dadbbc51b$export$205b650d120b95b5 = /** @class */ function() {
    function SimpleRNG(seed) {
        this.seed = seed;
    }
    SimpleRNG.prototype.nextInt = function() {
        var x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    };
    SimpleRNG.withSeed = function(seed) {
        return new SimpleRNG(seed);
    };
    return SimpleRNG;
}();


var $e9a9ba426f46b6eb$var$byAscendingObjectNumber = function(_a, _b) {
    var a = _a[0];
    var b = _b[0];
    return a.objectNumber - b.objectNumber;
};
var $e9a9ba426f46b6eb$var$PDFContext = /** @class */ function() {
    function PDFContext() {
        this.largestObjectNumber = 0;
        this.header = (0, $7610640e6ae69024$export$2e2bcd8739ae039).forVersion(1, 7);
        this.trailerInfo = {};
        this.indirectObjects = new Map();
        this.rng = (0, $7527625dadbbc51b$export$205b650d120b95b5).withSeed(1);
    }
    PDFContext.prototype.assign = function(ref, object) {
        this.indirectObjects.set(ref, object);
        if (ref.objectNumber > this.largestObjectNumber) this.largestObjectNumber = ref.objectNumber;
    };
    PDFContext.prototype.nextRef = function() {
        this.largestObjectNumber += 1;
        return (0, $06a507a20ec07388$export$2e2bcd8739ae039).of(this.largestObjectNumber);
    };
    PDFContext.prototype.register = function(object) {
        var ref = this.nextRef();
        this.assign(ref, object);
        return ref;
    };
    PDFContext.prototype.delete = function(ref) {
        return this.indirectObjects.delete(ref);
    };
    PDFContext.prototype.lookupMaybe = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $3923dd19d4d56cea$export$2e2bcd8739ae039));
        var result = ref instanceof (0, $06a507a20ec07388$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (!result || result === (0, $3923dd19d4d56cea$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $3923dd19d4d56cea$export$2e2bcd8739ae039)) {
                if (result === (0, $3923dd19d4d56cea$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $1cWQu.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.lookup = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        var result = ref instanceof (0, $06a507a20ec07388$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (types.length === 0) return result;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $3923dd19d4d56cea$export$2e2bcd8739ae039)) {
                if (result === (0, $3923dd19d4d56cea$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $1cWQu.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.getObjectRef = function(pdfObject) {
        var entries = Array.from(this.indirectObjects.entries());
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], ref = _a[0], object = _a[1];
            if (object === pdfObject) return ref;
        }
        return undefined;
    };
    PDFContext.prototype.enumerateIndirectObjects = function() {
        return Array.from(this.indirectObjects.entries()).sort($e9a9ba426f46b6eb$var$byAscendingObjectNumber);
    };
    PDFContext.prototype.obj = function(literal) {
        if (literal instanceof (0, $cWdWp.default)) return literal;
        else if (literal === null || literal === undefined) return 0, $3923dd19d4d56cea$export$2e2bcd8739ae039;
        else if (typeof literal === "string") return (0, $a7yPZ.default).of(literal);
        else if (typeof literal === "number") return (0, $gcVIu.default).of(literal);
        else if (typeof literal === "boolean") return literal ? (0, $evfTd.default).True : (0, $evfTd.default).False;
        else if (Array.isArray(literal)) {
            var array = (0, $7Igbp.default).withContext(this);
            for(var idx = 0, len = literal.length; idx < len; idx++)array.push(this.obj(literal[idx]));
            return array;
        } else {
            var dict = (0, $f437c135fa674ebe$export$2e2bcd8739ae039).withContext(this);
            var keys = Object.keys(literal);
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                var value = literal[key];
                if (value !== undefined) dict.set((0, $a7yPZ.default).of(key), this.obj(value));
            }
            return dict;
        }
    };
    PDFContext.prototype.stream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return (0, $6f2895f4e287e745$export$2e2bcd8739ae039).of(this.obj(dict), (0, $i8eKs.typedArrayFor)(contents));
    };
    PDFContext.prototype.flateStream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return this.stream((0, (/*@__PURE__*/$parcel$interopDefault($ckBc7))).deflate((0, $i8eKs.typedArrayFor)(contents)), (0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, dict), {
            Filter: "FlateDecode"
        }));
    };
    PDFContext.prototype.contentStream = function(operators, dict) {
        if (dict === void 0) dict = {};
        return (0, $b3f77b3eab24ae0a$export$2e2bcd8739ae039).of(this.obj(dict), operators);
    };
    PDFContext.prototype.formXObject = function(operators, dict) {
        if (dict === void 0) dict = {};
        return this.contentStream(operators, (0, $59LZ8.__assign)((0, $59LZ8.__assign)({
            BBox: this.obj([
                0,
                0,
                0,
                0
            ]),
            Matrix: this.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        }, dict), {
            Type: "XObject",
            Subtype: "Form"
        }));
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPushGraphicsStateContentStream = function() {
        if (this.pushGraphicsStateContentStreamRef) return this.pushGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).PushGraphicsState);
        var stream = (0, $b3f77b3eab24ae0a$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.pushGraphicsStateContentStreamRef = this.register(stream);
        return this.pushGraphicsStateContentStreamRef;
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `Q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPopGraphicsStateContentStream = function() {
        if (this.popGraphicsStateContentStreamRef) return this.popGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).PopGraphicsState);
        var stream = (0, $b3f77b3eab24ae0a$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.popGraphicsStateContentStreamRef = this.register(stream);
        return this.popGraphicsStateContentStreamRef;
    };
    PDFContext.prototype.addRandomSuffix = function(prefix, suffixLength) {
        if (suffixLength === void 0) suffixLength = 4;
        return prefix + "-" + Math.floor(this.rng.nextInt() * Math.pow(10, suffixLength));
    };
    PDFContext.create = function() {
        return new PDFContext();
    };
    return PDFContext;
}();
var $e9a9ba426f46b6eb$export$2e2bcd8739ae039 = $e9a9ba426f46b6eb$var$PDFContext;



var $7Igbp = parcelRequire("7Igbp");


var $a7yPZ = parcelRequire("a7yPZ");



var $59LZ8 = parcelRequire("59LZ8");

var $7Igbp = parcelRequire("7Igbp");


var $a7yPZ = parcelRequire("a7yPZ");

var $gcVIu = parcelRequire("gcVIu");

var $b808f27f9a7c9955$var$PDFPageLeaf = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFPageLeaf, _super);
    function PDFPageLeaf(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        var _this = _super.call(this, map, context) || this;
        _this.normalized = false;
        _this.autoNormalizeCTM = autoNormalizeCTM;
        return _this;
    }
    PDFPageLeaf.prototype.clone = function(context) {
        var clone = PDFPageLeaf.fromMapWithContext(new Map(), context || this.context, this.autoNormalizeCTM);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFPageLeaf.prototype.Parent = function() {
        return this.lookupMaybe((0, $a7yPZ.default).Parent, (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.Contents = function() {
        return this.lookup((0, $a7yPZ.default).of("Contents"));
    };
    PDFPageLeaf.prototype.Annots = function() {
        return this.lookupMaybe((0, $a7yPZ.default).Annots, (0, $7Igbp.default));
    };
    PDFPageLeaf.prototype.BleedBox = function() {
        return this.lookupMaybe((0, $a7yPZ.default).BleedBox, (0, $7Igbp.default));
    };
    PDFPageLeaf.prototype.TrimBox = function() {
        return this.lookupMaybe((0, $a7yPZ.default).TrimBox, (0, $7Igbp.default));
    };
    PDFPageLeaf.prototype.ArtBox = function() {
        return this.lookupMaybe((0, $a7yPZ.default).ArtBox, (0, $7Igbp.default));
    };
    PDFPageLeaf.prototype.Resources = function() {
        var dictOrRef = this.getInheritableAttribute((0, $a7yPZ.default).Resources);
        return this.context.lookupMaybe(dictOrRef, (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.MediaBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $a7yPZ.default).MediaBox);
        return this.context.lookup(arrayOrRef, (0, $7Igbp.default));
    };
    PDFPageLeaf.prototype.CropBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $a7yPZ.default).CropBox);
        return this.context.lookupMaybe(arrayOrRef, (0, $7Igbp.default));
    };
    PDFPageLeaf.prototype.Rotate = function() {
        var numberOrRef = this.getInheritableAttribute((0, $a7yPZ.default).Rotate);
        return this.context.lookupMaybe(numberOrRef, (0, $gcVIu.default));
    };
    PDFPageLeaf.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.get(name);
        });
        return attribute;
    };
    PDFPageLeaf.prototype.setParent = function(parentRef) {
        this.set((0, $a7yPZ.default).Parent, parentRef);
    };
    PDFPageLeaf.prototype.addContentStream = function(contentStreamRef) {
        var Contents = this.normalizedEntries().Contents || this.context.obj([]);
        this.set((0, $a7yPZ.default).Contents, Contents);
        Contents.push(contentStreamRef);
    };
    PDFPageLeaf.prototype.wrapContentStreams = function(startStream, endStream) {
        var Contents = this.Contents();
        if (Contents instanceof (0, $7Igbp.default)) {
            Contents.insert(0, startStream);
            Contents.push(endStream);
            return true;
        }
        return false;
    };
    PDFPageLeaf.prototype.addAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        Annots.push(annotRef);
    };
    PDFPageLeaf.prototype.removeAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        var index = Annots.indexOf(annotRef);
        if (index !== undefined) Annots.remove(index);
    };
    PDFPageLeaf.prototype.setFontDictionary = function(name, fontDictRef) {
        var Font = this.normalizedEntries().Font;
        Font.set(name, fontDictRef);
    };
    PDFPageLeaf.prototype.newFontDictionaryKey = function(tag) {
        var Font = this.normalizedEntries().Font;
        return Font.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newFontDictionary = function(tag, fontDictRef) {
        var key = this.newFontDictionaryKey(tag);
        this.setFontDictionary(key, fontDictRef);
        return key;
    };
    PDFPageLeaf.prototype.setXObject = function(name, xObjectRef) {
        var XObject = this.normalizedEntries().XObject;
        XObject.set(name, xObjectRef);
    };
    PDFPageLeaf.prototype.newXObjectKey = function(tag) {
        var XObject = this.normalizedEntries().XObject;
        return XObject.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newXObject = function(tag, xObjectRef) {
        var key = this.newXObjectKey(tag);
        this.setXObject(key, xObjectRef);
        return key;
    };
    PDFPageLeaf.prototype.setExtGState = function(name, extGStateRef) {
        var ExtGState = this.normalizedEntries().ExtGState;
        ExtGState.set(name, extGStateRef);
    };
    PDFPageLeaf.prototype.newExtGStateKey = function(tag) {
        var ExtGState = this.normalizedEntries().ExtGState;
        return ExtGState.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newExtGState = function(tag, extGStateRef) {
        var key = this.newExtGStateKey(tag);
        this.setExtGState(key, extGStateRef);
        return key;
    };
    PDFPageLeaf.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    PDFPageLeaf.prototype.normalize = function() {
        if (this.normalized) return;
        var context = this.context;
        var contentsRef = this.get((0, $a7yPZ.default).Contents);
        var contents = this.context.lookup(contentsRef);
        if (contents instanceof (0, $29b9b1023bfccc2c$export$2e2bcd8739ae039)) this.set((0, $a7yPZ.default).Contents, context.obj([
            contentsRef
        ]));
        if (this.autoNormalizeCTM) this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
        // TODO: Clone `Resources` if it is inherited
        var dictOrRef = this.getInheritableAttribute((0, $a7yPZ.default).Resources);
        var Resources = context.lookupMaybe(dictOrRef, (0, $f437c135fa674ebe$export$2e2bcd8739ae039)) || context.obj({});
        this.set((0, $a7yPZ.default).Resources, Resources);
        // TODO: Clone `Font` if it is inherited
        var Font = Resources.lookupMaybe((0, $a7yPZ.default).Font, (0, $f437c135fa674ebe$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $a7yPZ.default).Font, Font);
        // TODO: Clone `XObject` if it is inherited
        var XObject = Resources.lookupMaybe((0, $a7yPZ.default).XObject, (0, $f437c135fa674ebe$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $a7yPZ.default).XObject, XObject);
        // TODO: Clone `ExtGState` if it is inherited
        var ExtGState = Resources.lookupMaybe((0, $a7yPZ.default).ExtGState, (0, $f437c135fa674ebe$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $a7yPZ.default).ExtGState, ExtGState);
        var Annots = this.Annots() || context.obj([]);
        this.set((0, $a7yPZ.default).Annots, Annots);
        this.normalized = true;
    };
    PDFPageLeaf.prototype.normalizedEntries = function() {
        this.normalize();
        var Annots = this.Annots();
        var Resources = this.Resources();
        var Contents = this.Contents();
        return {
            Annots: Annots,
            Resources: Resources,
            Contents: Contents,
            Font: Resources.lookup((0, $a7yPZ.default).Font, (0, $f437c135fa674ebe$export$2e2bcd8739ae039)),
            XObject: Resources.lookup((0, $a7yPZ.default).XObject, (0, $f437c135fa674ebe$export$2e2bcd8739ae039)),
            ExtGState: Resources.lookup((0, $a7yPZ.default).ExtGState, (0, $f437c135fa674ebe$export$2e2bcd8739ae039))
        };
    };
    PDFPageLeaf.InheritableEntries = [
        "Resources",
        "MediaBox",
        "CropBox",
        "Rotate"
    ];
    PDFPageLeaf.withContextAndParent = function(context, parent) {
        var dict = new Map();
        dict.set((0, $a7yPZ.default).Type, (0, $a7yPZ.default).Page);
        dict.set((0, $a7yPZ.default).Parent, parent);
        dict.set((0, $a7yPZ.default).Resources, context.obj({}));
        dict.set((0, $a7yPZ.default).MediaBox, context.obj([
            0,
            0,
            612,
            792
        ]));
        return new PDFPageLeaf(dict, context, false);
    };
    PDFPageLeaf.fromMapWithContext = function(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        return new PDFPageLeaf(map, context, autoNormalizeCTM);
    };
    return PDFPageLeaf;
}((0, $f437c135fa674ebe$export$2e2bcd8739ae039));
var $b808f27f9a7c9955$export$2e2bcd8739ae039 = $b808f27f9a7c9955$var$PDFPageLeaf;


/**
 * PDFObjectCopier copies PDFObjects from a src context to a dest context.
 * The primary use case for this is to copy pages between PDFs.
 *
 * _Copying_ an object with a PDFObjectCopier is different from _cloning_ an
 * object with its [[PDFObject.clone]] method:
 *
 * ```
 *   const src: PDFContext = ...
 *   const dest: PDFContext = ...
 *   const originalObject: PDFObject = ...
 *   const copiedObject = PDFObjectCopier.for(src, dest).copy(originalObject);
 *   const clonedObject = originalObject.clone();
 * ```
 *
 * Copying an object is equivalent to cloning it and then copying over any other
 * objects that it references. Note that only dictionaries, arrays, and streams
 * (or structures build from them) can contain indirect references to other
 * objects. Copying a PDFObject that is not a dictionary, array, or stream is
 * supported, but is equivalent to cloning it.
 */ var $fc9573798ab90b32$var$PDFObjectCopier = /** @class */ function() {
    function PDFObjectCopier(src, dest) {
        var _this = this;
        this.traversedObjects = new Map();
        // prettier-ignore
        this.copy = function(object) {
            return object instanceof (0, $b808f27f9a7c9955$export$2e2bcd8739ae039) ? _this.copyPDFPage(object) : object instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039) ? _this.copyPDFDict(object) : object instanceof (0, $7Igbp.default) ? _this.copyPDFArray(object) : object instanceof (0, $29b9b1023bfccc2c$export$2e2bcd8739ae039) ? _this.copyPDFStream(object) : object instanceof (0, $06a507a20ec07388$export$2e2bcd8739ae039) ? _this.copyPDFIndirectObject(object) : object.clone();
        };
        this.copyPDFPage = function(originalPage) {
            var clonedPage = originalPage.clone();
            // Move any entries that the originalPage is inheriting from its parent
            // tree nodes directly into originalPage so they are preserved during
            // the copy.
            var InheritableEntries = (0, $b808f27f9a7c9955$export$2e2bcd8739ae039).InheritableEntries;
            for(var idx = 0, len = InheritableEntries.length; idx < len; idx++){
                var key = (0, $a7yPZ.default).of(InheritableEntries[idx]);
                var value = clonedPage.getInheritableAttribute(key);
                if (!clonedPage.get(key) && value) clonedPage.set(key, value);
            }
            // Remove the parent reference to prevent the whole donor document's page
            // tree from being copied when we only need a single page.
            clonedPage.delete((0, $a7yPZ.default).of("Parent"));
            return _this.copyPDFDict(clonedPage);
        };
        this.copyPDFDict = function(originalDict) {
            if (_this.traversedObjects.has(originalDict)) return _this.traversedObjects.get(originalDict);
            var clonedDict = originalDict.clone(_this.dest);
            _this.traversedObjects.set(originalDict, clonedDict);
            var entries = originalDict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedDict.set(key, _this.copy(value));
            }
            return clonedDict;
        };
        this.copyPDFArray = function(originalArray) {
            if (_this.traversedObjects.has(originalArray)) return _this.traversedObjects.get(originalArray);
            var clonedArray = originalArray.clone(_this.dest);
            _this.traversedObjects.set(originalArray, clonedArray);
            for(var idx = 0, len = originalArray.size(); idx < len; idx++){
                var value = originalArray.get(idx);
                clonedArray.set(idx, _this.copy(value));
            }
            return clonedArray;
        };
        this.copyPDFStream = function(originalStream) {
            if (_this.traversedObjects.has(originalStream)) return _this.traversedObjects.get(originalStream);
            var clonedStream = originalStream.clone(_this.dest);
            _this.traversedObjects.set(originalStream, clonedStream);
            var entries = originalStream.dict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedStream.dict.set(key, _this.copy(value));
            }
            return clonedStream;
        };
        this.copyPDFIndirectObject = function(ref) {
            var alreadyMapped = _this.traversedObjects.has(ref);
            if (!alreadyMapped) {
                var newRef = _this.dest.nextRef();
                _this.traversedObjects.set(ref, newRef);
                var dereferencedValue = _this.src.lookup(ref);
                if (dereferencedValue) {
                    var cloned = _this.copy(dereferencedValue);
                    _this.dest.assign(newRef, cloned);
                }
            }
            return _this.traversedObjects.get(ref);
        };
        this.src = src;
        this.dest = dest;
    }
    PDFObjectCopier.for = function(src, dest) {
        return new PDFObjectCopier(src, dest);
    };
    return PDFObjectCopier;
}();
var $fc9573798ab90b32$export$2e2bcd8739ae039 = $fc9573798ab90b32$var$PDFObjectCopier;



var $59LZ8 = parcelRequire("59LZ8");


var $5ZWJa = parcelRequire("5ZWJa");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
/**
 * Entries should be added using the [[addEntry]] and [[addDeletedEntry]]
 * methods **in order of ascending object number**.
 */ var $26cd178a6f39ea79$var$PDFCrossRefSection = /** @class */ function() {
    function PDFCrossRefSection(firstEntry) {
        this.subsections = firstEntry ? [
            [
                firstEntry
            ]
        ] : [];
        this.chunkIdx = 0;
        this.chunkLength = firstEntry ? 1 : 0;
    }
    PDFCrossRefSection.prototype.addEntry = function(ref, offset) {
        this.append({
            ref: ref,
            offset: offset,
            deleted: false
        });
    };
    PDFCrossRefSection.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        this.append({
            ref: ref,
            offset: nextFreeObjectNumber,
            deleted: true
        });
    };
    PDFCrossRefSection.prototype.toString = function() {
        var section = "xref\n";
        for(var rangeIdx = 0, rangeLen = this.subsections.length; rangeIdx < rangeLen; rangeIdx++){
            var range = this.subsections[rangeIdx];
            section += range[0].ref.objectNumber + " " + range.length + "\n";
            for(var entryIdx = 0, entryLen = range.length; entryIdx < entryLen; entryIdx++){
                var entry = range[entryIdx];
                section += (0, $cZKSB.padStart)(String(entry.offset), 10, "0");
                section += " ";
                section += (0, $cZKSB.padStart)(String(entry.ref.generationNumber), 5, "0");
                section += " ";
                section += entry.deleted ? "f" : "n";
                section += " \n";
            }
        }
        return section;
    };
    PDFCrossRefSection.prototype.sizeInBytes = function() {
        var size = 5;
        for(var idx = 0, len = this.subsections.length; idx < len; idx++){
            var subsection = this.subsections[idx];
            var subsectionLength = subsection.length;
            var firstEntry = subsection[0];
            size += 2;
            size += String(firstEntry.ref.objectNumber).length;
            size += String(subsectionLength).length;
            size += 20 * subsectionLength;
        }
        return size;
    };
    PDFCrossRefSection.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $5ZWJa.default).x;
        buffer[offset++] = (0, $5ZWJa.default).r;
        buffer[offset++] = (0, $5ZWJa.default).e;
        buffer[offset++] = (0, $5ZWJa.default).f;
        buffer[offset++] = (0, $5ZWJa.default).Newline;
        offset += this.copySubsectionsIntoBuffer(this.subsections, buffer, offset);
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copySubsectionsIntoBuffer = function(subsections, buffer, offset) {
        var initialOffset = offset;
        var length = subsections.length;
        for(var idx = 0; idx < length; idx++){
            var subsection = this.subsections[idx];
            var firstObjectNumber = String(subsection[0].ref.objectNumber);
            offset += (0, $cZKSB.copyStringIntoBuffer)(firstObjectNumber, buffer, offset);
            buffer[offset++] = (0, $5ZWJa.default).Space;
            var rangeLength = String(subsection.length);
            offset += (0, $cZKSB.copyStringIntoBuffer)(rangeLength, buffer, offset);
            buffer[offset++] = (0, $5ZWJa.default).Newline;
            offset += this.copyEntriesIntoBuffer(subsection, buffer, offset);
        }
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copyEntriesIntoBuffer = function(entries, buffer, offset) {
        var length = entries.length;
        for(var idx = 0; idx < length; idx++){
            var entry = entries[idx];
            var entryOffset = (0, $cZKSB.padStart)(String(entry.offset), 10, "0");
            offset += (0, $cZKSB.copyStringIntoBuffer)(entryOffset, buffer, offset);
            buffer[offset++] = (0, $5ZWJa.default).Space;
            var entryGen = (0, $cZKSB.padStart)(String(entry.ref.generationNumber), 5, "0");
            offset += (0, $cZKSB.copyStringIntoBuffer)(entryGen, buffer, offset);
            buffer[offset++] = (0, $5ZWJa.default).Space;
            buffer[offset++] = entry.deleted ? (0, $5ZWJa.default).f : (0, $5ZWJa.default).n;
            buffer[offset++] = (0, $5ZWJa.default).Space;
            buffer[offset++] = (0, $5ZWJa.default).Newline;
        }
        return 20 * length;
    };
    PDFCrossRefSection.prototype.append = function(currEntry) {
        if (this.chunkLength === 0) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx = 0;
            this.chunkLength = 1;
            return;
        }
        var chunk = this.subsections[this.chunkIdx];
        var prevEntry = chunk[this.chunkLength - 1];
        if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx += 1;
            this.chunkLength = 1;
        } else {
            chunk.push(currEntry);
            this.chunkLength += 1;
        }
    };
    PDFCrossRefSection.create = function() {
        return new PDFCrossRefSection({
            ref: (0, $06a507a20ec07388$export$2e2bcd8739ae039).of(0, 65535),
            offset: 0,
            deleted: true
        });
    };
    PDFCrossRefSection.createEmpty = function() {
        return new PDFCrossRefSection();
    };
    return PDFCrossRefSection;
}();
var $26cd178a6f39ea79$export$2e2bcd8739ae039 = $26cd178a6f39ea79$var$PDFCrossRefSection;




var $5ZWJa = parcelRequire("5ZWJa");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $023d797fe2fbf449$var$PDFTrailer = /** @class */ function() {
    function PDFTrailer(lastXRefOffset) {
        this.lastXRefOffset = String(lastXRefOffset);
    }
    PDFTrailer.prototype.toString = function() {
        return "startxref\n" + this.lastXRefOffset + "\n%%EOF";
    };
    PDFTrailer.prototype.sizeInBytes = function() {
        return 16 + this.lastXRefOffset.length;
    };
    PDFTrailer.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $5ZWJa.default).s;
        buffer[offset++] = (0, $5ZWJa.default).t;
        buffer[offset++] = (0, $5ZWJa.default).a;
        buffer[offset++] = (0, $5ZWJa.default).r;
        buffer[offset++] = (0, $5ZWJa.default).t;
        buffer[offset++] = (0, $5ZWJa.default).x;
        buffer[offset++] = (0, $5ZWJa.default).r;
        buffer[offset++] = (0, $5ZWJa.default).e;
        buffer[offset++] = (0, $5ZWJa.default).f;
        buffer[offset++] = (0, $5ZWJa.default).Newline;
        offset += (0, $cZKSB.copyStringIntoBuffer)(this.lastXRefOffset, buffer, offset);
        buffer[offset++] = (0, $5ZWJa.default).Newline;
        buffer[offset++] = (0, $5ZWJa.default).Percent;
        buffer[offset++] = (0, $5ZWJa.default).Percent;
        buffer[offset++] = (0, $5ZWJa.default).E;
        buffer[offset++] = (0, $5ZWJa.default).O;
        buffer[offset++] = (0, $5ZWJa.default).F;
        return offset - initialOffset;
    };
    PDFTrailer.forLastCrossRefSectionOffset = function(offset) {
        return new PDFTrailer(offset);
    };
    return PDFTrailer;
}();
var $023d797fe2fbf449$export$2e2bcd8739ae039 = $023d797fe2fbf449$var$PDFTrailer;



var $5ZWJa = parcelRequire("5ZWJa");
var $e96705d44694cea7$var$PDFTrailerDict = /** @class */ function() {
    function PDFTrailerDict(dict) {
        this.dict = dict;
    }
    PDFTrailerDict.prototype.toString = function() {
        return "trailer\n" + this.dict.toString();
    };
    PDFTrailerDict.prototype.sizeInBytes = function() {
        return 8 + this.dict.sizeInBytes();
    };
    PDFTrailerDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $5ZWJa.default).t;
        buffer[offset++] = (0, $5ZWJa.default).r;
        buffer[offset++] = (0, $5ZWJa.default).a;
        buffer[offset++] = (0, $5ZWJa.default).i;
        buffer[offset++] = (0, $5ZWJa.default).l;
        buffer[offset++] = (0, $5ZWJa.default).e;
        buffer[offset++] = (0, $5ZWJa.default).r;
        buffer[offset++] = (0, $5ZWJa.default).Newline;
        offset += this.dict.copyBytesInto(buffer, offset);
        return offset - initialOffset;
    };
    PDFTrailerDict.of = function(dict) {
        return new PDFTrailerDict(dict);
    };
    return PDFTrailerDict;
}();
var $e96705d44694cea7$export$2e2bcd8739ae039 = $e96705d44694cea7$var$PDFTrailerDict;



var $59LZ8 = parcelRequire("59LZ8");

var $a7yPZ = parcelRequire("a7yPZ");

var $gcVIu = parcelRequire("gcVIu");


var $5ZWJa = parcelRequire("5ZWJa");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $i8eKs = parcelRequire("i8eKs");
var $d1ad61da9bb2833e$var$PDFObjectStream = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFObjectStream, _super);
    function PDFObjectStream(context, objects, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, context.obj({}), encode) || this;
        _this.objects = objects;
        _this.offsets = _this.computeObjectOffsets();
        _this.offsetsString = _this.computeOffsetsString();
        _this.dict.set((0, $a7yPZ.default).of("Type"), (0, $a7yPZ.default).of("ObjStm"));
        _this.dict.set((0, $a7yPZ.default).of("N"), (0, $gcVIu.default).of(_this.objects.length));
        _this.dict.set((0, $a7yPZ.default).of("First"), (0, $gcVIu.default).of(_this.offsetsString.length));
        return _this;
    }
    PDFObjectStream.prototype.getObjectsCount = function() {
        return this.objects.length;
    };
    PDFObjectStream.prototype.clone = function(context) {
        return PDFObjectStream.withContextAndObjects(context || this.dict.context, this.objects.slice(), this.encode);
    };
    PDFObjectStream.prototype.getContentsString = function() {
        var value = this.offsetsString;
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            value += object + "\n";
        }
        return value;
    };
    PDFObjectStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = (0, $cZKSB.copyStringIntoBuffer)(this.offsetsString, buffer, 0);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            offset += object.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $5ZWJa.default).Newline;
        }
        return buffer;
    };
    PDFObjectStream.prototype.getUnencodedContentsSize = function() {
        return this.offsetsString.length + (0, $i8eKs.last)(this.offsets)[1] + (0, $i8eKs.last)(this.objects)[1].sizeInBytes() + 1;
    };
    PDFObjectStream.prototype.computeOffsetsString = function() {
        var offsetsString = "";
        for(var idx = 0, len = this.offsets.length; idx < len; idx++){
            var _a = this.offsets[idx], objectNumber = _a[0], offset = _a[1];
            offsetsString += objectNumber + " " + offset + " ";
        }
        return offsetsString;
    };
    PDFObjectStream.prototype.computeObjectOffsets = function() {
        var offset = 0;
        var offsets = new Array(this.objects.length);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], ref = _a[0], object = _a[1];
            offsets[idx] = [
                ref.objectNumber,
                offset
            ];
            offset += object.sizeInBytes() + 1; // '\n'
        }
        return offsets;
    };
    PDFObjectStream.withContextAndObjects = function(context, objects, encode) {
        if (encode === void 0) encode = true;
        return new PDFObjectStream(context, objects, encode);
    };
    return PDFObjectStream;
}((0, $9149f07c335e2813$export$2e2bcd8739ae039));
var $d1ad61da9bb2833e$export$2e2bcd8739ae039 = $d1ad61da9bb2833e$var$PDFObjectStream;



var $5ZWJa = parcelRequire("5ZWJa");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $egzXy = parcelRequire("egzXy");
var $7844c9967da92727$var$PDFWriter = /** @class */ function() {
    function PDFWriter(context, objectsPerTick) {
        var _this = this;
        this.parsedObjects = 0;
        this.shouldWaitForTick = function(n) {
            _this.parsedObjects += n;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        this.context = context;
        this.objectsPerTick = objectsPerTick;
    }
    PDFWriter.prototype.serializeToBuffer = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var _a, size, header, indirectObjects, xref, trailerDict, trailer, offset, buffer, idx, len, _b, ref, object, objectNumber, generationNumber, n;
            return (0, $59LZ8.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.computeBufferSize()
                        ];
                    case 1:
                        _a = _c.sent(), size = _a.size, header = _a.header, indirectObjects = _a.indirectObjects, xref = _a.xref, trailerDict = _a.trailerDict, trailer = _a.trailer;
                        offset = 0;
                        buffer = new Uint8Array(size);
                        offset += header.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $5ZWJa.default).Newline;
                        buffer[offset++] = (0, $5ZWJa.default).Newline;
                        idx = 0, len = indirectObjects.length;
                        _c.label = 2;
                    case 2:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _b = indirectObjects[idx], ref = _b[0], object = _b[1];
                        objectNumber = String(ref.objectNumber);
                        offset += (0, $cZKSB.copyStringIntoBuffer)(objectNumber, buffer, offset);
                        buffer[offset++] = (0, $5ZWJa.default).Space;
                        generationNumber = String(ref.generationNumber);
                        offset += (0, $cZKSB.copyStringIntoBuffer)(generationNumber, buffer, offset);
                        buffer[offset++] = (0, $5ZWJa.default).Space;
                        buffer[offset++] = (0, $5ZWJa.default).o;
                        buffer[offset++] = (0, $5ZWJa.default).b;
                        buffer[offset++] = (0, $5ZWJa.default).j;
                        buffer[offset++] = (0, $5ZWJa.default).Newline;
                        offset += object.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $5ZWJa.default).Newline;
                        buffer[offset++] = (0, $5ZWJa.default).e;
                        buffer[offset++] = (0, $5ZWJa.default).n;
                        buffer[offset++] = (0, $5ZWJa.default).d;
                        buffer[offset++] = (0, $5ZWJa.default).o;
                        buffer[offset++] = (0, $5ZWJa.default).b;
                        buffer[offset++] = (0, $5ZWJa.default).j;
                        buffer[offset++] = (0, $5ZWJa.default).Newline;
                        buffer[offset++] = (0, $5ZWJa.default).Newline;
                        n = object instanceof (0, $d1ad61da9bb2833e$export$2e2bcd8739ae039) ? object.getObjectsCount() : 1;
                        if (!this.shouldWaitForTick(n)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $egzXy.waitForTick)()
                        ];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        idx++;
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        if (xref) {
                            offset += xref.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $5ZWJa.default).Newline;
                        }
                        if (trailerDict) {
                            offset += trailerDict.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $5ZWJa.default).Newline;
                            buffer[offset++] = (0, $5ZWJa.default).Newline;
                        }
                        offset += trailer.copyBytesInto(buffer, offset);
                        return [
                            2 /*return*/ ,
                            buffer
                        ];
                }
            });
        });
    };
    PDFWriter.prototype.computeIndirectObjectSize = function(_a) {
        var ref = _a[0], object = _a[1];
        var refSize = ref.sizeInBytes() + 3; // 'R' -> 'obj\n'
        var objectSize = object.sizeInBytes() + 9; // '\nendobj\n\n'
        return refSize + objectSize;
    };
    PDFWriter.prototype.createTrailerDict = function() {
        return this.context.obj({
            Size: this.context.largestObjectNumber + 1,
            Root: this.context.trailerInfo.Root,
            Encrypt: this.context.trailerInfo.Encrypt,
            Info: this.context.trailerInfo.Info,
            ID: this.context.trailerInfo.ID
        });
    };
    PDFWriter.prototype.computeBufferSize = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var header, size, xref, indirectObjects, idx, len, indirectObject, ref, xrefOffset, trailerDict, trailer;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        header = (0, $7610640e6ae69024$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xref = (0, $26cd178a6f39ea79$export$2e2bcd8739ae039).create();
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0];
                        xref.addEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $egzXy.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        xrefOffset = size;
                        size += xref.sizeInBytes() + 1; // '\n'
                        trailerDict = (0, $e96705d44694cea7$export$2e2bcd8739ae039).of(this.createTrailerDict());
                        size += trailerDict.sizeInBytes() + 2; // '\n\n'
                        trailer = (0, $023d797fe2fbf449$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: indirectObjects,
                                xref: xref,
                                trailerDict: trailerDict,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFWriter.forContext = function(context, objectsPerTick) {
        return new PDFWriter(context, objectsPerTick);
    };
    return PDFWriter;
}();
var $7844c9967da92727$export$2e2bcd8739ae039 = $7844c9967da92727$var$PDFWriter;



var $59LZ8 = parcelRequire("59LZ8");



var $59LZ8 = parcelRequire("59LZ8");

var $cWdWp = parcelRequire("cWdWp");
var $45c005d97d55c8cc$var$PDFInvalidObject = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFInvalidObject, _super);
    function PDFInvalidObject(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    PDFInvalidObject.prototype.clone = function() {
        return PDFInvalidObject.of(this.data.slice());
    };
    PDFInvalidObject.prototype.toString = function() {
        return "PDFInvalidObject(" + this.data.length + " bytes)";
    };
    PDFInvalidObject.prototype.sizeInBytes = function() {
        return this.data.length;
    };
    PDFInvalidObject.prototype.copyBytesInto = function(buffer, offset) {
        var length = this.data.length;
        for(var idx = 0; idx < length; idx++)buffer[offset++] = this.data[idx];
        return length;
    };
    PDFInvalidObject.of = function(data) {
        return new PDFInvalidObject(data);
    };
    return PDFInvalidObject;
}((0, $cWdWp.default));
var $45c005d97d55c8cc$export$2e2bcd8739ae039 = $45c005d97d55c8cc$var$PDFInvalidObject;



var $a7yPZ = parcelRequire("a7yPZ");

var $gcVIu = parcelRequire("gcVIu");



var $59LZ8 = parcelRequire("59LZ8");

var $a7yPZ = parcelRequire("a7yPZ");


parcelRequire("6vLBB");
var $cXeLZ = parcelRequire("cXeLZ");
var $6E4Ej = parcelRequire("6E4Ej");
var $i8eKs = parcelRequire("i8eKs");
var $bbcaeac7ce29dcc3$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Deleted"] = 0] = "Deleted";
    EntryType[EntryType["Uncompressed"] = 1] = "Uncompressed";
    EntryType[EntryType["Compressed"] = 2] = "Compressed";
})($bbcaeac7ce29dcc3$export$e41c32906b33062a || ($bbcaeac7ce29dcc3$export$e41c32906b33062a = {}));
/**
 * Entries should be added using the [[addDeletedEntry]],
 * [[addUncompressedEntry]], and [[addCompressedEntry]] methods
 * **in order of ascending object number**.
 */ var $bbcaeac7ce29dcc3$var$PDFCrossRefStream = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFCrossRefStream, _super);
    function PDFCrossRefStream(dict, entries, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        // Returns an array of integer pairs for each subsection of the cross ref
        // section, where each integer pair represents:
        //   firstObjectNumber(OfSection), length(OfSection)
        _this.computeIndex = function() {
            var subsections = [];
            var subsectionLength = 0;
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var currEntry = _this.entries[idx];
                var prevEntry = _this.entries[idx - 1];
                if (idx === 0) subsections.push(currEntry.ref.objectNumber);
                else if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
                    subsections.push(subsectionLength);
                    subsections.push(currEntry.ref.objectNumber);
                    subsectionLength = 0;
                }
                subsectionLength += 1;
            }
            subsections.push(subsectionLength);
            return subsections;
        };
        _this.computeEntryTuples = function() {
            var entryTuples = new Array(_this.entries.length);
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var entry = _this.entries[idx];
                if (entry.type === $bbcaeac7ce29dcc3$export$e41c32906b33062a.Deleted) {
                    var type = entry.type, nextFreeObjectNumber = entry.nextFreeObjectNumber, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        nextFreeObjectNumber,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $bbcaeac7ce29dcc3$export$e41c32906b33062a.Uncompressed) {
                    var type = entry.type, offset = entry.offset, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        offset,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $bbcaeac7ce29dcc3$export$e41c32906b33062a.Compressed) {
                    var type = entry.type, objectStreamRef = entry.objectStreamRef, index = entry.index;
                    entryTuples[idx] = [
                        type,
                        objectStreamRef.objectNumber,
                        index
                    ];
                }
            }
            return entryTuples;
        };
        _this.computeMaxEntryByteWidths = function() {
            var entryTuples = _this.entryTuplesCache.access();
            var widths = [
                0,
                0,
                0
            ];
            for(var idx = 0, len = entryTuples.length; idx < len; idx++){
                var _a = entryTuples[idx], first = _a[0], second = _a[1], third = _a[2];
                var firstSize = (0, $cXeLZ.sizeInBytes)(first);
                var secondSize = (0, $cXeLZ.sizeInBytes)(second);
                var thirdSize = (0, $cXeLZ.sizeInBytes)(third);
                if (firstSize > widths[0]) widths[0] = firstSize;
                if (secondSize > widths[1]) widths[1] = secondSize;
                if (thirdSize > widths[2]) widths[2] = thirdSize;
            }
            return widths;
        };
        _this.entries = entries || [];
        _this.entryTuplesCache = (0, $6E4Ej.default).populatedBy(_this.computeEntryTuples);
        _this.maxByteWidthsCache = (0, $6E4Ej.default).populatedBy(_this.computeMaxEntryByteWidths);
        _this.indexCache = (0, $6E4Ej.default).populatedBy(_this.computeIndex);
        dict.set((0, $a7yPZ.default).of("Type"), (0, $a7yPZ.default).of("XRef"));
        return _this;
    }
    PDFCrossRefStream.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        var type = $bbcaeac7ce29dcc3$export$e41c32906b33062a.Deleted;
        this.entries.push({
            type: type,
            ref: ref,
            nextFreeObjectNumber: nextFreeObjectNumber
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addUncompressedEntry = function(ref, offset) {
        var type = $bbcaeac7ce29dcc3$export$e41c32906b33062a.Uncompressed;
        this.entries.push({
            type: type,
            ref: ref,
            offset: offset
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addCompressedEntry = function(ref, objectStreamRef, index) {
        var type = $bbcaeac7ce29dcc3$export$e41c32906b33062a.Compressed;
        this.entries.push({
            type: type,
            ref: ref,
            objectStreamRef: objectStreamRef,
            index: index
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.clone = function(context) {
        var _a = this, dict = _a.dict, entries = _a.entries, encode = _a.encode;
        return PDFCrossRefStream.of(dict.clone(context), entries.slice(), encode);
    };
    PDFCrossRefStream.prototype.getContentsString = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var value = "";
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $i8eKs.reverseArray)((0, $cXeLZ.bytesFor)(first));
            var secondBytes = (0, $i8eKs.reverseArray)((0, $cXeLZ.bytesFor)(second));
            var thirdBytes = (0, $i8eKs.reverseArray)((0, $cXeLZ.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)value += (firstBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)value += (secondBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)value += (thirdBytes[idx] || 0).toString(2);
        }
        return value;
    };
    PDFCrossRefStream.prototype.getUnencodedContents = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $i8eKs.reverseArray)((0, $cXeLZ.bytesFor)(first));
            var secondBytes = (0, $i8eKs.reverseArray)((0, $cXeLZ.bytesFor)(second));
            var thirdBytes = (0, $i8eKs.reverseArray)((0, $cXeLZ.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)buffer[offset++] = firstBytes[idx] || 0;
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)buffer[offset++] = secondBytes[idx] || 0;
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)buffer[offset++] = thirdBytes[idx] || 0;
        }
        return buffer;
    };
    PDFCrossRefStream.prototype.getUnencodedContentsSize = function() {
        var byteWidths = this.maxByteWidthsCache.access();
        var entryWidth = (0, $i8eKs.sum)(byteWidths);
        return entryWidth * this.entries.length;
    };
    PDFCrossRefStream.prototype.updateDict = function() {
        _super.prototype.updateDict.call(this);
        var byteWidths = this.maxByteWidthsCache.access();
        var index = this.indexCache.access();
        var context = this.dict.context;
        this.dict.set((0, $a7yPZ.default).of("W"), context.obj(byteWidths));
        this.dict.set((0, $a7yPZ.default).of("Index"), context.obj(index));
    };
    PDFCrossRefStream.create = function(dict, encode) {
        if (encode === void 0) encode = true;
        var stream = new PDFCrossRefStream(dict, [], encode);
        stream.addDeletedEntry((0, $06a507a20ec07388$export$2e2bcd8739ae039).of(0, 65535), 0);
        return stream;
    };
    PDFCrossRefStream.of = function(dict, entries, encode) {
        if (encode === void 0) encode = true;
        return new PDFCrossRefStream(dict, entries, encode);
    };
    return PDFCrossRefStream;
}((0, $9149f07c335e2813$export$2e2bcd8739ae039));
var $bbcaeac7ce29dcc3$export$2e2bcd8739ae039 = $bbcaeac7ce29dcc3$var$PDFCrossRefStream;




parcelRequire("6vLBB");
var $i8eKs = parcelRequire("i8eKs");
var $egzXy = parcelRequire("egzXy");
var $1aa54dc870166c36$var$PDFStreamWriter = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFStreamWriter, _super);
    function PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream) {
        var _this = _super.call(this, context, objectsPerTick) || this;
        _this.encodeStreams = encodeStreams;
        _this.objectsPerStream = objectsPerStream;
        return _this;
    }
    PDFStreamWriter.prototype.computeBufferSize = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var objectNumber, header, size, xrefStream, uncompressedObjects, compressedObjects, objectStreamRefs, indirectObjects, idx, len, indirectObject, ref, object, shouldNotCompress, chunk, objectStreamRef, idx, len, chunk, ref, objectStream, xrefStreamRef, xrefOffset, trailer;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        objectNumber = this.context.largestObjectNumber + 1;
                        header = (0, $7610640e6ae69024$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xrefStream = (0, $bbcaeac7ce29dcc3$export$2e2bcd8739ae039).create(this.createTrailerDict(), this.encodeStreams);
                        uncompressedObjects = [];
                        compressedObjects = [];
                        objectStreamRefs = [];
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            6
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0], object = indirectObject[1];
                        shouldNotCompress = ref === this.context.trailerInfo.Encrypt || object instanceof (0, $29b9b1023bfccc2c$export$2e2bcd8739ae039) || object instanceof (0, $45c005d97d55c8cc$export$2e2bcd8739ae039) || ref.generationNumber !== 0;
                        if (!shouldNotCompress) return [
                            3 /*break*/ ,
                            4
                        ];
                        uncompressedObjects.push(indirectObject);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $egzXy.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        chunk = (0, $i8eKs.last)(compressedObjects);
                        objectStreamRef = (0, $i8eKs.last)(objectStreamRefs);
                        if (!chunk || chunk.length % this.objectsPerStream === 0) {
                            chunk = [];
                            compressedObjects.push(chunk);
                            objectStreamRef = (0, $06a507a20ec07388$export$2e2bcd8739ae039).of(objectNumber++);
                            objectStreamRefs.push(objectStreamRef);
                        }
                        xrefStream.addCompressedEntry(ref, objectStreamRef, chunk.length);
                        chunk.push(indirectObject);
                        _a.label = 5;
                    case 5:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        idx = 0, len = compressedObjects.length;
                        _a.label = 7;
                    case 7:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            10
                        ];
                        chunk = compressedObjects[idx];
                        ref = objectStreamRefs[idx];
                        objectStream = (0, $d1ad61da9bb2833e$export$2e2bcd8739ae039).withContextAndObjects(this.context, chunk, this.encodeStreams);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize([
                            ref,
                            objectStream
                        ]);
                        uncompressedObjects.push([
                            ref,
                            objectStream
                        ]);
                        if (!this.shouldWaitForTick(chunk.length)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $egzXy.waitForTick)()
                        ];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        idx++;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 10:
                        xrefStreamRef = (0, $06a507a20ec07388$export$2e2bcd8739ae039).of(objectNumber++);
                        xrefStream.dict.set((0, $a7yPZ.default).of("Size"), (0, $gcVIu.default).of(objectNumber));
                        xrefStream.addUncompressedEntry(xrefStreamRef, size);
                        xrefOffset = size;
                        size += this.computeIndirectObjectSize([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        uncompressedObjects.push([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        trailer = (0, $023d797fe2fbf449$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: uncompressedObjects,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFStreamWriter.forContext = function(context, objectsPerTick, encodeStreams, objectsPerStream) {
        if (encodeStreams === void 0) encodeStreams = true;
        if (objectsPerStream === void 0) objectsPerStream = 50;
        return new PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream);
    };
    return PDFStreamWriter;
}((0, $7844c9967da92727$export$2e2bcd8739ae039));
var $1aa54dc870166c36$export$2e2bcd8739ae039 = $1aa54dc870166c36$var$PDFStreamWriter;






parcelRequire("9Mq7C");
var $gMRCf = parcelRequire("gMRCf");
var $7yxAx = parcelRequire("7yxAx");

var $59LZ8 = parcelRequire("59LZ8");

var $cWdWp = parcelRequire("cWdWp");

var $5ZWJa = parcelRequire("5ZWJa");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $bPoC4 = parcelRequire("bPoC4");
var $8I4bY = parcelRequire("8I4bY");

var $1cWQu = parcelRequire("1cWQu");
var $97a582c32ae6773b$var$PDFHexString = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFHexString, _super);
    function PDFHexString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFHexString.prototype.asBytes = function() {
        // Append a zero if the number of digits is odd. See PDF spec 7.3.4.3
        var hex = this.value + (this.value.length % 2 === 1 ? "0" : "");
        var hexLength = hex.length;
        var bytes = new Uint8Array(hex.length / 2);
        var hexOffset = 0;
        var bytesOffset = 0;
        // Interpret each pair of hex digits as a single byte
        while(hexOffset < hexLength){
            var byte = parseInt(hex.substring(hexOffset, hexOffset + 2), 16);
            bytes[bytesOffset] = byte;
            hexOffset += 2;
            bytesOffset += 1;
        }
        return bytes;
    };
    PDFHexString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $bPoC4.hasUtf16BOM)(bytes)) return (0, $bPoC4.utf16Decode)(bytes);
        return (0, $8I4bY.pdfDocEncodingDecode)(bytes);
    };
    PDFHexString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $cZKSB.parseDate)(text);
        if (!date) throw new (0, $1cWQu.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFHexString.prototype.asString = function() {
        return this.value;
    };
    PDFHexString.prototype.clone = function() {
        return PDFHexString.of(this.value);
    };
    PDFHexString.prototype.toString = function() {
        return "<" + this.value + ">";
    };
    PDFHexString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFHexString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $5ZWJa.default).LessThan;
        offset += (0, $cZKSB.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $5ZWJa.default).GreaterThan;
        return this.value.length + 2;
    };
    PDFHexString.of = function(value) {
        return new PDFHexString(value);
    };
    PDFHexString.fromText = function(value) {
        var encoded = (0, $bPoC4.utf16Encode)(value);
        var hex = "";
        for(var idx = 0, len = encoded.length; idx < len; idx++)hex += (0, $cZKSB.toHexStringOfMinLength)(encoded[idx], 4);
        return new PDFHexString(hex);
    };
    return PDFHexString;
}((0, $cWdWp.default));
var $97a582c32ae6773b$export$2e2bcd8739ae039 = $97a582c32ae6773b$var$PDFHexString;


parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/f91bdd61c164a72ea06be1a43dc0a412afc3925f/lib/font/afm.coffee
 */ var $587d3987c4649df3$var$StandardFontEmbedder = /** @class */ function() {
    function StandardFontEmbedder(fontName, customName) {
        // prettier-ignore
        this.encoding = fontName === (0, $7yxAx.FontNames).ZapfDingbats ? (0, $gMRCf.Encodings).ZapfDingbats : fontName === (0, $7yxAx.FontNames).Symbol ? (0, $gMRCf.Encodings).Symbol : (0, $gMRCf.Encodings).WinAnsi;
        this.font = (0, $7yxAx.Font).load(fontName);
        this.fontName = this.font.FontName;
        this.customName = customName;
    }
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but standard fonts use either WinAnsi, ZapfDingbats, or Symbol
     * encodings)
     */ StandardFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $cZKSB.toHexString)(glyphs[idx].code);
        return (0, $97a582c32ae6773b$export$2e2bcd8739ae039).of(hexCodes.join(""));
    };
    StandardFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var left = glyphs[idx].name;
            var right = (glyphs[idx + 1] || {}).name;
            var kernAmount = this.font.getXAxisKerningForPair(left, right) || 0;
            totalWidth += this.widthOfGlyph(left) + kernAmount;
        }
        var scale = size / 1000;
        return totalWidth * scale;
    };
    StandardFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, Ascender = _b.Ascender, Descender = _b.Descender, FontBBox = _b.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        var height = yTop - yBottom;
        if (!descender) height += Descender || 0;
        return height / 1000 * size;
    };
    StandardFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, Ascender = _a.Ascender, Descender = _a.Descender, FontBBox = _a.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        return 1000 * height / (yTop - yBottom);
    };
    StandardFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        var fontDict = context.obj({
            Type: "Font",
            Subtype: "Type1",
            BaseFont: this.customName || this.fontName,
            Encoding: this.encoding === (0, $gMRCf.Encodings).WinAnsi ? "WinAnsiEncoding" : undefined
        });
        if (ref) {
            context.assign(ref, fontDict);
            return ref;
        } else return context.register(fontDict);
    };
    StandardFontEmbedder.prototype.widthOfGlyph = function(glyphName) {
        // Default to 250 if font doesn't specify a width
        return this.font.getWidthOfGlyph(glyphName) || 250;
    };
    StandardFontEmbedder.prototype.encodeTextAsGlyphs = function(text) {
        var codePoints = Array.from(text);
        var glyphs = new Array(codePoints.length);
        for(var idx = 0, len = codePoints.length; idx < len; idx++){
            var codePoint = (0, $cZKSB.toCodePoint)(codePoints[idx]);
            glyphs[idx] = this.encoding.encodeUnicodeCodePoint(codePoint);
        }
        return glyphs;
    };
    StandardFontEmbedder.for = function(fontName, customName) {
        return new StandardFontEmbedder(fontName, customName);
    };
    return StandardFontEmbedder;
}();
var $587d3987c4649df3$export$2e2bcd8739ae039 = $587d3987c4649df3$var$StandardFontEmbedder;



var $59LZ8 = parcelRequire("59LZ8");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");

var $bPoC4 = parcelRequire("bPoC4");
var $9520bdf4b848783b$export$ecb273704ecc155f = function(glyphs, glyphId) {
    var bfChars = new Array(glyphs.length);
    for(var idx = 0, len = glyphs.length; idx < len; idx++){
        var glyph = glyphs[idx];
        var id = $9520bdf4b848783b$var$cmapHexFormat($9520bdf4b848783b$var$cmapHexString(glyphId(glyph)));
        var unicode = $9520bdf4b848783b$var$cmapHexFormat.apply(void 0, glyph.codePoints.map($9520bdf4b848783b$var$cmapCodePointFormat));
        bfChars[idx] = [
            id,
            unicode
        ];
    }
    return $9520bdf4b848783b$var$fillCmapTemplate(bfChars);
};
/* =============================== Templates ================================ */ var $9520bdf4b848783b$var$fillCmapTemplate = function(bfChars) {
    return "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n" + bfChars.length + " beginbfchar\n" + bfChars.map(function(_a) {
        var glyphId = _a[0], codePoint = _a[1];
        return glyphId + " " + codePoint;
    }).join("\n") + "\nendbfchar\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
};
/* =============================== Utilities ================================ */ var $9520bdf4b848783b$var$cmapHexFormat = function() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return "<" + values.join("") + ">";
};
var $9520bdf4b848783b$var$cmapHexString = function(value) {
    return (0, $cZKSB.toHexStringOfMinLength)(value, 4);
};
var $9520bdf4b848783b$var$cmapCodePointFormat = function(codePoint) {
    if ((0, $bPoC4.isWithinBMP)(codePoint)) return $9520bdf4b848783b$var$cmapHexString(codePoint);
    if ((0, $bPoC4.hasSurrogates)(codePoint)) {
        var hs = (0, $bPoC4.highSurrogate)(codePoint);
        var ls = (0, $bPoC4.lowSurrogate)(codePoint);
        return "" + $9520bdf4b848783b$var$cmapHexString(hs) + $9520bdf4b848783b$var$cmapHexString(ls);
    }
    var hex = (0, $cZKSB.toHexString)(codePoint);
    var msg = "0x" + hex + " is not a valid UTF-8 or UTF-16 codepoint.";
    throw new Error(msg);
};


// prettier-ignore
var $6b6f3eaebbc524a2$var$makeFontFlags = function(options) {
    var flags = 0;
    var flipBit = function(bit) {
        flags |= 1 << bit - 1;
    };
    if (options.fixedPitch) flipBit(1);
    if (options.serif) flipBit(2);
    if (options.symbolic) flipBit(3);
    if (options.script) flipBit(4);
    if (options.nonsymbolic) flipBit(6);
    if (options.italic) flipBit(7);
    if (options.allCap) flipBit(17);
    if (options.smallCap) flipBit(18);
    if (options.forceBold) flipBit(19);
    return flags;
};
var $6b6f3eaebbc524a2$export$aa92af1a056b24e8 = function(font) {
    var familyClass = font["OS/2"] ? font["OS/2"].sFamilyClass : 0;
    var flags = $6b6f3eaebbc524a2$var$makeFontFlags({
        fixedPitch: font.post.isFixedPitch,
        serif: 1 <= familyClass && familyClass <= 7,
        symbolic: true,
        script: familyClass === 10,
        italic: font.head.macStyle.italic
    });
    return flags;
};




var $59LZ8 = parcelRequire("59LZ8");

var $cWdWp = parcelRequire("cWdWp");

var $5ZWJa = parcelRequire("5ZWJa");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $bPoC4 = parcelRequire("bPoC4");
var $8I4bY = parcelRequire("8I4bY");

var $1cWQu = parcelRequire("1cWQu");
var $bdb4f5f430bc7c08$var$PDFString = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFString, _super);
    function PDFString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFString.prototype.asBytes = function() {
        var bytes = [];
        var octal = "";
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 0, len = this.value.length; idx < len; idx++){
            var char = this.value[idx];
            var byte = (0, $cZKSB.toCharCode)(char);
            var nextChar = this.value[idx + 1];
            if (!escaped) {
                if (byte === (0, $5ZWJa.default).BackSlash) escaped = true;
                else pushByte(byte);
            } else {
                if (byte === (0, $5ZWJa.default).Newline) pushByte();
                else if (byte === (0, $5ZWJa.default).CarriageReturn) pushByte();
                else if (byte === (0, $5ZWJa.default).n) pushByte((0, $5ZWJa.default).Newline);
                else if (byte === (0, $5ZWJa.default).r) pushByte((0, $5ZWJa.default).CarriageReturn);
                else if (byte === (0, $5ZWJa.default).t) pushByte((0, $5ZWJa.default).Tab);
                else if (byte === (0, $5ZWJa.default).b) pushByte((0, $5ZWJa.default).Backspace);
                else if (byte === (0, $5ZWJa.default).f) pushByte((0, $5ZWJa.default).FormFeed);
                else if (byte === (0, $5ZWJa.default).LeftParen) pushByte((0, $5ZWJa.default).LeftParen);
                else if (byte === (0, $5ZWJa.default).RightParen) pushByte((0, $5ZWJa.default).RightParen);
                else if (byte === (0, $5ZWJa.default).Backspace) pushByte((0, $5ZWJa.default).BackSlash);
                else if (byte >= (0, $5ZWJa.default).Zero && byte <= (0, $5ZWJa.default).Seven) {
                    octal += char;
                    if (octal.length === 3 || !(nextChar >= "0" && nextChar <= "7")) {
                        pushByte(parseInt(octal, 8));
                        octal = "";
                    }
                } else pushByte(byte);
            }
        }
        return new Uint8Array(bytes);
    };
    PDFString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $bPoC4.hasUtf16BOM)(bytes)) return (0, $bPoC4.utf16Decode)(bytes);
        return (0, $8I4bY.pdfDocEncodingDecode)(bytes);
    };
    PDFString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $cZKSB.parseDate)(text);
        if (!date) throw new (0, $1cWQu.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFString.prototype.asString = function() {
        return this.value;
    };
    PDFString.prototype.clone = function() {
        return PDFString.of(this.value);
    };
    PDFString.prototype.toString = function() {
        return "(" + this.value + ")";
    };
    PDFString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $5ZWJa.default).LeftParen;
        offset += (0, $cZKSB.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $5ZWJa.default).RightParen;
        return this.value.length + 2;
    };
    // The PDF spec allows newlines and parens to appear directly within a literal
    // string. These character _may_ be escaped. But they do not _have_ to be. So
    // for simplicity, we will not bother escaping them.
    PDFString.of = function(value) {
        return new PDFString(value);
    };
    PDFString.fromDate = function(date) {
        var year = (0, $cZKSB.padStart)(String(date.getUTCFullYear()), 4, "0");
        var month = (0, $cZKSB.padStart)(String(date.getUTCMonth() + 1), 2, "0");
        var day = (0, $cZKSB.padStart)(String(date.getUTCDate()), 2, "0");
        var hours = (0, $cZKSB.padStart)(String(date.getUTCHours()), 2, "0");
        var mins = (0, $cZKSB.padStart)(String(date.getUTCMinutes()), 2, "0");
        var secs = (0, $cZKSB.padStart)(String(date.getUTCSeconds()), 2, "0");
        return new PDFString("D:" + year + month + day + hours + mins + secs + "Z");
    };
    return PDFString;
}((0, $cWdWp.default));
var $bdb4f5f430bc7c08$export$2e2bcd8739ae039 = $bdb4f5f430bc7c08$var$PDFString;


parcelRequire("6vLBB");
var $i8eKs = parcelRequire("i8eKs");
var $6E4Ej = parcelRequire("6E4Ej");
var $cZKSB = parcelRequire("cZKSB");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $94580d5a22612d4f$var$CustomFontEmbedder = /** @class */ function() {
    function CustomFontEmbedder(font, fontData, customName, fontFeatures) {
        var _this = this;
        this.allGlyphsInFontSortedById = function() {
            var glyphs = new Array(_this.font.characterSet.length);
            for(var idx = 0, len = glyphs.length; idx < len; idx++){
                var codePoint = _this.font.characterSet[idx];
                glyphs[idx] = _this.font.glyphForCodePoint(codePoint);
            }
            return (0, $i8eKs.sortedUniq)(glyphs.sort((0, $i8eKs.byAscendingId)), function(g) {
                return g.id;
            });
        };
        this.font = font;
        this.scale = 1000 / this.font.unitsPerEm;
        this.fontData = fontData;
        this.fontName = this.font.postscriptName || "Font";
        this.customName = customName;
        this.fontFeatures = fontFeatures;
        this.baseFontName = "";
        this.glyphCache = (0, $6E4Ej.default).populatedBy(this.allGlyphsInFontSortedById);
    }
    CustomFontEmbedder.for = function(fontkit, fontData, customName, fontFeatures) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontEmbedder(font, fontData, customName, fontFeatures)
                        ];
                }
            });
        });
    };
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but embedded fonts use their own custom encodings)
     */ CustomFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $cZKSB.toHexStringOfMinLength)(glyphs[idx].id, 4);
        return (0, $97a582c32ae6773b$export$2e2bcd8739ae039).of(hexCodes.join(""));
    };
    // The advanceWidth takes into account kerning automatically, so we don't
    // have to do that manually like we do for the standard fonts.
    CustomFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++)totalWidth += glyphs[idx].advanceWidth * this.scale;
        var scale = size / 1000;
        return totalWidth * scale;
    };
    CustomFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, ascent = _b.ascent, descent = _b.descent, bbox = _b.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        var height = yTop - yBottom;
        if (!descender) height -= Math.abs(descent) || 0;
        return height / 1000 * size;
    };
    CustomFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, ascent = _a.ascent, descent = _a.descent, bbox = _a.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        return 1000 * height / (yTop - yBottom);
    };
    CustomFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        this.baseFontName = this.customName || context.addRandomSuffix(this.fontName);
        return this.embedFontDict(context, ref);
    };
    CustomFontEmbedder.prototype.embedFontDict = function(context, ref) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var cidFontDictRef, unicodeCMapRef, fontDict;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedCIDFontDict(context)
                        ];
                    case 1:
                        cidFontDictRef = _a.sent();
                        unicodeCMapRef = this.embedUnicodeCmap(context);
                        fontDict = context.obj({
                            Type: "Font",
                            Subtype: "Type0",
                            BaseFont: this.baseFontName,
                            Encoding: "Identity-H",
                            DescendantFonts: [
                                cidFontDictRef
                            ],
                            ToUnicode: unicodeCMapRef
                        });
                        if (ref) {
                            context.assign(ref, fontDict);
                            return [
                                2 /*return*/ ,
                                ref
                            ];
                        } else return [
                            2 /*return*/ ,
                            context.register(fontDict)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.isCFF = function() {
        return this.font.cff;
    };
    CustomFontEmbedder.prototype.embedCIDFontDict = function(context) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var fontDescriptorRef, cidFontDict;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontDescriptor(context)
                        ];
                    case 1:
                        fontDescriptorRef = _a.sent();
                        cidFontDict = context.obj({
                            Type: "Font",
                            Subtype: this.isCFF() ? "CIDFontType0" : "CIDFontType2",
                            CIDToGIDMap: "Identity",
                            BaseFont: this.baseFontName,
                            CIDSystemInfo: {
                                Registry: (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039).of("Adobe"),
                                Ordering: (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039).of("Identity"),
                                Supplement: 0
                            },
                            FontDescriptor: fontDescriptorRef,
                            W: this.computeWidths()
                        });
                        return [
                            2 /*return*/ ,
                            context.register(cidFontDict)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontDescriptor = function(context) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var fontStreamRef, scale, _a, italicAngle, ascent, descent, capHeight, xHeight, _b, minX, minY, maxX, maxY, fontDescriptor;
            var _c;
            return (0, $59LZ8.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontStream(context)
                        ];
                    case 1:
                        fontStreamRef = _d.sent();
                        scale = this.scale;
                        _a = this.font, italicAngle = _a.italicAngle, ascent = _a.ascent, descent = _a.descent, capHeight = _a.capHeight, xHeight = _a.xHeight;
                        _b = this.font.bbox, minX = _b.minX, minY = _b.minY, maxX = _b.maxX, maxY = _b.maxY;
                        fontDescriptor = context.obj((_c = {
                            Type: "FontDescriptor",
                            FontName: this.baseFontName,
                            Flags: (0, $6b6f3eaebbc524a2$export$aa92af1a056b24e8)(this.font),
                            FontBBox: [
                                minX * scale,
                                minY * scale,
                                maxX * scale,
                                maxY * scale
                            ],
                            ItalicAngle: italicAngle,
                            Ascent: ascent * scale,
                            Descent: descent * scale,
                            CapHeight: (capHeight || ascent) * scale,
                            XHeight: (xHeight || 0) * scale,
                            // Not sure how to compute/find this, nor is anybody else really:
                            // https://stackoverflow.com/questions/35485179/stemv-value-of-the-truetype-font
                            StemV: 0
                        }, _c[this.isCFF() ? "FontFile3" : "FontFile2"] = fontStreamRef, _c));
                        return [
                            2 /*return*/ ,
                            context.register(fontDescriptor)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.serializeFont = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            return (0, $59LZ8.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.fontData
                ];
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontStream = function(context) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var fontStream, _a, _b;
            return (0, $59LZ8.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = context).flateStream;
                        return [
                            4 /*yield*/ ,
                            this.serializeFont()
                        ];
                    case 1:
                        fontStream = _b.apply(_a, [
                            _c.sent(),
                            {
                                Subtype: this.isCFF() ? "CIDFontType0C" : undefined
                            }
                        ]);
                        return [
                            2 /*return*/ ,
                            context.register(fontStream)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedUnicodeCmap = function(context) {
        var cmap = (0, $9520bdf4b848783b$export$ecb273704ecc155f)(this.glyphCache.access(), this.glyphId.bind(this));
        var cmapStream = context.flateStream(cmap);
        return context.register(cmapStream);
    };
    CustomFontEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? glyph.id : -1;
    };
    CustomFontEmbedder.prototype.computeWidths = function() {
        var glyphs = this.glyphCache.access();
        var widths = [];
        var currSection = [];
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var currGlyph = glyphs[idx];
            var prevGlyph = glyphs[idx - 1];
            var currGlyphId = this.glyphId(currGlyph);
            var prevGlyphId = this.glyphId(prevGlyph);
            if (idx === 0) widths.push(currGlyphId);
            else if (currGlyphId - prevGlyphId !== 1) {
                widths.push(currSection);
                widths.push(currGlyphId);
                currSection = [];
            }
            currSection.push(currGlyph.advanceWidth * this.scale);
        }
        widths.push(currSection);
        return widths;
    };
    return CustomFontEmbedder;
}();
var $94580d5a22612d4f$export$2e2bcd8739ae039 = $94580d5a22612d4f$var$CustomFontEmbedder;



var $59LZ8 = parcelRequire("59LZ8");


parcelRequire("6vLBB");
var $6E4Ej = parcelRequire("6E4Ej");
var $i8eKs = parcelRequire("i8eKs");
var $cZKSB = parcelRequire("cZKSB");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $4017cb560b440560$var$CustomFontSubsetEmbedder = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(CustomFontSubsetEmbedder, _super);
    function CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures) {
        var _this = _super.call(this, font, fontData, customFontName, fontFeatures) || this;
        _this.subset = _this.font.createSubset();
        _this.glyphs = [];
        _this.glyphCache = (0, $6E4Ej.default).populatedBy(function() {
            return _this.glyphs;
        });
        _this.glyphIdMap = new Map();
        return _this;
    }
    CustomFontSubsetEmbedder.for = function(fontkit, fontData, customFontName, fontFeatures) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures)
                        ];
                }
            });
        });
    };
    CustomFontSubsetEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var glyph = glyphs[idx];
            var subsetGlyphId = this.subset.includeGlyph(glyph);
            this.glyphs[subsetGlyphId - 1] = glyph;
            this.glyphIdMap.set(glyph.id, subsetGlyphId);
            hexCodes[idx] = (0, $cZKSB.toHexStringOfMinLength)(subsetGlyphId, 4);
        }
        this.glyphCache.invalidate();
        return (0, $97a582c32ae6773b$export$2e2bcd8739ae039).of(hexCodes.join(""));
    };
    CustomFontSubsetEmbedder.prototype.isCFF = function() {
        return this.subset.cff;
    };
    CustomFontSubsetEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? this.glyphIdMap.get(glyph.id) : -1;
    };
    CustomFontSubsetEmbedder.prototype.serializeFont = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var parts = [];
            _this.subset.encodeStream().on("data", function(bytes) {
                return parts.push(bytes);
            }).on("end", function() {
                return resolve((0, $i8eKs.mergeUint8Arrays)(parts));
            }).on("error", function(err) {
                return reject(err);
            });
        });
    };
    return CustomFontSubsetEmbedder;
}((0, $94580d5a22612d4f$export$2e2bcd8739ae039));
var $4017cb560b440560$export$2e2bcd8739ae039 = $4017cb560b440560$var$CustomFontSubsetEmbedder;



var $59LZ8 = parcelRequire("59LZ8");


var $ec59dba154692ed3$export$c12eac46fbec1b74;
(function(AFRelationship) {
    AFRelationship["Source"] = "Source";
    AFRelationship["Data"] = "Data";
    AFRelationship["Alternative"] = "Alternative";
    AFRelationship["Supplement"] = "Supplement";
    AFRelationship["EncryptedPayload"] = "EncryptedPayload";
    AFRelationship["FormData"] = "EncryptedPayload";
    AFRelationship["Schema"] = "Schema";
    AFRelationship["Unspecified"] = "Unspecified";
})($ec59dba154692ed3$export$c12eac46fbec1b74 || ($ec59dba154692ed3$export$c12eac46fbec1b74 = {}));
var $ec59dba154692ed3$var$FileEmbedder = /** @class */ function() {
    function FileEmbedder(fileData, fileName, options) {
        if (options === void 0) options = {};
        this.fileData = fileData;
        this.fileName = fileName;
        this.options = options;
    }
    FileEmbedder.for = function(bytes, fileName, options) {
        if (options === void 0) options = {};
        return new FileEmbedder(bytes, fileName, options);
    };
    FileEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var _a, mimeType, description, creationDate, modificationDate, afRelationship, embeddedFileStream, embeddedFileStreamRef, fileSpecDict;
            return (0, $59LZ8.__generator)(this, function(_b) {
                _a = this.options, mimeType = _a.mimeType, description = _a.description, creationDate = _a.creationDate, modificationDate = _a.modificationDate, afRelationship = _a.afRelationship;
                embeddedFileStream = context.flateStream(this.fileData, {
                    Type: "EmbeddedFile",
                    Subtype: mimeType !== null && mimeType !== void 0 ? mimeType : undefined,
                    Params: {
                        Size: this.fileData.length,
                        CreationDate: creationDate ? (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039).fromDate(creationDate) : undefined,
                        ModDate: modificationDate ? (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039).fromDate(modificationDate) : undefined
                    }
                });
                embeddedFileStreamRef = context.register(embeddedFileStream);
                fileSpecDict = context.obj({
                    Type: "Filespec",
                    F: (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039).of(this.fileName),
                    UF: (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(this.fileName),
                    EF: {
                        F: embeddedFileStreamRef
                    },
                    Desc: description ? (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(description) : undefined,
                    AFRelationship: afRelationship !== null && afRelationship !== void 0 ? afRelationship : undefined
                });
                if (ref) {
                    context.assign(ref, fileSpecDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(fileSpecDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return FileEmbedder;
}();
var $ec59dba154692ed3$export$2e2bcd8739ae039 = $ec59dba154692ed3$var$FileEmbedder;



var $59LZ8 = parcelRequire("59LZ8");
// prettier-ignore
var $52ae0fa4c28dbb24$var$MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var $52ae0fa4c28dbb24$var$ColorSpace;
(function(ColorSpace) {
    ColorSpace["DeviceGray"] = "DeviceGray";
    ColorSpace["DeviceRGB"] = "DeviceRGB";
    ColorSpace["DeviceCMYK"] = "DeviceCMYK";
})($52ae0fa4c28dbb24$var$ColorSpace || ($52ae0fa4c28dbb24$var$ColorSpace = {}));
var $52ae0fa4c28dbb24$var$ChannelToColorSpace = {
    1: $52ae0fa4c28dbb24$var$ColorSpace.DeviceGray,
    3: $52ae0fa4c28dbb24$var$ColorSpace.DeviceRGB,
    4: $52ae0fa4c28dbb24$var$ColorSpace.DeviceCMYK
};
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/a6af76467ce06bd6a2af4aa7271ccac9ff152a7d/lib/image/jpeg.js
 */ var $52ae0fa4c28dbb24$var$JpegEmbedder = /** @class */ function() {
    function JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace) {
        this.imageData = imageData;
        this.bitsPerComponent = bitsPerComponent;
        this.width = width;
        this.height = height;
        this.colorSpace = colorSpace;
    }
    JpegEmbedder.for = function(imageData) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var dataView, soi, pos, marker, bitsPerComponent, height, width, channelByte, channelName, colorSpace;
            return (0, $59LZ8.__generator)(this, function(_a) {
                dataView = new DataView(imageData.buffer);
                soi = dataView.getUint16(0);
                if (soi !== 0xffd8) throw new Error("SOI not found in JPEG");
                pos = 2;
                while(pos < dataView.byteLength){
                    marker = dataView.getUint16(pos);
                    pos += 2;
                    if ($52ae0fa4c28dbb24$var$MARKERS.includes(marker)) break;
                    pos += dataView.getUint16(pos);
                }
                if (!$52ae0fa4c28dbb24$var$MARKERS.includes(marker)) throw new Error("Invalid JPEG");
                pos += 2;
                bitsPerComponent = dataView.getUint8(pos++);
                height = dataView.getUint16(pos);
                pos += 2;
                width = dataView.getUint16(pos);
                pos += 2;
                channelByte = dataView.getUint8(pos++);
                channelName = $52ae0fa4c28dbb24$var$ChannelToColorSpace[channelByte];
                if (!channelName) throw new Error("Unknown JPEG channel.");
                colorSpace = channelName;
                return [
                    2 /*return*/ ,
                    new JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace)
                ];
            });
        });
    };
    JpegEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var xObject;
            return (0, $59LZ8.__generator)(this, function(_a) {
                xObject = context.stream(this.imageData, {
                    Type: "XObject",
                    Subtype: "Image",
                    BitsPerComponent: this.bitsPerComponent,
                    Width: this.width,
                    Height: this.height,
                    ColorSpace: this.colorSpace,
                    Filter: "DCTDecode",
                    // CMYK JPEG streams in PDF are typically stored complemented,
                    // with 1 as 'off' and 0 as 'on' (PDF 32000-1:2008, 8.6.4.4).
                    //
                    // Standalone CMYK JPEG (usually exported by Photoshop) are
                    // stored inverse, with 0 as 'off' and 1 as 'on', like RGB.
                    //
                    // Applying a swap here as a hedge that most bytes passing
                    // through this method will benefit from it.
                    Decode: this.colorSpace === $52ae0fa4c28dbb24$var$ColorSpace.DeviceCMYK ? [
                        1,
                        0,
                        1,
                        0,
                        1,
                        0,
                        1,
                        0
                    ] : undefined
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JpegEmbedder;
}();
var $52ae0fa4c28dbb24$export$2e2bcd8739ae039 = $52ae0fa4c28dbb24$var$JpegEmbedder;



var $59LZ8 = parcelRequire("59LZ8");

var $ckBc7 = parcelRequire("ckBc7");
var $653a48f71451847a$var$UPNG = {};
$653a48f71451847a$var$UPNG.toRGBA8 = function(out) {
    var w = out.width, h = out.height;
    if (out.tabs.acTL == null) return [
        $653a48f71451847a$var$UPNG.toRGBA8.decodeImage(out.data, w, h, out).buffer
    ];
    var frms = [];
    if (out.frames[0].data == null) out.frames[0].data = out.data;
    var len = w * h * 4, img = new Uint8Array(len), empty = new Uint8Array(len), prev = new Uint8Array(len);
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i];
        var fx = frm.rect.x, fy = frm.rect.y, fw = frm.rect.width, fh = frm.rect.height;
        var fdata = $653a48f71451847a$var$UPNG.toRGBA8.decodeImage(frm.data, fw, fh, out);
        if (i != 0) for(var j = 0; j < len; j++)prev[j] = img[j];
        if (frm.blend == 0) $653a48f71451847a$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.blend == 1) $653a48f71451847a$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 1);
        frms.push(img.buffer.slice(0));
        if (frm.dispose == 0) ;
        else if (frm.dispose == 1) $653a48f71451847a$var$UPNG._copyTile(empty, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.dispose == 2) for(var j = 0; j < len; j++)img[j] = prev[j];
    }
    return frms;
};
$653a48f71451847a$var$UPNG.toRGBA8.decodeImage = function(data, w, h, out) {
    var area = w * h, bpp = $653a48f71451847a$var$UPNG.decode._getBPP(out);
    var bpl = Math.ceil(w * bpp / 8); // bytes per line
    var bf = new Uint8Array(area * 4), bf32 = new Uint32Array(bf.buffer);
    var ctype = out.ctype, depth = out.depth;
    var rs = $653a48f71451847a$var$UPNG._bin.readUshort;
    //console.log(ctype, depth);
    var time = Date.now();
    if (ctype == 6) {
        var qarea = area << 2;
        if (depth == 8) for(var i = 0; i < qarea; i += 4){
            bf[i] = data[i];
            bf[i + 1] = data[i + 1];
            bf[i + 2] = data[i + 2];
            bf[i + 3] = data[i + 3];
        }
        if (depth == 16) for(var i = 0; i < qarea; i++)bf[i] = data[i << 1];
    } else if (ctype == 2) {
        var ts = out.tabs["tRNS"];
        if (ts == null) {
            if (depth == 8) for(var i = 0; i < area; i++){
                var ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
            }
        } else {
            var tr = ts[0], tg = ts[1], tb = ts[2];
            if (depth == 8) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
                if (data[ti] == tr && data[ti + 1] == tg && data[ti + 2] == tb) bf[qi + 3] = 0;
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
                if (rs(data, ti) == tr && rs(data, ti + 2) == tg && rs(data, ti + 4) == tb) bf[qi + 3] = 0;
            }
        }
    } else if (ctype == 3) {
        var p = out.tabs["PLTE"], ap = out.tabs["tRNS"], tl = ap ? ap.length : 0;
        //console.log(p, ap);
        if (depth == 1) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 3)] >> 7 - ((i & 7) << 0) & 1, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 2) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 2)] >> 6 - ((i & 3) << 1) & 3, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 4) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 1)] >> 4 - ((i & 1) << 2) & 15, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, j = data[i], cj = 3 * j;
            bf[qi] = p[cj];
            bf[qi + 1] = p[cj + 1];
            bf[qi + 2] = p[cj + 2];
            bf[qi + 3] = j < tl ? ap[j] : 255;
        }
    } else if (ctype == 4) {
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 1, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 1];
        }
        if (depth == 16) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 2, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 2];
        }
    } else if (ctype == 0) {
        var tr = out.tabs["tRNS"] ? out.tabs["tRNS"] : -1;
        for(var y = 0; y < h; y++){
            var off = y * bpl, to = y * w;
            if (depth == 1) for(var x = 0; x < w; x++){
                var gr = 255 * (data[off + (x >>> 3)] >>> 7 - (x & 7) & 1), al = gr == tr * 255 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 2) for(var x = 0; x < w; x++){
                var gr = 85 * (data[off + (x >>> 2)] >>> 6 - ((x & 3) << 1) & 3), al = gr == tr * 85 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 4) for(var x = 0; x < w; x++){
                var gr = 17 * (data[off + (x >>> 1)] >>> 4 - ((x & 1) << 2) & 15), al = gr == tr * 17 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 8) for(var x = 0; x < w; x++){
                var gr = data[off + x], al = gr == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 16) for(var x = 0; x < w; x++){
                var gr = data[off + (x << 1)], al = rs(data, off + (x << i)) == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
        }
    }
    //console.log(Date.now()-time);
    return bf;
};
$653a48f71451847a$var$UPNG.decode = function(buff) {
    var data = new Uint8Array(buff), offset = 8, bin = $653a48f71451847a$var$UPNG._bin, rUs = bin.readUshort, rUi = bin.readUint;
    var out = {
        tabs: {},
        frames: []
    };
    var dd = new Uint8Array(data.length), doff = 0; // put all IDAT data into it
    var fd, foff = 0; // frames
    var mgck = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)if (data[i] != mgck[i]) throw "The input is not a PNG file!";
    while(offset < data.length){
        var len = bin.readUint(data, offset);
        offset += 4;
        var type = bin.readASCII(data, offset, 4);
        offset += 4;
        //console.log(type,len);
        if (type == "IHDR") $653a48f71451847a$var$UPNG.decode._IHDR(data, offset, out);
        else if (type == "IDAT") {
            for(var i = 0; i < len; i++)dd[doff + i] = data[offset + i];
            doff += len;
        } else if (type == "acTL") {
            out.tabs[type] = {
                num_frames: rUi(data, offset),
                num_plays: rUi(data, offset + 4)
            };
            fd = new Uint8Array(data.length);
        } else if (type == "fcTL") {
            if (foff != 0) {
                var fr = out.frames[out.frames.length - 1];
                fr.data = $653a48f71451847a$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
                foff = 0;
            }
            var rct = {
                x: rUi(data, offset + 12),
                y: rUi(data, offset + 16),
                width: rUi(data, offset + 4),
                height: rUi(data, offset + 8)
            };
            var del = rUs(data, offset + 22);
            del = rUs(data, offset + 20) / (del == 0 ? 100 : del);
            var frm = {
                rect: rct,
                delay: Math.round(del * 1000),
                dispose: data[offset + 24],
                blend: data[offset + 25]
            };
            //console.log(frm);
            out.frames.push(frm);
        } else if (type == "fdAT") {
            for(var i = 0; i < len - 4; i++)fd[foff + i] = data[offset + i + 4];
            foff += len - 4;
        } else if (type == "pHYs") out.tabs[type] = [
            bin.readUint(data, offset),
            bin.readUint(data, offset + 4),
            data[offset + 8]
        ];
        else if (type == "cHRM") {
            out.tabs[type] = [];
            for(var i = 0; i < 8; i++)out.tabs[type].push(bin.readUint(data, offset + i * 4));
        } else if (type == "tEXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = bin.nextZero(data, offset);
            var keyw = bin.readASCII(data, offset, nz - offset);
            var text = bin.readASCII(data, nz + 1, offset + len - nz - 1);
            out.tabs[type][keyw] = text;
        } else if (type == "iTXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = 0, off = offset;
            nz = bin.nextZero(data, off);
            var keyw = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            var cflag = data[off], cmeth = data[off + 1];
            off += 2;
            nz = bin.nextZero(data, off);
            var ltag = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            nz = bin.nextZero(data, off);
            var tkeyw = bin.readUTF8(data, off, nz - off);
            off = nz + 1;
            var text = bin.readUTF8(data, off, len - (off - offset));
            out.tabs[type][keyw] = text;
        } else if (type == "PLTE") out.tabs[type] = bin.readBytes(data, offset, len);
        else if (type == "hIST") {
            var pl = out.tabs["PLTE"].length / 3;
            out.tabs[type] = [];
            for(var i = 0; i < pl; i++)out.tabs[type].push(rUs(data, offset + i * 2));
        } else if (type == "tRNS") {
            if (out.ctype == 3) out.tabs[type] = bin.readBytes(data, offset, len);
            else if (out.ctype == 0) out.tabs[type] = rUs(data, offset);
            else if (out.ctype == 2) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
        //else console.log("tRNS for unsupported color type",out.ctype, len);
        } else if (type == "gAMA") out.tabs[type] = bin.readUint(data, offset) / 100000;
        else if (type == "sRGB") out.tabs[type] = data[offset];
        else if (type == "bKGD") {
            if (out.ctype == 0 || out.ctype == 4) out.tabs[type] = [
                rUs(data, offset)
            ];
            else if (out.ctype == 2 || out.ctype == 6) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
            else if (out.ctype == 3) out.tabs[type] = data[offset];
        } else if (type == "IEND") break;
        //else {  log("unknown chunk type", type, len);  }
        offset += len;
        var crc = bin.readUint(data, offset);
        offset += 4;
    }
    if (foff != 0) {
        var fr = out.frames[out.frames.length - 1];
        fr.data = $653a48f71451847a$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
        foff = 0;
    }
    out.data = $653a48f71451847a$var$UPNG.decode._decompress(out, dd, out.width, out.height);
    delete out.compress;
    delete out.interlace;
    delete out.filter;
    return out;
};
$653a48f71451847a$var$UPNG.decode._decompress = function(out, dd, w, h) {
    var time = Date.now();
    var bpp = $653a48f71451847a$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), buff = new Uint8Array((bpl + 1 + out.interlace) * h);
    dd = $653a48f71451847a$var$UPNG.decode._inflate(dd, buff);
    //console.log(dd.length, buff.length);
    //console.log(Date.now()-time);
    var time = Date.now();
    if (out.interlace == 0) dd = $653a48f71451847a$var$UPNG.decode._filterZero(dd, out, 0, w, h);
    else if (out.interlace == 1) dd = $653a48f71451847a$var$UPNG.decode._readInterlace(dd, out);
    //console.log(Date.now()-time);
    return dd;
};
$653a48f71451847a$var$UPNG.decode._inflate = function(data, buff) {
    var out = $653a48f71451847a$var$UPNG["inflateRaw"](new Uint8Array(data.buffer, 2, data.length - 6), buff);
    return out;
};
$653a48f71451847a$var$UPNG.inflateRaw = function() {
    var H = {};
    H.H = {};
    H.H.N = function(N, W) {
        var R = Uint8Array, i = 0, m = 0, J = 0, h = 0, Q = 0, X = 0, u = 0, w = 0, d = 0, v, C;
        if (N[0] == 3 && N[1] == 0) return W ? W : new R(0);
        var V = H.H, n = V.b, A = V.e, l = V.R, M = V.n, I = V.A, e = V.Z, b = V.m, Z = W == null;
        if (Z) W = new R(N.length >>> 2 << 3);
        while(i == 0){
            i = n(N, d, 1);
            m = n(N, d + 1, 2);
            d += 3;
            if (m == 0) {
                if ((d & 7) != 0) d += 8 - (d & 7);
                var D = (d >>> 3) + 4, q = N[D - 4] | N[D - 3] << 8;
                if (Z) W = H.H.W(W, w + q);
                W.set(new R(N.buffer, N.byteOffset + D, q), w);
                d = D + q << 3;
                w += q;
                continue;
            }
            if (Z) W = H.H.W(W, w + 131072);
            if (m == 1) {
                v = b.J;
                C = b.h;
                X = 511;
                u = 31;
            }
            if (m == 2) {
                J = A(N, d, 5) + 257;
                h = A(N, d + 5, 5) + 1;
                Q = A(N, d + 10, 4) + 4;
                d += 14;
                var E = d, j = 1;
                for(var c = 0; c < 38; c += 2){
                    b.Q[c] = 0;
                    b.Q[c + 1] = 0;
                }
                for(var c = 0; c < Q; c++){
                    var K = A(N, d + c * 3, 3);
                    b.Q[(b.X[c] << 1) + 1] = K;
                    if (K > j) j = K;
                }
                d += 3 * Q;
                M(b.Q, j);
                I(b.Q, j, b.u);
                v = b.w;
                C = b.d;
                d = l(b.u, (1 << j) - 1, J + h, N, d, b.v);
                var r = V.V(b.v, 0, J, b.C);
                X = (1 << r) - 1;
                var S = V.V(b.v, J, h, b.D);
                u = (1 << S) - 1;
                M(b.C, r);
                I(b.C, r, v);
                M(b.D, S);
                I(b.D, S, C);
            }
            while(true){
                var T = v[e(N, d) & X];
                d += T & 15;
                var p = T >>> 4;
                if (p >>> 8 == 0) W[w++] = p;
                else if (p == 256) break;
                else {
                    var z = w + p - 254;
                    if (p > 264) {
                        var _ = b.q[p - 257];
                        z = w + (_ >>> 3) + A(N, d, _ & 7);
                        d += _ & 7;
                    }
                    var $ = C[e(N, d) & u];
                    d += $ & 15;
                    var s = $ >>> 4, Y = b.c[s], a = (Y >>> 4) + n(N, d, Y & 15);
                    d += Y & 15;
                    while(w < z){
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                    }
                    w = z;
                }
            }
        }
        return W.length == w ? W : W.slice(0, w);
    };
    H.H.W = function(N, W) {
        var R = N.length;
        if (W <= R) return N;
        var V = new Uint8Array(R << 1);
        V.set(N, 0);
        return V;
    };
    H.H.R = function(N, W, R, V, n, A) {
        var l = H.H.e, M = H.H.Z, I = 0;
        while(I < R){
            var e = N[M(V, n) & W];
            n += e & 15;
            var b = e >>> 4;
            if (b <= 15) {
                A[I] = b;
                I++;
            } else {
                var Z = 0, m = 0;
                if (b == 16) {
                    m = 3 + l(V, n, 2);
                    n += 2;
                    Z = A[I - 1];
                } else if (b == 17) {
                    m = 3 + l(V, n, 3);
                    n += 3;
                } else if (b == 18) {
                    m = 11 + l(V, n, 7);
                    n += 7;
                }
                var J = I + m;
                while(I < J){
                    A[I] = Z;
                    I++;
                }
            }
        }
        return n;
    };
    H.H.V = function(N, W, R, V) {
        var n = 0, A = 0, l = V.length >>> 1;
        while(A < R){
            var M = N[A + W];
            V[A << 1] = 0;
            V[(A << 1) + 1] = M;
            if (M > n) n = M;
            A++;
        }
        while(A < l){
            V[A << 1] = 0;
            V[(A << 1) + 1] = 0;
            A++;
        }
        return n;
    };
    H.H.n = function(N, W) {
        var R = H.H.m, V = N.length, n, A, l, M, I, e = R.j;
        for(var M = 0; M <= W; M++)e[M] = 0;
        for(M = 1; M < V; M += 2)e[N[M]]++;
        var b = R.K;
        n = 0;
        e[0] = 0;
        for(A = 1; A <= W; A++){
            n = n + e[A - 1] << 1;
            b[A] = n;
        }
        for(l = 0; l < V; l += 2){
            I = N[l + 1];
            if (I != 0) {
                N[l] = b[I];
                b[I]++;
            }
        }
    };
    H.H.A = function(N, W, R) {
        var V = N.length, n = H.H.m, A = n.r;
        for(var l = 0; l < V; l += 2)if (N[l + 1] != 0) {
            var M = l >> 1, I = N[l + 1], e = M << 4 | I, b = W - I, Z = N[l] << b, m = Z + (1 << b);
            while(Z != m){
                var J = A[Z] >>> 15 - W;
                R[J] = e;
                Z++;
            }
        }
    };
    H.H.l = function(N, W) {
        var R = H.H.m.r, V = 15 - W;
        for(var n = 0; n < N.length; n += 2){
            var A = N[n] << W - N[n + 1];
            N[n] = R[A] >>> V;
        }
    };
    H.H.M = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
    };
    H.H.I = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
        N[V + 2] |= R >>> 16;
    };
    H.H.e = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.b = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.Z = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7);
    };
    H.H.i = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16 | N[(W >>> 3) + 3] << 24) >>> (W & 7);
    };
    H.H.m = function() {
        var N = Uint16Array, W = Uint32Array;
        return {
            K: new N(16),
            j: new N(16),
            X: [
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ],
            S: [
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                13,
                15,
                17,
                19,
                23,
                27,
                31,
                35,
                43,
                51,
                59,
                67,
                83,
                99,
                115,
                131,
                163,
                195,
                227,
                258,
                999,
                999,
                999
            ],
            T: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                0,
                0,
                0,
                0
            ],
            q: new N(32),
            p: [
                1,
                2,
                3,
                4,
                5,
                7,
                9,
                13,
                17,
                25,
                33,
                49,
                65,
                97,
                129,
                193,
                257,
                385,
                513,
                769,
                1025,
                1537,
                2049,
                3073,
                4097,
                6145,
                8193,
                12289,
                16385,
                24577,
                65535,
                65535
            ],
            z: [
                0,
                0,
                0,
                0,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                5,
                5,
                6,
                6,
                7,
                7,
                8,
                8,
                9,
                9,
                10,
                10,
                11,
                11,
                12,
                12,
                13,
                13,
                0,
                0
            ],
            c: new W(32),
            J: new N(512),
            _: [],
            h: new N(32),
            $: [],
            w: new N(32768),
            C: [],
            v: [],
            d: new N(32768),
            D: [],
            u: new N(512),
            Q: [],
            r: new N(32768),
            s: new W(286),
            Y: new W(30),
            a: new W(19),
            t: new W(15e3),
            k: new N(65536),
            g: new N(32768)
        };
    }();
    (function() {
        var N = H.H.m, W = 32768;
        for(var R = 0; R < W; R++){
            var V = R;
            V = (V & 2863311530) >>> 1 | (V & 1431655765) << 1;
            V = (V & 3435973836) >>> 2 | (V & 858993459) << 2;
            V = (V & 4042322160) >>> 4 | (V & 252645135) << 4;
            V = (V & 4278255360) >>> 8 | (V & 16711935) << 8;
            N.r[R] = (V >>> 16 | V << 16) >>> 17;
        }
        function n(A, l, M) {
            while(l-- != 0)A.push(0, M);
        }
        for(var R = 0; R < 32; R++){
            N.q[R] = N.S[R] << 3 | N.T[R];
            N.c[R] = N.p[R] << 4 | N.z[R];
        }
        n(N._, 144, 8);
        n(N._, 112, 9);
        n(N._, 24, 7);
        n(N._, 8, 8);
        H.H.n(N._, 9);
        H.H.A(N._, 9, N.J);
        H.H.l(N._, 9);
        n(N.$, 32, 5);
        H.H.n(N.$, 5);
        H.H.A(N.$, 5, N.h);
        H.H.l(N.$, 5);
        n(N.Q, 19, 0);
        n(N.C, 286, 0);
        n(N.D, 30, 0);
        n(N.v, 320, 0);
    })();
    return H.H.N;
}();
$653a48f71451847a$var$UPNG.decode._readInterlace = function(data, out) {
    var w = out.width, h = out.height;
    var bpp = $653a48f71451847a$var$UPNG.decode._getBPP(out), cbpp = bpp >> 3, bpl = Math.ceil(w * bpp / 8);
    var img = new Uint8Array(h * bpl);
    var di = 0;
    var starting_row = [
        0,
        0,
        4,
        0,
        2,
        0,
        1
    ];
    var starting_col = [
        0,
        4,
        0,
        2,
        0,
        1,
        0
    ];
    var row_increment = [
        8,
        8,
        8,
        4,
        4,
        2,
        2
    ];
    var col_increment = [
        8,
        8,
        4,
        4,
        2,
        2,
        1
    ];
    var pass = 0;
    while(pass < 7){
        var ri = row_increment[pass], ci = col_increment[pass];
        var sw = 0, sh = 0;
        var cr = starting_row[pass];
        while(cr < h){
            cr += ri;
            sh++;
        }
        var cc = starting_col[pass];
        while(cc < w){
            cc += ci;
            sw++;
        }
        var bpll = Math.ceil(sw * bpp / 8);
        $653a48f71451847a$var$UPNG.decode._filterZero(data, out, di, sw, sh);
        var y = 0, row = starting_row[pass];
        while(row < h){
            var col = starting_col[pass];
            var cdi = di + y * bpll << 3;
            while(col < w){
                if (bpp == 1) {
                    var val = data[cdi >> 3];
                    val = val >> 7 - (cdi & 7) & 1;
                    img[row * bpl + (col >> 3)] |= val << 7 - ((col & 7) << 0);
                }
                if (bpp == 2) {
                    var val = data[cdi >> 3];
                    val = val >> 6 - (cdi & 7) & 3;
                    img[row * bpl + (col >> 2)] |= val << 6 - ((col & 3) << 1);
                }
                if (bpp == 4) {
                    var val = data[cdi >> 3];
                    val = val >> 4 - (cdi & 7) & 15;
                    img[row * bpl + (col >> 1)] |= val << 4 - ((col & 1) << 2);
                }
                if (bpp >= 8) {
                    var ii = row * bpl + col * cbpp;
                    for(var j = 0; j < cbpp; j++)img[ii + j] = data[(cdi >> 3) + j];
                }
                cdi += bpp;
                col += ci;
            }
            y++;
            row += ri;
        }
        if (sw * sh != 0) di += sh * (1 + bpll);
        pass = pass + 1;
    }
    return img;
};
$653a48f71451847a$var$UPNG.decode._getBPP = function(out) {
    var noc = [
        1,
        null,
        3,
        1,
        2,
        null,
        4
    ][out.ctype];
    return noc * out.depth;
};
$653a48f71451847a$var$UPNG.decode._filterZero = function(data, out, off, w, h) {
    var bpp = $653a48f71451847a$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), paeth = $653a48f71451847a$var$UPNG.decode._paeth;
    bpp = Math.ceil(bpp / 8);
    var i = 0, di = 1, type = data[off], x = 0;
    if (type > 1) data[off] = [
        0,
        0,
        1
    ][type - 2];
    if (type == 3) for(x = bpp; x < bpl; x++)data[x + 1] = data[x + 1] + (data[x + 1 - bpp] >>> 1) & 255;
    for(var y = 0; y < h; y++){
        i = off + y * bpl;
        di = i + y + 1;
        type = data[di - 1];
        x = 0;
        if (type == 0) for(; x < bpl; x++)data[i + x] = data[di + x];
        else if (type == 1) {
            for(; x < bpp; x++)data[i + x] = data[di + x];
            for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpp];
        } else if (type == 2) for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpl];
        else if (type == 3) {
            for(; x < bpp; x++)data[i + x] = data[di + x] + (data[i + x - bpl] >>> 1);
            for(; x < bpl; x++)data[i + x] = data[di + x] + (data[i + x - bpl] + data[i + x - bpp] >>> 1);
        } else {
            for(; x < bpp; x++)data[i + x] = data[di + x] + paeth(0, data[i + x - bpl], 0);
            for(; x < bpl; x++)data[i + x] = data[di + x] + paeth(data[i + x - bpp], data[i + x - bpl], data[i + x - bpp - bpl]);
        }
    }
    return data;
};
$653a48f71451847a$var$UPNG.decode._paeth = function(a, b, c) {
    var p = a + b - c, pa = p - a, pb = p - b, pc = p - c;
    if (pa * pa <= pb * pb && pa * pa <= pc * pc) return a;
    else if (pb * pb <= pc * pc) return b;
    return c;
};
$653a48f71451847a$var$UPNG.decode._IHDR = function(data, offset, out) {
    var bin = $653a48f71451847a$var$UPNG._bin;
    out.width = bin.readUint(data, offset);
    offset += 4;
    out.height = bin.readUint(data, offset);
    offset += 4;
    out.depth = data[offset];
    offset++;
    out.ctype = data[offset];
    offset++;
    out.compress = data[offset];
    offset++;
    out.filter = data[offset];
    offset++;
    out.interlace = data[offset];
    offset++;
};
$653a48f71451847a$var$UPNG._bin = {
    nextZero: function(data, p) {
        while(data[p] != 0)p++;
        return p;
    },
    readUshort: function(buff, p) {
        return buff[p] << 8 | buff[p + 1];
    },
    writeUshort: function(buff, p, n) {
        buff[p] = n >> 8 & 255;
        buff[p + 1] = n & 255;
    },
    readUint: function(buff, p) {
        return buff[p] * 16777216 + (buff[p + 1] << 16 | buff[p + 2] << 8 | buff[p + 3]);
    },
    writeUint: function(buff, p, n) {
        buff[p] = n >> 24 & 255;
        buff[p + 1] = n >> 16 & 255;
        buff[p + 2] = n >> 8 & 255;
        buff[p + 3] = n & 255;
    },
    readASCII: function(buff, p, l) {
        var s = "";
        for(var i = 0; i < l; i++)s += String.fromCharCode(buff[p + i]);
        return s;
    },
    writeASCII: function(data, p, s) {
        for(var i = 0; i < s.length; i++)data[p + i] = s.charCodeAt(i);
    },
    readBytes: function(buff, p, l) {
        var arr = [];
        for(var i = 0; i < l; i++)arr.push(buff[p + i]);
        return arr;
    },
    pad: function(n) {
        return n.length < 2 ? "0" + n : n;
    },
    readUTF8: function(buff, p, l) {
        var s = "", ns;
        for(var i = 0; i < l; i++)s += "%" + $653a48f71451847a$var$UPNG._bin.pad(buff[p + i].toString(16));
        try {
            ns = decodeURIComponent(s);
        } catch (e) {
            return $653a48f71451847a$var$UPNG._bin.readASCII(buff, p, l);
        }
        return ns;
    }
};
$653a48f71451847a$var$UPNG._copyTile = function(sb, sw, sh, tb, tw, th, xoff, yoff, mode) {
    var w = Math.min(sw, tw), h = Math.min(sh, th);
    var si = 0, ti = 0;
    for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
        if (xoff >= 0 && yoff >= 0) {
            si = y * sw + x << 2;
            ti = (yoff + y) * tw + xoff + x << 2;
        } else {
            si = (-yoff + y) * sw - xoff + x << 2;
            ti = y * tw + x << 2;
        }
        if (mode == 0) {
            tb[ti] = sb[si];
            tb[ti + 1] = sb[si + 1];
            tb[ti + 2] = sb[si + 2];
            tb[ti + 3] = sb[si + 3];
        } else if (mode == 1) {
            var fa = sb[si + 3] * (1 / 255), fr = sb[si] * fa, fg = sb[si + 1] * fa, fb = sb[si + 2] * fa;
            var ba = tb[ti + 3] * (1 / 255), br = tb[ti] * ba, bg = tb[ti + 1] * ba, bb = tb[ti + 2] * ba;
            var ifa = 1 - fa, oa = fa + ba * ifa, ioa = oa == 0 ? 0 : 1 / oa;
            tb[ti + 3] = 255 * oa;
            tb[ti + 0] = (fr + br * ifa) * ioa;
            tb[ti + 1] = (fg + bg * ifa) * ioa;
            tb[ti + 2] = (fb + bb * ifa) * ioa;
        } else if (mode == 2) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) {
                tb[ti] = 0;
                tb[ti + 1] = 0;
                tb[ti + 2] = 0;
                tb[ti + 3] = 0;
            } else {
                tb[ti] = fr;
                tb[ti + 1] = fg;
                tb[ti + 2] = fb;
                tb[ti + 3] = fa;
            }
        } else if (mode == 3) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) continue;
            //if(fa!=255 && ba!=0) return false;
            if (fa < 220 && ba > 20) return false;
        }
    }
    return true;
};
$653a48f71451847a$var$UPNG.encode = function(bufs, w, h, ps, dels, tabs, forbidPlte) {
    if (ps == null) ps = 0;
    if (forbidPlte == null) forbidPlte = false;
    var nimg = $653a48f71451847a$var$UPNG.encode.compress(bufs, w, h, ps, [
        false,
        false,
        false,
        0,
        forbidPlte
    ]);
    $653a48f71451847a$var$UPNG.encode.compressPNG(nimg, -1);
    return $653a48f71451847a$var$UPNG.encode._main(nimg, w, h, dels, tabs);
};
$653a48f71451847a$var$UPNG.encodeLL = function(bufs, w, h, cc, ac, depth, dels, tabs) {
    var nimg = {
        ctype: 0 + (cc == 1 ? 0 : 2) + (ac == 0 ? 0 : 4),
        depth: depth,
        frames: []
    };
    var time = Date.now();
    var bipp = (cc + ac) * depth, bipl = bipp * w;
    for(var i = 0; i < bufs.length; i++)nimg.frames.push({
        rect: {
            x: 0,
            y: 0,
            width: w,
            height: h
        },
        img: new Uint8Array(bufs[i]),
        blend: 0,
        dispose: 1,
        bpp: Math.ceil(bipp / 8),
        bpl: Math.ceil(bipl / 8)
    });
    $653a48f71451847a$var$UPNG.encode.compressPNG(nimg, 0, true);
    var out = $653a48f71451847a$var$UPNG.encode._main(nimg, w, h, dels, tabs);
    return out;
};
$653a48f71451847a$var$UPNG.encode._main = function(nimg, w, h, dels, tabs) {
    if (tabs == null) tabs = {};
    var crc = $653a48f71451847a$var$UPNG.crc.crc, wUi = $653a48f71451847a$var$UPNG._bin.writeUint, wUs = $653a48f71451847a$var$UPNG._bin.writeUshort, wAs = $653a48f71451847a$var$UPNG._bin.writeASCII;
    var offset = 8, anim = nimg.frames.length > 1, pltAlpha = false;
    var leng = 33 + (anim ? 20 : 0);
    if (tabs["sRGB"] != null) leng += 13;
    if (tabs["pHYs"] != null) leng += 21;
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        for(var i = 0; i < dl; i++)if (nimg.plte[i] >>> 24 != 255) pltAlpha = true;
        leng += 8 + dl * 3 + 4 + (pltAlpha ? 8 + dl * 1 + 4 : 0);
    }
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) leng += 38;
        leng += fr.cimg.length + 12;
        if (j != 0) leng += 4;
    }
    leng += 12;
    var data = new Uint8Array(leng);
    var wr = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)data[i] = wr[i];
    wUi(data, offset, 13);
    offset += 4;
    wAs(data, offset, "IHDR");
    offset += 4;
    wUi(data, offset, w);
    offset += 4;
    wUi(data, offset, h);
    offset += 4;
    data[offset] = nimg.depth;
    offset++; // depth
    data[offset] = nimg.ctype;
    offset++; // ctype
    data[offset] = 0;
    offset++; // compress
    data[offset] = 0;
    offset++; // filter
    data[offset] = 0;
    offset++; // interlace
    wUi(data, offset, crc(data, offset - 17, 17));
    offset += 4; // crc
    // 13 bytes to say, that it is sRGB
    if (tabs["sRGB"] != null) {
        wUi(data, offset, 1);
        offset += 4;
        wAs(data, offset, "sRGB");
        offset += 4;
        data[offset] = tabs["sRGB"];
        offset++;
        wUi(data, offset, crc(data, offset - 5, 5));
        offset += 4; // crc
    }
    if (tabs["pHYs"] != null) {
        wUi(data, offset, 9);
        offset += 4;
        wAs(data, offset, "pHYs");
        offset += 4;
        wUi(data, offset, tabs["pHYs"][0]);
        offset += 4;
        wUi(data, offset, tabs["pHYs"][1]);
        offset += 4;
        data[offset] = tabs["pHYs"][2];
        offset++;
        wUi(data, offset, crc(data, offset - 13, 13));
        offset += 4; // crc
    }
    if (anim) {
        wUi(data, offset, 8);
        offset += 4;
        wAs(data, offset, "acTL");
        offset += 4;
        wUi(data, offset, nimg.frames.length);
        offset += 4;
        wUi(data, offset, tabs["loop"] != null ? tabs["loop"] : 0);
        offset += 4;
        wUi(data, offset, crc(data, offset - 12, 12));
        offset += 4; // crc
    }
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        wUi(data, offset, dl * 3);
        offset += 4;
        wAs(data, offset, "PLTE");
        offset += 4;
        for(var i = 0; i < dl; i++){
            var ti = i * 3, c = nimg.plte[i], r = c & 255, g = c >>> 8 & 255, b = c >>> 16 & 255;
            data[offset + ti + 0] = r;
            data[offset + ti + 1] = g;
            data[offset + ti + 2] = b;
        }
        offset += dl * 3;
        wUi(data, offset, crc(data, offset - dl * 3 - 4, dl * 3 + 4));
        offset += 4; // crc
        if (pltAlpha) {
            wUi(data, offset, dl);
            offset += 4;
            wAs(data, offset, "tRNS");
            offset += 4;
            for(var i = 0; i < dl; i++)data[offset + i] = nimg.plte[i] >>> 24 & 255;
            offset += dl;
            wUi(data, offset, crc(data, offset - dl - 4, dl + 4));
            offset += 4; // crc
        }
    }
    var fi = 0;
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) {
            wUi(data, offset, 26);
            offset += 4;
            wAs(data, offset, "fcTL");
            offset += 4;
            wUi(data, offset, fi++);
            offset += 4;
            wUi(data, offset, fr.rect.width);
            offset += 4;
            wUi(data, offset, fr.rect.height);
            offset += 4;
            wUi(data, offset, fr.rect.x);
            offset += 4;
            wUi(data, offset, fr.rect.y);
            offset += 4;
            wUs(data, offset, dels[j]);
            offset += 2;
            wUs(data, offset, 1000);
            offset += 2;
            data[offset] = fr.dispose;
            offset++; // dispose
            data[offset] = fr.blend;
            offset++; // blend
            wUi(data, offset, crc(data, offset - 30, 30));
            offset += 4; // crc
        }
        var imgd = fr.cimg, dl = imgd.length;
        wUi(data, offset, dl + (j == 0 ? 0 : 4));
        offset += 4;
        var ioff = offset;
        wAs(data, offset, j == 0 ? "IDAT" : "fdAT");
        offset += 4;
        if (j != 0) {
            wUi(data, offset, fi++);
            offset += 4;
        }
        data.set(imgd, offset);
        offset += dl;
        wUi(data, offset, crc(data, ioff, offset - ioff));
        offset += 4; // crc
    }
    wUi(data, offset, 0);
    offset += 4;
    wAs(data, offset, "IEND");
    offset += 4;
    wUi(data, offset, crc(data, offset - 4, 4));
    offset += 4; // crc
    return data.buffer;
};
$653a48f71451847a$var$UPNG.encode.compressPNG = function(out, filter, levelZero) {
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i], nw = frm.rect.width, nh = frm.rect.height;
        var fdata = new Uint8Array(nh * frm.bpl + nh);
        frm.cimg = $653a48f71451847a$var$UPNG.encode._filterZero(frm.img, nh, frm.bpp, frm.bpl, fdata, filter, levelZero);
    }
};
$653a48f71451847a$var$UPNG.encode.compress = function(bufs, w, h, ps, prms) {
    //var time = Date.now();
    var onlyBlend = prms[0], evenCrd = prms[1], forbidPrev = prms[2], minBits = prms[3], forbidPlte = prms[4];
    var ctype = 6, depth = 8, alphaAnd = 255;
    for(var j = 0; j < bufs.length; j++){
        var img = new Uint8Array(bufs[j]), ilen = img.length;
        for(var i = 0; i < ilen; i += 4)alphaAnd &= img[i + 3];
    }
    var gotAlpha = alphaAnd != 255;
    //console.log("alpha check", Date.now()-time);  time = Date.now();
    //var brute = gotAlpha && forGIF;		// brute : frames can only be copied, not "blended"
    var frms = $653a48f71451847a$var$UPNG.encode.framize(bufs, w, h, onlyBlend, evenCrd, forbidPrev);
    //console.log("framize", Date.now()-time);  time = Date.now();
    var cmap = {}, plte = [], inds = [];
    if (ps != 0) {
        var nbufs = [];
        for(var i = 0; i < frms.length; i++)nbufs.push(frms[i].img.buffer);
        var abuf = $653a48f71451847a$var$UPNG.encode.concatRGBA(nbufs), qres = $653a48f71451847a$var$UPNG.quantize(abuf, ps);
        var cof = 0, bb = new Uint8Array(qres.abuf);
        for(var i = 0; i < frms.length; i++){
            var ti = frms[i].img, bln = ti.length;
            inds.push(new Uint8Array(qres.inds.buffer, cof >> 2, bln >> 2));
            for(var j = 0; j < bln; j += 4){
                ti[j] = bb[cof + j];
                ti[j + 1] = bb[cof + j + 1];
                ti[j + 2] = bb[cof + j + 2];
                ti[j + 3] = bb[cof + j + 3];
            }
            cof += bln;
        }
        for(var i = 0; i < qres.plte.length; i++)plte.push(qres.plte[i].est.rgba);
    //console.log("quantize", Date.now()-time);  time = Date.now();
    } else // what if ps==0, but there are <=256 colors?  we still need to detect, if the palette could be used
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], img32 = new Uint32Array(frm.img.buffer), nw = frm.rect.width, ilen = img32.length;
        var ind = new Uint8Array(ilen);
        inds.push(ind);
        for(var i = 0; i < ilen; i++){
            var c = img32[i];
            if (i != 0 && c == img32[i - 1]) ind[i] = ind[i - 1];
            else if (i > nw && c == img32[i - nw]) ind[i] = ind[i - nw];
            else {
                var cmc = cmap[c];
                if (cmc == null) {
                    cmap[c] = cmc = plte.length;
                    plte.push(c);
                    if (plte.length >= 300) break;
                }
                ind[i] = cmc;
            }
        }
    }
    var cc = plte.length; //console.log("colors:",cc);
    if (cc <= 256 && forbidPlte == false) {
        if (cc <= 2) depth = 1;
        else if (cc <= 4) depth = 2;
        else if (cc <= 16) depth = 4;
        else depth = 8;
        depth = Math.max(depth, minBits);
    }
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], nx = frm.rect.x, ny = frm.rect.y, nw = frm.rect.width, nh = frm.rect.height;
        var cimg = frm.img, cimg32 = new Uint32Array(cimg.buffer);
        var bpl = 4 * nw, bpp = 4;
        if (cc <= 256 && forbidPlte == false) {
            bpl = Math.ceil(depth * nw / 8);
            var nimg = new Uint8Array(bpl * nh);
            var inj = inds[j];
            for(var y = 0; y < nh; y++){
                var i = y * bpl, ii = y * nw;
                if (depth == 8) for(var x = 0; x < nw; x++)nimg[i + x] = inj[ii + x];
                else if (depth == 4) for(var x = 0; x < nw; x++)nimg[i + (x >> 1)] |= inj[ii + x] << 4 - (x & 1) * 4;
                else if (depth == 2) for(var x = 0; x < nw; x++)nimg[i + (x >> 2)] |= inj[ii + x] << 6 - (x & 3) * 2;
                else if (depth == 1) for(var x = 0; x < nw; x++)nimg[i + (x >> 3)] |= inj[ii + x] << 7 - (x & 7) * 1;
            }
            cimg = nimg;
            ctype = 3;
            bpp = 1;
        } else if (gotAlpha == false && frms.length == 1) {
            var nimg = new Uint8Array(nw * nh * 3), area = nw * nh;
            for(var i = 0; i < area; i++){
                var ti = i * 3, qi = i * 4;
                nimg[ti] = cimg[qi];
                nimg[ti + 1] = cimg[qi + 1];
                nimg[ti + 2] = cimg[qi + 2];
            }
            cimg = nimg;
            ctype = 2;
            bpp = 3;
            bpl = 3 * nw;
        }
        frm.img = cimg;
        frm.bpl = bpl;
        frm.bpp = bpp;
    }
    //console.log("colors => palette indices", Date.now()-time);  time = Date.now();
    return {
        ctype: ctype,
        depth: depth,
        plte: plte,
        frames: frms
    };
};
$653a48f71451847a$var$UPNG.encode.framize = function(bufs, w, h, alwaysBlend, evenCrd, forbidPrev) {
    /*  DISPOSE
	    - 0 : no change
		- 1 : clear to transparent
		- 2 : retstore to content before rendering (previous frame disposed)
		BLEND
		- 0 : replace
		- 1 : blend
	*/ var frms = [];
    for(var j = 0; j < bufs.length; j++){
        var cimg = new Uint8Array(bufs[j]), cimg32 = new Uint32Array(cimg.buffer);
        var nimg;
        var nx = 0, ny = 0, nw = w, nh = h, blend = alwaysBlend ? 1 : 0;
        if (j != 0) {
            var tlim = forbidPrev || alwaysBlend || j == 1 || frms[j - 2].dispose != 0 ? 1 : 2, tstp = 0, tarea = 1e9;
            for(var it = 0; it < tlim; it++){
                var pimg = new Uint8Array(bufs[j - 1 - it]), p32 = new Uint32Array(bufs[j - 1 - it]);
                var mix = w, miy = h, max = -1, may = -1;
                for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
                    var i = y * w + x;
                    if (cimg32[i] != p32[i]) {
                        if (x < mix) mix = x;
                        if (x > max) max = x;
                        if (y < miy) miy = y;
                        if (y > may) may = y;
                    }
                }
                if (max == -1) mix = miy = max = may = 0;
                if (evenCrd) {
                    if ((mix & 1) == 1) mix--;
                    if ((miy & 1) == 1) miy--;
                }
                var sarea = (max - mix + 1) * (may - miy + 1);
                if (sarea < tarea) {
                    tarea = sarea;
                    tstp = it;
                    nx = mix;
                    ny = miy;
                    nw = max - mix + 1;
                    nh = may - miy + 1;
                }
            }
            // alwaysBlend: pokud zjistím, že blendit nelze, nastavím předchozímu snímku dispose=1. Zajistím, aby obsahoval můj obdélník.
            var pimg = new Uint8Array(bufs[j - 1 - tstp]);
            if (tstp == 1) frms[j - 1].dispose = 2;
            nimg = new Uint8Array(nw * nh * 4);
            $653a48f71451847a$var$UPNG._copyTile(pimg, w, h, nimg, nw, nh, -nx, -ny, 0);
            blend = $653a48f71451847a$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 3) ? 1 : 0;
            if (blend == 1) $653a48f71451847a$var$UPNG.encode._prepareDiff(cimg, w, h, nimg, {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            });
            else $653a48f71451847a$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 0);
        //UPNG._copyTile(cimg,w,h, nimg,nw,nh, -nx,-ny, blend==1?2:0);
        } else nimg = cimg.slice(0); // img may be rewritten further ... don't rewrite input
        frms.push({
            rect: {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            },
            img: nimg,
            blend: blend,
            dispose: 0
        });
    }
    if (alwaysBlend) for(var j = 0; j < frms.length; j++){
        var frm = frms[j];
        if (frm.blend == 1) continue;
        var r0 = frm.rect, r1 = frms[j - 1].rect;
        var miX = Math.min(r0.x, r1.x), miY = Math.min(r0.y, r1.y);
        var maX = Math.max(r0.x + r0.width, r1.x + r1.width), maY = Math.max(r0.y + r0.height, r1.y + r1.height);
        var r = {
            x: miX,
            y: miY,
            width: maX - miX,
            height: maY - miY
        };
        frms[j - 1].dispose = 1;
        if (j - 1 != 0) $653a48f71451847a$var$UPNG.encode._updateFrame(bufs, w, h, frms, j - 1, r, evenCrd);
        $653a48f71451847a$var$UPNG.encode._updateFrame(bufs, w, h, frms, j, r, evenCrd);
    }
    var area = 0;
    if (bufs.length != 1) for(var i = 0; i < frms.length; i++){
        var frm = frms[i];
        area += frm.rect.width * frm.rect.height;
    //if(i==0 || frm.blend!=1) continue;
    //var ob = new Uint8Array(
    //console.log(frm.blend, frm.dispose, frm.rect);
    }
    //if(area!=0) console.log(area);
    return frms;
};
$653a48f71451847a$var$UPNG.encode._updateFrame = function(bufs, w, h, frms, i, r, evenCrd) {
    var U8 = Uint8Array, U32 = Uint32Array;
    var pimg = new U8(bufs[i - 1]), pimg32 = new U32(bufs[i - 1]), nimg = i + 1 < bufs.length ? new U8(bufs[i + 1]) : null;
    var cimg = new U8(bufs[i]), cimg32 = new U32(cimg.buffer);
    var mix = w, miy = h, max = -1, may = -1;
    for(var y = 0; y < r.height; y++)for(var x = 0; x < r.width; x++){
        var cx = r.x + x, cy = r.y + y;
        var j = cy * w + cx, cc = cimg32[j];
        // no need to draw transparency, or to dispose it. Or, if writing the same color and the next one does not need transparency.
        if (cc == 0 || frms[i - 1].dispose == 0 && pimg32[j] == cc && (nimg == null || nimg[j * 4 + 3] != 0)) ;
        else {
            if (cx < mix) mix = cx;
            if (cx > max) max = cx;
            if (cy < miy) miy = cy;
            if (cy > may) may = cy;
        }
    }
    if (max == -1) mix = miy = max = may = 0;
    if (evenCrd) {
        if ((mix & 1) == 1) mix--;
        if ((miy & 1) == 1) miy--;
    }
    r = {
        x: mix,
        y: miy,
        width: max - mix + 1,
        height: may - miy + 1
    };
    var fr = frms[i];
    fr.rect = r;
    fr.blend = 1;
    fr.img = new Uint8Array(r.width * r.height * 4);
    if (frms[i - 1].dispose == 0) {
        $653a48f71451847a$var$UPNG._copyTile(pimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
        $653a48f71451847a$var$UPNG.encode._prepareDiff(cimg, w, h, fr.img, r);
    //UPNG._copyTile(cimg,w,h, fr.img,r.width,r.height, -r.x,-r.y, 2);
    } else $653a48f71451847a$var$UPNG._copyTile(cimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
};
$653a48f71451847a$var$UPNG.encode._prepareDiff = function(cimg, w, h, nimg, rec) {
    $653a48f71451847a$var$UPNG._copyTile(cimg, w, h, nimg, rec.width, rec.height, -rec.x, -rec.y, 2);
/*
	var n32 = new Uint32Array(nimg.buffer);
	var og = new Uint8Array(rec.width*rec.height*4), o32 = new Uint32Array(og.buffer);
	UPNG._copyTile(cimg,w,h, og,rec.width,rec.height, -rec.x,-rec.y, 0);
	for(var i=4; i<nimg.length; i+=4) {
		if(nimg[i-1]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)-1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}
	for(var i=nimg.length-8; i>0; i-=4) {
		if(nimg[i+7]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)+1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}*/ };
$653a48f71451847a$var$UPNG.encode._filterZero = function(img, h, bpp, bpl, data, filter, levelZero) {
    var fls = [], ftry = [
        0,
        1,
        2,
        3,
        4
    ];
    if (filter != -1) ftry = [
        filter
    ];
    else if (h * bpl > 500000 || bpp == 1) ftry = [
        0
    ];
    var opts;
    if (levelZero) opts = {
        level: 0
    };
    var CMPR = levelZero && UZIP != null ? UZIP : (0, (/*@__PURE__*/$parcel$interopDefault($ckBc7)));
    for(var i = 0; i < ftry.length; i++){
        for(var y = 0; y < h; y++)$653a48f71451847a$var$UPNG.encode._filterLine(data, img, y, bpl, bpp, ftry[i]);
        //var nimg = new Uint8Array(data.length);
        //var sz = UZIP.F.deflate(data, nimg);  fls.push(nimg.slice(0,sz));
        //var dfl = pako["deflate"](data), dl=dfl.length-4;
        //var crc = (dfl[dl+3]<<24)|(dfl[dl+2]<<16)|(dfl[dl+1]<<8)|(dfl[dl+0]<<0);
        //console.log(crc, UZIP.adler(data,2,data.length-6));
        fls.push(CMPR["deflate"](data, opts));
    }
    var ti, tsize = 1e9;
    for(var i = 0; i < fls.length; i++)if (fls[i].length < tsize) {
        ti = i;
        tsize = fls[i].length;
    }
    return fls[ti];
};
$653a48f71451847a$var$UPNG.encode._filterLine = function(data, img, y, bpl, bpp, type) {
    var i = y * bpl, di = i + y, paeth = $653a48f71451847a$var$UPNG.decode._paeth;
    data[di] = type;
    di++;
    if (type == 0) {
        if (bpl < 500) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x];
        else data.set(new Uint8Array(img.buffer, i, bpl), di);
    } else if (type == 1) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - img[i + x - bpp] + 256 & 255;
    } else if (y == 0) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        if (type == 2) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x];
        if (type == 3) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - (img[i + x - bpp] >> 1) + 256 & 255;
        if (type == 4) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - paeth(img[i + x - bpp], 0, 0) + 256 & 255;
    } else {
        if (type == 2) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x] + 256 - img[i + x - bpl] & 255;
        if (type == 3) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] >> 1) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] + img[i + x - bpp] >> 1) & 255;
        }
        if (type == 4) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - paeth(0, img[i + x - bpl], 0) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - paeth(img[i + x - bpp], img[i + x - bpl], img[i + x - bpp - bpl]) & 255;
        }
    }
};
$653a48f71451847a$var$UPNG.crc = {
    table: function() {
        var tab = new Uint32Array(256);
        for(var n = 0; n < 256; n++){
            var c = n;
            for(var k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
            else c = c >>> 1;
            tab[n] = c;
        }
        return tab;
    }(),
    update: function(c, buf, off, len) {
        for(var i = 0; i < len; i++)c = $653a48f71451847a$var$UPNG.crc.table[(c ^ buf[off + i]) & 0xff] ^ c >>> 8;
        return c;
    },
    crc: function(b, o, l) {
        return $653a48f71451847a$var$UPNG.crc.update(0xffffffff, b, o, l) ^ 0xffffffff;
    }
};
$653a48f71451847a$var$UPNG.quantize = function(abuf, ps) {
    var oimg = new Uint8Array(abuf), nimg = oimg.slice(0), nimg32 = new Uint32Array(nimg.buffer);
    var KD = $653a48f71451847a$var$UPNG.quantize.getKDtree(nimg, ps);
    var root = KD[0], leafs = KD[1];
    var planeDst = $653a48f71451847a$var$UPNG.quantize.planeDst;
    var sb = oimg, tb = nimg32, len = sb.length;
    var inds = new Uint8Array(oimg.length >> 2);
    for(var i = 0; i < len; i += 4){
        var r = sb[i] * (1 / 255), g = sb[i + 1] * (1 / 255), b = sb[i + 2] * (1 / 255), a = sb[i + 3] * (1 / 255);
        //  exact, but too slow :(
        var nd = $653a48f71451847a$var$UPNG.quantize.getNearest(root, r, g, b, a);
        //var nd = root;
        //while(nd.left) nd = (planeDst(nd.est,r,g,b,a)<=0) ? nd.left : nd.right;
        inds[i >> 2] = nd.ind;
        tb[i >> 2] = nd.est.rgba;
    }
    return {
        abuf: nimg.buffer,
        inds: inds,
        plte: leafs
    };
};
$653a48f71451847a$var$UPNG.quantize.getKDtree = function(nimg, ps, err) {
    if (err == null) err = 0.0001;
    var nimg32 = new Uint32Array(nimg.buffer);
    var root = {
        i0: 0,
        i1: nimg.length,
        bst: null,
        est: null,
        tdst: 0,
        left: null,
        right: null
    }; // basic statistic, extra statistic
    root.bst = $653a48f71451847a$var$UPNG.quantize.stats(nimg, root.i0, root.i1);
    root.est = $653a48f71451847a$var$UPNG.quantize.estats(root.bst);
    var leafs = [
        root
    ];
    while(leafs.length < ps){
        var maxL = 0, mi = 0;
        for(var i = 0; i < leafs.length; i++)if (leafs[i].est.L > maxL) {
            maxL = leafs[i].est.L;
            mi = i;
        }
        if (maxL < err) break;
        var node = leafs[mi];
        var s0 = $653a48f71451847a$var$UPNG.quantize.splitPixels(nimg, nimg32, node.i0, node.i1, node.est.e, node.est.eMq255);
        var s0wrong = node.i0 >= s0 || node.i1 <= s0;
        //console.log(maxL, leafs.length, mi);
        if (s0wrong) {
            node.est.L = 0;
            continue;
        }
        var ln = {
            i0: node.i0,
            i1: s0,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        ln.bst = $653a48f71451847a$var$UPNG.quantize.stats(nimg, ln.i0, ln.i1);
        ln.est = $653a48f71451847a$var$UPNG.quantize.estats(ln.bst);
        var rn = {
            i0: s0,
            i1: node.i1,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        rn.bst = {
            R: [],
            m: [],
            N: node.bst.N - ln.bst.N
        };
        for(var i = 0; i < 16; i++)rn.bst.R[i] = node.bst.R[i] - ln.bst.R[i];
        for(var i = 0; i < 4; i++)rn.bst.m[i] = node.bst.m[i] - ln.bst.m[i];
        rn.est = $653a48f71451847a$var$UPNG.quantize.estats(rn.bst);
        node.left = ln;
        node.right = rn;
        leafs[mi] = ln;
        leafs.push(rn);
    }
    leafs.sort(function(a, b) {
        return b.bst.N - a.bst.N;
    });
    for(var i = 0; i < leafs.length; i++)leafs[i].ind = i;
    return [
        root,
        leafs
    ];
};
$653a48f71451847a$var$UPNG.quantize.getNearest = function(nd, r, g, b, a) {
    if (nd.left == null) {
        nd.tdst = $653a48f71451847a$var$UPNG.quantize.dist(nd.est.q, r, g, b, a);
        return nd;
    }
    var planeDst = $653a48f71451847a$var$UPNG.quantize.planeDst(nd.est, r, g, b, a);
    var node0 = nd.left, node1 = nd.right;
    if (planeDst > 0) {
        node0 = nd.right;
        node1 = nd.left;
    }
    var ln = $653a48f71451847a$var$UPNG.quantize.getNearest(node0, r, g, b, a);
    if (ln.tdst <= planeDst * planeDst) return ln;
    var rn = $653a48f71451847a$var$UPNG.quantize.getNearest(node1, r, g, b, a);
    return rn.tdst < ln.tdst ? rn : ln;
};
$653a48f71451847a$var$UPNG.quantize.planeDst = function(est, r, g, b, a) {
    var e = est.e;
    return e[0] * r + e[1] * g + e[2] * b + e[3] * a - est.eMq;
};
$653a48f71451847a$var$UPNG.quantize.dist = function(q, r, g, b, a) {
    var d0 = r - q[0], d1 = g - q[1], d2 = b - q[2], d3 = a - q[3];
    return d0 * d0 + d1 * d1 + d2 * d2 + d3 * d3;
};
$653a48f71451847a$var$UPNG.quantize.splitPixels = function(nimg, nimg32, i0, i1, e, eMq) {
    var vecDot = $653a48f71451847a$var$UPNG.quantize.vecDot;
    i1 -= 4;
    var shfs = 0;
    while(i0 < i1){
        while(vecDot(nimg, i0, e) <= eMq)i0 += 4;
        while(vecDot(nimg, i1, e) > eMq)i1 -= 4;
        if (i0 >= i1) break;
        var t = nimg32[i0 >> 2];
        nimg32[i0 >> 2] = nimg32[i1 >> 2];
        nimg32[i1 >> 2] = t;
        i0 += 4;
        i1 -= 4;
    }
    while(vecDot(nimg, i0, e) > eMq)i0 -= 4;
    return i0 + 4;
};
$653a48f71451847a$var$UPNG.quantize.vecDot = function(nimg, i, e) {
    return nimg[i] * e[0] + nimg[i + 1] * e[1] + nimg[i + 2] * e[2] + nimg[i + 3] * e[3];
};
$653a48f71451847a$var$UPNG.quantize.stats = function(nimg, i0, i1) {
    var R = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var m = [
        0,
        0,
        0,
        0
    ];
    var N = i1 - i0 >> 2;
    for(var i = i0; i < i1; i += 4){
        var r = nimg[i] * (1 / 255), g = nimg[i + 1] * (1 / 255), b = nimg[i + 2] * (1 / 255), a = nimg[i + 3] * (1 / 255);
        //var r = nimg[i], g = nimg[i+1], b = nimg[i+2], a = nimg[i+3];
        m[0] += r;
        m[1] += g;
        m[2] += b;
        m[3] += a;
        R[0] += r * r;
        R[1] += r * g;
        R[2] += r * b;
        R[3] += r * a;
        R[5] += g * g;
        R[6] += g * b;
        R[7] += g * a;
        R[10] += b * b;
        R[11] += b * a;
        R[15] += a * a;
    }
    R[4] = R[1];
    R[8] = R[2];
    R[9] = R[6];
    R[12] = R[3];
    R[13] = R[7];
    R[14] = R[11];
    return {
        R: R,
        m: m,
        N: N
    };
};
$653a48f71451847a$var$UPNG.quantize.estats = function(stats) {
    var R = stats.R, m = stats.m, N = stats.N;
    // when all samples are equal, but N is large (millions), the Rj can be non-zero ( 0.0003.... - precission error)
    var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], iN = N == 0 ? 0 : 1 / N;
    var Rj = [
        R[0] - m0 * m0 * iN,
        R[1] - m0 * m1 * iN,
        R[2] - m0 * m2 * iN,
        R[3] - m0 * m3 * iN,
        R[4] - m1 * m0 * iN,
        R[5] - m1 * m1 * iN,
        R[6] - m1 * m2 * iN,
        R[7] - m1 * m3 * iN,
        R[8] - m2 * m0 * iN,
        R[9] - m2 * m1 * iN,
        R[10] - m2 * m2 * iN,
        R[11] - m2 * m3 * iN,
        R[12] - m3 * m0 * iN,
        R[13] - m3 * m1 * iN,
        R[14] - m3 * m2 * iN,
        R[15] - m3 * m3 * iN
    ];
    var A = Rj, M = $653a48f71451847a$var$UPNG.M4;
    var b = [
        0.5,
        0.5,
        0.5,
        0.5
    ], mi = 0, tmi = 0;
    if (N != 0) for(var i = 0; i < 10; i++){
        b = M.multVec(A, b);
        tmi = Math.sqrt(M.dot(b, b));
        b = M.sml(1 / tmi, b);
        if (Math.abs(tmi - mi) < 1e-9) break;
        mi = tmi;
    }
    //b = [0,0,1,0];  mi=N;
    var q = [
        m0 * iN,
        m1 * iN,
        m2 * iN,
        m3 * iN
    ];
    var eMq255 = M.dot(M.sml(255, q), b);
    return {
        Cov: Rj,
        q: q,
        e: b,
        L: mi,
        eMq255: eMq255,
        eMq: M.dot(b, q),
        rgba: (Math.round(255 * q[3]) << 24 | Math.round(255 * q[2]) << 16 | Math.round(255 * q[1]) << 8 | Math.round(255 * q[0]) << 0) >>> 0
    };
};
$653a48f71451847a$var$UPNG.M4 = {
    multVec: function(m, v) {
        return [
            m[0] * v[0] + m[1] * v[1] + m[2] * v[2] + m[3] * v[3],
            m[4] * v[0] + m[5] * v[1] + m[6] * v[2] + m[7] * v[3],
            m[8] * v[0] + m[9] * v[1] + m[10] * v[2] + m[11] * v[3],
            m[12] * v[0] + m[13] * v[1] + m[14] * v[2] + m[15] * v[3]
        ];
    },
    dot: function(x, y) {
        return x[0] * y[0] + x[1] * y[1] + x[2] * y[2] + x[3] * y[3];
    },
    sml: function(a, y) {
        return [
            a * y[0],
            a * y[1],
            a * y[2],
            a * y[3]
        ];
    }
};
$653a48f71451847a$var$UPNG.encode.concatRGBA = function(bufs) {
    var tlen = 0;
    for(var i = 0; i < bufs.length; i++)tlen += bufs[i].byteLength;
    var nimg = new Uint8Array(tlen), noff = 0;
    for(var i = 0; i < bufs.length; i++){
        var img = new Uint8Array(bufs[i]), il = img.length;
        for(var j = 0; j < il; j += 4){
            var r = img[j], g = img[j + 1], b = img[j + 2], a = img[j + 3];
            if (a == 0) r = g = b = 0;
            nimg[noff + j] = r;
            nimg[noff + j + 1] = g;
            nimg[noff + j + 2] = b;
            nimg[noff + j + 3] = a;
        }
        noff += il;
    }
    return nimg.buffer;
};
var $653a48f71451847a$export$2e2bcd8739ae039 = $653a48f71451847a$var$UPNG;


var $d93e596e6b8d36ea$var$getImageType = function(ctype) {
    if (ctype === 0) return $d93e596e6b8d36ea$export$3ff975e8f63e458c.Greyscale;
    if (ctype === 2) return $d93e596e6b8d36ea$export$3ff975e8f63e458c.Truecolour;
    if (ctype === 3) return $d93e596e6b8d36ea$export$3ff975e8f63e458c.IndexedColour;
    if (ctype === 4) return $d93e596e6b8d36ea$export$3ff975e8f63e458c.GreyscaleWithAlpha;
    if (ctype === 6) return $d93e596e6b8d36ea$export$3ff975e8f63e458c.TruecolourWithAlpha;
    throw new Error("Unknown color type: " + ctype);
};
var $d93e596e6b8d36ea$var$splitAlphaChannel = function(rgbaChannel) {
    var pixelCount = Math.floor(rgbaChannel.length / 4);
    var rgbChannel = new Uint8Array(pixelCount * 3);
    var alphaChannel = new Uint8Array(pixelCount * 1);
    var rgbaOffset = 0;
    var rgbOffset = 0;
    var alphaOffset = 0;
    while(rgbaOffset < rgbaChannel.length){
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        alphaChannel[alphaOffset++] = rgbaChannel[rgbaOffset++];
    }
    return {
        rgbChannel: rgbChannel,
        alphaChannel: alphaChannel
    };
};
var $d93e596e6b8d36ea$export$3ff975e8f63e458c;
(function(PngType) {
    PngType["Greyscale"] = "Greyscale";
    PngType["Truecolour"] = "Truecolour";
    PngType["IndexedColour"] = "IndexedColour";
    PngType["GreyscaleWithAlpha"] = "GreyscaleWithAlpha";
    PngType["TruecolourWithAlpha"] = "TruecolourWithAlpha";
})($d93e596e6b8d36ea$export$3ff975e8f63e458c || ($d93e596e6b8d36ea$export$3ff975e8f63e458c = {}));
var $d93e596e6b8d36ea$export$1f536085c24cc947 = /** @class */ function() {
    function PNG(pngData) {
        var upng = (0, $653a48f71451847a$export$2e2bcd8739ae039).decode(pngData);
        var frames = (0, $653a48f71451847a$export$2e2bcd8739ae039).toRGBA8(upng);
        if (frames.length > 1) throw new Error("Animated PNGs are not supported");
        var frame = new Uint8Array(frames[0]);
        var _a = $d93e596e6b8d36ea$var$splitAlphaChannel(frame), rgbChannel = _a.rgbChannel, alphaChannel = _a.alphaChannel;
        this.rgbChannel = rgbChannel;
        var hasAlphaValues = alphaChannel.some(function(a) {
            return a < 255;
        });
        if (hasAlphaValues) this.alphaChannel = alphaChannel;
        this.type = $d93e596e6b8d36ea$var$getImageType(upng.ctype);
        this.width = upng.width;
        this.height = upng.height;
        this.bitsPerComponent = 8;
    }
    PNG.load = function(pngData) {
        return new PNG(pngData);
    };
    return PNG;
}();


/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/png.coffee
 */ var $0a39e685a1b53e0a$var$PngEmbedder = /** @class */ function() {
    function PngEmbedder(png) {
        this.image = png;
        this.bitsPerComponent = png.bitsPerComponent;
        this.width = png.width;
        this.height = png.height;
        this.colorSpace = "DeviceRGB";
    }
    PngEmbedder.for = function(imageData) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var png;
            return (0, $59LZ8.__generator)(this, function(_a) {
                png = (0, $d93e596e6b8d36ea$export$1f536085c24cc947).load(imageData);
                return [
                    2 /*return*/ ,
                    new PngEmbedder(png)
                ];
            });
        });
    };
    PngEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var SMask, xObject;
            return (0, $59LZ8.__generator)(this, function(_a) {
                SMask = this.embedAlphaChannel(context);
                xObject = context.flateStream(this.image.rgbChannel, {
                    Type: "XObject",
                    Subtype: "Image",
                    BitsPerComponent: this.image.bitsPerComponent,
                    Width: this.image.width,
                    Height: this.image.height,
                    ColorSpace: this.colorSpace,
                    SMask: SMask
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PngEmbedder.prototype.embedAlphaChannel = function(context) {
        if (!this.image.alphaChannel) return undefined;
        var xObject = context.flateStream(this.image.alphaChannel, {
            Type: "XObject",
            Subtype: "Image",
            Height: this.image.height,
            Width: this.image.width,
            BitsPerComponent: this.image.bitsPerComponent,
            ColorSpace: "DeviceGray",
            Decode: [
                0,
                1
            ]
        });
        return context.register(xObject);
    };
    return PngEmbedder;
}();
var $0a39e685a1b53e0a$export$2e2bcd8739ae039 = $0a39e685a1b53e0a$var$PngEmbedder;



var $59LZ8 = parcelRequire("59LZ8");

var $1cWQu = parcelRequire("1cWQu");

var $gcVIu = parcelRequire("gcVIu");



var $1cWQu = parcelRequire("1cWQu");

var $7Igbp = parcelRequire("7Igbp");


var $a7yPZ = parcelRequire("a7yPZ");

var $gcVIu = parcelRequire("gcVIu");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Ascii85Stream class contained in this file is a TypeScript port of the
 * JavaScript Ascii85Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $59LZ8 = parcelRequire("59LZ8");

var $1cWQu = parcelRequire("1cWQu");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Stream class contained in this file is a TypeScript port of the
 * JavaScript Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ var $19e60957b3596052$var$Stream = /** @class */ function() {
    function Stream(buffer, start, length) {
        this.bytes = buffer;
        this.start = start || 0;
        this.pos = this.start;
        this.end = !!start && !!length ? start + length : this.bytes.length;
    }
    Object.defineProperty(Stream.prototype, "length", {
        get: function() {
            return this.end - this.start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "isEmpty", {
        get: function() {
            return this.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Stream.prototype.getByte = function() {
        if (this.pos >= this.end) return -1;
        return this.bytes[this.pos++];
    };
    Stream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    Stream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    // Returns subarray of original buffer, should only be read.
    Stream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.bytes;
        var pos = this.pos;
        var strEnd = this.end;
        if (!length) {
            var subarray = bytes.subarray(pos, strEnd);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        } else {
            var end = pos + length;
            if (end > strEnd) end = strEnd;
            this.pos = end;
            var subarray = bytes.subarray(pos, end);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        }
    };
    Stream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    Stream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    Stream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    Stream.prototype.reset = function() {
        this.pos = this.start;
    };
    Stream.prototype.moveStart = function() {
        this.start = this.pos;
    };
    Stream.prototype.makeSubStream = function(start, length) {
        return new Stream(this.bytes, start, length);
    };
    Stream.prototype.decode = function() {
        return this.bytes;
    };
    return Stream;
}();
var $19e60957b3596052$export$2e2bcd8739ae039 = $19e60957b3596052$var$Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The DecodeStream class contained in this file is a TypeScript port of the
 * JavaScript DecodeStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ // Lots of DecodeStreams are created whose buffers are never used.  For these
// we share a single empty buffer. This is (a) space-efficient and (b) avoids
// having special cases that would be required if we used |null| for an empty
// buffer.
var $48491c2b9a3179d6$var$emptyBuffer = new Uint8Array(0);
/**
 * Super class for the decoding streams
 */ var $48491c2b9a3179d6$var$DecodeStream = /** @class */ function() {
    function DecodeStream(maybeMinBufferLength) {
        this.pos = 0;
        this.bufferLength = 0;
        this.eof = false;
        this.buffer = $48491c2b9a3179d6$var$emptyBuffer;
        this.minBufferLength = 512;
        if (maybeMinBufferLength) // Compute the first power of two that is as big as maybeMinBufferLength.
        while(this.minBufferLength < maybeMinBufferLength)this.minBufferLength *= 2;
    }
    Object.defineProperty(DecodeStream.prototype, "isEmpty", {
        get: function() {
            while(!this.eof && this.bufferLength === 0)this.readBlock();
            return this.bufferLength === 0;
        },
        enumerable: false,
        configurable: true
    });
    DecodeStream.prototype.getByte = function() {
        var pos = this.pos;
        while(this.bufferLength <= pos){
            if (this.eof) return -1;
            this.readBlock();
        }
        return this.buffer[this.pos++];
    };
    DecodeStream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    DecodeStream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    DecodeStream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var end;
        var pos = this.pos;
        if (length) {
            this.ensureBuffer(pos + length);
            end = pos + length;
            while(!this.eof && this.bufferLength < end)this.readBlock();
            var bufEnd = this.bufferLength;
            if (end > bufEnd) end = bufEnd;
        } else {
            while(!this.eof)this.readBlock();
            end = this.bufferLength;
        }
        this.pos = end;
        var subarray = this.buffer.subarray(pos, end);
        // `this.buffer` is either a `Uint8Array` or `Uint8ClampedArray` here.
        return forceClamped && !(subarray instanceof Uint8ClampedArray) ? new Uint8ClampedArray(subarray) : subarray;
    };
    DecodeStream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    DecodeStream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    DecodeStream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    DecodeStream.prototype.reset = function() {
        this.pos = 0;
    };
    DecodeStream.prototype.makeSubStream = function(start, length /* dict */ ) {
        var end = start + length;
        while(this.bufferLength <= end && !this.eof)this.readBlock();
        return new (0, $19e60957b3596052$export$2e2bcd8739ae039)(this.buffer, start, length /* dict */ );
    };
    DecodeStream.prototype.decode = function() {
        while(!this.eof)this.readBlock();
        return this.buffer.subarray(0, this.bufferLength);
    };
    DecodeStream.prototype.readBlock = function() {
        throw new (0, $1cWQu.MethodNotImplementedError)(this.constructor.name, "readBlock");
    };
    DecodeStream.prototype.ensureBuffer = function(requested) {
        var buffer = this.buffer;
        if (requested <= buffer.byteLength) return buffer;
        var size = this.minBufferLength;
        while(size < requested)size *= 2;
        var buffer2 = new Uint8Array(size);
        buffer2.set(buffer);
        return this.buffer = buffer2;
    };
    return DecodeStream;
}();
var $48491c2b9a3179d6$export$2e2bcd8739ae039 = $48491c2b9a3179d6$var$DecodeStream;


var $ece5ac1b8fb1226a$var$isSpace = function(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
};
var $ece5ac1b8fb1226a$var$Ascii85Stream = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(Ascii85Stream, _super);
    function Ascii85Stream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.input = new Uint8Array(5);
        // Most streams increase in size when decoded, but Ascii85 streams
        // typically shrink by ~20%.
        if (maybeLength) maybeLength = 0.8 * maybeLength;
        return _this;
    }
    Ascii85Stream.prototype.readBlock = function() {
        var TILDA_CHAR = 0x7e; // '~'
        var Z_LOWER_CHAR = 0x7a; // 'z'
        var EOF = -1;
        var stream = this.stream;
        var c = stream.getByte();
        while($ece5ac1b8fb1226a$var$isSpace(c))c = stream.getByte();
        if (c === EOF || c === TILDA_CHAR) {
            this.eof = true;
            return;
        }
        var bufferLength = this.bufferLength;
        var buffer;
        var i;
        // special code for z
        if (c === Z_LOWER_CHAR) {
            buffer = this.ensureBuffer(bufferLength + 4);
            for(i = 0; i < 4; ++i)buffer[bufferLength + i] = 0;
            this.bufferLength += 4;
        } else {
            var input = this.input;
            input[0] = c;
            for(i = 1; i < 5; ++i){
                c = stream.getByte();
                while($ece5ac1b8fb1226a$var$isSpace(c))c = stream.getByte();
                input[i] = c;
                if (c === EOF || c === TILDA_CHAR) break;
            }
            buffer = this.ensureBuffer(bufferLength + i - 1);
            this.bufferLength += i - 1;
            // partial ending;
            if (i < 5) {
                for(; i < 5; ++i)input[i] = 117;
                this.eof = true;
            }
            var t = 0;
            for(i = 0; i < 5; ++i)t = t * 85 + (input[i] - 0x21);
            for(i = 3; i >= 0; --i){
                buffer[bufferLength + i] = t & 0xff;
                t >>= 8;
            }
        }
    };
    return Ascii85Stream;
}((0, $48491c2b9a3179d6$export$2e2bcd8739ae039));
var $ece5ac1b8fb1226a$export$2e2bcd8739ae039 = $ece5ac1b8fb1226a$var$Ascii85Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The AsciiHexStream class contained in this file is a TypeScript port of the
 * JavaScript AsciiHexStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $59LZ8 = parcelRequire("59LZ8");

var $cede5ef27fa9f869$var$AsciiHexStream = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(AsciiHexStream, _super);
    function AsciiHexStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.firstDigit = -1;
        // Most streams increase in size when decoded, but AsciiHex streams shrink
        // by 50%.
        if (maybeLength) maybeLength = 0.5 * maybeLength;
        return _this;
    }
    AsciiHexStream.prototype.readBlock = function() {
        var UPSTREAM_BLOCK_SIZE = 8000;
        var bytes = this.stream.getBytes(UPSTREAM_BLOCK_SIZE);
        if (!bytes.length) {
            this.eof = true;
            return;
        }
        var maxDecodeLength = bytes.length + 1 >> 1;
        var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
        var bufferLength = this.bufferLength;
        var firstDigit = this.firstDigit;
        for(var i = 0, ii = bytes.length; i < ii; i++){
            var ch = bytes[i];
            var digit = void 0;
            if (ch >= 0x30 && ch <= 0x39) // '0'-'9'
            digit = ch & 0x0f;
            else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) // 'A'-'Z', 'a'-'z'
            digit = (ch & 0x0f) + 9;
            else if (ch === 0x3e) {
                // '>'
                this.eof = true;
                break;
            } else continue; // ignoring
            if (firstDigit < 0) firstDigit = digit;
            else {
                buffer[bufferLength++] = firstDigit << 4 | digit;
                firstDigit = -1;
            }
        }
        if (firstDigit >= 0 && this.eof) {
            // incomplete byte
            buffer[bufferLength++] = firstDigit << 4;
            firstDigit = -1;
        }
        this.firstDigit = firstDigit;
        this.bufferLength = bufferLength;
    };
    return AsciiHexStream;
}((0, $48491c2b9a3179d6$export$2e2bcd8739ae039));
var $cede5ef27fa9f869$export$2e2bcd8739ae039 = $cede5ef27fa9f869$var$AsciiHexStream;


/*
 * Copyright 1996-2003 Glyph & Cog, LLC
 *
 * The flate stream implementation contained in this file is a JavaScript port
 * of XPDF's implementation, made available under the Apache 2.0 open source
 * license.
 */ 
var $59LZ8 = parcelRequire("59LZ8");

// prettier-ignore
var $fccec02a92be29a0$var$codeLenCodeMap = new Int32Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// prettier-ignore
var $fccec02a92be29a0$var$lengthDecode = new Int32Array([
    0x00003,
    0x00004,
    0x00005,
    0x00006,
    0x00007,
    0x00008,
    0x00009,
    0x0000a,
    0x1000b,
    0x1000d,
    0x1000f,
    0x10011,
    0x20013,
    0x20017,
    0x2001b,
    0x2001f,
    0x30023,
    0x3002b,
    0x30033,
    0x3003b,
    0x40043,
    0x40053,
    0x40063,
    0x40073,
    0x50083,
    0x500a3,
    0x500c3,
    0x500e3,
    0x00102,
    0x00102,
    0x00102
]);
// prettier-ignore
var $fccec02a92be29a0$var$distDecode = new Int32Array([
    0x00001,
    0x00002,
    0x00003,
    0x00004,
    0x10005,
    0x10007,
    0x20009,
    0x2000d,
    0x30011,
    0x30019,
    0x40021,
    0x40031,
    0x50041,
    0x50061,
    0x60081,
    0x600c1,
    0x70101,
    0x70181,
    0x80201,
    0x80301,
    0x90401,
    0x90601,
    0xa0801,
    0xa0c01,
    0xb1001,
    0xb1801,
    0xc2001,
    0xc3001,
    0xd4001,
    0xd6001
]);
// prettier-ignore
var $fccec02a92be29a0$var$fixedLitCodeTab = [
    new Int32Array([
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c0,
        0x70108,
        0x80060,
        0x80020,
        0x900a0,
        0x80000,
        0x80080,
        0x80040,
        0x900e0,
        0x70104,
        0x80058,
        0x80018,
        0x90090,
        0x70114,
        0x80078,
        0x80038,
        0x900d0,
        0x7010c,
        0x80068,
        0x80028,
        0x900b0,
        0x80008,
        0x80088,
        0x80048,
        0x900f0,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c8,
        0x7010a,
        0x80064,
        0x80024,
        0x900a8,
        0x80004,
        0x80084,
        0x80044,
        0x900e8,
        0x70106,
        0x8005c,
        0x8001c,
        0x90098,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d8,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b8,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f8,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c4,
        0x70109,
        0x80062,
        0x80022,
        0x900a4,
        0x80002,
        0x80082,
        0x80042,
        0x900e4,
        0x70105,
        0x8005a,
        0x8001a,
        0x90094,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d4,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b4,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f4,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cc,
        0x7010b,
        0x80066,
        0x80026,
        0x900ac,
        0x80006,
        0x80086,
        0x80046,
        0x900ec,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009c,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dc,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bc,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fc,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c2,
        0x70108,
        0x80061,
        0x80021,
        0x900a2,
        0x80001,
        0x80081,
        0x80041,
        0x900e2,
        0x70104,
        0x80059,
        0x80019,
        0x90092,
        0x70114,
        0x80079,
        0x80039,
        0x900d2,
        0x7010c,
        0x80069,
        0x80029,
        0x900b2,
        0x80009,
        0x80089,
        0x80049,
        0x900f2,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900ca,
        0x7010a,
        0x80065,
        0x80025,
        0x900aa,
        0x80005,
        0x80085,
        0x80045,
        0x900ea,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009a,
        0x70116,
        0x8007d,
        0x8003d,
        0x900da,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900ba,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fa,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c6,
        0x70109,
        0x80063,
        0x80023,
        0x900a6,
        0x80003,
        0x80083,
        0x80043,
        0x900e6,
        0x70105,
        0x8005b,
        0x8001b,
        0x90096,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d6,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b6,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f6,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900ce,
        0x7010b,
        0x80067,
        0x80027,
        0x900ae,
        0x80007,
        0x80087,
        0x80047,
        0x900ee,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009e,
        0x70117,
        0x8007f,
        0x8003f,
        0x900de,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900be,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900fe,
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c1,
        0x70108,
        0x80060,
        0x80020,
        0x900a1,
        0x80000,
        0x80080,
        0x80040,
        0x900e1,
        0x70104,
        0x80058,
        0x80018,
        0x90091,
        0x70114,
        0x80078,
        0x80038,
        0x900d1,
        0x7010c,
        0x80068,
        0x80028,
        0x900b1,
        0x80008,
        0x80088,
        0x80048,
        0x900f1,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c9,
        0x7010a,
        0x80064,
        0x80024,
        0x900a9,
        0x80004,
        0x80084,
        0x80044,
        0x900e9,
        0x70106,
        0x8005c,
        0x8001c,
        0x90099,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d9,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b9,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f9,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c5,
        0x70109,
        0x80062,
        0x80022,
        0x900a5,
        0x80002,
        0x80082,
        0x80042,
        0x900e5,
        0x70105,
        0x8005a,
        0x8001a,
        0x90095,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d5,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b5,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f5,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cd,
        0x7010b,
        0x80066,
        0x80026,
        0x900ad,
        0x80006,
        0x80086,
        0x80046,
        0x900ed,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009d,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dd,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bd,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fd,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c3,
        0x70108,
        0x80061,
        0x80021,
        0x900a3,
        0x80001,
        0x80081,
        0x80041,
        0x900e3,
        0x70104,
        0x80059,
        0x80019,
        0x90093,
        0x70114,
        0x80079,
        0x80039,
        0x900d3,
        0x7010c,
        0x80069,
        0x80029,
        0x900b3,
        0x80009,
        0x80089,
        0x80049,
        0x900f3,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900cb,
        0x7010a,
        0x80065,
        0x80025,
        0x900ab,
        0x80005,
        0x80085,
        0x80045,
        0x900eb,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009b,
        0x70116,
        0x8007d,
        0x8003d,
        0x900db,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900bb,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fb,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c7,
        0x70109,
        0x80063,
        0x80023,
        0x900a7,
        0x80003,
        0x80083,
        0x80043,
        0x900e7,
        0x70105,
        0x8005b,
        0x8001b,
        0x90097,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d7,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b7,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f7,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900cf,
        0x7010b,
        0x80067,
        0x80027,
        0x900af,
        0x80007,
        0x80087,
        0x80047,
        0x900ef,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009f,
        0x70117,
        0x8007f,
        0x8003f,
        0x900df,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900bf,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900ff
    ]),
    9
];
// prettier-ignore
var $fccec02a92be29a0$var$fixedDistCodeTab = [
    new Int32Array([
        0x50000,
        0x50010,
        0x50008,
        0x50018,
        0x50004,
        0x50014,
        0x5000c,
        0x5001c,
        0x50002,
        0x50012,
        0x5000a,
        0x5001a,
        0x50006,
        0x50016,
        0x5000e,
        0x00000,
        0x50001,
        0x50011,
        0x50009,
        0x50019,
        0x50005,
        0x50015,
        0x5000d,
        0x5001d,
        0x50003,
        0x50013,
        0x5000b,
        0x5001b,
        0x50007,
        0x50017,
        0x5000f,
        0x00000
    ]),
    5
];
var $fccec02a92be29a0$var$FlateStream = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(FlateStream, _super);
    function FlateStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        var cmf = stream.getByte();
        var flg = stream.getByte();
        if (cmf === -1 || flg === -1) throw new Error("Invalid header in flate stream: " + cmf + ", " + flg);
        if ((cmf & 0x0f) !== 0x08) throw new Error("Unknown compression method in flate stream: " + cmf + ", " + flg);
        if (((cmf << 8) + flg) % 31 !== 0) throw new Error("Bad FCHECK in flate stream: " + cmf + ", " + flg);
        if (flg & 0x20) throw new Error("FDICT bit set in flate stream: " + cmf + ", " + flg);
        _this.codeSize = 0;
        _this.codeBuf = 0;
        return _this;
    }
    FlateStream.prototype.readBlock = function() {
        var buffer;
        var len;
        var str = this.stream;
        // read block header
        var hdr = this.getBits(3);
        if (hdr & 1) this.eof = true;
        hdr >>= 1;
        if (hdr === 0) {
            // uncompressed block
            var b = void 0;
            if ((b = str.getByte()) === -1) throw new Error("Bad block header in flate stream");
            var blockLen = b;
            if ((b = str.getByte()) === -1) throw new Error("Bad block header in flate stream");
            blockLen |= b << 8;
            if ((b = str.getByte()) === -1) throw new Error("Bad block header in flate stream");
            var check = b;
            if ((b = str.getByte()) === -1) throw new Error("Bad block header in flate stream");
            check |= b << 8;
            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) // Ignoring error for bad "empty" block (see issue 1277)
            throw new Error("Bad uncompressed block length in flate stream");
            this.codeBuf = 0;
            this.codeSize = 0;
            var bufferLength = this.bufferLength;
            buffer = this.ensureBuffer(bufferLength + blockLen);
            var end = bufferLength + blockLen;
            this.bufferLength = end;
            if (blockLen === 0) {
                if (str.peekByte() === -1) this.eof = true;
            } else for(var n = bufferLength; n < end; ++n){
                if ((b = str.getByte()) === -1) {
                    this.eof = true;
                    break;
                }
                buffer[n] = b;
            }
            return;
        }
        var litCodeTable;
        var distCodeTable;
        if (hdr === 1) {
            // compressed block, fixed codes
            litCodeTable = $fccec02a92be29a0$var$fixedLitCodeTab;
            distCodeTable = $fccec02a92be29a0$var$fixedDistCodeTab;
        } else if (hdr === 2) {
            // compressed block, dynamic codes
            var numLitCodes = this.getBits(5) + 257;
            var numDistCodes = this.getBits(5) + 1;
            var numCodeLenCodes = this.getBits(4) + 4;
            // build the code lengths code table
            var codeLenCodeLengths = new Uint8Array($fccec02a92be29a0$var$codeLenCodeMap.length);
            var i = void 0;
            for(i = 0; i < numCodeLenCodes; ++i)codeLenCodeLengths[$fccec02a92be29a0$var$codeLenCodeMap[i]] = this.getBits(3);
            var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
            // build the literal and distance code tables
            len = 0;
            i = 0;
            var codes = numLitCodes + numDistCodes;
            var codeLengths = new Uint8Array(codes);
            var bitsLength = void 0;
            var bitsOffset = void 0;
            var what = void 0;
            while(i < codes){
                var code = this.getCode(codeLenCodeTab);
                if (code === 16) {
                    bitsLength = 2;
                    bitsOffset = 3;
                    what = len;
                } else if (code === 17) {
                    bitsLength = 3;
                    bitsOffset = 3;
                    what = len = 0;
                } else if (code === 18) {
                    bitsLength = 7;
                    bitsOffset = 11;
                    what = len = 0;
                } else {
                    codeLengths[i++] = len = code;
                    continue;
                }
                var repeatLength = this.getBits(bitsLength) + bitsOffset;
                while(repeatLength-- > 0)codeLengths[i++] = what;
            }
            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
        } else throw new Error("Unknown block type in flate stream");
        buffer = this.buffer;
        var limit = buffer ? buffer.length : 0;
        var pos = this.bufferLength;
        while(true){
            var code1 = this.getCode(litCodeTable);
            if (code1 < 256) {
                if (pos + 1 >= limit) {
                    buffer = this.ensureBuffer(pos + 1);
                    limit = buffer.length;
                }
                buffer[pos++] = code1;
                continue;
            }
            if (code1 === 256) {
                this.bufferLength = pos;
                return;
            }
            code1 -= 257;
            code1 = $fccec02a92be29a0$var$lengthDecode[code1];
            var code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            len = (code1 & 0xffff) + code2;
            code1 = this.getCode(distCodeTable);
            code1 = $fccec02a92be29a0$var$distDecode[code1];
            code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            var dist = (code1 & 0xffff) + code2;
            if (pos + len >= limit) {
                buffer = this.ensureBuffer(pos + len);
                limit = buffer.length;
            }
            for(var k = 0; k < len; ++k, ++pos)buffer[pos] = buffer[pos - dist];
        }
    };
    FlateStream.prototype.getBits = function(bits) {
        var str = this.stream;
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < bits){
            if ((b = str.getByte()) === -1) throw new Error("Bad encoding in flate stream");
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        b = codeBuf & (1 << bits) - 1;
        this.codeBuf = codeBuf >> bits;
        this.codeSize = codeSize -= bits;
        return b;
    };
    FlateStream.prototype.getCode = function(table) {
        var str = this.stream;
        var codes = table[0];
        var maxLen = table[1];
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < maxLen){
            if ((b = str.getByte()) === -1) break;
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        var code = codes[codeBuf & (1 << maxLen) - 1];
        if (typeof codes === "number") console.log("FLATE:", code);
        var codeLen = code >> 16;
        var codeVal = code & 0xffff;
        if (codeLen < 1 || codeSize < codeLen) throw new Error("Bad encoding in flate stream");
        this.codeBuf = codeBuf >> codeLen;
        this.codeSize = codeSize - codeLen;
        return codeVal;
    };
    FlateStream.prototype.generateHuffmanTable = function(lengths) {
        var n = lengths.length;
        // find max code length
        var maxLen = 0;
        var i;
        for(i = 0; i < n; ++i)if (lengths[i] > maxLen) maxLen = lengths[i];
        // build the table
        var size = 1 << maxLen;
        var codes = new Int32Array(size);
        for(var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1){
            for(var val = 0; val < n; ++val)if (lengths[val] === len) {
                // bit-reverse the code
                var code2 = 0;
                var t = code;
                for(i = 0; i < len; ++i){
                    code2 = code2 << 1 | t & 1;
                    t >>= 1;
                }
                // fill the table entries
                for(i = code2; i < size; i += skip)codes[i] = len << 16 | val;
                ++code;
            }
        }
        return [
            codes,
            maxLen
        ];
    };
    return FlateStream;
}((0, $48491c2b9a3179d6$export$2e2bcd8739ae039));
var $fccec02a92be29a0$export$2e2bcd8739ae039 = $fccec02a92be29a0$var$FlateStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The LZWStream class contained in this file is a TypeScript port of the
 * JavaScript LZWStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $59LZ8 = parcelRequire("59LZ8");

var $6371dea49f278652$var$LZWStream = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(LZWStream, _super);
    function LZWStream(stream, maybeLength, earlyChange) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.cachedData = 0;
        _this.bitsCached = 0;
        var maxLzwDictionarySize = 4096;
        var lzwState = {
            earlyChange: earlyChange,
            codeLength: 9,
            nextCode: 258,
            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
            currentSequence: new Uint8Array(maxLzwDictionarySize),
            currentSequenceLength: 0
        };
        for(var i = 0; i < 256; ++i){
            lzwState.dictionaryValues[i] = i;
            lzwState.dictionaryLengths[i] = 1;
        }
        _this.lzwState = lzwState;
        return _this;
    }
    LZWStream.prototype.readBlock = function() {
        var blockSize = 512;
        var estimatedDecodedSize = blockSize * 2;
        var decodedSizeDelta = blockSize;
        var i;
        var j;
        var q;
        var lzwState = this.lzwState;
        if (!lzwState) return; // eof was found
        var earlyChange = lzwState.earlyChange;
        var nextCode = lzwState.nextCode;
        var dictionaryValues = lzwState.dictionaryValues;
        var dictionaryLengths = lzwState.dictionaryLengths;
        var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
        var codeLength = lzwState.codeLength;
        var prevCode = lzwState.prevCode;
        var currentSequence = lzwState.currentSequence;
        var currentSequenceLength = lzwState.currentSequenceLength;
        var decodedLength = 0;
        var currentBufferLength = this.bufferLength;
        var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
        for(i = 0; i < blockSize; i++){
            var code = this.readBits(codeLength);
            var hasPrev = currentSequenceLength > 0;
            if (!code || code < 256) {
                currentSequence[0] = code;
                currentSequenceLength = 1;
            } else if (code >= 258) {
                if (code < nextCode) {
                    currentSequenceLength = dictionaryLengths[code];
                    for(j = currentSequenceLength - 1, q = code; j >= 0; j--){
                        currentSequence[j] = dictionaryValues[q];
                        q = dictionaryPrevCodes[q];
                    }
                } else currentSequence[currentSequenceLength++] = currentSequence[0];
            } else if (code === 256) {
                codeLength = 9;
                nextCode = 258;
                currentSequenceLength = 0;
                continue;
            } else {
                this.eof = true;
                delete this.lzwState;
                break;
            }
            if (hasPrev) {
                dictionaryPrevCodes[nextCode] = prevCode;
                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                dictionaryValues[nextCode] = currentSequence[0];
                nextCode++;
                codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
            }
            prevCode = code;
            decodedLength += currentSequenceLength;
            if (estimatedDecodedSize < decodedLength) {
                do estimatedDecodedSize += decodedSizeDelta;
                while (estimatedDecodedSize < decodedLength);
                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
            }
            for(j = 0; j < currentSequenceLength; j++)buffer[currentBufferLength++] = currentSequence[j];
        }
        lzwState.nextCode = nextCode;
        lzwState.codeLength = codeLength;
        lzwState.prevCode = prevCode;
        lzwState.currentSequenceLength = currentSequenceLength;
        this.bufferLength = currentBufferLength;
    };
    LZWStream.prototype.readBits = function(n) {
        var bitsCached = this.bitsCached;
        var cachedData = this.cachedData;
        while(bitsCached < n){
            var c = this.stream.getByte();
            if (c === -1) {
                this.eof = true;
                return null;
            }
            cachedData = cachedData << 8 | c;
            bitsCached += 8;
        }
        this.bitsCached = bitsCached -= n;
        this.cachedData = cachedData;
        return cachedData >>> bitsCached & (1 << n) - 1;
    };
    return LZWStream;
}((0, $48491c2b9a3179d6$export$2e2bcd8739ae039));
var $6371dea49f278652$export$2e2bcd8739ae039 = $6371dea49f278652$var$LZWStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The RunLengthStream class contained in this file is a TypeScript port of the
 * JavaScript RunLengthStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $59LZ8 = parcelRequire("59LZ8");

var $d54311a375556e46$var$RunLengthStream = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(RunLengthStream, _super);
    function RunLengthStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        return _this;
    }
    RunLengthStream.prototype.readBlock = function() {
        // The repeatHeader has following format. The first byte defines type of run
        // and amount of bytes to repeat/copy: n = 0 through 127 - copy next n bytes
        // (in addition to the second byte from the header), n = 129 through 255 -
        // duplicate the second byte from the header (257 - n) times, n = 128 - end.
        var repeatHeader = this.stream.getBytes(2);
        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
            this.eof = true;
            return;
        }
        var buffer;
        var bufferLength = this.bufferLength;
        var n = repeatHeader[0];
        if (n < 128) {
            // copy n bytes
            buffer = this.ensureBuffer(bufferLength + n + 1);
            buffer[bufferLength++] = repeatHeader[1];
            if (n > 0) {
                var source = this.stream.getBytes(n);
                buffer.set(source, bufferLength);
                bufferLength += n;
            }
        } else {
            n = 257 - n;
            var b = repeatHeader[1];
            buffer = this.ensureBuffer(bufferLength + n + 1);
            for(var i = 0; i < n; i++)buffer[bufferLength++] = b;
        }
        this.bufferLength = bufferLength;
    };
    return RunLengthStream;
}((0, $48491c2b9a3179d6$export$2e2bcd8739ae039));
var $d54311a375556e46$export$2e2bcd8739ae039 = $d54311a375556e46$var$RunLengthStream;



var $1b710cd3e7711338$var$decodeStream = function(stream, encoding, params) {
    if (encoding === (0, $a7yPZ.default).of("FlateDecode")) return new (0, $fccec02a92be29a0$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $a7yPZ.default).of("LZWDecode")) {
        var earlyChange = 1;
        if (params instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039)) {
            var EarlyChange = params.lookup((0, $a7yPZ.default).of("EarlyChange"));
            if (EarlyChange instanceof (0, $gcVIu.default)) earlyChange = EarlyChange.asNumber();
        }
        return new (0, $6371dea49f278652$export$2e2bcd8739ae039)(stream, undefined, earlyChange);
    }
    if (encoding === (0, $a7yPZ.default).of("ASCII85Decode")) return new (0, $ece5ac1b8fb1226a$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $a7yPZ.default).of("ASCIIHexDecode")) return new (0, $cede5ef27fa9f869$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $a7yPZ.default).of("RunLengthDecode")) return new (0, $d54311a375556e46$export$2e2bcd8739ae039)(stream);
    throw new (0, $1cWQu.UnsupportedEncodingError)(encoding.asString());
};
var $1b710cd3e7711338$export$b8317e68ca978594 = function(_a) {
    var dict = _a.dict, contents = _a.contents;
    var stream = new (0, $19e60957b3596052$export$2e2bcd8739ae039)(contents);
    var Filter = dict.lookup((0, $a7yPZ.default).of("Filter"));
    var DecodeParms = dict.lookup((0, $a7yPZ.default).of("DecodeParms"));
    if (Filter instanceof (0, $a7yPZ.default)) stream = $1b710cd3e7711338$var$decodeStream(stream, Filter, DecodeParms);
    else if (Filter instanceof (0, $7Igbp.default)) for(var idx = 0, len = Filter.size(); idx < len; idx++)stream = $1b710cd3e7711338$var$decodeStream(stream, Filter.lookup(idx, (0, $a7yPZ.default)), DecodeParms && DecodeParms.lookupMaybe(idx, (0, $f437c135fa674ebe$export$2e2bcd8739ae039)));
    else if (!!Filter) throw new (0, $1cWQu.UnexpectedObjectTypeError)([
        (0, $a7yPZ.default),
        (0, $7Igbp.default)
    ], Filter);
    return stream;
};




var $5ZWJa = parcelRequire("5ZWJa");
parcelRequire("6vLBB");
var $i8eKs = parcelRequire("i8eKs");
var $898d4138dcc9c9b7$var$fullPageBoundingBox = function(page) {
    var mediaBox = page.MediaBox();
    var width = mediaBox.lookup(2, (0, $gcVIu.default)).asNumber() - mediaBox.lookup(0, (0, $gcVIu.default)).asNumber();
    var height = mediaBox.lookup(3, (0, $gcVIu.default)).asNumber() - mediaBox.lookup(1, (0, $gcVIu.default)).asNumber();
    return {
        left: 0,
        bottom: 0,
        right: width,
        top: height
    };
};
// Returns the identity matrix, modified to position the content of the given
// bounding box at (0, 0).
var $898d4138dcc9c9b7$var$boundingBoxAdjustedMatrix = function(bb) {
    return [
        1,
        0,
        0,
        1,
        -bb.left,
        -bb.bottom
    ];
};
var $898d4138dcc9c9b7$var$PDFPageEmbedder = /** @class */ function() {
    function PDFPageEmbedder(page, boundingBox, transformationMatrix) {
        this.page = page;
        var bb = boundingBox !== null && boundingBox !== void 0 ? boundingBox : $898d4138dcc9c9b7$var$fullPageBoundingBox(page);
        this.width = bb.right - bb.left;
        this.height = bb.top - bb.bottom;
        this.boundingBox = bb;
        this.transformationMatrix = transformationMatrix !== null && transformationMatrix !== void 0 ? transformationMatrix : $898d4138dcc9c9b7$var$boundingBoxAdjustedMatrix(bb);
    }
    PDFPageEmbedder.for = function(page, boundingBox, transformationMatrix) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            return (0, $59LZ8.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new PDFPageEmbedder(page, boundingBox, transformationMatrix)
                ];
            });
        });
    };
    PDFPageEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var _a, Contents, Resources, decodedContents, _b, left, bottom, right, top, xObject;
            return (0, $59LZ8.__generator)(this, function(_c) {
                _a = this.page.normalizedEntries(), Contents = _a.Contents, Resources = _a.Resources;
                if (!Contents) throw new (0, $1cWQu.MissingPageContentsEmbeddingError)();
                decodedContents = this.decodeContents(Contents);
                _b = this.boundingBox, left = _b.left, bottom = _b.bottom, right = _b.right, top = _b.top;
                xObject = context.flateStream(decodedContents, {
                    Type: "XObject",
                    Subtype: "Form",
                    FormType: 1,
                    BBox: [
                        left,
                        bottom,
                        right,
                        top
                    ],
                    Matrix: this.transformationMatrix,
                    Resources: Resources
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    // `contents` is an array of streams which are merged to include them in the XObject.
    // This methods extracts each stream and joins them with a newline character.
    PDFPageEmbedder.prototype.decodeContents = function(contents) {
        var newline = Uint8Array.of((0, $5ZWJa.default).Newline);
        var decodedContents = [];
        for(var idx = 0, len = contents.size(); idx < len; idx++){
            var stream = contents.lookup(idx, (0, $29b9b1023bfccc2c$export$2e2bcd8739ae039));
            var content = void 0;
            if (stream instanceof (0, $6f2895f4e287e745$export$2e2bcd8739ae039)) content = (0, $1b710cd3e7711338$export$b8317e68ca978594)(stream).decode();
            else if (stream instanceof (0, $b3f77b3eab24ae0a$export$2e2bcd8739ae039)) content = stream.getUnencodedContents();
            else throw new (0, $1cWQu.UnrecognizedStreamTypeError)(stream);
            decodedContents.push(content, newline);
        }
        return (0, $i8eKs.mergeIntoTypedArray).apply(void 0, decodedContents);
    };
    return PDFPageEmbedder;
}();
var $898d4138dcc9c9b7$export$2e2bcd8739ae039 = $898d4138dcc9c9b7$var$PDFPageEmbedder;



var $gbXzY = parcelRequire("gbXzY");

var $cWdWp = parcelRequire("cWdWp");

var $evfTd = parcelRequire("evfTd");

var $gcVIu = parcelRequire("gcVIu");



var $a7yPZ = parcelRequire("a7yPZ");


var $7Igbp = parcelRequire("7Igbp");






var $59LZ8 = parcelRequire("59LZ8");


var $a7yPZ = parcelRequire("a7yPZ");

var $59LZ8 = parcelRequire("59LZ8");



var $7Igbp = parcelRequire("7Igbp");

var $a7yPZ = parcelRequire("a7yPZ");

var $59LZ8 = parcelRequire("59LZ8");


var $a7yPZ = parcelRequire("a7yPZ");




var $a7yPZ = parcelRequire("a7yPZ");

var $gcVIu = parcelRequire("gcVIu");

var $7Igbp = parcelRequire("7Igbp");

parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");

var $1cWQu = parcelRequire("1cWQu");
// Examples:
//   `/Helv 12 Tf` -> ['Helv', '12']
//   `/HeBo 8.00 Tf` -> ['HeBo', '8.00']
//   `/HeBo Tf` -> ['HeBo', undefined]
var $067f20341ad0ba0d$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/;
var $067f20341ad0ba0d$var$PDFAcroField = /** @class */ function() {
    function PDFAcroField(dict, ref) {
        this.dict = dict;
        this.ref = ref;
    }
    PDFAcroField.prototype.T = function() {
        return this.dict.lookupMaybe((0, $a7yPZ.default).of("T"), (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039), (0, $97a582c32ae6773b$export$2e2bcd8739ae039));
    };
    PDFAcroField.prototype.Ff = function() {
        var numberOrRef = this.getInheritableAttribute((0, $a7yPZ.default).of("Ff"));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $gcVIu.default));
    };
    PDFAcroField.prototype.V = function() {
        var valueOrRef = this.getInheritableAttribute((0, $a7yPZ.default).of("V"));
        return this.dict.context.lookup(valueOrRef);
    };
    PDFAcroField.prototype.Kids = function() {
        return this.dict.lookupMaybe((0, $a7yPZ.default).of("Kids"), (0, $7Igbp.default));
    };
    // Parent(): PDFDict | undefined {
    //   return this.dict.lookupMaybe(PDFName.of('Parent'), PDFDict);
    // }
    PDFAcroField.prototype.DA = function() {
        var da = this.dict.lookup((0, $a7yPZ.default).of("DA"));
        if (da instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039) || da instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFAcroField.prototype.setKids = function(kids) {
        this.dict.set((0, $a7yPZ.default).of("Kids"), this.dict.context.obj(kids));
    };
    PDFAcroField.prototype.getParent = function() {
        // const parent = this.Parent();
        // if (!parent) return undefined;
        // return new PDFAcroField(parent);
        var parentRef = this.dict.get((0, $a7yPZ.default).of("Parent"));
        if (parentRef instanceof (0, $06a507a20ec07388$export$2e2bcd8739ae039)) {
            var parent_1 = this.dict.lookup((0, $a7yPZ.default).of("Parent"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
            return new PDFAcroField(parent_1, parentRef);
        }
        return undefined;
    };
    PDFAcroField.prototype.setParent = function(parent) {
        if (!parent) this.dict.delete((0, $a7yPZ.default).of("Parent"));
        else this.dict.set((0, $a7yPZ.default).of("Parent"), parent);
    };
    PDFAcroField.prototype.getFullyQualifiedName = function() {
        var parent = this.getParent();
        if (!parent) return this.getPartialName();
        return parent.getFullyQualifiedName() + "." + this.getPartialName();
    };
    PDFAcroField.prototype.getPartialName = function() {
        var _a;
        return (_a = this.T()) === null || _a === void 0 ? void 0 : _a.decodeText();
    };
    PDFAcroField.prototype.setPartialName = function(partialName) {
        if (!partialName) this.dict.delete((0, $a7yPZ.default).of("T"));
        else this.dict.set((0, $a7yPZ.default).of("T"), (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(partialName));
    };
    PDFAcroField.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $a7yPZ.default).of("DA"), (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039).of(appearance));
    };
    PDFAcroField.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFAcroField.prototype.setFontSize = function(fontSize) {
        var _a;
        var name = (_a = this.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : "";
        var da = this.getDefaultAppearance();
        if (!da) throw new (0, $1cWQu.MissingDAEntryError)(name);
        var daMatch = (0, $cZKSB.findLastMatch)(da, $067f20341ad0ba0d$var$tfRegex);
        if (!daMatch.match) throw new (0, $1cWQu.MissingTfOperatorError)(name);
        var daStart = da.slice(0, daMatch.pos - daMatch.match[0].length);
        var daEnd = daMatch.pos <= da.length ? da.slice(daMatch.pos) : "";
        var fontName = daMatch.match[1];
        var modifiedDa = daStart + " /" + fontName + " " + fontSize + " Tf " + daEnd;
        this.setDefaultAppearance(modifiedDa);
    };
    PDFAcroField.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.Ff()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAcroField.prototype.setFlags = function(flags) {
        this.dict.set((0, $a7yPZ.default).of("Ff"), (0, $gcVIu.default).of(flags));
    };
    PDFAcroField.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAcroField.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAcroField.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAcroField.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAcroField.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.dict.get(name);
        });
        return attribute;
    };
    PDFAcroField.prototype.ascend = function(visitor) {
        visitor(this);
        var parent = this.getParent();
        if (parent) parent.ascend(visitor);
    };
    return PDFAcroField;
}();
var $067f20341ad0ba0d$export$2e2bcd8739ae039 = $067f20341ad0ba0d$var$PDFAcroField;



var $59LZ8 = parcelRequire("59LZ8");


var $a7yPZ = parcelRequire("a7yPZ");




var $a7yPZ = parcelRequire("a7yPZ");

var $gcVIu = parcelRequire("gcVIu");
// TODO: Also handle the `/S` and `/D` entries
var $853671933c0aabb9$var$BorderStyle = /** @class */ function() {
    function BorderStyle(dict) {
        this.dict = dict;
    }
    BorderStyle.prototype.W = function() {
        var W = this.dict.lookup((0, $a7yPZ.default).of("W"));
        if (W instanceof (0, $gcVIu.default)) return W;
        return undefined;
    };
    BorderStyle.prototype.getWidth = function() {
        var _a, _b;
        return (_b = (_a = this.W()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    BorderStyle.prototype.setWidth = function(width) {
        var W = this.dict.context.obj(width);
        this.dict.set((0, $a7yPZ.default).of("W"), W);
    };
    BorderStyle.fromDict = function(dict) {
        return new BorderStyle(dict);
    };
    return BorderStyle;
}();
var $853671933c0aabb9$export$2e2bcd8739ae039 = $853671933c0aabb9$var$BorderStyle;




var $a7yPZ = parcelRequire("a7yPZ");


var $7Igbp = parcelRequire("7Igbp");


var $gcVIu = parcelRequire("gcVIu");
var $b6647c6cf36dada2$var$PDFAnnotation = /** @class */ function() {
    function PDFAnnotation(dict) {
        this.dict = dict;
    }
    // This is technically required by the PDF spec
    PDFAnnotation.prototype.Rect = function() {
        return this.dict.lookup((0, $a7yPZ.default).of("Rect"), (0, $7Igbp.default));
    };
    PDFAnnotation.prototype.AP = function() {
        return this.dict.lookupMaybe((0, $a7yPZ.default).of("AP"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
    };
    PDFAnnotation.prototype.F = function() {
        var numberOrRef = this.dict.lookup((0, $a7yPZ.default).of("F"));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $gcVIu.default));
    };
    PDFAnnotation.prototype.getRectangle = function() {
        var _a;
        var Rect = this.Rect();
        return (_a = Rect === null || Rect === void 0 ? void 0 : Rect.asRectangle()) !== null && _a !== void 0 ? _a : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    };
    PDFAnnotation.prototype.setRectangle = function(rect) {
        var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
        var Rect = this.dict.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.dict.set((0, $a7yPZ.default).of("Rect"), Rect);
    };
    PDFAnnotation.prototype.getAppearanceState = function() {
        var AS = this.dict.lookup((0, $a7yPZ.default).of("AS"));
        if (AS instanceof (0, $a7yPZ.default)) return AS;
        return undefined;
    };
    PDFAnnotation.prototype.setAppearanceState = function(state) {
        this.dict.set((0, $a7yPZ.default).of("AS"), state);
    };
    PDFAnnotation.prototype.setAppearances = function(appearances) {
        this.dict.set((0, $a7yPZ.default).of("AP"), appearances);
    };
    PDFAnnotation.prototype.ensureAP = function() {
        var AP = this.AP();
        if (!AP) {
            AP = this.dict.context.obj({});
            this.dict.set((0, $a7yPZ.default).of("AP"), AP);
        }
        return AP;
    };
    PDFAnnotation.prototype.getNormalAppearance = function() {
        var AP = this.ensureAP();
        var N = AP.get((0, $a7yPZ.default).of("N"));
        if (N instanceof (0, $06a507a20ec07388$export$2e2bcd8739ae039) || N instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039)) return N;
        throw new Error("Unexpected N type: " + (N === null || N === void 0 ? void 0 : N.constructor.name));
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setNormalAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $a7yPZ.default).of("N"), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setRolloverAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $a7yPZ.default).of("R"), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setDownAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $a7yPZ.default).of("D"), appearance);
    };
    PDFAnnotation.prototype.removeRolloverAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $a7yPZ.default).of("R"));
    };
    PDFAnnotation.prototype.removeDownAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $a7yPZ.default).of("D"));
    };
    PDFAnnotation.prototype.getAppearances = function() {
        var AP = this.AP();
        if (!AP) return undefined;
        var N = AP.lookup((0, $a7yPZ.default).of("N"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039), (0, $29b9b1023bfccc2c$export$2e2bcd8739ae039));
        var R = AP.lookupMaybe((0, $a7yPZ.default).of("R"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039), (0, $29b9b1023bfccc2c$export$2e2bcd8739ae039));
        var D = AP.lookupMaybe((0, $a7yPZ.default).of("D"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039), (0, $29b9b1023bfccc2c$export$2e2bcd8739ae039));
        return {
            normal: N,
            rollover: R,
            down: D
        };
    };
    PDFAnnotation.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.F()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAnnotation.prototype.setFlags = function(flags) {
        this.dict.set((0, $a7yPZ.default).of("F"), (0, $gcVIu.default).of(flags));
    };
    PDFAnnotation.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAnnotation.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAnnotation.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAnnotation.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAnnotation.fromDict = function(dict) {
        return new PDFAnnotation(dict);
    };
    return PDFAnnotation;
}();
var $b6647c6cf36dada2$export$2e2bcd8739ae039 = $b6647c6cf36dada2$var$PDFAnnotation;



var $a7yPZ = parcelRequire("a7yPZ");

var $gcVIu = parcelRequire("gcVIu");

var $7Igbp = parcelRequire("7Igbp");


var $f06288b36b66cd5e$var$AppearanceCharacteristics = /** @class */ function() {
    function AppearanceCharacteristics(dict) {
        this.dict = dict;
    }
    AppearanceCharacteristics.prototype.R = function() {
        var R = this.dict.lookup((0, $a7yPZ.default).of("R"));
        if (R instanceof (0, $gcVIu.default)) return R;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BC = function() {
        var BC = this.dict.lookup((0, $a7yPZ.default).of("BC"));
        if (BC instanceof (0, $7Igbp.default)) return BC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BG = function() {
        var BG = this.dict.lookup((0, $a7yPZ.default).of("BG"));
        if (BG instanceof (0, $7Igbp.default)) return BG;
        return undefined;
    };
    AppearanceCharacteristics.prototype.CA = function() {
        var CA = this.dict.lookup((0, $a7yPZ.default).of("CA"));
        if (CA instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039) || CA instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039)) return CA;
        return undefined;
    };
    AppearanceCharacteristics.prototype.RC = function() {
        var RC = this.dict.lookup((0, $a7yPZ.default).of("RC"));
        if (RC instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039) || RC instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039)) return RC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.AC = function() {
        var AC = this.dict.lookup((0, $a7yPZ.default).of("AC"));
        if (AC instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039) || AC instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039)) return AC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.getRotation = function() {
        var _a;
        return (_a = this.R()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    AppearanceCharacteristics.prototype.getBorderColor = function() {
        var BC = this.BC();
        if (!BC) return undefined;
        var components = [];
        for(var idx = 0, len = BC === null || BC === void 0 ? void 0 : BC.size(); idx < len; idx++){
            var component = BC.get(idx);
            if (component instanceof (0, $gcVIu.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getBackgroundColor = function() {
        var BG = this.BG();
        if (!BG) return undefined;
        var components = [];
        for(var idx = 0, len = BG === null || BG === void 0 ? void 0 : BG.size(); idx < len; idx++){
            var component = BG.get(idx);
            if (component instanceof (0, $gcVIu.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getCaptions = function() {
        var CA = this.CA();
        var RC = this.RC();
        var AC = this.AC();
        return {
            normal: CA === null || CA === void 0 ? void 0 : CA.decodeText(),
            rollover: RC === null || RC === void 0 ? void 0 : RC.decodeText(),
            down: AC === null || AC === void 0 ? void 0 : AC.decodeText()
        };
    };
    AppearanceCharacteristics.prototype.setRotation = function(rotation) {
        var R = this.dict.context.obj(rotation);
        this.dict.set((0, $a7yPZ.default).of("R"), R);
    };
    AppearanceCharacteristics.prototype.setBorderColor = function(color) {
        var BC = this.dict.context.obj(color);
        this.dict.set((0, $a7yPZ.default).of("BC"), BC);
    };
    AppearanceCharacteristics.prototype.setBackgroundColor = function(color) {
        var BG = this.dict.context.obj(color);
        this.dict.set((0, $a7yPZ.default).of("BG"), BG);
    };
    AppearanceCharacteristics.prototype.setCaptions = function(captions) {
        var CA = (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(captions.normal);
        this.dict.set((0, $a7yPZ.default).of("CA"), CA);
        if (captions.rollover) {
            var RC = (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(captions.rollover);
            this.dict.set((0, $a7yPZ.default).of("RC"), RC);
        } else this.dict.delete((0, $a7yPZ.default).of("RC"));
        if (captions.down) {
            var AC = (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(captions.down);
            this.dict.set((0, $a7yPZ.default).of("AC"), AC);
        } else this.dict.delete((0, $a7yPZ.default).of("AC"));
    };
    AppearanceCharacteristics.fromDict = function(dict) {
        return new AppearanceCharacteristics(dict);
    };
    return AppearanceCharacteristics;
}();
var $f06288b36b66cd5e$export$2e2bcd8739ae039 = $f06288b36b66cd5e$var$AppearanceCharacteristics;


var $7d23e60087e51548$var$PDFWidgetAnnotation = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFWidgetAnnotation, _super);
    function PDFWidgetAnnotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFWidgetAnnotation.prototype.MK = function() {
        var MK = this.dict.lookup((0, $a7yPZ.default).of("MK"));
        if (MK instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039)) return MK;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.BS = function() {
        var BS = this.dict.lookup((0, $a7yPZ.default).of("BS"));
        if (BS instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039)) return BS;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.DA = function() {
        var da = this.dict.lookup((0, $a7yPZ.default).of("DA"));
        if (da instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039) || da instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.P = function() {
        var P = this.dict.get((0, $a7yPZ.default).of("P"));
        if (P instanceof (0, $06a507a20ec07388$export$2e2bcd8739ae039)) return P;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.setP = function(page) {
        this.dict.set((0, $a7yPZ.default).of("P"), page);
    };
    PDFWidgetAnnotation.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $a7yPZ.default).of("DA"), (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039).of(appearance));
    };
    PDFWidgetAnnotation.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFWidgetAnnotation.prototype.getAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $f06288b36b66cd5e$export$2e2bcd8739ae039).fromDict(MK);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $f06288b36b66cd5e$export$2e2bcd8739ae039).fromDict(MK);
        var ac = (0, $f06288b36b66cd5e$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $a7yPZ.default).of("MK"), ac.dict);
        return ac;
    };
    PDFWidgetAnnotation.prototype.getBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $853671933c0aabb9$export$2e2bcd8739ae039).fromDict(BS);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $853671933c0aabb9$export$2e2bcd8739ae039).fromDict(BS);
        var bs = (0, $853671933c0aabb9$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $a7yPZ.default).of("BS"), bs.dict);
        return bs;
    };
    PDFWidgetAnnotation.prototype.getOnValue = function() {
        var _a;
        var normal = (_a = this.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
        if (normal instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039)) {
            var keys = normal.keys();
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                if (key !== (0, $a7yPZ.default).of("Off")) return key;
            }
        }
        return undefined;
    };
    PDFWidgetAnnotation.fromDict = function(dict) {
        return new PDFWidgetAnnotation(dict);
    };
    PDFWidgetAnnotation.create = function(context, parent) {
        var dict = context.obj({
            Type: "Annot",
            Subtype: "Widget",
            Rect: [
                0,
                0,
                0,
                0
            ],
            Parent: parent
        });
        return new PDFWidgetAnnotation(dict);
    };
    return PDFWidgetAnnotation;
}((0, $b6647c6cf36dada2$export$2e2bcd8739ae039));
var $7d23e60087e51548$export$2e2bcd8739ae039 = $7d23e60087e51548$var$PDFWidgetAnnotation;



var $1cWQu = parcelRequire("1cWQu");
var $05ddbe3c6f42d8d9$var$PDFAcroTerminal = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFAcroTerminal, _super);
    function PDFAcroTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroTerminal.prototype.FT = function() {
        var nameOrRef = this.getInheritableAttribute((0, $a7yPZ.default).of("FT"));
        return this.dict.context.lookup(nameOrRef, (0, $a7yPZ.default));
    };
    PDFAcroTerminal.prototype.getWidgets = function() {
        var kidDicts = this.Kids();
        // This field is itself a widget
        if (!kidDicts) return [
            (0, $7d23e60087e51548$export$2e2bcd8739ae039).fromDict(this.dict)
        ];
        // This field's kids are its widgets
        var widgets = new Array(kidDicts.size());
        for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
            var dict = kidDicts.lookup(idx, (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
            widgets[idx] = (0, $7d23e60087e51548$export$2e2bcd8739ae039).fromDict(dict);
        }
        return widgets;
    };
    PDFAcroTerminal.prototype.addWidget = function(ref) {
        var Kids = this.normalizedEntries().Kids;
        Kids.push(ref);
    };
    PDFAcroTerminal.prototype.removeWidget = function(idx) {
        var kidDicts = this.Kids();
        if (!kidDicts) {
            // This field is itself a widget
            if (idx !== 0) throw new (0, $1cWQu.IndexOutOfBoundsError)(idx, 0, 0);
            this.setKids([]);
        } else {
            // This field's kids are its widgets
            if (idx < 0 || idx > kidDicts.size()) throw new (0, $1cWQu.IndexOutOfBoundsError)(idx, 0, kidDicts.size());
            kidDicts.remove(idx);
        }
    };
    PDFAcroTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        // If this field is itself a widget (because it was only rendered once in
        // the document, so the field and widget properties were merged) then we
        // add itself to the `Kids` array. The alternative would be to try
        // splitting apart the widget properties and creating a separate object
        // for them.
        if (!Kids) {
            Kids = this.dict.context.obj([
                this.ref
            ]);
            this.dict.set((0, $a7yPZ.default).of("Kids"), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroTerminal.fromDict = function(dict, ref) {
        return new PDFAcroTerminal(dict, ref);
    };
    return PDFAcroTerminal;
}((0, $067f20341ad0ba0d$export$2e2bcd8739ae039));
var $05ddbe3c6f42d8d9$export$2e2bcd8739ae039 = $05ddbe3c6f42d8d9$var$PDFAcroTerminal;



var $1cWQu = parcelRequire("1cWQu");
var $5196cbf6a655b8e3$var$PDFAcroButton = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFAcroButton, _super);
    function PDFAcroButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroButton.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $a7yPZ.default).of("Opt"), (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039), (0, $97a582c32ae6773b$export$2e2bcd8739ae039), (0, $7Igbp.default));
    };
    PDFAcroButton.prototype.setOpt = function(opt) {
        this.dict.set((0, $a7yPZ.default).of("Opt"), this.dict.context.obj(opt));
    };
    PDFAcroButton.prototype.getExportValues = function() {
        var opt = this.Opt();
        if (!opt) return undefined;
        if (opt instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039) || opt instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) return [
            opt
        ];
        var values = [];
        for(var idx = 0, len = opt.size(); idx < len; idx++){
            var value = opt.lookup(idx);
            if (value instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039) || value instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) values.push(value);
        }
        return values;
    };
    PDFAcroButton.prototype.removeExportValue = function(idx) {
        var opt = this.Opt();
        if (!opt) return;
        if (opt instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039) || opt instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) {
            if (idx !== 0) throw new (0, $1cWQu.IndexOutOfBoundsError)(idx, 0, 0);
            this.setOpt([]);
        } else {
            if (idx < 0 || idx > opt.size()) throw new (0, $1cWQu.IndexOutOfBoundsError)(idx, 0, opt.size());
            opt.remove(idx);
        }
    };
    // Enforce use use of /Opt even if it isn't strictly necessary
    PDFAcroButton.prototype.normalizeExportValues = function() {
        var _a, _b, _c, _d;
        var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
        var Opt = [];
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var exportVal = (_b = exportValues[idx]) !== null && _b !== void 0 ? _b : (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText((_d = (_c = widget.getOnValue()) === null || _c === void 0 ? void 0 : _c.decodeText()) !== null && _d !== void 0 ? _d : "");
            Opt.push(exportVal);
        }
        this.setOpt(Opt);
    };
    /**
     * Reuses existing opt if one exists with the same value (assuming
     * `useExistingIdx` is `true`). Returns index of existing (or new) opt.
     */ PDFAcroButton.prototype.addOpt = function(opt, useExistingOptIdx) {
        var _a;
        this.normalizeExportValues();
        var optText = opt.decodeText();
        var existingIdx;
        if (useExistingOptIdx) {
            var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
            for(var idx = 0, len = exportValues.length; idx < len; idx++){
                var exportVal = exportValues[idx];
                if (exportVal.decodeText() === optText) existingIdx = idx;
            }
        }
        var Opt = this.Opt();
        Opt.push(opt);
        return existingIdx !== null && existingIdx !== void 0 ? existingIdx : Opt.size() - 1;
    };
    PDFAcroButton.prototype.addWidgetWithOpt = function(widget, opt, useExistingOptIdx) {
        var optIdx = this.addOpt(opt, useExistingOptIdx);
        var apStateValue = (0, $a7yPZ.default).of(String(optIdx));
        this.addWidget(widget);
        return apStateValue;
    };
    return PDFAcroButton;
}((0, $05ddbe3c6f42d8d9$export$2e2bcd8739ae039));
var $5196cbf6a655b8e3$export$2e2bcd8739ae039 = $5196cbf6a655b8e3$var$PDFAcroButton;



var $59LZ8 = parcelRequire("59LZ8");

var $a7yPZ = parcelRequire("a7yPZ");


var $1cWQu = parcelRequire("1cWQu");
var $4760db20b4fb4187$var$PDFAcroCheckBox = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFAcroCheckBox, _super);
    function PDFAcroCheckBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroCheckBox.prototype.setValue = function(value) {
        var _a;
        var onValue = (_a = this.getOnValue()) !== null && _a !== void 0 ? _a : (0, $a7yPZ.default).of("Yes");
        if (value !== onValue && value !== (0, $a7yPZ.default).of("Off")) throw new (0, $1cWQu.InvalidAcroFieldValueError)();
        this.dict.set((0, $a7yPZ.default).of("V"), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $a7yPZ.default).of("Off");
            widget.setAppearanceState(state);
        }
    };
    PDFAcroCheckBox.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $a7yPZ.default)) return v;
        return (0, $a7yPZ.default).of("Off");
    };
    PDFAcroCheckBox.prototype.getOnValue = function() {
        var widget = this.getWidgets()[0];
        return widget === null || widget === void 0 ? void 0 : widget.getOnValue();
    };
    PDFAcroCheckBox.fromDict = function(dict, ref) {
        return new PDFAcroCheckBox(dict, ref);
    };
    PDFAcroCheckBox.create = function(context) {
        var dict = context.obj({
            FT: "Btn",
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroCheckBox(dict, ref);
    };
    return PDFAcroCheckBox;
}((0, $5196cbf6a655b8e3$export$2e2bcd8739ae039));
var $4760db20b4fb4187$export$2e2bcd8739ae039 = $4760db20b4fb4187$var$PDFAcroCheckBox;



var $59LZ8 = parcelRequire("59LZ8");




var $7Igbp = parcelRequire("7Igbp");

var $a7yPZ = parcelRequire("a7yPZ");
var $5e94843d22be1325$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $5e94843d22be1325$export$3600c95532547643;
(function(AcroFieldFlags) {
    /**
     * If set, the user may not change the value of the field. Any associated
     * widget annotations will not interact with the user; that is, they will not
     * respond to mouse clicks or change their appearance in response to mouse
     * motions. This flag is useful for fields whose values are computed or
     * imported from a database.
     */ AcroFieldFlags[AcroFieldFlags["ReadOnly"] = $5e94843d22be1325$var$flag(0)] = "ReadOnly";
    /**
     * If set, the field shall have a value at the time it is exported by a
     * submit-form action (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["Required"] = $5e94843d22be1325$var$flag(1)] = "Required";
    /**
     * If set, the field shall not be exported by a submit-form action
     * (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["NoExport"] = $5e94843d22be1325$var$flag(2)] = "NoExport";
})($5e94843d22be1325$export$3600c95532547643 || ($5e94843d22be1325$export$3600c95532547643 = {}));
var $5e94843d22be1325$export$59f660e89ffb4f8a;
(function(AcroButtonFlags) {
    /**
     * (Radio buttons only) If set, exactly one radio button shall be selected at
     * all times; selecting the currently selected button has no effect. If clear,
     * clicking the selected button deselects it, leaving no button selected.
     */ AcroButtonFlags[AcroButtonFlags["NoToggleToOff"] = $5e94843d22be1325$var$flag(14)] = "NoToggleToOff";
    /**
     * If set, the field is a set of radio buttons; if clear, the field is a check
     * box. This flag may be set only if the Pushbutton flag is clear.
     */ AcroButtonFlags[AcroButtonFlags["Radio"] = $5e94843d22be1325$var$flag(15)] = "Radio";
    /**
     * If set, the field is a pushbutton that does not retain a permanent value.
     */ AcroButtonFlags[AcroButtonFlags["PushButton"] = $5e94843d22be1325$var$flag(16)] = "PushButton";
    /**
     * If set, a group of radio buttons within a radio button field that use the
     * same value for the on state will turn on and off in unison; that is if one
     * is checked, they are all checked. If clear, the buttons are mutually
     * exclusive (the same behavior as HTML radio buttons).
     */ AcroButtonFlags[AcroButtonFlags["RadiosInUnison"] = $5e94843d22be1325$var$flag(25)] = "RadiosInUnison";
})($5e94843d22be1325$export$59f660e89ffb4f8a || ($5e94843d22be1325$export$59f660e89ffb4f8a = {}));
var $5e94843d22be1325$export$389fc7b97397dc8b;
(function(AcroTextFlags) {
    /**
     * If set, the field may contain multiple lines of text; if clear, the field's
     * text shall be restricted to a single line.
     */ AcroTextFlags[AcroTextFlags["Multiline"] = $5e94843d22be1325$var$flag(12)] = "Multiline";
    /**
     * If set, the field is intended for entering a secure password that should
     * not be echoed visibly to the screen. Characters typed from the keyboard
     * shall instead be echoed in some unreadable form, such as asterisks or
     * bullet characters.
     * > NOTE   To protect password confidentiality, readers should never store
     * >        the value of the text field in the PDF file if this flag is set.
     */ AcroTextFlags[AcroTextFlags["Password"] = $5e94843d22be1325$var$flag(13)] = "Password";
    /**
     * If set, the text entered in the field represents the pathname of a file
     * whose contents shall be submitted as the value of the field.
     */ AcroTextFlags[AcroTextFlags["FileSelect"] = $5e94843d22be1325$var$flag(20)] = "FileSelect";
    /**
     * If set, text entered in the field shall not be spell-checked.
     */ AcroTextFlags[AcroTextFlags["DoNotSpellCheck"] = $5e94843d22be1325$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the field shall not scroll (horizontally for single-line fields,
     * vertically for multiple-line fields) to accommodate more text than fits
     * within its annotation rectangle. Once the field is full, no further text
     * shall be accepted for interactive form filling; for non-interactive form
     * filling, the filler should take care not to add more character than will
     * visibly fit in the defined area.
     */ AcroTextFlags[AcroTextFlags["DoNotScroll"] = $5e94843d22be1325$var$flag(23)] = "DoNotScroll";
    /**
     * May be set only if the MaxLen entry is present in the text field dictionary
     * (see Table 229) and if the Multiline, Password, and FileSelect flags are
     * clear. If set, the field shall be automatically divided into as many
     * equally spaced positions, or combs, as the value of MaxLen, and the text
     * is laid out into those combs.
     */ AcroTextFlags[AcroTextFlags["Comb"] = $5e94843d22be1325$var$flag(24)] = "Comb";
    /**
     * If set, the value of this field shall be a rich text string
     * (see 12.7.3.4, "Rich Text Strings"). If the field has a value, the RV
     * entry of the field dictionary (Table 222) shall specify the rich text
     * string.
     */ AcroTextFlags[AcroTextFlags["RichText"] = $5e94843d22be1325$var$flag(25)] = "RichText";
})($5e94843d22be1325$export$389fc7b97397dc8b || ($5e94843d22be1325$export$389fc7b97397dc8b = {}));
var $5e94843d22be1325$export$eb88827058402599;
(function(AcroChoiceFlags) {
    /**
     * If set, the field is a combo box; if clear, the field is a list box.
     */ AcroChoiceFlags[AcroChoiceFlags["Combo"] = $5e94843d22be1325$var$flag(17)] = "Combo";
    /**
     * If set, the combo box shall include an editable text box as well as a
     * drop-down list; if clear, it shall include only a drop-down list. This
     * flag shall be used only if the Combo flag is set.
     */ AcroChoiceFlags[AcroChoiceFlags["Edit"] = $5e94843d22be1325$var$flag(18)] = "Edit";
    /**
     * If set, the field's option items shall be sorted alphabetically. This flag
     * is intended for use by writers, not by readers. Conforming readers shall
     * display the options in the order in which they occur in the Opt array
     * (see Table 231).
     */ AcroChoiceFlags[AcroChoiceFlags["Sort"] = $5e94843d22be1325$var$flag(19)] = "Sort";
    /**
     * If set, more than one of the field's option items may be selected
     * simultaneously; if clear, at most one item shall be selected.
     */ AcroChoiceFlags[AcroChoiceFlags["MultiSelect"] = $5e94843d22be1325$var$flag(21)] = "MultiSelect";
    /**
     * If set, text entered in the field shall not be spell-checked. This flag
     * shall not be used unless the Combo and Edit flags are both set.
     */ AcroChoiceFlags[AcroChoiceFlags["DoNotSpellCheck"] = $5e94843d22be1325$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the new value shall be committed as soon as a selection is made
     * (commonly with the pointing device). In this case, supplying a value for
     * a field involves three actions: selecting the field for fill-in,
     * selecting a choice for the fill-in value, and leaving that field, which
     * finalizes or "commits" the data choice and triggers any actions associated
     * with the entry or changing of this data. If this flag is on, then
     * processing does not wait for leaving the field action to occur, but
     * immediately proceeds to the third step.
     *
     * This option enables applications to perform an action once a selection is
     * made, without requiring the user to exit the field. If clear, the new
     * value is not committed until the user exits the field.
     */ AcroChoiceFlags[AcroChoiceFlags["CommitOnSelChange"] = $5e94843d22be1325$var$flag(26)] = "CommitOnSelChange";
})($5e94843d22be1325$export$eb88827058402599 || ($5e94843d22be1325$export$eb88827058402599 = {}));



var $1cWQu = parcelRequire("1cWQu");
var $91de3053180c437a$var$PDFAcroChoice = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFAcroChoice, _super);
    function PDFAcroChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroChoice.prototype.setValues = function(values) {
        if (this.hasFlag((0, $5e94843d22be1325$export$eb88827058402599).Combo) && !this.hasFlag((0, $5e94843d22be1325$export$eb88827058402599).Edit) && !this.valuesAreValid(values)) throw new (0, $1cWQu.InvalidAcroFieldValueError)();
        if (values.length === 0) this.dict.delete((0, $a7yPZ.default).of("V"));
        if (values.length === 1) this.dict.set((0, $a7yPZ.default).of("V"), values[0]);
        if (values.length > 1) {
            if (!this.hasFlag((0, $5e94843d22be1325$export$eb88827058402599).MultiSelect)) throw new (0, $1cWQu.MultiSelectValueError)();
            this.dict.set((0, $a7yPZ.default).of("V"), this.dict.context.obj(values));
        }
        this.updateSelectedIndices(values);
    };
    PDFAcroChoice.prototype.valuesAreValid = function(values) {
        var options = this.getOptions();
        var _loop_1 = function(idx, len) {
            var val = values[idx].decodeText();
            if (!options.find(function(o) {
                return val === (o.display || o.value).decodeText();
            })) return {
                value: false
            };
        };
        for(var idx = 0, len = values.length; idx < len; idx++){
            var state_1 = _loop_1(idx, len);
            if (typeof state_1 === "object") return state_1.value;
        }
        return true;
    };
    PDFAcroChoice.prototype.updateSelectedIndices = function(values) {
        if (values.length > 1) {
            var indices = new Array(values.length);
            var options = this.getOptions();
            var _loop_2 = function(idx, len) {
                var val = values[idx].decodeText();
                indices[idx] = options.findIndex(function(o) {
                    return val === (o.display || o.value).decodeText();
                });
            };
            for(var idx = 0, len = values.length; idx < len; idx++)_loop_2(idx, len);
            this.dict.set((0, $a7yPZ.default).of("I"), this.dict.context.obj(indices.sort()));
        } else this.dict.delete((0, $a7yPZ.default).of("I"));
    };
    PDFAcroChoice.prototype.getValues = function() {
        var v = this.V();
        if (v instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039) || v instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) return [
            v
        ];
        if (v instanceof (0, $7Igbp.default)) {
            var values = [];
            for(var idx = 0, len = v.size(); idx < len; idx++){
                var value = v.lookup(idx);
                if (value instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039) || value instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) values.push(value);
            }
            return values;
        }
        return [];
    };
    PDFAcroChoice.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $a7yPZ.default).of("Opt"), (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039), (0, $97a582c32ae6773b$export$2e2bcd8739ae039), (0, $7Igbp.default));
    };
    PDFAcroChoice.prototype.setOptions = function(options) {
        var newOpt = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = options[idx], value = _a.value, display = _a.display;
            newOpt[idx] = this.dict.context.obj([
                value,
                display || value
            ]);
        }
        this.dict.set((0, $a7yPZ.default).of("Opt"), this.dict.context.obj(newOpt));
    };
    PDFAcroChoice.prototype.getOptions = function() {
        var Opt = this.Opt();
        // Not supposed to happen - Opt _should_ always be `PDFArray | undefined`
        if (Opt instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039) || Opt instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) return [
            {
                value: Opt,
                display: Opt
            }
        ];
        if (Opt instanceof (0, $7Igbp.default)) {
            var res = [];
            for(var idx = 0, len = Opt.size(); idx < len; idx++){
                var item = Opt.lookup(idx);
                // If `item` is a string, use that as both the export and text value
                if (item instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039) || item instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) res.push({
                    value: item,
                    display: item
                });
                // If `item` is an array of one, treat it the same as just a string,
                // if it's an array of two then `item[0]` is the export value and
                // `item[1]` is the text value
                if (item instanceof (0, $7Igbp.default)) {
                    if (item.size() > 0) {
                        var first = item.lookup(0, (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039), (0, $97a582c32ae6773b$export$2e2bcd8739ae039));
                        var second = item.lookupMaybe(1, (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039), (0, $97a582c32ae6773b$export$2e2bcd8739ae039));
                        res.push({
                            value: first,
                            display: second || first
                        });
                    }
                }
            }
            return res;
        }
        return [];
    };
    return PDFAcroChoice;
}((0, $05ddbe3c6f42d8d9$export$2e2bcd8739ae039));
var $91de3053180c437a$export$2e2bcd8739ae039 = $91de3053180c437a$var$PDFAcroChoice;



var $59LZ8 = parcelRequire("59LZ8");


var $4d501aeb209a28de$var$PDFAcroComboBox = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFAcroComboBox, _super);
    function PDFAcroComboBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroComboBox.fromDict = function(dict, ref) {
        return new PDFAcroComboBox(dict, ref);
    };
    PDFAcroComboBox.create = function(context) {
        var dict = context.obj({
            FT: "Ch",
            Ff: (0, $5e94843d22be1325$export$eb88827058402599).Combo,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroComboBox(dict, ref);
    };
    return PDFAcroComboBox;
}((0, $91de3053180c437a$export$2e2bcd8739ae039));
var $4d501aeb209a28de$export$2e2bcd8739ae039 = $4d501aeb209a28de$var$PDFAcroComboBox;





var $7Igbp = parcelRequire("7Igbp");

var $a7yPZ = parcelRequire("a7yPZ");

var $59LZ8 = parcelRequire("59LZ8");

var $a7yPZ = parcelRequire("a7yPZ");

var $7b9e672813fd3df8$var$PDFAcroNonTerminal = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFAcroNonTerminal, _super);
    function PDFAcroNonTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroNonTerminal.prototype.addField = function(field) {
        var Kids = this.normalizedEntries().Kids;
        Kids === null || Kids === void 0 || Kids.push(field);
    };
    PDFAcroNonTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        if (!Kids) {
            Kids = this.dict.context.obj([]);
            this.dict.set((0, $a7yPZ.default).of("Kids"), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroNonTerminal.fromDict = function(dict, ref) {
        return new PDFAcroNonTerminal(dict, ref);
    };
    PDFAcroNonTerminal.create = function(context) {
        var dict = context.obj({});
        var ref = context.register(dict);
        return new PDFAcroNonTerminal(dict, ref);
    };
    return PDFAcroNonTerminal;
}((0, $067f20341ad0ba0d$export$2e2bcd8739ae039));
var $7b9e672813fd3df8$export$2e2bcd8739ae039 = $7b9e672813fd3df8$var$PDFAcroNonTerminal;



var $gcVIu = parcelRequire("gcVIu");


var $a7yPZ = parcelRequire("a7yPZ");

var $7Igbp = parcelRequire("7Igbp");




var $59LZ8 = parcelRequire("59LZ8");

var $7845f3837234047b$var$PDFAcroSignature = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFAcroSignature, _super);
    function PDFAcroSignature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroSignature.fromDict = function(dict, ref) {
        return new PDFAcroSignature(dict, ref);
    };
    return PDFAcroSignature;
}((0, $05ddbe3c6f42d8d9$export$2e2bcd8739ae039));
var $7845f3837234047b$export$2e2bcd8739ae039 = $7845f3837234047b$var$PDFAcroSignature;



var $59LZ8 = parcelRequire("59LZ8");

var $gcVIu = parcelRequire("gcVIu");



var $a7yPZ = parcelRequire("a7yPZ");

var $d6a62c64e2a348f0$var$PDFAcroText = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFAcroText, _super);
    function PDFAcroText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroText.prototype.MaxLen = function() {
        var maxLen = this.dict.lookup((0, $a7yPZ.default).of("MaxLen"));
        if (maxLen instanceof (0, $gcVIu.default)) return maxLen;
        return undefined;
    };
    PDFAcroText.prototype.Q = function() {
        var q = this.dict.lookup((0, $a7yPZ.default).of("Q"));
        if (q instanceof (0, $gcVIu.default)) return q;
        return undefined;
    };
    PDFAcroText.prototype.setMaxLength = function(maxLength) {
        this.dict.set((0, $a7yPZ.default).of("MaxLen"), (0, $gcVIu.default).of(maxLength));
    };
    PDFAcroText.prototype.removeMaxLength = function() {
        this.dict.delete((0, $a7yPZ.default).of("MaxLen"));
    };
    PDFAcroText.prototype.getMaxLength = function() {
        var _a;
        return (_a = this.MaxLen()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setQuadding = function(quadding) {
        this.dict.set((0, $a7yPZ.default).of("Q"), (0, $gcVIu.default).of(quadding));
    };
    PDFAcroText.prototype.getQuadding = function() {
        var _a;
        return (_a = this.Q()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setValue = function(value) {
        this.dict.set((0, $a7yPZ.default).of("V"), value);
    // const widgets = this.getWidgets();
    // for (let idx = 0, len = widgets.length; idx < len; idx++) {
    //   const widget = widgets[idx];
    //   const state = widget.getOnValue() === value ? value : PDFName.of('Off');
    //   widget.setAppearanceState(state);
    // }
    };
    PDFAcroText.prototype.removeValue = function() {
        this.dict.delete((0, $a7yPZ.default).of("V"));
    };
    PDFAcroText.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039) || v instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) return v;
        return undefined;
    };
    PDFAcroText.fromDict = function(dict, ref) {
        return new PDFAcroText(dict, ref);
    };
    PDFAcroText.create = function(context) {
        var dict = context.obj({
            FT: "Tx",
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroText(dict, ref);
    };
    return PDFAcroText;
}((0, $05ddbe3c6f42d8d9$export$2e2bcd8739ae039));
var $d6a62c64e2a348f0$export$2e2bcd8739ae039 = $d6a62c64e2a348f0$var$PDFAcroText;



var $59LZ8 = parcelRequire("59LZ8");


var $cc8e0c206e3a3c82$var$PDFAcroPushButton = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFAcroPushButton, _super);
    function PDFAcroPushButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroPushButton.fromDict = function(dict, ref) {
        return new PDFAcroPushButton(dict, ref);
    };
    PDFAcroPushButton.create = function(context) {
        var dict = context.obj({
            FT: "Btn",
            Ff: (0, $5e94843d22be1325$export$59f660e89ffb4f8a).PushButton,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroPushButton(dict, ref);
    };
    return PDFAcroPushButton;
}((0, $5196cbf6a655b8e3$export$2e2bcd8739ae039));
var $cc8e0c206e3a3c82$export$2e2bcd8739ae039 = $cc8e0c206e3a3c82$var$PDFAcroPushButton;



var $59LZ8 = parcelRequire("59LZ8");

var $a7yPZ = parcelRequire("a7yPZ");



var $1cWQu = parcelRequire("1cWQu");
var $30f61fd4202a189a$var$PDFAcroRadioButton = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFAcroRadioButton, _super);
    function PDFAcroRadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroRadioButton.prototype.setValue = function(value) {
        var onValues = this.getOnValues();
        if (!onValues.includes(value) && value !== (0, $a7yPZ.default).of("Off")) throw new (0, $1cWQu.InvalidAcroFieldValueError)();
        this.dict.set((0, $a7yPZ.default).of("V"), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $a7yPZ.default).of("Off");
            widget.setAppearanceState(state);
        }
    };
    PDFAcroRadioButton.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $a7yPZ.default)) return v;
        return (0, $a7yPZ.default).of("Off");
    };
    PDFAcroRadioButton.prototype.getOnValues = function() {
        var widgets = this.getWidgets();
        var onValues = [];
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var onValue = widgets[idx].getOnValue();
            if (onValue) onValues.push(onValue);
        }
        return onValues;
    };
    PDFAcroRadioButton.fromDict = function(dict, ref) {
        return new PDFAcroRadioButton(dict, ref);
    };
    PDFAcroRadioButton.create = function(context) {
        var dict = context.obj({
            FT: "Btn",
            Ff: (0, $5e94843d22be1325$export$59f660e89ffb4f8a).Radio,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroRadioButton(dict, ref);
    };
    return PDFAcroRadioButton;
}((0, $5196cbf6a655b8e3$export$2e2bcd8739ae039));
var $30f61fd4202a189a$export$2e2bcd8739ae039 = $30f61fd4202a189a$var$PDFAcroRadioButton;





var $59LZ8 = parcelRequire("59LZ8");

var $ab4454ef96cbfb06$var$PDFAcroListBox = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFAcroListBox, _super);
    function PDFAcroListBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroListBox.fromDict = function(dict, ref) {
        return new PDFAcroListBox(dict, ref);
    };
    PDFAcroListBox.create = function(context) {
        var dict = context.obj({
            FT: "Ch",
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroListBox(dict, ref);
    };
    return PDFAcroListBox;
}((0, $91de3053180c437a$export$2e2bcd8739ae039));
var $ab4454ef96cbfb06$export$2e2bcd8739ae039 = $ab4454ef96cbfb06$var$PDFAcroListBox;



var $7fb7c3f967d1e895$export$34b4fb8893136c4c = function(kidDicts) {
    if (!kidDicts) return [];
    var kids = [];
    for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
        var ref = kidDicts.get(idx);
        var dict = kidDicts.lookup(idx);
        // if (dict instanceof PDFDict) kids.push(PDFAcroField.fromDict(dict));
        if (ref instanceof (0, $06a507a20ec07388$export$2e2bcd8739ae039) && dict instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039)) kids.push([
            $7fb7c3f967d1e895$export$fe770f59a8fbe6d(dict, ref),
            ref
        ]);
    }
    return kids;
};
var $7fb7c3f967d1e895$export$fe770f59a8fbe6d = function(dict, ref) {
    var isNonTerminal = $7fb7c3f967d1e895$var$isNonTerminalAcroField(dict);
    if (isNonTerminal) return (0, $7b9e672813fd3df8$export$2e2bcd8739ae039).fromDict(dict, ref);
    return $7fb7c3f967d1e895$var$createPDFAcroTerminal(dict, ref);
};
// TODO: Maybe just check if the dict is *not* a widget? That might be better.
// According to the PDF spec:
//
//   > A field's children in the hierarchy may also include widget annotations
//   > that define its appearance on the page. A field that has children that
//   > are fields is called a non-terminal field. A field that does not have
//   > children that are fields is called a terminal field.
//
// The spec is not entirely clear about how to determine whether a given
// dictionary represents an acrofield or a widget annotation. So we will assume
// that a dictionary is an acrofield if it is a member of the `/Kids` array
// and it contains a `/T` entry (widgets do not have `/T` entries). This isn't
// a bullet proof solution, because the `/T` entry is technically defined as
// optional for acrofields by the PDF spec. But in practice all acrofields seem
// to have a `/T` entry defined.
var $7fb7c3f967d1e895$var$isNonTerminalAcroField = function(dict) {
    var kids = dict.lookup((0, $a7yPZ.default).of("Kids"));
    if (kids instanceof (0, $7Igbp.default)) for(var idx = 0, len = kids.size(); idx < len; idx++){
        var kid = kids.lookup(idx);
        var kidIsField = kid instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039) && kid.has((0, $a7yPZ.default).of("T"));
        if (kidIsField) return true;
    }
    return false;
};
var $7fb7c3f967d1e895$var$createPDFAcroTerminal = function(dict, ref) {
    var ftNameOrRef = $7fb7c3f967d1e895$var$getInheritableAttribute(dict, (0, $a7yPZ.default).of("FT"));
    var type = dict.context.lookup(ftNameOrRef, (0, $a7yPZ.default));
    if (type === (0, $a7yPZ.default).of("Btn")) return $7fb7c3f967d1e895$var$createPDFAcroButton(dict, ref);
    if (type === (0, $a7yPZ.default).of("Ch")) return $7fb7c3f967d1e895$var$createPDFAcroChoice(dict, ref);
    if (type === (0, $a7yPZ.default).of("Tx")) return (0, $d6a62c64e2a348f0$export$2e2bcd8739ae039).fromDict(dict, ref);
    if (type === (0, $a7yPZ.default).of("Sig")) return (0, $7845f3837234047b$export$2e2bcd8739ae039).fromDict(dict, ref);
    // We should never reach this line. But there are a lot of weird PDFs out
    // there. So, just to be safe, we'll try to handle things gracefully instead
    // of throwing an error.
    return (0, $05ddbe3c6f42d8d9$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $7fb7c3f967d1e895$var$createPDFAcroButton = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $7fb7c3f967d1e895$var$getInheritableAttribute(dict, (0, $a7yPZ.default).of("Ff"));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $gcVIu.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($7fb7c3f967d1e895$var$flagIsSet(flags, (0, $5e94843d22be1325$export$59f660e89ffb4f8a).PushButton)) return (0, $cc8e0c206e3a3c82$export$2e2bcd8739ae039).fromDict(dict, ref);
    else if ($7fb7c3f967d1e895$var$flagIsSet(flags, (0, $5e94843d22be1325$export$59f660e89ffb4f8a).Radio)) return (0, $30f61fd4202a189a$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $4760db20b4fb4187$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $7fb7c3f967d1e895$var$createPDFAcroChoice = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $7fb7c3f967d1e895$var$getInheritableAttribute(dict, (0, $a7yPZ.default).of("Ff"));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $gcVIu.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($7fb7c3f967d1e895$var$flagIsSet(flags, (0, $5e94843d22be1325$export$eb88827058402599).Combo)) return (0, $4d501aeb209a28de$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $ab4454ef96cbfb06$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $7fb7c3f967d1e895$var$flagIsSet = function(flags, flag) {
    return (flags & flag) !== 0;
};
var $7fb7c3f967d1e895$var$getInheritableAttribute = function(startNode, name) {
    var attribute;
    $7fb7c3f967d1e895$var$ascend(startNode, function(node) {
        if (!attribute) attribute = node.get(name);
    });
    return attribute;
};
var $7fb7c3f967d1e895$var$ascend = function(startNode, visitor) {
    visitor(startNode);
    var Parent = startNode.lookupMaybe((0, $a7yPZ.default).of("Parent"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
    if (Parent) $7fb7c3f967d1e895$var$ascend(Parent, visitor);
};


var $8202ad3a40180808$var$PDFAcroForm = /** @class */ function() {
    function PDFAcroForm(dict) {
        this.dict = dict;
    }
    PDFAcroForm.prototype.Fields = function() {
        var fields = this.dict.lookup((0, $a7yPZ.default).of("Fields"));
        if (fields instanceof (0, $7Igbp.default)) return fields;
        return undefined;
    };
    PDFAcroForm.prototype.getFields = function() {
        var Fields = this.normalizedEntries().Fields;
        var fields = new Array(Fields.size());
        for(var idx = 0, len = Fields.size(); idx < len; idx++){
            var ref = Fields.get(idx);
            var dict = Fields.lookup(idx, (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
            fields[idx] = [
                (0, $7fb7c3f967d1e895$export$fe770f59a8fbe6d)(dict, ref),
                ref
            ];
        }
        return fields;
    };
    PDFAcroForm.prototype.getAllFields = function() {
        var allFields = [];
        var pushFields = function(fields) {
            if (!fields) return;
            for(var idx = 0, len = fields.length; idx < len; idx++){
                var field = fields[idx];
                allFields.push(field);
                var fieldModel = field[0];
                if (fieldModel instanceof (0, $7b9e672813fd3df8$export$2e2bcd8739ae039)) pushFields((0, $7fb7c3f967d1e895$export$34b4fb8893136c4c)(fieldModel.Kids()));
            }
        };
        pushFields(this.getFields());
        return allFields;
    };
    PDFAcroForm.prototype.addField = function(field) {
        var Fields = this.normalizedEntries().Fields;
        Fields === null || Fields === void 0 || Fields.push(field);
    };
    PDFAcroForm.prototype.removeField = function(field) {
        var parent = field.getParent();
        var fields = parent === undefined ? this.normalizedEntries().Fields : parent.Kids();
        var index = fields === null || fields === void 0 ? void 0 : fields.indexOf(field.ref);
        if (fields === undefined || index === undefined) throw new Error("Tried to remove inexistent field " + field.getFullyQualifiedName());
        fields.remove(index);
        if (parent !== undefined && fields.size() === 0) this.removeField(parent);
    };
    PDFAcroForm.prototype.normalizedEntries = function() {
        var Fields = this.Fields();
        if (!Fields) {
            Fields = this.dict.context.obj([]);
            this.dict.set((0, $a7yPZ.default).of("Fields"), Fields);
        }
        return {
            Fields: Fields
        };
    };
    PDFAcroForm.fromDict = function(dict) {
        return new PDFAcroForm(dict);
    };
    PDFAcroForm.create = function(context) {
        var dict = context.obj({
            Fields: []
        });
        return new PDFAcroForm(dict);
    };
    return PDFAcroForm;
}();
var $8202ad3a40180808$export$2e2bcd8739ae039 = $8202ad3a40180808$var$PDFAcroForm;














var $gbXzY = parcelRequire("gbXzY");
var $b7fffe878ca6f446$var$PDFCatalog = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFCatalog, _super);
    function PDFCatalog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFCatalog.prototype.Pages = function() {
        return this.lookup((0, $a7yPZ.default).of("Pages"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.AcroForm = function() {
        return this.lookupMaybe((0, $a7yPZ.default).of("AcroForm"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getAcroForm = function() {
        var dict = this.AcroForm();
        if (!dict) return undefined;
        return (0, $8202ad3a40180808$export$2e2bcd8739ae039).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateAcroForm = function() {
        var acroForm = this.getAcroForm();
        if (!acroForm) {
            acroForm = (0, $8202ad3a40180808$export$2e2bcd8739ae039).create(this.context);
            var acroFormRef = this.context.register(acroForm.dict);
            this.set((0, $a7yPZ.default).of("AcroForm"), acroFormRef);
        }
        return acroForm;
    };
    PDFCatalog.prototype.ViewerPreferences = function() {
        return this.lookupMaybe((0, $a7yPZ.default).of("ViewerPreferences"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getViewerPreferences = function() {
        var dict = this.ViewerPreferences();
        if (!dict) return undefined;
        return (0, $gbXzY.default).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateViewerPreferences = function() {
        var viewerPrefs = this.getViewerPreferences();
        if (!viewerPrefs) {
            viewerPrefs = (0, $gbXzY.default).create(this.context);
            var viewerPrefsRef = this.context.register(viewerPrefs.dict);
            this.set((0, $a7yPZ.default).of("ViewerPreferences"), viewerPrefsRef);
        }
        return viewerPrefs;
    };
    /**
     * Inserts the given ref as a leaf node of this catalog's page tree at the
     * specified index (zero-based). Also increments the `Count` of each node in
     * the page tree hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted.
     */ PDFCatalog.prototype.insertLeafNode = function(leafRef, index) {
        var pagesRef = this.get((0, $a7yPZ.default).of("Pages"));
        var maybeParentRef = this.Pages().insertLeafNode(leafRef, index);
        return maybeParentRef || pagesRef;
    };
    PDFCatalog.prototype.removeLeafNode = function(index) {
        this.Pages().removeLeafNode(index);
    };
    PDFCatalog.withContextAndPages = function(context, pages) {
        var dict = new Map();
        dict.set((0, $a7yPZ.default).of("Type"), (0, $a7yPZ.default).of("Catalog"));
        dict.set((0, $a7yPZ.default).of("Pages"), pages);
        return new PDFCatalog(dict, context);
    };
    PDFCatalog.fromMapWithContext = function(map, context) {
        return new PDFCatalog(map, context);
    };
    return PDFCatalog;
}((0, $f437c135fa674ebe$export$2e2bcd8739ae039));
var $b7fffe878ca6f446$export$2e2bcd8739ae039 = $b7fffe878ca6f446$var$PDFCatalog;






var $59LZ8 = parcelRequire("59LZ8");

var $7Igbp = parcelRequire("7Igbp");


var $a7yPZ = parcelRequire("a7yPZ");

var $gcVIu = parcelRequire("gcVIu");


var $1cWQu = parcelRequire("1cWQu");
var $10777101caa9695d$var$PDFPageTree = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFPageTree, _super);
    function PDFPageTree() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFPageTree.prototype.Parent = function() {
        return this.lookup((0, $a7yPZ.default).of("Parent"));
    };
    PDFPageTree.prototype.Kids = function() {
        return this.lookup((0, $a7yPZ.default).of("Kids"), (0, $7Igbp.default));
    };
    PDFPageTree.prototype.Count = function() {
        return this.lookup((0, $a7yPZ.default).of("Count"), (0, $gcVIu.default));
    };
    PDFPageTree.prototype.pushTreeNode = function(treeRef) {
        var Kids = this.Kids();
        Kids.push(treeRef);
    };
    PDFPageTree.prototype.pushLeafNode = function(leafRef) {
        var Kids = this.Kids();
        this.insertLeafKid(Kids.size(), leafRef);
    };
    /**
     * Inserts the given ref as a leaf node of this page tree at the specified
     * index (zero-based). Also increments the `Count` of each page tree in the
     * hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted,
     * or `undefined` if it was inserted into the root node (the PDFPageTree upon
     * which the method was first called).
     */ PDFPageTree.prototype.insertLeafNode = function(leafRef, targetIndex) {
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex > Count) throw new (0, $1cWQu.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            if (leafsRemainingUntilTarget === 0) {
                // Insert page and return
                this.insertLeafKid(idx, leafRef);
                return undefined;
            }
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) // Dig in
                return kid.insertLeafNode(leafRef, leafsRemainingUntilTarget) || kidRef;
                else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $b808f27f9a7c9955$export$2e2bcd8739ae039)) // Move on
            leafsRemainingUntilTarget -= 1;
        }
        if (leafsRemainingUntilTarget === 0) {
            // Insert page at the end and return
            this.insertLeafKid(Kids.size(), leafRef);
            return undefined;
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $1cWQu.CorruptPageTreeError)(targetIndex, "insertLeafNode");
    };
    /**
     * Removes the leaf node at the specified index (zero-based) from this page
     * tree. Also decrements the `Count` of each page tree in the hierarchy to
     * account for the removed page.
     *
     * If `prune` is true, then intermediate tree nodes will be removed from the
     * tree if they contain 0 children after the leaf node is removed.
     */ PDFPageTree.prototype.removeLeafNode = function(targetIndex, prune) {
        if (prune === void 0) prune = true;
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex >= Count) throw new (0, $1cWQu.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) {
                    // Dig in
                    kid.removeLeafNode(leafsRemainingUntilTarget, prune);
                    if (prune && kid.Kids().size() === 0) Kids.remove(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $b808f27f9a7c9955$export$2e2bcd8739ae039)) {
                if (leafsRemainingUntilTarget === 0) {
                    // Remove page and return
                    this.removeKid(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= 1;
            }
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $1cWQu.CorruptPageTreeError)(targetIndex, "removeLeafNode");
    };
    PDFPageTree.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    /** Performs a Post-Order traversal of this page tree */ PDFPageTree.prototype.traverse = function(visitor) {
        var Kids = this.Kids();
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) kid.traverse(visitor);
            visitor(kid, kidRef);
        }
    };
    PDFPageTree.prototype.insertLeafKid = function(kidIdx, leafRef) {
        var Kids = this.Kids();
        this.ascend(function(node) {
            var newCount = node.Count().asNumber() + 1;
            node.set((0, $a7yPZ.default).of("Count"), (0, $gcVIu.default).of(newCount));
        });
        Kids.insert(kidIdx, leafRef);
    };
    PDFPageTree.prototype.removeKid = function(kidIdx) {
        var Kids = this.Kids();
        var kid = Kids.lookup(kidIdx);
        if (kid instanceof (0, $b808f27f9a7c9955$export$2e2bcd8739ae039)) this.ascend(function(node) {
            var newCount = node.Count().asNumber() - 1;
            node.set((0, $a7yPZ.default).of("Count"), (0, $gcVIu.default).of(newCount));
        });
        Kids.remove(kidIdx);
    };
    PDFPageTree.withContext = function(context, parent) {
        var dict = new Map();
        dict.set((0, $a7yPZ.default).of("Type"), (0, $a7yPZ.default).of("Pages"));
        dict.set((0, $a7yPZ.default).of("Kids"), context.obj([]));
        dict.set((0, $a7yPZ.default).of("Count"), context.obj(0));
        if (parent) dict.set((0, $a7yPZ.default).of("Parent"), parent);
        return new PDFPageTree(dict, context);
    };
    PDFPageTree.fromMapWithContext = function(map, context) {
        return new PDFPageTree(map, context);
    };
    return PDFPageTree;
}((0, $f437c135fa674ebe$export$2e2bcd8739ae039));
var $10777101caa9695d$export$2e2bcd8739ae039 = $10777101caa9695d$var$PDFPageTree;







var $59LZ8 = parcelRequire("59LZ8");

var $1cWQu = parcelRequire("1cWQu");

var $7Igbp = parcelRequire("7Igbp");

var $evfTd = parcelRequire("evfTd");



var $a7yPZ = parcelRequire("a7yPZ");


var $gcVIu = parcelRequire("gcVIu");




var $1cWQu = parcelRequire("1cWQu");

var $5ZWJa = parcelRequire("5ZWJa");

var $5ZWJa = parcelRequire("5ZWJa");
var $714371482519b4af$export$9492c31549e88980 = new Uint8Array(256);
$714371482519b4af$export$9492c31549e88980[(0, $5ZWJa.default).Zero] = 1;
$714371482519b4af$export$9492c31549e88980[(0, $5ZWJa.default).One] = 1;
$714371482519b4af$export$9492c31549e88980[(0, $5ZWJa.default).Two] = 1;
$714371482519b4af$export$9492c31549e88980[(0, $5ZWJa.default).Three] = 1;
$714371482519b4af$export$9492c31549e88980[(0, $5ZWJa.default).Four] = 1;
$714371482519b4af$export$9492c31549e88980[(0, $5ZWJa.default).Five] = 1;
$714371482519b4af$export$9492c31549e88980[(0, $5ZWJa.default).Six] = 1;
$714371482519b4af$export$9492c31549e88980[(0, $5ZWJa.default).Seven] = 1;
$714371482519b4af$export$9492c31549e88980[(0, $5ZWJa.default).Eight] = 1;
$714371482519b4af$export$9492c31549e88980[(0, $5ZWJa.default).Nine] = 1;
var $714371482519b4af$export$d438b84505bee68c = new Uint8Array(256);
$714371482519b4af$export$d438b84505bee68c[(0, $5ZWJa.default).Period] = 1;
$714371482519b4af$export$d438b84505bee68c[(0, $5ZWJa.default).Plus] = 1;
$714371482519b4af$export$d438b84505bee68c[(0, $5ZWJa.default).Minus] = 1;
var $714371482519b4af$export$4d926b029fa61cfe = new Uint8Array(256);
for(var $714371482519b4af$var$idx = 0, $714371482519b4af$var$len = 256; $714371482519b4af$var$idx < $714371482519b4af$var$len; $714371482519b4af$var$idx++)$714371482519b4af$export$4d926b029fa61cfe[$714371482519b4af$var$idx] = $714371482519b4af$export$9492c31549e88980[$714371482519b4af$var$idx] || $714371482519b4af$export$d438b84505bee68c[$714371482519b4af$var$idx] ? 1 : 0;



var $3dQGf = parcelRequire("3dQGf");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $b39cd123962c4e28$var$Newline = (0, $5ZWJa.default).Newline, $b39cd123962c4e28$var$CarriageReturn = (0, $5ZWJa.default).CarriageReturn;
// TODO: Throw error if eof is reached before finishing object parse...
var $b39cd123962c4e28$var$BaseParser = /** @class */ function() {
    function BaseParser(bytes, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        this.bytes = bytes;
        this.capNumbers = capNumbers;
    }
    BaseParser.prototype.parseRawInt = function() {
        var value = "";
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $714371482519b4af$export$9492c31549e88980)[byte]) break;
            value += (0, $cZKSB.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $1cWQu.NumberParsingError)(this.bytes.position(), value);
        return numberValue;
    };
    // TODO: Maybe handle exponential format?
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    BaseParser.prototype.parseRawNumber = function() {
        var value = "";
        // Parse integer-part, the leading (+ | - | . | 0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $714371482519b4af$export$4d926b029fa61cfe)[byte]) break;
            value += (0, $cZKSB.charFromCode)(this.bytes.next());
            if (byte === (0, $5ZWJa.default).Period) break;
        }
        // Parse decimal-part, the trailing (0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $714371482519b4af$export$9492c31549e88980)[byte]) break;
            value += (0, $cZKSB.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $1cWQu.NumberParsingError)(this.bytes.position(), value);
        if (numberValue > Number.MAX_SAFE_INTEGER) {
            if (this.capNumbers) {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", using Number.MAX_SAFE_INTEGER instead.";
                console.warn(msg);
                return Number.MAX_SAFE_INTEGER;
            } else {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", not capping.";
                console.warn(msg);
            }
        }
        return numberValue;
    };
    BaseParser.prototype.skipWhitespace = function() {
        while(!this.bytes.done() && (0, $3dQGf.IsWhitespace)[this.bytes.peek()])this.bytes.next();
    };
    BaseParser.prototype.skipLine = function() {
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $b39cd123962c4e28$var$Newline || byte === $b39cd123962c4e28$var$CarriageReturn) return;
            this.bytes.next();
        }
    };
    BaseParser.prototype.skipComment = function() {
        if (this.bytes.peek() !== (0, $5ZWJa.default).Percent) return false;
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $b39cd123962c4e28$var$Newline || byte === $b39cd123962c4e28$var$CarriageReturn) return true;
            this.bytes.next();
        }
        return true;
    };
    BaseParser.prototype.skipWhitespaceAndComments = function() {
        this.skipWhitespace();
        while(this.skipComment())this.skipWhitespace();
    };
    BaseParser.prototype.matchKeyword = function(keyword) {
        var initialOffset = this.bytes.offset();
        for(var idx = 0, len = keyword.length; idx < len; idx++)if (this.bytes.done() || this.bytes.next() !== keyword[idx]) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
        return true;
    };
    return BaseParser;
}();
var $b39cd123962c4e28$export$2e2bcd8739ae039 = $b39cd123962c4e28$var$BaseParser;



var $1cWQu = parcelRequire("1cWQu");


var $5ZWJa = parcelRequire("5ZWJa");
// TODO: See how line/col tracking affects performance
var $68b512220925acaf$var$ByteStream = /** @class */ function() {
    function ByteStream(bytes) {
        this.idx = 0;
        this.line = 0;
        this.column = 0;
        this.bytes = bytes;
        this.length = this.bytes.length;
    }
    ByteStream.prototype.moveTo = function(offset) {
        this.idx = offset;
    };
    ByteStream.prototype.next = function() {
        var byte = this.bytes[this.idx++];
        if (byte === (0, $5ZWJa.default).Newline) {
            this.line += 1;
            this.column = 0;
        } else this.column += 1;
        return byte;
    };
    ByteStream.prototype.assertNext = function(expected) {
        if (this.peek() !== expected) throw new (0, $1cWQu.NextByteAssertionError)(this.position(), expected, this.peek());
        return this.next();
    };
    ByteStream.prototype.peek = function() {
        return this.bytes[this.idx];
    };
    ByteStream.prototype.peekAhead = function(steps) {
        return this.bytes[this.idx + steps];
    };
    ByteStream.prototype.peekAt = function(offset) {
        return this.bytes[offset];
    };
    ByteStream.prototype.done = function() {
        return this.idx >= this.length;
    };
    ByteStream.prototype.offset = function() {
        return this.idx;
    };
    ByteStream.prototype.slice = function(start, end) {
        return this.bytes.slice(start, end);
    };
    ByteStream.prototype.position = function() {
        return {
            line: this.line,
            column: this.column,
            offset: this.idx
        };
    };
    ByteStream.of = function(bytes) {
        return new ByteStream(bytes);
    };
    ByteStream.fromPDFRawStream = function(rawStream) {
        return ByteStream.of((0, $1b710cd3e7711338$export$b8317e68ca978594)(rawStream).decode());
    };
    return ByteStream;
}();
var $68b512220925acaf$export$2e2bcd8739ae039 = $68b512220925acaf$var$ByteStream;






var $5ZWJa = parcelRequire("5ZWJa");

var $hV4t3 = parcelRequire("hV4t3");

var $59LZ8 = parcelRequire("59LZ8");

var $5ZWJa = parcelRequire("5ZWJa");
var $0a24692a8647bc1a$var$Space = (0, $5ZWJa.default).Space, $0a24692a8647bc1a$var$CarriageReturn = (0, $5ZWJa.default).CarriageReturn, $0a24692a8647bc1a$var$Newline = (0, $5ZWJa.default).Newline;
var $0a24692a8647bc1a$var$stream = [
    (0, $5ZWJa.default).s,
    (0, $5ZWJa.default).t,
    (0, $5ZWJa.default).r,
    (0, $5ZWJa.default).e,
    (0, $5ZWJa.default).a,
    (0, $5ZWJa.default).m
];
var $0a24692a8647bc1a$var$endstream = [
    (0, $5ZWJa.default).e,
    (0, $5ZWJa.default).n,
    (0, $5ZWJa.default).d,
    (0, $5ZWJa.default).s,
    (0, $5ZWJa.default).t,
    (0, $5ZWJa.default).r,
    (0, $5ZWJa.default).e,
    (0, $5ZWJa.default).a,
    (0, $5ZWJa.default).m
];
var $0a24692a8647bc1a$export$93ad50ccfacdd77 = {
    header: [
        (0, $5ZWJa.default).Percent,
        (0, $5ZWJa.default).P,
        (0, $5ZWJa.default).D,
        (0, $5ZWJa.default).F,
        (0, $5ZWJa.default).Dash
    ],
    eof: [
        (0, $5ZWJa.default).Percent,
        (0, $5ZWJa.default).Percent,
        (0, $5ZWJa.default).E,
        (0, $5ZWJa.default).O,
        (0, $5ZWJa.default).F
    ],
    obj: [
        (0, $5ZWJa.default).o,
        (0, $5ZWJa.default).b,
        (0, $5ZWJa.default).j
    ],
    endobj: [
        (0, $5ZWJa.default).e,
        (0, $5ZWJa.default).n,
        (0, $5ZWJa.default).d,
        (0, $5ZWJa.default).o,
        (0, $5ZWJa.default).b,
        (0, $5ZWJa.default).j
    ],
    xref: [
        (0, $5ZWJa.default).x,
        (0, $5ZWJa.default).r,
        (0, $5ZWJa.default).e,
        (0, $5ZWJa.default).f
    ],
    trailer: [
        (0, $5ZWJa.default).t,
        (0, $5ZWJa.default).r,
        (0, $5ZWJa.default).a,
        (0, $5ZWJa.default).i,
        (0, $5ZWJa.default).l,
        (0, $5ZWJa.default).e,
        (0, $5ZWJa.default).r
    ],
    startxref: [
        (0, $5ZWJa.default).s,
        (0, $5ZWJa.default).t,
        (0, $5ZWJa.default).a,
        (0, $5ZWJa.default).r,
        (0, $5ZWJa.default).t,
        (0, $5ZWJa.default).x,
        (0, $5ZWJa.default).r,
        (0, $5ZWJa.default).e,
        (0, $5ZWJa.default).f
    ],
    true: [
        (0, $5ZWJa.default).t,
        (0, $5ZWJa.default).r,
        (0, $5ZWJa.default).u,
        (0, $5ZWJa.default).e
    ],
    false: [
        (0, $5ZWJa.default).f,
        (0, $5ZWJa.default).a,
        (0, $5ZWJa.default).l,
        (0, $5ZWJa.default).s,
        (0, $5ZWJa.default).e
    ],
    null: [
        (0, $5ZWJa.default).n,
        (0, $5ZWJa.default).u,
        (0, $5ZWJa.default).l,
        (0, $5ZWJa.default).l
    ],
    stream: $0a24692a8647bc1a$var$stream,
    streamEOF1: (0, $59LZ8.__spreadArrays)($0a24692a8647bc1a$var$stream, [
        $0a24692a8647bc1a$var$Space,
        $0a24692a8647bc1a$var$CarriageReturn,
        $0a24692a8647bc1a$var$Newline
    ]),
    streamEOF2: (0, $59LZ8.__spreadArrays)($0a24692a8647bc1a$var$stream, [
        $0a24692a8647bc1a$var$CarriageReturn,
        $0a24692a8647bc1a$var$Newline
    ]),
    streamEOF3: (0, $59LZ8.__spreadArrays)($0a24692a8647bc1a$var$stream, [
        $0a24692a8647bc1a$var$CarriageReturn
    ]),
    streamEOF4: (0, $59LZ8.__spreadArrays)($0a24692a8647bc1a$var$stream, [
        $0a24692a8647bc1a$var$Newline
    ]),
    endstream: $0a24692a8647bc1a$var$endstream,
    EOF1endstream: (0, $59LZ8.__spreadArrays)([
        $0a24692a8647bc1a$var$CarriageReturn,
        $0a24692a8647bc1a$var$Newline
    ], $0a24692a8647bc1a$var$endstream),
    EOF2endstream: (0, $59LZ8.__spreadArrays)([
        $0a24692a8647bc1a$var$CarriageReturn
    ], $0a24692a8647bc1a$var$endstream),
    EOF3endstream: (0, $59LZ8.__spreadArrays)([
        $0a24692a8647bc1a$var$Newline
    ], $0a24692a8647bc1a$var$endstream)
};




var $3dQGf = parcelRequire("3dQGf");
parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
// TODO: Throw error if eof is reached before finishing object parse...
var $188fe2318991c893$var$PDFObjectParser = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFObjectParser, _super);
    function PDFObjectParser(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, byteStream, capNumbers) || this;
        _this.context = context;
        return _this;
    }
    // TODO: Is it possible to reduce duplicate parsing for ref lookaheads?
    PDFObjectParser.prototype.parseObject = function() {
        this.skipWhitespaceAndComments();
        if (this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).true)) return (0, $evfTd.default).True;
        if (this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).false)) return (0, $evfTd.default).False;
        if (this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).null)) return 0, $3923dd19d4d56cea$export$2e2bcd8739ae039;
        var byte = this.bytes.peek();
        if (byte === (0, $5ZWJa.default).LessThan && this.bytes.peekAhead(1) === (0, $5ZWJa.default).LessThan) return this.parseDictOrStream();
        if (byte === (0, $5ZWJa.default).LessThan) return this.parseHexString();
        if (byte === (0, $5ZWJa.default).LeftParen) return this.parseString();
        if (byte === (0, $5ZWJa.default).ForwardSlash) return this.parseName();
        if (byte === (0, $5ZWJa.default).LeftSquareBracket) return this.parseArray();
        if ((0, $714371482519b4af$export$4d926b029fa61cfe)[byte]) return this.parseNumberOrRef();
        throw new (0, $1cWQu.PDFObjectParsingError)(this.bytes.position(), byte);
    };
    PDFObjectParser.prototype.parseNumberOrRef = function() {
        var firstNum = this.parseRawNumber();
        this.skipWhitespaceAndComments();
        var lookaheadStart = this.bytes.offset();
        if ((0, $714371482519b4af$export$9492c31549e88980)[this.bytes.peek()]) {
            var secondNum = this.parseRawNumber();
            this.skipWhitespaceAndComments();
            if (this.bytes.peek() === (0, $5ZWJa.default).R) {
                this.bytes.assertNext((0, $5ZWJa.default).R);
                return (0, $06a507a20ec07388$export$2e2bcd8739ae039).of(firstNum, secondNum);
            }
        }
        this.bytes.moveTo(lookaheadStart);
        return (0, $gcVIu.default).of(firstNum);
    };
    // TODO: Maybe update PDFHexString.of() logic to remove whitespace and validate input?
    PDFObjectParser.prototype.parseHexString = function() {
        var value = "";
        this.bytes.assertNext((0, $5ZWJa.default).LessThan);
        while(!this.bytes.done() && this.bytes.peek() !== (0, $5ZWJa.default).GreaterThan)value += (0, $cZKSB.charFromCode)(this.bytes.next());
        this.bytes.assertNext((0, $5ZWJa.default).GreaterThan);
        return (0, $97a582c32ae6773b$export$2e2bcd8739ae039).of(value);
    };
    PDFObjectParser.prototype.parseString = function() {
        var nestingLvl = 0;
        var isEscaped = false;
        var value = "";
        while(!this.bytes.done()){
            var byte = this.bytes.next();
            value += (0, $cZKSB.charFromCode)(byte);
            // Check for unescaped parenthesis
            if (!isEscaped) {
                if (byte === (0, $5ZWJa.default).LeftParen) nestingLvl += 1;
                if (byte === (0, $5ZWJa.default).RightParen) nestingLvl -= 1;
            }
            // Track whether current character is being escaped or not
            if (byte === (0, $5ZWJa.default).BackSlash) isEscaped = !isEscaped;
            else if (isEscaped) isEscaped = false;
            // Once (if) the unescaped parenthesis balance out, return their contents
            if (nestingLvl === 0) // Remove the outer parens so they aren't part of the contents
            return (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039).of(value.substring(1, value.length - 1));
        }
        throw new (0, $1cWQu.UnbalancedParenthesisError)(this.bytes.position());
    };
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    // TODO: Maybe preallocate small Uint8Array if can use charFromCode?
    PDFObjectParser.prototype.parseName = function() {
        this.bytes.assertNext((0, $5ZWJa.default).ForwardSlash);
        var name = "";
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if ((0, $3dQGf.IsWhitespace)[byte] || (0, $hV4t3.IsDelimiter)[byte]) break;
            name += (0, $cZKSB.charFromCode)(byte);
            this.bytes.next();
        }
        return (0, $a7yPZ.default).of(name);
    };
    PDFObjectParser.prototype.parseArray = function() {
        this.bytes.assertNext((0, $5ZWJa.default).LeftSquareBracket);
        this.skipWhitespaceAndComments();
        var pdfArray = (0, $7Igbp.default).withContext(this.context);
        while(this.bytes.peek() !== (0, $5ZWJa.default).RightSquareBracket){
            var element = this.parseObject();
            pdfArray.push(element);
            this.skipWhitespaceAndComments();
        }
        this.bytes.assertNext((0, $5ZWJa.default).RightSquareBracket);
        return pdfArray;
    };
    PDFObjectParser.prototype.parseDict = function() {
        this.bytes.assertNext((0, $5ZWJa.default).LessThan);
        this.bytes.assertNext((0, $5ZWJa.default).LessThan);
        this.skipWhitespaceAndComments();
        var dict = new Map();
        while(!this.bytes.done() && this.bytes.peek() !== (0, $5ZWJa.default).GreaterThan && this.bytes.peekAhead(1) !== (0, $5ZWJa.default).GreaterThan){
            var key = this.parseName();
            var value = this.parseObject();
            dict.set(key, value);
            this.skipWhitespaceAndComments();
        }
        this.skipWhitespaceAndComments();
        this.bytes.assertNext((0, $5ZWJa.default).GreaterThan);
        this.bytes.assertNext((0, $5ZWJa.default).GreaterThan);
        var Type = dict.get((0, $a7yPZ.default).of("Type"));
        if (Type === (0, $a7yPZ.default).of("Catalog")) return (0, $b7fffe878ca6f446$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $a7yPZ.default).of("Pages")) return (0, $10777101caa9695d$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $a7yPZ.default).of("Page")) return (0, $b808f27f9a7c9955$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else return (0, $f437c135fa674ebe$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
    };
    PDFObjectParser.prototype.parseDictOrStream = function() {
        var startPos = this.bytes.position();
        var dict = this.parseDict();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).streamEOF1) && !this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).streamEOF2) && !this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).streamEOF3) && !this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).streamEOF4) && !this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).stream)) return dict;
        var start = this.bytes.offset();
        var end;
        var Length = dict.get((0, $a7yPZ.default).of("Length"));
        if (Length instanceof (0, $gcVIu.default)) {
            end = start + Length.asNumber();
            this.bytes.moveTo(end);
            this.skipWhitespaceAndComments();
            if (!this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).endstream)) {
                this.bytes.moveTo(start);
                end = this.findEndOfStreamFallback(startPos);
            }
        } else end = this.findEndOfStreamFallback(startPos);
        var contents = this.bytes.slice(start, end);
        return (0, $6f2895f4e287e745$export$2e2bcd8739ae039).of(dict, contents);
    };
    PDFObjectParser.prototype.findEndOfStreamFallback = function(startPos) {
        // Move to end of stream, while handling nested streams
        var nestingLvl = 1;
        var end = this.bytes.offset();
        while(!this.bytes.done()){
            end = this.bytes.offset();
            if (this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).stream)) nestingLvl += 1;
            else if (this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).EOF1endstream) || this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).EOF2endstream) || this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).EOF3endstream) || this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).endstream)) nestingLvl -= 1;
            else this.bytes.next();
            if (nestingLvl === 0) break;
        }
        if (nestingLvl !== 0) throw new (0, $1cWQu.PDFStreamParsingError)(startPos);
        return end;
    };
    PDFObjectParser.forBytes = function(bytes, context, capNumbers) {
        return new PDFObjectParser((0, $68b512220925acaf$export$2e2bcd8739ae039).of(bytes), context, capNumbers);
    };
    PDFObjectParser.forByteStream = function(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        return new PDFObjectParser(byteStream, context, capNumbers);
    };
    return PDFObjectParser;
}((0, $b39cd123962c4e28$export$2e2bcd8739ae039));
var $188fe2318991c893$export$2e2bcd8739ae039 = $188fe2318991c893$var$PDFObjectParser;



var $59LZ8 = parcelRequire("59LZ8");

var $1cWQu = parcelRequire("1cWQu");

var $a7yPZ = parcelRequire("a7yPZ");

var $gcVIu = parcelRequire("gcVIu");



parcelRequire("6vLBB");
var $egzXy = parcelRequire("egzXy");
var $48f2c18652de9099$var$PDFObjectStreamParser = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFObjectStreamParser, _super);
    function PDFObjectStreamParser(rawStream, shouldWaitForTick) {
        var _this = _super.call(this, (0, $68b512220925acaf$export$2e2bcd8739ae039).fromPDFRawStream(rawStream), rawStream.dict.context) || this;
        var dict = rawStream.dict;
        _this.alreadyParsed = false;
        _this.shouldWaitForTick = shouldWaitForTick || function() {
            return false;
        };
        _this.firstOffset = dict.lookup((0, $a7yPZ.default).of("First"), (0, $gcVIu.default)).asNumber();
        _this.objectCount = dict.lookup((0, $a7yPZ.default).of("N"), (0, $gcVIu.default)).asNumber();
        return _this;
    }
    PDFObjectStreamParser.prototype.parseIntoContext = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var offsetsAndObjectNumbers, idx, len, _a, objectNumber, offset, object, ref;
            return (0, $59LZ8.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $1cWQu.ReparseError)("PDFObjectStreamParser", "parseIntoContext");
                        this.alreadyParsed = true;
                        offsetsAndObjectNumbers = this.parseOffsetsAndObjectNumbers();
                        idx = 0, len = offsetsAndObjectNumbers.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = offsetsAndObjectNumbers[idx], objectNumber = _a.objectNumber, offset = _a.offset;
                        this.bytes.moveTo(this.firstOffset + offset);
                        object = this.parseObject();
                        ref = (0, $06a507a20ec07388$export$2e2bcd8739ae039).of(objectNumber, 0);
                        this.context.assign(ref, object);
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $egzXy.waitForTick)()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFObjectStreamParser.prototype.parseOffsetsAndObjectNumbers = function() {
        var offsetsAndObjectNumbers = [];
        for(var idx = 0, len = this.objectCount; idx < len; idx++){
            this.skipWhitespaceAndComments();
            var objectNumber = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var offset = this.parseRawInt();
            offsetsAndObjectNumbers.push({
                objectNumber: objectNumber,
                offset: offset
            });
        }
        return offsetsAndObjectNumbers;
    };
    PDFObjectStreamParser.forStream = function(rawStream, shouldWaitForTick) {
        return new PDFObjectStreamParser(rawStream, shouldWaitForTick);
    };
    return PDFObjectStreamParser;
}((0, $188fe2318991c893$export$2e2bcd8739ae039));
var $48f2c18652de9099$export$2e2bcd8739ae039 = $48f2c18652de9099$var$PDFObjectStreamParser;



var $59LZ8 = parcelRequire("59LZ8");




var $1cWQu = parcelRequire("1cWQu");



var $a7yPZ = parcelRequire("a7yPZ");






var $1cWQu = parcelRequire("1cWQu");

var $7Igbp = parcelRequire("7Igbp");

var $a7yPZ = parcelRequire("a7yPZ");

var $gcVIu = parcelRequire("gcVIu");


var $669523748b60c827$var$PDFXRefStreamParser = /** @class */ function() {
    function PDFXRefStreamParser(rawStream) {
        this.alreadyParsed = false;
        this.dict = rawStream.dict;
        this.bytes = (0, $68b512220925acaf$export$2e2bcd8739ae039).fromPDFRawStream(rawStream);
        this.context = this.dict.context;
        var Size = this.dict.lookup((0, $a7yPZ.default).of("Size"), (0, $gcVIu.default));
        var Index = this.dict.lookup((0, $a7yPZ.default).of("Index"));
        if (Index instanceof (0, $7Igbp.default)) {
            this.subsections = [];
            for(var idx = 0, len = Index.size(); idx < len; idx += 2){
                var firstObjectNumber = Index.lookup(idx + 0, (0, $gcVIu.default)).asNumber();
                var length_1 = Index.lookup(idx + 1, (0, $gcVIu.default)).asNumber();
                this.subsections.push({
                    firstObjectNumber: firstObjectNumber,
                    length: length_1
                });
            }
        } else this.subsections = [
            {
                firstObjectNumber: 0,
                length: Size.asNumber()
            }
        ];
        var W = this.dict.lookup((0, $a7yPZ.default).of("W"), (0, $7Igbp.default));
        this.byteWidths = [
            -1,
            -1,
            -1
        ];
        for(var idx = 0, len = W.size(); idx < len; idx++)this.byteWidths[idx] = W.lookup(idx, (0, $gcVIu.default)).asNumber();
    }
    PDFXRefStreamParser.prototype.parseIntoContext = function() {
        if (this.alreadyParsed) throw new (0, $1cWQu.ReparseError)("PDFXRefStreamParser", "parseIntoContext");
        this.alreadyParsed = true;
        this.context.trailerInfo = {
            Root: this.dict.get((0, $a7yPZ.default).of("Root")),
            Encrypt: this.dict.get((0, $a7yPZ.default).of("Encrypt")),
            Info: this.dict.get((0, $a7yPZ.default).of("Info")),
            ID: this.dict.get((0, $a7yPZ.default).of("ID"))
        };
        var entries = this.parseEntries();
        // for (let idx = 0, len = entries.length; idx < len; idx++) {
        // const entry = entries[idx];
        // if (entry.deleted) this.context.delete(entry.ref);
        // }
        return entries;
    };
    PDFXRefStreamParser.prototype.parseEntries = function() {
        var entries = [];
        var _a = this.byteWidths, typeFieldWidth = _a[0], offsetFieldWidth = _a[1], genFieldWidth = _a[2];
        for(var subsectionIdx = 0, subsectionLen = this.subsections.length; subsectionIdx < subsectionLen; subsectionIdx++){
            var _b = this.subsections[subsectionIdx], firstObjectNumber = _b.firstObjectNumber, length_2 = _b.length;
            for(var objIdx = 0; objIdx < length_2; objIdx++){
                var type = 0;
                for(var idx = 0, len = typeFieldWidth; idx < len; idx++)type = type << 8 | this.bytes.next();
                var offset = 0;
                for(var idx = 0, len = offsetFieldWidth; idx < len; idx++)offset = offset << 8 | this.bytes.next();
                var generationNumber = 0;
                for(var idx = 0, len = genFieldWidth; idx < len; idx++)generationNumber = generationNumber << 8 | this.bytes.next();
                // When the `type` field is absent, it defaults to 1
                if (typeFieldWidth === 0) type = 1;
                var objectNumber = firstObjectNumber + objIdx;
                var entry = {
                    ref: (0, $06a507a20ec07388$export$2e2bcd8739ae039).of(objectNumber, generationNumber),
                    offset: offset,
                    deleted: type === 0,
                    inObjectStream: type === 2
                };
                entries.push(entry);
            }
        }
        return entries;
    };
    PDFXRefStreamParser.forStream = function(rawStream) {
        return new PDFXRefStreamParser(rawStream);
    };
    return PDFXRefStreamParser;
}();
var $669523748b60c827$export$2e2bcd8739ae039 = $669523748b60c827$var$PDFXRefStreamParser;




var $5ZWJa = parcelRequire("5ZWJa");


parcelRequire("6vLBB");
var $egzXy = parcelRequire("egzXy");
var $04db4ec857fd3d28$var$PDFParser = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFParser, _super);
    function PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        if (objectsPerTick === void 0) objectsPerTick = Infinity;
        if (throwOnInvalidObject === void 0) throwOnInvalidObject = false;
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, (0, $68b512220925acaf$export$2e2bcd8739ae039).of(pdfBytes), (0, $e9a9ba426f46b6eb$export$2e2bcd8739ae039).create(), capNumbers) || this;
        _this.alreadyParsed = false;
        _this.parsedObjects = 0;
        _this.shouldWaitForTick = function() {
            _this.parsedObjects += 1;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        _this.objectsPerTick = objectsPerTick;
        _this.throwOnInvalidObject = throwOnInvalidObject;
        return _this;
    }
    PDFParser.prototype.parseDocument = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var prevOffset, offset;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $1cWQu.ReparseError)("PDFParser", "parseDocument");
                        this.alreadyParsed = true;
                        this.context.header = this.parseHeader();
                        _a.label = 1;
                    case 1:
                        if (!!this.bytes.done()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.parseDocumentSection()
                        ];
                    case 2:
                        _a.sent();
                        offset = this.bytes.offset();
                        if (offset === prevOffset) throw new (0, $1cWQu.StalledParserError)(this.bytes.position());
                        prevOffset = offset;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        this.maybeRecoverRoot();
                        if (this.context.lookup((0, $06a507a20ec07388$export$2e2bcd8739ae039).of(0))) {
                            console.warn("Removing parsed object: 0 0 R");
                            this.context.delete((0, $06a507a20ec07388$export$2e2bcd8739ae039).of(0));
                        }
                        return [
                            2 /*return*/ ,
                            this.context
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeRecoverRoot = function() {
        var isValidCatalog = function(obj) {
            return obj instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039) && obj.lookup((0, $a7yPZ.default).of("Type")) === (0, $a7yPZ.default).of("Catalog");
        };
        var catalog = this.context.lookup(this.context.trailerInfo.Root);
        if (!isValidCatalog(catalog)) {
            var indirectObjects = this.context.enumerateIndirectObjects();
            for(var idx = 0, len = indirectObjects.length; idx < len; idx++){
                var _a = indirectObjects[idx], ref = _a[0], object = _a[1];
                if (isValidCatalog(object)) this.context.trailerInfo.Root = ref;
            }
        }
    };
    PDFParser.prototype.parseHeader = function() {
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).header)) {
                var major = this.parseRawInt();
                this.bytes.assertNext((0, $5ZWJa.default).Period);
                var minor = this.parseRawInt();
                var header = (0, $7610640e6ae69024$export$2e2bcd8739ae039).forVersion(major, minor);
                this.skipBinaryHeaderComment();
                return header;
            }
            this.bytes.next();
        }
        throw new (0, $1cWQu.MissingPDFHeaderError)(this.bytes.position());
    };
    PDFParser.prototype.parseIndirectObjectHeader = function() {
        this.skipWhitespaceAndComments();
        var objectNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        var generationNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).obj)) throw new (0, $1cWQu.MissingKeywordError)(this.bytes.position(), (0, $0a24692a8647bc1a$export$93ad50ccfacdd77).obj);
        return (0, $06a507a20ec07388$export$2e2bcd8739ae039).of(objectNumber, generationNumber);
    };
    PDFParser.prototype.matchIndirectObjectHeader = function() {
        var initialOffset = this.bytes.offset();
        try {
            this.parseIndirectObjectHeader();
            return true;
        } catch (e) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
    };
    PDFParser.prototype.parseIndirectObject = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var ref, object;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ref = this.parseIndirectObjectHeader();
                        this.skipWhitespaceAndComments();
                        object = this.parseObject();
                        this.skipWhitespaceAndComments();
                        // if (!this.matchKeyword(Keywords.endobj)) {
                        // throw new MissingKeywordError(this.bytes.position(), Keywords.endobj);
                        // }
                        // TODO: Log a warning if this fails...
                        this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).endobj);
                        if (!(object instanceof (0, $6f2895f4e287e745$export$2e2bcd8739ae039) && object.dict.lookup((0, $a7yPZ.default).of("Type")) === (0, $a7yPZ.default).of("ObjStm"))) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $48f2c18652de9099$export$2e2bcd8739ae039).forStream(object, this.shouldWaitForTick).parseIntoContext()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (object instanceof (0, $6f2895f4e287e745$export$2e2bcd8739ae039) && object.dict.lookup((0, $a7yPZ.default).of("Type")) === (0, $a7yPZ.default).of("XRef")) (0, $669523748b60c827$export$2e2bcd8739ae039).forStream(object).parseIntoContext();
                        else this.context.assign(ref, object);
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ ,
                            ref
                        ];
                }
            });
        });
    };
    // TODO: Improve and clean this up
    PDFParser.prototype.tryToParseInvalidIndirectObject = function() {
        var startPos = this.bytes.position();
        var msg = "Trying to parse invalid object: " + JSON.stringify(startPos) + ")";
        if (this.throwOnInvalidObject) throw new Error(msg);
        console.warn(msg);
        var ref = this.parseIndirectObjectHeader();
        console.warn("Invalid object ref: " + ref);
        this.skipWhitespaceAndComments();
        var start = this.bytes.offset();
        var failed = true;
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).endobj)) failed = false;
            if (!failed) break;
            this.bytes.next();
        }
        if (failed) throw new (0, $1cWQu.PDFInvalidObjectParsingError)(startPos);
        var end = this.bytes.offset() - (0, $0a24692a8647bc1a$export$93ad50ccfacdd77).endobj.length;
        var object = (0, $45c005d97d55c8cc$export$2e2bcd8739ae039).of(this.bytes.slice(start, end));
        this.context.assign(ref, object);
        return ref;
    };
    PDFParser.prototype.parseIndirectObjects = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var initialOffset, e_1;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.skipWhitespaceAndComments();
                        _a.label = 1;
                    case 1:
                        if (!(!this.bytes.done() && (0, $714371482519b4af$export$9492c31549e88980)[this.bytes.peek()])) return [
                            3 /*break*/ ,
                            8
                        ];
                        initialOffset = this.bytes.offset();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObject()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_1 = _a.sent();
                        // TODO: Add tracing/logging mechanism to track when this happens!
                        this.bytes.moveTo(initialOffset);
                        this.tryToParseInvalidIndirectObject();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        this.skipWhitespaceAndComments();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $egzXy.waitForTick)()
                        ];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeParseCrossRefSection = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).xref)) return;
        this.skipWhitespaceAndComments();
        var objectNumber = -1;
        var xref = (0, $26cd178a6f39ea79$export$2e2bcd8739ae039).createEmpty();
        while(!this.bytes.done() && (0, $714371482519b4af$export$9492c31549e88980)[this.bytes.peek()]){
            var firstInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var secondInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var byte = this.bytes.peek();
            if (byte === (0, $5ZWJa.default).n || byte === (0, $5ZWJa.default).f) {
                var ref = (0, $06a507a20ec07388$export$2e2bcd8739ae039).of(objectNumber, secondInt);
                if (this.bytes.next() === (0, $5ZWJa.default).n) xref.addEntry(ref, firstInt);
                else // this.context.delete(ref);
                xref.addDeletedEntry(ref, firstInt);
                objectNumber += 1;
            } else objectNumber = firstInt;
            this.skipWhitespaceAndComments();
        }
        return xref;
    };
    PDFParser.prototype.maybeParseTrailerDict = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).trailer)) return;
        this.skipWhitespaceAndComments();
        var dict = this.parseDict();
        var context = this.context;
        context.trailerInfo = {
            Root: dict.get((0, $a7yPZ.default).of("Root")) || context.trailerInfo.Root,
            Encrypt: dict.get((0, $a7yPZ.default).of("Encrypt")) || context.trailerInfo.Encrypt,
            Info: dict.get((0, $a7yPZ.default).of("Info")) || context.trailerInfo.Info,
            ID: dict.get((0, $a7yPZ.default).of("ID")) || context.trailerInfo.ID
        };
    };
    PDFParser.prototype.maybeParseTrailer = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).startxref)) return;
        this.skipWhitespaceAndComments();
        var offset = this.parseRawInt();
        this.skipWhitespace();
        this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        return (0, $023d797fe2fbf449$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(offset);
    };
    PDFParser.prototype.parseDocumentSection = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObjects()
                        ];
                    case 1:
                        _a.sent();
                        this.maybeParseCrossRefSection();
                        this.maybeParseTrailerDict();
                        this.maybeParseTrailer();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * This operation is not necessary for valid PDF files. But some invalid PDFs
     * contain jibberish in between indirect objects. This method is designed to
     * skip past that jibberish, should it exist, until it reaches the next
     * indirect object header, an xref table section, or the file trailer.
     */ PDFParser.prototype.skipJibberish = function() {
        this.skipWhitespaceAndComments();
        while(!this.bytes.done()){
            var initialOffset = this.bytes.offset();
            var byte = this.bytes.peek();
            var isAlphaNumeric = byte >= (0, $5ZWJa.default).Space && byte <= (0, $5ZWJa.default).Tilde;
            if (isAlphaNumeric) {
                if (this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).xref) || this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).trailer) || this.matchKeyword((0, $0a24692a8647bc1a$export$93ad50ccfacdd77).startxref) || this.matchIndirectObjectHeader()) {
                    this.bytes.moveTo(initialOffset);
                    break;
                }
            }
            this.bytes.next();
        }
    };
    /**
     * Skips the binary comment following a PDF header. The specification
     * defines this binary comment (section 7.5.2 File Header) as a sequence of 4
     * or more bytes that are 128 or greater, and which are preceded by a "%".
     *
     * This would imply that to strip out this binary comment, we could check for
     * a sequence of bytes starting with "%", and remove all subsequent bytes that
     * are 128 or greater. This works for many documents that properly comply with
     * the spec. But in the wild, there are PDFs that omit the leading "%", and
     * include bytes that are less than 128 (e.g. 0 or 1). So in order to parse
     * these headers correctly, we just throw out all bytes leading up to the
     * first indirect object header.
     */ PDFParser.prototype.skipBinaryHeaderComment = function() {
        this.skipWhitespaceAndComments();
        try {
            var initialOffset = this.bytes.offset();
            this.parseIndirectObjectHeader();
            this.bytes.moveTo(initialOffset);
        } catch (e) {
            this.bytes.next();
            this.skipWhitespaceAndComments();
        }
    };
    PDFParser.forBytesWithOptions = function(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        return new PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers);
    };
    return PDFParser;
}((0, $188fe2318991c893$export$2e2bcd8739ae039));
var $04db4ec857fd3d28$export$2e2bcd8739ae039 = $04db4ec857fd3d28$var$PDFParser;







var $81e8a0a81fcef9c3$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $81e8a0a81fcef9c3$export$1fa7b68b35026177;
(function(AnnotationFlags) {
    /**
     * If set, do not display the annotation if it does not belong to one of the
     * standard annotation types and no annotation handler is available. If clear,
     * display such an unknown annotation using an appearance stream specified by
     * its appearance dictionary, if any.
     */ AnnotationFlags[AnnotationFlags["Invisible"] = $81e8a0a81fcef9c3$var$flag(0)] = "Invisible";
    /**
     * If set, do not display or print the annotation or allow it to interact with
     * the user, regardless of its annotation type or whether an annotation
     * handler is available.
     *
     * In cases where screen space is limited, the ability to hide and show
     * annotations selectively can be used in combination with appearance streams
     * to display auxiliary pop-up information similar in function to online help
     * systems.
     */ AnnotationFlags[AnnotationFlags["Hidden"] = $81e8a0a81fcef9c3$var$flag(1)] = "Hidden";
    /**
     * If set, print the annotation when the page is printed. If clear, never
     * print the annotation, regardless of whether it is displayed on the screen.
     *
     * This can be useful for annotations representing interactive pushbuttons,
     * which would serve no meaningful purpose on the printed page.
     */ AnnotationFlags[AnnotationFlags["Print"] = $81e8a0a81fcef9c3$var$flag(2)] = "Print";
    /**
     * If set, do not scale the annotation’s appearance to match the magnification
     * of the page. The location of the annotation on the page (defined by the
     * upper-left corner of its annotation rectangle) shall remain fixed,
     * regardless of the page magnification.
     */ AnnotationFlags[AnnotationFlags["NoZoom"] = $81e8a0a81fcef9c3$var$flag(3)] = "NoZoom";
    /**
     * If set, do not rotate the annotation’s appearance to match the rotation of
     * the page. The upper-left corner of the annotation rectangle shall remain in
     * a fixed location on the page, regardless of the page rotation.
     */ AnnotationFlags[AnnotationFlags["NoRotate"] = $81e8a0a81fcef9c3$var$flag(4)] = "NoRotate";
    /**
     * If set, do not display the annotation on the screen or allow it to interact
     * with the user. The annotation may be printed (depending on the setting of
     * the Print flag) but should be considered hidden for purposes of on-screen
     * display and user interaction.
     */ AnnotationFlags[AnnotationFlags["NoView"] = $81e8a0a81fcef9c3$var$flag(5)] = "NoView";
    /**
     * If set, do not allow the annotation to interact with the user. The
     * annotation may be displayed or printed (depending on the settings of the
     * NoView and Print flags) but should not respond to mouse clicks or change
     * its appearance in response to mouse motions.
     *
     * This flag shall be ignored for widget annotations; its function is
     * subsumed by the ReadOnly flag of the associated form field.
     */ AnnotationFlags[AnnotationFlags["ReadOnly"] = $81e8a0a81fcef9c3$var$flag(6)] = "ReadOnly";
    /**
     * If set, do not allow the annotation to be deleted or its properties
     * (including position and size) to be modified by the user. However, this
     * flag does not restrict changes to the annotation’s contents, such as the
     * value of a form field.
     */ AnnotationFlags[AnnotationFlags["Locked"] = $81e8a0a81fcef9c3$var$flag(7)] = "Locked";
    /**
     * If set, invert the interpretation of the NoView flag for certain events.
     *
     * A typical use is to have an annotation that appears only when a mouse
     * cursor is held over it.
     */ AnnotationFlags[AnnotationFlags["ToggleNoView"] = $81e8a0a81fcef9c3$var$flag(8)] = "ToggleNoView";
    /**
     * If set, do not allow the contents of the annotation to be modified by the
     * user. This flag does not restrict deletion of the annotation or changes to
     * other annotation properties, such as position and size.
     */ AnnotationFlags[AnnotationFlags["LockedContents"] = $81e8a0a81fcef9c3$var$flag(9)] = "LockedContents";
})($81e8a0a81fcef9c3$export$1fa7b68b35026177 || ($81e8a0a81fcef9c3$export$1fa7b68b35026177 = {}));







var $a7yPZ = parcelRequire("a7yPZ");
var $gcVIu = parcelRequire("gcVIu");
var $78d17f4067224563$export$69d5e1b305482e08 = function(name) {
    return name instanceof (0, $a7yPZ.default) ? name : (0, $a7yPZ.default).of(name);
};
var $78d17f4067224563$export$fb5b5e76a3a5c568 = function(num) {
    return num instanceof (0, $gcVIu.default) ? num : (0, $gcVIu.default).of(num);
};
var $78d17f4067224563$export$37576b9ba69b50db = function(num) {
    return num instanceof (0, $gcVIu.default) ? num.asNumber() : num;
};


parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
var $evyBg = parcelRequire("evyBg");
var $d82a2f5ff75b3e04$export$c3cc0f63dbb3500f;
(function(RotationTypes) {
    RotationTypes["Degrees"] = "degrees";
    RotationTypes["Radians"] = "radians";
})($d82a2f5ff75b3e04$export$c3cc0f63dbb3500f || ($d82a2f5ff75b3e04$export$c3cc0f63dbb3500f = {}));
var $d82a2f5ff75b3e04$export$8449e153fbd325fc = function(radianAngle) {
    (0, $2qnUk.assertIs)(radianAngle, "radianAngle", [
        "number"
    ]);
    return {
        type: $d82a2f5ff75b3e04$export$c3cc0f63dbb3500f.Radians,
        angle: radianAngle
    };
};
var $d82a2f5ff75b3e04$export$41fc368e1a942b97 = function(degreeAngle) {
    (0, $2qnUk.assertIs)(degreeAngle, "degreeAngle", [
        "number"
    ]);
    return {
        type: $d82a2f5ff75b3e04$export$c3cc0f63dbb3500f.Degrees,
        angle: degreeAngle
    };
};
var $d82a2f5ff75b3e04$var$Radians = $d82a2f5ff75b3e04$export$c3cc0f63dbb3500f.Radians, $d82a2f5ff75b3e04$var$Degrees = $d82a2f5ff75b3e04$export$c3cc0f63dbb3500f.Degrees;
var $d82a2f5ff75b3e04$export$c9fcf1a7df975d78 = function(degree) {
    return degree * Math.PI / 180;
};
var $d82a2f5ff75b3e04$export$c41dd2a8460d3196 = function(radian) {
    return radian * 180 / Math.PI;
};
var $d82a2f5ff75b3e04$export$cba01ba138429a1d = function(rotation) {
    return rotation.type === $d82a2f5ff75b3e04$var$Radians ? rotation.angle : rotation.type === $d82a2f5ff75b3e04$var$Degrees ? $d82a2f5ff75b3e04$export$c9fcf1a7df975d78(rotation.angle) : (0, $evyBg.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $d82a2f5ff75b3e04$export$56cb859c01fa134d = function(rotation) {
    return rotation.type === $d82a2f5ff75b3e04$var$Radians ? $d82a2f5ff75b3e04$export$c41dd2a8460d3196(rotation.angle) : rotation.type === $d82a2f5ff75b3e04$var$Degrees ? rotation.angle : (0, $evyBg.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $d82a2f5ff75b3e04$export$ee0ed07fe78ec05 = function(degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var quadrants = degreeAngle / 90 % 4;
    if (quadrants === 0) return 0;
    if (quadrants === 1) return 90;
    if (quadrants === 2) return 180;
    if (quadrants === 3) return 270;
    return 0; // `degreeAngle` is not a multiple of 90
};
var $d82a2f5ff75b3e04$export$312e44550db33c6a = function(dims, degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var rotation = $d82a2f5ff75b3e04$export$ee0ed07fe78ec05(degreeAngle);
    return rotation === 90 || rotation === 270 ? {
        width: dims.height,
        height: dims.width
    } : {
        width: dims.width,
        height: dims.height
    };
};
var $d82a2f5ff75b3e04$export$afddc3b8600307a4 = function(rectangle, borderWidth, degreeAngle) {
    if (borderWidth === void 0) borderWidth = 0;
    if (degreeAngle === void 0) degreeAngle = 0;
    var x = rectangle.x, y = rectangle.y, w = rectangle.width, h = rectangle.height;
    var r = $d82a2f5ff75b3e04$export$ee0ed07fe78ec05(degreeAngle);
    var b = borderWidth / 2;
    // prettier-ignore
    if (r === 0) return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
    else if (r === 90) return {
        x: x - h + b,
        y: y - b,
        width: h,
        height: w
    };
    else if (r === 180) return {
        x: x - w + b,
        y: y - h + b,
        width: w,
        height: h
    };
    else if (r === 270) return {
        x: x - b,
        y: y - w + b,
        width: h,
        height: w
    };
    else return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
};



var $7b945c9f8f83b90a$export$e0b576e7a74416cd = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).ClipNonZero);
};
var $7b945c9f8f83b90a$export$dd6fb25f201b5a7a = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).ClipEvenOdd);
};
/* ==================== Graphics State Operators ==================== */ var $7b945c9f8f83b90a$var$cos = Math.cos, $7b945c9f8f83b90a$var$sin = Math.sin, $7b945c9f8f83b90a$var$tan = Math.tan;
var $7b945c9f8f83b90a$export$ed5b99ee38154497 = function(a, b, c, d, e, f) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).ConcatTransformationMatrix, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(a),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(b),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(c),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(d),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(e),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $7b945c9f8f83b90a$export$d73ee8ef04f5226a = function(xPos, yPos) {
    return $7b945c9f8f83b90a$export$ed5b99ee38154497(1, 0, 0, 1, xPos, yPos);
};
var $7b945c9f8f83b90a$export$dcdf75081b88279d = function(xPos, yPos) {
    return $7b945c9f8f83b90a$export$ed5b99ee38154497(xPos, 0, 0, yPos, 0, 0);
};
var $7b945c9f8f83b90a$export$a2ba89726971a90f = function(angle) {
    return $7b945c9f8f83b90a$export$ed5b99ee38154497($7b945c9f8f83b90a$var$cos((0, $78d17f4067224563$export$37576b9ba69b50db)(angle)), $7b945c9f8f83b90a$var$sin((0, $78d17f4067224563$export$37576b9ba69b50db)(angle)), -$7b945c9f8f83b90a$var$sin((0, $78d17f4067224563$export$37576b9ba69b50db)(angle)), $7b945c9f8f83b90a$var$cos((0, $78d17f4067224563$export$37576b9ba69b50db)(angle)), 0, 0);
};
var $7b945c9f8f83b90a$export$91df22fbff99d059 = function(angle) {
    return $7b945c9f8f83b90a$export$a2ba89726971a90f((0, $d82a2f5ff75b3e04$export$c9fcf1a7df975d78)((0, $78d17f4067224563$export$37576b9ba69b50db)(angle)));
};
var $7b945c9f8f83b90a$export$985cb1d69d6a3add = function(xSkewAngle, ySkewAngle) {
    return $7b945c9f8f83b90a$export$ed5b99ee38154497(1, $7b945c9f8f83b90a$var$tan((0, $78d17f4067224563$export$37576b9ba69b50db)(xSkewAngle)), $7b945c9f8f83b90a$var$tan((0, $78d17f4067224563$export$37576b9ba69b50db)(ySkewAngle)), 1, 0, 0);
};
var $7b945c9f8f83b90a$export$8ecb831b3efbb169 = function(xSkewAngle, ySkewAngle) {
    return $7b945c9f8f83b90a$export$985cb1d69d6a3add((0, $d82a2f5ff75b3e04$export$c9fcf1a7df975d78)((0, $78d17f4067224563$export$37576b9ba69b50db)(xSkewAngle)), (0, $d82a2f5ff75b3e04$export$c9fcf1a7df975d78)((0, $78d17f4067224563$export$37576b9ba69b50db)(ySkewAngle)));
};
var $7b945c9f8f83b90a$export$e0e900d241274e06 = function(dashArray, dashPhase) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetLineDashPattern, [
        "[" + dashArray.map((0, $78d17f4067224563$export$fb5b5e76a3a5c568)).join(" ") + "]",
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(dashPhase)
    ]);
};
var $7b945c9f8f83b90a$export$d10d019aadfd45c7 = function() {
    return $7b945c9f8f83b90a$export$e0e900d241274e06([], 0);
};
var $7b945c9f8f83b90a$export$7a77bc708e50709e;
(function(LineCapStyle) {
    LineCapStyle[LineCapStyle["Butt"] = 0] = "Butt";
    LineCapStyle[LineCapStyle["Round"] = 1] = "Round";
    LineCapStyle[LineCapStyle["Projecting"] = 2] = "Projecting";
})($7b945c9f8f83b90a$export$7a77bc708e50709e || ($7b945c9f8f83b90a$export$7a77bc708e50709e = {}));
var $7b945c9f8f83b90a$export$6c65ed24e870eec = function(style) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetLineCapStyle, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $7b945c9f8f83b90a$export$cba5d0f1cde60b86;
(function(LineJoinStyle) {
    LineJoinStyle[LineJoinStyle["Miter"] = 0] = "Miter";
    LineJoinStyle[LineJoinStyle["Round"] = 1] = "Round";
    LineJoinStyle[LineJoinStyle["Bevel"] = 2] = "Bevel";
})($7b945c9f8f83b90a$export$cba5d0f1cde60b86 || ($7b945c9f8f83b90a$export$cba5d0f1cde60b86 = {}));
var $7b945c9f8f83b90a$export$97dfb3b4509cd5bc = function(style) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetLineJoinStyle, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $7b945c9f8f83b90a$export$568567f665d3f3bb = function(state) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetGraphicsStateParams, [
        (0, $78d17f4067224563$export$69d5e1b305482e08)(state)
    ]);
};
var $7b945c9f8f83b90a$export$cb182c48e35739ac = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).PushGraphicsState);
};
var $7b945c9f8f83b90a$export$10581a6f45bf75eb = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).PopGraphicsState);
};
var $7b945c9f8f83b90a$export$558e0f90d8262345 = function(width) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetLineWidth, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(width)
    ]);
};
var $7b945c9f8f83b90a$export$45bd49bb15a3c5cb = function(x1, y1, x2, y2, x3, y3) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).AppendBezierCurve, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(x1),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(y1),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(x2),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(y2),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(x3),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(y3)
    ]);
};
var $7b945c9f8f83b90a$export$6f4913b22432f892 = function(x1, y1, x2, y2) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).CurveToReplicateInitialPoint, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(x1),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(y1),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(x2),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(y2)
    ]);
};
var $7b945c9f8f83b90a$export$21f87e210c424cd0 = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).ClosePath);
};
var $7b945c9f8f83b90a$export$75f1ccd6dc32e80a = function(xPos, yPos) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).MoveTo, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(xPos),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $7b945c9f8f83b90a$export$73abee0cf983cb99 = function(xPos, yPos) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).LineTo, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(xPos),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $7b945c9f8f83b90a$export$405b065079b7caf2 = function(xPos, yPos, width, height) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).AppendRectangle, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(xPos),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(yPos),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(width),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(height)
    ]);
};
var $7b945c9f8f83b90a$export$dd4f28cef696bc7d = function(xPos, yPos, size) {
    return $7b945c9f8f83b90a$export$405b065079b7caf2(xPos, yPos, size, size);
};
var $7b945c9f8f83b90a$export$d9b706f8d0a70aef = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).StrokePath);
};
var $7b945c9f8f83b90a$export$9563e054e6f787fb = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).FillNonZero);
};
var $7b945c9f8f83b90a$export$76d37801baac10fb = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).FillNonZeroAndStroke);
};
var $7b945c9f8f83b90a$export$d366e9c0a9bd860f = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).EndPath);
};
var $7b945c9f8f83b90a$export$829ffc2dbe358942 = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).NextLine);
};
var $7b945c9f8f83b90a$export$b84c1833e225e397 = function(x, y) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).MoveText, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(x),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(y)
    ]);
};
var $7b945c9f8f83b90a$export$778bfc3c1a2b7ba4 = function(text) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).ShowText, [
        text
    ]);
};
var $7b945c9f8f83b90a$export$337b8dbf65fbb95e = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).BeginText);
};
var $7b945c9f8f83b90a$export$e3caa83a99d72806 = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).EndText);
};
var $7b945c9f8f83b90a$export$df01d619ff6ce7f7 = function(name, size) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetFontAndSize, [
        (0, $78d17f4067224563$export$69d5e1b305482e08)(name),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(size)
    ]);
};
var $7b945c9f8f83b90a$export$710392ce2617f080 = function(spacing) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetCharacterSpacing, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $7b945c9f8f83b90a$export$a2801242b2f8967d = function(spacing) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetWordSpacing, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $7b945c9f8f83b90a$export$20dbb065c447b4da = function(squeeze) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetTextHorizontalScaling, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(squeeze)
    ]);
};
var $7b945c9f8f83b90a$export$79399e66b6bb212c = function(lineHeight) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetTextLineHeight, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(lineHeight)
    ]);
};
var $7b945c9f8f83b90a$export$ad1653459b07f70c = function(rise) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetTextRise, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(rise)
    ]);
};
var $7b945c9f8f83b90a$export$ca45e4ab114d4814;
(function(TextRenderingMode) {
    TextRenderingMode[TextRenderingMode["Fill"] = 0] = "Fill";
    TextRenderingMode[TextRenderingMode["Outline"] = 1] = "Outline";
    TextRenderingMode[TextRenderingMode["FillAndOutline"] = 2] = "FillAndOutline";
    TextRenderingMode[TextRenderingMode["Invisible"] = 3] = "Invisible";
    TextRenderingMode[TextRenderingMode["FillAndClip"] = 4] = "FillAndClip";
    TextRenderingMode[TextRenderingMode["OutlineAndClip"] = 5] = "OutlineAndClip";
    TextRenderingMode[TextRenderingMode["FillAndOutlineAndClip"] = 6] = "FillAndOutlineAndClip";
    TextRenderingMode[TextRenderingMode["Clip"] = 7] = "Clip";
})($7b945c9f8f83b90a$export$ca45e4ab114d4814 || ($7b945c9f8f83b90a$export$ca45e4ab114d4814 = {}));
var $7b945c9f8f83b90a$export$99f0dc2c4cb099ab = function(mode) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetTextRenderingMode, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(mode)
    ]);
};
var $7b945c9f8f83b90a$export$d3656d656af31043 = function(a, b, c, d, e, f) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).SetTextMatrix, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(a),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(b),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(c),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(d),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(e),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $7b945c9f8f83b90a$export$f567083ac6aa5aa3 = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $7b945c9f8f83b90a$export$d3656d656af31043($7b945c9f8f83b90a$var$cos((0, $78d17f4067224563$export$37576b9ba69b50db)(rotationAngle)), $7b945c9f8f83b90a$var$sin((0, $78d17f4067224563$export$37576b9ba69b50db)(rotationAngle)) + $7b945c9f8f83b90a$var$tan((0, $78d17f4067224563$export$37576b9ba69b50db)(xSkewAngle)), -$7b945c9f8f83b90a$var$sin((0, $78d17f4067224563$export$37576b9ba69b50db)(rotationAngle)) + $7b945c9f8f83b90a$var$tan((0, $78d17f4067224563$export$37576b9ba69b50db)(ySkewAngle)), $7b945c9f8f83b90a$var$cos((0, $78d17f4067224563$export$37576b9ba69b50db)(rotationAngle)), x, y);
};
var $7b945c9f8f83b90a$export$909384d9b9d39aff = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $7b945c9f8f83b90a$export$f567083ac6aa5aa3((0, $d82a2f5ff75b3e04$export$c9fcf1a7df975d78)((0, $78d17f4067224563$export$37576b9ba69b50db)(rotationAngle)), (0, $d82a2f5ff75b3e04$export$c9fcf1a7df975d78)((0, $78d17f4067224563$export$37576b9ba69b50db)(xSkewAngle)), (0, $d82a2f5ff75b3e04$export$c9fcf1a7df975d78)((0, $78d17f4067224563$export$37576b9ba69b50db)(ySkewAngle)), x, y);
};
var $7b945c9f8f83b90a$export$382c18f8bccd9e2b = function(name) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).DrawObject, [
        (0, $78d17f4067224563$export$69d5e1b305482e08)(name)
    ]);
};
var $7b945c9f8f83b90a$export$f30201749d00f572 = function(gray) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).NonStrokingColorGray, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $7b945c9f8f83b90a$export$6502921112196b8f = function(gray) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).StrokingColorGray, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $7b945c9f8f83b90a$export$f59cae633978eea7 = function(red, green, blue) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).NonStrokingColorRgb, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(red),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(green),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $7b945c9f8f83b90a$export$e743468c48a4fd5a = function(red, green, blue) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).StrokingColorRgb, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(red),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(green),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $7b945c9f8f83b90a$export$e836aceb3db98cc0 = function(cyan, magenta, yellow, key) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).NonStrokingColorCmyk, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(cyan),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(magenta),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(yellow),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $7b945c9f8f83b90a$export$4004b818fda831c1 = function(cyan, magenta, yellow, key) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).StrokingColorCmyk, [
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(cyan),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(magenta),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(yellow),
        (0, $78d17f4067224563$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $7b945c9f8f83b90a$export$a028b403e40f1ab2 = function(tag) {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).BeginMarkedContent, [
        (0, $78d17f4067224563$export$69d5e1b305482e08)(tag)
    ]);
};
var $7b945c9f8f83b90a$export$935e2334f5a50589 = function() {
    return (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039).of((0, $4238d3c012553b3e$export$2e2bcd8739ae039).EndMarkedContent);
};


parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
var $evyBg = parcelRequire("evyBg");
var $c9f3d3f740911584$export$4eb09b1c0a6dec24;
(function(ColorTypes) {
    ColorTypes["Grayscale"] = "Grayscale";
    ColorTypes["RGB"] = "RGB";
    ColorTypes["CMYK"] = "CMYK";
})($c9f3d3f740911584$export$4eb09b1c0a6dec24 || ($c9f3d3f740911584$export$4eb09b1c0a6dec24 = {}));
var $c9f3d3f740911584$export$6f416a6db2dfcd5c = function(gray) {
    (0, $2qnUk.assertRange)(gray, "gray", 0.0, 1.0);
    return {
        type: $c9f3d3f740911584$export$4eb09b1c0a6dec24.Grayscale,
        gray: gray
    };
};
var $c9f3d3f740911584$export$8972dc0e6ad9238f = function(red, green, blue) {
    (0, $2qnUk.assertRange)(red, "red", 0, 1);
    (0, $2qnUk.assertRange)(green, "green", 0, 1);
    (0, $2qnUk.assertRange)(blue, "blue", 0, 1);
    return {
        type: $c9f3d3f740911584$export$4eb09b1c0a6dec24.RGB,
        red: red,
        green: green,
        blue: blue
    };
};
var $c9f3d3f740911584$export$358b1a66a3c77756 = function(cyan, magenta, yellow, key) {
    (0, $2qnUk.assertRange)(cyan, "cyan", 0, 1);
    (0, $2qnUk.assertRange)(magenta, "magenta", 0, 1);
    (0, $2qnUk.assertRange)(yellow, "yellow", 0, 1);
    (0, $2qnUk.assertRange)(key, "key", 0, 1);
    return {
        type: $c9f3d3f740911584$export$4eb09b1c0a6dec24.CMYK,
        cyan: cyan,
        magenta: magenta,
        yellow: yellow,
        key: key
    };
};
var $c9f3d3f740911584$var$Grayscale = $c9f3d3f740911584$export$4eb09b1c0a6dec24.Grayscale, $c9f3d3f740911584$var$RGB = $c9f3d3f740911584$export$4eb09b1c0a6dec24.RGB, $c9f3d3f740911584$var$CMYK = $c9f3d3f740911584$export$4eb09b1c0a6dec24.CMYK;
var $c9f3d3f740911584$export$6126e5d7ba707741 = function(color) {
    return color.type === $c9f3d3f740911584$var$Grayscale ? (0, $7b945c9f8f83b90a$export$f30201749d00f572)(color.gray) : color.type === $c9f3d3f740911584$var$RGB ? (0, $7b945c9f8f83b90a$export$f59cae633978eea7)(color.red, color.green, color.blue) : color.type === $c9f3d3f740911584$var$CMYK ? (0, $7b945c9f8f83b90a$export$e836aceb3db98cc0)(color.cyan, color.magenta, color.yellow, color.key) : (0, $evyBg.error)("Invalid color: " + JSON.stringify(color));
};
var $c9f3d3f740911584$export$ae31e5cacc8bb23d = function(color) {
    return color.type === $c9f3d3f740911584$var$Grayscale ? (0, $7b945c9f8f83b90a$export$6502921112196b8f)(color.gray) : color.type === $c9f3d3f740911584$var$RGB ? (0, $7b945c9f8f83b90a$export$e743468c48a4fd5a)(color.red, color.green, color.blue) : color.type === $c9f3d3f740911584$var$CMYK ? (0, $7b945c9f8f83b90a$export$4004b818fda831c1)(color.cyan, color.magenta, color.yellow, color.key) : (0, $evyBg.error)("Invalid color: " + JSON.stringify(color));
};
var $c9f3d3f740911584$export$8750a268217b0987 = function(comps, scale) {
    if (scale === void 0) scale = 1;
    return (comps === null || comps === void 0 ? void 0 : comps.length) === 1 ? $c9f3d3f740911584$export$6f416a6db2dfcd5c(comps[0] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 3 ? $c9f3d3f740911584$export$8972dc0e6ad9238f(comps[0] * scale, comps[1] * scale, comps[2] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 4 ? $c9f3d3f740911584$export$358b1a66a3c77756(comps[0] * scale, comps[1] * scale, comps[2] * scale, comps[3] * scale) : undefined;
};
var $c9f3d3f740911584$export$ffee2793812e3e56 = function(color) {
    return color.type === $c9f3d3f740911584$var$Grayscale ? [
        color.gray
    ] : color.type === $c9f3d3f740911584$var$RGB ? [
        color.red,
        color.green,
        color.blue
    ] : color.type === $c9f3d3f740911584$var$CMYK ? [
        color.cyan,
        color.magenta,
        color.yellow,
        color.key
    ] : (0, $evyBg.error)("Invalid color: " + JSON.stringify(color));
};




// Originated from pdfkit Copyright (c) 2014 Devon Govett
// https://github.com/foliojs/pdfkit/blob/1e62e6ffe24b378eb890df507a47610f4c4a7b24/lib/path.js
// MIT LICENSE
// Updated for pdf-lib & TypeScript by Jeremy Messenger

var $25082fb44240af98$var$cx = 0;
var $25082fb44240af98$var$cy = 0;
var $25082fb44240af98$var$px = 0;
var $25082fb44240af98$var$py = 0;
var $25082fb44240af98$var$sx = 0;
var $25082fb44240af98$var$sy = 0;
var $25082fb44240af98$var$parameters = new Map([
    [
        "A",
        7
    ],
    [
        "a",
        7
    ],
    [
        "C",
        6
    ],
    [
        "c",
        6
    ],
    [
        "H",
        1
    ],
    [
        "h",
        1
    ],
    [
        "L",
        2
    ],
    [
        "l",
        2
    ],
    [
        "M",
        2
    ],
    [
        "m",
        2
    ],
    [
        "Q",
        4
    ],
    [
        "q",
        4
    ],
    [
        "S",
        4
    ],
    [
        "s",
        4
    ],
    [
        "T",
        2
    ],
    [
        "t",
        2
    ],
    [
        "V",
        1
    ],
    [
        "v",
        1
    ],
    [
        "Z",
        0
    ],
    [
        "z",
        0
    ]
]);
var $25082fb44240af98$var$parse = function(path) {
    var cmd;
    var ret = [];
    var args = [];
    var curArg = "";
    var foundDecimal = false;
    var params = 0;
    for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
        var c = path_1[_i];
        if ($25082fb44240af98$var$parameters.has(c)) {
            params = $25082fb44240af98$var$parameters.get(c);
            if (cmd) {
                // save existing command
                if (curArg.length > 0) args[args.length] = +curArg;
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [];
                curArg = "";
                foundDecimal = false;
            }
            cmd = c;
        } else if ([
            " ",
            ","
        ].includes(c) || c === "-" && curArg.length > 0 && curArg[curArg.length - 1] !== "e" || c === "." && foundDecimal) {
            if (curArg.length === 0) continue;
            if (args.length === params) {
                // handle reused commands
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [
                    +curArg
                ];
                // handle assumed commands
                if (cmd === "M") cmd = "L";
                if (cmd === "m") cmd = "l";
            } else args[args.length] = +curArg;
            foundDecimal = c === ".";
            // fix for negative numbers or repeated decimals with no delimeter between commands
            curArg = [
                "-",
                "."
            ].includes(c) ? c : "";
        } else {
            curArg += c;
            if (c === ".") foundDecimal = true;
        }
    }
    // add the last command
    if (curArg.length > 0) {
        if (args.length === params) {
            // handle reused commands
            ret[ret.length] = {
                cmd: cmd,
                args: args
            };
            args = [
                +curArg
            ];
            // handle assumed commands
            if (cmd === "M") cmd = "L";
            if (cmd === "m") cmd = "l";
        } else args[args.length] = +curArg;
    }
    ret[ret.length] = {
        cmd: cmd,
        args: args
    };
    return ret;
};
var $25082fb44240af98$var$apply = function(commands) {
    // current point, control point, and subpath starting point
    $25082fb44240af98$var$cx = $25082fb44240af98$var$cy = $25082fb44240af98$var$px = $25082fb44240af98$var$py = $25082fb44240af98$var$sx = $25082fb44240af98$var$sy = 0;
    // run the commands
    var cmds = [];
    for(var i = 0; i < commands.length; i++){
        var c = commands[i];
        if (c.cmd && typeof $25082fb44240af98$var$runners[c.cmd] === "function") {
            var cmd = $25082fb44240af98$var$runners[c.cmd](c.args);
            if (Array.isArray(cmd)) cmds = cmds.concat(cmd);
            else cmds.push(cmd);
        }
    }
    return cmds;
};
var $25082fb44240af98$var$runners = {
    M: function(a) {
        $25082fb44240af98$var$cx = a[0];
        $25082fb44240af98$var$cy = a[1];
        $25082fb44240af98$var$px = $25082fb44240af98$var$py = null;
        $25082fb44240af98$var$sx = $25082fb44240af98$var$cx;
        $25082fb44240af98$var$sy = $25082fb44240af98$var$cy;
        return (0, $7b945c9f8f83b90a$export$75f1ccd6dc32e80a)($25082fb44240af98$var$cx, $25082fb44240af98$var$cy);
    },
    m: function(a) {
        $25082fb44240af98$var$cx += a[0];
        $25082fb44240af98$var$cy += a[1];
        $25082fb44240af98$var$px = $25082fb44240af98$var$py = null;
        $25082fb44240af98$var$sx = $25082fb44240af98$var$cx;
        $25082fb44240af98$var$sy = $25082fb44240af98$var$cy;
        return (0, $7b945c9f8f83b90a$export$75f1ccd6dc32e80a)($25082fb44240af98$var$cx, $25082fb44240af98$var$cy);
    },
    C: function(a) {
        $25082fb44240af98$var$cx = a[4];
        $25082fb44240af98$var$cy = a[5];
        $25082fb44240af98$var$px = a[2];
        $25082fb44240af98$var$py = a[3];
        return (0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb)(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    c: function(a) {
        var cmd = (0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb)(a[0] + $25082fb44240af98$var$cx, a[1] + $25082fb44240af98$var$cy, a[2] + $25082fb44240af98$var$cx, a[3] + $25082fb44240af98$var$cy, a[4] + $25082fb44240af98$var$cx, a[5] + $25082fb44240af98$var$cy);
        $25082fb44240af98$var$px = $25082fb44240af98$var$cx + a[2];
        $25082fb44240af98$var$py = $25082fb44240af98$var$cy + a[3];
        $25082fb44240af98$var$cx += a[4];
        $25082fb44240af98$var$cy += a[5];
        return cmd;
    },
    S: function(a) {
        if ($25082fb44240af98$var$px === null || $25082fb44240af98$var$py === null) {
            $25082fb44240af98$var$px = $25082fb44240af98$var$cx;
            $25082fb44240af98$var$py = $25082fb44240af98$var$cy;
        }
        var cmd = (0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb)($25082fb44240af98$var$cx - ($25082fb44240af98$var$px - $25082fb44240af98$var$cx), $25082fb44240af98$var$cy - ($25082fb44240af98$var$py - $25082fb44240af98$var$cy), a[0], a[1], a[2], a[3]);
        $25082fb44240af98$var$px = a[0];
        $25082fb44240af98$var$py = a[1];
        $25082fb44240af98$var$cx = a[2];
        $25082fb44240af98$var$cy = a[3];
        return cmd;
    },
    s: function(a) {
        if ($25082fb44240af98$var$px === null || $25082fb44240af98$var$py === null) {
            $25082fb44240af98$var$px = $25082fb44240af98$var$cx;
            $25082fb44240af98$var$py = $25082fb44240af98$var$cy;
        }
        var cmd = (0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb)($25082fb44240af98$var$cx - ($25082fb44240af98$var$px - $25082fb44240af98$var$cx), $25082fb44240af98$var$cy - ($25082fb44240af98$var$py - $25082fb44240af98$var$cy), $25082fb44240af98$var$cx + a[0], $25082fb44240af98$var$cy + a[1], $25082fb44240af98$var$cx + a[2], $25082fb44240af98$var$cy + a[3]);
        $25082fb44240af98$var$px = $25082fb44240af98$var$cx + a[0];
        $25082fb44240af98$var$py = $25082fb44240af98$var$cy + a[1];
        $25082fb44240af98$var$cx += a[2];
        $25082fb44240af98$var$cy += a[3];
        return cmd;
    },
    Q: function(a) {
        $25082fb44240af98$var$px = a[0];
        $25082fb44240af98$var$py = a[1];
        $25082fb44240af98$var$cx = a[2];
        $25082fb44240af98$var$cy = a[3];
        return (0, $7b945c9f8f83b90a$export$6f4913b22432f892)(a[0], a[1], $25082fb44240af98$var$cx, $25082fb44240af98$var$cy);
    },
    q: function(a) {
        var cmd = (0, $7b945c9f8f83b90a$export$6f4913b22432f892)(a[0] + $25082fb44240af98$var$cx, a[1] + $25082fb44240af98$var$cy, a[2] + $25082fb44240af98$var$cx, a[3] + $25082fb44240af98$var$cy);
        $25082fb44240af98$var$px = $25082fb44240af98$var$cx + a[0];
        $25082fb44240af98$var$py = $25082fb44240af98$var$cy + a[1];
        $25082fb44240af98$var$cx += a[2];
        $25082fb44240af98$var$cy += a[3];
        return cmd;
    },
    T: function(a) {
        if ($25082fb44240af98$var$px === null || $25082fb44240af98$var$py === null) {
            $25082fb44240af98$var$px = $25082fb44240af98$var$cx;
            $25082fb44240af98$var$py = $25082fb44240af98$var$cy;
        } else {
            $25082fb44240af98$var$px = $25082fb44240af98$var$cx - ($25082fb44240af98$var$px - $25082fb44240af98$var$cx);
            $25082fb44240af98$var$py = $25082fb44240af98$var$cy - ($25082fb44240af98$var$py - $25082fb44240af98$var$cy);
        }
        var cmd = (0, $7b945c9f8f83b90a$export$6f4913b22432f892)($25082fb44240af98$var$px, $25082fb44240af98$var$py, a[0], a[1]);
        $25082fb44240af98$var$px = $25082fb44240af98$var$cx - ($25082fb44240af98$var$px - $25082fb44240af98$var$cx);
        $25082fb44240af98$var$py = $25082fb44240af98$var$cy - ($25082fb44240af98$var$py - $25082fb44240af98$var$cy);
        $25082fb44240af98$var$cx = a[0];
        $25082fb44240af98$var$cy = a[1];
        return cmd;
    },
    t: function(a) {
        if ($25082fb44240af98$var$px === null || $25082fb44240af98$var$py === null) {
            $25082fb44240af98$var$px = $25082fb44240af98$var$cx;
            $25082fb44240af98$var$py = $25082fb44240af98$var$cy;
        } else {
            $25082fb44240af98$var$px = $25082fb44240af98$var$cx - ($25082fb44240af98$var$px - $25082fb44240af98$var$cx);
            $25082fb44240af98$var$py = $25082fb44240af98$var$cy - ($25082fb44240af98$var$py - $25082fb44240af98$var$cy);
        }
        var cmd = (0, $7b945c9f8f83b90a$export$6f4913b22432f892)($25082fb44240af98$var$px, $25082fb44240af98$var$py, $25082fb44240af98$var$cx + a[0], $25082fb44240af98$var$cy + a[1]);
        $25082fb44240af98$var$cx += a[0];
        $25082fb44240af98$var$cy += a[1];
        return cmd;
    },
    A: function(a) {
        var cmds = $25082fb44240af98$var$solveArc($25082fb44240af98$var$cx, $25082fb44240af98$var$cy, a);
        $25082fb44240af98$var$cx = a[5];
        $25082fb44240af98$var$cy = a[6];
        return cmds;
    },
    a: function(a) {
        a[5] += $25082fb44240af98$var$cx;
        a[6] += $25082fb44240af98$var$cy;
        var cmds = $25082fb44240af98$var$solveArc($25082fb44240af98$var$cx, $25082fb44240af98$var$cy, a);
        $25082fb44240af98$var$cx = a[5];
        $25082fb44240af98$var$cy = a[6];
        return cmds;
    },
    L: function(a) {
        $25082fb44240af98$var$cx = a[0];
        $25082fb44240af98$var$cy = a[1];
        $25082fb44240af98$var$px = $25082fb44240af98$var$py = null;
        return (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)($25082fb44240af98$var$cx, $25082fb44240af98$var$cy);
    },
    l: function(a) {
        $25082fb44240af98$var$cx += a[0];
        $25082fb44240af98$var$cy += a[1];
        $25082fb44240af98$var$px = $25082fb44240af98$var$py = null;
        return (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)($25082fb44240af98$var$cx, $25082fb44240af98$var$cy);
    },
    H: function(a) {
        $25082fb44240af98$var$cx = a[0];
        $25082fb44240af98$var$px = $25082fb44240af98$var$py = null;
        return (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)($25082fb44240af98$var$cx, $25082fb44240af98$var$cy);
    },
    h: function(a) {
        $25082fb44240af98$var$cx += a[0];
        $25082fb44240af98$var$px = $25082fb44240af98$var$py = null;
        return (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)($25082fb44240af98$var$cx, $25082fb44240af98$var$cy);
    },
    V: function(a) {
        $25082fb44240af98$var$cy = a[0];
        $25082fb44240af98$var$px = $25082fb44240af98$var$py = null;
        return (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)($25082fb44240af98$var$cx, $25082fb44240af98$var$cy);
    },
    v: function(a) {
        $25082fb44240af98$var$cy += a[0];
        $25082fb44240af98$var$px = $25082fb44240af98$var$py = null;
        return (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)($25082fb44240af98$var$cx, $25082fb44240af98$var$cy);
    },
    Z: function() {
        var cmd = (0, $7b945c9f8f83b90a$export$21f87e210c424cd0)();
        $25082fb44240af98$var$cx = $25082fb44240af98$var$sx;
        $25082fb44240af98$var$cy = $25082fb44240af98$var$sy;
        return cmd;
    },
    z: function() {
        var cmd = (0, $7b945c9f8f83b90a$export$21f87e210c424cd0)();
        $25082fb44240af98$var$cx = $25082fb44240af98$var$sx;
        $25082fb44240af98$var$cy = $25082fb44240af98$var$sy;
        return cmd;
    }
};
var $25082fb44240af98$var$solveArc = function(x, y, coords) {
    var rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
    var segs = $25082fb44240af98$var$arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    var cmds = [];
    for(var _i = 0, segs_1 = segs; _i < segs_1.length; _i++){
        var seg = segs_1[_i];
        var bez = $25082fb44240af98$var$segmentToBezier.apply(void 0, seg);
        cmds.push((0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb).apply(void 0, bez));
    }
    return cmds;
};
// from Inkscape svgtopdf, thanks!
var $25082fb44240af98$var$arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    var th = rotateX * (Math.PI / 180);
    var sinTh = Math.sin(th);
    var cosTh = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    $25082fb44240af98$var$px = cosTh * (ox - x) * 0.5 + sinTh * (oy - y) * 0.5;
    $25082fb44240af98$var$py = cosTh * (oy - y) * 0.5 - sinTh * (ox - x) * 0.5;
    var pl = $25082fb44240af98$var$px * $25082fb44240af98$var$px / (rx * rx) + $25082fb44240af98$var$py * $25082fb44240af98$var$py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    var a00 = cosTh / rx;
    var a01 = sinTh / rx;
    var a10 = -sinTh / ry;
    var a11 = cosTh / ry;
    var x0 = a00 * ox + a01 * oy;
    var y0 = a10 * ox + a11 * oy;
    var x1 = a00 * x + a01 * y;
    var y1 = a10 * x + a11 * y;
    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    var sfactorSq = 1 / d - 0.25;
    if (sfactorSq < 0) sfactorSq = 0;
    var sfactor = Math.sqrt(sfactorSq);
    if (sweep === large) sfactor = -sfactor;
    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    var th0 = Math.atan2(y0 - yc, x0 - xc);
    var th1 = Math.atan2(y1 - yc, x1 - xc);
    var thArc = th1 - th0;
    if (thArc < 0 && sweep === 1) thArc += 2 * Math.PI;
    else if (thArc > 0 && sweep === 0) thArc -= 2 * Math.PI;
    var segments = Math.ceil(Math.abs(thArc / (Math.PI * 0.5 + 0.001)));
    var result = [];
    for(var i = 0; i < segments; i++){
        var th2 = th0 + i * thArc / segments;
        var th3 = th0 + (i + 1) * thArc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sinTh,
            cosTh
        ];
    }
    return result;
};
var $25082fb44240af98$var$segmentToBezier = function(cx1, cy1, th0, th1, rx, ry, sinTh, cosTh) {
    var a00 = cosTh * rx;
    var a01 = -sinTh * ry;
    var a10 = sinTh * rx;
    var a11 = cosTh * ry;
    var thHalf = 0.5 * (th1 - th0);
    var t = 8 / 3 * Math.sin(thHalf * 0.5) * Math.sin(thHalf * 0.5) / Math.sin(thHalf);
    var x1 = cx1 + Math.cos(th0) - t * Math.sin(th0);
    var y1 = cy1 + Math.sin(th0) + t * Math.cos(th0);
    var x3 = cx1 + Math.cos(th1);
    var y3 = cy1 + Math.sin(th1);
    var x2 = x3 + t * Math.sin(th1);
    var y2 = y3 - t * Math.cos(th1);
    var result = [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
    return result;
};
var $25082fb44240af98$export$8de5166f0a5bde2a = function(path) {
    return $25082fb44240af98$var$apply($25082fb44240af98$var$parse(path));
};



var $59179fabd6039f42$export$b11bd9a0808bdc9 = function(line, options) {
    return [
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $7b945c9f8f83b90a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $7b945c9f8f83b90a$export$337b8dbf65fbb95e)(),
        (0, $c9f3d3f740911584$export$6126e5d7ba707741)(options.color),
        (0, $7b945c9f8f83b90a$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $7b945c9f8f83b90a$export$f567083ac6aa5aa3)((0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.rotate), (0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.xSkew), (0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.ySkew), options.x, options.y),
        (0, $7b945c9f8f83b90a$export$778bfc3c1a2b7ba4)(line),
        (0, $7b945c9f8f83b90a$export$e3caa83a99d72806)(),
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $59179fabd6039f42$export$f7b8b44d3d84bc26 = function(lines, options) {
    var operators = [
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $7b945c9f8f83b90a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $7b945c9f8f83b90a$export$337b8dbf65fbb95e)(),
        (0, $c9f3d3f740911584$export$6126e5d7ba707741)(options.color),
        (0, $7b945c9f8f83b90a$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $7b945c9f8f83b90a$export$79399e66b6bb212c)(options.lineHeight),
        (0, $7b945c9f8f83b90a$export$f567083ac6aa5aa3)((0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.rotate), (0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.xSkew), (0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.ySkew), options.x, options.y)
    ].filter(Boolean);
    for(var idx = 0, len = lines.length; idx < len; idx++)operators.push((0, $7b945c9f8f83b90a$export$778bfc3c1a2b7ba4)(lines[idx]), (0, $7b945c9f8f83b90a$export$829ffc2dbe358942)());
    operators.push((0, $7b945c9f8f83b90a$export$e3caa83a99d72806)(), (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)());
    return operators;
};
var $59179fabd6039f42$export$21a059be5bfd5fb = function(name, options) {
    return [
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $7b945c9f8f83b90a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $7b945c9f8f83b90a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $7b945c9f8f83b90a$export$a2ba89726971a90f)((0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.rotate)),
        (0, $7b945c9f8f83b90a$export$dcdf75081b88279d)(options.width, options.height),
        (0, $7b945c9f8f83b90a$export$985cb1d69d6a3add)((0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.xSkew), (0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.ySkew)),
        (0, $7b945c9f8f83b90a$export$382c18f8bccd9e2b)(name),
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $59179fabd6039f42$export$f8ea28c31069cbc9 = function(name, options) {
    return [
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $7b945c9f8f83b90a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $7b945c9f8f83b90a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $7b945c9f8f83b90a$export$a2ba89726971a90f)((0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.rotate)),
        (0, $7b945c9f8f83b90a$export$dcdf75081b88279d)(options.xScale, options.yScale),
        (0, $7b945c9f8f83b90a$export$985cb1d69d6a3add)((0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.xSkew), (0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.ySkew)),
        (0, $7b945c9f8f83b90a$export$382c18f8bccd9e2b)(name),
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $59179fabd6039f42$export$819db45aec5fcbe5 = function(options) {
    var _a, _b;
    return [
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $7b945c9f8f83b90a$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $c9f3d3f740911584$export$ae31e5cacc8bb23d)(options.color),
        (0, $7b945c9f8f83b90a$export$558e0f90d8262345)(options.thickness),
        (0, $7b945c9f8f83b90a$export$e0e900d241274e06)((_a = options.dashArray) !== null && _a !== void 0 ? _a : [], (_b = options.dashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $7b945c9f8f83b90a$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        options.lineCap && (0, $7b945c9f8f83b90a$export$6c65ed24e870eec)(options.lineCap),
        (0, $7b945c9f8f83b90a$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)(options.end.x, options.end.y),
        (0, $7b945c9f8f83b90a$export$d9b706f8d0a70aef)(),
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $59179fabd6039f42$export$cac848e0621718d8 = function(options) {
    var _a, _b;
    return [
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $7b945c9f8f83b90a$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $c9f3d3f740911584$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $c9f3d3f740911584$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $7b945c9f8f83b90a$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $7b945c9f8f83b90a$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $7b945c9f8f83b90a$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $7b945c9f8f83b90a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $7b945c9f8f83b90a$export$a2ba89726971a90f)((0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.rotate)),
        (0, $7b945c9f8f83b90a$export$985cb1d69d6a3add)((0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.xSkew), (0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.ySkew)),
        (0, $7b945c9f8f83b90a$export$75f1ccd6dc32e80a)(0, 0),
        (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)(0, options.height),
        (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)(options.width, options.height),
        (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)(options.width, 0),
        (0, $7b945c9f8f83b90a$export$21f87e210c424cd0)(),
        // prettier-ignore
        options.color && options.borderWidth ? (0, $7b945c9f8f83b90a$export$76d37801baac10fb)() : options.color ? (0, $7b945c9f8f83b90a$export$9563e054e6f787fb)() : options.borderColor ? (0, $7b945c9f8f83b90a$export$d9b706f8d0a70aef)() : (0, $7b945c9f8f83b90a$export$21f87e210c424cd0)(),
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $59179fabd6039f42$var$KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var $59179fabd6039f42$export$f219d5f4b18063ad = function(config) {
    var x = (0, $78d17f4067224563$export$37576b9ba69b50db)(config.x);
    var y = (0, $78d17f4067224563$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $78d17f4067224563$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $78d17f4067224563$export$37576b9ba69b50db)(config.yScale);
    x -= xScale;
    y -= yScale;
    var ox = xScale * $59179fabd6039f42$var$KAPPA;
    var oy = yScale * $59179fabd6039f42$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(),
        (0, $7b945c9f8f83b90a$export$75f1ccd6dc32e80a)(x, ym),
        (0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym),
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ];
};
var $59179fabd6039f42$var$drawEllipseCurves = function(config) {
    var centerX = (0, $78d17f4067224563$export$37576b9ba69b50db)(config.x);
    var centerY = (0, $78d17f4067224563$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $78d17f4067224563$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $78d17f4067224563$export$37576b9ba69b50db)(config.yScale);
    var x = -xScale;
    var y = -yScale;
    var ox = xScale * $59179fabd6039f42$var$KAPPA;
    var oy = yScale * $59179fabd6039f42$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $7b945c9f8f83b90a$export$d73ee8ef04f5226a)(centerX, centerY),
        (0, $7b945c9f8f83b90a$export$a2ba89726971a90f)((0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(config.rotate)),
        (0, $7b945c9f8f83b90a$export$75f1ccd6dc32e80a)(x, ym),
        (0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $7b945c9f8f83b90a$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym)
    ];
};
var $59179fabd6039f42$export$43c9e2bb0dc74582 = function(options) {
    var _a, _b, _c;
    return (0, $59LZ8.__spreadArrays)([
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $7b945c9f8f83b90a$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $c9f3d3f740911584$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $c9f3d3f740911584$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $7b945c9f8f83b90a$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $7b945c9f8f83b90a$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $7b945c9f8f83b90a$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0)
    ], options.rotate === undefined ? $59179fabd6039f42$export$f219d5f4b18063ad({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale
    }) : $59179fabd6039f42$var$drawEllipseCurves({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale,
        rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0)
    }), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $7b945c9f8f83b90a$export$76d37801baac10fb)() : options.color ? (0, $7b945c9f8f83b90a$export$9563e054e6f787fb)() : options.borderColor ? (0, $7b945c9f8f83b90a$export$d9b706f8d0a70aef)() : (0, $7b945c9f8f83b90a$export$21f87e210c424cd0)(),
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $59179fabd6039f42$export$47c8a640c39d0756 = function(path, options) {
    var _a, _b, _c;
    return (0, $59LZ8.__spreadArrays)([
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $7b945c9f8f83b90a$export$568567f665d3f3bb)(options.graphicsState),
        (0, $7b945c9f8f83b90a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $7b945c9f8f83b90a$export$a2ba89726971a90f)((0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)((_a = options.rotate) !== null && _a !== void 0 ? _a : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0))),
        // SVG path Y axis is opposite pdf-lib's
        options.scale ? (0, $7b945c9f8f83b90a$export$dcdf75081b88279d)(options.scale, -options.scale) : (0, $7b945c9f8f83b90a$export$dcdf75081b88279d)(1, -1),
        options.color && (0, $c9f3d3f740911584$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $c9f3d3f740911584$export$ae31e5cacc8bb23d)(options.borderColor),
        options.borderWidth && (0, $7b945c9f8f83b90a$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $7b945c9f8f83b90a$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $7b945c9f8f83b90a$export$e0e900d241274e06)((_b = options.borderDashArray) !== null && _b !== void 0 ? _b : [], (_c = options.borderDashPhase) !== null && _c !== void 0 ? _c : 0)
    ], (0, $25082fb44240af98$export$8de5166f0a5bde2a)(path), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $7b945c9f8f83b90a$export$76d37801baac10fb)() : options.color ? (0, $7b945c9f8f83b90a$export$9563e054e6f787fb)() : options.borderColor ? (0, $7b945c9f8f83b90a$export$d9b706f8d0a70aef)() : (0, $7b945c9f8f83b90a$export$21f87e210c424cd0)(),
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $59179fabd6039f42$export$695703ffa02b3ffb = function(options) {
    var size = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.size);
    /*********************** Define Check Mark Points ***************************/ // A check mark is defined by three points in some coordinate space. Here, we
    // define these points in a unit coordinate system, where the range of the x
    // and y axis are both [-1, 1].
    //
    // Note that we do not hard code `p1y` in case we wish to change the
    // size/shape of the check mark in the future. We want the check mark to
    // always form a right angle. This means that the dot product between (p1-p2)
    // and (p3-p2) should be zero:
    //
    //   (p1x-p2x) * (p3x-p2x) + (p1y-p2y) * (p3y-p2y) = 0
    //
    // We can now rejigger this equation to solve for `p1y`:
    //
    //   (p1y-p2y) * (p3y-p2y) = -((p1x-p2x) * (p3x-p2x))
    //   (p1y-p2y) = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y)
    //   p1y = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y) + p2y
    //
    // Thanks to my friend Joel Walker (https://github.com/JWalker1995) for
    // devising the above equation and unit coordinate system approach!
    // (x, y) coords of the check mark's bottommost point
    var p2x = -0.25;
    var p2y = -0.49;
    // (x, y) coords of the check mark's topmost point
    var p3y = 0.475;
    var p3x = 0.69;
    // (x, y) coords of the check mark's center (vertically) point
    var p1x = -0.675;
    var p1y = -((p1x - p2x) * (p3x - p2x)) / (p3y - p2y) + p2y;
    /****************************************************************************/ return [
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(),
        options.color && (0, $c9f3d3f740911584$export$ae31e5cacc8bb23d)(options.color),
        (0, $7b945c9f8f83b90a$export$558e0f90d8262345)(options.thickness),
        (0, $7b945c9f8f83b90a$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $7b945c9f8f83b90a$export$75f1ccd6dc32e80a)(p1x * size, p1y * size),
        (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)(p2x * size, p2y * size),
        (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)(p3x * size, p3y * size),
        (0, $7b945c9f8f83b90a$export$d9b706f8d0a70aef)(),
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $59179fabd6039f42$export$5dd9a0a87f38a2a6 = function(options) {
    return options.rotation === 0 ? [
        (0, $7b945c9f8f83b90a$export$d73ee8ef04f5226a)(0, 0),
        (0, $7b945c9f8f83b90a$export$91df22fbff99d059)(0)
    ] : options.rotation === 90 ? [
        (0, $7b945c9f8f83b90a$export$d73ee8ef04f5226a)(options.width, 0),
        (0, $7b945c9f8f83b90a$export$91df22fbff99d059)(90)
    ] : options.rotation === 180 ? [
        (0, $7b945c9f8f83b90a$export$d73ee8ef04f5226a)(options.width, options.height),
        (0, $7b945c9f8f83b90a$export$91df22fbff99d059)(180)
    ] : options.rotation === 270 ? [
        (0, $7b945c9f8f83b90a$export$d73ee8ef04f5226a)(0, options.height),
        (0, $7b945c9f8f83b90a$export$91df22fbff99d059)(270)
    ] : [];
}; // Invalid rotation - noop
var $59179fabd6039f42$export$1c2f7a8d0ec539ab = function(options) {
    var outline = $59179fabd6039f42$export$cac848e0621718d8({
        x: options.x,
        y: options.y,
        width: options.width,
        height: options.height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        xSkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        ySkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0)
    });
    if (!options.filled) return outline;
    var width = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.width);
    var height = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.height);
    var checkMarkSize = Math.min(width, height) / 2;
    var checkMark = $59179fabd6039f42$export$695703ffa02b3ffb({
        x: width / 2,
        y: height / 2,
        size: checkMarkSize,
        thickness: options.thickness,
        color: options.markColor
    });
    return (0, $59LZ8.__spreadArrays)([
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)()
    ], outline, checkMark, [
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ]);
};
var $59179fabd6039f42$export$d01bb537f184a293 = function(options) {
    var width = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.width);
    var height = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.height);
    var outlineScale = Math.min(width, height) / 2;
    var outline = $59179fabd6039f42$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale,
        yScale: outlineScale,
        color: options.color,
        borderColor: options.borderColor,
        borderWidth: options.borderWidth
    });
    if (!options.filled) return outline;
    var dot = $59179fabd6039f42$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale * 0.45,
        yScale: outlineScale * 0.45,
        color: options.dotColor,
        borderColor: undefined,
        borderWidth: 0
    });
    return (0, $59LZ8.__spreadArrays)([
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)()
    ], outline, dot, [
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ]);
};
var $59179fabd6039f42$export$31046eb8c5070d92 = function(options) {
    var x = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.x);
    var y = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.y);
    var width = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.width);
    var height = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.height);
    var background = $59179fabd6039f42$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        xSkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        ySkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0)
    });
    var lines = $59179fabd6039f42$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        xSkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        ySkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0)
    });
    return (0, $59LZ8.__spreadArrays)([
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)()
    ], background, lines, [
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ]);
};
var $59179fabd6039f42$export$8a28629e0fa0aec4 = function(lines, options) {
    var operators = [
        (0, $7b945c9f8f83b90a$export$337b8dbf65fbb95e)(),
        (0, $c9f3d3f740911584$export$6126e5d7ba707741)(options.color),
        (0, $7b945c9f8f83b90a$export$df01d619ff6ce7f7)(options.font, options.size)
    ];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var _a = lines[idx], encoded = _a.encoded, x = _a.x, y = _a.y;
        operators.push((0, $7b945c9f8f83b90a$export$f567083ac6aa5aa3)((0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.rotate), (0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.xSkew), (0, $d82a2f5ff75b3e04$export$cba01ba138429a1d)(options.ySkew), x, y), (0, $7b945c9f8f83b90a$export$778bfc3c1a2b7ba4)(encoded));
    }
    operators.push((0, $7b945c9f8f83b90a$export$e3caa83a99d72806)());
    return operators;
};
var $59179fabd6039f42$export$7d8517ad99905084 = function(options) {
    var x = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.x);
    var y = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.y);
    var width = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.width);
    var height = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.height);
    var borderWidth = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $7b945c9f8f83b90a$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $7b945c9f8f83b90a$export$21f87e210c424cd0)(),
        (0, $7b945c9f8f83b90a$export$e0b576e7a74416cd)(),
        (0, $7b945c9f8f83b90a$export$d366e9c0a9bd860f)()
    ];
    var background = $59179fabd6039f42$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        xSkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        ySkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0)
    });
    var lines = $59179fabd6039f42$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        xSkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        ySkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $59LZ8.__spreadArrays)([
        (0, $7b945c9f8f83b90a$export$a028b403e40f1ab2)("Tx"),
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)()
    ], lines, [
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)(),
        (0, $7b945c9f8f83b90a$export$935e2334f5a50589)()
    ]);
    return (0, $59LZ8.__spreadArrays)([
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)()
    ], background, clippingArea, markedContent, [
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ]);
};
var $59179fabd6039f42$export$5a3093287b85b7c0 = function(options) {
    var x = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.x);
    var y = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.y);
    var width = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.width);
    var height = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.height);
    var lineHeight = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.lineHeight);
    var borderWidth = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $78d17f4067224563$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $7b945c9f8f83b90a$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $7b945c9f8f83b90a$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $7b945c9f8f83b90a$export$21f87e210c424cd0)(),
        (0, $7b945c9f8f83b90a$export$e0b576e7a74416cd)(),
        (0, $7b945c9f8f83b90a$export$d366e9c0a9bd860f)()
    ];
    var background = $59179fabd6039f42$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        xSkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        ySkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0)
    });
    var highlights = [];
    for(var idx = 0, len = options.selectedLines.length; idx < len; idx++){
        var line = options.textLines[options.selectedLines[idx]];
        highlights.push.apply(highlights, $59179fabd6039f42$export$cac848e0621718d8({
            x: line.x - padding,
            y: line.y - (lineHeight - line.height) / 2,
            width: width - borderWidth,
            height: line.height + (lineHeight - line.height) / 2,
            borderWidth: 0,
            color: options.selectedColor,
            borderColor: undefined,
            rotate: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            xSkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            ySkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0)
        }));
    }
    var lines = $59179fabd6039f42$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        xSkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
        ySkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $59LZ8.__spreadArrays)([
        (0, $7b945c9f8f83b90a$export$a028b403e40f1ab2)("Tx"),
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)()
    ], lines, [
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)(),
        (0, $7b945c9f8f83b90a$export$935e2334f5a50589)()
    ]);
    return (0, $59LZ8.__spreadArrays)([
        (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)()
    ], background, highlights, clippingArea, markedContent, [
        (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
    ]);
};




// tslint:disable: max-classes-per-file

var $59LZ8 = parcelRequire("59LZ8");
// TODO: Include link to documentation with example
var $ab1852e734a4db56$export$20fcceeca2b098d2 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(EncryptedPDFError, _super);
    function EncryptedPDFError() {
        var _this = this;
        var msg = "Input document to `PDFDocument.load` is encrypted. You can use `PDFDocument.load(..., { ignoreEncryption: true })` if you wish to load the document anyways.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return EncryptedPDFError;
}(Error);
// TODO: Include link to documentation with example
var $ab1852e734a4db56$export$529a7c74d0636a48 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(FontkitNotRegisteredError, _super);
    function FontkitNotRegisteredError() {
        var _this = this;
        var msg = "Input to `PDFDocument.embedFont` was a custom font, but no `fontkit` instance was found. You must register a `fontkit` instance with `PDFDocument.registerFontkit(...)` before embedding custom fonts.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FontkitNotRegisteredError;
}(Error);
// TODO: Include link to documentation with example
var $ab1852e734a4db56$export$9564a4d28d94eae2 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(ForeignPageError, _super);
    function ForeignPageError() {
        var _this = this;
        var msg = "A `page` passed to `PDFDocument.addPage` or `PDFDocument.insertPage` was from a different (foreign) PDF document. If you want to copy pages from one PDFDocument to another, you must use `PDFDocument.copyPages(...)` to copy the pages before adding or inserting them.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ForeignPageError;
}(Error);
// TODO: Include link to documentation with example
var $ab1852e734a4db56$export$cdca06c5927ddc2d = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(RemovePageFromEmptyDocumentError, _super);
    function RemovePageFromEmptyDocumentError() {
        var _this = this;
        var msg = "PDFDocument has no pages so `PDFDocument.removePage` cannot be called";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RemovePageFromEmptyDocumentError;
}(Error);
var $ab1852e734a4db56$export$5bc08baa4a027cbd = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(NoSuchFieldError, _super);
    function NoSuchFieldError(name) {
        var _this = this;
        var msg = 'PDFDocument has no form field with the name "' + name + '"';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NoSuchFieldError;
}(Error);
var $ab1852e734a4db56$export$8909da6c566ff652 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(UnexpectedFieldTypeError, _super);
    function UnexpectedFieldTypeError(name, expected, actual) {
        var _a, _b;
        var _this = this;
        var expectedType = expected === null || expected === void 0 ? void 0 : expected.name;
        var actualType = (_b = (_a = actual === null || actual === void 0 ? void 0 : actual.constructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : actual;
        var msg = 'Expected field "' + name + '" to be of type ' + expectedType + ", " + ("but it is actually of type " + actualType);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedFieldTypeError;
}(Error);
var $ab1852e734a4db56$export$3437b42908c7d7a3 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(MissingOnValueCheckError, _super);
    function MissingOnValueCheckError(onValue) {
        var _this = this;
        var msg = 'Failed to select check box due to missing onValue: "' + onValue + '"';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingOnValueCheckError;
}(Error);
var $ab1852e734a4db56$export$c428cfe4dc6c68df = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(FieldAlreadyExistsError, _super);
    function FieldAlreadyExistsError(name) {
        var _this = this;
        var msg = 'A field already exists with the specified name: "' + name + '"';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldAlreadyExistsError;
}(Error);
var $ab1852e734a4db56$export$83c39fdacfe38500 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(InvalidFieldNamePartError, _super);
    function InvalidFieldNamePartError(namePart) {
        var _this = this;
        var msg = 'Field name contains invalid component: "' + namePart + '"';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidFieldNamePartError;
}(Error);
var $ab1852e734a4db56$export$6353a2ffd9106bd2 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(FieldExistsAsNonTerminalError, _super);
    function FieldExistsAsNonTerminalError(name) {
        var _this = this;
        var msg = 'A non-terminal field already exists with the specified name: "' + name + '"';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldExistsAsNonTerminalError;
}(Error);
var $ab1852e734a4db56$export$f2fed572e1ed57ab = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(RichTextFieldReadError, _super);
    function RichTextFieldReadError(fieldName) {
        var _this = this;
        var msg = "Reading rich text fields is not supported: Attempted to read rich text field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RichTextFieldReadError;
}(Error);
var $ab1852e734a4db56$export$5283dffc620a5c9f = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(CombedTextLayoutError, _super);
    function CombedTextLayoutError(lineLength, cellCount) {
        var _this = this;
        var msg = "Failed to layout combed text as lineLength=" + lineLength + " is greater than cellCount=" + cellCount;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CombedTextLayoutError;
}(Error);
var $ab1852e734a4db56$export$1577e99040d42609 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(ExceededMaxLengthError, _super);
    function ExceededMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set text with length=" + textLength + " for TextField with maxLength=" + maxLength + " and name=" + name;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ExceededMaxLengthError;
}(Error);
var $ab1852e734a4db56$export$6da6c372180e79b0 = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(InvalidMaxLengthError, _super);
    function InvalidMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set maxLength=" + maxLength + ", which is less than " + textLength + ", the length of this field's current value (name=" + name + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidMaxLengthError;
}(Error);


var $7710effdbf78fe81$export$84b2d1b68830363f;
(function(TextAlignment) {
    TextAlignment[TextAlignment["Left"] = 0] = "Left";
    TextAlignment[TextAlignment["Center"] = 1] = "Center";
    TextAlignment[TextAlignment["Right"] = 2] = "Right";
})($7710effdbf78fe81$export$84b2d1b68830363f || ($7710effdbf78fe81$export$84b2d1b68830363f = {}));


parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $e17b55f7294d0131$var$MIN_FONT_SIZE = 4;
var $e17b55f7294d0131$var$MAX_FONT_SIZE = 500;
var $e17b55f7294d0131$var$computeFontSize = function(lines, font, bounds, multiline) {
    if (multiline === void 0) multiline = false;
    var fontSize = $e17b55f7294d0131$var$MIN_FONT_SIZE;
    while(fontSize < $e17b55f7294d0131$var$MAX_FONT_SIZE){
        var linesUsed = 0;
        for(var lineIdx = 0, lineLen = lines.length; lineIdx < lineLen; lineIdx++){
            linesUsed += 1;
            var line = lines[lineIdx];
            var words = line.split(" ");
            // Layout the words using the current `fontSize`, line wrapping
            // whenever we reach the end of the current line.
            var spaceInLineRemaining = bounds.width;
            for(var idx = 0, len = words.length; idx < len; idx++){
                var isLastWord = idx === len - 1;
                var word = isLastWord ? words[idx] : words[idx] + " ";
                var widthOfWord = font.widthOfTextAtSize(word, fontSize);
                spaceInLineRemaining -= widthOfWord;
                if (spaceInLineRemaining <= 0) {
                    linesUsed += 1;
                    spaceInLineRemaining = bounds.width - widthOfWord;
                }
            }
        }
        // Return if we exceeded the allowed width
        if (!multiline && linesUsed > lines.length) return fontSize - 1;
        var height = font.heightAtSize(fontSize);
        var lineHeight = height + height * 0.2;
        var totalHeight = lineHeight * linesUsed;
        // Return if we exceeded the allowed height
        if (totalHeight > Math.abs(bounds.height)) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $e17b55f7294d0131$var$computeCombedFontSize = function(line, font, bounds, cellCount) {
    var cellWidth = bounds.width / cellCount;
    var cellHeight = bounds.height;
    var fontSize = $e17b55f7294d0131$var$MIN_FONT_SIZE;
    var chars = (0, $cZKSB.charSplit)(line);
    while(fontSize < $e17b55f7294d0131$var$MAX_FONT_SIZE){
        for(var idx = 0, len = chars.length; idx < len; idx++){
            var c = chars[idx];
            var tooLong = font.widthOfTextAtSize(c, fontSize) > cellWidth * 0.75;
            if (tooLong) return fontSize - 1;
        }
        var height = font.heightAtSize(fontSize, {
            descender: false
        });
        if (height > cellHeight) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $e17b55f7294d0131$var$lastIndexOfWhitespace = function(line) {
    for(var idx = line.length; idx > 0; idx--){
        if (/\s/.test(line[idx])) return idx;
    }
    return undefined;
};
var $e17b55f7294d0131$var$splitOutLines = function(input, maxWidth, font, fontSize) {
    var _a;
    var lastWhitespaceIdx = input.length;
    while(lastWhitespaceIdx > 0){
        var line = input.substring(0, lastWhitespaceIdx);
        var encoded = font.encodeText(line);
        var width = font.widthOfTextAtSize(line, fontSize);
        if (width < maxWidth) {
            var remainder = input.substring(lastWhitespaceIdx) || undefined;
            return {
                line: line,
                encoded: encoded,
                width: width,
                remainder: remainder
            };
        }
        lastWhitespaceIdx = (_a = $e17b55f7294d0131$var$lastIndexOfWhitespace(line)) !== null && _a !== void 0 ? _a : 0;
    }
    // We were unable to split the input enough to get a chunk that would fit
    // within the specified `maxWidth` so we'll just return everything
    return {
        line: input,
        encoded: font.encodeText(input),
        width: font.widthOfTextAtSize(input, fontSize),
        remainder: undefined
    };
};
var $e17b55f7294d0131$export$f6ba9f13f815cc95 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var lines = (0, $cZKSB.lineSplit)((0, $cZKSB.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $e17b55f7294d0131$var$computeFontSize(lines, font, bounds, true);
    var height = font.heightAtSize(fontSize);
    var lineHeight = height + height * 0.2;
    var textLines = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var y = bounds.y + bounds.height;
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var prevRemainder = lines[idx];
        while(prevRemainder !== undefined){
            var _b = $e17b55f7294d0131$var$splitOutLines(prevRemainder, bounds.width, font, fontSize), line = _b.line, encoded = _b.encoded, width = _b.width, remainder = _b.remainder;
            // prettier-ignore
            var x = alignment === (0, $7710effdbf78fe81$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $7710effdbf78fe81$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $7710effdbf78fe81$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
            y -= lineHeight;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x + width > maxX) maxX = x + width;
            if (y + height > maxY) maxY = y + height;
            textLines.push({
                text: line,
                encoded: encoded,
                width: width,
                height: height,
                x: x,
                y: y
            });
            // Only trim lines that we had to split ourselves. So we won't trim lines
            // that the user provided themselves with whitespace.
            prevRemainder = remainder === null || remainder === void 0 ? void 0 : remainder.trim();
        }
    }
    return {
        fontSize: fontSize,
        lineHeight: lineHeight,
        lines: textLines,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $e17b55f7294d0131$export$deba41d88dd75dfc = function(text, _a) {
    var fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds, cellCount = _a.cellCount;
    var line = (0, $cZKSB.mergeLines)((0, $cZKSB.cleanText)(text));
    if (line.length > cellCount) throw new (0, $ab1852e734a4db56$export$5283dffc620a5c9f)(line.length, cellCount);
    if (fontSize === undefined || fontSize === 0) fontSize = $e17b55f7294d0131$var$computeCombedFontSize(line, font, bounds, cellCount);
    var cellWidth = bounds.width / cellCount;
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    var y = bounds.y + (bounds.height / 2 - height / 2);
    var cells = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var cellOffset = 0;
    var charOffset = 0;
    while(cellOffset < cellCount){
        var _b = (0, $cZKSB.charAtIndex)(line, charOffset), char = _b[0], charLength = _b[1];
        var encoded = font.encodeText(char);
        var width = font.widthOfTextAtSize(char, fontSize);
        var cellCenter = bounds.x + (cellWidth * cellOffset + cellWidth / 2);
        var x = cellCenter - width / 2;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x + width > maxX) maxX = x + width;
        if (y + height > maxY) maxY = y + height;
        cells.push({
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        });
        cellOffset += 1;
        charOffset += charLength;
    }
    return {
        fontSize: fontSize,
        cells: cells,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $e17b55f7294d0131$export$c0030606588cf6f2 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var line = (0, $cZKSB.mergeLines)((0, $cZKSB.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $e17b55f7294d0131$var$computeFontSize([
        line
    ], font, bounds);
    var encoded = font.encodeText(line);
    var width = font.widthOfTextAtSize(line, fontSize);
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    // prettier-ignore
    var x = alignment === (0, $7710effdbf78fe81$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $7710effdbf78fe81$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $7710effdbf78fe81$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
    var y = bounds.y + (bounds.height / 2 - height / 2);
    return {
        fontSize: fontSize,
        line: {
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        },
        bounds: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    };
};




parcelRequire("6vLBB");
var $cZKSB = parcelRequire("cZKSB");
var $6754534916e67e80$export$8a3aea031520d39b = function(appearance) {
    if ("normal" in appearance) return appearance;
    return {
        normal: appearance
    };
};
// Examples:
//   `/Helv 12 Tf` -> ['/Helv 12 Tf', 'Helv', '12']
//   `/HeBo 8.00 Tf` -> ['/HeBo 8 Tf', 'HeBo', '8.00']
var $6754534916e67e80$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/;
var $6754534916e67e80$var$getDefaultFontSize = function(field) {
    var _a, _b;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : "";
    var daMatch = (_b = (0, $cZKSB.findLastMatch)(da, $6754534916e67e80$var$tfRegex).match) !== null && _b !== void 0 ? _b : [];
    var defaultFontSize = Number(daMatch[2]);
    return isFinite(defaultFontSize) ? defaultFontSize : undefined;
};
// Examples:
//   `0.3 g` -> ['0.3', 'g']
//   `0.3 1 .3 rg` -> ['0.3', '1', '.3', 'rg']
//   `0.3 1 .3 0 k` -> ['0.3', '1', '.3', '0', 'k']
var $6754534916e67e80$var$colorRegex = /(\d*\.\d+|\d+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+(g|rg|k)/;
var $6754534916e67e80$var$getDefaultColor = function(field) {
    var _a;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : "";
    var daMatch = (0, $cZKSB.findLastMatch)(da, $6754534916e67e80$var$colorRegex).match;
    var _b = daMatch !== null && daMatch !== void 0 ? daMatch : [], c1 = _b[1], c2 = _b[2], c3 = _b[3], c4 = _b[4], colorSpace = _b[5];
    if (colorSpace === "g" && c1) return (0, $c9f3d3f740911584$export$6f416a6db2dfcd5c)(Number(c1));
    if (colorSpace === "rg" && c1 && c2 && c3) return (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(Number(c1), Number(c2), Number(c3));
    if (colorSpace === "k" && c1 && c2 && c3 && c4) return (0, $c9f3d3f740911584$export$358b1a66a3c77756)(Number(c1), Number(c2), Number(c3), Number(c4));
    return undefined;
};
var $6754534916e67e80$var$updateDefaultAppearance = function(field, color, font, fontSize) {
    var _a;
    if (fontSize === void 0) fontSize = 0;
    var da = [
        (0, $c9f3d3f740911584$export$6126e5d7ba707741)(color).toString(),
        (0, $7b945c9f8f83b90a$export$df01d619ff6ce7f7)((_a = font === null || font === void 0 ? void 0 : font.name) !== null && _a !== void 0 ? _a : "dummy__noop", fontSize).toString()
    ].join("\n");
    field.setDefaultAppearance(da);
};
var $6754534916e67e80$export$e11eab3ac6c06eb0 = function(checkBox, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $6754534916e67e80$var$getDefaultColor(widget);
    var fieldColor = $6754534916e67e80$var$getDefaultColor(checkBox.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $d82a2f5ff75b3e04$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $d82a2f5ff75b3e04$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $59179fabd6039f42$export$5dd9a0a87f38a2a6)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $6754534916e67e80$var$updateDefaultAppearance(widget, textColor);
    else $6754534916e67e80$var$updateDefaultAppearance(checkBox.acroField, textColor);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        thickness: 1.5,
        borderWidth: borderWidth,
        borderColor: borderColor,
        markColor: textColor
    };
    return {
        normal: {
            on: (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$1c2f7a8d0ec539ab)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$1c2f7a8d0ec539ab)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$1c2f7a8d0ec539ab)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$1c2f7a8d0ec539ab)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $6754534916e67e80$export$6440094330a99ef8 = function(radioGroup, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $6754534916e67e80$var$getDefaultColor(widget);
    var fieldColor = $6754534916e67e80$var$getDefaultColor(radioGroup.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $d82a2f5ff75b3e04$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $d82a2f5ff75b3e04$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $59179fabd6039f42$export$5dd9a0a87f38a2a6)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $6754534916e67e80$var$updateDefaultAppearance(widget, textColor);
    else $6754534916e67e80$var$updateDefaultAppearance(radioGroup.acroField, textColor);
    var options = {
        x: width / 2,
        y: height / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        dotColor: textColor
    };
    return {
        normal: {
            on: (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$d01bb537f184a293)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$d01bb537f184a293)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$d01bb537f184a293)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$d01bb537f184a293)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $6754534916e67e80$export$68f9b19f48ffeeec = function(button, widget, font) {
    var _a, _b, _c, _d, _e;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $6754534916e67e80$var$getDefaultColor(widget);
    var fieldColor = $6754534916e67e80$var$getDefaultColor(button.acroField);
    var widgetFontSize = $6754534916e67e80$var$getDefaultFontSize(widget);
    var fieldFontSize = $6754534916e67e80$var$getDefaultFontSize(button.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var captions = ap === null || ap === void 0 ? void 0 : ap.getCaptions();
    var normalText = (_a = captions === null || captions === void 0 ? void 0 : captions.normal) !== null && _a !== void 0 ? _a : "";
    var downText = (_c = (_b = captions === null || captions === void 0 ? void 0 : captions.down) !== null && _b !== void 0 ? _b : normalText) !== null && _c !== void 0 ? _c : "";
    var borderWidth = (_d = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _d !== void 0 ? _d : 0;
    var rotation = (0, $d82a2f5ff75b3e04$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _f = (0, $d82a2f5ff75b3e04$export$312e44550db33c6a)(rectangle, rotation), width = _f.width, height = _f.height;
    var rotate = (0, $59179fabd6039f42$export$5dd9a0a87f38a2a6)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    var bounds = {
        x: borderWidth,
        y: borderWidth,
        width: width - borderWidth * 2,
        height: height - borderWidth * 2
    };
    var normalLayout = (0, $e17b55f7294d0131$export$c0030606588cf6f2)(normalText, {
        alignment: (0, $7710effdbf78fe81$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    var downLayout = (0, $e17b55f7294d0131$export$c0030606588cf6f2)(downText, {
        alignment: (0, $7710effdbf78fe81$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    // Update font size and color
    var fontSize = Math.min(normalLayout.fontSize, downLayout.fontSize);
    var textColor = (_e = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _e !== void 0 ? _e : black;
    if (widgetColor || widgetFontSize !== undefined) $6754534916e67e80$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $6754534916e67e80$var$updateDefaultAppearance(button.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize
    };
    return {
        normal: (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$31046eb8c5070d92)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, options), {
            color: normalBackgroundColor,
            textLines: [
                normalLayout.line
            ]
        }))),
        down: (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$31046eb8c5070d92)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, options), {
            color: downBackgroundColor,
            textLines: [
                downLayout.line
            ]
        })))
    };
};
var $6754534916e67e80$export$42ba95e6b8df3d7 = function(textField, widget, font) {
    var _a, _b, _c, _d;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $6754534916e67e80$var$getDefaultColor(widget);
    var fieldColor = $6754534916e67e80$var$getDefaultColor(textField.acroField);
    var widgetFontSize = $6754534916e67e80$var$getDefaultFontSize(widget);
    var fieldFontSize = $6754534916e67e80$var$getDefaultFontSize(textField.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = textField.getText()) !== null && _a !== void 0 ? _a : "";
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $d82a2f5ff75b3e04$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _e = (0, $d82a2f5ff75b3e04$export$312e44550db33c6a)(rectangle, rotation), width = _e.width, height = _e.height;
    var rotate = (0, $59179fabd6039f42$export$5dd9a0a87f38a2a6)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var textLines;
    var fontSize;
    var padding = textField.isCombed() ? 0 : 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    if (textField.isMultiline()) {
        var layout = (0, $e17b55f7294d0131$export$f6ba9f13f815cc95)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = layout.lines;
        fontSize = layout.fontSize;
    } else if (textField.isCombed()) {
        var layout = (0, $e17b55f7294d0131$export$deba41d88dd75dfc)(text, {
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds,
            cellCount: (_c = textField.getMaxLength()) !== null && _c !== void 0 ? _c : 0
        });
        textLines = layout.cells;
        fontSize = layout.fontSize;
    } else {
        var layout = (0, $e17b55f7294d0131$export$c0030606588cf6f2)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = [
            layout.line
        ];
        fontSize = layout.fontSize;
    }
    // Update font size and color
    var textColor = (_d = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _d !== void 0 ? _d : black;
    if (widgetColor || widgetFontSize !== undefined) $6754534916e67e80$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $6754534916e67e80$var$updateDefaultAppearance(textField.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: textLines,
        padding: padding
    };
    return (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$7d8517ad99905084)(options));
};
var $6754534916e67e80$export$90f1ca03d512ec5 = function(dropdown, widget, font) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $6754534916e67e80$var$getDefaultColor(widget);
    var fieldColor = $6754534916e67e80$var$getDefaultColor(dropdown.acroField);
    var widgetFontSize = $6754534916e67e80$var$getDefaultFontSize(widget);
    var fieldFontSize = $6754534916e67e80$var$getDefaultFontSize(dropdown.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = dropdown.getSelected()[0]) !== null && _a !== void 0 ? _a : "";
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $d82a2f5ff75b3e04$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $d82a2f5ff75b3e04$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $59179fabd6039f42$export$5dd9a0a87f38a2a6)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _e = (0, $e17b55f7294d0131$export$c0030606588cf6f2)(text, {
        alignment: (0, $7710effdbf78fe81$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), line = _e.line, fontSize = _e.fontSize;
    // Update font size and color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor || widgetFontSize !== undefined) $6754534916e67e80$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $6754534916e67e80$var$updateDefaultAppearance(dropdown.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: [
            line
        ],
        padding: padding
    };
    return (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$7d8517ad99905084)(options));
};
var $6754534916e67e80$export$f9fab495286778d2 = function(optionList, widget, font) {
    var _a, _b;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $6754534916e67e80$var$getDefaultColor(widget);
    var fieldColor = $6754534916e67e80$var$getDefaultColor(optionList.acroField);
    var widgetFontSize = $6754534916e67e80$var$getDefaultFontSize(widget);
    var fieldFontSize = $6754534916e67e80$var$getDefaultFontSize(optionList.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $d82a2f5ff75b3e04$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _c = (0, $d82a2f5ff75b3e04$export$312e44550db33c6a)(rectangle, rotation), width = _c.width, height = _c.height;
    var rotate = (0, $59179fabd6039f42$export$5dd9a0a87f38a2a6)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $c9f3d3f740911584$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var options = optionList.getOptions();
    var selected = optionList.getSelected();
    if (optionList.isSorted()) options.sort();
    var text = "";
    for(var idx = 0, len = options.length; idx < len; idx++){
        text += options[idx];
        if (idx < len - 1) text += "\n";
    }
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _d = (0, $e17b55f7294d0131$export$f6ba9f13f815cc95)(text, {
        alignment: (0, $7710effdbf78fe81$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), lines = _d.lines, fontSize = _d.fontSize, lineHeight = _d.lineHeight;
    var selectedLines = [];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var line = lines[idx];
        if (selected.includes(line.text)) selectedLines.push(idx);
    }
    var blue = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0.6, 193 / 255, 218 / 255);
    // Update font size and color
    var textColor = (_b = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _b !== void 0 ? _b : black;
    if (widgetColor || widgetFontSize !== undefined) $6754534916e67e80$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $6754534916e67e80$var$updateDefaultAppearance(optionList.acroField, textColor, font, fontSize);
    return (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$5a3093287b85b7c0)({
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: lines,
        lineHeight: lineHeight,
        selectedColor: blue,
        selectedLines: selectedLines,
        padding: padding
    }));
};



var $59LZ8 = parcelRequire("59LZ8");

var $59LZ8 = parcelRequire("59LZ8");




var $59LZ8 = parcelRequire("59LZ8");


var $59LZ8 = parcelRequire("59LZ8");


parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
/**
 * Represents a PDF page that has been embedded in a [[PDFDocument]].
 */ var $1b46723a68d54b97$var$PDFEmbeddedPage = /** @class */ function() {
    function PDFEmbeddedPage(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        (0, $2qnUk.assertIs)(ref, "ref", [
            [
                (0, $06a507a20ec07388$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        (0, $2qnUk.assertIs)(doc, "doc", [
            [
                (0, $c32e913e0d181c9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        (0, $2qnUk.assertIs)(embedder, "embedder", [
            [
                (0, $898d4138dcc9c9b7$export$2e2bcd8739ae039),
                "PDFPageEmbedder"
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this page after being scaled by the
     * given `factor`. For example:
     * ```js
     * embeddedPage.width  // => 500
     * embeddedPage.height // => 250
     *
     * const scaled = embeddedPage.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing a page with
     * [[PDFPage.drawPage]] to compute the `width` and `height` options.
     * @param factor The factor by which this page should be scaled.
     * @returns The width and height of the page after being scaled.
     */ PDFEmbeddedPage.prototype.scale = function(factor) {
        (0, $2qnUk.assertIs)(factor, "factor", [
            "number"
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this page. For example:
     * ```js
     * const { width, height } = embeddedPage.size()
     * ```
     * @returns The width and height of the page.
     */ PDFEmbeddedPage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable pages get embedded.
     *
     * Embed this embeddable page in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedPage.prototype.embed = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPdf]] and
     * > [[PDFDocument.embedPage]] methods, which will create instances of
     * > [[PDFEmbeddedPage]] for you.
     *
     * Create an instance of [[PDFEmbeddedPage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this embedded page.
     * @param doc The document to which the embedded page will belong.
     * @param embedder The embedder that will be used to embed the page.
     */ PDFEmbeddedPage.of = function(ref, doc, embedder) {
        return new PDFEmbeddedPage(ref, doc, embedder);
    };
    return PDFEmbeddedPage;
}();
var $1b46723a68d54b97$export$2e2bcd8739ae039 = $1b46723a68d54b97$var$PDFEmbeddedPage;



var $59LZ8 = parcelRequire("59LZ8");


parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
/**
 * Represents a font that has been embedded in a [[PDFDocument]].
 */ var $489bb5c728206ba0$var$PDFFont = /** @class */ function() {
    function PDFFont(ref, doc, embedder) {
        this.modified = true;
        (0, $2qnUk.assertIs)(ref, "ref", [
            [
                (0, $06a507a20ec07388$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        (0, $2qnUk.assertIs)(doc, "doc", [
            [
                (0, $c32e913e0d181c9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        (0, $2qnUk.assertIs)(embedder, "embedder", [
            [
                (0, $94580d5a22612d4f$export$2e2bcd8739ae039),
                "CustomFontEmbedder"
            ],
            [
                (0, $587d3987c4649df3$export$2e2bcd8739ae039),
                "StandardFontEmbedder"
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.name = embedder.fontName;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFPage.drawText]] method will automatically encode the text it is
     * > given.
     *
     * Encodes a string of text in this font.
     *
     * @param text The text to be encoded.
     * @returns The encoded text as a hex string.
     */ PDFFont.prototype.encodeText = function(text) {
        (0, $2qnUk.assertIs)(text, "text", [
            "string"
        ]);
        this.modified = true;
        return this.embedder.encodeText(text);
    };
    /**
     * Measure the width of a string of text drawn in this font at a given size.
     * For example:
     * ```js
     * const width = font.widthOfTextAtSize('Foo Bar Qux Baz', 36)
     * ```
     * @param text The string of text to be measured.
     * @param size The font size to be used for this measurement.
     * @returns The width of the string of text when drawn in this font at the
     *          given size.
     */ PDFFont.prototype.widthOfTextAtSize = function(text, size) {
        (0, $2qnUk.assertIs)(text, "text", [
            "string"
        ]);
        (0, $2qnUk.assertIs)(size, "size", [
            "number"
        ]);
        return this.embedder.widthOfTextAtSize(text, size);
    };
    /**
     * Measure the height of this font at a given size. For example:
     * ```js
     * const height = font.heightAtSize(24)
     * ```
     *
     * The `options.descender` value controls whether or not the font's
     * descender is included in the height calculation.
     *
     * @param size The font size to be used for this measurement.
     * @param options The options to be used when computing this measurement.
     * @returns The height of this font at the given size.
     */ PDFFont.prototype.heightAtSize = function(size, options) {
        var _a;
        (0, $2qnUk.assertIs)(size, "size", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.descender, "options.descender", [
            "boolean"
        ]);
        return this.embedder.heightOfFontAtSize(size, {
            descender: (_a = options === null || options === void 0 ? void 0 : options.descender) !== null && _a !== void 0 ? _a : true
        });
    };
    /**
     * Compute the font size at which this font is a given height. For example:
     * ```js
     * const fontSize = font.sizeAtHeight(12)
     * ```
     * @param height The height to be used for this calculation.
     * @returns The font size at which this font is the given height.
     */ PDFFont.prototype.sizeAtHeight = function(height) {
        (0, $2qnUk.assertIs)(height, "height", [
            "number"
        ]);
        return this.embedder.sizeOfFontAtHeight(height);
    };
    /**
     * Get the set of unicode code points that can be represented by this font.
     * @returns The set of unicode code points supported by this font.
     */ PDFFont.prototype.getCharacterSet = function() {
        if (this.embedder instanceof (0, $587d3987c4649df3$export$2e2bcd8739ae039)) return this.embedder.encoding.supportedCodePoints;
        else return this.embedder.font.characterSet;
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all fonts get embedded.
     *
     * Embed this font in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFFont.prototype.embed = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.modified) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.modified = false;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedFont]] and
     * > [[PDFDocument.embedStandardFont]] methods, which will create instances
     * > of [[PDFFont]] for you.
     *
     * Create an instance of [[PDFFont]] from an existing ref and embedder
     *
     * @param ref The unique reference for this font.
     * @param doc The document to which the font will belong.
     * @param embedder The embedder that will be used to embed the font.
     */ PDFFont.of = function(ref, doc, embedder) {
        return new PDFFont(ref, doc, embedder);
    };
    return PDFFont;
}();
var $489bb5c728206ba0$export$2e2bcd8739ae039 = $489bb5c728206ba0$var$PDFFont;



var $59LZ8 = parcelRequire("59LZ8");


parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
/**
 * Represents an image that has been embedded in a [[PDFDocument]].
 */ var $625ea9c00707f127$var$PDFImage = /** @class */ function() {
    function PDFImage(ref, doc, embedder) {
        (0, $2qnUk.assertIs)(ref, "ref", [
            [
                (0, $06a507a20ec07388$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        (0, $2qnUk.assertIs)(doc, "doc", [
            [
                (0, $c32e913e0d181c9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        (0, $2qnUk.assertIs)(embedder, "embedder", [
            [
                (0, $52ae0fa4c28dbb24$export$2e2bcd8739ae039),
                "JpegEmbedder"
            ],
            [
                (0, $0a39e685a1b53e0a$export$2e2bcd8739ae039),
                "PngEmbedder"
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this image after being scaled by the
     * given `factor`. For example:
     * ```js
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing an image with
     * [[PDFPage.drawImage]] to compute the `width` and `height` options.
     * @param factor The factor by which this image should be scaled.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scale = function(factor) {
        (0, $2qnUk.assertIs)(factor, "factor", [
            "number"
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this image after scaling it as large as
     * possible while maintaining its aspect ratio and not exceeding the
     * specified `width` and `height`. For example:
     * ```
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scaleToFit(750, 1000)
     * scaled.width  // => 750
     * scaled.height // => 375
     * ```
     * The `width` and `height` parameters can also be thought of as the width
     * and height of a box that the scaled image must fit within.
     * @param width The bounding box's width.
     * @param height The bounding box's height.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scaleToFit = function(width, height) {
        (0, $2qnUk.assertIs)(width, "width", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(height, "height", [
            "number"
        ]);
        var imgWidthScale = width / this.width;
        var imgHeightScale = height / this.height;
        var scale = Math.min(imgWidthScale, imgHeightScale);
        return this.scale(scale);
    };
    /**
     * Get the width and height of this image. For example:
     * ```js
     * const { width, height } = image.size()
     * ```
     * @returns The width and height of the image.
     */ PDFImage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all images get embedded.
     *
     * Embed this image in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFImage.prototype.embed = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var _a, doc, ref;
            return (0, $59LZ8.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.embedder) return [
                            2 /*return*/ 
                        ];
                        // The image should only be embedded once. If there's a pending embed
                        // operation then wait on it. Otherwise we need to start the embed.
                        if (!this.embedTask) {
                            _a = this, doc = _a.doc, ref = _a.ref;
                            this.embedTask = this.embedder.embedIntoContext(doc.context, ref);
                        }
                        return [
                            4 /*yield*/ ,
                            this.embedTask
                        ];
                    case 1:
                        _b.sent();
                        // We clear `this.embedder` so that the indirectly referenced image data
                        // can be garbage collected, thus avoiding a memory leak.
                        // See https://github.com/Hopding/pdf-lib/pull/1032/files.
                        this.embedder = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPng]] and [[PDFDocument.embedJpg]]
     * > methods, which will create instances of [[PDFImage]] for you.
     *
     * Create an instance of [[PDFImage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this image.
     * @param doc The document to which the image will belong.
     * @param embedder The embedder that will be used to embed the image.
     */ PDFImage.of = function(ref, doc, embedder) {
        return new PDFImage(ref, doc, embedder);
    };
    return PDFImage;
}();
var $625ea9c00707f127$export$2e2bcd8739ae039 = $625ea9c00707f127$var$PDFImage;




var $59LZ8 = parcelRequire("59LZ8");



var $59LZ8 = parcelRequire("59LZ8");





var $59LZ8 = parcelRequire("59LZ8");




var $1cWQu = parcelRequire("1cWQu");
var $a7yPZ = parcelRequire("a7yPZ");
parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
var $a851711d2fd1c050$export$8efa99ca8f041e7e;
(function(ImageAlignment) {
    ImageAlignment[ImageAlignment["Left"] = 0] = "Left";
    ImageAlignment[ImageAlignment["Center"] = 1] = "Center";
    ImageAlignment[ImageAlignment["Right"] = 2] = "Right";
})($a851711d2fd1c050$export$8efa99ca8f041e7e || ($a851711d2fd1c050$export$8efa99ca8f041e7e = {}));





var $284a8acf05ac55e4$export$55643210f1835a35 = function(options) {
    (0, $2qnUk.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.x, "options.x", [
        "number"
    ]);
    (0, $2qnUk.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.y, "options.y", [
        "number"
    ]);
    (0, $2qnUk.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.width, "options.width", [
        "number"
    ]);
    (0, $2qnUk.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.height, "options.height", [
        "number"
    ]);
    (0, $2qnUk.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.textColor, "options.textColor", [
        [
            Object,
            "Color"
        ]
    ]);
    (0, $2qnUk.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.backgroundColor, "options.backgroundColor", [
        [
            Object,
            "Color"
        ]
    ]);
    (0, $2qnUk.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderColor, "options.borderColor", [
        [
            Object,
            "Color"
        ]
    ]);
    (0, $2qnUk.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderWidth, "options.borderWidth", [
        "number"
    ]);
    (0, $2qnUk.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.rotate, "options.rotate", [
        [
            Object,
            "Rotation"
        ]
    ]);
};
/**
 * Represents a field of a [[PDFForm]].
 *
 * This class is effectively abstract. All fields in a [[PDFForm]] will
 * actually be an instance of a subclass of this class.
 *
 * Note that each field in a PDF is represented by a single field object.
 * However, a given field object may be rendered at multiple locations within
 * the document (across one or more pages). The rendering of a field is
 * controlled by its widgets. Each widget causes its field to be displayed at a
 * particular location in the document.
 *
 * Most of the time each field in a PDF has only a single widget, and thus is
 * only rendered once. However, if a field is rendered multiple times, it will
 * have multiple widgets - one for each location it is rendered.
 *
 * This abstraction of field objects and widgets is defined in the PDF
 * specification and dictates how PDF files store fields and where they are
 * to be rendered.
 */ var $284a8acf05ac55e4$var$PDFField = /** @class */ function() {
    function PDFField(acroField, ref, doc) {
        (0, $2qnUk.assertIs)(acroField, "acroField", [
            [
                (0, $05ddbe3c6f42d8d9$export$2e2bcd8739ae039),
                "PDFAcroTerminal"
            ]
        ]);
        (0, $2qnUk.assertIs)(ref, "ref", [
            [
                (0, $06a507a20ec07388$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        (0, $2qnUk.assertIs)(doc, "doc", [
            [
                (0, $c32e913e0d181c9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        this.acroField = acroField;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Get the fully qualified name of this field. For example:
     * ```js
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const name = field.getName()
     *   console.log('Field name:', name)
     * })
     * ```
     * Note that PDF fields are structured as a tree. Each field is the
     * descendent of a series of ancestor nodes all the way up to the form node,
     * which is always the root of the tree. Each node in the tree (except for
     * the form node) has a partial name. Partial names can be composed of any
     * unicode characters except a period (`.`). The fully qualified name of a
     * field is composed of the partial names of all its ancestors joined
     * with periods. This means that splitting the fully qualified name on
     * periods and taking the last element of the resulting array will give you
     * the partial name of a specific field.
     * @returns The fully qualified name of this field.
     */ PDFField.prototype.getName = function() {
        var _a;
        return (_a = this.acroField.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : "";
    };
    /**
     * Returns `true` if this field is read only. This means that PDF readers
     * will not allow users to interact with the field or change its value. See
     * [[PDFField.enableReadOnly]] and [[PDFField.disableReadOnly]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isReadOnly()) console.log('Read only is enabled')
     * ```
     * @returns Whether or not this is a read only field.
     */ PDFField.prototype.isReadOnly = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$3600c95532547643).ReadOnly);
    };
    /**
     * Prevent PDF readers from allowing users to interact with this field or
     * change its value. The field will not respond to mouse or keyboard input.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableReadOnly()
     * ```
     * Useful for fields whose values are computed, imported from a database, or
     * prefilled by software before being displayed to the user.
     */ PDFField.prototype.enableReadOnly = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$3600c95532547643).ReadOnly, true);
    };
    /**
     * Allow users to interact with this field and change its value in PDF
     * readers via mouse and keyboard input. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableReadOnly()
     * ```
     */ PDFField.prototype.disableReadOnly = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$3600c95532547643).ReadOnly, false);
    };
    /**
     * Returns `true` if this field must have a value when the form is submitted.
     * See [[PDFField.enableRequired]] and [[PDFField.disableRequired]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isRequired()) console.log('Field is required')
     * ```
     * @returns Whether or not this field is required.
     */ PDFField.prototype.isRequired = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$3600c95532547643).Required);
    };
    /**
     * Require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableRequired()
     * ```
     */ PDFField.prototype.enableRequired = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$3600c95532547643).Required, true);
    };
    /**
     * Do not require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableRequired()
     * ```
     */ PDFField.prototype.disableRequired = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$3600c95532547643).Required, false);
    };
    /**
     * Returns `true` if this field's value should be exported when the form is
     * submitted. See [[PDFField.enableExporting]] and
     * [[PDFField.disableExporting]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isExported()) console.log('Exporting is enabled')
     * ```
     * @returns Whether or not this field's value should be exported.
     */ PDFField.prototype.isExported = function() {
        return !this.acroField.hasFlag((0, $5e94843d22be1325$export$3600c95532547643).NoExport);
    };
    /**
     * Indicate that this field's value should be exported when the form is
     * submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableExporting()
     * ```
     */ PDFField.prototype.enableExporting = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$3600c95532547643).NoExport, false);
    };
    /**
     * Indicate that this field's value should **not** be exported when the form
     * is submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableExporting()
     * ```
     */ PDFField.prototype.disableExporting = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$3600c95532547643).NoExport, true);
    };
    /** @ignore */ PDFField.prototype.needsAppearancesUpdate = function() {
        throw new (0, $1cWQu.MethodNotImplementedError)(this.constructor.name, "needsAppearancesUpdate");
    };
    /** @ignore */ PDFField.prototype.defaultUpdateAppearances = function(_font) {
        throw new (0, $1cWQu.MethodNotImplementedError)(this.constructor.name, "defaultUpdateAppearances");
    };
    PDFField.prototype.markAsDirty = function() {
        this.doc.getForm().markFieldAsDirty(this.ref);
    };
    PDFField.prototype.markAsClean = function() {
        this.doc.getForm().markFieldAsClean(this.ref);
    };
    PDFField.prototype.isDirty = function() {
        return this.doc.getForm().fieldIsDirty(this.ref);
    };
    PDFField.prototype.createWidget = function(options) {
        var _a;
        var textColor = options.textColor;
        var backgroundColor = options.backgroundColor;
        var borderColor = options.borderColor;
        var borderWidth = options.borderWidth;
        var degreesAngle = (0, $d82a2f5ff75b3e04$export$56cb859c01fa134d)(options.rotate);
        var caption = options.caption;
        var x = options.x;
        var y = options.y;
        var width = options.width + borderWidth;
        var height = options.height + borderWidth;
        var hidden = Boolean(options.hidden);
        var pageRef = options.page;
        (0, $2qnUk.assertMultiple)(degreesAngle, "degreesAngle", 90);
        // Create a widget for this field
        var widget = (0, $7d23e60087e51548$export$2e2bcd8739ae039).create(this.doc.context, this.ref);
        // Set widget properties
        var rect = (0, $d82a2f5ff75b3e04$export$afddc3b8600307a4)({
            x: x,
            y: y,
            width: width,
            height: height
        }, borderWidth, degreesAngle);
        widget.setRectangle(rect);
        if (pageRef) widget.setP(pageRef);
        var ac = widget.getOrCreateAppearanceCharacteristics();
        if (backgroundColor) ac.setBackgroundColor((0, $c9f3d3f740911584$export$ffee2793812e3e56)(backgroundColor));
        ac.setRotation(degreesAngle);
        if (caption) ac.setCaptions({
            normal: caption
        });
        if (borderColor) ac.setBorderColor((0, $c9f3d3f740911584$export$ffee2793812e3e56)(borderColor));
        var bs = widget.getOrCreateBorderStyle();
        if (borderWidth !== undefined) bs.setWidth(borderWidth);
        widget.setFlagTo((0, $81e8a0a81fcef9c3$export$1fa7b68b35026177).Print, true);
        widget.setFlagTo((0, $81e8a0a81fcef9c3$export$1fa7b68b35026177).Hidden, hidden);
        widget.setFlagTo((0, $81e8a0a81fcef9c3$export$1fa7b68b35026177).Invisible, false);
        // Set acrofield properties
        if (textColor) {
            var da = (_a = this.acroField.getDefaultAppearance()) !== null && _a !== void 0 ? _a : "";
            var newDa = da + "\n" + (0, $c9f3d3f740911584$export$6126e5d7ba707741)(textColor).toString();
            this.acroField.setDefaultAppearance(newDa);
        }
        return widget;
    };
    PDFField.prototype.updateWidgetAppearanceWithFont = function(widget, font, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceStream(widget, normal, font),
            rollover: rollover && this.createAppearanceStream(widget, rollover, font),
            down: down && this.createAppearanceStream(widget, down, font)
        });
    };
    PDFField.prototype.updateOnOffWidgetAppearance = function(widget, onValue, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceDict(widget, normal, onValue),
            rollover: rollover && this.createAppearanceDict(widget, rollover, onValue),
            down: down && this.createAppearanceDict(widget, down, onValue)
        });
    };
    PDFField.prototype.updateWidgetAppearances = function(widget, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        widget.setNormalAppearance(normal);
        if (rollover) widget.setRolloverAppearance(rollover);
        else widget.removeRolloverAppearance();
        if (down) widget.setDownAppearance(down);
        else widget.removeDownAppearance();
    };
    // // TODO: Do we need to do this...?
    // private foo(font: PDFFont, dict: PDFDict) {
    //   if (!dict.lookup(PDFName.of('DR'))) {
    //     dict.set(PDFName.of('DR'), dict.context.obj({}));
    //   }
    //   const DR = dict.lookup(PDFName.of('DR'), PDFDict);
    //   if (!DR.lookup(PDFName.of('Font'))) {
    //     DR.set(PDFName.of('Font'), dict.context.obj({}));
    //   }
    //   const Font = DR.lookup(PDFName.of('Font'), PDFDict);
    //   Font.set(PDFName.of(font.name), font.ref);
    // }
    PDFField.prototype.createAppearanceStream = function(widget, appearance, font) {
        var _a;
        var context = this.acroField.dict.context;
        var _b = widget.getRectangle(), width = _b.width, height = _b.height;
        // TODO: Do we need to do this...?
        // if (font) {
        //   this.foo(font, widget.dict);
        //   this.foo(font, this.doc.getForm().acroForm.dict);
        // }
        // END TODO
        var Resources = font && {
            Font: (_a = {}, _a[font.name] = font.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                width,
                height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        var streamRef = context.register(stream);
        return streamRef;
    };
    /**
     * Create a FormXObject of the supplied image and add it to context.
     * The FormXObject size is calculated based on the widget (including
     * the alignment).
     * @param widget The widget that should display the image.
     * @param alignment The alignment of the image.
     * @param image The image that should be displayed.
     * @returns The ref for the FormXObject that was added to the context.
     */ PDFField.prototype.createImageAppearanceStream = function(widget, image, alignment) {
        // NOTE: This implementation doesn't handle image borders.
        // NOTE: Acrobat seems to resize the image (maybe even skewing its aspect
        //       ratio) to fit perfectly within the widget's rectangle. This method
        //       does not currently do that. Should there be an option for that?
        var _a;
        var _b;
        var context = this.acroField.dict.context;
        var rectangle = widget.getRectangle();
        var ap = widget.getAppearanceCharacteristics();
        var bs = widget.getBorderStyle();
        var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
        var rotation = (0, $d82a2f5ff75b3e04$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
        var rotate = (0, $59179fabd6039f42$export$5dd9a0a87f38a2a6)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, rectangle), {
            rotation: rotation
        }));
        var adj = (0, $d82a2f5ff75b3e04$export$312e44550db33c6a)(rectangle, rotation);
        var imageDims = image.scaleToFit(adj.width - borderWidth * 2, adj.height - borderWidth * 2);
        // Support borders on images and maybe other properties
        var options = {
            x: borderWidth,
            y: borderWidth,
            width: imageDims.width,
            height: imageDims.height,
            //
            rotate: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            xSkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            ySkew: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0)
        };
        if (alignment === (0, $a851711d2fd1c050$export$8efa99ca8f041e7e).Center) {
            options.x += (adj.width - borderWidth * 2) / 2 - imageDims.width / 2;
            options.y += (adj.height - borderWidth * 2) / 2 - imageDims.height / 2;
        } else if (alignment === (0, $a851711d2fd1c050$export$8efa99ca8f041e7e).Right) {
            options.x = adj.width - borderWidth - imageDims.width;
            options.y = adj.height - borderWidth - imageDims.height;
        }
        var imageName = this.doc.context.addRandomSuffix("Image", 10);
        var appearance = (0, $59LZ8.__spreadArrays)(rotate, (0, $59179fabd6039f42$export$21a059be5bfd5fb)(imageName, options));
        ////////////
        var Resources = {
            XObject: (_a = {}, _a[imageName] = image.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                rectangle.width,
                rectangle.height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        return context.register(stream);
    };
    PDFField.prototype.createAppearanceDict = function(widget, appearance, onValue) {
        var context = this.acroField.dict.context;
        var onStreamRef = this.createAppearanceStream(widget, appearance.on);
        var offStreamRef = this.createAppearanceStream(widget, appearance.off);
        var appearanceDict = context.obj({});
        appearanceDict.set(onValue, onStreamRef);
        appearanceDict.set((0, $a7yPZ.default).of("Off"), offStreamRef);
        return appearanceDict;
    };
    return PDFField;
}();
var $284a8acf05ac55e4$export$2e2bcd8739ae039 = $284a8acf05ac55e4$var$PDFField;



var $a7yPZ = parcelRequire("a7yPZ");
parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
/**
 * Represents a check box field of a [[PDFForm]].
 *
 * [[PDFCheckBox]] fields are interactive boxes that users can click with their
 * mouse. This type of [[PDFField]] has two states: `on` and `off`. The purpose
 * of a check box is to enable users to select from one or more options, where
 * each option is represented by a single check box. Check boxes are typically
 * square in shape and display a check mark when they are in the `on` state.
 */ var $3297675f35560625$var$PDFCheckBox = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFCheckBox, _super);
    function PDFCheckBox(acroCheckBox, ref, doc) {
        var _this = _super.call(this, acroCheckBox, ref, doc) || this;
        (0, $2qnUk.assertIs)(acroCheckBox, "acroCheckBox", [
            [
                (0, $4760db20b4fb4187$export$2e2bcd8739ae039),
                "PDFAcroCheckBox"
            ]
        ]);
        _this.acroField = acroCheckBox;
        return _this;
    }
    /**
     * Mark this check box. This operation is analogous to a human user clicking
     * a check box to fill it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been selected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.check()
     * ```
     *
     * This method will mark this check box as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a check mark inside the widgets of this check box
     * field.
     */ PDFCheckBox.prototype.check = function() {
        var _a;
        var onValue = (_a = this.acroField.getOnValue()) !== null && _a !== void 0 ? _a : (0, $a7yPZ.default).of("Yes");
        this.markAsDirty();
        this.acroField.setValue(onValue);
    };
    /**
     * Clears this check box. This operation is analogous to a human user clicking
     * a check box to unmark it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been deselected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was not selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.uncheck()
     * ```
     *
     * This method will mark this check box as dirty. See [[PDFCheckBox.check]]
     * for more details about what this means.
     */ PDFCheckBox.prototype.uncheck = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $a7yPZ.default).of("Off"));
    };
    /**
     * Returns `true` if this check box is selected (either by a human user via
     * a PDF reader, or else programmatically via software). For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.isChecked()) console.log('check box is selected')
     * ```
     * @returns Whether or not this check box is selected.
     */ PDFCheckBox.prototype.isChecked = function() {
        var onValue = this.acroField.getOnValue();
        return !!onValue && onValue === this.acroField.getValue();
    };
    /**
     * Show this check box on the specified page. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('some.checkBox.field')
     *
     * checkBox.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * })
     * ```
     * This will create a new widget for this check box field.
     * @param page The page to which this check box widget should be added.
     * @param options The options to be used when adding this check box widget.
     */ PDFCheckBox.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f;
        (0, $2qnUk.assertIs)(page, "page", [
            [
                (0, $65575dc41cd048b8$export$2e2bcd8739ae039),
                "PDFPage"
            ]
        ]);
        (0, $284a8acf05ac55e4$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!("textColor" in options)) options.textColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("backgroundColor" in options)) options.backgroundColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!("borderColor" in options)) options.borderColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("borderWidth" in options)) options.borderWidth = 1;
        // Create a widget for this check box
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        widget.setAppearanceState((0, $a7yPZ.default).of("Off"));
        this.updateWidgetAppearance(widget, (0, $a7yPZ.default).of("Yes"));
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this check box's widgets do not have an
     * appearance stream for its current state. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this check box needs an appearance update.
     */ PDFCheckBox.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the default appearance provider for check boxes. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.defaultUpdateAppearances()
     * ```
     */ PDFCheckBox.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for check boxs will be used. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *     down: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFCheckBox.prototype.updateAppearances = function(provider) {
        var _a;
        (0, $2qnUk.assertOrUndefined)(provider, "provider", [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = (_a = widget.getOnValue()) !== null && _a !== void 0 ? _a : (0, $a7yPZ.default).of("Yes");
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
        this.markAsClean();
    };
    PDFCheckBox.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $6754534916e67e80$export$e11eab3ac6c06eb0);
        var appearances = (0, $6754534916e67e80$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getCheckBox]] method, which will create an
     * > instance of [[PDFCheckBox]] for you.
     *
     * Create an instance of [[PDFCheckBox]] from an existing acroCheckBox and ref
     *
     * @param acroCheckBox The underlying `PDFAcroCheckBox` for this check box.
     * @param ref The unique reference for this check box.
     * @param doc The document to which this check box will belong.
     */ PDFCheckBox.of = function(acroCheckBox, ref, doc) {
        return new PDFCheckBox(acroCheckBox, ref, doc);
    };
    return PDFCheckBox;
}((0, $284a8acf05ac55e4$export$2e2bcd8739ae039));
var $3297675f35560625$export$2e2bcd8739ae039 = $3297675f35560625$var$PDFCheckBox;



var $59LZ8 = parcelRequire("59LZ8");







parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
/**
 * Represents a dropdown field of a [[PDFForm]].
 *
 * [[PDFDropdown]] fields are interactive text boxes that display a single
 * element (the currently selected value). The purpose of a dropdown is to
 * enable users to select a single option from a set of possible options. Users
 * can click on a dropdown to view the full list of options it provides.
 * Clicking on an option in the list will cause it to be selected and displayed
 * in the dropdown's text box. Some dropdowns allow users to enter text
 * directly into the box from their keyboard, rather than only being allowed to
 * choose an option from the list (see [[PDFDropdown.isEditable]]).
 */ var $3819b41396e6f8d0$var$PDFDropdown = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFDropdown, _super);
    function PDFDropdown(acroComboBox, ref, doc) {
        var _this = _super.call(this, acroComboBox, ref, doc) || this;
        (0, $2qnUk.assertIs)(acroComboBox, "acroComboBox", [
            [
                (0, $4d501aeb209a28de$export$2e2bcd8739ae039),
                "PDFAcroComboBox"
            ]
        ]);
        _this.acroField = acroComboBox;
        return _this;
    }
    /**
     * Get the list of available options for this dropdown. These options will be
     * displayed to users who click on this dropdown in a PDF reader.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const options = dropdown.getOptions()
     * console.log('Dropdown options:', options)
     * ```
     * @returns The options for this dropdown.
     */ PDFDropdown.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this dropdown. These are the values that were
     * selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const selections = dropdown.getSelected()
     * console.log('Dropdown selections:', selections)
     * ```
     * > **NOTE:** Note that PDF readers only display one selected option when
     * > rendering dropdowns. However, the PDF specification does allow for
     * > multiple values to be selected in a dropdown. As such, the `pdf-lib`
     * > API supports this. However, in most cases the array returned by this
     * > method will contain only a single element (or no elements).
     * @returns The selected options in this dropdown.
     */ PDFDropdown.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this dropdown. These are
     * the values that will be available for users to select when they view this
     * dropdown in a PDF reader. Note that preexisting options for this dropdown
     * will be removed. Only the values passed as `options` will be available to
     * select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('planets.dropdown')
     * dropdown.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     * @param options The options that should be available in this dropdown.
     */ PDFDropdown.prototype.setOptions = function(options) {
        (0, $2qnUk.assertIs)(options, "options", [
            Array
        ]);
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this dropdown. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this dropdown will
     * still be available for users to select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('rockets.dropdown')
     * dropdown.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * @param options New options that should be available in this dropdown.
     */ PDFDropdown.prototype.addOptions = function(options) {
        (0, $2qnUk.assertIs)(options, "options", [
            "string",
            Array
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this dropdown. This operation is analogous
     * to a human user opening the dropdown in a PDF reader and clicking on a
     * value to select it. This method will update the underlying state of the
     * dropdown to indicate which values have been selected. PDF libraries and
     * readers will be able to extract these values from the saved document and
     * determine which values were selected.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('best.superhero.dropdown')
     * dropdown.select('One Punch Man')
     * ```
     *
     * This method will mark this dropdown as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the selected option inside the widgets of this dropdown.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if the selected option for this field
     * contains characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFDropdown.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * Selecting an option that does not exist in this dropdown's option list
     * (see [[PDFDropdown.getOptions]]) will enable editing on this dropdown
     * (see [[PDFDropdown.enableEditing]]).
     *
     * > **NOTE:** PDF readers only display one selected option when rendering
     * > dropdowns. However, the PDF specification does allow for multiple values
     * > to be selected in a dropdown. As such, the `pdf-lib` API supports this.
     * > However, it is not recommended to select more than one value with this
     * > method, as only one will be visible. [[PDFOptionList]] fields are better
     * > suited for displaying multiple selected values.
     *
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFDropdown.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $2qnUk.assertIs)(options, "options", [
            "string",
            Array
        ]);
        (0, $2qnUk.assertIs)(merge, "merge", [
            "boolean"
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        var hasCustomOption = optionsArr.find(function(option) {
            return !validOptions.includes(option);
        });
        if (hasCustomOption) this.enableEditing();
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this dropdown. This operation is equivalent
     * to selecting an empty list. This method will update the underlying state
     * of the dropdown to indicate that no values have been selected.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.clear()
     * ```
     * This method will mark this text field as dirty. See [[PDFDropdown.select]]
     * for more details about what this means.
     */ PDFDropdown.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this dropdown. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.setFontSize(4)
     * dropdown.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFDropdown.prototype.setFontSize = function(fontSize) {
        (0, $2qnUk.assertPositive)(fontSize, "fontSize");
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if users are allowed to edit the selected value of this
     * dropdown directly and are not constrained by the list of available
     * options. See [[PDFDropdown.enableEditing]] and
     * [[PDFDropdown.disableEditing]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isEditable()) console.log('Editing is enabled')
     * ```
     * @returns Whether or not this dropdown is editable.
     */ PDFDropdown.prototype.isEditable = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$eb88827058402599).Edit);
    };
    /**
     * Allow users to edit the selected value of this dropdown in PDF readers
     * with their keyboard. This means that the selected value of this dropdown
     * will not be constrained by the list of available options. However, if this
     * dropdown has any available options, users will still be allowed to select
     * from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableEditing()
     * ```
     */ PDFDropdown.prototype.enableEditing = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).Edit, true);
    };
    /**
     * Do not allow users to edit the selected value of this dropdown in PDF
     * readers with their keyboard. This will constrain the selected value of
     * this dropdown to the list of available options. Users will only be able
     * to select an option from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableEditing()
     * ```
     */ PDFDropdown.prototype.disableEditing = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).Edit, false);
    };
    /**
     * Returns `true` if the option list of this dropdown is always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the dropdown. See [[PDFDropdown.enableSorting]] and
     * [[PDFDropdown.disableSorting]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this dropdown's options are sorted.
     */ PDFDropdown.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$eb88827058402599).Sort);
    };
    /**
     * Always display the option list of this dropdown in alphabetical order,
     * irrespective of the order in which the options were added to this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSorting()
     * ```
     */ PDFDropdown.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the option list of this dropdown in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to the list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSorting()
     * ```
     */ PDFDropdown.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this dropdown's
     * option list. See [[PDFDropdown.enableMultiselect]] and
     * [[PDFDropdown.disableMultiselect]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFDropdown.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this dropdown's option
     * list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableMultiselect()
     * ```
     */ PDFDropdown.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this dropdown's
     * option list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableMultiselect()
     * ```
     */ PDFDropdown.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the selected option should be spell checked by PDF
     * readers. Spell checking will only be performed if this dropdown allows
     * editing (see [[PDFDropdown.isEditable]]). See
     * [[PDFDropdown.enableSpellChecking]] and
     * [[PDFDropdown.disableSpellChecking]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this dropdown can be spell checked.
     */ PDFDropdown.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $5e94843d22be1325$export$eb88827058402599).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the selected option of this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSpellChecking()
     * ```
     */ PDFDropdown.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the selected option of this
     * dropdown. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSpellChecking()
     * ```
     */ PDFDropdown.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this dropdown field (by clicking
     * outside of it - on another field, for example). See
     * [[PDFDropdown.enableSelectOnClick]] and
     * [[PDFDropdown.disableSelectOnClick]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFDropdown.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this dropdown field (by clicking
     * outside of it - on another field, for example). For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this dropdown
     * field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this dropdown on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('best.gundam')
     * dropdown.setOptions(['Exia', 'Dynames'])
     * dropdown.select('Exia')
     *
     * dropdown.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this dropdown field.
     * @param page The page to which this dropdown widget should be added.
     * @param options The options to be used when adding this dropdown widget.
     */ PDFDropdown.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $2qnUk.assertIs)(page, "page", [
            [
                (0, $65575dc41cd048b8$export$2e2bcd8739ae039),
                "PDFPage"
            ]
        ]);
        (0, $284a8acf05ac55e4$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!("textColor" in options)) options.textColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("backgroundColor" in options)) options.backgroundColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!("borderColor" in options)) options.borderColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("borderWidth" in options)) options.borderWidth = 1;
        // Create a widget for this dropdown
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this dropdown has been marked as dirty, or if any of
     * this dropdown's widgets do not have an appearance stream. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this dropdown needs an appearance update.
     */ PDFDropdown.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $29b9b1023bfccc2c$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the default appearance provider for dropdowns. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFDropdown.prototype.defaultUpdateAppearances = function(font) {
        (0, $2qnUk.assertIs)(font, "font", [
            [
                (0, $489bb5c728206ba0$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for dropdowns will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFDropdown.prototype.updateAppearances = function(font, provider) {
        (0, $2qnUk.assertIs)(font, "font", [
            [
                (0, $489bb5c728206ba0$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(provider, "provider", [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFDropdown.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $6754534916e67e80$export$90f1ca03d512ec5);
        var appearances = (0, $6754534916e67e80$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getDropdown]] method, which will create an
     * > instance of [[PDFDropdown]] for you.
     *
     * Create an instance of [[PDFDropdown]] from an existing acroComboBox and ref
     *
     * @param acroComboBox The underlying `PDFAcroComboBox` for this dropdown.
     * @param ref The unique reference for this dropdown.
     * @param doc The document to which this dropdown will belong.
     */ PDFDropdown.of = function(acroComboBox, ref, doc) {
        return new PDFDropdown(acroComboBox, ref, doc);
    };
    return PDFDropdown;
}((0, $284a8acf05ac55e4$export$2e2bcd8739ae039));
var $3819b41396e6f8d0$export$2e2bcd8739ae039 = $3819b41396e6f8d0$var$PDFDropdown;



var $59LZ8 = parcelRequire("59LZ8");







parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
/**
 * Represents an option list field of a [[PDFForm]].
 *
 * [[PDFOptionList]] fields are interactive lists of options. The purpose of an
 * option list is to enable users to select one or more options from a set of
 * possible options. Users are able to see the full set of options without
 * first having to click on the field (though scrolling may be necessary).
 * Clicking an option in the list will cause it to be selected and displayed
 * with a highlighted background. Some option lists allow users to select
 * more than one option (see [[PDFOptionList.isMultiselect]]).
 */ var $de44dfbc177fb215$var$PDFOptionList = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFOptionList, _super);
    function PDFOptionList(acroListBox, ref, doc) {
        var _this = _super.call(this, acroListBox, ref, doc) || this;
        (0, $2qnUk.assertIs)(acroListBox, "acroListBox", [
            [
                (0, $ab4454ef96cbfb06$export$2e2bcd8739ae039),
                "PDFAcroListBox"
            ]
        ]);
        _this.acroField = acroListBox;
        return _this;
    }
    /**
     * Get the list of available options for this option list. These options will
     * be displayed to users who view this option list in a PDF reader.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const options = optionList.getOptions()
     * console.log('Option List options:', options)
     * ```
     * @returns The options for this option list.
     */ PDFOptionList.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this option list. These are the values that
     * were selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const selections = optionList.getSelected()
     * console.log('Option List selections:', selections)
     * ```
     * @returns The selected options for this option list.
     */ PDFOptionList.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this option list. These are
     * the values that will be available for users to select when they view this
     * option list in a PDF reader. Note that preexisting options for this
     * option list will be removed. Only the values passed as `options` will be
     * available to select.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('planets.optionList')
     * optionList.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     *
     * This method will mark this option list as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the options this field contains inside the widgets of this text
     * field (with selected options highlighted).
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains any options
     * with characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFOptionList.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * @param options The options that should be available in this option list.
     */ PDFOptionList.prototype.setOptions = function(options) {
        (0, $2qnUk.assertIs)(options, "options", [
            Array
        ]);
        this.markAsDirty();
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this option list. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this option list
     * will still be available for users to select.
     * For example:
     * ```js
     * const optionList = form.getOptionList('rockets.optionList')
     * optionList.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options New options that should be available in this option list.
     */ PDFOptionList.prototype.addOptions = function(options) {
        (0, $2qnUk.assertIs)(options, "options", [
            "string",
            Array
        ]);
        this.markAsDirty();
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this option list. This operation is analogous
     * to a human user opening the option list in a PDF reader and clicking on one
     * or more values to select them. This method will update the underlying state
     * of the option list to indicate which values have been selected. PDF
     * libraries and readers will be able to extract these values from the saved
     * document and determine which values were selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('best.superheroes.optionList')
     * optionList.select(['One Punch Man', 'Iron Man'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFOptionList.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $2qnUk.assertIs)(options, "options", [
            "string",
            Array
        ]);
        (0, $2qnUk.assertIs)(merge, "merge", [
            "boolean"
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        (0, $2qnUk.assertIsSubset)(optionsArr, "option", validOptions);
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this option list. This operation is
     * equivalent to selecting an empty list. This method will update the
     * underlying state of the option list to indicate that no values have been
     * selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.clear()
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     */ PDFOptionList.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for the text in this field. There needs to be a
     * default appearance string (DA) set with a font value specified
     * for this to work. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4);
     * ```
     * @param fontSize The font size to set the font to.
     */ /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this option list. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4)
     * optionList.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFOptionList.prototype.setFontSize = function(fontSize) {
        (0, $2qnUk.assertPositive)(fontSize, "fontSize");
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if the options of this option list are always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the option list. See [[PDFOptionList.enableSorting]] and
     * [[PDFOptionList.disableSorting]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this option list is sorted.
     */ PDFOptionList.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$eb88827058402599).Sort);
    };
    /**
     * Always display the options of this option list in alphabetical order,
     * irrespective of the order in which the options were added to this option
     * list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSorting()
     * ```
     */ PDFOptionList.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the options of this option list in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to this option list. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSorting()
     * ```
     */ PDFOptionList.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this option list.
     * See [[PDFOptionList.enableMultiselect]] and
     * [[PDFOptionList.disableMultiselect]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFOptionList.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableMultiselect()
     * ```
     */ PDFOptionList.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableMultiselect()
     * ```
     */ PDFOptionList.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this option list field (by
     * clicking outside of it - on another field, for example). See
     * [[PDFOptionList.enableSelectOnClick]] and
     * [[PDFOptionList.disableSelectOnClick]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFOptionList.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this option list field (by
     * clicking outside of it - on another field, for example). For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this option
     * list field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this option list on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('best.gundams')
     * optionList.setOptions(['Exia', 'Dynames', 'Kyrios', 'Virtue'])
     * optionList.select(['Exia', 'Virtue'])
     *
     * optionList.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this option list field.
     * @param page The page to which this option list widget should be added.
     * @param options The options to be used when adding this option list widget.
     */ PDFOptionList.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $2qnUk.assertIs)(page, "page", [
            [
                (0, $65575dc41cd048b8$export$2e2bcd8739ae039),
                "PDFPage"
            ]
        ]);
        (0, $284a8acf05ac55e4$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!("textColor" in options)) options.textColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("backgroundColor" in options)) options.backgroundColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!("borderColor" in options)) options.borderColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("borderWidth" in options)) options.borderWidth = 1;
        // Create a widget for this option list
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this option list has been marked as dirty, or if any of
     * this option list's widgets do not have an appearance stream. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this option list needs an appearance update.
     */ PDFOptionList.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $29b9b1023bfccc2c$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the default appearance provider for option lists. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFOptionList.prototype.defaultUpdateAppearances = function(font) {
        (0, $2qnUk.assertIs)(font, "font", [
            [
                (0, $489bb5c728206ba0$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for option lists will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawOptionList(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFOptionList.prototype.updateAppearances = function(font, provider) {
        (0, $2qnUk.assertIs)(font, "font", [
            [
                (0, $489bb5c728206ba0$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(provider, "provider", [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFOptionList.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $6754534916e67e80$export$f9fab495286778d2);
        var appearances = (0, $6754534916e67e80$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create
     * > an instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroListBox and
     * ref
     *
     * @param acroComboBox The underlying `PDFAcroListBox` for this option list.
     * @param ref The unique reference for this option list.
     * @param doc The document to which this option list will belong.
     */ PDFOptionList.of = function(acroListBox, ref, doc) {
        return new PDFOptionList(acroListBox, ref, doc);
    };
    return PDFOptionList;
}((0, $284a8acf05ac55e4$export$2e2bcd8739ae039));
var $de44dfbc177fb215$export$2e2bcd8739ae039 = $de44dfbc177fb215$var$PDFOptionList;



var $59LZ8 = parcelRequire("59LZ8");






var $a7yPZ = parcelRequire("a7yPZ");
parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
/**
 * Represents a radio group field of a [[PDFForm]].
 *
 * [[PDFRadioGroup]] fields are collections of radio buttons. The purpose of a
 * radio group is to enable users to select one option from a set of mutually
 * exclusive choices. Each choice in a radio group is represented by a radio
 * button. Radio buttons each have two states: `on` and `off`. At most one
 * radio button in a group may be in the `on` state at any time. Users can
 * click on a radio button to select it (and thereby automatically deselect any
 * other radio button that might have already been selected). Some radio
 * groups allow users to toggle a selected radio button `off` by clicking on
 * it (see [[PDFRadioGroup.isOffToggleable]]).
 *
 * Note that some radio groups allow multiple radio buttons to be in the `on`
 * state at the same type **if** they represent the same underlying value (see
 * [[PDFRadioGroup.isMutuallyExclusive]]).
 */ var $bb5efe6a18f31904$var$PDFRadioGroup = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFRadioGroup, _super);
    function PDFRadioGroup(acroRadioButton, ref, doc) {
        var _this = _super.call(this, acroRadioButton, ref, doc) || this;
        (0, $2qnUk.assertIs)(acroRadioButton, "acroRadioButton", [
            [
                (0, $30f61fd4202a189a$export$2e2bcd8739ae039),
                "PDFAcroRadioButton"
            ]
        ]);
        _this.acroField = acroRadioButton;
        return _this;
    }
    /**
     * Get the list of available options for this radio group. Each option is
     * represented by a radio button. These radio buttons are displayed at
     * various locations in the document, potentially on different pages (though
     * typically they are stacked horizontally or vertically on the same page).
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const options = radioGroup.getOptions()
     * console.log('Radio Group options:', options)
     * ```
     * @returns The options for this radio group.
     */ PDFRadioGroup.prototype.getOptions = function() {
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var exportOptions = new Array(exportValues.length);
            for(var idx = 0, len = exportValues.length; idx < len; idx++)exportOptions[idx] = exportValues[idx].decodeText();
            return exportOptions;
        }
        var onValues = this.acroField.getOnValues();
        var onOptions = new Array(onValues.length);
        for(var idx = 0, len = onOptions.length; idx < len; idx++)onOptions[idx] = onValues[idx].decodeText();
        return onOptions;
    };
    /**
     * Get the selected option for this radio group. The selected option is
     * represented by the radio button in this group that is turned on. At most
     * one radio button in a group can be selected. If no buttons in this group
     * are selected, `undefined` is returned.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const selected = radioGroup.getSelected()
     * console.log('Selected radio button:', selected)
     * ```
     * @returns The selected option for this radio group.
     */ PDFRadioGroup.prototype.getSelected = function() {
        var value = this.acroField.getValue();
        if (value === (0, $a7yPZ.default).of("Off")) return undefined;
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var onValues = this.acroField.getOnValues();
            for(var idx = 0, len = onValues.length; idx < len; idx++){
                if (onValues[idx] === value) return exportValues[idx].decodeText();
            }
        }
        return value.decodeText();
    };
    // // TODO: Figure out why this seems to crash Acrobat. Maybe it's because we
    // //       aren't removing the widget reference from the page's Annots?
    // removeOption(option: string) {
    //   assertIs(option, 'option', ['string']);
    //   // TODO: Assert is valid `option`!
    //   const onValues = this.acroField.getOnValues();
    //   const exportValues = this.acroField.getExportValues();
    //   if (exportValues) {
    //     for (let idx = 0, len = exportValues.length; idx < len; idx++) {
    //       if (exportValues[idx].decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   } else {
    //     for (let idx = 0, len = onValues.length; idx < len; idx++) {
    //       const value = onValues[idx];
    //       if (value.decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   }
    // }
    /**
     * Select an option for this radio group. This operation is analogous to a
     * human user clicking one of the radio buttons in this group via a PDF
     * reader to toggle it on. This method will update the underlying state of
     * the radio group to indicate which option has been selected. PDF libraries
     * and readers will be able to extract this value from the saved document and
     * determine which option was selected.
     *
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('best.superhero.radioGroup')
     * radioGroup.select('One Punch Man')
     * ```
     *
     * This method will mark this radio group as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a dot inside the widget of this check box field
     * that represents the selected option.
     *
     * @param option The option to be selected.
     */ PDFRadioGroup.prototype.select = function(option) {
        (0, $2qnUk.assertIs)(option, "option", [
            "string"
        ]);
        var validOptions = this.getOptions();
        (0, $2qnUk.assertIsOneOf)(option, "option", validOptions);
        this.markAsDirty();
        var onValues = this.acroField.getOnValues();
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            for(var idx = 0, len = exportValues.length; idx < len; idx++)if (exportValues[idx].decodeText() === option) this.acroField.setValue(onValues[idx]);
        } else for(var idx = 0, len = onValues.length; idx < len; idx++){
            var value = onValues[idx];
            if (value.decodeText() === option) this.acroField.setValue(value);
        }
    };
    /**
     * Clear any selected option for this dropdown. This will result in all
     * radio buttons in this group being toggled off. This method will update
     * the underlying state of the dropdown to indicate that no radio buttons
     * have been selected.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.clear()
     * ```
     * This method will mark this radio group as dirty. See
     * [[PDFRadioGroup.select]] for more details about what this means.
     */ PDFRadioGroup.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $a7yPZ.default).of("Off"));
    };
    /**
     * Returns `true` if users can click on radio buttons in this group to toggle
     * them off. The alternative is that once a user clicks on a radio button
     * to select it, the only way to deselect it is by selecting on another radio
     * button in the group. See [[PDFRadioGroup.enableOffToggling]] and
     * [[PDFRadioGroup.disableOffToggling]]. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isOffToggleable()) console.log('Off toggling is enabled')
     * ```
     */ PDFRadioGroup.prototype.isOffToggleable = function() {
        return !this.acroField.hasFlag((0, $5e94843d22be1325$export$59f660e89ffb4f8a).NoToggleToOff);
    };
    /**
     * Allow users to click on selected radio buttons in this group to toggle
     * them off. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableOffToggling()
     * ```
     * > **NOTE:** This feature is documented in the PDF specification
     * > (Table 226). However, most PDF readers do not respect this option and
     * > prevent users from toggling radio buttons off even when it is enabled.
     * > At the time of this writing (9/6/2020) Mac's Preview software did
     * > respect the option. Adobe Acrobat, Foxit Reader, and Google Chrome did
     * > not.
     */ PDFRadioGroup.prototype.enableOffToggling = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$59f660e89ffb4f8a).NoToggleToOff, false);
    };
    /**
     * Prevent users from clicking on selected radio buttons in this group to
     * toggle them off. Clicking on a selected radio button will have no effect.
     * The only way to deselect a selected radio button is to click on a
     * different radio button in the group. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableOffToggling()
     * ```
     */ PDFRadioGroup.prototype.disableOffToggling = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$59f660e89ffb4f8a).NoToggleToOff, true);
    };
    /**
     * Returns `true` if the radio buttons in this group are mutually exclusive.
     * This means that when the user selects a radio button, only that specific
     * button will be turned on. Even if other radio buttons in the group
     * represent the same value, they will not be enabled. The alternative to
     * this is that clicking a radio button will select that button along with
     * any other radio buttons in the group that share the same value. See
     * [[PDFRadioGroup.enableMutualExclusion]] and
     * [[PDFRadioGroup.disableMutualExclusion]].
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isMutuallyExclusive()) console.log('Mutual exclusion is enabled')
     * ```
     */ PDFRadioGroup.prototype.isMutuallyExclusive = function() {
        return !this.acroField.hasFlag((0, $5e94843d22be1325$export$59f660e89ffb4f8a).RadiosInUnison);
    };
    /**
     * When the user clicks a radio button in this group it will be selected. In
     * addition, any other radio buttons in this group that share the same
     * underlying value will also be selected. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableMutualExclusion()
     * ```
     * Note that this option must be enabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.enableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$59f660e89ffb4f8a).RadiosInUnison, false);
    };
    /**
     * When the user clicks a radio button in this group only it will be selected.
     * No other radio buttons in the group will be selected, even if they share
     * the same underlying value. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableMutualExclusion()
     * ```
     * Note that this option must be disabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.disableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$59f660e89ffb4f8a).RadiosInUnison, true);
    };
    /**
     * Add a new radio button to this group on the specified page. For example:
     * ```js
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('best.gundam')
     *
     * const options = {
     *   x: 50,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * }
     *
     * radioGroup.addOptionToPage('Exia', page, { ...options, y: 50 })
     * radioGroup.addOptionToPage('Dynames', page, { ...options, y: 110 })
     * ```
     * This will create a new radio button widget for this radio group field.
     * @param option The option that the radio button widget represents.
     * @param page The page to which the radio button widget should be added.
     * @param options The options to be used when adding the radio button widget.
     */ PDFRadioGroup.prototype.addOptionToPage = function(option, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        (0, $2qnUk.assertIs)(option, "option", [
            "string"
        ]);
        (0, $2qnUk.assertIs)(page, "page", [
            [
                (0, $65575dc41cd048b8$export$2e2bcd8739ae039),
                "PDFPage"
            ]
        ]);
        (0, $284a8acf05ac55e4$export$55643210f1835a35)(options);
        // Create a widget for this radio button
        var widget = this.createWidget({
            x: (_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options === null || options === void 0 ? void 0 : options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options === null || options === void 0 ? void 0 : options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options === null || options === void 0 ? void 0 : options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: (_e = options === null || options === void 0 ? void 0 : options.textColor) !== null && _e !== void 0 ? _e : (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_f = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _f !== void 0 ? _f : (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(1, 1, 1),
            borderColor: (_g = options === null || options === void 0 ? void 0 : options.borderColor) !== null && _g !== void 0 ? _g : (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0),
            borderWidth: (_h = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _h !== void 0 ? _h : 1,
            rotate: (_j = options === null || options === void 0 ? void 0 : options.rotate) !== null && _j !== void 0 ? _j : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        var apStateValue = this.acroField.addWidgetWithOpt(widgetRef, (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(option), !this.isMutuallyExclusive());
        // Set appearance streams for widget
        widget.setAppearanceState((0, $a7yPZ.default).of("Off"));
        this.updateWidgetAppearance(widget, apStateValue);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this group's radio button widgets do not have an
     * appearance stream for their current state. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this radio group needs an appearance update.
     */ PDFRadioGroup.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the default appearance provider for radio groups. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.defaultUpdateAppearances()
     * ```
     */ PDFRadioGroup.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    // rg.updateAppearances((field: any, widget: any) => {
    //   assert(field === rg);
    //   assert(widget instanceof PDFWidgetAnnotation);
    //   return { on: [...rectangle, ...circle], off: [...rectangle, ...circle] };
    // });
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the given appearance provider. If no `provider` is passed, the
     * default appearance provider for radio groups will be used. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *     down: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFRadioGroup.prototype.updateAppearances = function(provider) {
        (0, $2qnUk.assertOrUndefined)(provider, "provider", [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = widget.getOnValue();
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
    };
    PDFRadioGroup.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $6754534916e67e80$export$6440094330a99ef8);
        var appearances = (0, $6754534916e67e80$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create an
     * > instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroRadioButton
     * and ref
     *
     * @param acroRadioButton The underlying `PDFAcroRadioButton` for this
     *                        radio group.
     * @param ref The unique reference for this radio group.
     * @param doc The document to which this radio group will belong.
     */ PDFRadioGroup.of = function(acroRadioButton, ref, doc) {
        return new PDFRadioGroup(acroRadioButton, ref, doc);
    };
    return PDFRadioGroup;
}((0, $284a8acf05ac55e4$export$2e2bcd8739ae039));
var $bb5efe6a18f31904$export$2e2bcd8739ae039 = $bb5efe6a18f31904$var$PDFRadioGroup;



var $59LZ8 = parcelRequire("59LZ8");


parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
/**
 * Represents a signature field of a [[PDFForm]].
 *
 * [[PDFSignature]] fields are digital signatures. `pdf-lib` does not
 * currently provide any specialized APIs for creating digital signatures or
 * reading the contents of existing digital signatures.
 */ var $594f83a589064e1a$var$PDFSignature = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFSignature, _super);
    function PDFSignature(acroSignature, ref, doc) {
        var _this = _super.call(this, acroSignature, ref, doc) || this;
        (0, $2qnUk.assertIs)(acroSignature, "acroSignature", [
            [
                (0, $7845f3837234047b$export$2e2bcd8739ae039),
                "PDFAcroSignature"
            ]
        ]);
        _this.acroField = acroSignature;
        return _this;
    }
    PDFSignature.prototype.needsAppearancesUpdate = function() {
        return false;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getSignature]] method, which will create an
     * > instance of [[PDFSignature]] for you.
     *
     * Create an instance of [[PDFSignature]] from an existing acroSignature and
     * ref
     *
     * @param acroSignature The underlying `PDFAcroSignature` for this signature.
     * @param ref The unique reference for this signature.
     * @param doc The document to which this signature will belong.
     */ PDFSignature.of = function(acroSignature, ref, doc) {
        return new PDFSignature(acroSignature, ref, doc);
    };
    return PDFSignature;
}((0, $284a8acf05ac55e4$export$2e2bcd8739ae039));
var $594f83a589064e1a$export$2e2bcd8739ae039 = $594f83a589064e1a$var$PDFSignature;



var $59LZ8 = parcelRequire("59LZ8");










parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
/**
 * Represents a text field of a [[PDFForm]].
 *
 * [[PDFTextField]] fields are boxes that display text entered by the user. The
 * purpose of a text field is to enable users to enter text or view text values
 * in the document prefilled by software. Users can click on a text field and
 * input text via their keyboard. Some text fields allow multiple lines of text
 * to be entered (see [[PDFTextField.isMultiline]]).
 */ var $4bc1f151a2e56f7f$var$PDFTextField = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFTextField, _super);
    function PDFTextField(acroText, ref, doc) {
        var _this = _super.call(this, acroText, ref, doc) || this;
        (0, $2qnUk.assertIs)(acroText, "acroText", [
            [
                (0, $d6a62c64e2a348f0$export$2e2bcd8739ae039),
                "PDFAcroText"
            ]
        ]);
        _this.acroField = acroText;
        return _this;
    }
    /**
     * Get the text that this field contains. This text is visible to users who
     * view this field in a PDF reader.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const text = textField.getText()
     * console.log('Text field contents:', text)
     * ```
     *
     * Note that if this text field contains no underlying value, `undefined`
     * will be returned. Text fields may also contain an underlying value that
     * is simply an empty string (`''`). This detail is largely irrelevant for
     * most applications. In general, you'll want to treat both cases the same
     * way and simply consider the text field to be empty. In either case, the
     * text field will appear empty to users when viewed in a PDF reader.
     *
     * An error will be thrown if this is a rich text field. `pdf-lib` does not
     * support reading rich text fields. Nor do most PDF readers and writers.
     * Rich text fields are based on XFA (XML Forms Architecture). Relatively few
     * PDFs use rich text fields or XFA. Unlike PDF itself, XFA is not an ISO
     * standard. XFA has been deprecated in PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     *
     * @returns The text contained in this text field.
     */ PDFTextField.prototype.getText = function() {
        var value = this.acroField.getValue();
        if (!value && this.isRichFormatted()) throw new (0, $ab1852e734a4db56$export$f2fed572e1ed57ab)(this.getName());
        return value === null || value === void 0 ? void 0 : value.decodeText();
    };
    /**
     * Set the text for this field. This operation is analogous to a human user
     * clicking on the text field in a PDF reader and typing in text via their
     * keyboard. This method will update the underlying state of the text field
     * to indicate what text has been set. PDF libraries and readers will be able
     * to extract these values from the saved document and determine what text
     * was set.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('best.superhero.text.field')
     * textField.setText('One Punch Man')
     * ```
     *
     * This method will mark this text field as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the text this field contains inside the widgets of this text
     * field.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains text outside
     * the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFTextField.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * If this is a rich text field, it will be converted to a standard text
     * field in order to set the text. `pdf-lib` does not support writing rich
     * text strings. Nor do most PDF readers and writers. See
     * [[PDFTextField.getText]] for more information about rich text fields and
     * their deprecation in PDF 2.0.
     *
     * @param text The text this field should contain.
     */ PDFTextField.prototype.setText = function(text) {
        (0, $2qnUk.assertOrUndefined)(text, "text", [
            "string"
        ]);
        var maxLength = this.getMaxLength();
        if (maxLength !== undefined && text && text.length > maxLength) throw new (0, $ab1852e734a4db56$export$1577e99040d42609)(text.length, maxLength, this.getName());
        this.markAsDirty();
        this.disableRichFormatting();
        if (text) this.acroField.setValue((0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(text));
        else this.acroField.removeValue();
    };
    /**
     * Get the alignment for this text field. This value represents the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const alignment = textField.getAlignment()
     * if (alignment === TextAlignment.Left) console.log('Text is left justified')
     * if (alignment === TextAlignment.Center) console.log('Text is centered')
     * if (alignment === TextAlignment.Right) console.log('Text is right justified')
     * ```
     * @returns The alignment of this text field.
     */ PDFTextField.prototype.getAlignment = function() {
        var quadding = this.acroField.getQuadding();
        // prettier-ignore
        return quadding === 0 ? (0, $7710effdbf78fe81$export$84b2d1b68830363f).Left : quadding === 1 ? (0, $7710effdbf78fe81$export$84b2d1b68830363f).Center : quadding === 2 ? (0, $7710effdbf78fe81$export$84b2d1b68830363f).Right : (0, $7710effdbf78fe81$export$84b2d1b68830363f).Left;
    };
    /**
     * Set the alignment for this text field. This will determine the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Text will be left justified when displayed
     * textField.setAlignment(TextAlignment.Left)
     *
     * // Text will be centered when displayed
     * textField.setAlignment(TextAlignment.Center)
     *
     * // Text will be right justified when displayed
     * textField.setAlignment(TextAlignment.Right)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param alignment The alignment for this text field.
     */ PDFTextField.prototype.setAlignment = function(alignment) {
        (0, $2qnUk.assertIsOneOf)(alignment, "alignment", (0, $7710effdbf78fe81$export$84b2d1b68830363f));
        this.markAsDirty();
        this.acroField.setQuadding(alignment);
    };
    /**
     * Get the maximum length of this field. This value represents the maximum
     * number of characters that can be typed into this field by the user. If
     * this field does not have a maximum length, `undefined` is returned.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const maxLength = textField.getMaxLength()
     * if (maxLength === undefined) console.log('No max length')
     * else console.log(`Max length is ${maxLength}`)
     * ```
     * @returns The maximum number of characters allowed in this field, or
     *          `undefined` if no limit exists.
     */ PDFTextField.prototype.getMaxLength = function() {
        return this.acroField.getMaxLength();
    };
    /**
     * Set the maximum length of this field. This limits the number of characters
     * that can be typed into this field by the user. This also limits the length
     * of the string that can be passed to [[PDFTextField.setText]]. This limit
     * can be removed by passing `undefined` as `maxLength`. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Allow between 0 and 5 characters to be entered
     * textField.setMaxLength(5)
     *
     * // Allow any number of characters to be entered
     * textField.setMaxLength(undefined)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param maxLength The maximum number of characters allowed in this field, or
     *                  `undefined` to remove the limit.
     */ PDFTextField.prototype.setMaxLength = function(maxLength) {
        (0, $2qnUk.assertRangeOrUndefined)(maxLength, "maxLength", 0, Number.MAX_SAFE_INTEGER);
        this.markAsDirty();
        if (maxLength === undefined) this.acroField.removeMaxLength();
        else {
            var text = this.getText();
            if (text && text.length > maxLength) throw new (0, $ab1852e734a4db56$export$6da6c372180e79b0)(text.length, maxLength, this.getName());
            this.acroField.setMaxLength(maxLength);
        }
    };
    /**
     * Remove the maximum length for this text field. This allows any number of
     * characters to be typed into this field by the user. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.removeMaxLength()
     * ```
     * Calling this method is equivalent to passing `undefined` to
     * [[PDFTextField.setMaxLength]].
     */ PDFTextField.prototype.removeMaxLength = function() {
        this.markAsDirty();
        this.acroField.removeMaxLength();
    };
    /**
     * Display an image inside the bounds of this text field's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const textField = form.getTextField('some.text.field')
     * textField.setImage(pngImage)
     * ```
     * This will update the appearances streams for each of this text field's widgets.
     * @param image The image that should be displayed.
     */ PDFTextField.prototype.setImage = function(image) {
        var fieldAlignment = this.getAlignment();
        // prettier-ignore
        var alignment = fieldAlignment === (0, $7710effdbf78fe81$export$84b2d1b68830363f).Center ? (0, $a851711d2fd1c050$export$8efa99ca8f041e7e).Center : fieldAlignment === (0, $7710effdbf78fe81$export$84b2d1b68830363f).Right ? (0, $a851711d2fd1c050$export$8efa99ca8f041e7e).Right : (0, $a851711d2fd1c050$export$8efa99ca8f041e7e).Left;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this text field. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.setFontSize(4)
     * textField.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFTextField.prototype.setFontSize = function(fontSize) {
        (0, $2qnUk.assertPositive)(fontSize, "fontSize");
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if each line of text is shown on a new line when this
     * field is displayed in a PDF reader. The alternative is that all lines of
     * text are merged onto a single line when displayed. See
     * [[PDFTextField.enableMultiline]] and [[PDFTextField.disableMultiline]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isMultiline()) console.log('Multiline is enabled')
     * ```
     * @returns Whether or not this is a multiline text field.
     */ PDFTextField.prototype.isMultiline = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$389fc7b97397dc8b).Multiline);
    };
    /**
     * Display each line of text on a new line when this field is displayed in a
     * PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).Multiline, true);
    };
    /**
     * Display each line of text on the same line when this field is displayed
     * in a PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).Multiline, false);
    };
    /**
     * Returns `true` if this is a password text field. This means that the field
     * is intended for storing a secure password. See
     * [[PDFTextField.enablePassword]] and [[PDFTextField.disablePassword]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isPassword()) console.log('Password is enabled')
     * ```
     * @returns Whether or not this is a password text field.
     */ PDFTextField.prototype.isPassword = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$389fc7b97397dc8b).Password);
    };
    /**
     * Indicate that this text field is intended for storing a secure password.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enablePassword()
     * ```
     * Values entered into password text fields should not be displayed on the
     * screen by PDF readers. Most PDF readers will display the value as
     * asterisks or bullets. PDF readers should never store values entered by the
     * user into password text fields. Similarly, applications should not
     * write data to a password text field.
     *
     * **Please note that this method does not cause entered values to be
     * encrypted or secured in any way! It simply sets a flag that PDF software
     * and readers can access to determine the _purpose_ of this field.**
     */ PDFTextField.prototype.enablePassword = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).Password, true);
    };
    /**
     * Indicate that this text field is **not** intended for storing a secure
     * password. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disablePassword()
     * ```
     */ PDFTextField.prototype.disablePassword = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).Password, false);
    };
    /**
     * Returns `true` if the contents of this text field represent a file path.
     * See [[PDFTextField.enableFileSelection]] and
     * [[PDFTextField.disableFileSelection]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isFileSelector()) console.log('Is a file selector')
     * ```
     * @returns Whether or not this field should contain file paths.
     */ PDFTextField.prototype.isFileSelector = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$389fc7b97397dc8b).FileSelect);
    };
    /**
     * Indicate that this text field is intended to store a file path. The
     * contents of the file stored at that path should be submitted as the value
     * of the field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableFileSelection()
     * ```
     */ PDFTextField.prototype.enableFileSelection = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).FileSelect, true);
    };
    /**
     * Indicate that this text field is **not** intended to store a file path.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableFileSelection()
     * ```
     */ PDFTextField.prototype.disableFileSelection = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).FileSelect, false);
    };
    /**
     * Returns `true` if the text entered in this field should be spell checked
     * by PDF readers. See [[PDFTextField.enableSpellChecking]] and
     * [[PDFTextField.disableSpellChecking]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this field should be spell checked.
     */ PDFTextField.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $5e94843d22be1325$export$389fc7b97397dc8b).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableSpellChecking()
     * ```
     */ PDFTextField.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableSpellChecking()
     * ```
     */ PDFTextField.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if PDF readers should allow the user to scroll the text
     * field when its contents do not fit within the field's view bounds. See
     * [[PDFTextField.enableScrolling]] and [[PDFTextField.disableScrolling]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isScrollable()) console.log('Scrolling is enabled')
     * ```
     * @returns Whether or not the field is scrollable in PDF readers.
     */ PDFTextField.prototype.isScrollable = function() {
        return !this.acroField.hasFlag((0, $5e94843d22be1325$export$389fc7b97397dc8b).DoNotScroll);
    };
    /**
     * Allow PDF readers to present a scroll bar to the user when the contents
     * of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableScrolling()
     * ```
     * A horizontal scroll bar should be shown for singleline fields. A vertical
     * scroll bar should be shown for multiline fields.
     */ PDFTextField.prototype.enableScrolling = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).DoNotScroll, false);
    };
    /**
     * Do not allow PDF readers to present a scroll bar to the user when the
     * contents of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableScrolling()
     * ```
     */ PDFTextField.prototype.disableScrolling = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).DoNotScroll, true);
    };
    /**
     * Returns `true` if this is a combed text field. This means that the field
     * is split into `n` equal size cells with one character in each (where `n`
     * is equal to the max length of the text field). The result is that all
     * characters in this field are displayed an equal distance apart from one
     * another. See [[PDFTextField.enableCombing]] and
     * [[PDFTextField.disableCombing]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isCombed()) console.log('Combing is enabled')
     * ```
     * Note that in order for a text field to be combed, the following must be
     * true (in addition to enabling combing):
     * * It must not be a multiline field (see [[PDFTextField.isMultiline]])
     * * It must not be a password field (see [[PDFTextField.isPassword]])
     * * It must not be a file selector field (see [[PDFTextField.isFileSelector]])
     * * It must have a max length defined (see [[PDFTextField.setMaxLength]])
     * @returns Whether or not this field is combed.
     */ PDFTextField.prototype.isCombed = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$389fc7b97397dc8b).Comb) && !this.isMultiline() && !this.isPassword() && !this.isFileSelector() && this.getMaxLength() !== undefined;
    };
    /**
     * Split this field into `n` equal size cells with one character in each
     * (where `n` is equal to the max length of the text field). This will cause
     * all characters in the field to be displayed an equal distance apart from
     * one another. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableCombing()
     * ```
     *
     * In addition to calling this method, text fields must have a max length
     * defined in order to be combed (see [[PDFTextField.setMaxLength]]).
     *
     * This method will also call the following three methods internally:
     * * [[PDFTextField.disableMultiline]]
     * * [[PDFTextField.disablePassword]]
     * * [[PDFTextField.disableFileSelection]]
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableCombing = function() {
        if (this.getMaxLength() === undefined) {
            var msg = "PDFTextFields must have a max length in order to be combed";
            console.warn(msg);
        }
        this.markAsDirty();
        this.disableMultiline();
        this.disablePassword();
        this.disableFileSelection();
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).Comb, true);
    };
    /**
     * Turn off combing for this text field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableCombing()
     * ```
     * See [[PDFTextField.isCombed]] and [[PDFTextField.enableCombing]] for more
     * information about what combing is.
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableCombing = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).Comb, false);
    };
    /**
     * Returns `true` if this text field contains rich text. See
     * [[PDFTextField.enableRichFormatting]] and
     * [[PDFTextField.disableRichFormatting]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isRichFormatted()) console.log('Rich formatting enabled')
     * ```
     * @returns Whether or not this field contains rich text.
     */ PDFTextField.prototype.isRichFormatted = function() {
        return this.acroField.hasFlag((0, $5e94843d22be1325$export$389fc7b97397dc8b).RichText);
    };
    /**
     * Indicate that this field contains XFA data - or rich text. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableRichFormatting()
     * ```
     * Note that `pdf-lib` does not support reading or writing rich text fields.
     * Nor do most PDF readers and writers. Rich text fields are based on XFA
     * (XML Forms Architecture). Relatively few PDFs use rich text fields or XFA.
     * Unlike PDF itself, XFA is not an ISO standard. XFA has been deprecated in
     * PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     */ PDFTextField.prototype.enableRichFormatting = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).RichText, true);
    };
    /**
     * Indicate that this is a standard text field that does not XFA data (rich
     * text). For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableRichFormatting()
     * ```
     */ PDFTextField.prototype.disableRichFormatting = function() {
        this.acroField.setFlagTo((0, $5e94843d22be1325$export$389fc7b97397dc8b).RichText, false);
    };
    /**
     * Show this text field on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('best.gundam')
     * textField.setText('Exia')
     *
     * textField.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this text field.
     * @param page The page to which this text field widget should be added.
     * @param options The options to be used when adding this text field widget.
     */ PDFTextField.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $2qnUk.assertIs)(page, "page", [
            [
                (0, $65575dc41cd048b8$export$2e2bcd8739ae039),
                "PDFPage"
            ]
        ]);
        (0, $284a8acf05ac55e4$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!("textColor" in options)) options.textColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("backgroundColor" in options)) options.backgroundColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!("borderColor" in options)) options.borderColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("borderWidth" in options)) options.borderWidth = 1;
        // Create a widget for this text field
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this text field has been marked as dirty, or if any of
     * this text field's widgets do not have an appearance stream. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this text field needs an appearance update.
     */ PDFTextField.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $29b9b1023bfccc2c$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the default appearance provider for text fields. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFTextField.prototype.defaultUpdateAppearances = function(font) {
        (0, $2qnUk.assertIs)(font, "font", [
            [
                (0, $489bb5c728206ba0$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for text fields will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFTextField.prototype.updateAppearances = function(font, provider) {
        (0, $2qnUk.assertIs)(font, "font", [
            [
                (0, $489bb5c728206ba0$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(provider, "provider", [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    PDFTextField.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $6754534916e67e80$export$42ba95e6b8df3d7);
        var appearances = (0, $6754534916e67e80$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getTextField]] method, which will create an
     * > instance of [[PDFTextField]] for you.
     *
     * Create an instance of [[PDFTextField]] from an existing acroText and ref
     *
     * @param acroText The underlying `PDFAcroText` for this text field.
     * @param ref The unique reference for this text field.
     * @param doc The document to which this text field will belong.
     */ PDFTextField.of = function(acroText, ref, doc) {
        return new PDFTextField(acroText, ref, doc);
    };
    return PDFTextField;
}((0, $284a8acf05ac55e4$export$2e2bcd8739ae039));
var $4bc1f151a2e56f7f$export$2e2bcd8739ae039 = $4bc1f151a2e56f7f$var$PDFTextField;




var $d094577b58833cd9$export$7dcb046109e65a3d;
(function(StandardFonts) {
    StandardFonts["Courier"] = "Courier";
    StandardFonts["CourierBold"] = "Courier-Bold";
    StandardFonts["CourierOblique"] = "Courier-Oblique";
    StandardFonts["CourierBoldOblique"] = "Courier-BoldOblique";
    StandardFonts["Helvetica"] = "Helvetica";
    StandardFonts["HelveticaBold"] = "Helvetica-Bold";
    StandardFonts["HelveticaOblique"] = "Helvetica-Oblique";
    StandardFonts["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    StandardFonts["TimesRoman"] = "Times-Roman";
    StandardFonts["TimesRomanBold"] = "Times-Bold";
    StandardFonts["TimesRomanItalic"] = "Times-Italic";
    StandardFonts["TimesRomanBoldItalic"] = "Times-BoldItalic";
    StandardFonts["Symbol"] = "Symbol";
    StandardFonts["ZapfDingbats"] = "ZapfDingbats";
})($d094577b58833cd9$export$7dcb046109e65a3d || ($d094577b58833cd9$export$7dcb046109e65a3d = {}));





var $a7yPZ = parcelRequire("a7yPZ");
parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
var $6E4Ej = parcelRequire("6E4Ej");
/**
 * Represents the interactive form of a [[PDFDocument]].
 *
 * Interactive forms (sometimes called _AcroForms_) are collections of fields
 * designed to gather information from a user. A PDF document may contains any
 * number of fields that appear on various pages, all of which make up a single,
 * global interactive form spanning the entire document. This means that
 * instances of [[PDFDocument]] shall contain at most one [[PDFForm]].
 *
 * The fields of an interactive form are represented by [[PDFField]] instances.
 */ var $fe733bdf43a1ae2b$var$PDFForm = /** @class */ function() {
    function PDFForm(acroForm, doc) {
        var _this = this;
        this.embedDefaultFont = function() {
            return _this.doc.embedStandardFont((0, $d094577b58833cd9$export$7dcb046109e65a3d).Helvetica);
        };
        (0, $2qnUk.assertIs)(acroForm, "acroForm", [
            [
                (0, $8202ad3a40180808$export$2e2bcd8739ae039),
                "PDFAcroForm"
            ]
        ]);
        (0, $2qnUk.assertIs)(doc, "doc", [
            [
                (0, $c32e913e0d181c9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        this.acroForm = acroForm;
        this.doc = doc;
        this.dirtyFields = new Set();
        this.defaultFontCache = (0, $6E4Ej.default).populatedBy(this.embedDefaultFont);
    }
    /**
     * Returns `true` if this [[PDFForm]] has XFA data. Most PDFs with form
     * fields do not use XFA as it is not widely supported by PDF readers.
     *
     * > `pdf-lib` does not support creation, modification, or reading of XFA
     * > fields.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * if (form.hasXFA()) console.log('PDF has XFA data')
     * ```
     * @returns Whether or not this form has XFA data.
     */ PDFForm.prototype.hasXFA = function() {
        return this.acroForm.dict.has((0, $a7yPZ.default).of("XFA"));
    };
    /**
     * Disconnect the XFA data from this [[PDFForm]] (if any exists). This will
     * force readers to fallback to standard fields if the [[PDFDocument]]
     * contains any. For example:
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * form.deleteXFA()
     * ```
     */ PDFForm.prototype.deleteXFA = function() {
        this.acroForm.dict.delete((0, $a7yPZ.default).of("XFA"));
    };
    /**
     * Get all fields contained in this [[PDFForm]]. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns An array of all fields in this form.
     */ PDFForm.prototype.getFields = function() {
        var allFields = this.acroForm.getAllFields();
        var fields = [];
        for(var idx = 0, len = allFields.length; idx < len; idx++){
            var _a = allFields[idx], acroField = _a[0], ref = _a[1];
            var field = $fe733bdf43a1ae2b$var$convertToPDFField(acroField, ref, this.doc);
            if (field) fields.push(field);
        }
        return fields;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getFieldMaybe('Page1.Foo.Bar[0]')
     * if (field) console.log('Field exists!')
     * ```
     * @param name A fully qualified field name.
     * @returns The field with the specified name, if one exists.
     */ PDFForm.prototype.getFieldMaybe = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.getName() === name) return field;
        }
        return undefined;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('Page1.Foo.Bar[0]')
     * ```
     * If no field exists with the provided name, an error will be thrown.
     * @param name A fully qualified field name.
     * @returns The field with the specified name.
     */ PDFForm.prototype.getField = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getFieldMaybe(name);
        if (field) return field;
        throw new (0, $ab1852e734a4db56$export$5bc08baa4a027cbd)(name);
    };
    /**
     * Get the button field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const button = form.getButton('Page1.Foo.Button[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a button.
     * @param name A fully qualified button name.
     * @returns The button with the specified name.
     */ PDFForm.prototype.getButton = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $4e6da06f9bc76d09$export$2e2bcd8739ae039)) return field;
        throw new (0, $ab1852e734a4db56$export$8909da6c566ff652)(name, (0, $4e6da06f9bc76d09$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const checkBox = form.getCheckBox('Page1.Foo.CheckBox[0]')
     * checkBox.check()
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a check box.
     * @param name A fully qualified check box name.
     * @returns The check box with the specified name.
     */ PDFForm.prototype.getCheckBox = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $3297675f35560625$export$2e2bcd8739ae039)) return field;
        throw new (0, $ab1852e734a4db56$export$8909da6c566ff652)(name, (0, $3297675f35560625$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const dropdown = form.getDropdown('Page1.Foo.Dropdown[0]')
     * const options = dropdown.getOptions()
     * dropdown.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a dropdown.
     * @param name A fully qualified dropdown name.
     * @returns The dropdown with the specified name.
     */ PDFForm.prototype.getDropdown = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $3819b41396e6f8d0$export$2e2bcd8739ae039)) return field;
        throw new (0, $ab1852e734a4db56$export$8909da6c566ff652)(name, (0, $3819b41396e6f8d0$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const optionList = form.getOptionList('Page1.Foo.OptionList[0]')
     * const options = optionList.getOptions()
     * optionList.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not an option list.
     * @param name A fully qualified option list name.
     * @returns The option list with the specified name.
     */ PDFForm.prototype.getOptionList = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $de44dfbc177fb215$export$2e2bcd8739ae039)) return field;
        throw new (0, $ab1852e734a4db56$export$8909da6c566ff652)(name, (0, $de44dfbc177fb215$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const radioGroup = form.getRadioGroup('Page1.Foo.RadioGroup[0]')
     * const options = radioGroup.getOptions()
     * radioGroup.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a radio group.
     * @param name A fully qualified radio group name.
     * @returns The radio group with the specified name.
     */ PDFForm.prototype.getRadioGroup = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $bb5efe6a18f31904$export$2e2bcd8739ae039)) return field;
        throw new (0, $ab1852e734a4db56$export$8909da6c566ff652)(name, (0, $bb5efe6a18f31904$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the signature field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const signature = form.getSignature('Page1.Foo.Signature[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a signature.
     * @param name A fully qualified signature name.
     * @returns The signature with the specified name.
     */ PDFForm.prototype.getSignature = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $594f83a589064e1a$export$2e2bcd8739ae039)) return field;
        throw new (0, $ab1852e734a4db56$export$8909da6c566ff652)(name, (0, $594f83a589064e1a$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const textField = form.getTextField('Page1.Foo.TextField[0]')
     * textField.setText('Are you designed to act or to be acted upon?')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a text field.
     * @param name A fully qualified text field name.
     * @returns The text field with the specified name.
     */ PDFForm.prototype.getTextField = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $4bc1f151a2e56f7f$export$2e2bcd8739ae039)) return field;
        throw new (0, $ab1852e734a4db56$export$8909da6c566ff652)(name, (0, $4bc1f151a2e56f7f$export$2e2bcd8739ae039), field);
    };
    /**
     * Create a new button field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('cool.new.button')
     *
     * button.addToPage('Do Stuff', font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new button.
     * @returns The new button field.
     */ PDFForm.prototype.createButton = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var nameParts = $fe733bdf43a1ae2b$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var button = (0, $cc8e0c206e3a3c82$export$2e2bcd8739ae039).create(this.doc.context);
        button.setPartialName(nameParts.terminal);
        $fe733bdf43a1ae2b$var$addFieldToParent(parent, [
            button,
            button.ref
        ], nameParts.terminal);
        return (0, $4e6da06f9bc76d09$export$2e2bcd8739ae039).of(button, button.ref, this.doc);
    };
    /**
     * Create a new check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('cool.new.checkBox')
     *
     * checkBox.addToPage(page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new check box.
     * @returns The new check box field.
     */ PDFForm.prototype.createCheckBox = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var nameParts = $fe733bdf43a1ae2b$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var checkBox = (0, $4760db20b4fb4187$export$2e2bcd8739ae039).create(this.doc.context);
        checkBox.setPartialName(nameParts.terminal);
        $fe733bdf43a1ae2b$var$addFieldToParent(parent, [
            checkBox,
            checkBox.ref
        ], nameParts.terminal);
        return (0, $3297675f35560625$export$2e2bcd8739ae039).of(checkBox, checkBox.ref, this.doc);
    };
    /**
     * Create a new dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('cool.new.dropdown')
     *
     * dropdown.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new dropdown.
     * @returns The new dropdown field.
     */ PDFForm.prototype.createDropdown = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var nameParts = $fe733bdf43a1ae2b$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var comboBox = (0, $4d501aeb209a28de$export$2e2bcd8739ae039).create(this.doc.context);
        comboBox.setPartialName(nameParts.terminal);
        $fe733bdf43a1ae2b$var$addFieldToParent(parent, [
            comboBox,
            comboBox.ref
        ], nameParts.terminal);
        return (0, $3819b41396e6f8d0$export$2e2bcd8739ae039).of(comboBox, comboBox.ref, this.doc);
    };
    /**
     * Create a new option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('cool.new.optionList')
     *
     * optionList.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new option list.
     * @returns The new option list field.
     */ PDFForm.prototype.createOptionList = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var nameParts = $fe733bdf43a1ae2b$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var listBox = (0, $ab4454ef96cbfb06$export$2e2bcd8739ae039).create(this.doc.context);
        listBox.setPartialName(nameParts.terminal);
        $fe733bdf43a1ae2b$var$addFieldToParent(parent, [
            listBox,
            listBox.ref
        ], nameParts.terminal);
        return (0, $de44dfbc177fb215$export$2e2bcd8739ae039).of(listBox, listBox.ref, this.doc);
    };
    /**
     * Create a new radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('cool.new.radioGroup')
     *
     * radioGroup.addOptionToPage('is-dog', page, { y: 0 })
     * radioGroup.addOptionToPage('is-cat', page, { y: 75 })
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createRadioGroup = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var nameParts = $fe733bdf43a1ae2b$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var radioButton = (0, $30f61fd4202a189a$export$2e2bcd8739ae039).create(this.doc.context);
        radioButton.setPartialName(nameParts.terminal);
        $fe733bdf43a1ae2b$var$addFieldToParent(parent, [
            radioButton,
            radioButton.ref
        ], nameParts.terminal);
        return (0, $bb5efe6a18f31904$export$2e2bcd8739ae039).of(radioButton, radioButton.ref, this.doc);
    };
    /**
     * Create a new text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('cool.new.textField')
     *
     * textField.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createTextField = function(name) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        var nameParts = $fe733bdf43a1ae2b$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var text = (0, $d6a62c64e2a348f0$export$2e2bcd8739ae039).create(this.doc.context);
        text.setPartialName(nameParts.terminal);
        $fe733bdf43a1ae2b$var$addFieldToParent(parent, [
            text,
            text.ref
        ], nameParts.terminal);
        return (0, $4bc1f151a2e56f7f$export$2e2bcd8739ae039).of(text, text.ref, this.doc);
    };
    /**
     * Flatten all fields in this [[PDFForm]].
     *
     * Flattening a form field will take the current appearance for each of that
     * field's widgets and make them part of their page's content stream. All form
     * fields and annotations associated are then removed. Note that once a form
     * has been flattened its fields can no longer be accessed or edited.
     *
     * This operation is often used after filling form fields to ensure a
     * consistent appearance across different PDF readers and/or printers.
     * Another common use case is to copy a template document with form fields
     * into another document. In this scenario you would load the template
     * document, fill its fields, flatten it, and then copy its pages into the
     * recipient document - the filled fields will be copied over.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * form.flatten();
     * ```
     */ PDFForm.prototype.flatten = function(options) {
        if (options === void 0) options = {
            updateFieldAppearances: true
        };
        if (options.updateFieldAppearances) this.updateFieldAppearances();
        var fields = this.getFields();
        for(var i = 0, lenFields = fields.length; i < lenFields; i++){
            var field = fields[i];
            var widgets = field.acroField.getWidgets();
            for(var j = 0, lenWidgets = widgets.length; j < lenWidgets; j++){
                var widget = widgets[j];
                var page = this.findWidgetPage(widget);
                var widgetRef = this.findWidgetAppearanceRef(field, widget);
                var xObjectKey = page.node.newXObject("FlatWidget", widgetRef);
                var rectangle = widget.getRectangle();
                var operators = (0, $59LZ8.__spreadArrays)([
                    (0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(),
                    (0, $7b945c9f8f83b90a$export$d73ee8ef04f5226a)(rectangle.x, rectangle.y)
                ], (0, $59179fabd6039f42$export$5dd9a0a87f38a2a6)((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, rectangle), {
                    rotation: 0
                })), [
                    (0, $7b945c9f8f83b90a$export$382c18f8bccd9e2b)(xObjectKey),
                    (0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)()
                ]).filter(Boolean);
                page.pushOperators.apply(page, operators);
            }
            this.removeField(field);
        }
    };
    /**
     * Remove a field from this [[PDFForm]].
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * const ageField = form.getFields().find(x => x.getName() === 'Age');
     * form.removeField(ageField);
     * ```
     */ PDFForm.prototype.removeField = function(field) {
        var widgets = field.acroField.getWidgets();
        var pages = new Set();
        for(var i = 0, len = widgets.length; i < len; i++){
            var widget = widgets[i];
            var widgetRef = this.findWidgetAppearanceRef(field, widget);
            var page = this.findWidgetPage(widget);
            pages.add(page);
            page.node.removeAnnot(widgetRef);
        }
        pages.forEach(function(page) {
            return page.node.removeAnnot(field.ref);
        });
        this.acroForm.removeField(field.acroField);
        var fieldKids = field.acroField.normalizedEntries().Kids;
        var kidsCount = fieldKids.size();
        for(var childIndex = 0; childIndex < kidsCount; childIndex++){
            var child = fieldKids.get(childIndex);
            if (child instanceof (0, $06a507a20ec07388$export$2e2bcd8739ae039)) this.doc.context.delete(child);
        }
        this.doc.context.delete(field.ref);
    };
    /**
     * Update the appearance streams for all widgets of all fields in this
     * [[PDFForm]]. Appearance streams will only be created for a widget if it
     * does not have any existing appearance streams, or the field's value has
     * changed (e.g. by calling [[PDFTextField.setText]] or
     * [[PDFDropdown.select]]).
     *
     * For example:
     * ```js
     * const courier = await pdfDoc.embedFont(StandardFonts.Courier)
     * const form = pdfDoc.getForm()
     * form.updateFieldAppearances(courier)
     * ```
     *
     * **IMPORTANT:** The default value for the `font` parameter is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if any fields contain text with
     * characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing that as the `font`
     * parameter allows you to generate appearance streams with non WinAnsi
     * characters (assuming your custom font supports them).
     *
     * > **NOTE:** The [[PDFDocument.save]] method will call this method to
     * > update appearances automatically if a form was accessed via the
     * > [[PDFDocument.getForm]] method prior to saving.
     *
     * @param font Optionally, the font to use when creating new appearances.
     */ PDFForm.prototype.updateFieldAppearances = function(font) {
        (0, $2qnUk.assertOrUndefined)(font, "font", [
            [
                (0, $489bb5c728206ba0$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        font = font !== null && font !== void 0 ? font : this.getDefaultFont();
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.needsAppearancesUpdate()) field.defaultUpdateAppearances(font);
        }
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsDirty(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsDirty = function(fieldRef) {
        (0, $2qnUk.assertOrUndefined)(fieldRef, "fieldRef", [
            [
                (0, $06a507a20ec07388$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        this.dirtyFields.add(fieldRef);
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to not be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsClean(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsClean = function(fieldRef) {
        (0, $2qnUk.assertOrUndefined)(fieldRef, "fieldRef", [
            [
                (0, $06a507a20ec07388$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        this.dirtyFields.delete(fieldRef);
    };
    /**
     * Returns `true` is the specified field has been marked as dirty.
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * if (form.fieldIsDirty(field.ref)) console.log('Field is dirty')
     * ```
     * @param fieldRef The reference to the field that should be checked.
     * @returns Whether or not the specified field is dirty.
     */ PDFForm.prototype.fieldIsDirty = function(fieldRef) {
        (0, $2qnUk.assertOrUndefined)(fieldRef, "fieldRef", [
            [
                (0, $06a507a20ec07388$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        return this.dirtyFields.has(fieldRef);
    };
    PDFForm.prototype.getDefaultFont = function() {
        return this.defaultFontCache.access();
    };
    PDFForm.prototype.findWidgetPage = function(widget) {
        var pageRef = widget.P();
        var page = this.doc.getPages().find(function(x) {
            return x.ref === pageRef;
        });
        if (page === undefined) {
            var widgetRef = this.doc.context.getObjectRef(widget.dict);
            if (widgetRef === undefined) throw new Error("Could not find PDFRef for PDFObject");
            page = this.doc.findPageForAnnotationRef(widgetRef);
            if (page === undefined) throw new Error("Could not find page for PDFRef " + widgetRef);
        }
        return page;
    };
    PDFForm.prototype.findWidgetAppearanceRef = function(field, widget) {
        var _a;
        var refOrDict = widget.getNormalAppearance();
        if (refOrDict instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039) && (field instanceof (0, $3297675f35560625$export$2e2bcd8739ae039) || field instanceof (0, $bb5efe6a18f31904$export$2e2bcd8739ae039))) {
            var value = field.acroField.getValue();
            var ref = (_a = refOrDict.get(value)) !== null && _a !== void 0 ? _a : refOrDict.get((0, $a7yPZ.default).of("Off"));
            if (ref instanceof (0, $06a507a20ec07388$export$2e2bcd8739ae039)) refOrDict = ref;
        }
        if (!(refOrDict instanceof (0, $06a507a20ec07388$export$2e2bcd8739ae039))) {
            var name_1 = field.getName();
            throw new Error("Failed to extract appearance ref for: " + name_1);
        }
        return refOrDict;
    };
    PDFForm.prototype.findOrCreateNonTerminals = function(partialNames) {
        var nonTerminal = [
            this.acroForm
        ];
        for(var idx = 0, len = partialNames.length; idx < len; idx++){
            var namePart = partialNames[idx];
            if (!namePart) throw new (0, $ab1852e734a4db56$export$83c39fdacfe38500)(namePart);
            var parent_1 = nonTerminal[0], parentRef = nonTerminal[1];
            var res = this.findNonTerminal(namePart, parent_1);
            if (res) nonTerminal = res;
            else {
                var node = (0, $7b9e672813fd3df8$export$2e2bcd8739ae039).create(this.doc.context);
                node.setPartialName(namePart);
                node.setParent(parentRef);
                var nodeRef = this.doc.context.register(node.dict);
                parent_1.addField(nodeRef);
                nonTerminal = [
                    node,
                    nodeRef
                ];
            }
        }
        return nonTerminal;
    };
    PDFForm.prototype.findNonTerminal = function(partialName, parent) {
        var fields = parent instanceof (0, $8202ad3a40180808$export$2e2bcd8739ae039) ? this.acroForm.getFields() : (0, $7fb7c3f967d1e895$export$34b4fb8893136c4c)(parent.Kids());
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var _a = fields[idx], field = _a[0], ref = _a[1];
            if (field.getPartialName() === partialName) {
                if (field instanceof (0, $7b9e672813fd3df8$export$2e2bcd8739ae039)) return [
                    field,
                    ref
                ];
                throw new (0, $ab1852e734a4db56$export$c428cfe4dc6c68df)(partialName);
            }
        }
        return undefined;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.getForm]] method, which will create an
     * > instance of [[PDFForm]] for you.
     *
     * Create an instance of [[PDFForm]] from an existing acroForm and embedder
     *
     * @param acroForm The underlying `PDFAcroForm` for this form.
     * @param doc The document to which the form will belong.
     */ PDFForm.of = function(acroForm, doc) {
        return new PDFForm(acroForm, doc);
    };
    return PDFForm;
}();
var $fe733bdf43a1ae2b$export$2e2bcd8739ae039 = $fe733bdf43a1ae2b$var$PDFForm;
var $fe733bdf43a1ae2b$var$convertToPDFField = function(field, ref, doc) {
    if (field instanceof (0, $cc8e0c206e3a3c82$export$2e2bcd8739ae039)) return (0, $4e6da06f9bc76d09$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $4760db20b4fb4187$export$2e2bcd8739ae039)) return (0, $3297675f35560625$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $4d501aeb209a28de$export$2e2bcd8739ae039)) return (0, $3819b41396e6f8d0$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $ab4454ef96cbfb06$export$2e2bcd8739ae039)) return (0, $de44dfbc177fb215$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $d6a62c64e2a348f0$export$2e2bcd8739ae039)) return (0, $4bc1f151a2e56f7f$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $30f61fd4202a189a$export$2e2bcd8739ae039)) return (0, $bb5efe6a18f31904$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $7845f3837234047b$export$2e2bcd8739ae039)) return (0, $594f83a589064e1a$export$2e2bcd8739ae039).of(field, ref, doc);
    return undefined;
};
var $fe733bdf43a1ae2b$var$splitFieldName = function(fullyQualifiedName) {
    if (fullyQualifiedName.length === 0) throw new Error("PDF field names must not be empty strings");
    var parts = fullyQualifiedName.split(".");
    for(var idx = 0, len = parts.length; idx < len; idx++){
        if (parts[idx] === "") throw new Error('Periods in PDF field names must be separated by at least one character: "' + fullyQualifiedName + '"');
    }
    if (parts.length === 1) return {
        nonTerminal: [],
        terminal: parts[0]
    };
    return {
        nonTerminal: parts.slice(0, parts.length - 1),
        terminal: parts[parts.length - 1]
    };
};
var $fe733bdf43a1ae2b$var$addFieldToParent = function(_a, _b, partialName) {
    var parent = _a[0], parentRef = _a[1];
    var field = _b[0], fieldRef = _b[1];
    var entries = parent.normalizedEntries();
    var fields = (0, $7fb7c3f967d1e895$export$34b4fb8893136c4c)("Kids" in entries ? entries.Kids : entries.Fields);
    for(var idx = 0, len = fields.length; idx < len; idx++){
        if (fields[idx][0].getPartialName() === partialName) throw new (0, $ab1852e734a4db56$export$c428cfe4dc6c68df)(partialName);
    }
    parent.addField(fieldRef);
    field.setParent(parentRef);
};


var $9ed9386fb79996c0$export$b4a05ae367f5515c = {
    "4A0": [
        4767.87,
        6740.79
    ],
    "2A0": [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    Executive: [
        521.86,
        756.0
    ],
    Folio: [
        612.0,
        936.0
    ],
    Legal: [
        612.0,
        1008.0
    ],
    Letter: [
        612.0,
        792.0
    ],
    Tabloid: [
        792.0,
        1224.0
    ]
};



var $1cWQu = parcelRequire("1cWQu");
var $a7yPZ = parcelRequire("a7yPZ");
var $30ac22a0995bedca$export$ba19d141a3749548;
(function(ParseSpeeds) {
    ParseSpeeds[ParseSpeeds["Fastest"] = Infinity] = "Fastest";
    ParseSpeeds[ParseSpeeds["Fast"] = 1500] = "Fast";
    ParseSpeeds[ParseSpeeds["Medium"] = 500] = "Medium";
    ParseSpeeds[ParseSpeeds["Slow"] = 100] = "Slow";
})($30ac22a0995bedca$export$ba19d141a3749548 || ($30ac22a0995bedca$export$ba19d141a3749548 = {}));


parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
var $6E4Ej = parcelRequire("6E4Ej");
var $i8eKs = parcelRequire("i8eKs");
var $9GHB7 = parcelRequire("9GHB7");
var $4PFuJ = parcelRequire("4PFuJ");


var $59LZ8 = parcelRequire("59LZ8");

var $7Igbp = parcelRequire("7Igbp");
var $a7yPZ = parcelRequire("a7yPZ");
/**
 * Represents a file that has been embedded in a [[PDFDocument]].
 */ var $e8440867e1e7cb7a$var$PDFEmbeddedFile = /** @class */ function() {
    function PDFEmbeddedFile(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable files get embedded.
     *
     * Embed this embeddable file in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedFile.prototype.embed = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var ref, Names, EmbeddedFiles, EFNames, AF;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _a.sent();
                        if (!this.doc.catalog.has((0, $a7yPZ.default).of("Names"))) this.doc.catalog.set((0, $a7yPZ.default).of("Names"), this.doc.context.obj({}));
                        Names = this.doc.catalog.lookup((0, $a7yPZ.default).of("Names"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
                        if (!Names.has((0, $a7yPZ.default).of("EmbeddedFiles"))) Names.set((0, $a7yPZ.default).of("EmbeddedFiles"), this.doc.context.obj({}));
                        EmbeddedFiles = Names.lookup((0, $a7yPZ.default).of("EmbeddedFiles"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
                        if (!EmbeddedFiles.has((0, $a7yPZ.default).of("Names"))) EmbeddedFiles.set((0, $a7yPZ.default).of("Names"), this.doc.context.obj([]));
                        EFNames = EmbeddedFiles.lookup((0, $a7yPZ.default).of("Names"), (0, $7Igbp.default));
                        EFNames.push((0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(this.embedder.fileName));
                        EFNames.push(ref);
                        /**
                         * The AF-Tag is needed to achieve PDF-A3 compliance for embedded files
                         *
                         * The following document outlines the uses cases of the associated files (AF) tag.
                         * See:
                         * https://www.pdfa.org/wp-content/uploads/2018/10/PDF20_AN002-AF.pdf
                         */ if (!this.doc.catalog.has((0, $a7yPZ.default).of("AF"))) this.doc.catalog.set((0, $a7yPZ.default).of("AF"), this.doc.context.obj([]));
                        AF = this.doc.catalog.lookup((0, $a7yPZ.default).of("AF"), (0, $7Igbp.default));
                        AF.push(ref);
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.attach]] method, which will create
     * instances of [[PDFEmbeddedFile]] for you.
     *
     * Create an instance of [[PDFEmbeddedFile]] from an existing ref and embedder
     *
     * @param ref The unique reference for this file.
     * @param doc The document to which the file will belong.
     * @param embedder The embedder that will be used to embed the file.
     */ PDFEmbeddedFile.of = function(ref, doc, embedder) {
        return new PDFEmbeddedFile(ref, doc, embedder);
    };
    return PDFEmbeddedFile;
}();
var $e8440867e1e7cb7a$export$2e2bcd8739ae039 = $e8440867e1e7cb7a$var$PDFEmbeddedFile;



var $59LZ8 = parcelRequire("59LZ8");

var $7Igbp = parcelRequire("7Igbp");
var $a7yPZ = parcelRequire("a7yPZ");
/**
 * Represents JavaScript that has been embedded in a [[PDFDocument]].
 */ var $93ab3acdf6ee5e99$var$PDFJavaScript = /** @class */ function() {
    function PDFJavaScript(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all JavaScripts get embedded.
     *
     * Embed this JavaScript in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFJavaScript.prototype.embed = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var _a, catalog, context, ref, Names, Javascript, JSNames;
            return (0, $59LZ8.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.doc, catalog = _a.catalog, context = _a.context;
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _b.sent();
                        if (!catalog.has((0, $a7yPZ.default).of("Names"))) catalog.set((0, $a7yPZ.default).of("Names"), context.obj({}));
                        Names = catalog.lookup((0, $a7yPZ.default).of("Names"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
                        if (!Names.has((0, $a7yPZ.default).of("JavaScript"))) Names.set((0, $a7yPZ.default).of("JavaScript"), context.obj({}));
                        Javascript = Names.lookup((0, $a7yPZ.default).of("JavaScript"), (0, $f437c135fa674ebe$export$2e2bcd8739ae039));
                        if (!Javascript.has((0, $a7yPZ.default).of("Names"))) Javascript.set((0, $a7yPZ.default).of("Names"), context.obj([]));
                        JSNames = Javascript.lookup((0, $a7yPZ.default).of("Names"), (0, $7Igbp.default));
                        JSNames.push((0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(this.embedder.scriptName));
                        JSNames.push(ref);
                        this.alreadyEmbedded = true;
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addJavaScript]] method, which will
     * create instances of [[PDFJavaScript]] for you.
     *
     * Create an instance of [[PDFJavaScript]] from an existing ref and script
     *
     * @param ref The unique reference for this script.
     * @param doc The document to which the script will belong.
     * @param embedder The embedder that will be used to embed the script.
     */ PDFJavaScript.of = function(ref, doc, embedder) {
        return new PDFJavaScript(ref, doc, embedder);
    };
    return PDFJavaScript;
}();
var $93ab3acdf6ee5e99$export$2e2bcd8739ae039 = $93ab3acdf6ee5e99$var$PDFJavaScript;



var $59LZ8 = parcelRequire("59LZ8");

var $635e2b685fa1b568$var$JavaScriptEmbedder = /** @class */ function() {
    function JavaScriptEmbedder(script, scriptName) {
        this.script = script;
        this.scriptName = scriptName;
    }
    JavaScriptEmbedder.for = function(script, scriptName) {
        return new JavaScriptEmbedder(script, scriptName);
    };
    JavaScriptEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var jsActionDict;
            return (0, $59LZ8.__generator)(this, function(_a) {
                jsActionDict = context.obj({
                    Type: "Action",
                    S: "JavaScript",
                    JS: (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(this.script)
                });
                if (ref) {
                    context.assign(ref, jsActionDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(jsActionDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JavaScriptEmbedder;
}();
var $635e2b685fa1b568$export$2e2bcd8739ae039 = $635e2b685fa1b568$var$JavaScriptEmbedder;


/**
 * Represents a PDF document.
 */ var $c32e913e0d181c9e$var$PDFDocument = /** @class */ function() {
    function PDFDocument(context, ignoreEncryption, updateMetadata) {
        var _this = this;
        /** The default word breaks used in PDFPage.drawText */ this.defaultWordBreaks = [
            " "
        ];
        this.computePages = function() {
            var pages = [];
            _this.catalog.Pages().traverse(function(node, ref) {
                if (node instanceof (0, $b808f27f9a7c9955$export$2e2bcd8739ae039)) {
                    var page = _this.pageMap.get(node);
                    if (!page) {
                        page = (0, $65575dc41cd048b8$export$2e2bcd8739ae039).of(node, ref, _this);
                        _this.pageMap.set(node, page);
                    }
                    pages.push(page);
                }
            });
            return pages;
        };
        this.getOrCreateForm = function() {
            var acroForm = _this.catalog.getOrCreateAcroForm();
            return (0, $fe733bdf43a1ae2b$export$2e2bcd8739ae039).of(acroForm, _this);
        };
        (0, $2qnUk.assertIs)(context, "context", [
            [
                (0, $e9a9ba426f46b6eb$export$2e2bcd8739ae039),
                "PDFContext"
            ]
        ]);
        (0, $2qnUk.assertIs)(ignoreEncryption, "ignoreEncryption", [
            "boolean"
        ]);
        this.context = context;
        this.catalog = context.lookup(context.trailerInfo.Root);
        this.isEncrypted = !!context.lookup(context.trailerInfo.Encrypt);
        this.pageCache = (0, $6E4Ej.default).populatedBy(this.computePages);
        this.pageMap = new Map();
        this.formCache = (0, $6E4Ej.default).populatedBy(this.getOrCreateForm);
        this.fonts = [];
        this.images = [];
        this.embeddedPages = [];
        this.embeddedFiles = [];
        this.javaScripts = [];
        if (!ignoreEncryption && this.isEncrypted) throw new (0, $ab1852e734a4db56$export$20fcceeca2b098d2)();
        if (updateMetadata) this.updateInfoDict();
    }
    /**
     * Load an existing [[PDFDocument]]. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                               |
     * | ------------- | ------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PDF |
     * | `Uint8Array`  | The raw bytes of a PDF                                 |
     * | `ArrayBuffer` | The raw bytes of a PDF                                 |
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * // pdf=string
     * const base64 =
     *  'JVBERi0xLjcKJYGBgYEKCjUgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbm' +
     *  'd0aCAxMDQKPj4Kc3RyZWFtCniccwrhMlAAwaJ0Ln2P1Jyy1JLM5ERdc0MjCwUjE4WQNC4Q' +
     *  '6cNlCFZkqGCqYGSqEJLLZWNuYGZiZmbkYuZsZmlmZGRgZmluDCQNzc3NTM2NzdzMXMxMjQ' +
     *  'ztFEKyuEK0uFxDuAAOERdVCmVuZHN0cmVhbQplbmRvYmoKCjYgMCBvYmoKPDwKL0ZpbHRl' +
     *  'ciAvRmxhdGVEZWNvZGUKL1R5cGUgL09ialN0bQovTiA0Ci9GaXJzdCAyMAovTGVuZ3RoID' +
     *  'IxNQo+PgpzdHJlYW0KeJxVj9GqwjAMhu/zFHkBzTo3nCCCiiKIHPEICuJF3cKoSCu2E8/b' +
     *  '20wPIr1p8v9/8kVhgilmGfawX2CGaVrgcAi0/bsy0lrX7IGWpvJ4iJYEN3gEmrrGBlQwGs' +
     *  'HHO9VBX1wNrxAqMX87RBD5xpJuddqwd82tjAHxzV1U5LPgy52DKXWnr1Lheg+j/c/pzGVr' +
     *  'iqV0VlwZPXGPCJjElw/ybkwUmeoWgxesDXGhHJC/D/iikp1Av80ptKU0FdBEe25pPihAM1' +
     *  'u6ytgaaWfs2Hrz35CJT1+EWmAKZW5kc3RyZWFtCmVuZG9iagoKNyAwIG9iago8PAovU2l6' +
     *  'ZSA4Ci9Sb290IDIgMCBSCi9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9UeXBlIC9YUmVmCi9MZW' +
     *  '5ndGggMzgKL1cgWyAxIDIgMiBdCi9JbmRleCBbIDAgOCBdCj4+CnN0cmVhbQp4nBXEwREA' +
     *  'EBAEsCwz3vrvRmOOyyOoGhZdutHN2MT55fIAVocD+AplbmRzdHJlYW0KZW5kb2JqCgpzdG' +
     *  'FydHhyZWYKNTEwCiUlRU9G'
     *
     * const dataUri = 'data:application/pdf;base64,' + base64
     *
     * const pdfDoc1 = await PDFDocument.load(base64)
     * const pdfDoc2 = await PDFDocument.load(dataUri)
     *
     * // pdf=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('with_update_sections.pdf')
     * const pdfDoc3 = await PDFDocument.load(uint8Array)
     *
     * // pdf=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/with_update_sections.pdf'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const pdfDoc4 = await PDFDocument.load(arrayBuffer)
     *
     * ```
     *
     * @param pdf The input data containing a PDF document.
     * @param options The options to be used when loading the document.
     * @returns Resolves with a document loaded from the input.
     */ PDFDocument.load = function(pdf, options) {
        if (options === void 0) options = {};
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var _a, ignoreEncryption, _b, parseSpeed, _c, throwOnInvalidObject, _d, updateMetadata, _e, capNumbers, bytes, context;
            return (0, $59LZ8.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        _a = options.ignoreEncryption, ignoreEncryption = _a === void 0 ? false : _a, _b = options.parseSpeed, parseSpeed = _b === void 0 ? (0, $30ac22a0995bedca$export$ba19d141a3749548).Slow : _b, _c = options.throwOnInvalidObject, throwOnInvalidObject = _c === void 0 ? false : _c, _d = options.updateMetadata, updateMetadata = _d === void 0 ? true : _d, _e = options.capNumbers, capNumbers = _e === void 0 ? false : _e;
                        (0, $2qnUk.assertIs)(pdf, "pdf", [
                            "string",
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $2qnUk.assertIs)(ignoreEncryption, "ignoreEncryption", [
                            "boolean"
                        ]);
                        (0, $2qnUk.assertIs)(parseSpeed, "parseSpeed", [
                            "number"
                        ]);
                        (0, $2qnUk.assertIs)(throwOnInvalidObject, "throwOnInvalidObject", [
                            "boolean"
                        ]);
                        bytes = (0, $i8eKs.toUint8Array)(pdf);
                        return [
                            4 /*yield*/ ,
                            (0, $04db4ec857fd3d28$export$2e2bcd8739ae039).forBytesWithOptions(bytes, parseSpeed, throwOnInvalidObject, capNumbers).parseDocument()
                        ];
                    case 1:
                        context = _f.sent();
                        return [
                            2 /*return*/ ,
                            new PDFDocument(context, ignoreEncryption, updateMetadata)
                        ];
                }
            });
        });
    };
    /**
     * Create a new [[PDFDocument]].
     * @returns Resolves with the newly created document.
     */ PDFDocument.create = function(options) {
        if (options === void 0) options = {};
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var _a, updateMetadata, context, pageTree, pageTreeRef, catalog;
            return (0, $59LZ8.__generator)(this, function(_b) {
                _a = options.updateMetadata, updateMetadata = _a === void 0 ? true : _a;
                context = (0, $e9a9ba426f46b6eb$export$2e2bcd8739ae039).create();
                pageTree = (0, $10777101caa9695d$export$2e2bcd8739ae039).withContext(context);
                pageTreeRef = context.register(pageTree);
                catalog = (0, $b7fffe878ca6f446$export$2e2bcd8739ae039).withContextAndPages(context, pageTreeRef);
                context.trailerInfo.Root = context.register(catalog);
                return [
                    2 /*return*/ ,
                    new PDFDocument(context, false, updateMetadata)
                ];
            });
        });
    };
    /**
     * Register a fontkit instance. This must be done before custom fonts can
     * be embedded. See [here](https://github.com/Hopding/pdf-lib/tree/master#fontkit-installation)
     * for instructions on how to install and register a fontkit instance.
     *
     * > You do **not** need to call this method to embed standard fonts.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     * import fontkit from '@pdf-lib/fontkit'
     *
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.registerFontkit(fontkit)
     * ```
     *
     * @param fontkit The fontkit instance to be registered.
     */ PDFDocument.prototype.registerFontkit = function(fontkit) {
        this.fontkit = fontkit;
    };
    /**
     * Get the [[PDFForm]] containing all interactive fields for this document.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns The form for this document.
     */ PDFDocument.prototype.getForm = function() {
        var form = this.formCache.access();
        if (form.hasXFA()) {
            console.warn("Removing XFA form data as pdf-lib does not support reading or writing XFA");
            form.deleteXFA();
        }
        return form;
    };
    /**
     * Get this document's title metadata. The title appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const title = pdfDoc.getTitle()
     * ```
     * @returns A string containing the title of this document, if it has one.
     */ PDFDocument.prototype.getTitle = function() {
        var title = this.getInfoDict().lookup((0, $a7yPZ.default).Title);
        if (!title) return undefined;
        $c32e913e0d181c9e$var$assertIsLiteralOrHexString(title);
        return title.decodeText();
    };
    /**
     * Get this document's author metadata. The author appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const author = pdfDoc.getAuthor()
     * ```
     * @returns A string containing the author of this document, if it has one.
     */ PDFDocument.prototype.getAuthor = function() {
        var author = this.getInfoDict().lookup((0, $a7yPZ.default).Author);
        if (!author) return undefined;
        $c32e913e0d181c9e$var$assertIsLiteralOrHexString(author);
        return author.decodeText();
    };
    /**
     * Get this document's subject metadata. The subject appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const subject = pdfDoc.getSubject()
     * ```
     * @returns A string containing the subject of this document, if it has one.
     */ PDFDocument.prototype.getSubject = function() {
        var subject = this.getInfoDict().lookup((0, $a7yPZ.default).Subject);
        if (!subject) return undefined;
        $c32e913e0d181c9e$var$assertIsLiteralOrHexString(subject);
        return subject.decodeText();
    };
    /**
     * Get this document's keywords metadata. The keywords appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const keywords = pdfDoc.getKeywords()
     * ```
     * @returns A string containing the keywords of this document, if it has any.
     */ PDFDocument.prototype.getKeywords = function() {
        var keywords = this.getInfoDict().lookup((0, $a7yPZ.default).Keywords);
        if (!keywords) return undefined;
        $c32e913e0d181c9e$var$assertIsLiteralOrHexString(keywords);
        return keywords.decodeText();
    };
    /**
     * Get this document's creator metadata. The creator appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creator = pdfDoc.getCreator()
     * ```
     * @returns A string containing the creator of this document, if it has one.
     */ PDFDocument.prototype.getCreator = function() {
        var creator = this.getInfoDict().lookup((0, $a7yPZ.default).Creator);
        if (!creator) return undefined;
        $c32e913e0d181c9e$var$assertIsLiteralOrHexString(creator);
        return creator.decodeText();
    };
    /**
     * Get this document's producer metadata. The producer appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const producer = pdfDoc.getProducer()
     * ```
     * @returns A string containing the producer of this document, if it has one.
     */ PDFDocument.prototype.getProducer = function() {
        var producer = this.getInfoDict().lookup((0, $a7yPZ.default).Producer);
        if (!producer) return undefined;
        $c32e913e0d181c9e$var$assertIsLiteralOrHexString(producer);
        return producer.decodeText();
    };
    /**
     * Get this document's creation date metadata. The creation date appears in
     * the "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creationDate = pdfDoc.getCreationDate()
     * ```
     * @returns A Date containing the creation date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getCreationDate = function() {
        var creationDate = this.getInfoDict().lookup((0, $a7yPZ.default).CreationDate);
        if (!creationDate) return undefined;
        $c32e913e0d181c9e$var$assertIsLiteralOrHexString(creationDate);
        return creationDate.decodeDate();
    };
    /**
     * Get this document's modification date metadata. The modification date
     * appears in the "Document Properties" section of most PDF readers.
     * For example:
     * ```js
     * const modification = pdfDoc.getModificationDate()
     * ```
     * @returns A Date containing the modification date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getModificationDate = function() {
        var modificationDate = this.getInfoDict().lookup((0, $a7yPZ.default).ModDate);
        if (!modificationDate) return undefined;
        $c32e913e0d181c9e$var$assertIsLiteralOrHexString(modificationDate);
        return modificationDate.decodeDate();
    };
    /**
     * Set this document's title metadata. The title will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳')
     * ```
     *
     * To display the title in the window's title bar, set the
     * `showInWindowTitleBar` option to `true` (works for _most_ PDF readers).
     * For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳', { showInWindowTitleBar: true })
     * ```
     *
     * @param title The title of this document.
     * @param options The options to be used when setting the title.
     */ PDFDocument.prototype.setTitle = function(title, options) {
        (0, $2qnUk.assertIs)(title, "title", [
            "string"
        ]);
        var key = (0, $a7yPZ.default).of("Title");
        this.getInfoDict().set(key, (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(title));
        // Indicate that readers should display the title rather than the filename
        if (options === null || options === void 0 ? void 0 : options.showInWindowTitleBar) {
            var prefs = this.catalog.getOrCreateViewerPreferences();
            prefs.setDisplayDocTitle(true);
        }
    };
    /**
     * Set this document's author metadata. The author will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setAuthor('Humpty Dumpty')
     * ```
     * @param author The author of this document.
     */ PDFDocument.prototype.setAuthor = function(author) {
        (0, $2qnUk.assertIs)(author, "author", [
            "string"
        ]);
        var key = (0, $a7yPZ.default).of("Author");
        this.getInfoDict().set(key, (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(author));
    };
    /**
     * Set this document's subject metadata. The subject will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setSubject('📘 An Epic Tale of Woe 📖')
     * ```
     * @param subject The subject of this document.
     */ PDFDocument.prototype.setSubject = function(subject) {
        (0, $2qnUk.assertIs)(subject, "author", [
            "string"
        ]);
        var key = (0, $a7yPZ.default).of("Subject");
        this.getInfoDict().set(key, (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(subject));
    };
    /**
     * Set this document's keyword metadata. These keywords will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setKeywords(['eggs', 'wall', 'fall', 'king', 'horses', 'men'])
     * ```
     * @param keywords An array of keywords associated with this document.
     */ PDFDocument.prototype.setKeywords = function(keywords) {
        (0, $2qnUk.assertIs)(keywords, "keywords", [
            Array
        ]);
        var key = (0, $a7yPZ.default).of("Keywords");
        this.getInfoDict().set(key, (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(keywords.join(" ")));
    };
    /**
     * Set this document's creator metadata. The creator will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreator('PDF App 9000 🤖')
     * ```
     * @param creator The creator of this document.
     */ PDFDocument.prototype.setCreator = function(creator) {
        (0, $2qnUk.assertIs)(creator, "creator", [
            "string"
        ]);
        var key = (0, $a7yPZ.default).of("Creator");
        this.getInfoDict().set(key, (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(creator));
    };
    /**
     * Set this document's producer metadata. The producer will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setProducer('PDF App 9000 🤖')
     * ```
     * @param producer The producer of this document.
     */ PDFDocument.prototype.setProducer = function(producer) {
        (0, $2qnUk.assertIs)(producer, "creator", [
            "string"
        ]);
        var key = (0, $a7yPZ.default).of("Producer");
        this.getInfoDict().set(key, (0, $97a582c32ae6773b$export$2e2bcd8739ae039).fromText(producer));
    };
    /**
     * Set this document's language metadata. The language will appear in the
     * "Document Properties" section of some PDF readers. For example:
     * ```js
     * pdfDoc.setLanguage('en-us')
     * ```
     *
     * @param language An RFC 3066 _Language-Tag_ denoting the language of this
     *                 document, or an empty string if the language is unknown.
     */ PDFDocument.prototype.setLanguage = function(language) {
        (0, $2qnUk.assertIs)(language, "language", [
            "string"
        ]);
        var key = (0, $a7yPZ.default).of("Lang");
        this.catalog.set(key, (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039).of(language));
    };
    /**
     * Set this document's creation date metadata. The creation date will appear
     * in the "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreationDate(new Date())
     * ```
     * @param creationDate The date this document was created.
     */ PDFDocument.prototype.setCreationDate = function(creationDate) {
        (0, $2qnUk.assertIs)(creationDate, "creationDate", [
            [
                Date,
                "Date"
            ]
        ]);
        var key = (0, $a7yPZ.default).of("CreationDate");
        this.getInfoDict().set(key, (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039).fromDate(creationDate));
    };
    /**
     * Set this document's modification date metadata. The modification date will
     * appear in the "Document Properties" section of most PDF readers. For
     * example:
     * ```js
     * pdfDoc.setModificationDate(new Date())
     * ```
     * @param modificationDate The date this document was last modified.
     */ PDFDocument.prototype.setModificationDate = function(modificationDate) {
        (0, $2qnUk.assertIs)(modificationDate, "modificationDate", [
            [
                Date,
                "Date"
            ]
        ]);
        var key = (0, $a7yPZ.default).of("ModDate");
        this.getInfoDict().set(key, (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039).fromDate(modificationDate));
    };
    /**
     * Get the number of pages contained in this document. For example:
     * ```js
     * const totalPages = pdfDoc.getPageCount()
     * ```
     * @returns The number of pages in this document.
     */ PDFDocument.prototype.getPageCount = function() {
        if (this.pageCount === undefined) this.pageCount = this.getPages().length;
        return this.pageCount;
    };
    /**
     * Get an array of all the pages contained in this document. The pages are
     * stored in the array in the same order that they are rendered in the
     * document. For example:
     * ```js
     * const pages = pdfDoc.getPages()
     * pages[0]   // The first page of the document
     * pages[2]   // The third page of the document
     * pages[197] // The 198th page of the document
     * ```
     * @returns An array of all the pages contained in this document.
     */ PDFDocument.prototype.getPages = function() {
        return this.pageCache.access();
    };
    /**
     * Get the page rendered at a particular `index` of the document. For example:
     * ```js
     * pdfDoc.getPage(0)   // The first page of the document
     * pdfDoc.getPage(2)   // The third page of the document
     * pdfDoc.getPage(197) // The 198th page of the document
     * ```
     * @returns The [[PDFPage]] rendered at the given `index` of the document.
     */ PDFDocument.prototype.getPage = function(index) {
        var pages = this.getPages();
        (0, $2qnUk.assertRange)(index, "index", 0, pages.length - 1);
        return pages[index];
    };
    /**
     * Get an array of indices for all the pages contained in this document. The
     * array will contain a range of integers from
     * `0..pdfDoc.getPageCount() - 1`. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     *
     * const indices = pdfDoc.getPageIndices()
     * indices // => [0, 1, 2]
     * ```
     * @returns An array of indices for all pages contained in this document.
     */ PDFDocument.prototype.getPageIndices = function() {
        return (0, $i8eKs.range)(0, this.getPageCount());
    };
    /**
     * Remove the page at a given index from this document. For example:
     * ```js
     * pdfDoc.removePage(0)   // Remove the first page of the document
     * pdfDoc.removePage(2)   // Remove the third page of the document
     * pdfDoc.removePage(197) // Remove the 198th page of the document
     * ```
     * Once a page has been removed, it will no longer be rendered at that index
     * in the document.
     * @param index The index of the page to be removed.
     */ PDFDocument.prototype.removePage = function(index) {
        var pageCount = this.getPageCount();
        if (this.pageCount === 0) throw new (0, $ab1852e734a4db56$export$cdca06c5927ddc2d)();
        (0, $2qnUk.assertRange)(index, "index", 0, pageCount - 1);
        this.catalog.removeLeafNode(index);
        this.pageCount = pageCount - 1;
    };
    /**
     * Add a page to the end of this document. This method accepts three
     * different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                            |
     * | ------------------ | ----------------------------------------------------------------------------------- |
     * | `undefined`        | Create a new page and add it to the end of this document                            |
     * | `[number, number]` | Create a new page with the given dimensions and add it to the end of this document  |
     * | `PDFPage`          | Add the existing page to the end of this document                                   |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.addPage()
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.addPage(PageSizes.A7)
     * const newPage2 = pdfDoc.addPage(PageSizes.Letter)
     * const newPage3 = pdfDoc.addPage([500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.addPage(existingPage)
     * ```
     *
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.addPage = function(page) {
        (0, $2qnUk.assertIs)(page, "page", [
            "undefined",
            [
                (0, $65575dc41cd048b8$export$2e2bcd8739ae039),
                "PDFPage"
            ],
            Array
        ]);
        return this.insertPage(this.getPageCount(), page);
    };
    /**
     * Insert a page at a given index within this document. This method accepts
     * three different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                       |
     * | ------------------ | ------------------------------------------------------------------------------ |
     * | `undefined`        | Create a new page and insert it into this document                             |
     * | `[number, number]` | Create a new page with the given dimensions and insert it into this document   |
     * | `PDFPage`          | Insert the existing page into this document                                    |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.insertPage(2)
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.insertPage(2, PageSizes.A7)
     * const newPage2 = pdfDoc.insertPage(0, PageSizes.Letter)
     * const newPage3 = pdfDoc.insertPage(198, [500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.insertPage(0, existingPage)
     * ```
     *
     * @param index The index at which the page should be inserted (zero-based).
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.insertPage = function(index, page) {
        var pageCount = this.getPageCount();
        (0, $2qnUk.assertRange)(index, "index", 0, pageCount);
        (0, $2qnUk.assertIs)(page, "page", [
            "undefined",
            [
                (0, $65575dc41cd048b8$export$2e2bcd8739ae039),
                "PDFPage"
            ],
            Array
        ]);
        if (!page || Array.isArray(page)) {
            var dims = Array.isArray(page) ? page : (0, $9ed9386fb79996c0$export$b4a05ae367f5515c).A4;
            page = (0, $65575dc41cd048b8$export$2e2bcd8739ae039).create(this);
            page.setSize.apply(page, dims);
        } else if (page.doc !== this) throw new (0, $ab1852e734a4db56$export$9564a4d28d94eae2)();
        var parentRef = this.catalog.insertLeafNode(page.ref, index);
        page.node.setParent(parentRef);
        this.pageMap.set(page.node, page);
        this.pageCache.invalidate();
        this.pageCount = pageCount + 1;
        return page;
    };
    /**
     * Copy pages from a source document into this document. Allows pages to be
     * copied between different [[PDFDocument]] instances. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * const srcDoc = await PDFDocument.load(...)
     *
     * const copiedPages = await pdfDoc.copyPages(srcDoc, [0, 3, 89])
     * const [firstPage, fourthPage, ninetiethPage] = copiedPages;
     *
     * pdfDoc.addPage(fourthPage)
     * pdfDoc.insertPage(0, ninetiethPage)
     * pdfDoc.addPage(firstPage)
     * ```
     * @param srcDoc The document from which pages should be copied.
     * @param indices The indices of the pages that should be copied.
     * @returns Resolves with an array of pages copied into this document.
     */ PDFDocument.prototype.copyPages = function(srcDoc, indices) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var copier, srcPages, copiedPages, idx, len, srcPage, copiedPage, ref;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $2qnUk.assertIs)(srcDoc, "srcDoc", [
                            [
                                PDFDocument,
                                "PDFDocument"
                            ]
                        ]);
                        (0, $2qnUk.assertIs)(indices, "indices", [
                            Array
                        ]);
                        return [
                            4 /*yield*/ ,
                            srcDoc.flush()
                        ];
                    case 1:
                        _a.sent();
                        copier = (0, $fc9573798ab90b32$export$2e2bcd8739ae039).for(srcDoc.context, this.context);
                        srcPages = srcDoc.getPages();
                        copiedPages = new Array(indices.length);
                        for(idx = 0, len = indices.length; idx < len; idx++){
                            srcPage = srcPages[indices[idx]];
                            copiedPage = copier.copy(srcPage.node);
                            ref = this.context.register(copiedPage);
                            copiedPages[idx] = (0, $65575dc41cd048b8$export$2e2bcd8739ae039).of(copiedPage, ref, this);
                        }
                        return [
                            2 /*return*/ ,
                            copiedPages
                        ];
                }
            });
        });
    };
    /**
     * Get a copy of this document.
     *
     * For example:
     * ```js
     * const srcDoc = await PDFDocument.load(...)
     * const pdfDoc = await srcDoc.copy()
     * ```
     *
     * > **NOTE:**  This method won't copy all information over to the new
     * > document (acroforms, outlines, etc...).
     *
     * @returns Resolves with a copy this document.
     */ PDFDocument.prototype.copy = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var pdfCopy, contentPages, idx, len;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.create()
                        ];
                    case 1:
                        pdfCopy = _a.sent();
                        return [
                            4 /*yield*/ ,
                            pdfCopy.copyPages(this, this.getPageIndices())
                        ];
                    case 2:
                        contentPages = _a.sent();
                        for(idx = 0, len = contentPages.length; idx < len; idx++)pdfCopy.addPage(contentPages[idx]);
                        if (this.getAuthor() !== undefined) pdfCopy.setAuthor(this.getAuthor());
                        if (this.getCreationDate() !== undefined) pdfCopy.setCreationDate(this.getCreationDate());
                        if (this.getCreator() !== undefined) pdfCopy.setCreator(this.getCreator());
                        if (this.getModificationDate() !== undefined) pdfCopy.setModificationDate(this.getModificationDate());
                        if (this.getProducer() !== undefined) pdfCopy.setProducer(this.getProducer());
                        if (this.getSubject() !== undefined) pdfCopy.setSubject(this.getSubject());
                        if (this.getTitle() !== undefined) pdfCopy.setTitle(this.getTitle());
                        pdfCopy.defaultWordBreaks = this.defaultWordBreaks;
                        return [
                            2 /*return*/ ,
                            pdfCopy
                        ];
                }
            });
        });
    };
    /**
     * Add JavaScript to this document. The supplied `script` is executed when the
     * document is opened. The `script` can be used to perform some operation
     * when the document is opened (e.g. logging to the console), or it can be
     * used to define a function that can be referenced later in a JavaScript
     * action. For example:
     * ```js
     * // Show "Hello World!" in the console when the PDF is opened
     * pdfDoc.addJavaScript(
     *   'main',
     *   'console.show(); console.println("Hello World!");'
     * );
     *
     * // Define a function named "foo" that can be called in JavaScript Actions
     * pdfDoc.addJavaScript(
     *   'foo',
     *   'function foo() { return "foo"; }'
     * );
     * ```
     * See the [JavaScript for Acrobat API Reference](https://www.adobe.com/content/dam/acom/en/devnet/acrobat/pdfs/js_api_reference.pdf)
     * for details.
     * @param name The name of the script. Must be unique per document.
     * @param script The JavaScript to execute.
     */ PDFDocument.prototype.addJavaScript = function(name, script) {
        (0, $2qnUk.assertIs)(name, "name", [
            "string"
        ]);
        (0, $2qnUk.assertIs)(script, "script", [
            "string"
        ]);
        var embedder = (0, $635e2b685fa1b568$export$2e2bcd8739ae039).for(script, name);
        var ref = this.context.nextRef();
        var javaScript = (0, $93ab3acdf6ee5e99$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.javaScripts.push(javaScript);
    };
    /**
     * Add an attachment to this document. Attachments are visible in the
     * "Attachments" panel of Adobe Acrobat and some other PDF readers. Any
     * type of file can be added as an attachment. This includes, but is not
     * limited to, `.png`, `.jpg`, `.pdf`, `.csv`, `.docx`, and `.xlsx` files.
     *
     * The input data can be provided in multiple formats:
     *
     * | Type          | Contents                                                       |
     * | ------------- | -------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing an attachment |
     * | `Uint8Array`  | The raw bytes of an attachment                                 |
     * | `ArrayBuffer` | The raw bytes of an attachment                                 |
     *
     * For example:
     * ```js
     * // attachment=string
     * await pdfDoc.attach('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * await pdfDoc.attach('data:image/jpeg;base64,/9j/4AAQ...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * await pdfDoc.attach(uint8Array, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * await pdfDoc.attach(arrayBuffer, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * ```
     *
     * @param attachment The input data containing the file to be attached.
     * @param name The name of the file to be attached.
     * @returns Resolves when the attachment is complete.
     */ PDFDocument.prototype.attach = function(attachment, name, options) {
        if (options === void 0) options = {};
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, embeddedFile;
            return (0, $59LZ8.__generator)(this, function(_a) {
                (0, $2qnUk.assertIs)(attachment, "attachment", [
                    "string",
                    Uint8Array,
                    ArrayBuffer
                ]);
                (0, $2qnUk.assertIs)(name, "name", [
                    "string"
                ]);
                (0, $2qnUk.assertOrUndefined)(options.mimeType, "mimeType", [
                    "string"
                ]);
                (0, $2qnUk.assertOrUndefined)(options.description, "description", [
                    "string"
                ]);
                (0, $2qnUk.assertOrUndefined)(options.creationDate, "options.creationDate", [
                    Date
                ]);
                (0, $2qnUk.assertOrUndefined)(options.modificationDate, "options.modificationDate", [
                    Date
                ]);
                (0, $2qnUk.assertIsOneOfOrUndefined)(options.afRelationship, "options.afRelationship", (0, $ec59dba154692ed3$export$c12eac46fbec1b74));
                bytes = (0, $i8eKs.toUint8Array)(attachment);
                embedder = (0, $ec59dba154692ed3$export$2e2bcd8739ae039).for(bytes, name, options);
                ref = this.context.nextRef();
                embeddedFile = (0, $e8440867e1e7cb7a$export$2e2bcd8739ae039).of(ref, this, embedder);
                this.embeddedFiles.push(embeddedFile);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Embed a font into this document. The input data can be provided in multiple
     * formats:
     *
     * | Type            | Contents                                                |
     * | --------------- | ------------------------------------------------------- |
     * | `StandardFonts` | One of the standard 14 fonts                            |
     * | `string`        | A base64 encoded string (or data URI) containing a font |
     * | `Uint8Array`    | The raw bytes of a font                                 |
     * | `ArrayBuffer`   | The raw bytes of a font                                 |
     *
     * For example:
     * ```js
     * // font=StandardFonts
     * import { StandardFonts } from 'pdf-lib'
     * const font1 = await pdfDoc.embedFont(StandardFonts.Helvetica)
     *
     * // font=string
     * const font2 = await pdfDoc.embedFont('AAEAAAAVAQAABABQRFNJRx/upe...')
     * const font3 = await pdfDoc.embedFont('data:font/opentype;base64,AAEAAA...')
     *
     * // font=Uint8Array
     * import fs from 'fs'
     * const font4 = await pdfDoc.embedFont(fs.readFileSync('Ubuntu-R.ttf'))
     *
     * // font=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf'
     * const ubuntuBytes = await fetch(url).then(res => res.arrayBuffer())
     * const font5 = await pdfDoc.embedFont(ubuntuBytes)
     * ```
     * See also: [[registerFontkit]]
     * @param font The input data for a font.
     * @param options The options to be used when embedding the font.
     * @returns Resolves with the embedded font.
     */ PDFDocument.prototype.embedFont = function(font, options) {
        if (options === void 0) options = {};
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var _a, subset, customName, features, embedder, bytes, fontkit, _b, ref, pdfFont;
            return (0, $59LZ8.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = options.subset, subset = _a === void 0 ? false : _a, customName = options.customName, features = options.features;
                        (0, $2qnUk.assertIs)(font, "font", [
                            "string",
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $2qnUk.assertIs)(subset, "subset", [
                            "boolean"
                        ]);
                        if (!(0, $4PFuJ.isStandardFont)(font)) return [
                            3 /*break*/ ,
                            1
                        ];
                        embedder = (0, $587d3987c4649df3$export$2e2bcd8739ae039).for(font, customName);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 1:
                        if (!(0, $i8eKs.canBeConvertedToUint8Array)(font)) return [
                            3 /*break*/ ,
                            6
                        ];
                        bytes = (0, $i8eKs.toUint8Array)(font);
                        fontkit = this.assertFontkit();
                        if (!subset) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $4017cb560b440560$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 2:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $94580d5a22612d4f$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 4:
                        _b = _c.sent();
                        _c.label = 5;
                    case 5:
                        embedder = _b;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        throw new TypeError("`font` must be one of `StandardFonts | string | Uint8Array | ArrayBuffer`");
                    case 7:
                        ref = this.context.nextRef();
                        pdfFont = (0, $489bb5c728206ba0$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.fonts.push(pdfFont);
                        return [
                            2 /*return*/ ,
                            pdfFont
                        ];
                }
            });
        });
    };
    /**
     * Embed a standard font into this document.
     * For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     * const helveticaFont = pdfDoc.embedFont(StandardFonts.Helvetica)
     * ```
     * @param font The standard font to be embedded.
     * @param customName The name to be used when embedding the font.
     * @returns The embedded font.
     */ PDFDocument.prototype.embedStandardFont = function(font, customName) {
        (0, $2qnUk.assertIs)(font, "font", [
            "string"
        ]);
        if (!(0, $4PFuJ.isStandardFont)(font)) throw new TypeError("`font` must be one of type `StandardFonts`");
        var embedder = (0, $587d3987c4649df3$export$2e2bcd8739ae039).for(font, customName);
        var ref = this.context.nextRef();
        var pdfFont = (0, $489bb5c728206ba0$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.fonts.push(pdfFont);
        return pdfFont;
    };
    /**
     * Embed a JPEG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                      |
     * | ------------- | ------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing a JPEG image |
     * | `Uint8Array`  | The raw bytes of a JPEG image                                 |
     * | `ArrayBuffer` | The raw bytes of a JPEG image                                 |
     *
     * For example:
     * ```js
     * // jpg=string
     * const image1 = await pdfDoc.embedJpg('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...')
     * const image2 = await pdfDoc.embedJpg('data:image/jpeg;base64,/9j/4AAQ...')
     *
     * // jpg=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * const image3 = await pdfDoc.embedJpg(uint8Array)
     *
     * // jpg=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedJpg(arrayBuffer)
     * ```
     *
     * @param jpg The input data for a JPEG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedJpg = function(jpg) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $2qnUk.assertIs)(jpg, "jpg", [
                            "string",
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $i8eKs.toUint8Array)(jpg);
                        return [
                            4 /*yield*/ ,
                            (0, $52ae0fa4c28dbb24$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $625ea9c00707f127$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed a PNG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                     |
     * | ------------- | ------------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PNG image |
     * | `Uint8Array`  | The raw bytes of a PNG image                                 |
     * | `ArrayBuffer` | The raw bytes of a PNG image                                 |
     *
     * For example:
     * ```js
     * // png=string
     * const image1 = await pdfDoc.embedPng('iVBORw0KGgoAAAANSUhEUgAAAlgAAAF3...')
     * const image2 = await pdfDoc.embedPng('data:image/png;base64,iVBORw0KGg...')
     *
     * // png=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('small_mario.png')
     * const image3 = await pdfDoc.embedPng(uint8Array)
     *
     * // png=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/small_mario.png'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedPng(arrayBuffer)
     * ```
     *
     * @param png The input data for a PNG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedPng = function(png) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $2qnUk.assertIs)(png, "png", [
                            "string",
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $i8eKs.toUint8Array)(png);
                        return [
                            4 /*yield*/ ,
                            (0, $0a39e685a1b53e0a$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $625ea9c00707f127$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 of `sourcePdf` into `pdfDoc`
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, [73])
     * ```
     *
     * See [[PDFDocument.load]] for examples of the allowed input data formats.
     *
     * @param pdf The input data containing a PDF document.
     * @param indices The indices of the pages that should be embedded.
     * @returns Resolves with an array of the embedded pages.
     */ PDFDocument.prototype.embedPdf = function(pdf, indices) {
        if (indices === void 0) indices = [
            0
        ];
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var srcDoc, _a, srcPages;
            return (0, $59LZ8.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (0, $2qnUk.assertIs)(pdf, "pdf", [
                            "string",
                            Uint8Array,
                            ArrayBuffer,
                            [
                                PDFDocument,
                                "PDFDocument"
                            ]
                        ]);
                        (0, $2qnUk.assertIs)(indices, "indices", [
                            Array
                        ]);
                        if (!(pdf instanceof PDFDocument)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = pdf;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.load(pdf)
                        ];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        srcDoc = _a;
                        srcPages = (0, $i8eKs.pluckIndices)(srcDoc.getPages(), indices);
                        return [
                            2 /*return*/ ,
                            this.embedPages(srcPages)
                        ];
                }
            });
        });
    };
    /**
     * Embed a single PDF page into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     * const sourcePdfPage = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPage = await pdfDoc.embedPage(
     *   sourcePdfPage,
     *
     *   // Clip a section of the source page so that we only embed part of it
     *   { left: 100, right: 450, bottom: 330, top: 570 },
     *
     *   // Translate all drawings of the embedded page by (10, 200) units
     *   [1, 0, 0, 1, 10, 200],
     * )
     * ```
     *
     * @param page The page to be embedded.
     * @param boundingBox
     * Optionally, an area of the source page that should be embedded
     * (defaults to entire page).
     * @param transformationMatrix
     * Optionally, a transformation matrix that is always applied to the embedded
     * page anywhere it is drawn.
     * @returns Resolves with the embedded pdf page.
     */ PDFDocument.prototype.embedPage = function(page, boundingBox, transformationMatrix) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var embeddedPage;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $2qnUk.assertIs)(page, "page", [
                            [
                                (0, $65575dc41cd048b8$export$2e2bcd8739ae039),
                                "PDFPage"
                            ]
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.embedPages([
                                page
                            ], [
                                boundingBox
                            ], [
                                transformationMatrix
                            ])
                        ];
                    case 1:
                        embeddedPage = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            embeddedPage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     *
     * const page1 = sourcePdfDoc.getPages()[0]
     * const page2 = sourcePdfDoc.getPages()[52]
     * const page3 = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPages = await pdfDoc.embedPages([page1, page2, page3])
     * ```
     *
     * @param page
     * The pages to be embedded (they must all share the same context).
     * @param boundingBoxes
     * Optionally, an array of clipping boundaries - one for each page
     * (defaults to entirety of each page).
     * @param transformationMatrices
     * Optionally, an array of transformation matrices - one for each page
     * (each page's transformation will apply anywhere it is drawn).
     * @returns Resolves with an array of the embedded pdf pages.
     */ PDFDocument.prototype.embedPages = function(pages, boundingBoxes, transformationMatrices) {
        if (boundingBoxes === void 0) boundingBoxes = [];
        if (transformationMatrices === void 0) transformationMatrices = [];
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var idx, len, currPage, nextPage, context, maybeCopyPage, embeddedPages, idx, len, page, box, matrix, embedder, ref;
            var _a;
            return (0, $59LZ8.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (pages.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        // Assert all pages have the same context
                        for(idx = 0, len = pages.length - 1; idx < len; idx++){
                            currPage = pages[idx];
                            nextPage = pages[idx + 1];
                            if (currPage.node.context !== nextPage.node.context) throw new (0, $1cWQu.PageEmbeddingMismatchedContextError)();
                        }
                        context = pages[0].node.context;
                        maybeCopyPage = context === this.context ? function(p) {
                            return p;
                        } : (0, $fc9573798ab90b32$export$2e2bcd8739ae039).for(context, this.context).copy;
                        embeddedPages = new Array(pages.length);
                        idx = 0, len = pages.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        page = maybeCopyPage(pages[idx].node);
                        box = boundingBoxes[idx];
                        matrix = transformationMatrices[idx];
                        return [
                            4 /*yield*/ ,
                            (0, $898d4138dcc9c9b7$export$2e2bcd8739ae039).for(page, box, matrix)
                        ];
                    case 2:
                        embedder = _b.sent();
                        ref = this.context.nextRef();
                        embeddedPages[idx] = (0, $1b46723a68d54b97$export$2e2bcd8739ae039).of(ref, this, embedder);
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        (_a = this.embeddedPages).push.apply(_a, embeddedPages);
                        return [
                            2 /*return*/ ,
                            embeddedPages
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You shouldn't need to call this method directly. The [[save]]
     * > and [[saveAsBase64]] methods will automatically ensure that all embedded
     * > assets are flushed before serializing the document.
     *
     * Flush all embedded fonts, PDF pages, and images to this document's
     * [[context]].
     *
     * @returns Resolves when the flush is complete.
     */ PDFDocument.prototype.flush = function() {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.fonts)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.images)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedPages)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedFiles)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.javaScripts)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to an array of bytes making up a PDF file.
     * For example:
     * ```js
     * const pdfBytes = await pdfDoc.save()
     * ```
     *
     * There are a number of things you can do with the serialized document,
     * depending on the JavaScript environment you're running in:
     * * Write it to a file in Node or React Native
     * * Download it as a Blob in the browser
     * * Render it in an `iframe`
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with the bytes of the serialized document.
     */ PDFDocument.prototype.save = function(options) {
        if (options === void 0) options = {};
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var _a, useObjectStreams, _b, addDefaultPage, _c, objectsPerTick, _d, updateFieldAppearances, form, Writer;
            return (0, $59LZ8.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.useObjectStreams, useObjectStreams = _a === void 0 ? true : _a, _b = options.addDefaultPage, addDefaultPage = _b === void 0 ? true : _b, _c = options.objectsPerTick, objectsPerTick = _c === void 0 ? 50 : _c, _d = options.updateFieldAppearances, updateFieldAppearances = _d === void 0 ? true : _d;
                        (0, $2qnUk.assertIs)(useObjectStreams, "useObjectStreams", [
                            "boolean"
                        ]);
                        (0, $2qnUk.assertIs)(addDefaultPage, "addDefaultPage", [
                            "boolean"
                        ]);
                        (0, $2qnUk.assertIs)(objectsPerTick, "objectsPerTick", [
                            "number"
                        ]);
                        (0, $2qnUk.assertIs)(updateFieldAppearances, "updateFieldAppearances", [
                            "boolean"
                        ]);
                        if (addDefaultPage && this.getPageCount() === 0) this.addPage();
                        if (updateFieldAppearances) {
                            form = this.formCache.getValue();
                            if (form) form.updateFieldAppearances();
                        }
                        return [
                            4 /*yield*/ ,
                            this.flush()
                        ];
                    case 1:
                        _e.sent();
                        Writer = useObjectStreams ? (0, $1aa54dc870166c36$export$2e2bcd8739ae039) : (0, $7844c9967da92727$export$2e2bcd8739ae039);
                        return [
                            2 /*return*/ ,
                            Writer.forContext(this.context, objectsPerTick).serializeToBuffer()
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to a base64 encoded string or data URI making up a
     * PDF file. For example:
     * ```js
     * const base64String = await pdfDoc.saveAsBase64()
     * base64String // => 'JVBERi0xLjcKJYGBgYEKC...'
     *
     * const base64DataUri = await pdfDoc.saveAsBase64({ dataUri: true })
     * base64DataUri // => 'data:application/pdf;base64,JVBERi0xLjcKJYGBgYEKC...'
     * ```
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with a base64 encoded string or data URI of the
     *          serialized document.
     */ PDFDocument.prototype.saveAsBase64 = function(options) {
        if (options === void 0) options = {};
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var _a, dataUri, otherOptions, bytes, base64;
            return (0, $59LZ8.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = options.dataUri, dataUri = _a === void 0 ? false : _a, otherOptions = (0, $59LZ8.__rest)(options, [
                            "dataUri"
                        ]);
                        (0, $2qnUk.assertIs)(dataUri, "dataUri", [
                            "boolean"
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.save(otherOptions)
                        ];
                    case 1:
                        bytes = _b.sent();
                        base64 = (0, $9GHB7.encodeToBase64)(bytes);
                        return [
                            2 /*return*/ ,
                            dataUri ? "data:application/pdf;base64," + base64 : base64
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.findPageForAnnotationRef = function(ref) {
        var pages = this.getPages();
        for(var idx = 0, len = pages.length; idx < len; idx++){
            var page = pages[idx];
            var annotations = page.node.Annots();
            if ((annotations === null || annotations === void 0 ? void 0 : annotations.indexOf(ref)) !== undefined) return page;
        }
        return undefined;
    };
    PDFDocument.prototype.embedAll = function(embeddables) {
        return (0, $59LZ8.__awaiter)(this, void 0, void 0, function() {
            var idx, len;
            return (0, $59LZ8.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        idx = 0, len = embeddables.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            embeddables[idx].embed()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.updateInfoDict = function() {
        var pdfLib = "pdf-lib (https://github.com/Hopding/pdf-lib)";
        var now = new Date();
        var info = this.getInfoDict();
        this.setProducer(pdfLib);
        this.setModificationDate(now);
        if (!info.get((0, $a7yPZ.default).of("Creator"))) this.setCreator(pdfLib);
        if (!info.get((0, $a7yPZ.default).of("CreationDate"))) this.setCreationDate(now);
    };
    PDFDocument.prototype.getInfoDict = function() {
        var existingInfo = this.context.lookup(this.context.trailerInfo.Info);
        if (existingInfo instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039)) return existingInfo;
        var newInfo = this.context.obj({});
        this.context.trailerInfo.Info = this.context.register(newInfo);
        return newInfo;
    };
    PDFDocument.prototype.assertFontkit = function() {
        if (!this.fontkit) throw new (0, $ab1852e734a4db56$export$529a7c74d0636a48)();
        return this.fontkit;
    };
    return PDFDocument;
}();
var $c32e913e0d181c9e$export$2e2bcd8739ae039 = $c32e913e0d181c9e$var$PDFDocument;
/* tslint:disable-next-line only-arrow-functions */ function $c32e913e0d181c9e$var$assertIsLiteralOrHexString(pdfObject) {
    if (!(pdfObject instanceof (0, $97a582c32ae6773b$export$2e2bcd8739ae039)) && !(pdfObject instanceof (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039))) throw new (0, $1cWQu.UnexpectedObjectTypeError)([
        (0, $97a582c32ae6773b$export$2e2bcd8739ae039),
        (0, $bdb4f5f430bc7c08$export$2e2bcd8739ae039)
    ], pdfObject);
}





var $1ef26efbd45bd2b7$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode["Normal"] = "Normal";
    BlendMode["Multiply"] = "Multiply";
    BlendMode["Screen"] = "Screen";
    BlendMode["Overlay"] = "Overlay";
    BlendMode["Darken"] = "Darken";
    BlendMode["Lighten"] = "Lighten";
    BlendMode["ColorDodge"] = "ColorDodge";
    BlendMode["ColorBurn"] = "ColorBurn";
    BlendMode["HardLight"] = "HardLight";
    BlendMode["SoftLight"] = "SoftLight";
    BlendMode["Difference"] = "Difference";
    BlendMode["Exclusion"] = "Exclusion";
})($1ef26efbd45bd2b7$export$c9b8fe72ac71821 || ($1ef26efbd45bd2b7$export$c9b8fe72ac71821 = {}));





var $7Igbp = parcelRequire("7Igbp");
var $a7yPZ = parcelRequire("a7yPZ");
parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
var $cZKSB = parcelRequire("cZKSB");
var $4PFuJ = parcelRequire("4PFuJ");
/**
 * Represents a single page of a [[PDFDocument]].
 */ var $65575dc41cd048b8$var$PDFPage = /** @class */ function() {
    function PDFPage(leafNode, ref, doc) {
        this.fontSize = 24;
        this.fontColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        this.lineHeight = 24;
        this.x = 0;
        this.y = 0;
        (0, $2qnUk.assertIs)(leafNode, "leafNode", [
            [
                (0, $b808f27f9a7c9955$export$2e2bcd8739ae039),
                "PDFPageLeaf"
            ]
        ]);
        (0, $2qnUk.assertIs)(ref, "ref", [
            [
                (0, $06a507a20ec07388$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        (0, $2qnUk.assertIs)(doc, "doc", [
            [
                (0, $c32e913e0d181c9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        this.node = leafNode;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Rotate this page by a multiple of 90 degrees. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * page.setRotation(degrees(-90))
     * page.setRotation(degrees(0))
     * page.setRotation(degrees(90))
     * page.setRotation(degrees(180))
     * page.setRotation(degrees(270))
     * ```
     * @param angle The angle to rotate this page.
     */ PDFPage.prototype.setRotation = function(angle) {
        var degreesAngle = (0, $d82a2f5ff75b3e04$export$56cb859c01fa134d)(angle);
        (0, $2qnUk.assertMultiple)(degreesAngle, "degreesAngle", 90);
        this.node.set((0, $a7yPZ.default).of("Rotate"), this.doc.context.obj(degreesAngle));
    };
    /**
     * Get this page's rotation angle in degrees. For example:
     * ```js
     * const rotationAngle = page.getRotation().angle;
     * ```
     * @returns The rotation angle of the page in degrees (always a multiple of
     *          90 degrees).
     */ PDFPage.prototype.getRotation = function() {
        var Rotate = this.node.Rotate();
        return (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(Rotate ? Rotate.asNumber() : 0);
    };
    /**
     * Resize this page by increasing or decreasing its width and height. For
     * example:
     * ```js
     * page.setSize(250, 500)
     * page.setSize(page.getWidth() + 50, page.getHeight() + 100)
     * page.setSize(page.getWidth() - 50, page.getHeight() - 100)
     * ```
     *
     * Note that the PDF specification does not allow for pages to have explicit
     * widths and heights. Instead it defines the "size" of a page in terms of
     * five rectangles: the MediaBox, CropBox, BleedBox, TrimBox, and ArtBox. As a
     * result, this method cannot directly change the width and height of a page.
     * Instead, it works by adjusting these five boxes.
     *
     * This method performs the following steps:
     *   1. Set width & height of MediaBox.
     *   2. Set width & height of CropBox, if it has same dimensions as MediaBox.
     *   3. Set width & height of BleedBox, if it has same dimensions as MediaBox.
     *   4. Set width & height of TrimBox, if it has same dimensions as MediaBox.
     *   5. Set width & height of ArtBox, if it has same dimensions as MediaBox.
     *
     * This approach works well for most PDF documents as all PDF pages must
     * have a MediaBox, but relatively few have a CropBox, BleedBox, TrimBox, or
     * ArtBox. And when they do have these additional boxes, they often have the
     * same dimensions as the MediaBox. However, if you find this method does not
     * work for your document, consider setting the boxes directly:
     *   * [[PDFPage.setMediaBox]]
     *   * [[PDFPage.setCropBox]]
     *   * [[PDFPage.setBleedBox]]
     *   * [[PDFPage.setTrimBox]]
     *   * [[PDFPage.setArtBox]]
     *
     * @param width The new width of the page.
     * @param height The new height of the page.
     */ PDFPage.prototype.setSize = function(width, height) {
        (0, $2qnUk.assertIs)(width, "width", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(height, "height", [
            "number"
        ]);
        var mediaBox = this.getMediaBox();
        this.setMediaBox(mediaBox.x, mediaBox.y, width, height);
        var cropBox = this.getCropBox();
        var bleedBox = this.getBleedBox();
        var trimBox = this.getTrimBox();
        var artBox = this.getArtBox();
        var hasCropBox = this.node.CropBox();
        var hasBleedBox = this.node.BleedBox();
        var hasTrimBox = this.node.TrimBox();
        var hasArtBox = this.node.ArtBox();
        if (hasCropBox && (0, $4PFuJ.rectanglesAreEqual)(cropBox, mediaBox)) this.setCropBox(mediaBox.x, mediaBox.y, width, height);
        if (hasBleedBox && (0, $4PFuJ.rectanglesAreEqual)(bleedBox, mediaBox)) this.setBleedBox(mediaBox.x, mediaBox.y, width, height);
        if (hasTrimBox && (0, $4PFuJ.rectanglesAreEqual)(trimBox, mediaBox)) this.setTrimBox(mediaBox.x, mediaBox.y, width, height);
        if (hasArtBox && (0, $4PFuJ.rectanglesAreEqual)(artBox, mediaBox)) this.setArtBox(mediaBox.x, mediaBox.y, width, height);
    };
    /**
     * Resize this page by increasing or decreasing its width. For example:
     * ```js
     * page.setWidth(250)
     * page.setWidth(page.getWidth() + 50)
     * page.setWidth(page.getWidth() - 50)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's width.
     *
     * @param width The new width of the page.
     */ PDFPage.prototype.setWidth = function(width) {
        (0, $2qnUk.assertIs)(width, "width", [
            "number"
        ]);
        this.setSize(width, this.getSize().height);
    };
    /**
     * Resize this page by increasing or decreasing its height. For example:
     * ```js
     * page.setHeight(500)
     * page.setHeight(page.getWidth() + 100)
     * page.setHeight(page.getWidth() - 100)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's height.
     *
     * @param height The new height of the page.
     */ PDFPage.prototype.setHeight = function(height) {
        (0, $2qnUk.assertIs)(height, "height", [
            "number"
        ]);
        this.setSize(this.getSize().width, height);
    };
    /**
     * Set the MediaBox of this page. For example:
     * ```js
     * const mediaBox = page.getMediaBox()
     *
     * page.setMediaBox(0, 0, 250, 500)
     * page.setMediaBox(mediaBox.x, mediaBox.y, 50, 100)
     * page.setMediaBox(15, 5, mediaBox.width - 50, mediaBox.height - 100)
     * ```
     *
     * See [[PDFPage.getMediaBox]] for details about what the MediaBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new MediaBox.
     * @param y The y coordinate of the lower left corner of the new MediaBox.
     * @param width The width of the new MediaBox.
     * @param height The height of the new MediaBox.
     */ PDFPage.prototype.setMediaBox = function(x, y, width, height) {
        (0, $2qnUk.assertIs)(x, "x", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(y, "y", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(width, "width", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(height, "height", [
            "number"
        ]);
        var mediaBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $a7yPZ.default).MediaBox, mediaBox);
    };
    /**
     * Set the CropBox of this page. For example:
     * ```js
     * const cropBox = page.getCropBox()
     *
     * page.setCropBox(0, 0, 250, 500)
     * page.setCropBox(cropBox.x, cropBox.y, 50, 100)
     * page.setCropBox(15, 5, cropBox.width - 50, cropBox.height - 100)
     * ```
     *
     * See [[PDFPage.getCropBox]] for details about what the CropBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new CropBox.
     * @param y The y coordinate of the lower left corner of the new CropBox.
     * @param width The width of the new CropBox.
     * @param height The height of the new CropBox.
     */ PDFPage.prototype.setCropBox = function(x, y, width, height) {
        (0, $2qnUk.assertIs)(x, "x", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(y, "y", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(width, "width", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(height, "height", [
            "number"
        ]);
        var cropBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $a7yPZ.default).CropBox, cropBox);
    };
    /**
     * Set the BleedBox of this page. For example:
     * ```js
     * const bleedBox = page.getBleedBox()
     *
     * page.setBleedBox(0, 0, 250, 500)
     * page.setBleedBox(bleedBox.x, bleedBox.y, 50, 100)
     * page.setBleedBox(15, 5, bleedBox.width - 50, bleedBox.height - 100)
     * ```
     *
     * See [[PDFPage.getBleedBox]] for details about what the BleedBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new BleedBox.
     * @param y The y coordinate of the lower left corner of the new BleedBox.
     * @param width The width of the new BleedBox.
     * @param height The height of the new BleedBox.
     */ PDFPage.prototype.setBleedBox = function(x, y, width, height) {
        (0, $2qnUk.assertIs)(x, "x", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(y, "y", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(width, "width", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(height, "height", [
            "number"
        ]);
        var bleedBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $a7yPZ.default).BleedBox, bleedBox);
    };
    /**
     * Set the TrimBox of this page. For example:
     * ```js
     * const trimBox = page.getTrimBox()
     *
     * page.setTrimBox(0, 0, 250, 500)
     * page.setTrimBox(trimBox.x, trimBox.y, 50, 100)
     * page.setTrimBox(15, 5, trimBox.width - 50, trimBox.height - 100)
     * ```
     *
     * See [[PDFPage.getTrimBox]] for details about what the TrimBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new TrimBox.
     * @param y The y coordinate of the lower left corner of the new TrimBox.
     * @param width The width of the new TrimBox.
     * @param height The height of the new TrimBox.
     */ PDFPage.prototype.setTrimBox = function(x, y, width, height) {
        (0, $2qnUk.assertIs)(x, "x", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(y, "y", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(width, "width", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(height, "height", [
            "number"
        ]);
        var trimBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $a7yPZ.default).TrimBox, trimBox);
    };
    /**
     * Set the ArtBox of this page. For example:
     * ```js
     * const artBox = page.getArtBox()
     *
     * page.setArtBox(0, 0, 250, 500)
     * page.setArtBox(artBox.x, artBox.y, 50, 100)
     * page.setArtBox(15, 5, artBox.width - 50, artBox.height - 100)
     * ```
     *
     * See [[PDFPage.getArtBox]] for details about what the ArtBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new ArtBox.
     * @param y The y coordinate of the lower left corner of the new ArtBox.
     * @param width The width of the new ArtBox.
     * @param height The height of the new ArtBox.
     */ PDFPage.prototype.setArtBox = function(x, y, width, height) {
        (0, $2qnUk.assertIs)(x, "x", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(y, "y", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(width, "width", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(height, "height", [
            "number"
        ]);
        var artBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $a7yPZ.default).ArtBox, artBox);
    };
    /**
     * Get this page's width and height. For example:
     * ```js
     * const { width, height } = page.getSize()
     * ```
     *
     * This method uses [[PDFPage.getMediaBox]] to obtain the page's
     * width and height.
     *
     * @returns The width and height of the page.
     */ PDFPage.prototype.getSize = function() {
        var _a = this.getMediaBox(), width = _a.width, height = _a.height;
        return {
            width: width,
            height: height
        };
    };
    /**
     * Get this page's width. For example:
     * ```js
     * const width = page.getWidth()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The width of the page.
     */ PDFPage.prototype.getWidth = function() {
        return this.getSize().width;
    };
    /**
     * Get this page's height. For example:
     * ```js
     * const height = page.getHeight()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The height of the page.
     */ PDFPage.prototype.getHeight = function() {
        return this.getSize().height;
    };
    /**
     * Get the rectangle defining this page's MediaBox. For example:
     * ```js
     * const { x, y, width, height } = page.getMediaBox()
     * ```
     *
     * The MediaBox of a page defines the boundaries of the physical medium on
     * which the page is to be displayed/printed. It may include extended area
     * surrounding the page content for bleed marks, printing marks, etc...
     * It may also include areas close to the edges of the medium that cannot be
     * marked because of physical limitations of the output device. Content
     * falling outside this boundary may safely be discarded without affecting
     * the meaning of the PDF file.
     *
     * @returns An object defining the lower left corner of the MediaBox and its
     *          width & height.
     */ PDFPage.prototype.getMediaBox = function() {
        var mediaBox = this.node.MediaBox();
        return mediaBox.asRectangle();
    };
    /**
     * Get the rectangle defining this page's CropBox. For example:
     * ```js
     * const { x, y, width, height } = page.getCropBox()
     * ```
     *
     * The CropBox of a page defines the region to which the contents of the page
     * shall be clipped when displayed or printed. Unlike the other boxes, the
     * CropBox does not necessarily represent the physical page geometry. It
     * merely imposes clipping on the page contents.
     *
     * The CropBox's default value is the page's MediaBox.
     *
     * @returns An object defining the lower left corner of the CropBox and its
     *          width & height.
     */ PDFPage.prototype.getCropBox = function() {
        var _a;
        var cropBox = this.node.CropBox();
        return (_a = cropBox === null || cropBox === void 0 ? void 0 : cropBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getMediaBox();
    };
    /**
     * Get the rectangle defining this page's BleedBox. For example:
     * ```js
     * const { x, y, width, height } = page.getBleedBox()
     * ```
     *
     * The BleedBox of a page defines the region to which the contents of the
     * page shall be clipped when output in a production environment. This may
     * include any extra bleed area needed to accommodate the physical
     * limitations of cutting, folding, and trimming equipment. The actual
     * printed page may include printing marks that fall outside the BleedBox.
     *
     * The BleedBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the BleedBox and its
     *          width & height.
     */ PDFPage.prototype.getBleedBox = function() {
        var _a;
        var bleedBox = this.node.BleedBox();
        return (_a = bleedBox === null || bleedBox === void 0 ? void 0 : bleedBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's TrimBox. For example:
     * ```js
     * const { x, y, width, height } = page.getTrimBox()
     * ```
     *
     * The TrimBox of a page defines the intended dimensions of the finished
     * page after trimming. It may be smaller than the MediaBox to allow for
     * production-related content, such as printing instructions, cut marks, or
     * color bars.
     *
     * The TrimBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the TrimBox and its
     *          width & height.
     */ PDFPage.prototype.getTrimBox = function() {
        var _a;
        var trimBox = this.node.TrimBox();
        return (_a = trimBox === null || trimBox === void 0 ? void 0 : trimBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's ArtBox. For example:
     * ```js
     * const { x, y, width, height } = page.getArtBox()
     * ```
     *
     * The ArtBox of a page defines the extent of the page's meaningful content
     * (including potential white space).
     *
     * The ArtBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the ArtBox and its
     *          width & height.
     */ PDFPage.prototype.getArtBox = function() {
        var _a;
        var artBox = this.node.ArtBox();
        return (_a = artBox === null || artBox === void 0 ? void 0 : artBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Translate this page's content to a new location on the page. This operation
     * is often useful after resizing the page with [[setSize]]. For example:
     * ```js
     * // Add 50 units of whitespace to the top and right of the page
     * page.setSize(page.getWidth() + 50, page.getHeight() + 50)
     *
     * // Move the page's content from the lower-left corner of the page
     * // to the top-right corner.
     * page.translateContent(50, 50)
     *
     * // Now there are 50 units of whitespace to the left and bottom of the page
     * ```
     * See also: [[resetPosition]]
     * @param x The new position on the x-axis for this page's content.
     * @param y The new position on the y-axis for this page's content.
     */ PDFPage.prototype.translateContent = function(x, y) {
        (0, $2qnUk.assertIs)(x, "x", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(y, "y", [
            "number"
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(), (0, $7b945c9f8f83b90a$export$d73ee8ef04f5226a)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the size, content, and annotations of a page.
     *
     * For example:
     * ```js
     * page.scale(0.5, 0.5);
     * ```
     *
     * @param x The factor by which the width for the page should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the height for the page should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scale = function(x, y) {
        (0, $2qnUk.assertIs)(x, "x", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(y, "y", [
            "number"
        ]);
        this.setSize(this.getWidth() * x, this.getHeight() * y);
        this.scaleContent(x, y);
        this.scaleAnnotations(x, y);
    };
    /**
     * Scale the content of a page. This is useful after resizing an existing
     * page. This scales only the content, not the annotations.
     *
     * For example:
     * ```js
     * // Bisect the size of the page
     * page.setSize(page.getWidth() / 2, page.getHeight() / 2);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     * ```
     * See also: [[scaleAnnotations]]
     * @param x The factor by which the x-axis for the content should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the content should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleContent = function(x, y) {
        (0, $2qnUk.assertIs)(x, "x", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(y, "y", [
            "number"
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $7b945c9f8f83b90a$export$cb182c48e35739ac)(), (0, $7b945c9f8f83b90a$export$dcdf75081b88279d)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $7b945c9f8f83b90a$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the annotations of a page. This is useful if you want to scale a
     * page with comments or other annotations.
     * ```js
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleAnnotations(0.5, 0.5);
     * ```
     * See also: [[scaleContent]]
     * @param x The factor by which the x-axis for the annotations should be
     *          scaled (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the annotations should be
     *          scaled (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleAnnotations = function(x, y) {
        (0, $2qnUk.assertIs)(x, "x", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(y, "y", [
            "number"
        ]);
        var annots = this.node.Annots();
        if (!annots) return;
        for(var idx = 0; idx < annots.size(); idx++){
            var annot = annots.lookup(idx);
            if (annot instanceof (0, $f437c135fa674ebe$export$2e2bcd8739ae039)) this.scaleAnnot(annot, x, y);
        }
    };
    /**
     * Reset the x and y coordinates of this page to `(0, 0)`. This operation is
     * often useful after calling [[translateContent]]. For example:
     * ```js
     * // Shift the page's contents up and to the right by 50 units
     * page.translateContent(50, 50)
     *
     * // This text will shifted - it will be drawn at (50, 50)
     * page.drawText('I am shifted')
     *
     * // Move back to (0, 0)
     * page.resetPosition()
     *
     * // This text will not be shifted - it will be drawn at (0, 0)
     * page.drawText('I am not shifted')
     * ```
     */ PDFPage.prototype.resetPosition = function() {
        this.getContentStream(false);
        this.x = 0;
        this.y = 0;
    };
    /**
     * Choose a default font for this page. The default font will be used whenever
     * text is drawn on this page and no font is specified. For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     *
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const courierFont = await pdfDoc.embedFont(StandardFonts.Courier)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     * page.drawText('I will be drawn in Helvetica')
     *
     * page.setFont(timesRomanFont)
     * page.drawText('I will be drawn in Courier', { font: courierFont })
     * ```
     * @param font The default font to be used when drawing text on this page.
     */ PDFPage.prototype.setFont = function(font) {
        // TODO: Reuse image Font name if we've already added this image to Resources.Fonts
        (0, $2qnUk.assertIs)(font, "font", [
            [
                (0, $489bb5c728206ba0$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        this.font = font;
        this.fontKey = this.node.newFontDictionary(this.font.name, this.font.ref);
    };
    /**
     * Choose a default font size for this page. The default font size will be
     * used whenever text is drawn on this page and no font size is specified.
     * For example:
     * ```js
     * page.setFontSize(12)
     * page.drawText('I will be drawn in size 12')
     *
     * page.setFontSize(36)
     * page.drawText('I will be drawn in size 24', { fontSize: 24 })
     * ```
     * @param fontSize The default font size to be used when drawing text on this
     *                 page.
     */ PDFPage.prototype.setFontSize = function(fontSize) {
        (0, $2qnUk.assertIs)(fontSize, "fontSize", [
            "number"
        ]);
        this.fontSize = fontSize;
    };
    /**
     * Choose a default font color for this page. The default font color will be
     * used whenever text is drawn on this page and no font color is specified.
     * For example:
     * ```js
     * import { rgb, cmyk, grayscale } from 'pdf-lib'
     *
     * page.setFontColor(rgb(0.97, 0.02, 0.97))
     * page.drawText('I will be drawn in pink')
     *
     * page.setFontColor(cmyk(0.4, 0.7, 0.39, 0.15))
     * page.drawText('I will be drawn in gray', { color: grayscale(0.5) })
     * ```
     * @param fontColor The default font color to be used when drawing text on
     *                  this page.
     */ PDFPage.prototype.setFontColor = function(fontColor) {
        (0, $2qnUk.assertIs)(fontColor, "fontColor", [
            [
                Object,
                "Color"
            ]
        ]);
        this.fontColor = fontColor;
    };
    /**
     * Choose a default line height for this page. The default line height will be
     * used whenever text is drawn on this page and no line height is specified.
     * For example:
     * ```js
     * page.setLineHeight(12);
     * page.drawText('These lines will be vertically \n separated by 12 units')
     *
     * page.setLineHeight(36);
     * page.drawText('These lines will be vertically \n separated by 24 units', {
     *   lineHeight: 24
     * })
     * ```
     * @param lineHeight The default line height to be used when drawing text on
     *                   this page.
     */ PDFPage.prototype.setLineHeight = function(lineHeight) {
        (0, $2qnUk.assertIs)(lineHeight, "lineHeight", [
            "number"
        ]);
        this.lineHeight = lineHeight;
    };
    /**
     * Get the default position of this page. For example:
     * ```js
     * const { x, y } = page.getPosition()
     * ```
     * @returns The default position of the page.
     */ PDFPage.prototype.getPosition = function() {
        return {
            x: this.x,
            y: this.y
        };
    };
    /**
     * Get the default x coordinate of this page. For example:
     * ```js
     * const x = page.getX()
     * ```
     * @returns The default x coordinate of the page.
     */ PDFPage.prototype.getX = function() {
        return this.x;
    };
    /**
     * Get the default y coordinate of this page. For example:
     * ```js
     * const y = page.getY()
     * ```
     * @returns The default y coordinate of the page.
     */ PDFPage.prototype.getY = function() {
        return this.y;
    };
    /**
     * Change the default position of this page. For example:
     * ```js
     * page.moveTo(0, 0)
     * page.drawText('I will be drawn at the origin')
     *
     * page.moveTo(0, 25)
     * page.drawText('I will be drawn 25 units up')
     *
     * page.moveTo(25, 25)
     * page.drawText('I will be drawn 25 units up and 25 units to the right')
     * ```
     * @param x The new default position on the x-axis for this page.
     * @param y The new default position on the y-axis for this page.
     */ PDFPage.prototype.moveTo = function(x, y) {
        (0, $2qnUk.assertIs)(x, "x", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(y, "y", [
            "number"
        ]);
        this.x = x;
        this.y = y;
    };
    /**
     * Change the default position of this page to be further down the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveDown(10)
     * page.drawText('I will be drawn at (50, 40)')
     * ```
     * @param yDecrease The amount by which the page's default position along the
     *                  y-axis should be decreased.
     */ PDFPage.prototype.moveDown = function(yDecrease) {
        (0, $2qnUk.assertIs)(yDecrease, "yDecrease", [
            "number"
        ]);
        this.y -= yDecrease;
    };
    /**
     * Change the default position of this page to be further up the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveUp(10)
     * page.drawText('I will be drawn at (50, 60)')
     * ```
     * @param yIncrease The amount by which the page's default position along the
     *                  y-axis should be increased.
     */ PDFPage.prototype.moveUp = function(yIncrease) {
        (0, $2qnUk.assertIs)(yIncrease, "yIncrease", [
            "number"
        ]);
        this.y += yIncrease;
    };
    /**
     * Change the default position of this page to be further left on the x-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveLeft(10)
     * page.drawText('I will be drawn at (40, 50)')
     * ```
     * @param xDecrease The amount by which the page's default position along the
     *                  x-axis should be decreased.
     */ PDFPage.prototype.moveLeft = function(xDecrease) {
        (0, $2qnUk.assertIs)(xDecrease, "xDecrease", [
            "number"
        ]);
        this.x -= xDecrease;
    };
    /**
     * Change the default position of this page to be further right on the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveRight(10)
     * page.drawText('I will be drawn at (60, 50)')
     * ```
     * @param xIncrease The amount by which the page's default position along the
     *                  x-axis should be increased.
     */ PDFPage.prototype.moveRight = function(xIncrease) {
        (0, $2qnUk.assertIs)(xIncrease, "xIncrease", [
            "number"
        ]);
        this.x += xIncrease;
    };
    /**
     * Push one or more operators to the end of this page's current content
     * stream. For example:
     * ```js
     * import {
     *   pushGraphicsState,
     *   moveTo,
     *   lineTo,
     *   closePath,
     *   setFillingColor,
     *   rgb,
     *   fill,
     *   popGraphicsState,
     * } from 'pdf-lib'
     *
     * // Draw a green triangle in the lower-left corner of the page
     * page.pushOperators(
     *   pushGraphicsState(),
     *   moveTo(0, 0),
     *   lineTo(100, 0),
     *   lineTo(50, 100),
     *   closePath(),
     *   setFillingColor(rgb(0.0, 1.0, 0.0)),
     *   fill(),
     *   popGraphicsState(),
     * )
     * ```
     * @param operator The operators to be pushed.
     */ PDFPage.prototype.pushOperators = function() {
        var operator = [];
        for(var _i = 0; _i < arguments.length; _i++)operator[_i] = arguments[_i];
        (0, $2qnUk.assertEachIs)(operator, "operator", [
            [
                (0, $2cc502e5651ab7a6$export$2e2bcd8739ae039),
                "PDFOperator"
            ]
        ]);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, operator);
    };
    /**
     * Draw one or more lines of text on this page. For example:
     * ```js
     * import { StandardFonts, rgb } from 'pdf-lib'
     *
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     *
     * page.moveTo(5, 200)
     * page.drawText('The Life of an Egg', { size: 36 })
     *
     * page.moveDown(36)
     * page.drawText('An Epic Tale of Woe', { size: 30 })
     *
     * page.drawText(
     *   `Humpty Dumpty sat on a wall \n` +
     *   `Humpty Dumpty had a great fall; \n` +
     *   `All the king's horses and all the king's men \n` +
     *   `Couldn't put Humpty together again. \n`,
     *   {
     *     x: 25,
     *     y: 100,
     *     font: timesRomanFont,
     *     size: 24,
     *     color: rgb(1, 0, 0),
     *     lineHeight: 24,
     *     opacity: 0.75,
     *   },
     * )
     * ```
     * @param text The text to be drawn.
     * @param options The options to be used when drawing the text.
     */ PDFPage.prototype.drawText = function(text, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        (0, $2qnUk.assertIs)(text, "text", [
            "string"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.color, "options.color", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $2qnUk.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $2qnUk.assertOrUndefined)(options.font, "options.font", [
            [
                (0, $489bb5c728206ba0$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.size, "options.size", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.rotate, "options.rotate", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.xSkew, "options.xSkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.ySkew, "options.ySkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.x, "options.x", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.y, "options.y", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.lineHeight, "options.lineHeight", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.maxWidth, "options.maxWidth", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.wordBreaks, "options.wordBreaks", [
            Array
        ]);
        (0, $2qnUk.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $1ef26efbd45bd2b7$export$c9b8fe72ac71821));
        var _h = this.setOrEmbedFont(options.font), oldFont = _h.oldFont, newFont = _h.newFont, newFontKey = _h.newFontKey;
        var fontSize = options.size || this.fontSize;
        var wordBreaks = options.wordBreaks || this.doc.defaultWordBreaks;
        var textWidth = function(t) {
            return newFont.widthOfTextAtSize(t, fontSize);
        };
        var lines = options.maxWidth === undefined ? (0, $cZKSB.lineSplit)((0, $cZKSB.cleanText)(text)) : (0, $cZKSB.breakTextIntoLines)(text, wordBreaks, options.maxWidth, textWidth);
        var encodedLines = new Array(lines.length);
        for(var idx = 0, len = lines.length; idx < len; idx++)encodedLines[idx] = newFont.encodeText(lines[idx]);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $59179fabd6039f42$export$f7b8b44d3d84bc26)(encodedLines, {
            color: (_a = options.color) !== null && _a !== void 0 ? _a : this.fontColor,
            font: newFontKey,
            size: fontSize,
            rotate: (_b = options.rotate) !== null && _b !== void 0 ? _b : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            xSkew: (_c = options.xSkew) !== null && _c !== void 0 ? _c : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            ySkew: (_d = options.ySkew) !== null && _d !== void 0 ? _d : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            x: (_e = options.x) !== null && _e !== void 0 ? _e : this.x,
            y: (_f = options.y) !== null && _f !== void 0 ? _f : this.y,
            lineHeight: (_g = options.lineHeight) !== null && _g !== void 0 ? _g : this.lineHeight,
            graphicsState: graphicsStateKey
        }));
        if (options.font) {
            if (oldFont) this.setFont(oldFont);
            else this.resetFont();
        }
    };
    /**
     * Draw an image on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const jpgUrl = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer())
     *
     * const jpgImage = await pdfDoc.embedJpg(jpgImageBytes)
     * const jpgDims = jpgImage.scale(0.5)
     *
     * const page = pdfDoc.addPage()
     *
     * page.drawImage(jpgImage, {
     *   x: 25,
     *   y: 25,
     *   width: jpgDims.width,
     *   height: jpgDims.height,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     * @param image The image to be drawn.
     * @param options The options to be used when drawing the image.
     */ PDFPage.prototype.drawImage = function(image, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        // TODO: Reuse image XObject name if we've already added this image to Resources.XObjects
        (0, $2qnUk.assertIs)(image, "image", [
            [
                (0, $625ea9c00707f127$export$2e2bcd8739ae039),
                "PDFImage"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.x, "options.x", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.y, "options.y", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.width, "options.width", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.height, "options.height", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.rotate, "options.rotate", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.xSkew, "options.xSkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.ySkew, "options.ySkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $2qnUk.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $1ef26efbd45bd2b7$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject("Image", image.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $59179fabd6039f42$export$21a059be5bfd5fb)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : image.size().width,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : image.size().height,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an embedded PDF page on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const page = pdfDoc.addPage()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 from the PDF
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, 73)
     *
     * page.drawPage(embeddedPage, {
     *   x: 250,
     *   y: 200,
     *   xScale: 0.5,
     *   yScale: 0.5,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     *
     * The `options` argument accepts both `width`/`height` and `xScale`/`yScale`
     * as options. Since each of these options defines the size of the drawn page,
     * if both options are given, `width` and `height` take precedence and the
     * corresponding scale variants are ignored.
     *
     * @param embeddedPage The embedded page to be drawn.
     * @param options The options to be used when drawing the embedded page.
     */ PDFPage.prototype.drawPage = function(embeddedPage, options) {
        var _a, _b, _c, _d, _e;
        if (options === void 0) options = {};
        // TODO: Reuse embeddedPage XObject name if we've already added this embeddedPage to Resources.XObjects
        (0, $2qnUk.assertIs)(embeddedPage, "embeddedPage", [
            [
                (0, $1b46723a68d54b97$export$2e2bcd8739ae039),
                "PDFEmbeddedPage"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.x, "options.x", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.y, "options.y", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.xScale, "options.xScale", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.yScale, "options.yScale", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.width, "options.width", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.height, "options.height", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.rotate, "options.rotate", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.xSkew, "options.xSkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.ySkew, "options.ySkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $2qnUk.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $1ef26efbd45bd2b7$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject("EmbeddedPdfPage", embeddedPage.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        // prettier-ignore
        var xScale = options.width !== undefined ? options.width / embeddedPage.width : options.xScale !== undefined ? options.xScale : 1;
        // prettier-ignore
        var yScale = options.height !== undefined ? options.height / embeddedPage.height : options.yScale !== undefined ? options.yScale : 1;
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $59179fabd6039f42$export$f8ea28c31069cbc9)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: xScale,
            yScale: yScale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            xSkew: (_d = options.xSkew) !== null && _d !== void 0 ? _d : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            ySkew: (_e = options.ySkew) !== null && _e !== void 0 ? _e : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an SVG path on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * const svgPath = 'M 0,20 L 100,160 Q 130,200 150,120 C 190,-40 200,200 300,150 L 400,90'
     *
     * // Draw path as black line
     * page.drawSvgPath(svgPath, { x: 25, y: 75 })
     *
     * // Change border style and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 275,
     *   borderColor: rgb(0.5, 0.5, 0.5),
     *   borderWidth: 2,
     *   borderOpacity: 0.75,
     * })
     *
     * // Set fill color and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 475,
     *   color: rgb(1.0, 0, 0),
     *   opacity: 0.75,
     * })
     *
     * // Draw 50% of original size
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 675,
     *   scale: 0.5,
     * })
     * ```
     * @param path The SVG path to be drawn.
     * @param options The options to be used when drawing the SVG path.
     */ PDFPage.prototype.drawSvgPath = function(path, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (options === void 0) options = {};
        (0, $2qnUk.assertIs)(path, "path", [
            "string"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.x, "options.x", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.y, "options.y", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.scale, "options.scale", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.rotate, "options.rotate", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.borderWidth, "options.borderWidth", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.color, "options.color", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $2qnUk.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $2qnUk.assertOrUndefined)(options.borderColor, "options.borderColor", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.borderDashArray, "options.borderDashArray", [
            Array
        ]);
        (0, $2qnUk.assertOrUndefined)(options.borderDashPhase, "options.borderDashPhase", [
            "number"
        ]);
        (0, $2qnUk.assertIsOneOfOrUndefined)(options.borderLineCap, "options.borderLineCap", (0, $7b945c9f8f83b90a$export$7a77bc708e50709e));
        (0, $2qnUk.assertRangeOrUndefined)(options.borderOpacity, "options.borderOpacity", 0, 1);
        (0, $2qnUk.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $1ef26efbd45bd2b7$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!("color" in options) && !("borderColor" in options)) options.borderColor = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $59179fabd6039f42$export$47c8a640c39d0756)(path, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            scale: options.scale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            color: (_d = options.color) !== null && _d !== void 0 ? _d : undefined,
            borderColor: (_e = options.borderColor) !== null && _e !== void 0 ? _e : undefined,
            borderWidth: (_f = options.borderWidth) !== null && _f !== void 0 ? _f : 0,
            borderDashArray: (_g = options.borderDashArray) !== null && _g !== void 0 ? _g : undefined,
            borderDashPhase: (_h = options.borderDashPhase) !== null && _h !== void 0 ? _h : undefined,
            borderLineCap: (_j = options.borderLineCap) !== null && _j !== void 0 ? _j : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a line on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * page.drawLine({
     *   start: { x: 25, y: 75 },
     *   end: { x: 125, y: 175 },
     *   thickness: 2,
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the line.
     */ PDFPage.prototype.drawLine = function(options) {
        var _a, _b, _c, _d, _e;
        (0, $2qnUk.assertIs)(options.start, "options.start", [
            [
                Object,
                "{ x: number, y: number }"
            ]
        ]);
        (0, $2qnUk.assertIs)(options.end, "options.end", [
            [
                Object,
                "{ x: number, y: number }"
            ]
        ]);
        (0, $2qnUk.assertIs)(options.start.x, "options.start.x", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(options.start.y, "options.start.y", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(options.end.x, "options.end.x", [
            "number"
        ]);
        (0, $2qnUk.assertIs)(options.end.y, "options.end.y", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.thickness, "options.thickness", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.color, "options.color", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.dashArray, "options.dashArray", [
            Array
        ]);
        (0, $2qnUk.assertOrUndefined)(options.dashPhase, "options.dashPhase", [
            "number"
        ]);
        (0, $2qnUk.assertIsOneOfOrUndefined)(options.lineCap, "options.lineCap", (0, $7b945c9f8f83b90a$export$7a77bc708e50709e));
        (0, $2qnUk.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $2qnUk.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $1ef26efbd45bd2b7$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            borderOpacity: options.opacity,
            blendMode: options.blendMode
        });
        if (!("color" in options)) options.color = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $59179fabd6039f42$export$819db45aec5fcbe5)({
            start: options.start,
            end: options.end,
            thickness: (_a = options.thickness) !== null && _a !== void 0 ? _a : 1,
            color: (_b = options.color) !== null && _b !== void 0 ? _b : undefined,
            dashArray: (_c = options.dashArray) !== null && _c !== void 0 ? _c : undefined,
            dashPhase: (_d = options.dashPhase) !== null && _d !== void 0 ? _d : undefined,
            lineCap: (_e = options.lineCap) !== null && _e !== void 0 ? _e : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a rectangle on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawRectangle({
     *   x: 25,
     *   y: 75,
     *   width: 250,
     *   height: 75,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the rectangle.
     */ PDFPage.prototype.drawRectangle = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (options === void 0) options = {};
        (0, $2qnUk.assertOrUndefined)(options.x, "options.x", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.y, "options.y", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.width, "options.width", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.height, "options.height", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.rotate, "options.rotate", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.xSkew, "options.xSkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.ySkew, "options.ySkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.borderWidth, "options.borderWidth", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.color, "options.color", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $2qnUk.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $2qnUk.assertOrUndefined)(options.borderColor, "options.borderColor", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.borderDashArray, "options.borderDashArray", [
            Array
        ]);
        (0, $2qnUk.assertOrUndefined)(options.borderDashPhase, "options.borderDashPhase", [
            "number"
        ]);
        (0, $2qnUk.assertIsOneOfOrUndefined)(options.borderLineCap, "options.borderLineCap", (0, $7b945c9f8f83b90a$export$7a77bc708e50709e));
        (0, $2qnUk.assertRangeOrUndefined)(options.borderOpacity, "options.borderOpacity", 0, 1);
        (0, $2qnUk.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $1ef26efbd45bd2b7$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!("color" in options) && !("borderColor" in options)) options.color = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $59179fabd6039f42$export$cac848e0621718d8)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 150,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            color: (_j = options.color) !== null && _j !== void 0 ? _j : undefined,
            borderColor: (_k = options.borderColor) !== null && _k !== void 0 ? _k : undefined,
            borderDashArray: (_l = options.borderDashArray) !== null && _l !== void 0 ? _l : undefined,
            borderDashPhase: (_m = options.borderDashPhase) !== null && _m !== void 0 ? _m : undefined,
            graphicsState: graphicsStateKey,
            borderLineCap: (_o = options.borderLineCap) !== null && _o !== void 0 ? _o : undefined
        }));
    };
    /**
     * Draw a square on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawSquare({
     *   x: 25,
     *   y: 75,
     *   size: 100,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the square.
     */ PDFPage.prototype.drawSquare = function(options) {
        if (options === void 0) options = {};
        var size = options.size;
        (0, $2qnUk.assertOrUndefined)(size, "size", [
            "number"
        ]);
        this.drawRectangle((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, options), {
            width: size,
            height: size
        }));
    };
    /**
     * Draw an ellipse on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawEllipse({
     *   x: 200,
     *   y: 75,
     *   xScale: 100,
     *   yScale: 50,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawEllipse = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (options === void 0) options = {};
        (0, $2qnUk.assertOrUndefined)(options.x, "options.x", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.y, "options.y", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.xScale, "options.xScale", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.yScale, "options.yScale", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.rotate, "options.rotate", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(options.color, "options.color", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $2qnUk.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $2qnUk.assertOrUndefined)(options.borderColor, "options.borderColor", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $2qnUk.assertRangeOrUndefined)(options.borderOpacity, "options.borderOpacity", 0, 1);
        (0, $2qnUk.assertOrUndefined)(options.borderWidth, "options.borderWidth", [
            "number"
        ]);
        (0, $2qnUk.assertOrUndefined)(options.borderDashArray, "options.borderDashArray", [
            Array
        ]);
        (0, $2qnUk.assertOrUndefined)(options.borderDashPhase, "options.borderDashPhase", [
            "number"
        ]);
        (0, $2qnUk.assertIsOneOfOrUndefined)(options.borderLineCap, "options.borderLineCap", (0, $7b945c9f8f83b90a$export$7a77bc708e50709e));
        (0, $2qnUk.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $1ef26efbd45bd2b7$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!("color" in options) && !("borderColor" in options)) options.color = (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $59179fabd6039f42$export$43c9e2bb0dc74582)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: (_c = options.xScale) !== null && _c !== void 0 ? _c : 100,
            yScale: (_d = options.yScale) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : undefined,
            color: (_f = options.color) !== null && _f !== void 0 ? _f : undefined,
            borderColor: (_g = options.borderColor) !== null && _g !== void 0 ? _g : undefined,
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            borderDashArray: (_j = options.borderDashArray) !== null && _j !== void 0 ? _j : undefined,
            borderDashPhase: (_k = options.borderDashPhase) !== null && _k !== void 0 ? _k : undefined,
            borderLineCap: (_l = options.borderLineCap) !== null && _l !== void 0 ? _l : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a circle on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawCircle({
     *   x: 200,
     *   y: 150,
     *   size: 100,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawCircle = function(options) {
        if (options === void 0) options = {};
        var _a = options.size, size = _a === void 0 ? 100 : _a;
        (0, $2qnUk.assertOrUndefined)(size, "size", [
            "number"
        ]);
        this.drawEllipse((0, $59LZ8.__assign)((0, $59LZ8.__assign)({}, options), {
            xScale: size,
            yScale: size
        }));
    };
    PDFPage.prototype.setOrEmbedFont = function(font) {
        var oldFont = this.font;
        var oldFontKey = this.fontKey;
        if (font) this.setFont(font);
        else this.getFont();
        var newFont = this.font;
        var newFontKey = this.fontKey;
        return {
            oldFont: oldFont,
            oldFontKey: oldFontKey,
            newFont: newFont,
            newFontKey: newFontKey
        };
    };
    PDFPage.prototype.getFont = function() {
        if (!this.font || !this.fontKey) {
            var font = this.doc.embedStandardFont((0, $d094577b58833cd9$export$7dcb046109e65a3d).Helvetica);
            this.setFont(font);
        }
        return [
            this.font,
            this.fontKey
        ];
    };
    PDFPage.prototype.resetFont = function() {
        this.font = undefined;
        this.fontKey = undefined;
    };
    PDFPage.prototype.getContentStream = function(useExisting) {
        if (useExisting === void 0) useExisting = true;
        if (useExisting && this.contentStream) return this.contentStream;
        this.contentStream = this.createContentStream();
        this.contentStreamRef = this.doc.context.register(this.contentStream);
        this.node.addContentStream(this.contentStreamRef);
        return this.contentStream;
    };
    PDFPage.prototype.createContentStream = function() {
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        var dict = this.doc.context.obj({});
        var contentStream = (0, $b3f77b3eab24ae0a$export$2e2bcd8739ae039).of(dict, operators);
        return contentStream;
    };
    PDFPage.prototype.maybeEmbedGraphicsState = function(options) {
        var opacity = options.opacity, borderOpacity = options.borderOpacity, blendMode = options.blendMode;
        if (opacity === undefined && borderOpacity === undefined && blendMode === undefined) return undefined;
        var graphicsState = this.doc.context.obj({
            Type: "ExtGState",
            ca: opacity,
            CA: borderOpacity,
            BM: blendMode
        });
        var key = this.node.newExtGState("GS", graphicsState);
        return key;
    };
    PDFPage.prototype.scaleAnnot = function(annot, x, y) {
        var selectors = [
            "RD",
            "CL",
            "Vertices",
            "QuadPoints",
            "L",
            "Rect"
        ];
        for(var idx = 0, len = selectors.length; idx < len; idx++){
            var list = annot.lookup((0, $a7yPZ.default).of(selectors[idx]));
            if (list instanceof (0, $7Igbp.default)) list.scalePDFNumbers(x, y);
        }
        var inkLists = annot.lookup((0, $a7yPZ.default).of("InkList"));
        if (inkLists instanceof (0, $7Igbp.default)) for(var idx = 0, len = inkLists.size(); idx < len; idx++){
            var arr = inkLists.lookup(idx);
            if (arr instanceof (0, $7Igbp.default)) arr.scalePDFNumbers(x, y);
        }
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]] from an existing leaf node.
     *
     * @param leafNode The leaf node to be wrapped.
     * @param ref The unique reference for the page.
     * @param doc The document to which the page will belong.
     */ PDFPage.of = function(leafNode, ref, doc) {
        return new PDFPage(leafNode, ref, doc);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]].
     *
     * @param doc The document to which the page will belong.
     */ PDFPage.create = function(doc) {
        (0, $2qnUk.assertIs)(doc, "doc", [
            [
                (0, $c32e913e0d181c9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        var dummyRef = (0, $06a507a20ec07388$export$2e2bcd8739ae039).of(-1);
        var pageLeaf = (0, $b808f27f9a7c9955$export$2e2bcd8739ae039).withContextAndParent(doc.context, dummyRef);
        var pageRef = doc.context.register(pageLeaf);
        return new PDFPage(pageLeaf, pageRef, doc);
    };
    return PDFPage;
}();
var $65575dc41cd048b8$export$2e2bcd8739ae039 = $65575dc41cd048b8$var$PDFPage;









parcelRequire("6vLBB");
var $2qnUk = parcelRequire("2qnUk");
/**
 * Represents a button field of a [[PDFForm]].
 *
 * [[PDFButton]] fields are interactive controls that users can click with their
 * mouse. This type of [[PDFField]] is not stateful. The purpose of a button
 * is to perform an action when the user clicks on it, such as opening a print
 * modal or resetting the form. Buttons are typically rectangular in shape and
 * have a text label describing the action that they perform when clicked.
 */ var $4e6da06f9bc76d09$var$PDFButton = /** @class */ function(_super) {
    (0, $59LZ8.__extends)(PDFButton, _super);
    function PDFButton(acroPushButton, ref, doc) {
        var _this = _super.call(this, acroPushButton, ref, doc) || this;
        (0, $2qnUk.assertIs)(acroPushButton, "acroButton", [
            [
                (0, $cc8e0c206e3a3c82$export$2e2bcd8739ae039),
                "PDFAcroPushButton"
            ]
        ]);
        _this.acroField = acroPushButton;
        return _this;
    }
    /**
     * Display an image inside the bounds of this button's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const button = form.getButton('some.button.field')
     * button.setImage(pngImage, ImageAlignment.Center)
     * ```
     * This will update the appearances streams for each of this button's widgets.
     * @param image The image that should be displayed.
     * @param alignment The alignment of the image.
     */ PDFButton.prototype.setImage = function(image, alignment) {
        if (alignment === void 0) alignment = (0, $a851711d2fd1c050$export$8efa99ca8f041e7e).Center;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this button. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * button.setFontSize(4)
     * button.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFButton.prototype.setFontSize = function(fontSize) {
        (0, $2qnUk.assertPositive)(fontSize, "fontSize");
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Show this button on the specified page with the given text. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('some.button.field')
     *
     * button.addToPage('Do Stuff', page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this button field.
     * @param text The text to be displayed for this button widget.
     * @param page The page to which this button widget should be added.
     * @param options The options to be used when adding this button widget.
     */ PDFButton.prototype.addToPage = function(// TODO: This needs to be optional, e.g. for image buttons
    text, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        (0, $2qnUk.assertOrUndefined)(text, "text", [
            "string"
        ]);
        (0, $2qnUk.assertOrUndefined)(page, "page", [
            [
                (0, $65575dc41cd048b8$export$2e2bcd8739ae039),
                "PDFPage"
            ]
        ]);
        (0, $284a8acf05ac55e4$export$55643210f1835a35)(options);
        // Create a widget for this button
        var widget = this.createWidget({
            x: ((_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0) - ((_b = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _b !== void 0 ? _b : 0) / 2,
            y: ((_c = options === null || options === void 0 ? void 0 : options.y) !== null && _c !== void 0 ? _c : 0) - ((_d = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _d !== void 0 ? _d : 0) / 2,
            width: (_e = options === null || options === void 0 ? void 0 : options.width) !== null && _e !== void 0 ? _e : 100,
            height: (_f = options === null || options === void 0 ? void 0 : options.height) !== null && _f !== void 0 ? _f : 50,
            textColor: (_g = options === null || options === void 0 ? void 0 : options.textColor) !== null && _g !== void 0 ? _g : (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_h = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _h !== void 0 ? _h : (0, $c9f3d3f740911584$export$8972dc0e6ad9238f)(0.75, 0.75, 0.75),
            borderColor: options === null || options === void 0 ? void 0 : options.borderColor,
            borderWidth: (_j = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _j !== void 0 ? _j : 0,
            rotate: (_k = options === null || options === void 0 ? void 0 : options.rotate) !== null && _k !== void 0 ? _k : (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(0),
            caption: text,
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_l = options === null || options === void 0 ? void 0 : options.font) !== null && _l !== void 0 ? _l : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this button has been marked as dirty, or if any of this
     * button's widgets do not have an appearance stream. For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * if (button.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this button needs an appearance update.
     */ PDFButton.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $29b9b1023bfccc2c$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the default appearance provider for buttons. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFButton.prototype.defaultUpdateAppearances = function(font) {
        (0, $2qnUk.assertIs)(font, "font", [
            [
                (0, $489bb5c728206ba0$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for buttons will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return {
     *     normal: drawButton(...),
     *     down: drawButton(...),
     *   }
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFButton.prototype.updateAppearances = function(font, provider) {
        (0, $2qnUk.assertIs)(font, "font", [
            [
                (0, $489bb5c728206ba0$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        (0, $2qnUk.assertOrUndefined)(provider, "provider", [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
    };
    PDFButton.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $6754534916e67e80$export$68f9b19f48ffeeec);
        var appearances = (0, $6754534916e67e80$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getButton]] method, which will create an
     * > instance of [[PDFButton]] for you.
     *
     * Create an instance of [[PDFButton]] from an existing acroPushButton and ref
     *
     * @param acroPushButton The underlying `PDFAcroPushButton` for this button.
     * @param ref The unique reference for this button.
     * @param doc The document to which this button will belong.
     */ PDFButton.of = function(acroPushButton, ref, doc) {
        return new PDFButton(acroPushButton, ref, doc);
    };
    return PDFButton;
}((0, $284a8acf05ac55e4$export$2e2bcd8739ae039));
var $4e6da06f9bc76d09$export$2e2bcd8739ae039 = $4e6da06f9bc76d09$var$PDFButton;




































var $37309827377c117a$exports = {};


parcelRequire("6vLBB");
$parcel$exportWildcard($148a99c9e2d34415$exports, $37309827377c117a$exports);


function $d4bf4bbe2f3ac1b4$export$f5544efc2684376b(dataTransfer) {
    if (dataTransfer.items) // Use DataTransferItemList interface to access the file(s)
    return [
        ...dataTransfer.items
    ].filter((item)=>item.kind === "file").map((item)=>item.getAsFile());
    else // Use DataTransfer interface to access the file(s)
    return [
        ...dataTransfer.files
    ];
}
function $d4bf4bbe2f3ac1b4$export$befaf6bce9e08d55(fileName) {
    return fileName.replace(/\.[^/.]+$/, "");
}


var $da5f9092355a8063$export$cb6da89c6af1a8ec;
(function(Size) {
    Size["A4"] = "A4";
    Size["A3"] = "A3";
})($da5f9092355a8063$export$cb6da89c6af1a8ec || ($da5f9092355a8063$export$cb6da89c6af1a8ec = {}));
const $da5f9092355a8063$export$42c58ba01fdcd19c = {
    ["A4"]: 20,
    ["A3"]: 20
};


const $74dcec03938f78d8$var$A3_LANDSCAPE = [
    (0, $9ed9386fb79996c0$export$b4a05ae367f5515c).A3[1],
    (0, $9ed9386fb79996c0$export$b4a05ae367f5515c).A3[0]
];
const $74dcec03938f78d8$var$A4_PORTRAIT = (0, $9ed9386fb79996c0$export$b4a05ae367f5515c).A4;
async function $74dcec03938f78d8$export$d80f93a7e52cdefb(pdfs, pages, config) {
    const fileNameBase = `${pdfs.map((pdf)=>(0, $d4bf4bbe2f3ac1b4$export$befaf6bce9e08d55)(pdf.fileName)).join("-")}.pdf`;
    const theDoc = await (0, $c32e913e0d181c9e$export$2e2bcd8739ae039).create();
    let size;
    const onlyOnePage = pages.filter((page)=>page.included).length <= 1;
    if (config.a4toa3 && !onlyOnePage) {
        let pagesProcessed = 0;
        for(let i = 0; i < pdfs.length; i++){
            const pdf = pdfs[i];
            let indices = pages.filter((page)=>page.fileIndex === i && page.included).map((page)=>page.pageIndex);
            if (indices.length === 0) continue;
            if (config.whiteFront) indices = [
                undefined,
                ...indices
            ];
            if (config.bothSided) {
                console.log("inputIndices", indices);
                // replace pages from [4*n+1, 4*n+2, 4*n+3, 4*n+4] to [4*n+1, 4*n+3, 4*n+4, 4*n+2]
                const newIndices = [];
                const normLength = Math.ceil(indices.length / 4) * 4;
                for(let i = 0; i < indices.length / 4; i++)newIndices.push(indices[normLength - i * 2 - 1], indices[i * 2], indices[i * 2 + 1], indices[normLength - i * 2 - 2]);
                indices = newIndices;
            }
            console.log({
                indices: indices
            });
            const doc = await (0, $c32e913e0d181c9e$export$2e2bcd8739ae039).load(await pdf.file.arrayBuffer());
            for (const index of indices){
                let a3Page;
                let pageToEmbed, options;
                if (index !== undefined) {
                    pageToEmbed = await theDoc.embedPage(doc.getPage(index));
                    const isLandscape = pageToEmbed.height / pageToEmbed.width <= 1.1;
                    if (isLandscape) options = {
                        x: $74dcec03938f78d8$var$A3_LANDSCAPE[0] / 2 - ($74dcec03938f78d8$var$A4_PORTRAIT[0] - pageToEmbed.height) / 2,
                        y: ($74dcec03938f78d8$var$A4_PORTRAIT[1] - pageToEmbed.width) / 2,
                        rotate: (0, $d82a2f5ff75b3e04$export$41fc368e1a942b97)(90)
                    };
                    else options = {
                        x: ($74dcec03938f78d8$var$A4_PORTRAIT[0] - pageToEmbed.width) / 2,
                        y: ($74dcec03938f78d8$var$A4_PORTRAIT[1] - pageToEmbed.height) / 2
                    };
                }
                if (pagesProcessed % 2 === 0) {
                    a3Page = theDoc.insertPage(theDoc.getPages().length, $74dcec03938f78d8$var$A3_LANDSCAPE);
                    if (pageToEmbed && options) a3Page.drawPage(pageToEmbed, options);
                } else if (pageToEmbed && options) {
                    a3Page = theDoc.getPages()[theDoc.getPages().length - 1];
                    a3Page.drawPage(pageToEmbed, {
                        ...options,
                        x: options.x + $74dcec03938f78d8$var$A3_LANDSCAPE[0] / 2
                    });
                }
                pagesProcessed++;
            }
        }
        size = (0, $da5f9092355a8063$export$cb6da89c6af1a8ec).A3;
    } else {
        for(let i = 0; i < pdfs.length; i++){
            const pdf = pdfs[i];
            const indices = pages.filter((page)=>page.fileIndex === i && page.included).map((page)=>page.pageIndex);
            if (indices.length > 0) {
                const copiedPages = await theDoc.copyPages(await (0, $c32e913e0d181c9e$export$2e2bcd8739ae039).load(await pdf.file.arrayBuffer()), indices);
                copiedPages.forEach((copied)=>theDoc.addPage(copied));
            }
        }
        size = (0, $da5f9092355a8063$export$cb6da89c6af1a8ec).A4;
    }
    const fileName = `[${size}${config.bothSided ? "\u4E21\u9762\u77ED\u8FBA\u3068\u3058" : "\u7247\u9762"}]-${fileNameBase}`;
    theDoc.setTitle(fileName);
    return {
        doc: theDoc,
        fileName: fileName,
        size: size
    };
}



var $a8406dc0fd998931$export$8cde213409fd6377 = "r7yxk0";


parcelRequire("hEVyQ");
const $8ebda0951e5ad6dc$var$Preview = ({ url: url })=>{
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("iframe", {
        src: url,
        className: $a8406dc0fd998931$export$8cde213409fd6377,
        title: "\u30D7\u30EC\u30D3\u30E5\u30FC"
    });
};
var $8ebda0951e5ad6dc$export$2e2bcd8739ae039 = $8ebda0951e5ad6dc$var$Preview;







var $hEVyQ = parcelRequire("hEVyQ");











function $42a74229a45f72a2$export$5a6f9035944c8119(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiButton", slot);
}
const $42a74229a45f72a2$var$buttonClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $42a74229a45f72a2$export$2e2bcd8739ae039 = $42a74229a45f72a2$var$buttonClasses;



var $hEVyQ = parcelRequire("hEVyQ");
/**
 * @ignore - internal component.
 */ const $ca07cea049c7a668$var$ButtonGroupContext = /*#__PURE__*/ $hEVyQ.createContext({});
var $ca07cea049c7a668$export$2e2bcd8739ae039 = $ca07cea049c7a668$var$ButtonGroupContext;



const $21f9df141609ba2e$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $21f9df141609ba2e$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $42a74229a45f72a2$export$5a6f9035944c8119), classes);
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $21f9df141609ba2e$var$commonIconStyles = (ownerState)=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $21f9df141609ba2e$var$ButtonRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)((0, $02430851b7e91562$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $f0eb61bababa8473$export$effb20ecdbf4d6aa)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dbd72f49419aab0a$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dbd72f49419aab0a$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dbd72f49419aab0a$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $42a74229a45f72a2$export$2e2bcd8739ae039).focusVisible}`]: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $42a74229a45f72a2$export$2e2bcd8739ae039).disabled}`]: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $dbd72f49419aab0a$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $42a74229a45f72a2$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $42a74229a45f72a2$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $21f9df141609ba2e$var$ButtonStartIcon = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $21f9df141609ba2e$var$commonIconStyles(ownerState)));
const $21f9df141609ba2e$var$ButtonEndIcon = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $21f9df141609ba2e$var$commonIconStyles(ownerState)));
const $21f9df141609ba2e$var$Button = /*#__PURE__*/ $hEVyQ.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $hEVyQ.useContext((0, $ca07cea049c7a668$export$2e2bcd8739ae039));
    const resolvedProps = (0, $ec866b9bc2d17599$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $21f9df141609ba2e$var$_excluded);
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $21f9df141609ba2e$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($21f9df141609ba2e$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($21f9df141609ba2e$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)($21f9df141609ba2e$var$ButtonRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        ownerState: ownerState,
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(contextProps.className, classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $21f9df141609ba2e$export$2e2bcd8739ae039 = $21f9df141609ba2e$var$Button;




var $hEVyQ = parcelRequire("hEVyQ");








function $cd25d89b1f34badb$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiFab", slot);
}
const $cd25d89b1f34badb$var$fabClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiFab", [
    "root",
    "primary",
    "secondary",
    "extended",
    "circular",
    "focusVisible",
    "disabled",
    "colorInherit",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge",
    "info",
    "error",
    "warning",
    "success"
]);
var $cd25d89b1f34badb$export$2e2bcd8739ae039 = $cd25d89b1f34badb$var$fabClasses;




const $de771ae912d0ac67$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableFocusRipple",
    "focusVisibleClassName",
    "size",
    "variant"
];
const $de771ae912d0ac67$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `size${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(size)}`,
            color === "inherit" ? "colorInherit" : color
        ]
    };
    const composedClasses = (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $cd25d89b1f34badb$export$e2cfa0ca4bce1fc2), classes);
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $de771ae912d0ac67$var$FabRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)((0, $02430851b7e91562$export$2e2bcd8739ae039), {
    name: "MuiFab",
    slot: "Root",
    shouldForwardProp: (prop)=>(0, $f0eb61bababa8473$export$effb20ecdbf4d6aa)(prop) || prop === "classes",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            styles[(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, theme.typography.button, {
        minHeight: 36,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: "50%",
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: "none"
        },
        [`&.${(0, $cd25d89b1f34badb$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        }
    }, ownerState.size === "small" && {
        width: 40,
        height: 40
    }, ownerState.size === "medium" && {
        width: 48,
        height: 48
    }, ownerState.variant === "extended" && {
        borderRadius: 24,
        padding: "0 16px",
        width: "auto",
        minHeight: "auto",
        minWidth: 48,
        height: 48
    }, ownerState.variant === "extended" && ownerState.size === "small" && {
        width: "auto",
        padding: "0 8px",
        borderRadius: 17,
        minWidth: 34,
        height: 34
    }, ownerState.variant === "extended" && ownerState.size === "medium" && {
        width: "auto",
        padding: "0 16px",
        borderRadius: 20,
        minWidth: 40,
        height: 40
    }, ownerState.color === "inherit" && {
        color: "inherit"
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, ownerState.color !== "inherit" && ownerState.color !== "default" && (theme.vars || theme).palette[ownerState.color] != null && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }), ({ theme: theme })=>({
        [`&.${(0, $cd25d89b1f34badb$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    }));
const $de771ae912d0ac67$var$Fab = /*#__PURE__*/ $hEVyQ.forwardRef(function Fab(inProps, ref) {
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiFab"
    });
    const { children: children, className: className, color: color = "default", component: component = "button", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = "large", variant: variant = "circular" } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $de771ae912d0ac67$var$_excluded);
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    });
    const classes = $de771ae912d0ac67$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($de771ae912d0ac67$var$FabRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes,
        children: children
    }));
});
var $de771ae912d0ac67$export$2e2bcd8739ae039 = $de771ae912d0ac67$var$Fab;




var $hEVyQ = parcelRequire("hEVyQ");




/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $9b05097b823f349f$export$2e2bcd8739ae039(element) {
    return typeof element === "string";
}


function $38c5ab0f0c310902$export$2e2bcd8739ae039(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $9b05097b823f349f$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, otherProps, {
        ownerState: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, otherProps.ownerState, ownerState)
    });
}




parcelRequire("hEVyQ");



function $8251d502ea5b484c$export$2e2bcd8739ae039() {
    const theme = (0, $adb2b7c4d20eb565$export$2e2bcd8739ae039)((0, $d2a1fcd560cfdd72$export$2e2bcd8739ae039));
    return theme[0, $7586e29635f86062$export$2e2bcd8739ae039] || theme;
}







var $hEVyQ = parcelRequire("hEVyQ");






var $hEVyQ = parcelRequire("hEVyQ");

var $d805c54cae78c53f$export$2e2bcd8739ae039 = {
    disabled: false
};




var $f17e35a4d3005ad1$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $7cd725fa5ce36b75$export$bb38bb9a1161268 = "unmounted";
var $7cd725fa5ce36b75$export$84cbff306f539230 = "exited";
var $7cd725fa5ce36b75$export$df38205c966be359 = "entering";
var $7cd725fa5ce36b75$export$78e9e6e3e014d60a = "entered";
var $7cd725fa5ce36b75$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $7cd725fa5ce36b75$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $9fb73a7ee2a909cc$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $7cd725fa5ce36b75$export$84cbff306f539230;
                _this.appearStatus = $7cd725fa5ce36b75$export$df38205c966be359;
            } else initialStatus = $7cd725fa5ce36b75$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $7cd725fa5ce36b75$export$bb38bb9a1161268;
        else initialStatus = $7cd725fa5ce36b75$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $7cd725fa5ce36b75$export$bb38bb9a1161268) return {
            status: $7cd725fa5ce36b75$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $7cd725fa5ce36b75$export$df38205c966be359 && status !== $7cd725fa5ce36b75$export$78e9e6e3e014d60a) nextStatus = $7cd725fa5ce36b75$export$df38205c966be359;
            } else if (status === $7cd725fa5ce36b75$export$df38205c966be359 || status === $7cd725fa5ce36b75$export$78e9e6e3e014d60a) nextStatus = $7cd725fa5ce36b75$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $7cd725fa5ce36b75$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b4bc5509af1b9d3e$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $f17e35a4d3005ad1$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $7cd725fa5ce36b75$export$84cbff306f539230) this.setState({
            status: $7cd725fa5ce36b75$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($b4bc5509af1b9d3e$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $d805c54cae78c53f$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $7cd725fa5ce36b75$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $7cd725fa5ce36b75$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $7cd725fa5ce36b75$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($b4bc5509af1b9d3e$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $d805c54cae78c53f$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $7cd725fa5ce36b75$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $7cd725fa5ce36b75$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $7cd725fa5ce36b75$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b4bc5509af1b9d3e$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $7cd725fa5ce36b75$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($hEVyQ))).createElement((0, $3ab9174fd4fe3441$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($hEVyQ))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($hEVyQ))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($hEVyQ))).Component);
$7cd725fa5ce36b75$var$Transition.contextType = (0, $3ab9174fd4fe3441$export$2e2bcd8739ae039);
$7cd725fa5ce36b75$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $7cd725fa5ce36b75$var$noop() {}
$7cd725fa5ce36b75$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $7cd725fa5ce36b75$var$noop,
    onEntering: $7cd725fa5ce36b75$var$noop,
    onEntered: $7cd725fa5ce36b75$var$noop,
    onExit: $7cd725fa5ce36b75$var$noop,
    onExiting: $7cd725fa5ce36b75$var$noop,
    onExited: $7cd725fa5ce36b75$var$noop
};
$7cd725fa5ce36b75$var$Transition.UNMOUNTED = $7cd725fa5ce36b75$export$bb38bb9a1161268;
$7cd725fa5ce36b75$var$Transition.EXITED = $7cd725fa5ce36b75$export$84cbff306f539230;
$7cd725fa5ce36b75$var$Transition.ENTERING = $7cd725fa5ce36b75$export$df38205c966be359;
$7cd725fa5ce36b75$var$Transition.ENTERED = $7cd725fa5ce36b75$export$78e9e6e3e014d60a;
$7cd725fa5ce36b75$var$Transition.EXITING = $7cd725fa5ce36b75$export$4aacc83d4d59139f;
var $7cd725fa5ce36b75$export$2e2bcd8739ae039 = $7cd725fa5ce36b75$var$Transition;



const $0e1964581c172064$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $0e1964581c172064$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




const $6eec8cc105391dd4$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $6eec8cc105391dd4$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $6eec8cc105391dd4$var$styles = {
    entering: {
        opacity: 1,
        transform: $6eec8cc105391dd4$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $6eec8cc105391dd4$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $6eec8cc105391dd4$var$Grow = /*#__PURE__*/ $hEVyQ.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $7cd725fa5ce36b75$export$2e2bcd8739ae039) } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $6eec8cc105391dd4$var$_excluded);
    const timer = $hEVyQ.useRef();
    const autoTimeout = $hEVyQ.useRef();
    const theme = (0, $8251d502ea5b484c$export$2e2bcd8739ae039)();
    const nodeRef = $hEVyQ.useRef(null);
    const handleRef = (0, $4905b1fe0147563b$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $0e1964581c172064$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $0e1964581c172064$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $6eec8cc105391dd4$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $0e1964581c172064$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $6eec8cc105391dd4$var$isWebKit154 ? duration : duration * 0.666,
                delay: $6eec8cc105391dd4$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $6eec8cc105391dd4$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $hEVyQ.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)(TransitionComponent, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $hEVyQ.cloneElement(children, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
                style: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
                    opacity: 0,
                    transform: $6eec8cc105391dd4$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $6eec8cc105391dd4$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$6eec8cc105391dd4$var$Grow.muiSupportAuto = true;
var $6eec8cc105391dd4$export$2e2bcd8739ae039 = $6eec8cc105391dd4$var$Grow;







var $hEVyQ = parcelRequire("hEVyQ");
function $9c0df9755538240d$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $498c51d7f7ea2b21$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $498c51d7f7ea2b21$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $498c51d7f7ea2b21$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $6248a9a5e5635fa4$export$8960430cfd85939f = Math.max;
var $6248a9a5e5635fa4$export$96ec731ed4dcb222 = Math.min;
var $6248a9a5e5635fa4$export$2077e0241d6afd3c = Math.round;



function $1fae9e116c09b3a4$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $3c8c527a52bfe157$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $1fae9e116c09b3a4$export$2e2bcd8739ae039)());
}


function $bf515e7930a738c8$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $498c51d7f7ea2b21$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $6248a9a5e5635fa4$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $6248a9a5e5635fa4$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $498c51d7f7ea2b21$export$45a5e7f76e0caa8d)(element) ? (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $3c8c527a52bfe157$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $1fc591420ee01a1d$export$2e2bcd8739ae039(node) {
    var win = (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $1f1de68bb86caf74$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $f1315672d843d1b4$export$2e2bcd8739ae039(node) {
    if (node === (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(node) || !(0, $498c51d7f7ea2b21$export$1b3bfaa9684536aa)(node)) return (0, $1fc591420ee01a1d$export$2e2bcd8739ae039)(node);
    else return (0, $1f1de68bb86caf74$export$2e2bcd8739ae039)(node);
}


function $4e2b39ec97f5ef92$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $394718861fdee8d4$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $498c51d7f7ea2b21$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $1a9f2a3d2457ee19$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bf515e7930a738c8$export$2e2bcd8739ae039)((0, $394718861fdee8d4$export$2e2bcd8739ae039)(element)).left + (0, $1fc591420ee01a1d$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $8c69db192cac5f6d$export$2e2bcd8739ae039(element) {
    return (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $8b070ce9abd1e027$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $8c69db192cac5f6d$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $9ed726cdcd0ed7c0$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $6248a9a5e5635fa4$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $6248a9a5e5635fa4$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $9ed726cdcd0ed7c0$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $498c51d7f7ea2b21$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $498c51d7f7ea2b21$export$1b3bfaa9684536aa)(offsetParent) && $9ed726cdcd0ed7c0$var$isElementScaled(offsetParent);
    var documentElement = (0, $394718861fdee8d4$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $bf515e7930a738c8$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4e2b39ec97f5ef92$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $8b070ce9abd1e027$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $f1315672d843d1b4$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $498c51d7f7ea2b21$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $bf515e7930a738c8$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $1a9f2a3d2457ee19$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $70be0fdf2c663575$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bf515e7930a738c8$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $e864ea88a9e66959$export$2e2bcd8739ae039(element) {
    if ((0, $4e2b39ec97f5ef92$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $498c51d7f7ea2b21$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $394718861fdee8d4$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2e22222a2ba2a9f2$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $4e2b39ec97f5ef92$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $498c51d7f7ea2b21$export$1b3bfaa9684536aa)(node) && (0, $8b070ce9abd1e027$export$2e2bcd8739ae039)(node)) return node;
    return $2e22222a2ba2a9f2$export$2e2bcd8739ae039((0, $e864ea88a9e66959$export$2e2bcd8739ae039)(node));
}





function $cdb08bfff971b5cf$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2e22222a2ba2a9f2$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $8b070ce9abd1e027$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($cdb08bfff971b5cf$export$2e2bcd8739ae039((0, $e864ea88a9e66959$export$2e2bcd8739ae039)(target)));
}







function $b8f017f769abf113$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $4e2b39ec97f5ef92$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3785e6a94690ee33$var$getTrueOffsetParent(element) {
    if (!(0, $498c51d7f7ea2b21$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $8c69db192cac5f6d$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3785e6a94690ee33$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $1fae9e116c09b3a4$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $1fae9e116c09b3a4$export$2e2bcd8739ae039)());
    if (isIE && (0, $498c51d7f7ea2b21$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $8c69db192cac5f6d$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $e864ea88a9e66959$export$2e2bcd8739ae039)(element);
    if ((0, $498c51d7f7ea2b21$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $498c51d7f7ea2b21$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $4e2b39ec97f5ef92$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $8c69db192cac5f6d$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3785e6a94690ee33$export$2e2bcd8739ae039(element) {
    var window = (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(element);
    var offsetParent = $3785e6a94690ee33$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $b8f017f769abf113$export$2e2bcd8739ae039)(offsetParent) && (0, $8c69db192cac5f6d$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $3785e6a94690ee33$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4e2b39ec97f5ef92$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $4e2b39ec97f5ef92$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $8c69db192cac5f6d$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $3785e6a94690ee33$var$getContainingBlock(element) || window;
}


var $8ede325fedf51993$export$1e95b668f3b82d = "top";
var $8ede325fedf51993$export$40e543e69a8b3fbb = "bottom";
var $8ede325fedf51993$export$79ffe56a765070d2 = "right";
var $8ede325fedf51993$export$eabcd2c8791e7bf4 = "left";
var $8ede325fedf51993$export$dfb5619354ba860 = "auto";
var $8ede325fedf51993$export$aec2ce47c367b8c3 = [
    $8ede325fedf51993$export$1e95b668f3b82d,
    $8ede325fedf51993$export$40e543e69a8b3fbb,
    $8ede325fedf51993$export$79ffe56a765070d2,
    $8ede325fedf51993$export$eabcd2c8791e7bf4
];
var $8ede325fedf51993$export$b3571188c770cc5a = "start";
var $8ede325fedf51993$export$bd5df0f255a350f8 = "end";
var $8ede325fedf51993$export$390fd549c5303b4d = "clippingParents";
var $8ede325fedf51993$export$d7b7311ec04a3e8f = "viewport";
var $8ede325fedf51993$export$ae5ab1c730825774 = "popper";
var $8ede325fedf51993$export$ca50aac9f3ba507f = "reference";
var $8ede325fedf51993$export$368f9a87e87fa4e1 = /*#__PURE__*/ $8ede325fedf51993$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $8ede325fedf51993$export$b3571188c770cc5a,
        placement + "-" + $8ede325fedf51993$export$bd5df0f255a350f8
    ]);
}, []);
var $8ede325fedf51993$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($8ede325fedf51993$export$aec2ce47c367b8c3, [
    $8ede325fedf51993$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $8ede325fedf51993$export$b3571188c770cc5a,
        placement + "-" + $8ede325fedf51993$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $8ede325fedf51993$export$421679a7c3d56e = "beforeRead";
var $8ede325fedf51993$export$aafa59e2e03f2942 = "read";
var $8ede325fedf51993$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $8ede325fedf51993$export$c65e99957a05207c = "beforeMain";
var $8ede325fedf51993$export$f22da7240b7add18 = "main";
var $8ede325fedf51993$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $8ede325fedf51993$export$8d4d2d70e7d46032 = "beforeWrite";
var $8ede325fedf51993$export$68d8715fc104d294 = "write";
var $8ede325fedf51993$export$70a6e5159acce2e6 = "afterWrite";
var $8ede325fedf51993$export$d087d3878fdf71d5 = [
    $8ede325fedf51993$export$421679a7c3d56e,
    $8ede325fedf51993$export$aafa59e2e03f2942,
    $8ede325fedf51993$export$6964f6c886723980,
    $8ede325fedf51993$export$c65e99957a05207c,
    $8ede325fedf51993$export$f22da7240b7add18,
    $8ede325fedf51993$export$bab79516f2d662fe,
    $8ede325fedf51993$export$8d4d2d70e7d46032,
    $8ede325fedf51993$export$68d8715fc104d294,
    $8ede325fedf51993$export$70a6e5159acce2e6
];


function $bff35c3c9a233cb7$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $bff35c3c9a233cb7$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $bff35c3c9a233cb7$var$order(modifiers); // order based on phase
    return (0, $8ede325fedf51993$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $12dfbf5a21c273ed$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f13654e334c09fc6$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $3b25fc927e18aba2$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $3b25fc927e18aba2$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $3b25fc927e18aba2$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $3b25fc927e18aba2$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $3b25fc927e18aba2$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $498c51d7f7ea2b21$export$45a5e7f76e0caa8d)(reference) ? (0, $cdb08bfff971b5cf$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $cdb08bfff971b5cf$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $cdb08bfff971b5cf$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $bff35c3c9a233cb7$export$2e2bcd8739ae039)((0, $f13654e334c09fc6$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$3b25fc927e18aba2$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $9ed726cdcd0ed7c0$export$2e2bcd8739ae039)(reference, (0, $3785e6a94690ee33$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $70be0fdf2c663575$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $12dfbf5a21c273ed$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$3b25fc927e18aba2$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $3b25fc927e18aba2$export$8f7491d57c8f97a9 = /*#__PURE__*/ $3b25fc927e18aba2$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $81db9a6cc07cdaba$var$passive = {
    passive: true
};
function $81db9a6cc07cdaba$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $81db9a6cc07cdaba$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $81db9a6cc07cdaba$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $81db9a6cc07cdaba$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $81db9a6cc07cdaba$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $81db9a6cc07cdaba$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $81db9a6cc07cdaba$var$effect,
    data: {}
};



function $e2ba7d07a9ebf8fb$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $7dfdedea0686afcd$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $5c2170814ee4e663$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $716085711f9d5a54$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $e2ba7d07a9ebf8fb$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $7dfdedea0686afcd$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $8ede325fedf51993$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $8ede325fedf51993$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $8ede325fedf51993$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $8ede325fedf51993$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $5c2170814ee4e663$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $8ede325fedf51993$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $8ede325fedf51993$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $bb32904074905bdb$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $716085711f9d5a54$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $bb32904074905bdb$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $bb32904074905bdb$var$popperOffsets,
    data: {}
};










var $e631fd2caeca0292$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $e631fd2caeca0292$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $6248a9a5e5635fa4$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $6248a9a5e5635fa4$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $e631fd2caeca0292$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $8ede325fedf51993$export$eabcd2c8791e7bf4);
    var sideY = (0, $8ede325fedf51993$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3785e6a94690ee33$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $394718861fdee8d4$export$2e2bcd8739ae039)(popper);
            if ((0, $8c69db192cac5f6d$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $8ede325fedf51993$export$1e95b668f3b82d) || (placement === (0, $8ede325fedf51993$export$eabcd2c8791e7bf4) || placement === (0, $8ede325fedf51993$export$79ffe56a765070d2)) && variation === (0, $8ede325fedf51993$export$bd5df0f255a350f8)) {
            sideY = (0, $8ede325fedf51993$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $8ede325fedf51993$export$eabcd2c8791e7bf4) || (placement === (0, $8ede325fedf51993$export$1e95b668f3b82d) || placement === (0, $8ede325fedf51993$export$40e543e69a8b3fbb)) && variation === (0, $8ede325fedf51993$export$bd5df0f255a350f8)) {
            sideX = (0, $8ede325fedf51993$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $e631fd2caeca0292$var$unsetSides);
    var _ref4 = roundOffsets === true ? $e631fd2caeca0292$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $e631fd2caeca0292$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $e2ba7d07a9ebf8fb$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $7dfdedea0686afcd$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $e631fd2caeca0292$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $e631fd2caeca0292$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e631fd2caeca0292$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $e631fd2caeca0292$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $c0c9971b0854b877$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $498c51d7f7ea2b21$export$1b3bfaa9684536aa)(element) || !(0, $4e2b39ec97f5ef92$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $c0c9971b0854b877$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $498c51d7f7ea2b21$export$1b3bfaa9684536aa)(element) || !(0, $4e2b39ec97f5ef92$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $c0c9971b0854b877$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $c0c9971b0854b877$var$applyStyles,
    effect: $c0c9971b0854b877$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $d200f773e574ba44$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $e2ba7d07a9ebf8fb$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $8ede325fedf51993$export$eabcd2c8791e7bf4),
        (0, $8ede325fedf51993$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $8ede325fedf51993$export$eabcd2c8791e7bf4),
        (0, $8ede325fedf51993$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $d200f773e574ba44$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $8ede325fedf51993$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $d200f773e574ba44$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d200f773e574ba44$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $d200f773e574ba44$var$offset
};


var $f876e2a202ce1ea3$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $f876e2a202ce1ea3$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $f876e2a202ce1ea3$var$hash[matched];
    });
}



var $1d4c4aff7ae6d1ae$var$hash = {
    start: "end",
    end: "start"
};
function $1d4c4aff7ae6d1ae$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $1d4c4aff7ae6d1ae$var$hash[matched];
    });
}







function $18be72db58b279bf$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6bc18bf1cdd0ce7d$export$2e2bcd8739ae039)(element);
    var html = (0, $394718861fdee8d4$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $3c8c527a52bfe157$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $1a9f2a3d2457ee19$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $298a77c266cd6d1f$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $394718861fdee8d4$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $1fc591420ee01a1d$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $6248a9a5e5635fa4$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $6248a9a5e5635fa4$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $1a9f2a3d2457ee19$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $8c69db192cac5f6d$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $6248a9a5e5635fa4$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $51cc713416d05012$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $498c51d7f7ea2b21$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $585c19a59089b0a6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $2fbea7c90580fb24$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bf515e7930a738c8$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $2fbea7c90580fb24$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $8ede325fedf51993$export$d7b7311ec04a3e8f) ? (0, $585c19a59089b0a6$export$2e2bcd8739ae039)((0, $18be72db58b279bf$export$2e2bcd8739ae039)(element, strategy)) : (0, $498c51d7f7ea2b21$export$45a5e7f76e0caa8d)(clippingParent) ? $2fbea7c90580fb24$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $585c19a59089b0a6$export$2e2bcd8739ae039)((0, $298a77c266cd6d1f$export$2e2bcd8739ae039)((0, $394718861fdee8d4$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $2fbea7c90580fb24$var$getClippingParents(element) {
    var clippingParents = (0, $cdb08bfff971b5cf$export$2e2bcd8739ae039)((0, $e864ea88a9e66959$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $8c69db192cac5f6d$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $498c51d7f7ea2b21$export$1b3bfaa9684536aa)(element) ? (0, $3785e6a94690ee33$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $498c51d7f7ea2b21$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $498c51d7f7ea2b21$export$45a5e7f76e0caa8d)(clippingParent) && (0, $51cc713416d05012$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4e2b39ec97f5ef92$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $2fbea7c90580fb24$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $2fbea7c90580fb24$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $2fbea7c90580fb24$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $6248a9a5e5635fa4$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $6248a9a5e5635fa4$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $6248a9a5e5635fa4$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $6248a9a5e5635fa4$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $2fbea7c90580fb24$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $258116157c6a1996$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $e260d3b12b1f8587$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $258116157c6a1996$export$2e2bcd8739ae039)(), paddingObject);
}


function $c3d0b8a18a42c656$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $a6122750fd89b7cf$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $8ede325fedf51993$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $8ede325fedf51993$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $8ede325fedf51993$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $e260d3b12b1f8587$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c3d0b8a18a42c656$export$2e2bcd8739ae039)(padding, (0, $8ede325fedf51993$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $8ede325fedf51993$export$ae5ab1c730825774) ? (0, $8ede325fedf51993$export$ca50aac9f3ba507f) : (0, $8ede325fedf51993$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $2fbea7c90580fb24$export$2e2bcd8739ae039)((0, $498c51d7f7ea2b21$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $394718861fdee8d4$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bf515e7930a738c8$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $716085711f9d5a54$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $585c19a59089b0a6$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $8ede325fedf51993$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $8ede325fedf51993$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $8ede325fedf51993$export$79ffe56a765070d2),
                (0, $8ede325fedf51993$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $8ede325fedf51993$export$1e95b668f3b82d),
                (0, $8ede325fedf51993$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $824f06cac932b54f$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $8ede325fedf51993$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $7dfdedea0686afcd$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $8ede325fedf51993$export$368f9a87e87fa4e1) : (0, $8ede325fedf51993$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $7dfdedea0686afcd$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $8ede325fedf51993$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $a6122750fd89b7cf$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $e2ba7d07a9ebf8fb$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $f917f730df97b31b$var$getExpandedFallbackPlacements(placement) {
    if ((0, $e2ba7d07a9ebf8fb$export$2e2bcd8739ae039)(placement) === (0, $8ede325fedf51993$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $f876e2a202ce1ea3$export$2e2bcd8739ae039)(placement);
    return [
        (0, $1d4c4aff7ae6d1ae$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $1d4c4aff7ae6d1ae$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $f917f730df97b31b$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $e2ba7d07a9ebf8fb$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $f876e2a202ce1ea3$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $f917f730df97b31b$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $e2ba7d07a9ebf8fb$export$2e2bcd8739ae039)(placement) === (0, $8ede325fedf51993$export$dfb5619354ba860) ? (0, $824f06cac932b54f$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $e2ba7d07a9ebf8fb$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $7dfdedea0686afcd$export$2e2bcd8739ae039)(placement) === (0, $8ede325fedf51993$export$b3571188c770cc5a);
        var isVertical = [
            (0, $8ede325fedf51993$export$1e95b668f3b82d),
            (0, $8ede325fedf51993$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $a6122750fd89b7cf$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $8ede325fedf51993$export$79ffe56a765070d2) : (0, $8ede325fedf51993$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $8ede325fedf51993$export$40e543e69a8b3fbb) : (0, $8ede325fedf51993$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $f876e2a202ce1ea3$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $f876e2a202ce1ea3$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $f917f730df97b31b$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $f917f730df97b31b$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $aaf0c065aa3252ba$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $4d869606e6b13e23$export$f28d906d67a997f3(min, value, max) {
    return (0, $6248a9a5e5635fa4$export$8960430cfd85939f)(min, (0, $6248a9a5e5635fa4$export$96ec731ed4dcb222)(value, max));
}
function $4d869606e6b13e23$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4d869606e6b13e23$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $fa9b90168a541685$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $a6122750fd89b7cf$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $e2ba7d07a9ebf8fb$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $7dfdedea0686afcd$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $5c2170814ee4e663$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $aaf0c065aa3252ba$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $8ede325fedf51993$export$1e95b668f3b82d) : (0, $8ede325fedf51993$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $8ede325fedf51993$export$40e543e69a8b3fbb) : (0, $8ede325fedf51993$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $8ede325fedf51993$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $8ede325fedf51993$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $70be0fdf2c663575$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $258116157c6a1996$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4d869606e6b13e23$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3785e6a94690ee33$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4d869606e6b13e23$export$f28d906d67a997f3)(tether ? (0, $6248a9a5e5635fa4$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $6248a9a5e5635fa4$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $8ede325fedf51993$export$1e95b668f3b82d) : (0, $8ede325fedf51993$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $8ede325fedf51993$export$40e543e69a8b3fbb) : (0, $8ede325fedf51993$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $8ede325fedf51993$export$1e95b668f3b82d),
            (0, $8ede325fedf51993$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4d869606e6b13e23$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $4d869606e6b13e23$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $fa9b90168a541685$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $fa9b90168a541685$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $042f35bc9a90deaf$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $e260d3b12b1f8587$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c3d0b8a18a42c656$export$2e2bcd8739ae039)(padding, (0, $8ede325fedf51993$export$aec2ce47c367b8c3)));
};
function $042f35bc9a90deaf$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $e2ba7d07a9ebf8fb$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $5c2170814ee4e663$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $8ede325fedf51993$export$eabcd2c8791e7bf4),
        (0, $8ede325fedf51993$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $042f35bc9a90deaf$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $70be0fdf2c663575$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $8ede325fedf51993$export$1e95b668f3b82d) : (0, $8ede325fedf51993$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $8ede325fedf51993$export$40e543e69a8b3fbb) : (0, $8ede325fedf51993$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3785e6a94690ee33$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4d869606e6b13e23$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $042f35bc9a90deaf$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $51cc713416d05012$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $042f35bc9a90deaf$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $042f35bc9a90deaf$var$arrow,
    effect: $042f35bc9a90deaf$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $7da2e81be49eb5f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7da2e81be49eb5f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $8ede325fedf51993$export$1e95b668f3b82d),
        (0, $8ede325fedf51993$export$79ffe56a765070d2),
        (0, $8ede325fedf51993$export$40e543e69a8b3fbb),
        (0, $8ede325fedf51993$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7da2e81be49eb5f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $a6122750fd89b7cf$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $a6122750fd89b7cf$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7da2e81be49eb5f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7da2e81be49eb5f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7da2e81be49eb5f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7da2e81be49eb5f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7da2e81be49eb5f3$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $7da2e81be49eb5f3$var$hide
};




var $a2bb3a214962277f$export$d34966752335dd47 = [
    (0, $81db9a6cc07cdaba$export$2e2bcd8739ae039),
    (0, $bb32904074905bdb$export$2e2bcd8739ae039),
    (0, $e631fd2caeca0292$export$2e2bcd8739ae039),
    (0, $c0c9971b0854b877$export$2e2bcd8739ae039),
    (0, $d200f773e574ba44$export$2e2bcd8739ae039),
    (0, $f917f730df97b31b$export$2e2bcd8739ae039),
    (0, $fa9b90168a541685$export$2e2bcd8739ae039),
    (0, $042f35bc9a90deaf$export$2e2bcd8739ae039),
    (0, $7da2e81be49eb5f3$export$2e2bcd8739ae039)
];
var $a2bb3a214962277f$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $3b25fc927e18aba2$export$ed5e13716264f202)({
    defaultModifiers: $a2bb3a214962277f$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules





var $hEVyQ = parcelRequire("hEVyQ");




function $ded59086793e2f08$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base/react-portal/components-api/#portal)
 */ const $ded59086793e2f08$var$Portal = /*#__PURE__*/ $hEVyQ.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $hEVyQ.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $e81b6b5071071d38$export$2e2bcd8739ae039)(/*#__PURE__*/ $hEVyQ.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $61eddb5b42e38ae3$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($ded59086793e2f08$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $61eddb5b42e38ae3$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $0019f7c6881c2f5e$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $0019f7c6881c2f5e$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $hEVyQ.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $hEVyQ.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($hEVyQ.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($hEVyQ.Fragment, {
        children: mountNode ? /*#__PURE__*/ $b4bc5509af1b9d3e$exports.createPortal(children, mountNode) : mountNode
    });
});
var $ded59086793e2f08$export$2e2bcd8739ae039 = $ded59086793e2f08$var$Portal;




function $0f73642681846ac0$export$1b69b6cd0fa638a1(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiPopper", slot);
}
const $0f73642681846ac0$var$popperClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiPopper", [
    "root"
]);
var $0f73642681846ac0$export$2e2bcd8739ae039 = $0f73642681846ac0$var$popperClasses;








/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $77c45ae8ca22598d$export$2e2bcd8739ae039(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $38e49c0d25aa48af$export$2e2bcd8739ae039(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $b7b832241cf4cf2d$export$2e2bcd8739ae039(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $77c45ae8ca22598d$export$2e2bcd8739ae039)((0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $38e49c0d25aa48af$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $38e49c0d25aa48af$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $017e18918f8f9401$export$2e2bcd8739ae039(componentProps, ownerState) {
    if (typeof componentProps === "function") return componentProps(ownerState);
    return componentProps;
}


const $5349abac08f60531$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState"
];
function $5349abac08f60531$export$2e2bcd8739ae039(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState } = parameters, rest = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(parameters, $5349abac08f60531$var$_excluded);
    const resolvedComponentsProps = (0, $017e18918f8f9401$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $b7b832241cf4cf2d$export$2e2bcd8739ae039)((0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $e81b6b5071071d38$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $38c5ab0f0c310902$export$2e2bcd8739ae039)(elementType, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $hEVyQ = parcelRequire("hEVyQ");

const $fbd11cce7bafc9ab$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $fbd11cce7bafc9ab$var$ClassNameConfiguratorContext = /*#__PURE__*/ $hEVyQ.createContext($fbd11cce7bafc9ab$var$defaultContextValue);
function $fbd11cce7bafc9ab$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $hEVyQ.useContext($fbd11cce7bafc9ab$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $fbd11cce7bafc9ab$export$2e2bcd8739ae039(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $hEVyQ.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($fbd11cce7bafc9ab$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



const $bf5253bf0d2f39c5$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $bf5253bf0d2f39c5$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $bf5253bf0d2f39c5$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $bf5253bf0d2f39c5$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $bf5253bf0d2f39c5$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $bf5253bf0d2f39c5$var$isVirtualElement(element) {
    return !$bf5253bf0d2f39c5$var$isHTMLElement(element);
}
const $bf5253bf0d2f39c5$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $fbd11cce7bafc9ab$export$b0f7603cd2f9ee15)((0, $0f73642681846ac0$export$1b69b6cd0fa638a1)));
};
const $bf5253bf0d2f39c5$var$defaultPopperOptions = {};
const $bf5253bf0d2f39c5$var$PopperTooltip = /*#__PURE__*/ $hEVyQ.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $bf5253bf0d2f39c5$var$_excluded);
    const tooltipRef = $hEVyQ.useRef(null);
    const ownRef = (0, $e81b6b5071071d38$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $hEVyQ.useRef(null);
    const handlePopperRef = (0, $e81b6b5071071d38$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $hEVyQ.useRef(handlePopperRef);
    (0, $61eddb5b42e38ae3$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $hEVyQ.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $bf5253bf0d2f39c5$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $hEVyQ.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $hEVyQ.useState($bf5253bf0d2f39c5$var$resolveAnchorEl(anchorEl));
    $hEVyQ.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $hEVyQ.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($bf5253bf0d2f39c5$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $61eddb5b42e38ae3$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $a2bb3a214962277f$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $bf5253bf0d2f39c5$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $5349abac08f60531$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)(Root, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base/react-popper/components-api/#popper)
 */ const $bf5253bf0d2f39c5$var$Popper = /*#__PURE__*/ $hEVyQ.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $bf5253bf0d2f39c5$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $bf5253bf0d2f39c5$var$_excluded2);
    const [exited, setExited] = $hEVyQ.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $bf5253bf0d2f39c5$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $bf5253bf0d2f39c5$var$isHTMLElement(resolvedAnchorEl) ? (0, $9c0df9755538240d$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $9c0df9755538240d$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $ded59086793e2f08$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($bf5253bf0d2f39c5$var$PopperTooltip, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $bf5253bf0d2f39c5$export$2e2bcd8739ae039 = $bf5253bf0d2f39c5$var$Popper;






var $hEVyQ = parcelRequire("hEVyQ");


const $dce3646f1a5bc842$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $dce3646f1a5bc842$var$PopperRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)((0, $bf5253bf0d2f39c5$export$2e2bcd8739ae039), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $dce3646f1a5bc842$var$Popper = /*#__PURE__*/ $hEVyQ.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $980399c30f268020$export$2e2bcd8739ae039)();
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $dce3646f1a5bc842$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($dce3646f1a5bc842$var$PopperRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $dce3646f1a5bc842$export$2e2bcd8739ae039 = $dce3646f1a5bc842$var$Popper;





var $hEVyQ = parcelRequire("hEVyQ");
let $3cfe2edc2babac3a$var$globalId = 0;
function $3cfe2edc2babac3a$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $hEVyQ.useState(idOverride);
    const id = idOverride || defaultId;
    $hEVyQ.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $3cfe2edc2babac3a$var$globalId += 1;
            setDefaultId(`mui-${$3cfe2edc2babac3a$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $3cfe2edc2babac3a$var$maybeReactUseId = $hEVyQ["useId".toString()];
function $3cfe2edc2babac3a$export$2e2bcd8739ae039(idOverride) {
    if ($3cfe2edc2babac3a$var$maybeReactUseId !== undefined) {
        const reactId = $3cfe2edc2babac3a$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $3cfe2edc2babac3a$var$useGlobalId(idOverride);
}


var $a38a3db6cb350898$export$2e2bcd8739ae039 = (0, $3cfe2edc2babac3a$export$2e2bcd8739ae039);






function $229e32a4fa1bb643$export$837848f5f6cee923(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiTooltip", slot);
}
const $229e32a4fa1bb643$var$tooltipClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $229e32a4fa1bb643$export$2e2bcd8739ae039 = $229e32a4fa1bb643$var$tooltipClasses;



const $b9e0e95da8778dd4$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $b9e0e95da8778dd4$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $b9e0e95da8778dd4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $229e32a4fa1bb643$export$837848f5f6cee923), classes);
};
const $b9e0e95da8778dd4$var$TooltipPopper = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)((0, $dce3646f1a5bc842$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $229e32a4fa1bb643$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $229e32a4fa1bb643$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $229e32a4fa1bb643$export$2e2bcd8739ae039).arrow}`]: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $229e32a4fa1bb643$export$2e2bcd8739ae039).arrow}`]: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $b9e0e95da8778dd4$var$TooltipTooltip = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $dbd72f49419aab0a$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$b9e0e95da8778dd4$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $229e32a4fa1bb643$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $229e32a4fa1bb643$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $229e32a4fa1bb643$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $229e32a4fa1bb643$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $b9e0e95da8778dd4$var$TooltipArrow = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $dbd72f49419aab0a$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $b9e0e95da8778dd4$var$hystersisOpen = false;
let $b9e0e95da8778dd4$var$hystersisTimer = null;
let $b9e0e95da8778dd4$var$cursorPosition = {
    x: 0,
    y: 0
};
function $b9e0e95da8778dd4$export$b9ee5a7ace0541f8() {
    $b9e0e95da8778dd4$var$hystersisOpen = false;
    clearTimeout($b9e0e95da8778dd4$var$hystersisTimer);
}
function $b9e0e95da8778dd4$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $b9e0e95da8778dd4$var$Tooltip = /*#__PURE__*/ $hEVyQ.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: children, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $6eec8cc105391dd4$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $b9e0e95da8778dd4$var$_excluded);
    const theme = (0, $8251d502ea5b484c$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $hEVyQ.useState();
    const [arrowRef, setArrowRef] = $hEVyQ.useState(null);
    const ignoreNonTouchEvents = $hEVyQ.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = $hEVyQ.useRef();
    const enterTimer = $hEVyQ.useRef();
    const leaveTimer = $hEVyQ.useRef();
    const touchTimer = $hEVyQ.useRef();
    const [openState, setOpenState] = (0, $0feb9b02456bcdb9$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $a38a3db6cb350898$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $hEVyQ.useRef();
    const stopTouchInteraction = $hEVyQ.useCallback(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        clearTimeout(touchTimer.current);
    }, []);
    $hEVyQ.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            stopTouchInteraction();
        };
    }, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        clearTimeout($b9e0e95da8778dd4$var$hystersisTimer);
        $b9e0e95da8778dd4$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $ce5ab4ef9d0fb403$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        clearTimeout($b9e0e95da8778dd4$var$hystersisTimer);
        $b9e0e95da8778dd4$var$hystersisTimer = setTimeout(()=>{
            $b9e0e95da8778dd4$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose && open) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>{
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        if (enterDelay || $b9e0e95da8778dd4$var$hystersisOpen && enterNextDelay) enterTimer.current = setTimeout(()=>{
            handleOpen(event);
        }, $b9e0e95da8778dd4$var$hystersisOpen ? enterNextDelay : enterDelay);
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveDelay);
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $ddefa92cf2d002cd$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $hEVyQ.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.current = setTimeout(()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        }, enterTouchDelay);
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveTouchDelay);
    };
    $hEVyQ.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $4905b1fe0147563b$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const popperRef = $hEVyQ.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $b9e0e95da8778dd4$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, nameOrDescProps, other, children.props, {
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $b9e0e95da8778dd4$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $b9e0e95da8778dd4$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $b9e0e95da8778dd4$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $b9e0e95da8778dd4$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $hEVyQ.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $b9e0e95da8778dd4$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $b9e0e95da8778dd4$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $6eec8cc105391dd4$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $b9e0e95da8778dd4$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $b9e0e95da8778dd4$var$TooltipArrow;
    const popperProps = (0, $38c5ab0f0c310902$export$2e2bcd8739ae039)(PopperComponent, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $38c5ab0f0c310902$export$2e2bcd8739ae039)(TransitionComponent, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $38c5ab0f0c310902$export$2e2bcd8739ae039)(TooltipComponent, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $38c5ab0f0c310902$export$2e2bcd8739ae039)(ArrowComponent, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)($hEVyQ.Fragment, {
        children: [
            /*#__PURE__*/ $hEVyQ.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)(PopperComponent, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $dce3646f1a5bc842$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $b9e0e95da8778dd4$var$cursorPosition.y,
                            left: $b9e0e95da8778dd4$var$cursorPosition.x,
                            right: $b9e0e95da8778dd4$var$cursorPosition.x,
                            bottom: $b9e0e95da8778dd4$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)(TransitionComponent, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)(TooltipComponent, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)(ArrowComponent, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $b9e0e95da8778dd4$export$2e2bcd8739ae039 = $b9e0e95da8778dd4$var$Tooltip;




var $21124b1a61270646$export$2e2bcd8739ae039 = (0, $68f272343dd416b4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("path", {
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67 2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), "SaveAlt");


const $42efde2d1d9827db$var$fabStyle = {
    position: "fixed",
    bottom: 16,
    right: 16
};
const $42efde2d1d9827db$var$Exporter = ({ pdfs: pdfs, pages: pages, config: config })=>{
    const [exported, setExported] = (0, $hEVyQ.useState)(null);
    (0, $hEVyQ.useEffect)(()=>{
        if (exported) URL.revokeObjectURL(exported.url);
        save();
    }, [
        pdfs,
        pages,
        config
    ]);
    async function save() {
        const { doc: doc, fileName: fileName, size: size } = await (0, $74dcec03938f78d8$export$d80f93a7e52cdefb)(pdfs, pages, config);
        const barray = await doc.save();
        const url = URL.createObjectURL(new Blob([
            barray
        ], {
            type: "application/pdf"
        }));
        const output = {
            url: url,
            fileName: fileName,
            pages: doc.getPages().length,
            size: size
        };
        setExported(output);
        return output;
    }
    function download(output) {
        const downloadLink = document.createElement("a");
        downloadLink.href = output.url;
        var result = prompt("\u30D5\u30A1\u30A4\u30EB\u540D\u3092\u6307\u5B9A\u3057\u3066\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9", (0, $d4bf4bbe2f3ac1b4$export$befaf6bce9e08d55)(output.fileName));
        if (!result) return;
        downloadLink.download = result + ".pdf";
        downloadLink.click();
    }
    const priceBefore = pages.length * (0, $da5f9092355a8063$export$42c58ba01fdcd19c)[(0, $da5f9092355a8063$export$cb6da89c6af1a8ec).A4];
    const priceAfter = exported ? (0, $da5f9092355a8063$export$42c58ba01fdcd19c)[exported.size] * exported.pages : NaN;
    return exported ? /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)((0, $7d421eaa7dee1123$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $b9e0e95da8778dd4$export$2e2bcd8739ae039), {
                title: "PDF\u3092\u4FDD\u5B58",
                sx: $42efde2d1d9827db$var$fabStyle,
                children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $de771ae912d0ac67$export$2e2bcd8739ae039), {
                    color: "primary",
                    "aria-label": "add",
                    size: "large",
                    onClick: async ()=>download(exported),
                    children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $21124b1a61270646$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $21f9df141609ba2e$export$2e2bcd8739ae039), {
                variant: "contained",
                color: "primary",
                startIcon: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $21124b1a61270646$export$2e2bcd8739ae039), {}),
                onClick: async ()=>download(exported),
                children: "PDF\u3092\u4FDD\u5B58"
            }),
            "\u6982\u7B97\uFF1A",
            priceBefore,
            "\u5186 \u2192 ",
            isNaN(priceAfter) ? "?" : /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)("b", {
                children: [
                    priceAfter,
                    "\u5186 ",
                    $42efde2d1d9827db$var$displayDiscount(priceBefore, priceAfter),
                    "\uD83C\uDF89"
                ]
            }),
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $8ebda0951e5ad6dc$export$2e2bcd8739ae039), {
                url: exported.url
            })
        ]
    }) : /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("div", {
        style: {
            display: "inline-block",
            width: "100%",
            aspectRatio: "1/1.41",
            maxHeight: "100vh"
        }
    });
};
var $42efde2d1d9827db$export$2e2bcd8739ae039 = $42efde2d1d9827db$var$Exporter;
function $42efde2d1d9827db$var$displayDiscount(priceBefore, priceAfter) {
    const discount = priceBefore - priceAfter;
    const discountRate = discount / priceBefore * 100;
    if (discountRate > 20) return `\u{7D04}${(discountRate / 10).toFixed(0)}\u{5272}\u{5F15}`;
    return `\u{7D04}${discountRate.toFixed(0)}%\u{5F15}`;
}




var $hEVyQ = parcelRequire("hEVyQ");



var $c221795dffb31a20$export$2e2bcd8739ae039 = (0, $68f272343dd416b4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
}), "AddCircle");





var $hEVyQ = parcelRequire("hEVyQ");






const $de8361469344ae5e$var$_excluded = [
    "sx"
];
const $de8361469344ae5e$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $104cc514cb62d3a2$export$2e2bcd8739ae039);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $de8361469344ae5e$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $de8361469344ae5e$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $de8361469344ae5e$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $c041f5f3d1fce1ef$export$53b83ca8eaab0383)(result)) return systemProps;
        return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, systemProps, result);
    };
    else finalSx = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, systemProps, inSx);
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, otherProps, {
        sx: finalSx
    });
}




const $b38c0cd43352c92f$var$_excluded = [
    "className",
    "component"
];
function $b38c0cd43352c92f$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $8b67f114cb8f4e1d$export$2e2bcd8739ae039)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $e8cd13de62f033e2$export$2e2bcd8739ae039));
    const Box = /*#__PURE__*/ $hEVyQ.forwardRef(function Box(inProps, ref) {
        const theme = (0, $adb2b7c4d20eb565$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $de8361469344ae5e$export$2e2bcd8739ae039)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(_extendSxProp, $b38c0cd43352c92f$var$_excluded);
        return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)(BoxRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            as: component,
            ref: ref,
            className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}






const $55e42bd2fd1a305e$var$defaultTheme = (0, $ea1da536acea9340$export$2e2bcd8739ae039)();
const $55e42bd2fd1a305e$var$Box = (0, $b38c0cd43352c92f$export$2e2bcd8739ae039)({
    themeId: (0, $7586e29635f86062$export$2e2bcd8739ae039),
    defaultTheme: $55e42bd2fd1a305e$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $01568f097002593e$export$2e2bcd8739ae039).generate
});
var $55e42bd2fd1a305e$export$2e2bcd8739ae039 = $55e42bd2fd1a305e$var$Box;




const $8c8fa781ccebdb1b$var$PdfLoader = ({ addPdfs: addPdfs, more: more })=>{
    const [loading, setLoading] = (0, $hEVyQ.useState)(false);
    async function filesHandler(files) {
        const { getDocument: getDocument, GlobalWorkerOptions: GlobalWorkerOptions } = await (parcelRequire("bz579"));
        GlobalWorkerOptions.workerSrc = await (parcelRequire("2cOpH"));
        const documents = await Promise.all(files.map(async (file)=>{
            const ab = await file.arrayBuffer();
            return await getDocument({
                data: ab
            }).promise;
        }));
        addPdfs(documents.map((doc, i)=>({
                file: files[i],
                pdfJsDoc: doc,
                fileName: files[i].name
            })));
    }
    (0, $hEVyQ.useEffect)(()=>{
        [
            "dragenter",
            "dragover",
            "dragleave",
            "drop"
        ].forEach((eventName)=>{
            document.addEventListener(eventName, preventDefaults, false);
        });
        function preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        }
        document.addEventListener("drop", dropHandler);
        async function dropHandler(ev) {
            ev.preventDefault();
            if (loading) {
                alert("\u30D5\u30A1\u30A4\u30EB\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u65B0\u305F\u306A\u30D5\u30A1\u30A4\u30EB\u306E\u8FFD\u52A0\u306F\u3067\u304D\u307E\u305B\u3093");
                return;
            }
            setLoading(true);
            try {
                const openedFiles = (0, $d4bf4bbe2f3ac1b4$export$f5544efc2684376b)(ev.dataTransfer);
                await filesHandler(openedFiles);
                setLoading(false);
            } catch (e) {
                console.error(e);
                setLoading(false);
            }
        }
        return ()=>{
            [
                "dragenter",
                "dragover",
                "dragleave",
                "drop"
            ].forEach((eventName)=>{
                document.removeEventListener(eventName, preventDefaults, false);
            });
            document.removeEventListener("drop", dropHandler);
        };
    }, [
        addPdfs
    ]);
    // TODO: Add a button to open a file dialog
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)((0, $55e42bd2fd1a305e$export$2e2bcd8739ae039), {
        as: "label",
        color: "primary",
        sx: {
            width: "100%",
            minHeight: more ? "100px" : "300px",
            border: "5px red dashed",
            borderRadius: "15px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "40px",
            boxSizing: "border-box",
            margin: "8px 0",
            padding: "16px"
        },
        children: [
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $c221795dffb31a20$export$2e2bcd8739ae039), {
                color: "primary",
                fontSize: "large"
            }),
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("input", {
                id: "file",
                type: "file",
                name: "file",
                style: {
                    display: "none"
                },
                onChange: (e)=>{
                    if (!e.target.files) return;
                    filesHandler(Array.from(e.target.files));
                }
            }),
            more ? "PDF\u3092\u3055\u3089\u306B\u8FFD\u52A0" : "PDF\u3092\u30C9\u30ED\u30C3\u30D7"
        ]
    });
};
var $8c8fa781ccebdb1b$export$2e2bcd8739ae039 = $8c8fa781ccebdb1b$var$PdfLoader;





var $hEVyQ = parcelRequire("hEVyQ");








var $hEVyQ = parcelRequire("hEVyQ");









function $04d59f5836ee09e9$export$24c1f8f60cbac79e(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiTypography", slot);
}
const $04d59f5836ee09e9$var$typographyClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $04d59f5836ee09e9$export$2e2bcd8739ae039 = $04d59f5836ee09e9$var$typographyClasses;



const $de7c7e4ec7447f0a$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $de7c7e4ec7447f0a$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $04d59f5836ee09e9$export$24c1f8f60cbac79e), classes);
};
const $de7c7e4ec7447f0a$export$140e2f5526d3cad8 = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        margin: 0
    }, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $de7c7e4ec7447f0a$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $de7c7e4ec7447f0a$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $de7c7e4ec7447f0a$var$transformDeprecatedColors = (color)=>{
    return $de7c7e4ec7447f0a$var$colorTransformations[color] || color;
};
const $de7c7e4ec7447f0a$var$Typography = /*#__PURE__*/ $hEVyQ.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $de7c7e4ec7447f0a$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $de8361469344ae5e$export$2e2bcd8739ae039)((0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $de7c7e4ec7447f0a$var$defaultVariantMapping } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $de7c7e4ec7447f0a$var$_excluded);
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $de7c7e4ec7447f0a$var$defaultVariantMapping[variant]) || "span";
    const classes = $de7c7e4ec7447f0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($de7c7e4ec7447f0a$export$140e2f5526d3cad8, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className)
    }, other));
});
var $de7c7e4ec7447f0a$export$2e2bcd8739ae039 = $de7c7e4ec7447f0a$var$Typography;







function $99a583d325054f9b$export$717666c39ec07e12(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiFormControlLabel", slot);
}
const $99a583d325054f9b$var$formControlLabelClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $99a583d325054f9b$export$2e2bcd8739ae039 = $99a583d325054f9b$var$formControlLabelClasses;


function $df87038443fe47cd$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



const $b29d482e48f88850$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $b29d482e48f88850$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $99a583d325054f9b$export$717666c39ec07e12), classes);
};
const $b29d482e48f88850$export$1b479270917a5676 = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $99a583d325054f9b$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $99a583d325054f9b$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $99a583d325054f9b$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $99a583d325054f9b$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $b29d482e48f88850$var$AsteriskComponent = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $99a583d325054f9b$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $b29d482e48f88850$var$FormControlLabel = /*#__PURE__*/ $hEVyQ.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $b29d482e48f88850$var$_excluded);
    const muiFormControl = (0, $aa5dba5365b3a355$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $df87038443fe47cd$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $b29d482e48f88850$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $de7c7e4ec7447f0a$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $de7c7e4ec7447f0a$export$2e2bcd8739ae039), (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)($b29d482e48f88850$export$1b479270917a5676, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $hEVyQ.cloneElement(control, controlProps),
            label,
            required && /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)($b29d482e48f88850$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $b29d482e48f88850$export$2e2bcd8739ae039 = $b29d482e48f88850$var$FormControlLabel;




var $hEVyQ = parcelRequire("hEVyQ");











function $3d871ec79a866f9f$export$39f6debbec19b3ba(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiSwitch", slot);
}
const $3d871ec79a866f9f$var$switchClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
var $3d871ec79a866f9f$export$2e2bcd8739ae039 = $3d871ec79a866f9f$var$switchClasses;



const $cbc4abe4af451d28$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $cbc4abe4af451d28$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $3d871ec79a866f9f$export$39f6debbec19b3ba), classes);
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $cbc4abe4af451d28$var$SwitchRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        display: "inline-flex",
        width: 58,
        height: 38,
        overflow: "hidden",
        padding: 12,
        boxSizing: "border-box",
        position: "relative",
        flexShrink: 0,
        zIndex: 0,
        // Reset the stacking context.
        verticalAlign: "middle",
        // For correct alignment with the text.
        "@media print": {
            colorAdjust: "exact"
        }
    }, ownerState.edge === "start" && {
        marginLeft: -8
    }, ownerState.edge === "end" && {
        marginRight: -8
    }, ownerState.size === "small" && {
        width: 40,
        height: 24,
        padding: 7,
        [`& .${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).thumb}`]: {
            width: 16,
            height: 16
        },
        [`& .${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).switchBase}`]: {
            padding: 4,
            [`&.${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).checked}`]: {
                transform: "translateX(16px)"
            }
        }
    }));
const $cbc4abe4af451d28$var$SwitchSwitchBase = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)((0, $2474e6bdebed9cd3$export$2e2bcd8739ae039), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).checked} + .${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).disabled} + .${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
        },
        [`& .${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dbd72f49419aab0a$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dbd72f49419aab0a$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).disabled}`]: {
                color: theme.vars ? theme.vars.palette.Switch[`${ownerState.color}DisabledColor`] : `${theme.palette.mode === "light" ? (0, $dbd72f49419aab0a$export$c0816ed86df316af)(theme.palette[ownerState.color].main, 0.62) : (0, $dbd72f49419aab0a$export$4b073707ff63303)(theme.palette[ownerState.color].main, 0.55)}`
            }
        },
        [`&.${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).checked} + .${(0, $3d871ec79a866f9f$export$2e2bcd8739ae039).track}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main
        }
    }));
const $cbc4abe4af451d28$var$SwitchTrack = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
    }));
const $cbc4abe4af451d28$var$SwitchThumb = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const $cbc4abe4af451d28$var$Switch = /*#__PURE__*/ $hEVyQ.forwardRef(function Switch(inProps, ref) {
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className: className, color: color = "primary", edge: edge = false, size: size = "medium", sx: sx } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $cbc4abe4af451d28$var$_excluded);
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $cbc4abe4af451d28$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($cbc4abe4af451d28$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)($cbc4abe4af451d28$var$SwitchRoot, {
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($cbc4abe4af451d28$var$SwitchSwitchBase, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($cbc4abe4af451d28$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $cbc4abe4af451d28$export$2e2bcd8739ae039 = $cbc4abe4af451d28$var$Switch;


const $ebaa23340bdc83e7$var$FileManager = ()=>{
    const [pdfs, setPdfs] = (0, $hEVyQ.useState)([]);
    let [pages, setPages] = (0, $hEVyQ.useState)([]);
    const [pack, setPack] = (0, $hEVyQ.useState)(true);
    const [bothSided, setBothSided] = (0, $hEVyQ.useState)(false);
    const [whiteFront, setWhiteFront] = (0, $hEVyQ.useState)(false);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $8c8fa781ccebdb1b$export$2e2bcd8739ae039), {
                addPdfs: (newPdfs)=>{
                    setPdfs((pdfs)=>[
                            ...pdfs,
                            ...newPdfs
                        ]);
                    const newPages = [];
                    newPdfs.forEach((pdf, i)=>{
                        const doc = pdf.pdfJsDoc;
                        for(let j = 0; j < doc.numPages; j++)newPages.push(doc.getPage(j + 1).then((page)=>({
                                file: pdf.file,
                                fileIndex: pdfs.length + i,
                                pageIndex: j,
                                pageProxy: page,
                                included: true
                            })));
                    });
                    Promise.all(newPages).then((allPages)=>setPages((pages)=>[
                                ...pages,
                                ...allPages
                            ]));
                },
                more: pdfs.length > 0
            }),
            pdfs.length > 0 && /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)((0, $7d421eaa7dee1123$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $ed760d377ebb44c8$export$c6856de364e4c9db), {
                        pages: pages,
                        setPages: setPages
                    }),
                    /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $b29d482e48f88850$export$2e2bcd8739ae039), {
                        sx: {
                            fontSize: "20px"
                        },
                        control: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $cbc4abe4af451d28$export$2e2bcd8739ae039), {
                            checked: pack,
                            onChange: (e)=>setPack(e.target.checked)
                        }),
                        label: "A3\u306B\u6577\u304D\u8A70\u3081\u308B"
                    }),
                    /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $b29d482e48f88850$export$2e2bcd8739ae039), {
                        sx: {
                            fontSize: "20px"
                        },
                        control: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $cbc4abe4af451d28$export$2e2bcd8739ae039), {
                            checked: pack && bothSided,
                            disabled: !pack,
                            onChange: (e)=>setBothSided(e.target.checked)
                        }),
                        label: "\u4E21\u9762\u5370\u5237\u30FB\u518A\u5B50"
                    }),
                    /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $b29d482e48f88850$export$2e2bcd8739ae039), {
                        sx: {
                            fontSize: "20px"
                        },
                        control: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $cbc4abe4af451d28$export$2e2bcd8739ae039), {
                            checked: pack && bothSided && whiteFront,
                            disabled: !(pack && bothSided),
                            onChange: (e)=>setWhiteFront(e.target.checked)
                        }),
                        label: "\u8868\u7D19\u7A7A\u767D"
                    }),
                    /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $42efde2d1d9827db$export$2e2bcd8739ae039), {
                        pdfs: pdfs,
                        pages: pages,
                        config: {
                            a4toa3: pack,
                            bothSided: bothSided,
                            whiteFront: whiteFront
                        }
                    })
                ]
            })
        ]
    });
};
var $ebaa23340bdc83e7$export$2e2bcd8739ae039 = $ebaa23340bdc83e7$var$FileManager;



parcelRequire("hEVyQ");



var $hEVyQ = parcelRequire("hEVyQ");









function $52c32870260f8fa0$export$f3b76d2cce458caa(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiCard", slot);
}
const $52c32870260f8fa0$var$cardClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiCard", [
    "root"
]);
var $52c32870260f8fa0$export$2e2bcd8739ae039 = $52c32870260f8fa0$var$cardClasses;



const $7c9331d3e3f2ce4e$var$_excluded = [
    "className",
    "raised"
];
const $7c9331d3e3f2ce4e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $52c32870260f8fa0$export$f3b76d2cce458caa), classes);
};
const $7c9331d3e3f2ce4e$var$CardRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)((0, $5fce1dd627eb6b1d$export$2e2bcd8739ae039), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $7c9331d3e3f2ce4e$var$Card = /*#__PURE__*/ $hEVyQ.forwardRef(function Card(inProps, ref) {
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $7c9331d3e3f2ce4e$var$_excluded);
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        raised: raised
    });
    const classes = $7c9331d3e3f2ce4e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($7c9331d3e3f2ce4e$var$CardRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $7c9331d3e3f2ce4e$export$2e2bcd8739ae039 = $7c9331d3e3f2ce4e$var$Card;




var $hEVyQ = parcelRequire("hEVyQ");







function $7509ecdbfafec115$export$964336739a8c7119(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiCardContent", slot);
}
const $7509ecdbfafec115$var$cardContentClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiCardContent", [
    "root"
]);
var $7509ecdbfafec115$export$2e2bcd8739ae039 = $7509ecdbfafec115$var$cardContentClasses;



const $691b44f48c4af79a$var$_excluded = [
    "className",
    "component"
];
const $691b44f48c4af79a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $7509ecdbfafec115$export$964336739a8c7119), classes);
};
const $691b44f48c4af79a$var$CardContentRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("div", {
    name: "MuiCardContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    };
});
const $691b44f48c4af79a$var$CardContent = /*#__PURE__*/ $hEVyQ.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiCardContent"
    });
    const { className: className, component: component = "div" } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $691b44f48c4af79a$var$_excluded);
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        component: component
    });
    const classes = $691b44f48c4af79a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($691b44f48c4af79a$var$CardContentRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        as: component,
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $691b44f48c4af79a$export$2e2bcd8739ae039 = $691b44f48c4af79a$var$CardContent;




var $hEVyQ = parcelRequire("hEVyQ");









var $hEVyQ = parcelRequire("hEVyQ");
/**
 * @ignore - internal component.
 */ const $b49e489fa610e588$var$GridContext = /*#__PURE__*/ $hEVyQ.createContext();
var $b49e489fa610e588$export$2e2bcd8739ae039 = $b49e489fa610e588$var$GridContext;




function $a9623c630f19f853$export$9973ac5fd0181f33(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiGrid", slot);
}
const $a9623c630f19f853$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $a9623c630f19f853$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $a9623c630f19f853$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $a9623c630f19f853$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $a9623c630f19f853$var$gridClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$a9623c630f19f853$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$a9623c630f19f853$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$a9623c630f19f853$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$a9623c630f19f853$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$a9623c630f19f853$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$a9623c630f19f853$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$a9623c630f19f853$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$a9623c630f19f853$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $a9623c630f19f853$export$2e2bcd8739ae039 = $a9623c630f19f853$var$gridClasses;



const $66f38be10116642f$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $66f38be10116642f$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $66f38be10116642f$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $2bc41c1b49f158a3$export$980e6a259d807490)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$66f38be10116642f$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $66f38be10116642f$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $2bc41c1b49f158a3$export$980e6a259d807490)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $2bc41c1b49f158a3$export$88347efdb2e19abd)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $a9623c630f19f853$export$2e2bcd8739ae039).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $66f38be10116642f$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $66f38be10116642f$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $2bc41c1b49f158a3$export$980e6a259d807490)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $66f38be10116642f$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $2bc41c1b49f158a3$export$88347efdb2e19abd)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$66f38be10116642f$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $a9623c630f19f853$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $66f38be10116642f$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $a9623c630f19f853$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $66f38be10116642f$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $2bc41c1b49f158a3$export$980e6a259d807490)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $66f38be10116642f$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $2bc41c1b49f158a3$export$88347efdb2e19abd)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$66f38be10116642f$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$66f38be10116642f$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $a9623c630f19f853$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $66f38be10116642f$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $a9623c630f19f853$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $66f38be10116642f$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $66f38be10116642f$var$GridRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $66f38be10116642f$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $66f38be10116642f$export$71d4225eeb1bc13e, $66f38be10116642f$export$380604d7c79f9e8f, $66f38be10116642f$export$4315fba5128fb4a1, $66f38be10116642f$export$ca2a698f6020fda);
function $66f38be10116642f$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $66f38be10116642f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $66f38be10116642f$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $a9623c630f19f853$export$9973ac5fd0181f33), classes);
};
const $66f38be10116642f$var$Grid = /*#__PURE__*/ $hEVyQ.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints } = (0, $8251d502ea5b484c$export$2e2bcd8739ae039)();
    const props = (0, $de8361469344ae5e$export$2e2bcd8739ae039)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = "wrap", zeroMinWidth: zeroMinWidth = false } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $66f38be10116642f$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $hEVyQ.useContext((0, $b49e489fa610e588$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $66f38be10116642f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $b49e489fa610e588$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($66f38be10116642f$var$GridRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
            ownerState: ownerState,
            className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $66f38be10116642f$export$2e2bcd8739ae039 = $66f38be10116642f$var$Grid;


const $c7b5c1500df9292d$var$Banners = ()=>{
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $7d421eaa7dee1123$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)((0, $66f38be10116642f$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            sx: {
                marginBottom: "16px"
            },
            children: [
                /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)($c7b5c1500df9292d$var$Banner, {
                    head: "\uD83D\uDCB0\u7BC0\u7D04",
                    children: [
                        "A4\u6587\u66F8\u3092A3\u306B\u6577\u304D\u8A70\u3081\u3066\u5370\u5237\u4EE3\u3092\u7D04\u534A\u984D\u306B\u3057\u307E\u3059\uFF08\u203B\u30B3\u30F3\u30D3\u30CB\u306E\u30CD\u30C3\u30C8\u30D7\u30EA\u30F3\u30C8\u306F\u767D\u9ED2\u306E\u5834\u5408A3\u307E\u3067\u540C\u6599\u91D1\u306E\u305F\u3081\u3002",
                        /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("a", {
                            href: "https://www.printing.ne.jp/support/lite/pricelist_lite.html",
                            target: "_blank",
                            children: "\u53C2\u80031"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("a", {
                            href: "https://networkprint.ne.jp/sharp_netprint/ja/howto_price_f.aspx",
                            target: "_blank",
                            children: "2"
                        }),
                        "\uFF09"
                    ]
                }),
                /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($c7b5c1500df9292d$var$Banner, {
                    head: "\uD83C\uDF33\u30A8\u30B3",
                    children: "\u5370\u5237\u3057\u306A\u304F\u3066\u3082\u3044\u3044\u30DA\u30FC\u30B8\u3092\u7C21\u5358\u306B\u9664\u5916\u3067\u304D\u307E\u3059"
                }),
                /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($c7b5c1500df9292d$var$Banner, {
                    head: "\uD83D\uDE00\u7C21\u5358",
                    children: "\u8907\u6570\u306EPDF\u3092\u4E00\u3064\u306B\u307E\u3068\u3081\u3066\u5370\u5237\u3067\u304D\u308B\u305F\u3081\u3001\u30CD\u30C3\u30C8\u30D7\u30EA\u30F3\u30C8\u3067\u8907\u6570\u306EID\u5165\u529B\u3084\u9078\u629E\u3068\u3044\u3063\u305F\u624B\u9593\u304C\u7701\u3051\u307E\u3059\u3002"
                }),
                /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($c7b5c1500df9292d$var$Banner, {
                    head: "\uD83D\uDE85\u9AD8\u901F\u30FB\uD83D\uDD10\u5B89\u5168",
                    children: "PDF\u306E\u5185\u5BB9\u306F\u3042\u306A\u305F\u306E\u30C7\u30D0\u30A4\u30B9\u5185\u3067\u306E\u307F\u4FDD\u6301\u30FB\u7DE8\u96C6\u3055\u308C\u3001\u30B5\u30FC\u30D0\u30FC\u306B\u306F\u4E00\u5207\u9001\u4FE1\u3055\u308C\u307E\u305B\u3093"
                })
            ]
        })
    });
};
var $c7b5c1500df9292d$export$2e2bcd8739ae039 = $c7b5c1500df9292d$var$Banners;
const $c7b5c1500df9292d$var$Banner = ({ head: head, children: children })=>{
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $66f38be10116642f$export$2e2bcd8739ae039), {
        item: true,
        xs: 6,
        md: 3,
        children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $7c9331d3e3f2ce4e$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)((0, $691b44f48c4af79a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $de7c7e4ec7447f0a$export$2e2bcd8739ae039), {
                        variant: "h5",
                        component: "div",
                        children: head
                    }),
                    /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $de7c7e4ec7447f0a$export$2e2bcd8739ae039), {
                        sx: {
                            mb: 1.5
                        },
                        color: "text.secondary",
                        children: children
                    })
                ]
            })
        })
    });
};


function $265466ff1ee01838$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)("div", {
        style: {
            fontFamily: "system-ui, sans-serif",
            lineHeight: "1.8"
        },
        children: [
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $c7b5c1500df9292d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $ebaa23340bdc83e7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("h3", {
                children: "\u4F7F\u3044\u65B9"
            }),
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("li", {
                        children: "PDF\u30D5\u30A1\u30A4\u30EB\u3092\u8AAD\u307F\u8FBC\u307F\u307E\u3059"
                    }),
                    /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("li", {
                        children: "\u30D7\u30EC\u30D3\u30E5\u30FC\u3092\u78BA\u8A8D\u3057PDF\u3092\u4FDD\u5B58\u3057\u307E\u3059"
                    }),
                    /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("li", {
                        children: "\u3042\u3068\u306F\u3001\u4FDD\u5B58\u3057\u305FPDF\u3092\u5370\u5237\u3059\u308B\u3060\u3051\u3067\u3059\u3002\u5370\u5237\u7528\u7D19\u30B5\u30A4\u30BA\u306E\u6307\u793A\u304C\u30D5\u30A1\u30A4\u30EB\u540D\u306E\u5148\u982D\u306B\u4ED8\u4E0E\u3055\u308C\u307E\u3059\uFF08\u4F8B\uFF1A[A3\u7247\u9762]\uFF09"
                    })
                ]
            })
        ]
    });
}


/*import {cssBundleHref} from "@remix-run/css-bundle";
import type {LinksFunction} from "@remix-run/node";
import {
    Links,
    LiveReload,
    Meta,
    Outlet,
    Scripts,
    ScrollRestoration,
} from "@remix-run/react";
 */ 

parcelRequire("hEVyQ");



var $hEVyQ = parcelRequire("hEVyQ");









function $01da7c567169f571$export$47a2da616e55e8e9(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiAppBar", slot);
}
const $01da7c567169f571$var$appBarClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent"
]);
var $01da7c567169f571$export$2e2bcd8739ae039 = $01da7c567169f571$var$appBarClasses;



const $6d88a874c2d46f11$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $6d88a874c2d46f11$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(color)}`,
            `position${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(position)}`
        ]
    };
    return (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $01da7c567169f571$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $6d88a874c2d46f11$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $6d88a874c2d46f11$var$AppBarRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)((0, $5fce1dd627eb6b1d$export$2e2bcd8739ae039), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.position)}`],
            styles[`color${(0, $2acf9cf0cb04308d$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $6d88a874c2d46f11$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $6d88a874c2d46f11$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $6d88a874c2d46f11$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $6d88a874c2d46f11$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $6d88a874c2d46f11$var$AppBar = /*#__PURE__*/ $hEVyQ.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $6d88a874c2d46f11$var$_excluded);
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $6d88a874c2d46f11$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($6d88a874c2d46f11$var$AppBarRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $6d88a874c2d46f11$export$2e2bcd8739ae039 = $6d88a874c2d46f11$var$AppBar;




var $hEVyQ = parcelRequire("hEVyQ");







function $344ae68cc976bace$export$b12cb262231eef32(slot) {
    return (0, $09942e33151bb514$export$2e2bcd8739ae039)("MuiToolbar", slot);
}
const $344ae68cc976bace$var$toolbarClasses = (0, $8c0ac374284de90a$export$2e2bcd8739ae039)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $344ae68cc976bace$export$2e2bcd8739ae039 = $344ae68cc976bace$var$toolbarClasses;



const $ec0e386618f99e4d$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $ec0e386618f99e4d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $aa74efc05e7ee0b2$export$2e2bcd8739ae039)(slots, (0, $344ae68cc976bace$export$b12cb262231eef32), classes);
};
const $ec0e386618f99e4d$var$ToolbarRoot = (0, $f0eb61bababa8473$export$2e2bcd8739ae039)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $ec0e386618f99e4d$var$Toolbar = /*#__PURE__*/ $hEVyQ.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $7fe3c49d20140c33$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $c2d6c7e30fa459e6$export$2e2bcd8739ae039)(props, $ec0e386618f99e4d$var$_excluded);
    const ownerState = (0, $7ca105576352d92d$export$2e2bcd8739ae039)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $ec0e386618f99e4d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)($ec0e386618f99e4d$var$ToolbarRoot, (0, $7ca105576352d92d$export$2e2bcd8739ae039)({
        as: component,
        className: (0, $12c3a87622ffcd48$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $ec0e386618f99e4d$export$2e2bcd8739ae039 = $ec0e386618f99e4d$var$Toolbar;


function $0469f3c304a346f3$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $55e42bd2fd1a305e$export$2e2bcd8739ae039), {
        sx: {
            flexGrow: 1
        },
        children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $6d88a874c2d46f11$export$2e2bcd8739ae039), {
            position: "static",
            children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)((0, $ec0e386618f99e4d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $de7c7e4ec7447f0a$export$2e2bcd8739ae039), {
                        variant: "h6",
                        component: "div",
                        sx: {
                            flexGrow: 1
                        },
                        children: "PDF\u30B7\u30AD\u30C4\u30E1 - \u30B3\u30F3\u30D3\u30CB\u30D7\u30EA\u30F3\u30C8\u3092\u534A\u984D\u306B\uFF01"
                    }),
                    /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $21f9df141609ba2e$export$2e2bcd8739ae039), {
                        href: "https://twitter.com/na2hiro",
                        color: "inherit",
                        sx: {
                            textTransform: "none"
                        },
                        children: "@na2hiro"
                    })
                ]
            })
        })
    });
}


function $41102a9b36d06704$export$f6ed56c171b7aa66({ children: children }) {
    return /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsxs)((0, $7d421eaa7dee1123$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("header", {
                children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $0469f3c304a346f3$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("main", {
                style: {
                    margin: "8px"
                },
                children: children
            }),
            /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)("footer", {})
        ]
    });
}


const $682a00d935c0f5db$var$container = document.getElementById("app");
const $682a00d935c0f5db$var$root = (0, $94b66d1f5bb6e578$export$882461b6382ed46c)($682a00d935c0f5db$var$container);
$682a00d935c0f5db$var$root.render(/*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $41102a9b36d06704$export$f6ed56c171b7aa66), {
    children: /*#__PURE__*/ (0, $7d421eaa7dee1123$exports.jsx)((0, $265466ff1ee01838$export$2e2bcd8739ae039), {})
}));

})();
//# sourceMappingURL=index.cc5d172e.js.map
